(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireddfb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireddfb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bnAYy", function(module, exports) {
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6XHer")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("iZX2P")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("iZX2P")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("iZX2P")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("iZX2P")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("iZX2P")).createElementVNode; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("iZX2P")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("iZX2P")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("iZX2P")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("iZX2P")).createVNode; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("donES")).customRef; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("iZX2P")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("iZX2P")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("iZX2P")).getCurrentInstance; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("iZX2P")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("iZX2P")).h; });
$parcel$export(module.exports, "hasInjectionContext", function () { return (parcelRequire("iZX2P")).hasInjectionContext; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("iZX2P")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("iZX2P")).inject; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("donES")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("donES")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("donES")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("donES")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("donES")).markRaw; });
$parcel$export(module.exports, "mergeDefaults", function () { return (parcelRequire("iZX2P")).mergeDefaults; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("iZX2P")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("iZX2P")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6XHer")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("6XHer")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("iZX2P")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("iZX2P")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("iZX2P")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("iZX2P")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("iZX2P")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("iZX2P")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("iZX2P")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("iZX2P")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("iZX2P")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("iZX2P")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("donES")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("donES")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("iZX2P")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("iZX2P")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("iZX2P")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("iZX2P")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("iZX2P")).resolveDynamicComponent; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("donES")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("donES")).shallowRef; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("iZX2P")).Teleport; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("donES")).toRaw; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("iZX2P")).useSlots; });
$parcel$export(module.exports, "useTemplateRef", function () { return (parcelRequire("iZX2P")).useTemplateRef; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("iZX2P")).version; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("iZX2P")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("iZX2P")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("iZX2P")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("iZX2P")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("aRSfV")).createApp; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("aRSfV")).render; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("aRSfV")).Transition; });
$parcel$export(module.exports, "TransitionGroup", function () { return (parcelRequire("aRSfV")).TransitionGroup; });
$parcel$export(module.exports, "useCssVars", function () { return (parcelRequire("aRSfV")).useCssVars; });
$parcel$export(module.exports, "vModelCheckbox", function () { return (parcelRequire("aRSfV")).vModelCheckbox; });
$parcel$export(module.exports, "vModelRadio", function () { return (parcelRequire("aRSfV")).vModelRadio; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("aRSfV")).vModelSelect; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("aRSfV")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("aRSfV")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("aRSfV")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("aRSfV")).withModifiers; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("donES")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("donES")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("donES")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("donES")).readonly; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("donES")).shallowReadonly; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("donES")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("donES")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("donES")).toValue; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("donES")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("6XHer")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("6XHer")).toDisplayString; });
/**
* vue v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $iZX2P = parcelRequire("iZX2P");parcelRequire("aRSfV");parcelRequire("donES");parcelRequire("6XHer");
function $848e864767b3fe2e$var$initDev() {
    (0, $iZX2P.initCustomFormatter)();
}
const $848e864767b3fe2e$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("iZX2P", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $dd4bb9853057f55f$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $dd4bb9853057f55f$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $dd4bb9853057f55f$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $dd4bb9853057f55f$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $dd4bb9853057f55f$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "withCtx", function () { return $dd4bb9853057f55f$export$694b237e827a3d23; });
$parcel$export(module.exports, "withDirectives", function () { return $dd4bb9853057f55f$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "provide", function () { return $dd4bb9853057f55f$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $dd4bb9853057f55f$export$a976684a0efeb93f; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $dd4bb9853057f55f$export$f13e630aa3915748; });
$parcel$export(module.exports, "hasInjectionContext", function () { return $dd4bb9853057f55f$export$caf6761f24fc571a; });
$parcel$export(module.exports, "watchEffect", function () { return $dd4bb9853057f55f$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watch", function () { return $dd4bb9853057f55f$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "Teleport", function () { return $dd4bb9853057f55f$export$76d55a0304a371f4; });
$parcel$export(module.exports, "useTransitionState", function () { return $dd4bb9853057f55f$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $dd4bb9853057f55f$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $dd4bb9853057f55f$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $dd4bb9853057f55f$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $dd4bb9853057f55f$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "createCommentVNode", function () { return $dd4bb9853057f55f$export$49553837c7236d3c; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $dd4bb9853057f55f$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $dd4bb9853057f55f$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $dd4bb9853057f55f$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $dd4bb9853057f55f$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "useTemplateRef", function () { return $dd4bb9853057f55f$export$83a5dbc1f35517ca; });
$parcel$export(module.exports, "createVNode", function () { return $dd4bb9853057f55f$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $dd4bb9853057f55f$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "onUnmounted", function () { return $dd4bb9853057f55f$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onUpdated", function () { return $dd4bb9853057f55f$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $dd4bb9853057f55f$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $dd4bb9853057f55f$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onBeforeMount", function () { return $dd4bb9853057f55f$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $dd4bb9853057f55f$export$ab91988a13872e4c; });
$parcel$export(module.exports, "resolveComponent", function () { return $dd4bb9853057f55f$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $dd4bb9853057f55f$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $dd4bb9853057f55f$export$a1989e995cd481be; });
$parcel$export(module.exports, "renderList", function () { return $dd4bb9853057f55f$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $dd4bb9853057f55f$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "renderSlot", function () { return $dd4bb9853057f55f$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $dd4bb9853057f55f$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $dd4bb9853057f55f$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "useSlots", function () { return $dd4bb9853057f55f$export$9203a8e84125433c; });
$parcel$export(module.exports, "mergeDefaults", function () { return $dd4bb9853057f55f$export$ec60f47d4a8a2e7f; });
$parcel$export(module.exports, "computed", function () { return $dd4bb9853057f55f$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "version", function () { return $dd4bb9853057f55f$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createRenderer", function () { return $dd4bb9853057f55f$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $dd4bb9853057f55f$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $dd4bb9853057f55f$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $dd4bb9853057f55f$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $dd4bb9853057f55f$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $dd4bb9853057f55f$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $dd4bb9853057f55f$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $dd4bb9853057f55f$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $dd4bb9853057f55f$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $dd4bb9853057f55f$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $dd4bb9853057f55f$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("donES")).customRef; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("donES")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("donES")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("donES")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("donES")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("donES")).markRaw; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("donES")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("donES")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("donES")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("donES")).shallowRef; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("donES")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6XHer")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6XHer")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("6XHer")).normalizeStyle; });
/**
* @vue/runtime-core v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $donES = parcelRequire("donES");

var $6XHer = parcelRequire("6XHer");
const $dd4bb9853057f55f$var$stack = [];
function $dd4bb9853057f55f$var$pushWarningContext(vnode) {
    $dd4bb9853057f55f$var$stack.push(vnode);
}
function $dd4bb9853057f55f$var$popWarningContext() {
    $dd4bb9853057f55f$var$stack.pop();
}
let $dd4bb9853057f55f$var$isWarning = false;
function $dd4bb9853057f55f$var$warn$1(msg, ...args) {
    if ($dd4bb9853057f55f$var$isWarning) return;
    $dd4bb9853057f55f$var$isWarning = true;
    (0, $donES.pauseTracking)();
    const instance = $dd4bb9853057f55f$var$stack.length ? $dd4bb9853057f55f$var$stack[$dd4bb9853057f55f$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $dd4bb9853057f55f$var$getComponentTrace();
    if (appWarnHandler) $dd4bb9853057f55f$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$dd4bb9853057f55f$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$dd4bb9853057f55f$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $donES.resetTracking)();
    $dd4bb9853057f55f$var$isWarning = false;
}
function $dd4bb9853057f55f$var$getComponentTrace() {
    let currentVNode = $dd4bb9853057f55f$var$stack[$dd4bb9853057f55f$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $dd4bb9853057f55f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$dd4bb9853057f55f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $dd4bb9853057f55f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$dd4bb9853057f55f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$dd4bb9853057f55f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $dd4bb9853057f55f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$dd4bb9853057f55f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $dd4bb9853057f55f$var$formatProp(key, value, raw) {
    if ((0, $6XHer.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $donES.isRef)(value)) {
        value = $dd4bb9853057f55f$var$formatProp(key, (0, $donES.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $6XHer.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $donES.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $dd4bb9853057f55f$export$dfbcecb440255e4a(val, type) {
    return;
}
const $dd4bb9853057f55f$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $dd4bb9853057f55f$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $dd4bb9853057f55f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $dd4bb9853057f55f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $6XHer.isFunction)(fn)) {
        const res = $dd4bb9853057f55f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $6XHer.isPromise)(res)) res.catch((err)=>{
            $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $6XHer.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($dd4bb9853057f55f$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $6XHer.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $donES.pauseTracking)();
            $dd4bb9853057f55f$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $donES.resetTracking)();
            return;
        }
    }
    $dd4bb9853057f55f$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $dd4bb9853057f55f$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $dd4bb9853057f55f$var$queue = [];
let $dd4bb9853057f55f$var$flushIndex = -1;
const $dd4bb9853057f55f$var$pendingPostFlushCbs = [];
let $dd4bb9853057f55f$var$activePostFlushCbs = null;
let $dd4bb9853057f55f$var$postFlushIndex = 0;
const $dd4bb9853057f55f$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $dd4bb9853057f55f$var$currentFlushPromise = null;
const $dd4bb9853057f55f$var$RECURSION_LIMIT = 100;
function $dd4bb9853057f55f$export$bdd553fddd433dcb(fn) {
    const p = $dd4bb9853057f55f$var$currentFlushPromise || $dd4bb9853057f55f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $dd4bb9853057f55f$var$findInsertionIndex(id) {
    let start = $dd4bb9853057f55f$var$flushIndex + 1;
    let end = $dd4bb9853057f55f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $dd4bb9853057f55f$var$queue[middle];
        const middleJobId = $dd4bb9853057f55f$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $dd4bb9853057f55f$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $dd4bb9853057f55f$var$getId(job);
        const lastJob = $dd4bb9853057f55f$var$queue[$dd4bb9853057f55f$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $dd4bb9853057f55f$var$getId(lastJob)) $dd4bb9853057f55f$var$queue.push(job);
        else $dd4bb9853057f55f$var$queue.splice($dd4bb9853057f55f$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $dd4bb9853057f55f$var$queueFlush();
    }
}
function $dd4bb9853057f55f$var$queueFlush() {
    if (!$dd4bb9853057f55f$var$currentFlushPromise) $dd4bb9853057f55f$var$currentFlushPromise = $dd4bb9853057f55f$var$resolvedPromise.then($dd4bb9853057f55f$var$flushJobs);
}
function $dd4bb9853057f55f$export$59536a0199721cab(cb) {
    if (!(0, $6XHer.isArray)(cb)) {
        if ($dd4bb9853057f55f$var$activePostFlushCbs && cb.id === -1) $dd4bb9853057f55f$var$activePostFlushCbs.splice($dd4bb9853057f55f$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $dd4bb9853057f55f$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$dd4bb9853057f55f$var$pendingPostFlushCbs.push(cb[i]);
    $dd4bb9853057f55f$var$queueFlush();
}
function $dd4bb9853057f55f$var$flushPreFlushCbs(instance, minUid, seen, i = $dd4bb9853057f55f$var$flushIndex + 1) {
    for(; i < $dd4bb9853057f55f$var$queue.length; i++){
        const cb = $dd4bb9853057f55f$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid || minUid !== void 0 && !(cb.id >= minUid)) continue;
            $dd4bb9853057f55f$var$queue.splice(i, 1);
            i = instance ? i - 1 : $dd4bb9853057f55f$var$flushIndex;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $dd4bb9853057f55f$var$flushPostFlushCbs(seen, skip, minUid = 0) {
    if ($dd4bb9853057f55f$var$pendingPostFlushCbs.length) {
        let cbs = $dd4bb9853057f55f$var$pendingPostFlushCbs;
        let kept = 0;
        if (skip) {
            cbs = [];
            for(let i = 0; i < $dd4bb9853057f55f$var$pendingPostFlushCbs.length; i++){
                const cb = $dd4bb9853057f55f$var$pendingPostFlushCbs[i];
                if (cb.i !== void 0 ? !cb.i || cb.i.uid < minUid : skip.has(cb)) $dd4bb9853057f55f$var$pendingPostFlushCbs[kept++] = cb;
                else cbs.push(cb);
            }
        }
        const deduped = [
            ...new Set(cbs)
        ].sort((a, b)=>$dd4bb9853057f55f$var$getId(a) - $dd4bb9853057f55f$var$getId(b));
        $dd4bb9853057f55f$var$pendingPostFlushCbs.length = kept;
        if ($dd4bb9853057f55f$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$dd4bb9853057f55f$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $dd4bb9853057f55f$var$activePostFlushCbs = deduped;
        for($dd4bb9853057f55f$var$postFlushIndex = 0; $dd4bb9853057f55f$var$postFlushIndex < $dd4bb9853057f55f$var$activePostFlushCbs.length; $dd4bb9853057f55f$var$postFlushIndex++){
            const cb = $dd4bb9853057f55f$var$activePostFlushCbs[$dd4bb9853057f55f$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $dd4bb9853057f55f$var$activePostFlushCbs = null;
        $dd4bb9853057f55f$var$postFlushIndex = 0;
    }
}
let $dd4bb9853057f55f$var$isFlushing = false;
function $dd4bb9853057f55f$var$flushOnAppMount(fn, minUid) {
    if ($dd4bb9853057f55f$var$isFlushing) {
        fn();
        return;
    }
    const queued = minUid === void 0 ? void 0 : new Set($dd4bb9853057f55f$var$pendingPostFlushCbs);
    fn();
    $dd4bb9853057f55f$var$isFlushing = true;
    try {
        $dd4bb9853057f55f$var$flushPreFlushCbs(void 0, minUid);
        $dd4bb9853057f55f$var$flushPostFlushCbs(void 0, queued, minUid);
    } finally{
        $dd4bb9853057f55f$var$isFlushing = false;
    }
}
const $dd4bb9853057f55f$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $dd4bb9853057f55f$var$flushJobs(seen) {
    const check = (0, $6XHer.NOOP);
    try {
        for($dd4bb9853057f55f$var$flushIndex = 0; $dd4bb9853057f55f$var$flushIndex < $dd4bb9853057f55f$var$queue.length; $dd4bb9853057f55f$var$flushIndex++){
            const job = $dd4bb9853057f55f$var$queue[$dd4bb9853057f55f$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $dd4bb9853057f55f$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $dd4bb9853057f55f$var$flushIndex < $dd4bb9853057f55f$var$queue.length; $dd4bb9853057f55f$var$flushIndex++){
            const job = $dd4bb9853057f55f$var$queue[$dd4bb9853057f55f$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $dd4bb9853057f55f$var$flushIndex = -1;
        $dd4bb9853057f55f$var$queue.length = 0;
        $dd4bb9853057f55f$var$flushPostFlushCbs(seen);
        $dd4bb9853057f55f$var$currentFlushPromise = null;
        if ($dd4bb9853057f55f$var$queue.length || $dd4bb9853057f55f$var$pendingPostFlushCbs.length) $dd4bb9853057f55f$var$flushJobs(seen);
    }
}
function $dd4bb9853057f55f$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $dd4bb9853057f55f$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $dd4bb9853057f55f$var$getComponentName(instance.type);
        $dd4bb9853057f55f$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $dd4bb9853057f55f$var$isHmrUpdating = false;
const $dd4bb9853057f55f$var$setHmrUpdating = (v1)=>{
    try {
        return $dd4bb9853057f55f$var$isHmrUpdating;
    } finally{
        $dd4bb9853057f55f$var$isHmrUpdating = v1;
    }
};
const $dd4bb9853057f55f$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $dd4bb9853057f55f$var$map = /* @__PURE__ */ new Map();
function $dd4bb9853057f55f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $dd4bb9853057f55f$var$map.get(id);
    if (!record) {
        $dd4bb9853057f55f$var$createRecord(id, instance.type);
        record = $dd4bb9853057f55f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $dd4bb9853057f55f$var$unregisterHMR(instance) {
    $dd4bb9853057f55f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $dd4bb9853057f55f$var$createRecord(id, initialDef) {
    if ($dd4bb9853057f55f$var$map.has(id)) return false;
    $dd4bb9853057f55f$var$map.set(id, {
        initialDef: $dd4bb9853057f55f$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $dd4bb9853057f55f$var$normalizeClassComponent(component) {
    return $dd4bb9853057f55f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $dd4bb9853057f55f$var$rerender(id, newRender) {
    const record = $dd4bb9853057f55f$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $dd4bb9853057f55f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $dd4bb9853057f55f$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $dd4bb9853057f55f$var$isHmrUpdating = false;
    });
}
function $dd4bb9853057f55f$var$reload(id, newComp) {
    const record = $dd4bb9853057f55f$var$map.get(id);
    if (!record) return;
    newComp = $dd4bb9853057f55f$var$normalizeClassComponent(newComp);
    $dd4bb9853057f55f$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $dd4bb9853057f55f$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $dd4bb9853057f55f$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $dd4bb9853057f55f$var$updateComponentDef(oldComp, newComp);
            $dd4bb9853057f55f$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $dd4bb9853057f55f$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $dd4bb9853057f55f$var$isHmrUpdating = true;
                instance.parent.update();
                $dd4bb9853057f55f$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $dd4bb9853057f55f$export$59536a0199721cab(()=>{
        $dd4bb9853057f55f$var$hmrDirtyComponents.clear();
    });
}
function $dd4bb9853057f55f$var$updateComponentDef(oldComp, newComp) {
    (0, $6XHer.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $dd4bb9853057f55f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $dd4bb9853057f55f$var$devtools$1;
let $dd4bb9853057f55f$var$buffer = [];
let $dd4bb9853057f55f$var$devtoolsNotInstalled = false;
function $dd4bb9853057f55f$var$emit$1(event, ...args) {
    if ($dd4bb9853057f55f$var$devtools$1) $dd4bb9853057f55f$var$devtools$1.emit(event, ...args);
    else if (!$dd4bb9853057f55f$var$devtoolsNotInstalled) $dd4bb9853057f55f$var$buffer.push({
        event: event,
        args: args
    });
}
function $dd4bb9853057f55f$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $dd4bb9853057f55f$var$devtools$1 = hook;
    if ($dd4bb9853057f55f$var$devtools$1) {
        $dd4bb9853057f55f$var$devtools$1.enabled = true;
        $dd4bb9853057f55f$var$buffer.forEach(({ event: event, args: args })=>$dd4bb9853057f55f$var$devtools$1.emit(event, ...args));
        $dd4bb9853057f55f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $dd4bb9853057f55f$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$dd4bb9853057f55f$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $dd4bb9853057f55f$var$devtoolsNotInstalled = true;
                $dd4bb9853057f55f$var$buffer = [];
            }
        }, 3e3);
    } else {
        $dd4bb9853057f55f$var$devtoolsNotInstalled = true;
        $dd4bb9853057f55f$var$buffer = [];
    }
}
function $dd4bb9853057f55f$var$devtoolsInitApp(app, version) {
    $dd4bb9853057f55f$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $dd4bb9853057f55f$export$ffb0004e005737fa,
        Text: $dd4bb9853057f55f$export$5f1af8db9871e1d6,
        Comment: $dd4bb9853057f55f$export$4d299b491347818a,
        Static: $dd4bb9853057f55f$export$c1b9a1d3af45b7b6
    });
}
function $dd4bb9853057f55f$var$devtoolsUnmountApp(app) {
    $dd4bb9853057f55f$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $dd4bb9853057f55f$var$devtoolsComponentAdded = /* @__PURE__ */ $dd4bb9853057f55f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $dd4bb9853057f55f$var$devtoolsComponentUpdated = /* @__PURE__ */ $dd4bb9853057f55f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $dd4bb9853057f55f$var$_devtoolsComponentRemoved = /* @__PURE__ */ $dd4bb9853057f55f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $dd4bb9853057f55f$var$devtoolsComponentRemoved = (component)=>{
    if ($dd4bb9853057f55f$var$devtools$1 && typeof $dd4bb9853057f55f$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$dd4bb9853057f55f$var$devtools$1.cleanupBuffer(component)) $dd4bb9853057f55f$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $dd4bb9853057f55f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $dd4bb9853057f55f$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $dd4bb9853057f55f$var$devtoolsPerfStart = /* @__PURE__ */ $dd4bb9853057f55f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $dd4bb9853057f55f$var$devtoolsPerfEnd = /* @__PURE__ */ $dd4bb9853057f55f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $dd4bb9853057f55f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $dd4bb9853057f55f$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $dd4bb9853057f55f$var$devtoolsComponentEmit(component, event, params) {
    $dd4bb9853057f55f$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $dd4bb9853057f55f$var$currentRenderingInstance = null;
let $dd4bb9853057f55f$var$currentScopeId = null;
function $dd4bb9853057f55f$var$setCurrentRenderingInstance(instance) {
    const prev = $dd4bb9853057f55f$var$currentRenderingInstance;
    $dd4bb9853057f55f$var$currentRenderingInstance = instance;
    $dd4bb9853057f55f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $dd4bb9853057f55f$export$ac020265ca2cc4cd(id) {
    $dd4bb9853057f55f$var$currentScopeId = id;
}
function $dd4bb9853057f55f$export$f2dc6805dc11834e() {
    $dd4bb9853057f55f$var$currentScopeId = null;
}
const $dd4bb9853057f55f$export$15ba313e13f3dd04 = (_id)=>$dd4bb9853057f55f$export$694b237e827a3d23;
function $dd4bb9853057f55f$export$694b237e827a3d23(fn, ctx = $dd4bb9853057f55f$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $dd4bb9853057f55f$export$c20bee82f26f1e27(-1);
        const prevInstance = $dd4bb9853057f55f$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $dd4bb9853057f55f$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $dd4bb9853057f55f$var$blockStack.length; i > prevStackSize; i--)$dd4bb9853057f55f$var$closeBlock();
            $dd4bb9853057f55f$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $dd4bb9853057f55f$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $dd4bb9853057f55f$var$validateDirectiveName(name) {
    if ((0, $6XHer.isBuiltInDirective)(name)) $dd4bb9853057f55f$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $dd4bb9853057f55f$export$49729353e7c1e6c5(vnode, directives) {
    if ($dd4bb9853057f55f$var$currentRenderingInstance === null) return vnode;
    const instance = $dd4bb9853057f55f$var$getComponentPublicInstance($dd4bb9853057f55f$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $6XHer.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $6XHer.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $donES.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $donES.pauseTracking)();
            $dd4bb9853057f55f$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $donES.resetTracking)();
        }
    }
}
function $dd4bb9853057f55f$export$abe1e183e22e10ad(key, value) {
    if ($dd4bb9853057f55f$var$currentInstance) {
        let provides = $dd4bb9853057f55f$var$currentInstance.provides;
        const parentProvides = $dd4bb9853057f55f$var$currentInstance.parent && $dd4bb9853057f55f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $dd4bb9853057f55f$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $dd4bb9853057f55f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $dd4bb9853057f55f$export$f13e630aa3915748();
    if (instance || $dd4bb9853057f55f$var$currentApp) {
        let provides = $dd4bb9853057f55f$var$currentApp ? $dd4bb9853057f55f$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $6XHer.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $dd4bb9853057f55f$export$caf6761f24fc571a() {
    return !!($dd4bb9853057f55f$export$f13e630aa3915748() || $dd4bb9853057f55f$var$currentApp);
}
const $dd4bb9853057f55f$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $dd4bb9853057f55f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $dd4bb9853057f55f$export$a976684a0efeb93f($dd4bb9853057f55f$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $dd4bb9853057f55f$export$ede35fc0e5500309(effect, options) {
    return $dd4bb9853057f55f$var$doWatch(effect, null, options);
}
function $dd4bb9853057f55f$export$b7f27ea67102d543(effect, options) {
    return $dd4bb9853057f55f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $dd4bb9853057f55f$export$2035654f31b0e555(effect, options) {
    return $dd4bb9853057f55f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $dd4bb9853057f55f$export$3db5d71bdb2d5499(source, cb, options) {
    return $dd4bb9853057f55f$var$doWatch(source, cb, options);
}
function $dd4bb9853057f55f$var$doWatch(source, cb, options = (0, $6XHer.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $6XHer.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($dd4bb9853057f55f$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $dd4bb9853057f55f$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $6XHer.NOOP);
            watchStopHandle.resume = (0, $6XHer.NOOP);
            watchStopHandle.pause = (0, $6XHer.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $dd4bb9853057f55f$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$dd4bb9853057f55f$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        job.i = instance;
        $dd4bb9853057f55f$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $dd4bb9853057f55f$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $donES.watch)(source, cb, baseWatchOptions);
    if ($dd4bb9853057f55f$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $dd4bb9853057f55f$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $6XHer.isString)(source) ? source.includes(".") ? $dd4bb9853057f55f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $6XHer.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $dd4bb9853057f55f$var$setCurrentInstance(this);
    const res = $dd4bb9853057f55f$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $dd4bb9853057f55f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $dd4bb9853057f55f$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $dd4bb9853057f55f$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $dd4bb9853057f55f$var$isTeleport = (type)=>type.__isTeleport;
const $dd4bb9853057f55f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $dd4bb9853057f55f$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $dd4bb9853057f55f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $dd4bb9853057f55f$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $dd4bb9853057f55f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $6XHer.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $dd4bb9853057f55f$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $dd4bb9853057f55f$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $dd4bb9853057f55f$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $dd4bb9853057f55f$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $dd4bb9853057f55f$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $dd4bb9853057f55f$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $dd4bb9853057f55f$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $dd4bb9853057f55f$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($dd4bb9853057f55f$var$pendingMounts.get(vnode) !== mountJob) return;
                $dd4bb9853057f55f$var$pendingMounts.delete(vnode);
                if ($dd4bb9853057f55f$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $dd4bb9853057f55f$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $dd4bb9853057f55f$var$pendingMounts.set(vnode, mountJob);
            $dd4bb9853057f55f$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($dd4bb9853057f55f$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $dd4bb9853057f55f$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $dd4bb9853057f55f$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $dd4bb9853057f55f$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $dd4bb9853057f55f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $dd4bb9853057f55f$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $dd4bb9853057f55f$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $dd4bb9853057f55f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $dd4bb9853057f55f$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $dd4bb9853057f55f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $dd4bb9853057f55f$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $dd4bb9853057f55f$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $dd4bb9853057f55f$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $dd4bb9853057f55f$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $dd4bb9853057f55f$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $dd4bb9853057f55f$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $dd4bb9853057f55f$var$moveTeleport,
    hydrate: $dd4bb9853057f55f$var$hydrateTeleport
};
function $dd4bb9853057f55f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
        if (vnode.targetStart) insert(vnode.targetStart, container, parentAnchor);
        insert(vnode.targetAnchor, container, parentAnchor);
        parentAnchor = vnode.targetAnchor;
    }
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$dd4bb9853057f55f$var$pendingMounts.has(vnode) && (!isReorder || $dd4bb9853057f55f$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $dd4bb9853057f55f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $dd4bb9853057f55f$var$resolveTarget(vnode.props, querySelector);
    const disabled = $dd4bb9853057f55f$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $dd4bb9853057f55f$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $dd4bb9853057f55f$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $dd4bb9853057f55f$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $dd4bb9853057f55f$export$76d55a0304a371f4 = $dd4bb9853057f55f$var$TeleportImpl;
function $dd4bb9853057f55f$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $dd4bb9853057f55f$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$dd4bb9853057f55f$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $dd4bb9853057f55f$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $dd4bb9853057f55f$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $dd4bb9853057f55f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $dd4bb9853057f55f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $dd4bb9853057f55f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $dd4bb9853057f55f$var$TransitionHookValidator = [
    Function,
    Array
];
const $dd4bb9853057f55f$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $dd4bb9853057f55f$var$TransitionHookValidator,
    onEnter: $dd4bb9853057f55f$var$TransitionHookValidator,
    onAfterEnter: $dd4bb9853057f55f$var$TransitionHookValidator,
    onEnterCancelled: $dd4bb9853057f55f$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $dd4bb9853057f55f$var$TransitionHookValidator,
    onLeave: $dd4bb9853057f55f$var$TransitionHookValidator,
    onAfterLeave: $dd4bb9853057f55f$var$TransitionHookValidator,
    onLeaveCancelled: $dd4bb9853057f55f$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $dd4bb9853057f55f$var$TransitionHookValidator,
    onAppear: $dd4bb9853057f55f$var$TransitionHookValidator,
    onAfterAppear: $dd4bb9853057f55f$var$TransitionHookValidator,
    onAppearCancelled: $dd4bb9853057f55f$var$TransitionHookValidator
};
const $dd4bb9853057f55f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $dd4bb9853057f55f$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $dd4bb9853057f55f$export$f13e630aa3915748();
        const state = $dd4bb9853057f55f$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $dd4bb9853057f55f$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $dd4bb9853057f55f$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $dd4bb9853057f55f$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $donES.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $dd4bb9853057f55f$var$emptyPlaceholder(child);
            const innerChild = $dd4bb9853057f55f$var$getInnerChild$1(child);
            if (!innerChild) return $dd4bb9853057f55f$var$emptyPlaceholder(child);
            let enterHooks = $dd4bb9853057f55f$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $dd4bb9853057f55f$export$4d299b491347818a) $dd4bb9853057f55f$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $dd4bb9853057f55f$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $dd4bb9853057f55f$export$4d299b491347818a && !$dd4bb9853057f55f$var$isSameVNodeType(oldInnerChild, innerChild) && $dd4bb9853057f55f$var$getTransitionRoot(instance.subTree)) {
                let leavingHooks = $dd4bb9853057f55f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $dd4bb9853057f55f$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $dd4bb9853057f55f$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $dd4bb9853057f55f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $dd4bb9853057f55f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $dd4bb9853057f55f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$dd4bb9853057f55f$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$dd4bb9853057f55f$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $dd4bb9853057f55f$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $dd4bb9853057f55f$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $dd4bb9853057f55f$export$abd95b5f5e8a8837 = $dd4bb9853057f55f$var$BaseTransitionImpl;
function $dd4bb9853057f55f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $dd4bb9853057f55f$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $dd4bb9853057f55f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $dd4bb9853057f55f$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $6XHer.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$dd4bb9853057f55f$var$leaveCbKey]) el[$dd4bb9853057f55f$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $dd4bb9853057f55f$var$isSameVNodeType(vnode, leavingVNode)) {
                let leavingCb = leavingVNode.el[$dd4bb9853057f55f$var$leaveCbKey];
                if (!leavingCb) {
                    const leavingRoot = $dd4bb9853057f55f$var$getTransitionRoot(leavingVNode);
                    leavingCb = leavingRoot && leavingRoot.el[$dd4bb9853057f55f$var$leaveCbKey];
                }
                if (leavingCb) leavingCb();
            }
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$dd4bb9853057f55f$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$dd4bb9853057f55f$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$dd4bb9853057f55f$var$enterCbKey] = void 0;
            };
            const done = el[$dd4bb9853057f55f$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$dd4bb9853057f55f$var$enterCbKey]) el[$dd4bb9853057f55f$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$dd4bb9853057f55f$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$dd4bb9853057f55f$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$dd4bb9853057f55f$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $dd4bb9853057f55f$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $dd4bb9853057f55f$var$emptyPlaceholder(vnode) {
    if ($dd4bb9853057f55f$var$isKeepAlive(vnode)) {
        vnode = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $dd4bb9853057f55f$var$getInnerChild$1(vnode) {
    if (!$dd4bb9853057f55f$var$isKeepAlive(vnode)) {
        if ($dd4bb9853057f55f$var$isTeleport(vnode.type) && vnode.children) return $dd4bb9853057f55f$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $6XHer.isFunction)(children.default)) return children.default();
    }
}
function $dd4bb9853057f55f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $dd4bb9853057f55f$export$7770a22486565649($dd4bb9853057f55f$var$isTeleport(subTree.type) ? $dd4bb9853057f55f$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
        vnode.transition = hooks;
        if (vnode.type === $dd4bb9853057f55f$export$ffb0004e005737fa && (0, $6XHer.isArray)(vnode.children)) {
            const child = $dd4bb9853057f55f$var$filterSingleRoot(vnode.children, false);
            if (child) $dd4bb9853057f55f$export$7770a22486565649(child, hooks);
        }
    }
}
function $dd4bb9853057f55f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $dd4bb9853057f55f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($dd4bb9853057f55f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $dd4bb9853057f55f$export$4d299b491347818a) ret.push(key != null ? $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $dd4bb9853057f55f$var$getTransitionRoot(vnode) {
    if (vnode.component) return $dd4bb9853057f55f$var$getTransitionRoot(vnode.component.subTree);
    if (vnode.type === $dd4bb9853057f55f$export$ffb0004e005737fa) {
        const child = (0, $6XHer.isArray)(vnode.children) && $dd4bb9853057f55f$var$filterSingleRoot(vnode.children, false);
        return child ? $dd4bb9853057f55f$var$getTransitionRoot(child) : void 0;
    }
    if (vnode.type !== $dd4bb9853057f55f$export$4d299b491347818a) return vnode;
}
// @__NO_SIDE_EFFECTS__
function $dd4bb9853057f55f$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $6XHer.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $6XHer.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $dd4bb9853057f55f$export$f680877a34711e37() {
    const i = $dd4bb9853057f55f$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $dd4bb9853057f55f$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $dd4bb9853057f55f$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $dd4bb9853057f55f$export$83a5dbc1f35517ca(key) {
    const i = $dd4bb9853057f55f$export$f13e630aa3915748();
    const r = (0, $donES.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $6XHer.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $dd4bb9853057f55f$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $dd4bb9853057f55f$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $dd4bb9853057f55f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $6XHer.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$dd4bb9853057f55f$var$setRef(r, oldRawRef && ((0, $6XHer.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($dd4bb9853057f55f$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $dd4bb9853057f55f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $dd4bb9853057f55f$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $6XHer.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $donES.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $6XHer.EMPTY_OBJ) ? (0, $6XHer.NO) : (key)=>{
        if ($dd4bb9853057f55f$var$isTemplateRefKey(refs, key)) return false;
        return (0, $6XHer.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $dd4bb9853057f55f$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $dd4bb9853057f55f$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $6XHer.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $donES.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $6XHer.isFunction)(ref)) $dd4bb9853057f55f$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $6XHer.isString)(ref);
        const _isRef = (0, $donES.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $6XHer.isArray)(existing) && (0, $6XHer.remove)(existing, refValue);
                    else {
                        if (!(0, $6XHer.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $dd4bb9853057f55f$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $dd4bb9853057f55f$var$pendingSetRefMap.set(rawRef, job);
                $dd4bb9853057f55f$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $dd4bb9853057f55f$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $dd4bb9853057f55f$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $dd4bb9853057f55f$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $dd4bb9853057f55f$var$pendingSetRefMap.delete(rawRef);
    }
}
let $dd4bb9853057f55f$var$hasLoggedMismatchError = false;
const $dd4bb9853057f55f$var$logMismatchError = ()=>{
    if ($dd4bb9853057f55f$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $dd4bb9853057f55f$var$hasLoggedMismatchError = true;
};
const $dd4bb9853057f55f$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $dd4bb9853057f55f$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $dd4bb9853057f55f$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($dd4bb9853057f55f$var$isSVGContainer(container)) return "svg";
    if ($dd4bb9853057f55f$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $dd4bb9853057f55f$var$isComment = (node)=>node.nodeType === 8;
function $dd4bb9853057f55f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $dd4bb9853057f55f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $dd4bb9853057f55f$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $dd4bb9853057f55f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6XHer.def)(node, "__vnode", vnode, true);
            (0, $6XHer.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $dd4bb9853057f55f$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $dd4bb9853057f55f$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $dd4bb9853057f55f$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $dd4bb9853057f55f$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $dd4bb9853057f55f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($dd4bb9853057f55f$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $dd4bb9853057f55f$var$getContainerType(container), optimized);
                    if (($dd4bb9853057f55f$var$isAsyncWrapper(vnode) || vnode.component.asyncDep) && !vnode.component.subTree) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$c1b9a1d3af45b7b6);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $dd4bb9853057f55f$export$22f9b5ffd89dac9("") : $dd4bb9853057f55f$export$bf5c4cf060303d58(node.nodeType === 8 ? $dd4bb9853057f55f$export$4d299b491347818a : "div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $dd4bb9853057f55f$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $dd4bb9853057f55f$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $dd4bb9853057f55f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $dd4bb9853057f55f$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$dd4bb9853057f55f$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $dd4bb9853057f55f$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$dd4bb9853057f55f$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $dd4bb9853057f55f$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $dd4bb9853057f55f$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $dd4bb9853057f55f$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $6XHer.isOn)(key) && !(0, $6XHer.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $6XHer.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($dd4bb9853057f55f$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $donES.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $dd4bb9853057f55f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $dd4bb9853057f55f$var$normalizeVNode(children[i]);
            const isText = vnode.type === $dd4bb9853057f55f$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $dd4bb9853057f55f$var$normalizeVNode(children[i + 1]).type === $dd4bb9853057f55f$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$dd4bb9853057f55f$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $dd4bb9853057f55f$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $dd4bb9853057f55f$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $dd4bb9853057f55f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $dd4bb9853057f55f$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$dd4bb9853057f55f$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $dd4bb9853057f55f$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $dd4bb9853057f55f$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $dd4bb9853057f55f$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $dd4bb9853057f55f$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $dd4bb9853057f55f$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $dd4bb9853057f55f$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $dd4bb9853057f55f$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $dd4bb9853057f55f$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$dd4bb9853057f55f$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $dd4bb9853057f55f$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $6XHer.normalizeClass)(clientValue);
        if (!$dd4bb9853057f55f$var$isSetEqual($dd4bb9853057f55f$var$toClassSet(actual || ""), $dd4bb9853057f55f$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $6XHer.isString)(clientValue) ? clientValue : (0, $6XHer.stringifyStyle)((0, $6XHer.normalizeStyle)(clientValue));
        const actualMap = $dd4bb9853057f55f$var$toStyleMap(actual);
        const expectedMap = $dd4bb9853057f55f$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $dd4bb9853057f55f$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$dd4bb9853057f55f$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $6XHer.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $6XHer.isBooleanAttr)(key) || (0, $6XHer.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $dd4bb9853057f55f$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $dd4bb9853057f55f$var$normalizeHiddenValue(clientValue);
        } else if ((0, $6XHer.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $6XHer.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $6XHer.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$dd4bb9853057f55f$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$dd4bb9853057f55f$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $dd4bb9853057f55f$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $dd4bb9853057f55f$var$normalizeHiddenValue(value) {
    if (!(0, $6XHer.isRenderableAttrValue)(value)) return false;
    if ((0, $6XHer.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $6XHer.includeBooleanAttr)(value) ? "" : false;
}
function $dd4bb9853057f55f$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $dd4bb9853057f55f$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $dd4bb9853057f55f$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $dd4bb9853057f55f$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $dd4bb9853057f55f$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $dd4bb9853057f55f$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $6XHer.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $6XHer.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $dd4bb9853057f55f$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $dd4bb9853057f55f$var$allowMismatchAttr = "data-allow-mismatch";
const $dd4bb9853057f55f$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $dd4bb9853057f55f$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($dd4bb9853057f55f$var$allowMismatchAttr))el = el.parentElement;
    return $dd4bb9853057f55f$var$isMismatchAllowedByAttr(el && el.getAttribute($dd4bb9853057f55f$var$allowMismatchAttr), allowedType);
}
function $dd4bb9853057f55f$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($dd4bb9853057f55f$var$MismatchTypeString[allowedType]);
    }
}
function $dd4bb9853057f55f$var$isNodeMismatchAllowed(node, vnode) {
    return $dd4bb9853057f55f$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $dd4bb9853057f55f$var$isMismatchAllowedByNode(node) || $dd4bb9853057f55f$var$isMismatchAllowedByVNode(vnode);
}
function $dd4bb9853057f55f$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $dd4bb9853057f55f$var$isMismatchAllowedByAttr(node.getAttribute($dd4bb9853057f55f$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $dd4bb9853057f55f$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$dd4bb9853057f55f$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $dd4bb9853057f55f$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $dd4bb9853057f55f$var$requestIdleCallback = (0, $6XHer.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $dd4bb9853057f55f$var$cancelIdleCallback = (0, $6XHer.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $dd4bb9853057f55f$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $dd4bb9853057f55f$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$dd4bb9853057f55f$var$cancelIdleCallback(id);
    };
function $dd4bb9853057f55f$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $dd4bb9853057f55f$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        const observe = (el)=>{
            if ($dd4bb9853057f55f$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            if (getComputedStyle(el).display === "contents") for(let i = 0; i < el.children.length; i++){
                if (observe(el.children[i]) === false) return false;
            }
            ob.observe(el);
        };
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            return observe(el);
        });
        return ()=>ob.disconnect();
    };
const $dd4bb9853057f55f$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $dd4bb9853057f55f$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $6XHer.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $dd4bb9853057f55f$var$forEachElement(node, cb) {
    if ($dd4bb9853057f55f$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($dd4bb9853057f55f$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $dd4bb9853057f55f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $dd4bb9853057f55f$export$d75d499b4c16cf21(source) {
    if ((0, $6XHer.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $dd4bb9853057f55f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$dd4bb9853057f55f$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $dd4bb9853057f55f$var$currentInstance;
            $dd4bb9853057f55f$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$dd4bb9853057f55f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $dd4bb9853057f55f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$dd4bb9853057f55f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $dd4bb9853057f55f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $donES.ref)(false);
            const error = (0, $donES.ref)();
            const delayed = (0, $donES.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $dd4bb9853057f55f$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $dd4bb9853057f55f$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $dd4bb9853057f55f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $dd4bb9853057f55f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $dd4bb9853057f55f$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $dd4bb9853057f55f$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $dd4bb9853057f55f$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $dd4bb9853057f55f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $dd4bb9853057f55f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $dd4bb9853057f55f$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $6XHer.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $dd4bb9853057f55f$var$invalidateMount(instance2.m);
            $dd4bb9853057f55f$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $6XHer.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $dd4bb9853057f55f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $dd4bb9853057f55f$var$getComponentName($dd4bb9853057f55f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$dd4bb9853057f55f$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) {
                $dd4bb9853057f55f$var$resetShapeFlag(current);
                if (cached) $dd4bb9853057f55f$var$resetShapeFlag(cached);
            }
            cache.delete(key);
            keys.delete(key);
        }
        $dd4bb9853057f55f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$dd4bb9853057f55f$var$matches(include, name));
            exclude && pruneCache((name)=>!$dd4bb9853057f55f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($dd4bb9853057f55f$var$isSuspense(instance.subTree.type)) $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
                    const vnode = $dd4bb9853057f55f$var$getInnerChild(instance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $dd4bb9853057f55f$var$getInnerChild(instance.subTree));
            }
        };
        $dd4bb9853057f55f$export$6d1641039221b5cb(cacheSubtree);
        $dd4bb9853057f55f$export$5876c47052fb88b1(cacheSubtree);
        $dd4bb9853057f55f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $dd4bb9853057f55f$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $dd4bb9853057f55f$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $dd4bb9853057f55f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$dd4bb9853057f55f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $dd4bb9853057f55f$var$getInnerChild(rawVNode);
            if (vnode.type === $dd4bb9853057f55f$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $dd4bb9853057f55f$var$getComponentName($dd4bb9853057f55f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$dd4bb9853057f55f$var$matches(include, name)) || exclude && name && $dd4bb9853057f55f$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $dd4bb9853057f55f$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $dd4bb9853057f55f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $dd4bb9853057f55f$export$70eb8a58709972df = $dd4bb9853057f55f$var$KeepAliveImpl;
function $dd4bb9853057f55f$var$matches(pattern, name) {
    if ((0, $6XHer.isArray)(pattern)) return pattern.some((p)=>$dd4bb9853057f55f$var$matches(p, name));
    else if ((0, $6XHer.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $6XHer.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $dd4bb9853057f55f$export$ba52d824b95a2154(hook, target) {
    $dd4bb9853057f55f$var$registerKeepAliveHook(hook, "a", target);
}
function $dd4bb9853057f55f$export$bf1440eeaf5fa709(hook, target) {
    $dd4bb9853057f55f$var$registerKeepAliveHook(hook, "da", target);
}
function $dd4bb9853057f55f$var$registerKeepAliveHook(hook, type, target = $dd4bb9853057f55f$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $dd4bb9853057f55f$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($dd4bb9853057f55f$var$isKeepAlive(current.parent.vnode)) $dd4bb9853057f55f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $dd4bb9853057f55f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $dd4bb9853057f55f$var$injectHook(type, hook, keepAliveRoot, true);
    $dd4bb9853057f55f$export$13348a43ccacfe58(()=>{
        (0, $6XHer.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $dd4bb9853057f55f$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $dd4bb9853057f55f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $dd4bb9853057f55f$var$injectHook(type, hook, target = $dd4bb9853057f55f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $donES.pauseTracking)();
            const reset = $dd4bb9853057f55f$var$setCurrentInstance(target);
            const res = $dd4bb9853057f55f$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $donES.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $dd4bb9853057f55f$var$createHook = (lifecycle)=>(hook, target = $dd4bb9853057f55f$var$currentInstance)=>{
        if (!$dd4bb9853057f55f$var$isInSSRComponentSetup || lifecycle === "sp") $dd4bb9853057f55f$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $dd4bb9853057f55f$export$23b7aeb0d671f804 = $dd4bb9853057f55f$var$createHook("bm");
const $dd4bb9853057f55f$export$6d1641039221b5cb = $dd4bb9853057f55f$var$createHook("m");
const $dd4bb9853057f55f$export$ab91988a13872e4c = $dd4bb9853057f55f$var$createHook("bu");
const $dd4bb9853057f55f$export$5876c47052fb88b1 = $dd4bb9853057f55f$var$createHook("u");
const $dd4bb9853057f55f$export$40c420df62d2614 = $dd4bb9853057f55f$var$createHook("bum");
const $dd4bb9853057f55f$export$13348a43ccacfe58 = $dd4bb9853057f55f$var$createHook("um");
const $dd4bb9853057f55f$export$ebf0c601f267bceb = $dd4bb9853057f55f$var$createHook("sp");
const $dd4bb9853057f55f$export$898295a813d662eb = $dd4bb9853057f55f$var$createHook("rtg");
const $dd4bb9853057f55f$export$2b41f4235363e921 = $dd4bb9853057f55f$var$createHook("rtc");
function $dd4bb9853057f55f$export$6a3a15856e50ad19(hook, target = $dd4bb9853057f55f$var$currentInstance) {
    $dd4bb9853057f55f$var$injectHook("ec", hook, target);
}
const $dd4bb9853057f55f$var$COMPONENTS = "components";
const $dd4bb9853057f55f$var$DIRECTIVES = "directives";
function $dd4bb9853057f55f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $dd4bb9853057f55f$var$resolveAsset($dd4bb9853057f55f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $dd4bb9853057f55f$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $dd4bb9853057f55f$export$b44c564a05ca975(component) {
    if ((0, $6XHer.isString)(component)) return $dd4bb9853057f55f$var$resolveAsset($dd4bb9853057f55f$var$COMPONENTS, component, false) || component;
    else return component || $dd4bb9853057f55f$var$NULL_DYNAMIC_COMPONENT;
}
function $dd4bb9853057f55f$export$a1989e995cd481be(name) {
    return $dd4bb9853057f55f$var$resolveAsset($dd4bb9853057f55f$var$DIRECTIVES, name);
}
function $dd4bb9853057f55f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $dd4bb9853057f55f$var$currentRenderingInstance || $dd4bb9853057f55f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $dd4bb9853057f55f$var$COMPONENTS) {
            const selfName = $dd4bb9853057f55f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $6XHer.camelize)(name) || selfName === (0, $6XHer.capitalize)((0, $6XHer.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $dd4bb9853057f55f$var$resolve(instance[type] || Component[type], name) || // global registration
        $dd4bb9853057f55f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $dd4bb9853057f55f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $6XHer.camelize)(name)] || registry[(0, $6XHer.capitalize)((0, $6XHer.camelize)(name))]);
}
function $dd4bb9853057f55f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $6XHer.isArray)(source);
    if (sourceIsArray || (0, $6XHer.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $donES.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $donES.isShallow)(source);
            isReadonlySource = (0, $donES.isReadonly)(source);
            source = (0, $donES.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $donES.toReadonly)((0, $donES.toReactive)(source[i])) : (0, $donES.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        if (!Number.isInteger(source) || source < 0) ret = [];
        else {
            ret = new Array(source);
            for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
        }
    } else if ((0, $6XHer.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $dd4bb9853057f55f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $6XHer.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $dd4bb9853057f55f$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($dd4bb9853057f55f$var$currentRenderingInstance.ce || $dd4bb9853057f55f$var$currentRenderingInstance.parent && $dd4bb9853057f55f$var$isAsyncWrapper($dd4bb9853057f55f$var$currentRenderingInstance.parent) && $dd4bb9853057f55f$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $6XHer.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $dd4bb9853057f55f$export$e7eaa45e502fe5cc(), $dd4bb9853057f55f$export$9f2dfe8048dfb22b($dd4bb9853057f55f$export$ffb0004e005737fa, null, [
            $dd4bb9853057f55f$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $dd4bb9853057f55f$var$blockStack.length;
    $dd4bb9853057f55f$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $dd4bb9853057f55f$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $dd4bb9853057f55f$export$9f2dfe8048dfb22b($dd4bb9853057f55f$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $6XHer.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $dd4bb9853057f55f$var$blockStack.length; i > prevStackSize; i--)$dd4bb9853057f55f$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $dd4bb9853057f55f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$dd4bb9853057f55f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $dd4bb9853057f55f$export$4d299b491347818a) return false;
        if (child.type === $dd4bb9853057f55f$export$ffb0004e005737fa && !$dd4bb9853057f55f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $dd4bb9853057f55f$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $6XHer.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $dd4bb9853057f55f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($dd4bb9853057f55f$var$isStatefulComponent(i)) return $dd4bb9853057f55f$var$getComponentPublicInstance(i);
    return $dd4bb9853057f55f$var$getPublicInstance(i.parent);
};
const $dd4bb9853057f55f$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $dd4bb9853057f55f$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $dd4bb9853057f55f$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $dd4bb9853057f55f$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
const $dd4bb9853057f55f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $6XHer.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>(0, i.vnode.el),
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$dd4bb9853057f55f$var$getPublicInstance(i.parent),
    $root: (i)=>$dd4bb9853057f55f$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $dd4bb9853057f55f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $dd4bb9853057f55f$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $dd4bb9853057f55f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $dd4bb9853057f55f$var$instanceWatch.bind(i) : (0, $6XHer.NOOP)
});
const $dd4bb9853057f55f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $dd4bb9853057f55f$var$hasSetupBinding = (state, key)=>state !== (0, $6XHer.EMPTY_OBJ) && !state.__isScriptSetup && (0, $6XHer.hasOwn)(state, key);
const $dd4bb9853057f55f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($dd4bb9853057f55f$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $6XHer.EMPTY_OBJ) && (0, $6XHer.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $6XHer.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $6XHer.EMPTY_OBJ) && (0, $6XHer.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $dd4bb9853057f55f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $dd4bb9853057f55f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $donES.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $6XHer.EMPTY_OBJ) && (0, $6XHer.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $6XHer.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($dd4bb9853057f55f$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $6XHer.EMPTY_OBJ) && (0, $6XHer.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $6XHer.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $6XHer.EMPTY_OBJ) && key[0] !== "$" && (0, $6XHer.hasOwn)(data, key) || $dd4bb9853057f55f$var$hasSetupBinding(setupState, key) || (0, $6XHer.hasOwn)(props, key) || (0, $6XHer.hasOwn)(ctx, key) || (0, $6XHer.hasOwn)($dd4bb9853057f55f$var$publicPropertiesMap, key) || (0, $6XHer.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $6XHer.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $dd4bb9853057f55f$var$target;
const $dd4bb9853057f55f$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $6XHer.extend)({}, $dd4bb9853057f55f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $dd4bb9853057f55f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $6XHer.isGloballyAllowed)(key);
        return has;
    }
});
function $dd4bb9853057f55f$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($dd4bb9853057f55f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$dd4bb9853057f55f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $6XHer.NOOP)
        });
    });
    return target;
}
function $dd4bb9853057f55f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $6XHer.NOOP)
        });
    });
}
function $dd4bb9853057f55f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $donES.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($dd4bb9853057f55f$var$isReservedPrefix(key[0])) {
                $dd4bb9853057f55f$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $6XHer.NOOP)
            });
        }
    });
}
const $dd4bb9853057f55f$var$warnRuntimeUsage = (method)=>$dd4bb9853057f55f$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $dd4bb9853057f55f$export$80b33eababae110e() {
    return null;
}
function $dd4bb9853057f55f$export$51ecece22fc17ddc() {
    return null;
}
function $dd4bb9853057f55f$export$da25b65ca24b518a(exposed) {}
function $dd4bb9853057f55f$export$77e79129327f3d0d(options) {}
function $dd4bb9853057f55f$export$1b3acd4bb805b712() {
    return null;
}
function $dd4bb9853057f55f$export$acd55aa037e791bb() {}
function $dd4bb9853057f55f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $dd4bb9853057f55f$export$9203a8e84125433c() {
    return $dd4bb9853057f55f$var$getContext("useSlots").slots;
}
function $dd4bb9853057f55f$export$75e29435042cd2ea() {
    return $dd4bb9853057f55f$var$getContext("useAttrs").attrs;
}
function $dd4bb9853057f55f$var$getContext(calledFunctionName) {
    const i = $dd4bb9853057f55f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $dd4bb9853057f55f$var$createSetupContext(i));
}
function $dd4bb9853057f55f$var$normalizePropsOrEmits(props) {
    return (0, $6XHer.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $dd4bb9853057f55f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $dd4bb9853057f55f$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $6XHer.isArray)(opt) || (0, $6XHer.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $dd4bb9853057f55f$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $6XHer.isArray)(a) && (0, $6XHer.isArray)(b)) return a.concat(b);
    return (0, $6XHer.extend)({}, $dd4bb9853057f55f$var$normalizePropsOrEmits(a), $dd4bb9853057f55f$var$normalizePropsOrEmits(b));
}
function $dd4bb9853057f55f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $dd4bb9853057f55f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $dd4bb9853057f55f$export$f13e630aa3915748();
    const inSSRSetup = $dd4bb9853057f55f$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $dd4bb9853057f55f$var$unsetCurrentInstance();
    if (inSSRSetup) $dd4bb9853057f55f$var$setInSSRSetupState(false);
    const restore = ()=>{
        $dd4bb9853057f55f$var$setCurrentInstance(ctx);
        if (inSSRSetup) $dd4bb9853057f55f$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($dd4bb9853057f55f$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $dd4bb9853057f55f$var$unsetCurrentInstance();
        if (inSSRSetup) $dd4bb9853057f55f$var$setInSSRSetupState(false);
    };
    if ((0, $6XHer.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $dd4bb9853057f55f$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $dd4bb9853057f55f$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $dd4bb9853057f55f$var$shouldCacheAccess = true;
function $dd4bb9853057f55f$var$applyOptions(instance) {
    const options = $dd4bb9853057f55f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $dd4bb9853057f55f$var$shouldCacheAccess = false;
    if (options.beforeCreate) $dd4bb9853057f55f$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $dd4bb9853057f55f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $6XHer.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $6XHer.isObject)(data)) ;
        else instance.data = (0, $donES.reactive)(data);
    }
    $dd4bb9853057f55f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $6XHer.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $6XHer.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $6XHer.NOOP);
        const set = !(0, $6XHer.isFunction)(opt) && (0, $6XHer.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $6XHer.NOOP);
        const c = $dd4bb9853057f55f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$dd4bb9853057f55f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $6XHer.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $dd4bb9853057f55f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $dd4bb9853057f55f$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $6XHer.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($dd4bb9853057f55f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($dd4bb9853057f55f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($dd4bb9853057f55f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($dd4bb9853057f55f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($dd4bb9853057f55f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($dd4bb9853057f55f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($dd4bb9853057f55f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($dd4bb9853057f55f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($dd4bb9853057f55f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($dd4bb9853057f55f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($dd4bb9853057f55f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($dd4bb9853057f55f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $6XHer.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $6XHer.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $dd4bb9853057f55f$var$markAsyncBoundary(instance);
}
function $dd4bb9853057f55f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $6XHer.NOOP)) {
    if ((0, $6XHer.isArray)(injectOptions)) injectOptions = $dd4bb9853057f55f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $6XHer.isObject)(opt)) {
            if ("default" in opt) injected = $dd4bb9853057f55f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $dd4bb9853057f55f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $dd4bb9853057f55f$export$a976684a0efeb93f(opt);
        if ((0, $donES.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $dd4bb9853057f55f$var$callHook(hook, instance, type) {
    $dd4bb9853057f55f$export$dae85862a8d94378((0, $6XHer.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $dd4bb9853057f55f$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $dd4bb9853057f55f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $6XHer.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $6XHer.isFunction)(handler)) $dd4bb9853057f55f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $6XHer.isFunction)(raw)) $dd4bb9853057f55f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $6XHer.isObject)(raw)) {
        if ((0, $6XHer.isArray)(raw)) raw.forEach((r)=>$dd4bb9853057f55f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $6XHer.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $6XHer.isFunction)(handler)) $dd4bb9853057f55f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $dd4bb9853057f55f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$dd4bb9853057f55f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $dd4bb9853057f55f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $6XHer.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $dd4bb9853057f55f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $dd4bb9853057f55f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$dd4bb9853057f55f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $dd4bb9853057f55f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $dd4bb9853057f55f$var$internalOptionMergeStrats = {
    data: $dd4bb9853057f55f$var$mergeDataFn,
    props: $dd4bb9853057f55f$var$mergeEmitsOrPropsOptions,
    emits: $dd4bb9853057f55f$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $dd4bb9853057f55f$var$mergeObjectOptions,
    computed: $dd4bb9853057f55f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $dd4bb9853057f55f$var$mergeAsArray,
    created: $dd4bb9853057f55f$var$mergeAsArray,
    beforeMount: $dd4bb9853057f55f$var$mergeAsArray,
    mounted: $dd4bb9853057f55f$var$mergeAsArray,
    beforeUpdate: $dd4bb9853057f55f$var$mergeAsArray,
    updated: $dd4bb9853057f55f$var$mergeAsArray,
    beforeDestroy: $dd4bb9853057f55f$var$mergeAsArray,
    beforeUnmount: $dd4bb9853057f55f$var$mergeAsArray,
    destroyed: $dd4bb9853057f55f$var$mergeAsArray,
    unmounted: $dd4bb9853057f55f$var$mergeAsArray,
    activated: $dd4bb9853057f55f$var$mergeAsArray,
    deactivated: $dd4bb9853057f55f$var$mergeAsArray,
    errorCaptured: $dd4bb9853057f55f$var$mergeAsArray,
    serverPrefetch: $dd4bb9853057f55f$var$mergeAsArray,
    // assets
    components: $dd4bb9853057f55f$var$mergeObjectOptions,
    directives: $dd4bb9853057f55f$var$mergeObjectOptions,
    // watch
    watch: $dd4bb9853057f55f$var$mergeWatchOptions,
    // provide / inject
    provide: $dd4bb9853057f55f$var$mergeDataFn,
    inject: $dd4bb9853057f55f$var$mergeInject
};
function $dd4bb9853057f55f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $6XHer.extend)((0, $6XHer.isFunction)(to) ? to.call(this, this) : to, (0, $6XHer.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $dd4bb9853057f55f$var$mergeInject(to, from) {
    return $dd4bb9853057f55f$var$mergeObjectOptions($dd4bb9853057f55f$var$normalizeInject(to), $dd4bb9853057f55f$var$normalizeInject(from));
}
function $dd4bb9853057f55f$var$normalizeInject(raw) {
    if ((0, $6XHer.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $dd4bb9853057f55f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $dd4bb9853057f55f$var$mergeObjectOptions(to, from) {
    return to ? (0, $6XHer.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $dd4bb9853057f55f$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $6XHer.isArray)(to) && (0, $6XHer.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $6XHer.extend)(/* @__PURE__ */ Object.create(null), $dd4bb9853057f55f$var$normalizePropsOrEmits(to), $dd4bb9853057f55f$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $dd4bb9853057f55f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $6XHer.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $dd4bb9853057f55f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $dd4bb9853057f55f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $6XHer.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $dd4bb9853057f55f$var$uid$1 = 0;
function $dd4bb9853057f55f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $6XHer.isFunction)(rootComponent)) rootComponent = (0, $6XHer.extend)({}, rootComponent);
        if (rootProps != null && !(0, $6XHer.isObject)(rootProps)) rootProps = null;
        const context = $dd4bb9853057f55f$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $dd4bb9853057f55f$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $dd4bb9853057f55f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $6XHer.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $6XHer.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $dd4bb9853057f55f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $dd4bb9853057f55f$var$devtoolsInitApp(app, $dd4bb9853057f55f$export$83d89fbfd8236492);
                    }
                    return $dd4bb9853057f55f$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $dd4bb9853057f55f$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $dd4bb9853057f55f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $dd4bb9853057f55f$var$currentApp;
                $dd4bb9853057f55f$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $dd4bb9853057f55f$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $dd4bb9853057f55f$var$currentApp = null;
function $dd4bb9853057f55f$export$fb78bd113157f1a1(props, name, options = (0, $6XHer.EMPTY_OBJ)) {
    const i = $dd4bb9853057f55f$export$f13e630aa3915748();
    const camelizedName = (0, $6XHer.camelize)(name);
    const hyphenatedName = (0, $6XHer.hyphenate)(name);
    const modifiers = $dd4bb9853057f55f$var$getModelModifiers(props, camelizedName);
    const res = (0, $donES.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $6XHer.EMPTY_OBJ);
        let prevEmittedValue;
        $dd4bb9853057f55f$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $6XHer.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $6XHer.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $6XHer.EMPTY_OBJ) && (0, $6XHer.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $6XHer.hasChanged)(value, prevSetValue) && ((0, $6XHer.hasChanged)(value, emittedValue) && !(0, $6XHer.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $6XHer.EMPTY_OBJ) && !(0, $6XHer.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $6XHer.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $dd4bb9853057f55f$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $6XHer.camelize)(modelName)}Modifiers`] || props[`${(0, $6XHer.hyphenate)(modelName)}Modifiers`];
};
function $dd4bb9853057f55f$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $6XHer.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $dd4bb9853057f55f$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $6XHer.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $6XHer.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $6XHer.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $6XHer.toHandlerKey)((0, $6XHer.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $6XHer.toHandlerKey)((0, $6XHer.hyphenate)(event))];
    if (handler) $dd4bb9853057f55f$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $dd4bb9853057f55f$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $dd4bb9853057f55f$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $dd4bb9853057f55f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $dd4bb9853057f55f$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6XHer.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $dd4bb9853057f55f$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $6XHer.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $6XHer.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $6XHer.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $6XHer.extend)(normalized, raw);
    if ((0, $6XHer.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $dd4bb9853057f55f$var$isEmitListener(options, key) {
    if (!options || !(0, $6XHer.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $6XHer.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $6XHer.hasOwn)(options, (0, $6XHer.hyphenate)(key)) || (0, $6XHer.hasOwn)(options, key);
}
let $dd4bb9853057f55f$var$accessedAttrs = false;
function $dd4bb9853057f55f$var$markAttrsAccessed() {
    $dd4bb9853057f55f$var$accessedAttrs = true;
}
function $dd4bb9853057f55f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $dd4bb9853057f55f$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $dd4bb9853057f55f$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $dd4bb9853057f55f$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $dd4bb9853057f55f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $dd4bb9853057f55f$var$blockStack.length = 0;
        $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, 1);
        result = $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $6XHer.isModelListener))) fallthroughAttrs = $dd4bb9853057f55f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $dd4bb9853057f55f$var$isTeleport(root.type) ? $dd4bb9853057f55f$var$getInnerChild$1(root) || root : root;
        $dd4bb9853057f55f$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $dd4bb9853057f55f$var$setCurrentRenderingInstance(prev);
    return result;
}
const $dd4bb9853057f55f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $dd4bb9853057f55f$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $dd4bb9853057f55f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $dd4bb9853057f55f$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($dd4bb9853057f55f$export$3868d13f8734ae81(child)) {
            if (child.type !== $dd4bb9853057f55f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $dd4bb9853057f55f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $6XHer.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $dd4bb9853057f55f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $6XHer.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $dd4bb9853057f55f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $dd4bb9853057f55f$export$4d299b491347818a;
};
function $dd4bb9853057f55f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $dd4bb9853057f55f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($dd4bb9853057f55f$var$hasPropValueChanged(nextProps, prevProps, key) && !$dd4bb9853057f55f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $dd4bb9853057f55f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $dd4bb9853057f55f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (!(0, $6XHer.hasOwn)(prevProps, key) || $dd4bb9853057f55f$var$hasPropValueChanged(nextProps, prevProps, key) && !$dd4bb9853057f55f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $dd4bb9853057f55f$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $6XHer.isObject)(nextProp) && (0, $6XHer.isObject)(prevProp)) return !(0, $6XHer.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $dd4bb9853057f55f$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $dd4bb9853057f55f$var$internalObjectProto = {};
const $dd4bb9853057f55f$var$createInternalObject = ()=>Object.create($dd4bb9853057f55f$var$internalObjectProto);
const $dd4bb9853057f55f$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $dd4bb9853057f55f$var$internalObjectProto;
function $dd4bb9853057f55f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $dd4bb9853057f55f$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $dd4bb9853057f55f$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $donES.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $dd4bb9853057f55f$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $dd4bb9853057f55f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $donES.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($dd4bb9853057f55f$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $6XHer.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $6XHer.camelize)(key);
                        props[camelizedKey] = $dd4bb9853057f55f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($dd4bb9853057f55f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $6XHer.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $6XHer.hyphenate)(key)) === key || !(0, $6XHer.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $dd4bb9853057f55f$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $6XHer.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $donES.trigger)(instance.attrs, "set", "");
}
function $dd4bb9853057f55f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $6XHer.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $6XHer.hasOwn)(options, camelKey = (0, $6XHer.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$dd4bb9853057f55f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $donES.toRaw)(props);
        const castValues = rawCastValues || (0, $6XHer.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $dd4bb9853057f55f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $6XHer.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $dd4bb9853057f55f$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $6XHer.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $6XHer.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $dd4bb9853057f55f$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $6XHer.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $dd4bb9853057f55f$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $dd4bb9853057f55f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $dd4bb9853057f55f$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6XHer.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $dd4bb9853057f55f$var$normalizePropsOptions(raw2, appContext, true);
            (0, $6XHer.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $6XHer.isObject)(comp)) cache.set(comp, (0, $6XHer.EMPTY_ARR));
        return 0, $6XHer.EMPTY_ARR;
    }
    if ((0, $6XHer.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $6XHer.camelize)(raw[i]);
        if ($dd4bb9853057f55f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $6XHer.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $6XHer.camelize)(key);
        if ($dd4bb9853057f55f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $6XHer.isArray)(opt) || (0, $6XHer.isFunction)(opt) ? {
                type: opt
            } : (0, $6XHer.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $6XHer.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $6XHer.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $6XHer.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $6XHer.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $6XHer.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $dd4bb9853057f55f$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $6XHer.isReservedProp)(key)) return true;
    return false;
}
function $dd4bb9853057f55f$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $dd4bb9853057f55f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $donES.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $6XHer.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $dd4bb9853057f55f$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $dd4bb9853057f55f$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $dd4bb9853057f55f$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $6XHer.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $dd4bb9853057f55f$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $dd4bb9853057f55f$var$warn$1($dd4bb9853057f55f$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $dd4bb9853057f55f$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $dd4bb9853057f55f$var$isSimpleType = /* @__PURE__ */ (0, $6XHer.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $dd4bb9853057f55f$var$assertType(value, type) {
    let valid;
    const expectedType = $dd4bb9853057f55f$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($dd4bb9853057f55f$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $6XHer.isObject)(value);
    else if (expectedType === "Array") valid = (0, $6XHer.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $dd4bb9853057f55f$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $6XHer.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $6XHer.toRawType)(value);
    const expectedValue = $dd4bb9853057f55f$var$styleValue(value, expectedType);
    const receivedValue = $dd4bb9853057f55f$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $dd4bb9853057f55f$var$isExplicable(expectedType) && $dd4bb9853057f55f$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($dd4bb9853057f55f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $dd4bb9853057f55f$var$styleValue(value, type) {
    if ((0, $6XHer.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $dd4bb9853057f55f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $dd4bb9853057f55f$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $dd4bb9853057f55f$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $dd4bb9853057f55f$var$normalizeSlotValue = (value)=>(0, $6XHer.isArray)(value) ? value.map($dd4bb9853057f55f$var$normalizeVNode) : [
        $dd4bb9853057f55f$var$normalizeVNode(value)
    ];
const $dd4bb9853057f55f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $dd4bb9853057f55f$export$694b237e827a3d23((...args)=>{
        return $dd4bb9853057f55f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $dd4bb9853057f55f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($dd4bb9853057f55f$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $6XHer.isFunction)(value)) slots[key] = $dd4bb9853057f55f$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $dd4bb9853057f55f$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $dd4bb9853057f55f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $dd4bb9853057f55f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $dd4bb9853057f55f$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$dd4bb9853057f55f$var$isInternalKey(key)) slots[key] = children[key];
};
const $dd4bb9853057f55f$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $dd4bb9853057f55f$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $dd4bb9853057f55f$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $6XHer.def)(slots, "_", type, true);
        } else $dd4bb9853057f55f$var$normalizeObjectSlots(children, slots);
    } else if (children) $dd4bb9853057f55f$var$normalizeVNodeSlots(instance, children);
};
const $dd4bb9853057f55f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $6XHer.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $dd4bb9853057f55f$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $dd4bb9853057f55f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $dd4bb9853057f55f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$dd4bb9853057f55f$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $dd4bb9853057f55f$var$supported;
let $dd4bb9853057f55f$var$perf;
function $dd4bb9853057f55f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $dd4bb9853057f55f$var$isSupported()) $dd4bb9853057f55f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsPerfStart(instance, type, $dd4bb9853057f55f$var$isSupported() ? $dd4bb9853057f55f$var$perf.now() : Date.now());
}
function $dd4bb9853057f55f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $dd4bb9853057f55f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$dd4bb9853057f55f$var$formatComponentName(instance, instance.type)}> ${type}`;
        $dd4bb9853057f55f$var$perf.mark(endTag);
        $dd4bb9853057f55f$var$perf.measure(measureName, startTag, endTag);
        $dd4bb9853057f55f$var$perf.clearMeasures(measureName);
        $dd4bb9853057f55f$var$perf.clearMarks(startTag);
        $dd4bb9853057f55f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsPerfEnd(instance, type, $dd4bb9853057f55f$var$isSupported() ? $dd4bb9853057f55f$var$perf.now() : Date.now());
}
function $dd4bb9853057f55f$var$isSupported() {
    if ($dd4bb9853057f55f$var$supported !== void 0) return $dd4bb9853057f55f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $dd4bb9853057f55f$var$supported = true;
        $dd4bb9853057f55f$var$perf = window.performance;
    } else $dd4bb9853057f55f$var$supported = false;
    return $dd4bb9853057f55f$var$supported;
}
function $dd4bb9853057f55f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $6XHer.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $6XHer.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $6XHer.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $dd4bb9853057f55f$var$queuePostRenderEffect = $dd4bb9853057f55f$var$queueEffectWithSuspense;
function $dd4bb9853057f55f$export$53ae2f996c64e9a(options) {
    return $dd4bb9853057f55f$var$baseCreateRenderer(options);
}
function $dd4bb9853057f55f$export$200524cf0d997ff0(options) {
    return $dd4bb9853057f55f$var$baseCreateRenderer(options, $dd4bb9853057f55f$var$createHydrationFunctions);
}
function $dd4bb9853057f55f$var$baseCreateRenderer(options, createHydrationFns) {
    $dd4bb9853057f55f$var$initFeatureFlags();
    const target = (0, $6XHer.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $6XHer.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$dd4bb9853057f55f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
            if (n2.dynamicChildren === (0, $6XHer.EMPTY_ARR)) n2.dynamicChildren = [];
            n2.dynamicChildren.hasOnce = true;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $dd4bb9853057f55f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $dd4bb9853057f55f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $dd4bb9853057f55f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $dd4bb9853057f55f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $dd4bb9853057f55f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $dd4bb9853057f55f$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $dd4bb9853057f55f$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $6XHer.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6XHer.def)(el, "__vnode", vnode, true);
            (0, $6XHer.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $dd4bb9853057f55f$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $dd4bb9853057f55f$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(children[i]) : $dd4bb9853057f55f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $6XHer.EMPTY_OBJ);
        const newProps = n2.props || (0, $6XHer.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $dd4bb9853057f55f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $dd4bb9853057f55f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $dd4bb9853057f55f$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $dd4bb9853057f55f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $dd4bb9853057f55f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
            vnodeHook && $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $dd4bb9853057f55f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const oldEl = oldVNode.el || $dd4bb9853057f55f$var$resolveAsyncComponentPlaceholder(oldVNode);
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldEl && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $dd4bb9853057f55f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$dd4bb9853057f55f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldEl) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $6XHer.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $6XHer.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $6XHer.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $dd4bb9853057f55f$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $dd4bb9853057f55f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($dd4bb9853057f55f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $dd4bb9853057f55f$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized, namespace);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($dd4bb9853057f55f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                n2.el = n1.el;
                n2.placeholder = n1.placeholder;
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            n2.placeholder = n1.placeholder;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $dd4bb9853057f55f$var$isAsyncWrapper(initialVNode);
                $dd4bb9853057f55f$var$toggleRecurse(instance, false);
                if (bm) (0, $6XHer.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $dd4bb9853057f55f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $dd4bb9853057f55f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $dd4bb9853057f55f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $dd4bb9853057f55f$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $dd4bb9853057f55f$var$queuePostRenderEffect(()=>$dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $dd4bb9853057f55f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $dd4bb9853057f55f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $dd4bb9853057f55f$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $dd4bb9853057f55f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $6XHer.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $dd4bb9853057f55f$var$toggleRecurse(instance, true);
                const nextTree = $dd4bb9853057f55f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $dd4bb9853057f55f$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $dd4bb9853057f55f$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $dd4bb9853057f55f$var$queuePostRenderEffect(()=>$dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $donES.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$dd4bb9853057f55f$var$queueJob(job);
        $dd4bb9853057f55f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $dd4bb9853057f55f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $dd4bb9853057f55f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $donES.pauseTracking)();
        $dd4bb9853057f55f$var$flushPreFlushCbs(instance);
        (0, $donES.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $6XHer.EMPTY_ARR);
        c2 = c2 || (0, $6XHer.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(c2[i]) : $dd4bb9853057f55f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(c2[i]) : $dd4bb9853057f55f$var$normalizeVNode(c2[i]);
            if ($dd4bb9853057f55f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(c2[e2]) : $dd4bb9853057f55f$var$normalizeVNode(c2[e2]);
            if ($dd4bb9853057f55f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(c2[i]) : $dd4bb9853057f55f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $dd4bb9853057f55f$var$cloneIfMounted(c2[i]) : $dd4bb9853057f55f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $dd4bb9853057f55f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $dd4bb9853057f55f$var$getSequence(newIndexToOldIndexMap) : (0, $6XHer.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $dd4bb9853057f55f$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $dd4bb9853057f55f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $dd4bb9853057f55f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$dd4bb9853057f55f$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $dd4bb9853057f55f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$dd4bb9853057f55f$var$leaveCbKey];
                    if (el._isLeaving) el[$dd4bb9853057f55f$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
        if (ref != null) {
            (0, $donES.pauseTracking)();
            $dd4bb9853057f55f$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $donES.resetTracking)();
        }
        if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$dd4bb9853057f55f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $dd4bb9853057f55f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $dd4bb9853057f55f$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
            vnodeHook && $dd4bb9853057f55f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $dd4bb9853057f55f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        const isFragment = type === $dd4bb9853057f55f$export$ffb0004e005737fa;
        if (isFragment && !transition) {
            removeFragment(el, anchor);
            return;
        }
        if (type === $dd4bb9853057f55f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
            return;
        }
        const leavingNode = isFragment ? $dd4bb9853057f55f$var$getTransitionRoot(vnode) : vnode;
        const performRemove = ()=>{
            if (isFragment) {
                if (hostParentNode(el)) removeFragment(el, anchor);
            } else hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (leavingNode && leavingNode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const leavingEl = leavingNode.el;
            const performLeave = ()=>leave(leavingEl, performRemove);
            if (delayLeave) delayLeave(leavingEl, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $dd4bb9853057f55f$var$invalidateMount(m);
        $dd4bb9853057f55f$var$invalidateMount(a);
        if (bum) (0, $6XHer.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        } else if (instance.vnode.el && subTree) {
            subTree.transition = instance.vnode.transition;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $dd4bb9853057f55f$var$queuePostRenderEffect(um, parentSuspense);
        $dd4bb9853057f55f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $dd4bb9853057f55f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$dd4bb9853057f55f$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    const render = (vnode, container, namespace)=>{
        const minUid = vnode && container._vnode ? void 0 : vnode && vnode.component ? vnode.component.uid : $dd4bb9853057f55f$var$getNextUid();
        $dd4bb9853057f55f$var$flushOnAppMount(()=>{
            if (vnode == null) {
                if (container._vnode) unmount(container._vnode, null, null, true);
            } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
            container._vnode = vnode;
        }, minUid);
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $dd4bb9853057f55f$var$createAppAPI(render, hydrate)
    };
}
function $dd4bb9853057f55f$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $dd4bb9853057f55f$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $dd4bb9853057f55f$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $dd4bb9853057f55f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $6XHer.isArray)(ch1) && (0, $6XHer.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $dd4bb9853057f55f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $dd4bb9853057f55f$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $dd4bb9853057f55f$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $dd4bb9853057f55f$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $dd4bb9853057f55f$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $dd4bb9853057f55f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $dd4bb9853057f55f$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $dd4bb9853057f55f$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $dd4bb9853057f55f$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $dd4bb9853057f55f$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $dd4bb9853057f55f$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $dd4bb9853057f55f$var$isSuspense = (type)=>type.__isSuspense;
let $dd4bb9853057f55f$var$suspenseId = 0;
const $dd4bb9853057f55f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $dd4bb9853057f55f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback && !parentSuspense.isHydrating) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $dd4bb9853057f55f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $dd4bb9853057f55f$var$hydrateSuspense,
    normalize: $dd4bb9853057f55f$var$normalizeSuspenseChildren
};
const $dd4bb9853057f55f$export$74bf444e3cd11ea5 = $dd4bb9853057f55f$var$SuspenseImpl;
function $dd4bb9853057f55f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $6XHer.isFunction)(eventListener)) eventListener();
}
function $dd4bb9853057f55f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $dd4bb9853057f55f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $dd4bb9853057f55f$var$triggerEvent(vnode, "onPending");
        $dd4bb9853057f55f$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $dd4bb9853057f55f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $dd4bb9853057f55f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($dd4bb9853057f55f$var$isSameVNodeType(pendingBranch, newBranch)) {
            suspense.deps++;
            patch(pendingBranch, newBranch, // a hydrating pending branch is adopted SSR DOM, already in place
            isHydrating ? container : suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            suspense.deps--;
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $dd4bb9853057f55f$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $dd4bb9853057f55f$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $dd4bb9853057f55f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $dd4bb9853057f55f$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $dd4bb9853057f55f$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $dd4bb9853057f55f$var$setActiveBranch(suspense, newBranch);
    } else {
        $dd4bb9853057f55f$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $dd4bb9853057f55f$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $dd4bb9853057f55f$var$hasWarned = false;
function $dd4bb9853057f55f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $dd4bb9853057f55f$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $6XHer.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $dd4bb9853057f55f$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $dd4bb9853057f55f$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $dd4bb9853057f55f$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $dd4bb9853057f55f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $dd4bb9853057f55f$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspenseId = void 0;
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $dd4bb9853057f55f$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $dd4bb9853057f55f$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $dd4bb9853057f55f$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        // `namespace` intentionally shadows the boundary's own: the dep must be
        // mounted with the namespace of the position it was rendered at, which can
        // differ from the boundary's (e.g. a component nested inside an <svg>).
        registerDep (instance, setupRenderEffect, optimized2, namespace2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $dd4bb9853057f55f$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $dd4bb9853057f55f$var$unsetCurrentInstance();
                if (!instance.scope.active) {
                    if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
                    return;
                }
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $dd4bb9853057f55f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace2, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $dd4bb9853057f55f$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $dd4bb9853057f55f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $dd4bb9853057f55f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $dd4bb9853057f55f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $dd4bb9853057f55f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $dd4bb9853057f55f$var$normalizeSuspenseSlot(children.fallback) : $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$4d299b491347818a);
}
function $dd4bb9853057f55f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $6XHer.isFunction)(s)) {
        const trackBlock = $dd4bb9853057f55f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $dd4bb9853057f55f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $dd4bb9853057f55f$var$currentBlock;
            $dd4bb9853057f55f$var$closeBlock();
        }
    }
    if ((0, $6XHer.isArray)(s)) {
        const singleChild = $dd4bb9853057f55f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $dd4bb9853057f55f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $dd4bb9853057f55f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $6XHer.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $dd4bb9853057f55f$export$59536a0199721cab(fn);
}
function $dd4bb9853057f55f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $dd4bb9853057f55f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $dd4bb9853057f55f$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $dd4bb9853057f55f$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $dd4bb9853057f55f$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $dd4bb9853057f55f$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $dd4bb9853057f55f$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $dd4bb9853057f55f$var$blockStack = [];
let $dd4bb9853057f55f$var$currentBlock = null;
function $dd4bb9853057f55f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $dd4bb9853057f55f$var$blockStack.push($dd4bb9853057f55f$var$currentBlock = disableTracking ? null : []);
}
function $dd4bb9853057f55f$var$closeBlock() {
    $dd4bb9853057f55f$var$blockStack.pop();
    $dd4bb9853057f55f$var$currentBlock = $dd4bb9853057f55f$var$blockStack[$dd4bb9853057f55f$var$blockStack.length - 1] || null;
}
let $dd4bb9853057f55f$var$isBlockTreeEnabled = 1;
function $dd4bb9853057f55f$export$c20bee82f26f1e27(value, inVOnce = false) {
    $dd4bb9853057f55f$var$isBlockTreeEnabled += value;
    if (value < 0 && $dd4bb9853057f55f$var$currentBlock && inVOnce) $dd4bb9853057f55f$var$currentBlock.hasOnce = true;
}
function $dd4bb9853057f55f$var$setupBlock(vnode) {
    vnode.dynamicChildren = $dd4bb9853057f55f$var$isBlockTreeEnabled > 0 ? $dd4bb9853057f55f$var$currentBlock || (0, $6XHer.EMPTY_ARR) : null;
    $dd4bb9853057f55f$var$closeBlock();
    if ($dd4bb9853057f55f$var$isBlockTreeEnabled > 0 && $dd4bb9853057f55f$var$currentBlock) $dd4bb9853057f55f$var$currentBlock.push(vnode);
    return vnode;
}
function $dd4bb9853057f55f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $dd4bb9853057f55f$var$setupBlock($dd4bb9853057f55f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $dd4bb9853057f55f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $dd4bb9853057f55f$var$setupBlock($dd4bb9853057f55f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $dd4bb9853057f55f$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $dd4bb9853057f55f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $dd4bb9853057f55f$var$vnodeArgsTransformer;
function $dd4bb9853057f55f$export$83beccd3afeeb809(transformer) {
    $dd4bb9853057f55f$var$vnodeArgsTransformer = transformer;
}
const $dd4bb9853057f55f$var$createVNodeWithArgsTransform = (...args)=>{
    return $dd4bb9853057f55f$var$_createVNode(...$dd4bb9853057f55f$var$vnodeArgsTransformer ? $dd4bb9853057f55f$var$vnodeArgsTransformer(args, $dd4bb9853057f55f$var$currentRenderingInstance) : args);
};
const $dd4bb9853057f55f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $dd4bb9853057f55f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $6XHer.isString)(ref) || (0, $donES.isRef)(ref) || (0, $6XHer.isFunction)(ref) ? {
        i: $dd4bb9853057f55f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $dd4bb9853057f55f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $dd4bb9853057f55f$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $dd4bb9853057f55f$var$normalizeKey(props),
        ref: props && $dd4bb9853057f55f$var$normalizeRef(props),
        scopeId: $dd4bb9853057f55f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $dd4bb9853057f55f$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $dd4bb9853057f55f$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $6XHer.isString)(children) ? 8 : 16;
    if ($dd4bb9853057f55f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $dd4bb9853057f55f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $dd4bb9853057f55f$var$currentBlock.push(vnode);
    return vnode;
}
function $dd4bb9853057f55f$var$hasContentChildren(children) {
    if ((0, $6XHer.isString)(children)) return children !== "";
    if ((0, $6XHer.isArray)(children)) return children.length > 0;
    return false;
}
const $dd4bb9853057f55f$export$bf5c4cf060303d58 = $dd4bb9853057f55f$var$_createVNode;
function $dd4bb9853057f55f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $dd4bb9853057f55f$var$NULL_DYNAMIC_COMPONENT) type = $dd4bb9853057f55f$export$4d299b491347818a;
    if ($dd4bb9853057f55f$export$3868d13f8734ae81(type)) {
        const cloned = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $dd4bb9853057f55f$var$normalizeChildren(cloned, children);
        if ($dd4bb9853057f55f$var$isBlockTreeEnabled > 0 && !isBlockNode && $dd4bb9853057f55f$var$currentBlock) {
            if (cloned.shapeFlag & 6) $dd4bb9853057f55f$var$currentBlock[$dd4bb9853057f55f$var$currentBlock.indexOf(type)] = cloned;
            else $dd4bb9853057f55f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($dd4bb9853057f55f$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $dd4bb9853057f55f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $6XHer.isString)(klass)) props.class = (0, $6XHer.normalizeClass)(klass);
        if ((0, $6XHer.isObject)(style)) {
            if ((0, $donES.isProxy)(style) && !(0, $6XHer.isArray)(style)) style = (0, $6XHer.extend)({}, style);
            props.style = (0, $6XHer.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $6XHer.isString)(type) ? 1 : $dd4bb9853057f55f$var$isSuspense(type) ? 128 : $dd4bb9853057f55f$var$isTeleport(type) ? 64 : (0, $6XHer.isObject)(type) ? 4 : (0, $6XHer.isFunction)(type) ? 2 : 0;
    return $dd4bb9853057f55f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $dd4bb9853057f55f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $donES.isProxy)(props) || $dd4bb9853057f55f$var$isInternalObject(props) ? (0, $6XHer.extend)({}, props) : props;
}
function $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $dd4bb9853057f55f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $dd4bb9853057f55f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $6XHer.isArray)(ref) ? ref.concat($dd4bb9853057f55f$var$normalizeRef(extraProps)) : [
            ref,
            $dd4bb9853057f55f$var$normalizeRef(extraProps)
        ] : $dd4bb9853057f55f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $dd4bb9853057f55f$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce,
        cacheIndex: vnode.cacheIndex
    };
    if (transition && cloneTransition) $dd4bb9853057f55f$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $dd4bb9853057f55f$var$deepCloneVNode(vnode) {
    const cloned = $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $6XHer.isArray)(vnode.children)) cloned.children = vnode.children.map($dd4bb9853057f55f$var$deepCloneVNode);
    return cloned;
}
function $dd4bb9853057f55f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$5f1af8db9871e1d6, null, text, flag);
}
function $dd4bb9853057f55f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $dd4bb9853057f55f$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($dd4bb9853057f55f$export$e7eaa45e502fe5cc(), $dd4bb9853057f55f$export$9f2dfe8048dfb22b($dd4bb9853057f55f$export$4d299b491347818a, null, text)) : $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$4d299b491347818a, null, text);
}
function $dd4bb9853057f55f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$4d299b491347818a);
    else if ((0, $6XHer.isArray)(child)) return $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($dd4bb9853057f55f$export$3868d13f8734ae81(child)) return $dd4bb9853057f55f$var$cloneIfMounted(child);
    else return $dd4bb9853057f55f$export$bf5c4cf060303d58($dd4bb9853057f55f$export$5f1af8db9871e1d6, null, String(child));
}
function $dd4bb9853057f55f$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $dd4bb9853057f55f$export$ee4f9e12c0a92a1a(child);
}
function $dd4bb9853057f55f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $6XHer.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $dd4bb9853057f55f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$dd4bb9853057f55f$var$isInternalObject(children)) children._ctx = $dd4bb9853057f55f$var$currentRenderingInstance;
            else if (slotFlag === 3 && $dd4bb9853057f55f$var$currentRenderingInstance) {
                if ($dd4bb9853057f55f$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $6XHer.isFunction)(children)) {
        if (shapeFlag & 65) {
            $dd4bb9853057f55f$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $dd4bb9853057f55f$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $dd4bb9853057f55f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $dd4bb9853057f55f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $6XHer.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $6XHer.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $6XHer.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $6XHer.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $6XHer.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $dd4bb9853057f55f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $dd4bb9853057f55f$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $dd4bb9853057f55f$var$emptyAppContext = $dd4bb9853057f55f$var$createAppContext();
let $dd4bb9853057f55f$var$uid = 0;
function $dd4bb9853057f55f$var$getNextUid() {
    return $dd4bb9853057f55f$var$uid;
}
function $dd4bb9853057f55f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $dd4bb9853057f55f$var$emptyAppContext;
    const instance = {
        uid: $dd4bb9853057f55f$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $donES.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $dd4bb9853057f55f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $dd4bb9853057f55f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $6XHer.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $6XHer.EMPTY_OBJ),
        data: (0, $6XHer.EMPTY_OBJ),
        props: (0, $6XHer.EMPTY_OBJ),
        attrs: (0, $6XHer.EMPTY_OBJ),
        slots: (0, $6XHer.EMPTY_OBJ),
        refs: (0, $6XHer.EMPTY_OBJ),
        setupState: (0, $6XHer.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $dd4bb9853057f55f$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $dd4bb9853057f55f$var$currentInstance = null;
const $dd4bb9853057f55f$export$f13e630aa3915748 = ()=>$dd4bb9853057f55f$var$currentInstance || $dd4bb9853057f55f$var$currentRenderingInstance;
let $dd4bb9853057f55f$var$internalSetCurrentInstance;
let $dd4bb9853057f55f$var$setInSSRSetupState;
{
    const g = (0, $6XHer.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $dd4bb9853057f55f$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$dd4bb9853057f55f$var$currentInstance = v1);
    $dd4bb9853057f55f$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$dd4bb9853057f55f$var$isInSSRComponentSetup = v1);
}const $dd4bb9853057f55f$var$setCurrentInstance = (instance)=>{
    const prev = $dd4bb9853057f55f$var$currentInstance;
    $dd4bb9853057f55f$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $dd4bb9853057f55f$var$internalSetCurrentInstance(prev);
    };
};
const $dd4bb9853057f55f$var$unsetCurrentInstance = ()=>{
    $dd4bb9853057f55f$var$currentInstance && $dd4bb9853057f55f$var$currentInstance.scope.off();
    $dd4bb9853057f55f$var$internalSetCurrentInstance(null);
};
const $dd4bb9853057f55f$var$isBuiltInTag = /* @__PURE__ */ (0, $6XHer.makeMap)("slot,component");
function $dd4bb9853057f55f$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($dd4bb9853057f55f$var$isBuiltInTag(name) || isNativeTag(name)) $dd4bb9853057f55f$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $dd4bb9853057f55f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $dd4bb9853057f55f$var$isInSSRComponentSetup = false;
function $dd4bb9853057f55f$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $dd4bb9853057f55f$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $dd4bb9853057f55f$var$isStatefulComponent(instance);
    $dd4bb9853057f55f$var$initProps(instance, props, isStateful, isSSR);
    $dd4bb9853057f55f$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $dd4bb9853057f55f$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $dd4bb9853057f55f$var$setInSSRSetupState(false);
    return setupResult;
}
function $dd4bb9853057f55f$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $dd4bb9853057f55f$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $donES.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $dd4bb9853057f55f$var$createSetupContext(instance) : null;
        const reset = $dd4bb9853057f55f$var$setCurrentInstance(instance);
        const setupResult = $dd4bb9853057f55f$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $6XHer.isPromise)(setupResult);
        (0, $donES.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$dd4bb9853057f55f$var$isAsyncWrapper(instance)) $dd4bb9853057f55f$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($dd4bb9853057f55f$var$unsetCurrentInstance, $dd4bb9853057f55f$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $dd4bb9853057f55f$var$setInSSRSetupState(true);
                try {
                    $dd4bb9853057f55f$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $dd4bb9853057f55f$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $dd4bb9853057f55f$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $dd4bb9853057f55f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $dd4bb9853057f55f$var$finishComponentSetup(instance, isSSR);
}
function $dd4bb9853057f55f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $6XHer.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $6XHer.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $donES.proxyRefs)(setupResult);
    }
    $dd4bb9853057f55f$var$finishComponentSetup(instance, isSSR);
}
let $dd4bb9853057f55f$var$compile;
let $dd4bb9853057f55f$var$installWithProxy;
function $dd4bb9853057f55f$export$667bb5a67822b941(_compile) {
    $dd4bb9853057f55f$var$compile = _compile;
    $dd4bb9853057f55f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $dd4bb9853057f55f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $dd4bb9853057f55f$export$c93a9c496c5211fa = ()=>!$dd4bb9853057f55f$var$compile;
function $dd4bb9853057f55f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $dd4bb9853057f55f$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $dd4bb9853057f55f$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $6XHer.extend)((0, $6XHer.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $dd4bb9853057f55f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $6XHer.NOOP);
        if ($dd4bb9853057f55f$var$installWithProxy) $dd4bb9853057f55f$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $dd4bb9853057f55f$var$setCurrentInstance(instance);
        (0, $donES.pauseTracking)();
        try {
            $dd4bb9853057f55f$var$applyOptions(instance);
        } finally{
            (0, $donES.resetTracking)();
            reset();
        }
    }
}
const $dd4bb9853057f55f$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $donES.track)(target, "get", "");
        return target[key];
    }
};
function $dd4bb9853057f55f$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $donES.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $dd4bb9853057f55f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $dd4bb9853057f55f$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $dd4bb9853057f55f$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $donES.proxyRefs)((0, $donES.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $dd4bb9853057f55f$var$publicPropertiesMap) return $dd4bb9853057f55f$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $dd4bb9853057f55f$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $dd4bb9853057f55f$var$classifyRE = /(?:^|[-_])\w/g;
const $dd4bb9853057f55f$var$classify = (str)=>str.replace($dd4bb9853057f55f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $dd4bb9853057f55f$var$getComponentName(Component, includeInferred = true) {
    return (0, $6XHer.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $dd4bb9853057f55f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $dd4bb9853057f55f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $dd4bb9853057f55f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $dd4bb9853057f55f$var$isClassComponent(value) {
    return (0, $6XHer.isFunction)(value) && "__vccOpts" in value;
}
const $dd4bb9853057f55f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $donES.computed)(getterOrOptions, debugOptions, $dd4bb9853057f55f$var$isInSSRComponentSetup);
    return c;
};
function $dd4bb9853057f55f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $dd4bb9853057f55f$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $6XHer.isObject)(propsOrChildren) && !(0, $6XHer.isArray)(propsOrChildren)) {
                if ($dd4bb9853057f55f$export$3868d13f8734ae81(propsOrChildren)) return $dd4bb9853057f55f$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $dd4bb9853057f55f$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $dd4bb9853057f55f$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $dd4bb9853057f55f$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $dd4bb9853057f55f$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $dd4bb9853057f55f$export$c20bee82f26f1e27(1);
    }
}
function $dd4bb9853057f55f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $donES.toRaw)(instance.props)));
        if (instance.setupState !== (0, $6XHer.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $6XHer.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $donES.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $6XHer.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $6XHer.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $donES.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $6XHer.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $6XHer.isArray)(opts) && opts.includes(key) || (0, $6XHer.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $donES.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $dd4bb9853057f55f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $dd4bb9853057f55f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $dd4bb9853057f55f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $6XHer.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($dd4bb9853057f55f$var$isBlockTreeEnabled > 0 && $dd4bb9853057f55f$var$currentBlock) $dd4bb9853057f55f$var$currentBlock.push(cached);
    return true;
}
const $dd4bb9853057f55f$export$83d89fbfd8236492 = "3.5.44";
const $dd4bb9853057f55f$export$c106dd0671a0fc2d = (0, $6XHer.NOOP);
const $dd4bb9853057f55f$export$795e0ad4a0e2ed30 = $dd4bb9853057f55f$var$ErrorTypeStrings$1;
const $dd4bb9853057f55f$export$6922d3b3a607469e = $dd4bb9853057f55f$var$devtools$1;
const $dd4bb9853057f55f$export$b0c258b32c26c785 = $dd4bb9853057f55f$var$setDevtoolsHook$1;
const $dd4bb9853057f55f$var$_ssrUtils = {
    createComponentInstance: $dd4bb9853057f55f$var$createComponentInstance,
    setupComponent: $dd4bb9853057f55f$var$setupComponent,
    renderComponentRoot: $dd4bb9853057f55f$var$renderComponentRoot,
    setCurrentRenderingInstance: $dd4bb9853057f55f$var$setCurrentRenderingInstance,
    isVNode: $dd4bb9853057f55f$export$3868d13f8734ae81,
    normalizeVNode: $dd4bb9853057f55f$var$normalizeVNode,
    getComponentPublicInstance: $dd4bb9853057f55f$var$getComponentPublicInstance,
    ensureValidVNode: $dd4bb9853057f55f$var$ensureValidVNode,
    pushWarningContext: $dd4bb9853057f55f$var$pushWarningContext,
    popWarningContext: $dd4bb9853057f55f$var$popWarningContext
};
const $dd4bb9853057f55f$export$a9679033567b336d = $dd4bb9853057f55f$var$_ssrUtils;
const $dd4bb9853057f55f$export$83cf26e06ea620e1 = null;
const $dd4bb9853057f55f$export$dc678eddf276286e = null;
const $dd4bb9853057f55f$export$22072a82865312f6 = null;

});
parcelRegister("donES", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $9bffde4ffa967ea0$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $9bffde4ffa967ea0$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $9bffde4ffa967ea0$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "onScopeDispose", function () { return $9bffde4ffa967ea0$export$a780418acd4762da; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $9bffde4ffa967ea0$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $9bffde4ffa967ea0$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $9bffde4ffa967ea0$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $9bffde4ffa967ea0$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $9bffde4ffa967ea0$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $9bffde4ffa967ea0$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isShallow", function () { return $9bffde4ffa967ea0$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "isReadonly", function () { return $9bffde4ffa967ea0$export$92d09b48637741e7; });
$parcel$export(module.exports, "toReactive", function () { return $9bffde4ffa967ea0$export$45c769cf449a508c; });
$parcel$export(module.exports, "isReactive", function () { return $9bffde4ffa967ea0$export$352205f445242f02; });
$parcel$export(module.exports, "toReadonly", function () { return $9bffde4ffa967ea0$export$4a78e7a2a4fb689f; });
$parcel$export(module.exports, "shallowReadArray", function () { return $9bffde4ffa967ea0$export$5eb48af14254449e; });
$parcel$export(module.exports, "isProxy", function () { return $9bffde4ffa967ea0$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "isRef", function () { return $9bffde4ffa967ea0$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $9bffde4ffa967ea0$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $9bffde4ffa967ea0$export$90a44edba14e47be; });
$parcel$export(module.exports, "shallowReactive", function () { return $9bffde4ffa967ea0$export$8d81cefd22d22260; });
$parcel$export(module.exports, "shallowReadonly", function () { return $9bffde4ffa967ea0$export$7c4b5f2b50f09f6b; });
$parcel$export(module.exports, "markRaw", function () { return $9bffde4ffa967ea0$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $9bffde4ffa967ea0$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $9bffde4ffa967ea0$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "unref", function () { return $9bffde4ffa967ea0$export$a239a76781616204; });
$parcel$export(module.exports, "toValue", function () { return $9bffde4ffa967ea0$export$30bdcc2218aa9458; });
$parcel$export(module.exports, "proxyRefs", function () { return $9bffde4ffa967ea0$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $9bffde4ffa967ea0$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $9bffde4ffa967ea0$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $9bffde4ffa967ea0$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "computed", function () { return $9bffde4ffa967ea0$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "watch", function () { return $9bffde4ffa967ea0$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "traverse", function () { return $9bffde4ffa967ea0$export$df3f009e3d155b20; });
/**
* @vue/reactivity v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $6XHer = parcelRequire("6XHer");
function $9bffde4ffa967ea0$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $9bffde4ffa967ea0$var$activeEffectScope;
class $9bffde4ffa967ea0$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $9bffde4ffa967ea0$var$activeEffectScope) {
            if ($9bffde4ffa967ea0$var$activeEffectScope.active) {
                this.parent = $9bffde4ffa967ea0$var$activeEffectScope;
                this.index = ($9bffde4ffa967ea0$var$activeEffectScope.scopes || ($9bffde4ffa967ea0$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $9bffde4ffa967ea0$var$activeEffectScope;
            try {
                $9bffde4ffa967ea0$var$activeEffectScope = this;
                return fn();
            } finally{
                $9bffde4ffa967ea0$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $9bffde4ffa967ea0$var$activeEffectScope;
            $9bffde4ffa967ea0$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($9bffde4ffa967ea0$var$activeEffectScope === this) $9bffde4ffa967ea0$var$activeEffectScope = this.prevScope;
            else {
                let current = $9bffde4ffa967ea0$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $9bffde4ffa967ea0$export$7056603ea81600be(detached) {
    return new $9bffde4ffa967ea0$export$1168ed9dbc71ddbd(detached);
}
function $9bffde4ffa967ea0$export$c7be4b0125a10cba() {
    return $9bffde4ffa967ea0$var$activeEffectScope;
}
function $9bffde4ffa967ea0$export$a780418acd4762da(fn, failSilently = false) {
    if ($9bffde4ffa967ea0$var$activeEffectScope) $9bffde4ffa967ea0$var$activeEffectScope.cleanups.push(fn);
}
let $9bffde4ffa967ea0$var$activeSub;
const $9bffde4ffa967ea0$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $9bffde4ffa967ea0$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $9bffde4ffa967ea0$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($9bffde4ffa967ea0$var$activeEffectScope) {
            if ($9bffde4ffa967ea0$var$activeEffectScope.active) $9bffde4ffa967ea0$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($9bffde4ffa967ea0$var$pausedQueueEffects.has(this)) {
                $9bffde4ffa967ea0$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $9bffde4ffa967ea0$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $9bffde4ffa967ea0$var$cleanupEffect(this);
        $9bffde4ffa967ea0$var$prepareDeps(this);
        const prevEffect = $9bffde4ffa967ea0$var$activeSub;
        const prevShouldTrack = $9bffde4ffa967ea0$var$shouldTrack;
        $9bffde4ffa967ea0$var$activeSub = this;
        $9bffde4ffa967ea0$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $9bffde4ffa967ea0$var$cleanupDeps(this);
            $9bffde4ffa967ea0$var$activeSub = prevEffect;
            $9bffde4ffa967ea0$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$9bffde4ffa967ea0$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $9bffde4ffa967ea0$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $9bffde4ffa967ea0$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($9bffde4ffa967ea0$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $9bffde4ffa967ea0$var$isDirty(this);
    }
}
let $9bffde4ffa967ea0$var$batchDepth = 0;
let $9bffde4ffa967ea0$var$batchedSub;
let $9bffde4ffa967ea0$var$batchedComputed;
function $9bffde4ffa967ea0$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $9bffde4ffa967ea0$var$batchedComputed;
        $9bffde4ffa967ea0$var$batchedComputed = sub;
        return;
    }
    sub.next = $9bffde4ffa967ea0$var$batchedSub;
    $9bffde4ffa967ea0$var$batchedSub = sub;
}
function $9bffde4ffa967ea0$var$startBatch() {
    $9bffde4ffa967ea0$var$batchDepth++;
}
function $9bffde4ffa967ea0$var$endBatch() {
    if (--$9bffde4ffa967ea0$var$batchDepth > 0) return;
    if ($9bffde4ffa967ea0$var$batchedComputed) {
        let e = $9bffde4ffa967ea0$var$batchedComputed;
        $9bffde4ffa967ea0$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($9bffde4ffa967ea0$var$batchedSub){
        let e = $9bffde4ffa967ea0$var$batchedSub;
        $9bffde4ffa967ea0$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $9bffde4ffa967ea0$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $9bffde4ffa967ea0$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $9bffde4ffa967ea0$var$removeSub(link);
            $9bffde4ffa967ea0$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $9bffde4ffa967ea0$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($9bffde4ffa967ea0$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $9bffde4ffa967ea0$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $9bffde4ffa967ea0$var$globalVersion) return;
    computed.globalVersion = $9bffde4ffa967ea0$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$9bffde4ffa967ea0$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $9bffde4ffa967ea0$var$activeSub;
    const prevShouldTrack = $9bffde4ffa967ea0$var$shouldTrack;
    $9bffde4ffa967ea0$var$activeSub = computed;
    $9bffde4ffa967ea0$var$shouldTrack = true;
    try {
        $9bffde4ffa967ea0$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $6XHer.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $9bffde4ffa967ea0$var$activeSub = prevSub;
        $9bffde4ffa967ea0$var$shouldTrack = prevShouldTrack;
        $9bffde4ffa967ea0$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $9bffde4ffa967ea0$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$9bffde4ffa967ea0$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $9bffde4ffa967ea0$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $9bffde4ffa967ea0$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $9bffde4ffa967ea0$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $9bffde4ffa967ea0$export$28352bb4dd362521(fn);
    if (options) (0, $6XHer.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $9bffde4ffa967ea0$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $9bffde4ffa967ea0$var$shouldTrack = true;
const $9bffde4ffa967ea0$var$trackStack = [];
function $9bffde4ffa967ea0$export$938a971395fef855() {
    $9bffde4ffa967ea0$var$trackStack.push($9bffde4ffa967ea0$var$shouldTrack);
    $9bffde4ffa967ea0$var$shouldTrack = false;
}
function $9bffde4ffa967ea0$export$1f8ffc6fd33b1d16() {
    $9bffde4ffa967ea0$var$trackStack.push($9bffde4ffa967ea0$var$shouldTrack);
    $9bffde4ffa967ea0$var$shouldTrack = true;
}
function $9bffde4ffa967ea0$export$c39176b1babaa8b8() {
    const last = $9bffde4ffa967ea0$var$trackStack.pop();
    $9bffde4ffa967ea0$var$shouldTrack = last === void 0 ? true : last;
}
function $9bffde4ffa967ea0$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($9bffde4ffa967ea0$var$activeSub instanceof $9bffde4ffa967ea0$export$28352bb4dd362521) $9bffde4ffa967ea0$var$activeSub.cleanup = fn;
}
function $9bffde4ffa967ea0$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $9bffde4ffa967ea0$var$activeSub;
        $9bffde4ffa967ea0$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $9bffde4ffa967ea0$var$activeSub = prevSub;
        }
    }
}
let $9bffde4ffa967ea0$var$globalVersion = 0;
class $9bffde4ffa967ea0$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $9bffde4ffa967ea0$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$9bffde4ffa967ea0$var$activeSub || !$9bffde4ffa967ea0$var$shouldTrack || $9bffde4ffa967ea0$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $9bffde4ffa967ea0$var$activeSub) {
            link = this.activeLink = new $9bffde4ffa967ea0$var$Link($9bffde4ffa967ea0$var$activeSub, this);
            if (!$9bffde4ffa967ea0$var$activeSub.deps) $9bffde4ffa967ea0$var$activeSub.deps = $9bffde4ffa967ea0$var$activeSub.depsTail = link;
            else {
                link.prevDep = $9bffde4ffa967ea0$var$activeSub.depsTail;
                $9bffde4ffa967ea0$var$activeSub.depsTail.nextDep = link;
                $9bffde4ffa967ea0$var$activeSub.depsTail = link;
            }
            $9bffde4ffa967ea0$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $9bffde4ffa967ea0$var$activeSub.depsTail;
                link.nextDep = void 0;
                $9bffde4ffa967ea0$var$activeSub.depsTail.nextDep = link;
                $9bffde4ffa967ea0$var$activeSub.depsTail = link;
                if ($9bffde4ffa967ea0$var$activeSub.deps === link) $9bffde4ffa967ea0$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $9bffde4ffa967ea0$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $9bffde4ffa967ea0$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $9bffde4ffa967ea0$var$endBatch();
        }
    }
}
function $9bffde4ffa967ea0$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$9bffde4ffa967ea0$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $9bffde4ffa967ea0$var$targetMap = /* @__PURE__ */ new WeakMap();
const $9bffde4ffa967ea0$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $9bffde4ffa967ea0$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $9bffde4ffa967ea0$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $9bffde4ffa967ea0$export$6b2a7d5132615086(target, type, key) {
    if ($9bffde4ffa967ea0$var$shouldTrack && $9bffde4ffa967ea0$var$activeSub) {
        let depsMap = $9bffde4ffa967ea0$var$targetMap.get(target);
        if (!depsMap) $9bffde4ffa967ea0$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $9bffde4ffa967ea0$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $9bffde4ffa967ea0$var$targetMap.get(target);
    if (!depsMap) {
        $9bffde4ffa967ea0$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $9bffde4ffa967ea0$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $6XHer.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $6XHer.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $9bffde4ffa967ea0$export$4f926f0baab682cd || !(0, $6XHer.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($9bffde4ffa967ea0$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($9bffde4ffa967ea0$export$3c41b1a4e06acc14));
                        if ((0, $6XHer.isMap)(target)) run(depsMap.get($9bffde4ffa967ea0$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($9bffde4ffa967ea0$export$3c41b1a4e06acc14));
                        if ((0, $6XHer.isMap)(target)) run(depsMap.get($9bffde4ffa967ea0$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $6XHer.isMap)(target)) run(depsMap.get($9bffde4ffa967ea0$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $9bffde4ffa967ea0$var$endBatch();
}
function $9bffde4ffa967ea0$var$getDepFromReactive(object, key) {
    const depMap = $9bffde4ffa967ea0$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $9bffde4ffa967ea0$export$1544eab4943788e4(array) {
    const raw = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $9bffde4ffa967ea0$export$6b2a7d5132615086(raw, "iterate", $9bffde4ffa967ea0$export$4f926f0baab682cd);
    if ($9bffde4ffa967ea0$export$7f3fe6025abfa26e(array)) return raw;
    if (!$9bffde4ffa967ea0$export$92d09b48637741e7(array)) return raw.map($9bffde4ffa967ea0$export$45c769cf449a508c);
    return $9bffde4ffa967ea0$export$352205f445242f02(array) ? raw.map((item)=>$9bffde4ffa967ea0$export$4a78e7a2a4fb689f($9bffde4ffa967ea0$export$45c769cf449a508c(item))) : raw.map($9bffde4ffa967ea0$export$4a78e7a2a4fb689f);
}
function $9bffde4ffa967ea0$export$5eb48af14254449e(arr) {
    $9bffde4ffa967ea0$export$6b2a7d5132615086(arr = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(arr), "iterate", $9bffde4ffa967ea0$export$4f926f0baab682cd);
    return arr;
}
function $9bffde4ffa967ea0$var$toWrapped(target, item) {
    if ($9bffde4ffa967ea0$export$92d09b48637741e7(target)) return $9bffde4ffa967ea0$export$352205f445242f02(target) ? $9bffde4ffa967ea0$export$4a78e7a2a4fb689f($9bffde4ffa967ea0$export$45c769cf449a508c(item)) : $9bffde4ffa967ea0$export$4a78e7a2a4fb689f(item);
    return $9bffde4ffa967ea0$export$45c769cf449a508c(item);
}
const $9bffde4ffa967ea0$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $9bffde4ffa967ea0$var$iterator(this, Symbol.iterator, (item)=>$9bffde4ffa967ea0$var$toWrapped(this, item));
    },
    concat (...args) {
        return $9bffde4ffa967ea0$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $6XHer.isArray)(x) ? $9bffde4ffa967ea0$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $9bffde4ffa967ea0$var$iterator(this, "entries", (value)=>{
            value[1] = $9bffde4ffa967ea0$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$9bffde4ffa967ea0$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "find", fn, thisArg, (item)=>$9bffde4ffa967ea0$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "findLast", fn, thisArg, (item)=>$9bffde4ffa967ea0$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $9bffde4ffa967ea0$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $9bffde4ffa967ea0$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $9bffde4ffa967ea0$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $9bffde4ffa967ea0$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $9bffde4ffa967ea0$var$noTracking(this, "pop");
    },
    push (...args) {
        return $9bffde4ffa967ea0$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $9bffde4ffa967ea0$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $9bffde4ffa967ea0$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $9bffde4ffa967ea0$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $9bffde4ffa967ea0$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $9bffde4ffa967ea0$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $9bffde4ffa967ea0$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $9bffde4ffa967ea0$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $9bffde4ffa967ea0$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $9bffde4ffa967ea0$var$noTracking(this, "unshift", args);
    },
    values () {
        return $9bffde4ffa967ea0$var$iterator(this, "values", (item)=>$9bffde4ffa967ea0$var$toWrapped(this, item));
    }
};
function $9bffde4ffa967ea0$var$iterator(self, method, wrapValue) {
    const arr = $9bffde4ffa967ea0$export$5eb48af14254449e(self);
    const methodFn = arr[method];
    const iter = methodFn.call(arr);
    if (arr !== self && !$9bffde4ffa967ea0$export$7f3fe6025abfa26e(self)) {
        if (iter[Symbol.toStringTag] === "Array Iterator") {
            const wrapped = Object.create(Object.getPrototypeOf(iter));
            wrapped.next = ()=>$9bffde4ffa967ea0$var$wrapResult(iter.next(), wrapValue);
            if (methodFn !== $9bffde4ffa967ea0$var$arrayProto[method]) Object.defineProperties(wrapped, {
                return: {
                    get () {
                        const fn = iter.return;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                },
                throw: {
                    get () {
                        const fn = iter.throw;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                }
            });
            return wrapped;
        }
        iter._next = iter.next;
        iter.next = ()=>$9bffde4ffa967ea0$var$wrapResult(iter._next(), wrapValue);
    }
    return iter;
}
function $9bffde4ffa967ea0$var$wrapResult(result, wrapValue) {
    if (!result.done) result.value = wrapValue(result.value);
    return result;
}
const $9bffde4ffa967ea0$var$arrayProto = Array.prototype;
function $9bffde4ffa967ea0$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $9bffde4ffa967ea0$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$9bffde4ffa967ea0$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $9bffde4ffa967ea0$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $9bffde4ffa967ea0$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $9bffde4ffa967ea0$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $9bffde4ffa967ea0$var$reduce(self, method, fn, args) {
    const arr = $9bffde4ffa967ea0$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$9bffde4ffa967ea0$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $9bffde4ffa967ea0$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $9bffde4ffa967ea0$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $9bffde4ffa967ea0$var$toWrapped(self, result) : result;
}
function $9bffde4ffa967ea0$var$searchProxy(self, method, args) {
    const arr = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(self);
    $9bffde4ffa967ea0$export$6b2a7d5132615086(arr, "iterate", $9bffde4ffa967ea0$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $9bffde4ffa967ea0$export$5f3ca29d057519b3(args[0])) {
        args[0] = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $9bffde4ffa967ea0$var$noTracking(self, method, args = []) {
    $9bffde4ffa967ea0$export$938a971395fef855();
    $9bffde4ffa967ea0$var$startBatch();
    const res = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $9bffde4ffa967ea0$var$endBatch();
    $9bffde4ffa967ea0$export$c39176b1babaa8b8();
    return res;
}
const $9bffde4ffa967ea0$var$isNonTrackableKeys = /* @__PURE__ */ (0, $6XHer.makeMap)(`__proto__,__v_isRef,__isVue`);
const $9bffde4ffa967ea0$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $6XHer.isSymbol)));
function $9bffde4ffa967ea0$var$hasOwnProperty(key) {
    if (!(0, $6XHer.isSymbol)(key)) key = String(key);
    const obj = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(this);
    $9bffde4ffa967ea0$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $9bffde4ffa967ea0$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $9bffde4ffa967ea0$var$shallowReadonlyMap : $9bffde4ffa967ea0$var$readonlyMap : isShallow2 ? $9bffde4ffa967ea0$var$shallowReactiveMap : $9bffde4ffa967ea0$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $6XHer.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $9bffde4ffa967ea0$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $9bffde4ffa967ea0$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $9bffde4ffa967ea0$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $6XHer.isSymbol)(key) ? $9bffde4ffa967ea0$var$builtInSymbols.has(key) : $9bffde4ffa967ea0$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $9bffde4ffa967ea0$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($9bffde4ffa967ea0$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $6XHer.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $6XHer.isObject)(value) ? $9bffde4ffa967ea0$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $6XHer.isObject)(res)) return isReadonly2 ? $9bffde4ffa967ea0$export$6ec456bd5b7b3c51(res) : $9bffde4ffa967ea0$export$90a44edba14e47be(res);
        return res;
    }
}
class $9bffde4ffa967ea0$var$MutableReactiveHandler extends $9bffde4ffa967ea0$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $6XHer.isArray)(target) && (0, $6XHer.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $9bffde4ffa967ea0$export$92d09b48637741e7(oldValue);
            if (!$9bffde4ffa967ea0$export$7f3fe6025abfa26e(value) && !$9bffde4ffa967ea0$export$92d09b48637741e7(value)) {
                oldValue = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(oldValue);
                value = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $9bffde4ffa967ea0$export$4f9f5282de18fc69(oldValue) && !$9bffde4ffa967ea0$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $6XHer.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $9bffde4ffa967ea0$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $9bffde4ffa967ea0$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6XHer.hasChanged)(value, oldValue)) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $6XHer.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $6XHer.isSymbol)(key) || !$9bffde4ffa967ea0$var$builtInSymbols.has(key)) $9bffde4ffa967ea0$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $9bffde4ffa967ea0$export$6b2a7d5132615086(target, "iterate", (0, $6XHer.isArray)(target) ? "length" : $9bffde4ffa967ea0$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $9bffde4ffa967ea0$var$ReadonlyReactiveHandler extends $9bffde4ffa967ea0$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $9bffde4ffa967ea0$var$mutableHandlers = /* @__PURE__ */ new $9bffde4ffa967ea0$var$MutableReactiveHandler();
const $9bffde4ffa967ea0$var$readonlyHandlers = /* @__PURE__ */ new $9bffde4ffa967ea0$var$ReadonlyReactiveHandler();
const $9bffde4ffa967ea0$var$shallowReactiveHandlers = /* @__PURE__ */ new $9bffde4ffa967ea0$var$MutableReactiveHandler(true);
const $9bffde4ffa967ea0$var$shallowReadonlyHandlers = /* @__PURE__ */ new $9bffde4ffa967ea0$var$ReadonlyReactiveHandler(true);
const $9bffde4ffa967ea0$var$toShallow = (value)=>value;
const $9bffde4ffa967ea0$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $9bffde4ffa967ea0$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $6XHer.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $9bffde4ffa967ea0$var$toShallow : isReadonly2 ? $9bffde4ffa967ea0$export$4a78e7a2a4fb689f : $9bffde4ffa967ea0$export$45c769cf449a508c;
        !isReadonly2 && $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $9bffde4ffa967ea0$export$49093fa1cddcb78d : $9bffde4ffa967ea0$export$3c41b1a4e06acc14);
        return (0, $6XHer.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $9bffde4ffa967ea0$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $9bffde4ffa967ea0$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(target);
            const rawKey = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6XHer.hasChanged)(key, rawKey)) $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "get", key);
                $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $9bffde4ffa967ea0$var$getProto(rawTarget);
            const wrap = shallow ? $9bffde4ffa967ea0$var$toShallow : readonly ? $9bffde4ffa967ea0$export$4a78e7a2a4fb689f : $9bffde4ffa967ea0$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $9bffde4ffa967ea0$export$6b2a7d5132615086($9bffde4ffa967ea0$export$ab18938b9fc5f28e(target), "iterate", $9bffde4ffa967ea0$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(target);
            const rawKey = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6XHer.hasChanged)(key, rawKey)) $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "has", key);
                $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $9bffde4ffa967ea0$var$toShallow : readonly ? $9bffde4ffa967ea0$export$4a78e7a2a4fb689f : $9bffde4ffa967ea0$export$45c769cf449a508c;
            !readonly && $9bffde4ffa967ea0$export$6b2a7d5132615086(rawTarget, "iterate", $9bffde4ffa967ea0$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $6XHer.extend)(instrumentations, readonly ? {
        add: $9bffde4ffa967ea0$var$createReadonlyMethod("add"),
        set: $9bffde4ffa967ea0$var$createReadonlyMethod("set"),
        delete: $9bffde4ffa967ea0$var$createReadonlyMethod("delete"),
        clear: $9bffde4ffa967ea0$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(this);
            const proto = $9bffde4ffa967ea0$var$getProto(target);
            const rawValue = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$9bffde4ffa967ea0$export$7f3fe6025abfa26e(value) && !$9bffde4ffa967ea0$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $6XHer.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $6XHer.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$9bffde4ffa967ea0$export$7f3fe6025abfa26e(value) && !$9bffde4ffa967ea0$export$92d09b48637741e7(value)) value = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(value);
            const target = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $9bffde4ffa967ea0$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6XHer.hasChanged)(value, oldValue)) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $9bffde4ffa967ea0$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $9bffde4ffa967ea0$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $9bffde4ffa967ea0$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $9bffde4ffa967ea0$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $9bffde4ffa967ea0$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $6XHer.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $9bffde4ffa967ea0$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $9bffde4ffa967ea0$var$createInstrumentationGetter(false, false)
};
const $9bffde4ffa967ea0$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $9bffde4ffa967ea0$var$createInstrumentationGetter(false, true)
};
const $9bffde4ffa967ea0$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $9bffde4ffa967ea0$var$createInstrumentationGetter(true, false)
};
const $9bffde4ffa967ea0$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $9bffde4ffa967ea0$var$createInstrumentationGetter(true, true)
};
function $9bffde4ffa967ea0$var$checkIdentityKeys(target, has, key) {
    const rawKey = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $6XHer.toRawType)(target);
        $9bffde4ffa967ea0$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $9bffde4ffa967ea0$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $9bffde4ffa967ea0$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $9bffde4ffa967ea0$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $9bffde4ffa967ea0$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $9bffde4ffa967ea0$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $9bffde4ffa967ea0$export$92d09b48637741e7(target)) return target;
    return $9bffde4ffa967ea0$var$createReactiveObject(target, false, $9bffde4ffa967ea0$var$mutableHandlers, $9bffde4ffa967ea0$var$mutableCollectionHandlers, $9bffde4ffa967ea0$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$8d81cefd22d22260(target) {
    return $9bffde4ffa967ea0$var$createReactiveObject(target, false, $9bffde4ffa967ea0$var$shallowReactiveHandlers, $9bffde4ffa967ea0$var$shallowCollectionHandlers, $9bffde4ffa967ea0$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$6ec456bd5b7b3c51(target) {
    return $9bffde4ffa967ea0$var$createReactiveObject(target, true, $9bffde4ffa967ea0$var$readonlyHandlers, $9bffde4ffa967ea0$var$readonlyCollectionHandlers, $9bffde4ffa967ea0$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$7c4b5f2b50f09f6b(target) {
    return $9bffde4ffa967ea0$var$createReactiveObject(target, true, $9bffde4ffa967ea0$var$shallowReadonlyHandlers, $9bffde4ffa967ea0$var$shallowReadonlyCollectionHandlers, $9bffde4ffa967ea0$var$shallowReadonlyMap);
}
function $9bffde4ffa967ea0$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $6XHer.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $9bffde4ffa967ea0$var$targetTypeMap((0, $6XHer.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $9bffde4ffa967ea0$export$92d09b48637741e7(value)) return /* @__PURE__ */ $9bffde4ffa967ea0$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $9bffde4ffa967ea0$export$ab18938b9fc5f28e(raw) : observed;
}
function $9bffde4ffa967ea0$export$995ab8b13ad7a9d0(value) {
    if (!(0, $6XHer.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $6XHer.def)(value, "__v_skip", true);
    return value;
}
const $9bffde4ffa967ea0$export$45c769cf449a508c = (value)=>(0, $6XHer.isObject)(value) ? /* @__PURE__ */ $9bffde4ffa967ea0$export$90a44edba14e47be(value) : value;
const $9bffde4ffa967ea0$export$4a78e7a2a4fb689f = (value)=>(0, $6XHer.isObject)(value) ? /* @__PURE__ */ $9bffde4ffa967ea0$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$eff4d24c3ff7876e(value) {
    return $9bffde4ffa967ea0$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$9b7bc5fe3b17c8b3(value) {
    return $9bffde4ffa967ea0$var$createRef(value, true);
}
function $9bffde4ffa967ea0$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $9bffde4ffa967ea0$var$RefImpl(rawValue, shallow);
}
class $9bffde4ffa967ea0$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $9bffde4ffa967ea0$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $9bffde4ffa967ea0$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $9bffde4ffa967ea0$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $9bffde4ffa967ea0$export$7f3fe6025abfa26e(newValue) || $9bffde4ffa967ea0$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $9bffde4ffa967ea0$export$ab18938b9fc5f28e(newValue);
        if ((0, $6XHer.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $9bffde4ffa967ea0$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $9bffde4ffa967ea0$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $9bffde4ffa967ea0$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $9bffde4ffa967ea0$export$30bdcc2218aa9458(source) {
    return (0, $6XHer.isFunction)(source) ? source() : $9bffde4ffa967ea0$export$a239a76781616204(source);
}
const $9bffde4ffa967ea0$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $9bffde4ffa967ea0$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $9bffde4ffa967ea0$export$f353fd1b97db3fa0(objectWithRefs) {
    return $9bffde4ffa967ea0$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $9bffde4ffa967ea0$var$shallowUnwrapHandlers);
}
class $9bffde4ffa967ea0$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $9bffde4ffa967ea0$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $9bffde4ffa967ea0$export$a20c2dd6199824cb(factory) {
    return new $9bffde4ffa967ea0$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$2e9533675e5e70e0(object) {
    const ret = (0, $6XHer.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $9bffde4ffa967ea0$var$propertyToRef(object, key);
    return ret;
}
class $9bffde4ffa967ea0$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $6XHer.isSymbol)(key) ? key : String(key);
        this._raw = $9bffde4ffa967ea0$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $6XHer.isArray)(_object) || (0, $6XHer.isSymbol)(this._key) || !(0, $6XHer.isIntegerKey)(this._key)) do shallow = !$9bffde4ffa967ea0$export$5f3ca29d057519b3(obj) || $9bffde4ffa967ea0$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $9bffde4ffa967ea0$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $9bffde4ffa967ea0$var$getDepFromReactive(this._raw, this._key);
    }
}
class $9bffde4ffa967ea0$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $9bffde4ffa967ea0$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $6XHer.isFunction)(source)) return new $9bffde4ffa967ea0$var$GetterRefImpl(source);
    else if ((0, $6XHer.isObject)(source) && arguments.length > 1) return $9bffde4ffa967ea0$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $9bffde4ffa967ea0$export$eff4d24c3ff7876e(source);
}
function $9bffde4ffa967ea0$var$propertyToRef(source, key, defaultValue) {
    return new $9bffde4ffa967ea0$var$ObjectRefImpl(source, key, defaultValue);
}
class $9bffde4ffa967ea0$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $9bffde4ffa967ea0$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $9bffde4ffa967ea0$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $9bffde4ffa967ea0$var$activeSub !== this) {
            $9bffde4ffa967ea0$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $9bffde4ffa967ea0$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $9bffde4ffa967ea0$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $6XHer.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $9bffde4ffa967ea0$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $9bffde4ffa967ea0$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $9bffde4ffa967ea0$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $9bffde4ffa967ea0$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $9bffde4ffa967ea0$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $9bffde4ffa967ea0$var$INITIAL_WATCHER_VALUE = {};
const $9bffde4ffa967ea0$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $9bffde4ffa967ea0$var$activeWatcher = void 0;
function $9bffde4ffa967ea0$export$2532f7acfca7c82d() {
    return $9bffde4ffa967ea0$var$activeWatcher;
}
function $9bffde4ffa967ea0$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $9bffde4ffa967ea0$var$activeWatcher) {
    if (owner) {
        let cleanups = $9bffde4ffa967ea0$var$cleanupMap.get(owner);
        if (!cleanups) $9bffde4ffa967ea0$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $9bffde4ffa967ea0$export$3db5d71bdb2d5499(source, cb, options = (0, $6XHer.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $9bffde4ffa967ea0$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($9bffde4ffa967ea0$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $9bffde4ffa967ea0$export$df3f009e3d155b20(source2, 1);
        return $9bffde4ffa967ea0$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($9bffde4ffa967ea0$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $9bffde4ffa967ea0$export$7f3fe6025abfa26e(source);
    } else if ($9bffde4ffa967ea0$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $6XHer.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$9bffde4ffa967ea0$export$352205f445242f02(s) || $9bffde4ffa967ea0$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($9bffde4ffa967ea0$export$4f9f5282de18fc69(s)) return s.value;
                else if ($9bffde4ffa967ea0$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $6XHer.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $6XHer.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $9bffde4ffa967ea0$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $9bffde4ffa967ea0$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $9bffde4ffa967ea0$var$activeWatcher;
            $9bffde4ffa967ea0$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $9bffde4ffa967ea0$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $6XHer.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$9bffde4ffa967ea0$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $9bffde4ffa967ea0$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $6XHer.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            try {
                return _cb(...args);
            } finally{
                watchHandle();
            }
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($9bffde4ffa967ea0$var$INITIAL_WATCHER_VALUE) : $9bffde4ffa967ea0$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $6XHer.hasChanged)(v, oldValue[i])) : (0, $6XHer.hasChanged)(newValue, oldValue))) {
                const currentWatcher = $9bffde4ffa967ea0$var$activeWatcher;
                $9bffde4ffa967ea0$export$938a971395fef855();
                try {
                    if (cleanup) cleanup();
                    $9bffde4ffa967ea0$var$activeWatcher = effect;
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $9bffde4ffa967ea0$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $9bffde4ffa967ea0$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $9bffde4ffa967ea0$var$activeWatcher = currentWatcher;
                    $9bffde4ffa967ea0$export$c39176b1babaa8b8();
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $9bffde4ffa967ea0$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$9bffde4ffa967ea0$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $9bffde4ffa967ea0$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $9bffde4ffa967ea0$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $9bffde4ffa967ea0$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $6XHer.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($9bffde4ffa967ea0$export$4f9f5282de18fc69(value)) $9bffde4ffa967ea0$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $6XHer.isArray)(value)) for(let i = 0; i < value.length; i++)$9bffde4ffa967ea0$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $6XHer.isSet)(value) || (0, $6XHer.isMap)(value)) value.forEach((v)=>{
        $9bffde4ffa967ea0$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $6XHer.isPlainObject)(value)) {
        for(const key in value)$9bffde4ffa967ea0$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $9bffde4ffa967ea0$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("6XHer", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $5119c9b9c9f9bc3d$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $5119c9b9c9f9bc3d$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $5119c9b9c9f9bc3d$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $5119c9b9c9f9bc3d$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $5119c9b9c9f9bc3d$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $5119c9b9c9f9bc3d$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $5119c9b9c9f9bc3d$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $5119c9b9c9f9bc3d$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $5119c9b9c9f9bc3d$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $5119c9b9c9f9bc3d$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $5119c9b9c9f9bc3d$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $5119c9b9c9f9bc3d$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $5119c9b9c9f9bc3d$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $5119c9b9c9f9bc3d$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $5119c9b9c9f9bc3d$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $5119c9b9c9f9bc3d$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $5119c9b9c9f9bc3d$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $5119c9b9c9f9bc3d$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $5119c9b9c9f9bc3d$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $5119c9b9c9f9bc3d$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $5119c9b9c9f9bc3d$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $5119c9b9c9f9bc3d$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $5119c9b9c9f9bc3d$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $5119c9b9c9f9bc3d$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $5119c9b9c9f9bc3d$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $5119c9b9c9f9bc3d$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $5119c9b9c9f9bc3d$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $5119c9b9c9f9bc3d$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $5119c9b9c9f9bc3d$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $5119c9b9c9f9bc3d$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $5119c9b9c9f9bc3d$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $5119c9b9c9f9bc3d$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $5119c9b9c9f9bc3d$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $5119c9b9c9f9bc3d$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $5119c9b9c9f9bc3d$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $5119c9b9c9f9bc3d$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $5119c9b9c9f9bc3d$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $5119c9b9c9f9bc3d$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $5119c9b9c9f9bc3d$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $5119c9b9c9f9bc3d$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $5119c9b9c9f9bc3d$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $5119c9b9c9f9bc3d$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $5119c9b9c9f9bc3d$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $5119c9b9c9f9bc3d$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $5119c9b9c9f9bc3d$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $5119c9b9c9f9bc3d$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $5119c9b9c9f9bc3d$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $5119c9b9c9f9bc3d$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $5119c9b9c9f9bc3d$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $5119c9b9c9f9bc3d$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $5119c9b9c9f9bc3d$export$b5b1545233b45293; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $5119c9b9c9f9bc3d$export$97fe3d6453ee2f5e; });
/**
* @vue/shared v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $5119c9b9c9f9bc3d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $5119c9b9c9f9bc3d$export$cf583d23ab39677c = {};
const $5119c9b9c9f9bc3d$export$6bd8558f433f1cc1 = [];
const $5119c9b9c9f9bc3d$export$5702a91a6f42969f = ()=>{};
const $5119c9b9c9f9bc3d$export$c01351c0af048e39 = ()=>false;
const $5119c9b9c9f9bc3d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $5119c9b9c9f9bc3d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $5119c9b9c9f9bc3d$export$8b58be045bf06082 = Object.assign;
const $5119c9b9c9f9bc3d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $5119c9b9c9f9bc3d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5119c9b9c9f9bc3d$export$b5a638e9b3fff9f3 = (val, key)=>$5119c9b9c9f9bc3d$var$hasOwnProperty.call(val, key);
const $5119c9b9c9f9bc3d$export$43bee75e5e14138e = Array.isArray;
const $5119c9b9c9f9bc3d$export$5c90113a285f2241 = (val)=>$5119c9b9c9f9bc3d$export$1dccc787cc36538b(val) === "[object Map]";
const $5119c9b9c9f9bc3d$export$6750766a7c7ec627 = (val)=>$5119c9b9c9f9bc3d$export$1dccc787cc36538b(val) === "[object Set]";
const $5119c9b9c9f9bc3d$export$871608497c498473 = (val)=>$5119c9b9c9f9bc3d$export$1dccc787cc36538b(val) === "[object Date]";
const $5119c9b9c9f9bc3d$export$49841c62b9eff15 = (val)=>$5119c9b9c9f9bc3d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $5119c9b9c9f9bc3d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $5119c9b9c9f9bc3d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $5119c9b9c9f9bc3d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $5119c9b9c9f9bc3d$export$4369c812aac99591 = (val)=>{
    return ($5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(val) || $5119c9b9c9f9bc3d$export$f6e2535fb5126e54(val)) && $5119c9b9c9f9bc3d$export$f6e2535fb5126e54(val.then) && $5119c9b9c9f9bc3d$export$f6e2535fb5126e54(val.catch);
};
const $5119c9b9c9f9bc3d$export$830c053460e5ddf6 = Object.prototype.toString;
const $5119c9b9c9f9bc3d$export$1dccc787cc36538b = (value)=>$5119c9b9c9f9bc3d$export$830c053460e5ddf6.call(value);
const $5119c9b9c9f9bc3d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $5119c9b9c9f9bc3d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $5119c9b9c9f9bc3d$export$53b83ca8eaab0383 = (val)=>$5119c9b9c9f9bc3d$export$1dccc787cc36538b(val) === "[object Object]";
const $5119c9b9c9f9bc3d$export$e2a2b93446ec9fe = (key)=>$5119c9b9c9f9bc3d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $5119c9b9c9f9bc3d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $5119c9b9c9f9bc3d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $5119c9b9c9f9bc3d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $5119c9b9c9f9bc3d$var$camelizeRE = /-\w/g;
const $5119c9b9c9f9bc3d$export$161d051f5dd25de7 = $5119c9b9c9f9bc3d$var$cacheStringFunction((str)=>{
    return str.replace($5119c9b9c9f9bc3d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $5119c9b9c9f9bc3d$var$hyphenateRE = /\B([A-Z])/g;
const $5119c9b9c9f9bc3d$export$6e6a0a3676c4b8bb = $5119c9b9c9f9bc3d$var$cacheStringFunction((str)=>str.replace($5119c9b9c9f9bc3d$var$hyphenateRE, "-$1").toLowerCase());
const $5119c9b9c9f9bc3d$export$9a00dee1beb8f576 = $5119c9b9c9f9bc3d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $5119c9b9c9f9bc3d$export$8c022799eeaaefcd = $5119c9b9c9f9bc3d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$5119c9b9c9f9bc3d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $5119c9b9c9f9bc3d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $5119c9b9c9f9bc3d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $5119c9b9c9f9bc3d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $5119c9b9c9f9bc3d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $5119c9b9c9f9bc3d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $5119c9b9c9f9bc3d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $5119c9b9c9f9bc3d$var$_globalThis;
const $5119c9b9c9f9bc3d$export$ff5f2eeb11fc7e14 = ()=>{
    return $5119c9b9c9f9bc3d$var$_globalThis || ($5119c9b9c9f9bc3d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $5119c9b9c9f9bc3d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $5119c9b9c9f9bc3d$export$53d5e12f9a1d3cde(name) {
    return $5119c9b9c9f9bc3d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $5119c9b9c9f9bc3d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $5119c9b9c9f9bc3d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $5119c9b9c9f9bc3d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $5119c9b9c9f9bc3d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $5119c9b9c9f9bc3d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $5119c9b9c9f9bc3d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $5119c9b9c9f9bc3d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $5119c9b9c9f9bc3d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$GLOBALS_ALLOWED);
const $5119c9b9c9f9bc3d$export$d6571a1911e4f27e = $5119c9b9c9f9bc3d$export$f73b8c13b7f97ebf;
const $5119c9b9c9f9bc3d$var$range = 2;
function $5119c9b9c9f9bc3d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $5119c9b9c9f9bc3d$var$range; j <= i + $5119c9b9c9f9bc3d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $5119c9b9c9f9bc3d$export$8756898546458274(value) {
    if ($5119c9b9c9f9bc3d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $5119c9b9c9f9bc3d$export$844ec244b1367d54(item) ? $5119c9b9c9f9bc3d$export$76a205ce979d066a(item) : $5119c9b9c9f9bc3d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($5119c9b9c9f9bc3d$export$844ec244b1367d54(value) || $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(value)) return value;
}
const $5119c9b9c9f9bc3d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $5119c9b9c9f9bc3d$var$propertyDelimiterRE = /:([^]+)/;
const $5119c9b9c9f9bc3d$var$styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $5119c9b9c9f9bc3d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($5119c9b9c9f9bc3d$var$styleCommentRE, (match)=>match.startsWith("/*") ? "" : match).split($5119c9b9c9f9bc3d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($5119c9b9c9f9bc3d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $5119c9b9c9f9bc3d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($5119c9b9c9f9bc3d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($5119c9b9c9f9bc3d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $5119c9b9c9f9bc3d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $5119c9b9c9f9bc3d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($5119c9b9c9f9bc3d$export$844ec244b1367d54(value)) res = value;
    else if ($5119c9b9c9f9bc3d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $5119c9b9c9f9bc3d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $5119c9b9c9f9bc3d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$5119c9b9c9f9bc3d$export$844ec244b1367d54(klass)) props.class = $5119c9b9c9f9bc3d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $5119c9b9c9f9bc3d$export$8756898546458274(style);
    return props;
}
const $5119c9b9c9f9bc3d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $5119c9b9c9f9bc3d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $5119c9b9c9f9bc3d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $5119c9b9c9f9bc3d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $5119c9b9c9f9bc3d$export$1ccf854a0984f890 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$HTML_TAGS);
const $5119c9b9c9f9bc3d$export$6328ce7565ea1049 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$SVG_TAGS);
const $5119c9b9c9f9bc3d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$MATH_TAGS);
const $5119c9b9c9f9bc3d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$VOID_TAGS);
const $5119c9b9c9f9bc3d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,playsinline,readonly`;
const $5119c9b9c9f9bc3d$export$d186f5eb2e810715 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$specialBooleanAttrs);
const $5119c9b9c9f9bc3d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8($5119c9b9c9f9bc3d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $5119c9b9c9f9bc3d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $5119c9b9c9f9bc3d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $5119c9b9c9f9bc3d$var$attrValidationCache = {};
function $5119c9b9c9f9bc3d$export$d55ef77660f30d12(name) {
    if ($5119c9b9c9f9bc3d$var$attrValidationCache.hasOwnProperty(name)) return $5119c9b9c9f9bc3d$var$attrValidationCache[name];
    const isUnsafe = $5119c9b9c9f9bc3d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $5119c9b9c9f9bc3d$var$attrValidationCache[name] = !isUnsafe;
}
const $5119c9b9c9f9bc3d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $5119c9b9c9f9bc3d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $5119c9b9c9f9bc3d$export$80da416f43933831 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $5119c9b9c9f9bc3d$export$fc0748a8e0014066 = /* @__PURE__ */ $5119c9b9c9f9bc3d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $5119c9b9c9f9bc3d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $5119c9b9c9f9bc3d$var$escapeRE = /["'&<>]/;
function $5119c9b9c9f9bc3d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $5119c9b9c9f9bc3d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $5119c9b9c9f9bc3d$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $5119c9b9c9f9bc3d$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($5119c9b9c9f9bc3d$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $5119c9b9c9f9bc3d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $5119c9b9c9f9bc3d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($5119c9b9c9f9bc3d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $5119c9b9c9f9bc3d$var$looseCompareArrays(a, b, seen) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $5119c9b9c9f9bc3d$export$ae8015769846262c(a[i], b[i], seen);
    return equal;
}
function $5119c9b9c9f9bc3d$var$looseCompareCollections(a, b, seen) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $5119c9b9c9f9bc3d$export$ae8015769846262c(item, candidates[i], seen)) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $5119c9b9c9f9bc3d$var$looseCompareObjects(a, b, seen) {
    let aValidType = $5119c9b9c9f9bc3d$export$5c90113a285f2241(a);
    let bValidType = $5119c9b9c9f9bc3d$export$5c90113a285f2241(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $5119c9b9c9f9bc3d$var$looseCompareCollections(a, b, seen) : false;
    aValidType = $5119c9b9c9f9bc3d$export$6750766a7c7ec627(a);
    bValidType = $5119c9b9c9f9bc3d$export$6750766a7c7ec627(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $5119c9b9c9f9bc3d$var$looseCompareCollections(a, b, seen) : false;
    const aKeysCount = Object.keys(a).length;
    const bKeysCount = Object.keys(b).length;
    if (aKeysCount !== bKeysCount) return false;
    for(const key in a){
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$5119c9b9c9f9bc3d$export$ae8015769846262c(a[key], b[key], seen)) return false;
    }
    return String(a) === String(b);
}
function $5119c9b9c9f9bc3d$var$looseCompareNested(a, b, seen, compare) {
    if (!seen) seen = [
        /* @__PURE__ */ new Map(),
        /* @__PURE__ */ new Map()
    ];
    const [seenA, seenB] = seen;
    if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
    seenA.set(a, b);
    seenB.set(b, a);
    const equal = compare(a, b, seen);
    seenA.delete(a);
    seenB.delete(b);
    return equal;
}
function $5119c9b9c9f9bc3d$export$ae8015769846262c(a, b, seen) {
    if (a === b) return true;
    let aValidType = $5119c9b9c9f9bc3d$export$871608497c498473(a);
    let bValidType = $5119c9b9c9f9bc3d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $5119c9b9c9f9bc3d$export$a244864fd9645c7f(a);
    bValidType = $5119c9b9c9f9bc3d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $5119c9b9c9f9bc3d$export$43bee75e5e14138e(a);
    bValidType = $5119c9b9c9f9bc3d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $5119c9b9c9f9bc3d$var$looseCompareNested(a, b, seen, $5119c9b9c9f9bc3d$var$looseCompareArrays) : false;
    aValidType = $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(a);
    bValidType = $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        return $5119c9b9c9f9bc3d$var$looseCompareNested(a, b, seen, $5119c9b9c9f9bc3d$var$looseCompareObjects);
    }
    return String(a) === String(b);
}
function $5119c9b9c9f9bc3d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$5119c9b9c9f9bc3d$export$ae8015769846262c(item, val));
}
const $5119c9b9c9f9bc3d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $5119c9b9c9f9bc3d$export$b5b1545233b45293 = (val)=>{
    return $5119c9b9c9f9bc3d$export$844ec244b1367d54(val) ? val : val == null ? "" : $5119c9b9c9f9bc3d$export$43bee75e5e14138e(val) || $5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(val) && (val.toString === $5119c9b9c9f9bc3d$export$830c053460e5ddf6 || !$5119c9b9c9f9bc3d$export$f6e2535fb5126e54(val.toString)) ? $5119c9b9c9f9bc3d$var$isRef(val) ? $5119c9b9c9f9bc3d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $5119c9b9c9f9bc3d$var$replacer, 2) : String(val);
};
const $5119c9b9c9f9bc3d$var$replacer = (_key, val)=>{
    if ($5119c9b9c9f9bc3d$var$isRef(val)) return $5119c9b9c9f9bc3d$var$replacer(_key, val.value);
    else if ($5119c9b9c9f9bc3d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$5119c9b9c9f9bc3d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($5119c9b9c9f9bc3d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$5119c9b9c9f9bc3d$var$stringifySymbol(v))
    };
    else if ($5119c9b9c9f9bc3d$export$a244864fd9645c7f(val)) return $5119c9b9c9f9bc3d$var$stringifySymbol(val);
    else if ($5119c9b9c9f9bc3d$export$a6cdc56e425d0d0a(val) && !$5119c9b9c9f9bc3d$export$43bee75e5e14138e(val) && !$5119c9b9c9f9bc3d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $5119c9b9c9f9bc3d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $5119c9b9c9f9bc3d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $5119c9b9c9f9bc3d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("aRSfV", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("iZX2P")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("iZX2P")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("iZX2P")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6XHer")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("iZX2P")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("iZX2P")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("iZX2P")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("iZX2P")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("iZX2P")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("iZX2P")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("iZX2P")).createRenderer; });
$parcel$export(module.exports, "createSlots", function () { return (parcelRequire("iZX2P")).createSlots; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("iZX2P")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("iZX2P")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("iZX2P")).createVNode; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("donES")).customRef; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("iZX2P")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("iZX2P")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("iZX2P")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("iZX2P")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("iZX2P")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("iZX2P")).h; });
$parcel$export(module.exports, "hasInjectionContext", function () { return (parcelRequire("iZX2P")).hasInjectionContext; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("iZX2P")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("iZX2P")).inject; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("donES")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("donES")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("donES")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("donES")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("iZX2P")).isRuntimeOnly; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("donES")).markRaw; });
$parcel$export(module.exports, "mergeDefaults", function () { return (parcelRequire("iZX2P")).mergeDefaults; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("iZX2P")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("iZX2P")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6XHer")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("6XHer")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("iZX2P")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("iZX2P")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("iZX2P")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("iZX2P")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("iZX2P")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("iZX2P")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("iZX2P")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("iZX2P")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("iZX2P")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("iZX2P")).provide; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return (parcelRequire("iZX2P")).queuePostFlushCb; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("donES")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("donES")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("iZX2P")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("iZX2P")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("iZX2P")).resolveComponent; });
$parcel$export(module.exports, "resolveDirective", function () { return (parcelRequire("iZX2P")).resolveDirective; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("iZX2P")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("iZX2P")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("iZX2P")).setTransitionHooks; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("donES")).shallowReactive; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("donES")).shallowRef; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("iZX2P")).Static; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("iZX2P")).Teleport; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("donES")).toRaw; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("iZX2P")).useSlots; });
$parcel$export(module.exports, "useTemplateRef", function () { return (parcelRequire("iZX2P")).useTemplateRef; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("iZX2P")).useTransitionState; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("iZX2P")).version; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("iZX2P")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("iZX2P")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("iZX2P")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("iZX2P")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("iZX2P")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("donES")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("donES")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("donES")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("donES")).readonly; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("donES")).shallowReadonly; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("donES")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("donES")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("donES")).toValue; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("donES")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("6XHer")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("6XHer")).toDisplayString; });

$parcel$export(module.exports, "Transition", function () { return $7e98f0b941dabf58$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $7e98f0b941dabf58$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "useCssVars", function () { return $7e98f0b941dabf58$export$ef28b76f07940108; });
$parcel$export(module.exports, "createApp", function () { return $7e98f0b941dabf58$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "render", function () { return $7e98f0b941dabf58$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "TransitionGroup", function () { return $7e98f0b941dabf58$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "vModelText", function () { return $7e98f0b941dabf58$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $7e98f0b941dabf58$export$8847c2e532b35714; });
$parcel$export(module.exports, "vModelRadio", function () { return $7e98f0b941dabf58$export$b4356c59b38b7aa9; });
$parcel$export(module.exports, "vModelSelect", function () { return $7e98f0b941dabf58$export$87d227567b51ca39; });
$parcel$export(module.exports, "withModifiers", function () { return $7e98f0b941dabf58$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $7e98f0b941dabf58$export$f691a8759658f782; });
/**
* @vue/runtime-dom v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $iZX2P = parcelRequire("iZX2P");
var $6XHer = parcelRequire("6XHer");
var $donES = parcelRequire("donES");
var $donES = parcelRequire("donES");parcelRequire("6XHer");

var $6XHer = parcelRequire("6XHer");
let $7e98f0b941dabf58$var$policy = void 0;
const $7e98f0b941dabf58$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($7e98f0b941dabf58$var$tt) try {
    $7e98f0b941dabf58$var$policy = /* @__PURE__ */ $7e98f0b941dabf58$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $7e98f0b941dabf58$var$unsafeToTrustedHTML = $7e98f0b941dabf58$var$policy ? (val)=>$7e98f0b941dabf58$var$policy.createHTML(val) : (val)=>val;
const $7e98f0b941dabf58$var$svgNS = "http://www.w3.org/2000/svg";
const $7e98f0b941dabf58$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $7e98f0b941dabf58$var$doc = typeof document !== "undefined" ? document : null;
const $7e98f0b941dabf58$var$templateContainer = $7e98f0b941dabf58$var$doc && /* @__PURE__ */ $7e98f0b941dabf58$var$doc.createElement("template");
const $7e98f0b941dabf58$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $7e98f0b941dabf58$var$doc.createElementNS($7e98f0b941dabf58$var$svgNS, tag) : namespace === "mathml" ? $7e98f0b941dabf58$var$doc.createElementNS($7e98f0b941dabf58$var$mathmlNS, tag) : is ? $7e98f0b941dabf58$var$doc.createElement(tag, {
            is: is
        }) : $7e98f0b941dabf58$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$7e98f0b941dabf58$var$doc.createTextNode(text),
    createComment: (text)=>$7e98f0b941dabf58$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$7e98f0b941dabf58$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $7e98f0b941dabf58$var$templateContainer.innerHTML = $7e98f0b941dabf58$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $7e98f0b941dabf58$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $7e98f0b941dabf58$var$TRANSITION = "transition";
const $7e98f0b941dabf58$var$ANIMATION = "animation";
const $7e98f0b941dabf58$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $7e98f0b941dabf58$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $7e98f0b941dabf58$var$TransitionPropsValidators = /* @__PURE__ */ (0, $6XHer.extend)({}, (0, $iZX2P.BaseTransitionPropsValidators), $7e98f0b941dabf58$var$DOMTransitionPropsValidators);
const $7e98f0b941dabf58$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $7e98f0b941dabf58$var$TransitionPropsValidators;
    return t;
};
const $7e98f0b941dabf58$export$be58926105124dd4 = /* @__PURE__ */ $7e98f0b941dabf58$var$decorate$1((props, { slots: slots })=>(0, $iZX2P.h)((0, $iZX2P.BaseTransition), $7e98f0b941dabf58$var$resolveTransitionProps(props), slots));
const $7e98f0b941dabf58$var$callHook = (hook, args = [])=>{
    if ((0, $6XHer.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $7e98f0b941dabf58$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $6XHer.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $7e98f0b941dabf58$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $7e98f0b941dabf58$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $7e98f0b941dabf58$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $7e98f0b941dabf58$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $7e98f0b941dabf58$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $7e98f0b941dabf58$var$removeTransitionClass(el, leaveFromClass);
        $7e98f0b941dabf58$var$removeTransitionClass(el, leaveToClass);
        $7e98f0b941dabf58$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $7e98f0b941dabf58$var$callHook(hook, [
                el,
                resolve
            ]);
            $7e98f0b941dabf58$var$nextFrame(()=>{
                $7e98f0b941dabf58$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $7e98f0b941dabf58$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$7e98f0b941dabf58$var$hasExplicitCallback(hook)) $7e98f0b941dabf58$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $6XHer.extend)(baseProps, {
        onBeforeEnter (el) {
            $7e98f0b941dabf58$var$callHook(onBeforeEnter, [
                el
            ]);
            $7e98f0b941dabf58$var$addTransitionClass(el, enterFromClass);
            $7e98f0b941dabf58$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $7e98f0b941dabf58$var$callHook(onBeforeAppear, [
                el
            ]);
            $7e98f0b941dabf58$var$addTransitionClass(el, appearFromClass);
            $7e98f0b941dabf58$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $7e98f0b941dabf58$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $7e98f0b941dabf58$var$forceReflow(el);
                $7e98f0b941dabf58$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $7e98f0b941dabf58$var$addTransitionClass(el, leaveActiveClass);
                $7e98f0b941dabf58$var$forceReflow(el);
            }
            $7e98f0b941dabf58$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $7e98f0b941dabf58$var$removeTransitionClass(el, leaveFromClass);
                $7e98f0b941dabf58$var$addTransitionClass(el, leaveToClass);
                if (!$7e98f0b941dabf58$var$hasExplicitCallback(onLeave)) $7e98f0b941dabf58$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $7e98f0b941dabf58$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $7e98f0b941dabf58$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $7e98f0b941dabf58$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $7e98f0b941dabf58$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $7e98f0b941dabf58$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $6XHer.isObject)(duration)) return [
        $7e98f0b941dabf58$var$NumberOf(duration.enter),
        $7e98f0b941dabf58$var$NumberOf(duration.leave)
    ];
    else {
        const n = $7e98f0b941dabf58$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $7e98f0b941dabf58$var$NumberOf(val) {
    const res = (0, $6XHer.toNumber)(val);
    return res;
}
function $7e98f0b941dabf58$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$7e98f0b941dabf58$var$vtcKey] || (el[$7e98f0b941dabf58$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $7e98f0b941dabf58$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$7e98f0b941dabf58$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$7e98f0b941dabf58$var$vtcKey] = void 0;
    }
}
function $7e98f0b941dabf58$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $7e98f0b941dabf58$var$endId = 0;
function $7e98f0b941dabf58$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$7e98f0b941dabf58$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $7e98f0b941dabf58$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $7e98f0b941dabf58$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$7e98f0b941dabf58$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$7e98f0b941dabf58$var$TRANSITION}Duration`);
    const transitionTimeout = $7e98f0b941dabf58$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$7e98f0b941dabf58$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$7e98f0b941dabf58$var$ANIMATION}Duration`);
    const animationTimeout = $7e98f0b941dabf58$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $7e98f0b941dabf58$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $7e98f0b941dabf58$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $7e98f0b941dabf58$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $7e98f0b941dabf58$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $7e98f0b941dabf58$var$TRANSITION : $7e98f0b941dabf58$var$ANIMATION : null;
        propCount = type ? type === $7e98f0b941dabf58$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $7e98f0b941dabf58$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$7e98f0b941dabf58$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $7e98f0b941dabf58$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$7e98f0b941dabf58$var$toMs(d) + $7e98f0b941dabf58$var$toMs(delays[i])));
}
function $7e98f0b941dabf58$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $7e98f0b941dabf58$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $7e98f0b941dabf58$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$7e98f0b941dabf58$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $7e98f0b941dabf58$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $7e98f0b941dabf58$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $7e98f0b941dabf58$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$7e98f0b941dabf58$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $7e98f0b941dabf58$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $7e98f0b941dabf58$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $7e98f0b941dabf58$var$setDisplay(el, false);
            });
        } else $7e98f0b941dabf58$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $7e98f0b941dabf58$var$setDisplay(el, value);
    }
};
function $7e98f0b941dabf58$var$setDisplay(el, value) {
    el.style.display = value ? el[$7e98f0b941dabf58$var$vShowOriginalDisplay] : "none";
    el[$7e98f0b941dabf58$var$vShowHidden] = !value;
}
function $7e98f0b941dabf58$var$initVShowForSSR() {
    $7e98f0b941dabf58$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $7e98f0b941dabf58$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $7e98f0b941dabf58$export$ef28b76f07940108(getter) {
    const instance = (0, $iZX2P.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$7e98f0b941dabf58$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $7e98f0b941dabf58$var$setVarsOnNode(instance.ce, vars);
        else $7e98f0b941dabf58$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $iZX2P.onBeforeUpdate)(()=>{
        (0, $iZX2P.queuePostFlushCb)(setVars);
    });
    (0, $iZX2P.onMounted)(()=>{
        (0, $iZX2P.watch)(setVars, (0, $6XHer.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $iZX2P.onUnmounted)(()=>ob.disconnect());
    });
}
function $7e98f0b941dabf58$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $7e98f0b941dabf58$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $7e98f0b941dabf58$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $iZX2P.Fragment)) vnode.children.forEach((c)=>$7e98f0b941dabf58$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $iZX2P.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $7e98f0b941dabf58$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $7e98f0b941dabf58$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $6XHer.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$7e98f0b941dabf58$var$CSS_VAR_TEXT] = cssText;
    }
}
const $7e98f0b941dabf58$var$displayRE = /(?:^|;)\s*display\s*:/;
function $7e98f0b941dabf58$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $6XHer.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $6XHer.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $7e98f0b941dabf58$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $7e98f0b941dabf58$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$7e98f0b941dabf58$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $6XHer.isString)(prev) && prev ? prev[key] : void 0, value)) $7e98f0b941dabf58$var$setStyle(style, key, value);
            } else $7e98f0b941dabf58$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$7e98f0b941dabf58$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $7e98f0b941dabf58$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($7e98f0b941dabf58$var$vShowOriginalDisplay in el) {
        if (!isCssString || prev !== next) el[$7e98f0b941dabf58$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$7e98f0b941dabf58$var$vShowHidden]) style.display = "none";
    }
}
const $7e98f0b941dabf58$var$semicolonRE = /[^\\];\s*$/;
const $7e98f0b941dabf58$var$importantRE = /\s*!important$/;
function $7e98f0b941dabf58$var$setStyle(style, name, val) {
    if ((0, $6XHer.isArray)(val)) val.forEach((v)=>$7e98f0b941dabf58$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) {
            if ($7e98f0b941dabf58$var$importantRE.test(val)) style.setProperty(name, val.replace($7e98f0b941dabf58$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $7e98f0b941dabf58$var$autoPrefix(style, name);
            if ($7e98f0b941dabf58$var$importantRE.test(val)) style.setProperty((0, $6XHer.hyphenate)(prefixed), val.replace($7e98f0b941dabf58$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $7e98f0b941dabf58$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $7e98f0b941dabf58$var$prefixCache = {};
function $7e98f0b941dabf58$var$autoPrefix(style, rawName) {
    const cached = $7e98f0b941dabf58$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $6XHer.camelize)(rawName);
    if (name !== "filter" && name in style) return $7e98f0b941dabf58$var$prefixCache[rawName] = name;
    name = (0, $6XHer.capitalize)(name);
    for(let i = 0; i < $7e98f0b941dabf58$var$prefixes.length; i++){
        const prefixed = $7e98f0b941dabf58$var$prefixes[i] + name;
        if (prefixed in style) return $7e98f0b941dabf58$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $7e98f0b941dabf58$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $6XHer.isString)(next) && prev === next;
}
const $7e98f0b941dabf58$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $7e98f0b941dabf58$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $6XHer.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($7e98f0b941dabf58$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($7e98f0b941dabf58$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $6XHer.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $6XHer.isSymbol)(value) ? String(value) : value);
}
function $7e98f0b941dabf58$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $7e98f0b941dabf58$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $6XHer.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $7e98f0b941dabf58$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $7e98f0b941dabf58$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $7e98f0b941dabf58$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $7e98f0b941dabf58$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$7e98f0b941dabf58$var$veiKey] || (el[$7e98f0b941dabf58$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $7e98f0b941dabf58$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $7e98f0b941dabf58$var$createInvoker(nextValue, instance);
            $7e98f0b941dabf58$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $7e98f0b941dabf58$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $7e98f0b941dabf58$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $7e98f0b941dabf58$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $7e98f0b941dabf58$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($7e98f0b941dabf58$var$optionsModifierRE)) && !$7e98f0b941dabf58$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $6XHer.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $7e98f0b941dabf58$var$cachedNow = 0;
const $7e98f0b941dabf58$var$p = /* @__PURE__ */ Promise.resolve();
const $7e98f0b941dabf58$var$getNow = ()=>$7e98f0b941dabf58$var$cachedNow || ($7e98f0b941dabf58$var$p.then(()=>$7e98f0b941dabf58$var$cachedNow = 0), $7e98f0b941dabf58$var$cachedNow = Date.now());
function $7e98f0b941dabf58$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $6XHer.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $iZX2P.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $iZX2P.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $7e98f0b941dabf58$var$getNow();
    return invoker;
}
function $7e98f0b941dabf58$var$sanitizeEventValue(value, propName) {
    if ((0, $6XHer.isFunction)(value) || (0, $6XHer.isArray)(value)) return value;
    (0, $iZX2P.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $6XHer.NOOP;
}
const $7e98f0b941dabf58$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $7e98f0b941dabf58$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $7e98f0b941dabf58$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $7e98f0b941dabf58$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $6XHer.isOn)(key)) {
        if (!(0, $6XHer.isModelListener)(key)) $7e98f0b941dabf58$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $7e98f0b941dabf58$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $7e98f0b941dabf58$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $7e98f0b941dabf58$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($7e98f0b941dabf58$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $6XHer.isString)(nextValue)))) $7e98f0b941dabf58$var$patchDOMProp(el, (0, $6XHer.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $7e98f0b941dabf58$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $7e98f0b941dabf58$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $7e98f0b941dabf58$var$isNativeOn(key) && (0, $6XHer.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($7e98f0b941dabf58$var$isNativeOn(key) && (0, $6XHer.isString)(value)) return false;
    return key in el;
}
function $7e98f0b941dabf58$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $6XHer.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $6XHer.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $6XHer.camelize)(prop) === camelKey);
}
const $7e98f0b941dabf58$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $7e98f0b941dabf58$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $iZX2P.defineComponent)(options, extraOptions);
    if ((0, $6XHer.isPlainObject)(Comp)) Comp = (0, $6XHer.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $7e98f0b941dabf58$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $7e98f0b941dabf58$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $7e98f0b941dabf58$export$a00e2346eabbdbef(options, extraOptions, $7e98f0b941dabf58$export$35800275c0037383);
};
const $7e98f0b941dabf58$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $7e98f0b941dabf58$export$b337c1a55163dbe3 extends $7e98f0b941dabf58$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $7e98f0b941dabf58$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $7e98f0b941dabf58$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $6XHer.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $7e98f0b941dabf58$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $iZX2P.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $6XHer.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $6XHer.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $6XHer.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            if (this._connected) this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $6XHer.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $donES.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $6XHer.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $6XHer.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $7e98f0b941dabf58$var$REMOVAL;
        const camelKey = (0, $6XHer.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $6XHer.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $7e98f0b941dabf58$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $6XHer.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $6XHer.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $6XHer.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $7e98f0b941dabf58$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $iZX2P.createVNode)(this._def, (0, $6XHer.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $6XHer.isPlainObject)(args[0]) ? (0, $6XHer.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $6XHer.hyphenate)(event) !== event) dispatch((0, $6XHer.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $7e98f0b941dabf58$export$da5acfe93a94e37d(caller) {
    const instance = (0, $iZX2P.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $iZX2P.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $iZX2P.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $7e98f0b941dabf58$export$64d45095031fa749() {
    const el = $7e98f0b941dabf58$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $7e98f0b941dabf58$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $iZX2P.getCurrentInstance)();
        if (!instance) return 0, $6XHer.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $6XHer.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $6XHer.EMPTY_OBJ;
        return mod;
    }
}
const $7e98f0b941dabf58$var$positionMap = /* @__PURE__ */ new WeakMap();
const $7e98f0b941dabf58$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $7e98f0b941dabf58$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $7e98f0b941dabf58$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $7e98f0b941dabf58$var$pendingGroups = /* @__PURE__ */ new WeakMap();
const $7e98f0b941dabf58$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $7e98f0b941dabf58$var$TransitionGroupImpl = /* @__PURE__ */ $7e98f0b941dabf58$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $6XHer.extend)({}, $7e98f0b941dabf58$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $iZX2P.getCurrentInstance)();
        const state = (0, $iZX2P.useTransitionState)();
        let prevChildren;
        let children;
        let origins;
        let moves;
        const willMove = ()=>{
            if (moves === void 0) moves = prevChildren.length > 0 && $7e98f0b941dabf58$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, $7e98f0b941dabf58$var$resolveMoveClass(props));
            return moves;
        };
        (0, $iZX2P.onUpdated)(()=>{
            $7e98f0b941dabf58$var$pendingGroups.delete(instance);
            if (!willMove()) {
                prevChildren = [];
                origins = void 0;
                return;
            }
            const moveClass = $7e98f0b941dabf58$var$resolveMoveClass(props);
            prevChildren.forEach($7e98f0b941dabf58$var$callPendingCbs);
            const shift = origins && $7e98f0b941dabf58$var$getOriginShift(origins, instance.vnode.el);
            origins = void 0;
            prevChildren.forEach((c)=>$7e98f0b941dabf58$var$recordPosition(c, shift));
            const movedChildren = prevChildren.filter($7e98f0b941dabf58$var$applyTranslation);
            $7e98f0b941dabf58$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $7e98f0b941dabf58$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$7e98f0b941dabf58$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$7e98f0b941dabf58$var$moveCbKey] = null;
                        $7e98f0b941dabf58$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $donES.toRaw)(props);
            const cssTransitionProps = $7e98f0b941dabf58$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $iZX2P.Fragment);
            prevChildren = [];
            moves = void 0;
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$7e98f0b941dabf58$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $iZX2P.setTransitionHooks)(child, (0, $iZX2P.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $7e98f0b941dabf58$var$positionMap.set(child, $7e98f0b941dabf58$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $iZX2P.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $iZX2P.setTransitionHooks)(child, (0, $iZX2P.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren.length) {
                origins = $7e98f0b941dabf58$var$getOrigins(instance);
                $7e98f0b941dabf58$var$pendingGroups.set(instance, willMove);
            }
            return (0, $iZX2P.createVNode)(tag, null, children);
        };
    }
});
const $7e98f0b941dabf58$export$19ffa8f511f7bc2e = $7e98f0b941dabf58$var$TransitionGroupImpl;
function $7e98f0b941dabf58$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$7e98f0b941dabf58$var$moveCbKey]) el[$7e98f0b941dabf58$var$moveCbKey]();
    if (el[$7e98f0b941dabf58$var$enterCbKey]) el[$7e98f0b941dabf58$var$enterCbKey]();
}
function $7e98f0b941dabf58$var$resolveMoveClass(props) {
    return props.moveClass || `${props.name || "v"}-move`;
}
function $7e98f0b941dabf58$var$recordPosition(c, shift) {
    $7e98f0b941dabf58$var$newPositionMap.set(c, $7e98f0b941dabf58$var$getPosition(c.el, shift));
}
function $7e98f0b941dabf58$var$applyTranslation(c) {
    const oldPos = $7e98f0b941dabf58$var$positionMap.get(c);
    const newPos = $7e98f0b941dabf58$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $7e98f0b941dabf58$var$getPosition(el, shift) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left - (shift ? shift.left : 0),
        top: rect.top - (shift ? shift.top : 0)
    };
}
function $7e98f0b941dabf58$var$getOrigins(instance) {
    let origins;
    for(let group = instance.parent; group; group = group.parent){
        const willMove = $7e98f0b941dabf58$var$pendingGroups.get(group);
        if (willMove) {
            const item = $7e98f0b941dabf58$var$findItem(group.vnode.el, instance.vnode.el);
            if (item) (origins || (origins = [])).push((0, $6XHer.extend)($7e98f0b941dabf58$var$getPosition(item), {
                item: item,
                willMove: willMove
            }));
        }
    }
    return origins;
}
function $7e98f0b941dabf58$var$findItem(root, node) {
    const container = root.nodeType === 1 ? root : root.parentNode;
    while(node && node.parentNode !== container)node = node.parentNode;
    if (node && node.nodeType === 1) return node;
}
function $7e98f0b941dabf58$var$getOriginShift(origins, root) {
    const origin = origins.find((o)=>o.willMove() && o.item.contains(root));
    return origin && $7e98f0b941dabf58$var$getPosition(origin.item, origin);
}
function $7e98f0b941dabf58$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$7e98f0b941dabf58$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $7e98f0b941dabf58$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $7e98f0b941dabf58$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $6XHer.isArray)(fn) ? (value)=>(0, $6XHer.invokeArrayFns)(fn, value) : fn;
};
function $7e98f0b941dabf58$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $7e98f0b941dabf58$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $7e98f0b941dabf58$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $7e98f0b941dabf58$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $7e98f0b941dabf58$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $6XHer.looseToNumber)(value);
    return value;
}
const $7e98f0b941dabf58$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$7e98f0b941dabf58$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$7e98f0b941dabf58$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $7e98f0b941dabf58$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$7e98f0b941dabf58$var$assignKey]($7e98f0b941dabf58$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $7e98f0b941dabf58$var$addEventListener(el, "change", ()=>{
            el.value = $7e98f0b941dabf58$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $7e98f0b941dabf58$var$addEventListener(el, "compositionstart", $7e98f0b941dabf58$var$onCompositionStart);
            $7e98f0b941dabf58$var$addEventListener(el, "compositionend", $7e98f0b941dabf58$var$onCompositionEnd);
            $7e98f0b941dabf58$var$addEventListener(el, "change", $7e98f0b941dabf58$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$7e98f0b941dabf58$var$initialValueKey];
        delete el[$7e98f0b941dabf58$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$7e98f0b941dabf58$var$assignKey]($7e98f0b941dabf58$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $6XHer.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $7e98f0b941dabf58$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        $7e98f0b941dabf58$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $7e98f0b941dabf58$var$getValue(el);
            const checked = el.checked;
            const assign = el[$7e98f0b941dabf58$var$assignKey];
            if ((0, $6XHer.isArray)(modelValue)) {
                const index = (0, $6XHer.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $6XHer.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($7e98f0b941dabf58$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $7e98f0b941dabf58$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        $7e98f0b941dabf58$var$setChecked(el, binding, vnode);
    }
};
function $7e98f0b941dabf58$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $6XHer.isArray)(value)) checked = (0, $6XHer.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $6XHer.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $6XHer.looseEqual)(value, $7e98f0b941dabf58$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $7e98f0b941dabf58$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $6XHer.looseEqual)(value, vnode.props.value);
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        $7e98f0b941dabf58$var$addEventListener(el, "change", ()=>{
            el[$7e98f0b941dabf58$var$assignKey]($7e98f0b941dabf58$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $6XHer.looseEqual)(value, vnode.props.value);
    }
};
const $7e98f0b941dabf58$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $7e98f0b941dabf58$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $6XHer.looseToNumber)($7e98f0b941dabf58$var$getValue(o)) : $7e98f0b941dabf58$var$getValue(o));
            const multiple = el.multiple;
            const assignedValue = multiple ? (0, $6XHer.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
            const pending = el._pendingValue = [
                multiple,
                multiple ? (0, $6XHer.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
            ];
            try {
                el[$7e98f0b941dabf58$var$assignKey](assignedValue);
            } finally{
                (0, $iZX2P.nextTick)(()=>{
                    if (el._pendingValue === pending) el._pendingValue = void 0;
                });
            }
        });
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $7e98f0b941dabf58$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$7e98f0b941dabf58$var$assignKey] = $7e98f0b941dabf58$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        const pending = el._pendingValue;
        el._pendingValue = void 0;
        if (!pending || pending[0] !== el.multiple || !$7e98f0b941dabf58$var$isSameSelectValue(value, pending[1], pending[0])) $7e98f0b941dabf58$var$setSelected(el, value);
    }
};
function $7e98f0b941dabf58$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $6XHer.looseEqual)(value, assignedValue);
    if ((0, $6XHer.isArray)(value)) return (0, $6XHer.looseEqual)(value, assignedValue);
    if ((0, $6XHer.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue){
            if (!value.has(item)) return false;
        }
        return true;
    }
    return false;
}
function $7e98f0b941dabf58$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $6XHer.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $6XHer.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $7e98f0b941dabf58$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $6XHer.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $6XHer.looseEqual)($7e98f0b941dabf58$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $7e98f0b941dabf58$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $7e98f0b941dabf58$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $7e98f0b941dabf58$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $7e98f0b941dabf58$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $7e98f0b941dabf58$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $7e98f0b941dabf58$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $7e98f0b941dabf58$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $7e98f0b941dabf58$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $7e98f0b941dabf58$export$87d227567b51ca39;
        case "TEXTAREA":
            return $7e98f0b941dabf58$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $7e98f0b941dabf58$export$8847c2e532b35714;
                case "radio":
                    return $7e98f0b941dabf58$export$b4356c59b38b7aa9;
                default:
                    return $7e98f0b941dabf58$export$f1f88689f5728478;
            }
    }
}
function $7e98f0b941dabf58$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $7e98f0b941dabf58$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $7e98f0b941dabf58$var$initVModelForSSR() {
    $7e98f0b941dabf58$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $7e98f0b941dabf58$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $6XHer.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $7e98f0b941dabf58$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $6XHer.isArray)(value)) {
            if (vnode.props && (0, $6XHer.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $6XHer.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $7e98f0b941dabf58$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $7e98f0b941dabf58$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $7e98f0b941dabf58$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $7e98f0b941dabf58$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$7e98f0b941dabf58$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $7e98f0b941dabf58$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $7e98f0b941dabf58$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $7e98f0b941dabf58$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $7e98f0b941dabf58$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $6XHer.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $7e98f0b941dabf58$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $7e98f0b941dabf58$var$rendererOptions = /* @__PURE__ */ (0, $6XHer.extend)({
    patchProp: $7e98f0b941dabf58$export$cd4aa0842d13df8b
}, $7e98f0b941dabf58$export$de4fb7f5030605d3);
let $7e98f0b941dabf58$var$renderer;
let $7e98f0b941dabf58$var$enabledHydration = false;
function $7e98f0b941dabf58$var$ensureRenderer() {
    return $7e98f0b941dabf58$var$renderer || ($7e98f0b941dabf58$var$renderer = (0, $iZX2P.createRenderer)($7e98f0b941dabf58$var$rendererOptions));
}
function $7e98f0b941dabf58$var$ensureHydrationRenderer() {
    $7e98f0b941dabf58$var$renderer = $7e98f0b941dabf58$var$enabledHydration ? $7e98f0b941dabf58$var$renderer : (0, $iZX2P.createHydrationRenderer)($7e98f0b941dabf58$var$rendererOptions);
    $7e98f0b941dabf58$var$enabledHydration = true;
    return $7e98f0b941dabf58$var$renderer;
}
const $7e98f0b941dabf58$export$b3890eb0ae9dca99 = (...args)=>{
    $7e98f0b941dabf58$var$ensureRenderer().render(...args);
};
const $7e98f0b941dabf58$export$fa8d919ba61d84db = (...args)=>{
    $7e98f0b941dabf58$var$ensureHydrationRenderer().hydrate(...args);
};
const $7e98f0b941dabf58$export$4e373c34abfa8c68 = (...args)=>{
    const app = $7e98f0b941dabf58$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $7e98f0b941dabf58$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $6XHer.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $7e98f0b941dabf58$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $7e98f0b941dabf58$export$35800275c0037383 = (...args)=>{
    const app = $7e98f0b941dabf58$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $7e98f0b941dabf58$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $7e98f0b941dabf58$var$resolveRootNamespace(container));
    };
    return app;
};
function $7e98f0b941dabf58$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $7e98f0b941dabf58$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $6XHer.isHTMLTag)(tag) || (0, $6XHer.isSVGTag)(tag) || (0, $6XHer.isMathMLTag)(tag),
        writable: false
    });
}
function $7e98f0b941dabf58$var$injectCompilerOptionsCheck(app) {
    if ((0, $iZX2P.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $iZX2P.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $iZX2P.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $iZX2P.warn)(msg);
            }
        });
    }
}
function $7e98f0b941dabf58$var$normalizeContainer(container) {
    if ((0, $6XHer.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $7e98f0b941dabf58$var$ssrDirectiveInitialized = false;
const $7e98f0b941dabf58$export$800b28255aa678d9 = ()=>{
    if (!$7e98f0b941dabf58$var$ssrDirectiveInitialized) {
        $7e98f0b941dabf58$var$ssrDirectiveInitialized = true;
        $7e98f0b941dabf58$var$initVModelForSSR();
        $7e98f0b941dabf58$var$initVShowForSSR();
    }
};

});


parcelRegister("gPqVN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c4064cc0edef0a95$export$2e2bcd8739ae039; });

var $2q1Wz = parcelRequire("2q1Wz");

var $hEYpB = parcelRequire("hEYpB");

var $1nFzo = parcelRequire("1nFzo");
var $c4064cc0edef0a95$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        BaseToast: $hEYpB.default,
        AdminBanner: $1nFzo.default
    },
    computed: {
        ...(0, $2q1Wz.mapGetters)("sessions", [
            "user",
            "trueUser"
        ]),
        ...(0, $2q1Wz.mapGetters)([
            "adminBannerHidden"
        ]),
        isAdmin () {
            const user = this.trueUser || this.user;
            return user && (user.role === "company_admin" || user.role === "super_admin" || user.role_type === "company_admin" || user.role_type === "super_admin");
        },
        darkTheme () {
            return this.user?.plan_preferences?.dark_theme === true;
        }
    },
    watch: {
        darkTheme (newValue) {
            this.applyTheme(newValue);
        },
        user: {
            handler () {
                // Apply theme when user data is loaded or updated
                this.applyTheme(this.darkTheme);
            },
            immediate: true
        }
    },
    mounted () {
        // Apply theme on mount in case user is already loaded
        this.applyTheme(this.darkTheme);
        const flashMessage = document.getElementById("app").dataset.flashMessage;
        if (flashMessage) this.$store.dispatch("showToast", {
            type: "success",
            message: flashMessage
        });
    },
    methods: {
        applyTheme (isDark) {
            if (isDark) document.documentElement.setAttribute("data-theme", "dark");
            else document.documentElement.removeAttribute("data-theme");
        }
    }
};

});
parcelRegister("2q1Wz", function(module, exports) {

$parcel$export(module.exports, "useStore", function () { return $1c2f8475454ab52e$export$6ccbb43953eebf8; });
$parcel$export(module.exports, "createStore", function () { return $1c2f8475454ab52e$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "mapGetters", function () { return $1c2f8475454ab52e$export$74d9085e6d5a97cb; });
$parcel$export(module.exports, "mapActions", function () { return $1c2f8475454ab52e$export$1d73b9b98821f6dc; });
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */ parcelRequire("bnAYy");
var $donES = parcelRequire("donES");
var $iZX2P = parcelRequire("iZX2P");

var $4J6PC = parcelRequire("4J6PC");
var $1c2f8475454ab52e$export$67bdc3ac2df6c0d1 = 'store';
function $1c2f8475454ab52e$export$6ccbb43953eebf8(key) {
    if (key === void 0) key = null;
    return (0, $iZX2P.inject)(key !== null ? key : $1c2f8475454ab52e$export$67bdc3ac2df6c0d1);
}
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */ function $1c2f8475454ab52e$var$find(list, f) {
    return list.filter(f)[0];
}
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */ function $1c2f8475454ab52e$var$deepCopy(obj, cache) {
    if (cache === void 0) cache = [];
    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') return obj;
    // if obj is hit, it is in circular structure
    var hit = $1c2f8475454ab52e$var$find(cache, function(c) {
        return c.original === obj;
    });
    if (hit) return hit.copy;
    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy: copy
    });
    Object.keys(obj).forEach(function(key) {
        copy[key] = $1c2f8475454ab52e$var$deepCopy(obj[key], cache);
    });
    return copy;
}
/**
 * forEach for object
 */ function $1c2f8475454ab52e$var$forEachValue(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
function $1c2f8475454ab52e$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $1c2f8475454ab52e$var$isPromise(val) {
    return val && typeof val.then === 'function';
}
function $1c2f8475454ab52e$var$assert(condition, msg) {
    if (!condition) throw new Error("[vuex] " + msg);
}
function $1c2f8475454ab52e$var$partial(fn, arg) {
    return function() {
        return fn(arg);
    };
}
function $1c2f8475454ab52e$var$genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    return function() {
        var i = subs.indexOf(fn);
        if (i > -1) subs.splice(i, 1);
    };
}
function $1c2f8475454ab52e$var$resetStore(store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state;
    // init all modules
    $1c2f8475454ab52e$var$installModule(store, state, [], store._modules.root, true);
    // reset state
    $1c2f8475454ab52e$var$resetStoreState(store, state, hot);
}
function $1c2f8475454ab52e$var$resetStoreState(store, state, hot) {
    var oldState = store._state;
    var oldScope = store._scope;
    // bind store public getters
    store.getters = {};
    // reset local getters cache
    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computedObj = {};
    var computedCache = {};
    // create a new effect scope and create computed object inside it to avoid
    // getters (computed) getting destroyed on component unmount.
    var scope = (0, $donES.effectScope)(true);
    scope.run(function() {
        $1c2f8475454ab52e$var$forEachValue(wrappedGetters, function(fn, key) {
            // use computed to leverage its lazy-caching mechanism
            // direct inline function use will lead to closure preserving oldState.
            // using partial to return function with only arguments preserved in closure environment.
            computedObj[key] = $1c2f8475454ab52e$var$partial(fn, store);
            computedCache[key] = (0, $donES.computed)(function() {
                return computedObj[key]();
            });
            Object.defineProperty(store.getters, key, {
                get: function() {
                    return computedCache[key].value;
                },
                enumerable: true // for local getters
            });
        });
    });
    store._state = (0, $donES.reactive)({
        data: state
    });
    // register the newly created effect scope to the store so that we can
    // dispose the effects when this method runs again in the future.
    store._scope = scope;
    // enable strict mode for new state
    if (store.strict) $1c2f8475454ab52e$var$enableStrictMode(store);
    if (oldState) {
        if (hot) // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function() {
            oldState.data = null;
        });
    }
    // dispose previously registered effect scope if there is one.
    if (oldScope) oldScope.stop();
}
function $1c2f8475454ab52e$var$installModule(store, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store._modules.getNamespace(path);
    // register in namespace map
    if (module.namespaced) {
        if (store._modulesNamespaceMap[namespace] && true) console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
        store._modulesNamespaceMap[namespace] = module;
    }
    // set state
    if (!isRoot && !hot) {
        var parentState = $1c2f8475454ab52e$var$getNestedState(rootState, path.slice(0, -1));
        var moduleName = path[path.length - 1];
        store._withCommit(function() {
            if (moduleName in parentState) console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
            parentState[moduleName] = module.state;
        });
    }
    var local = module.context = $1c2f8475454ab52e$var$makeLocalContext(store, namespace, path);
    module.forEachMutation(function(mutation, key) {
        var namespacedType = namespace + key;
        $1c2f8475454ab52e$var$registerMutation(store, namespacedType, mutation, local);
    });
    module.forEachAction(function(action, key) {
        var type = action.root ? key : namespace + key;
        var handler = action.handler || action;
        $1c2f8475454ab52e$var$registerAction(store, type, handler, local);
    });
    module.forEachGetter(function(getter, key) {
        var namespacedType = namespace + key;
        $1c2f8475454ab52e$var$registerGetter(store, namespacedType, getter, local);
    });
    module.forEachChild(function(child, key) {
        $1c2f8475454ab52e$var$installModule(store, rootState, path.concat(key), child, hot);
    });
}
/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */ function $1c2f8475454ab52e$var$makeLocalContext(store, namespace, path) {
    var noNamespace = namespace === '';
    var local = {
        dispatch: noNamespace ? store.dispatch : function(_type, _payload, _options) {
            var args = $1c2f8475454ab52e$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._actions[type]) {
                    console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            return store.dispatch(type, payload);
        },
        commit: noNamespace ? store.commit : function(_type, _payload, _options) {
            var args = $1c2f8475454ab52e$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._mutations[type]) {
                    console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            store.commit(type, payload, options);
        }
    };
    // getters and state object must be gotten lazily
    // because they will be changed by state update
    Object.defineProperties(local, {
        getters: {
            get: noNamespace ? function() {
                return store.getters;
            } : function() {
                return $1c2f8475454ab52e$var$makeLocalGetters(store, namespace);
            }
        },
        state: {
            get: function() {
                return $1c2f8475454ab52e$var$getNestedState(store.state, path);
            }
        }
    });
    return local;
}
function $1c2f8475454ab52e$var$makeLocalGetters(store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
        var gettersProxy = {};
        var splitPos = namespace.length;
        Object.keys(store.getters).forEach(function(type) {
            // skip if the target getter is not match this namespace
            if (type.slice(0, splitPos) !== namespace) return;
            // extract local getter type
            var localType = type.slice(splitPos);
            // Add a port to the getters proxy.
            // Define as getter property because
            // we do not want to evaluate the getters in this time.
            Object.defineProperty(gettersProxy, localType, {
                get: function() {
                    return store.getters[type];
                },
                enumerable: true
            });
        });
        store._makeLocalGettersCache[namespace] = gettersProxy;
    }
    return store._makeLocalGettersCache[namespace];
}
function $1c2f8475454ab52e$var$registerMutation(store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
        handler.call(store, local.state, payload);
    });
}
function $1c2f8475454ab52e$var$registerAction(store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
        var res = handler.call(store, {
            dispatch: local.dispatch,
            commit: local.commit,
            getters: local.getters,
            state: local.state,
            rootGetters: store.getters,
            rootState: store.state
        }, payload);
        if (!$1c2f8475454ab52e$var$isPromise(res)) res = Promise.resolve(res);
        if (store._devtoolHook) return res.catch(function(err) {
            store._devtoolHook.emit('vuex:error', err);
            throw err;
        });
        else return res;
    });
}
function $1c2f8475454ab52e$var$registerGetter(store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
        console.error("[vuex] duplicate getter key: " + type);
        return;
    }
    store._wrappedGetters[type] = function wrappedGetter(store) {
        return rawGetter(local.state, local.getters, store.state, store.getters // root getters
        );
    };
}
function $1c2f8475454ab52e$var$enableStrictMode(store) {
    (0, $donES.watch)(function() {
        return store._state.data;
    }, function() {
        $1c2f8475454ab52e$var$assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }, {
        deep: true,
        flush: 'sync'
    });
}
function $1c2f8475454ab52e$var$getNestedState(state, path) {
    return path.reduce(function(state, key) {
        return state[key];
    }, state);
}
function $1c2f8475454ab52e$var$unifyObjectStyle(type, payload, options) {
    if ($1c2f8475454ab52e$var$isObject(type) && type.type) {
        options = payload;
        payload = type;
        type = type.type;
    }
    $1c2f8475454ab52e$var$assert(typeof type === 'string', "expects string as the type, but found " + typeof type + ".");
    return {
        type: type,
        payload: payload,
        options: options
    };
}
var $1c2f8475454ab52e$var$LABEL_VUEX_BINDINGS = 'vuex bindings';
var $1c2f8475454ab52e$var$MUTATIONS_LAYER_ID = 'vuex:mutations';
var $1c2f8475454ab52e$var$ACTIONS_LAYER_ID = 'vuex:actions';
var $1c2f8475454ab52e$var$INSPECTOR_ID = 'vuex';
var $1c2f8475454ab52e$var$actionId = 0;
function $1c2f8475454ab52e$var$addDevtools(app, store) {
    (0, $4J6PC.setupDevtoolsPlugin)({
        id: 'org.vuejs.vuex',
        app: app,
        label: 'Vuex',
        homepage: 'https://next.vuex.vuejs.org/',
        logo: 'https://vuejs.org/images/icons/favicon-96x96.png',
        packageName: 'vuex',
        componentStateTypes: [
            $1c2f8475454ab52e$var$LABEL_VUEX_BINDINGS
        ]
    }, function(api) {
        api.addTimelineLayer({
            id: $1c2f8475454ab52e$var$MUTATIONS_LAYER_ID,
            label: 'Vuex Mutations',
            color: $1c2f8475454ab52e$var$COLOR_LIME_500
        });
        api.addTimelineLayer({
            id: $1c2f8475454ab52e$var$ACTIONS_LAYER_ID,
            label: 'Vuex Actions',
            color: $1c2f8475454ab52e$var$COLOR_LIME_500
        });
        api.addInspector({
            id: $1c2f8475454ab52e$var$INSPECTOR_ID,
            label: 'Vuex',
            icon: 'storage',
            treeFilterPlaceholder: 'Filter stores...'
        });
        api.on.getInspectorTree(function(payload) {
            if (payload.app === app && payload.inspectorId === $1c2f8475454ab52e$var$INSPECTOR_ID) {
                if (payload.filter) {
                    var nodes = [];
                    $1c2f8475454ab52e$var$flattenStoreForInspectorTree(nodes, store._modules.root, payload.filter, '');
                    payload.rootNodes = nodes;
                } else payload.rootNodes = [
                    $1c2f8475454ab52e$var$formatStoreForInspectorTree(store._modules.root, '')
                ];
            }
        });
        api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $1c2f8475454ab52e$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                $1c2f8475454ab52e$var$makeLocalGetters(store, modulePath);
                payload.state = $1c2f8475454ab52e$var$formatStoreForInspectorState($1c2f8475454ab52e$var$getStoreModule(store._modules, modulePath), modulePath === 'root' ? store.getters : store._makeLocalGettersCache, modulePath);
            }
        });
        api.on.editInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $1c2f8475454ab52e$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                var path = payload.path;
                if (modulePath !== 'root') path = modulePath.split('/').filter(Boolean).concat(path);
                store._withCommit(function() {
                    payload.set(store._state.data, path, payload.state.value);
                });
            }
        });
        store.subscribe(function(mutation, state) {
            var data = {};
            if (mutation.payload) data.payload = mutation.payload;
            data.state = state;
            api.notifyComponentUpdate();
            api.sendInspectorTree($1c2f8475454ab52e$var$INSPECTOR_ID);
            api.sendInspectorState($1c2f8475454ab52e$var$INSPECTOR_ID);
            api.addTimelineEvent({
                layerId: $1c2f8475454ab52e$var$MUTATIONS_LAYER_ID,
                event: {
                    time: Date.now(),
                    title: mutation.type,
                    data: data
                }
            });
        });
        store.subscribeAction({
            before: function(action, state) {
                var data = {};
                if (action.payload) data.payload = action.payload;
                action._id = $1c2f8475454ab52e$var$actionId++;
                action._time = Date.now();
                data.state = state;
                api.addTimelineEvent({
                    layerId: $1c2f8475454ab52e$var$ACTIONS_LAYER_ID,
                    event: {
                        time: action._time,
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'start',
                        data: data
                    }
                });
            },
            after: function(action, state) {
                var data = {};
                var duration = Date.now() - action._time;
                data.duration = {
                    _custom: {
                        type: 'duration',
                        display: duration + "ms",
                        tooltip: 'Action duration',
                        value: duration
                    }
                };
                if (action.payload) data.payload = action.payload;
                data.state = state;
                api.addTimelineEvent({
                    layerId: $1c2f8475454ab52e$var$ACTIONS_LAYER_ID,
                    event: {
                        time: Date.now(),
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'end',
                        data: data
                    }
                });
            }
        });
    });
}
// extracted from tailwind palette
var $1c2f8475454ab52e$var$COLOR_LIME_500 = 0x84cc16;
var $1c2f8475454ab52e$var$COLOR_DARK = 0x666666;
var $1c2f8475454ab52e$var$COLOR_WHITE = 0xffffff;
var $1c2f8475454ab52e$var$TAG_NAMESPACED = {
    label: 'namespaced',
    textColor: $1c2f8475454ab52e$var$COLOR_WHITE,
    backgroundColor: $1c2f8475454ab52e$var$COLOR_DARK
};
/**
 * @param {string} path
 */ function $1c2f8475454ab52e$var$extractNameFromPath(path) {
    return path && path !== 'root' ? path.split('/').slice(-2, -1)[0] : 'Root';
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorNode}
 */ function $1c2f8475454ab52e$var$formatStoreForInspectorTree(module, path) {
    return {
        id: path || 'root',
        // all modules end with a `/`, we want the last segment only
        // cart/ -> cart
        // nested/cart/ -> cart
        label: $1c2f8475454ab52e$var$extractNameFromPath(path),
        tags: module.namespaced ? [
            $1c2f8475454ab52e$var$TAG_NAMESPACED
        ] : [],
        children: Object.keys(module._children).map(function(moduleName) {
            return $1c2f8475454ab52e$var$formatStoreForInspectorTree(module._children[moduleName], path + moduleName + '/');
        })
    };
}
/**
 * @param {import('@vue/devtools-api').CustomInspectorNode[]} result
 * @param {*} module
 * @param {string} filter
 * @param {string} path
 */ function $1c2f8475454ab52e$var$flattenStoreForInspectorTree(result, module, filter, path) {
    if (path.includes(filter)) result.push({
        id: path || 'root',
        label: path.endsWith('/') ? path.slice(0, path.length - 1) : path || 'Root',
        tags: module.namespaced ? [
            $1c2f8475454ab52e$var$TAG_NAMESPACED
        ] : []
    });
    Object.keys(module._children).forEach(function(moduleName) {
        $1c2f8475454ab52e$var$flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + '/');
    });
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorState}
 */ function $1c2f8475454ab52e$var$formatStoreForInspectorState(module, getters, path) {
    getters = path === 'root' ? getters : getters[path];
    var gettersKeys = Object.keys(getters);
    var storeState = {
        state: Object.keys(module.state).map(function(key) {
            return {
                key: key,
                editable: true,
                value: module.state[key]
            };
        })
    };
    if (gettersKeys.length) {
        var tree = $1c2f8475454ab52e$var$transformPathsToObjectTree(getters);
        storeState.getters = Object.keys(tree).map(function(key) {
            return {
                key: key.endsWith('/') ? $1c2f8475454ab52e$var$extractNameFromPath(key) : key,
                editable: false,
                value: $1c2f8475454ab52e$var$canThrow(function() {
                    return tree[key];
                })
            };
        });
    }
    return storeState;
}
function $1c2f8475454ab52e$var$transformPathsToObjectTree(getters) {
    var result = {};
    Object.keys(getters).forEach(function(key) {
        var path = key.split('/');
        if (path.length > 1) {
            var target = result;
            var leafKey = path.pop();
            path.forEach(function(p) {
                if (!target[p]) target[p] = {
                    _custom: {
                        value: {},
                        display: p,
                        tooltip: 'Module',
                        abstract: true
                    }
                };
                target = target[p]._custom.value;
            });
            target[leafKey] = $1c2f8475454ab52e$var$canThrow(function() {
                return getters[key];
            });
        } else result[key] = $1c2f8475454ab52e$var$canThrow(function() {
            return getters[key];
        });
    });
    return result;
}
function $1c2f8475454ab52e$var$getStoreModule(moduleMap, path) {
    var names = path.split('/').filter(function(n) {
        return n;
    });
    return names.reduce(function(module, moduleName, i) {
        var child = module[moduleName];
        if (!child) throw new Error("Missing module \"" + moduleName + "\" for path \"" + path + "\".");
        return i === names.length - 1 ? child : child._children;
    }, path === 'root' ? moduleMap : moduleMap.root._children);
}
function $1c2f8475454ab52e$var$canThrow(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
// Base data struct for store's module, package with some attribute and method
var $1c2f8475454ab52e$var$Module = function Module(rawModule, runtime) {
    this.runtime = runtime;
    // Store some children item
    this._children = Object.create(null);
    // Store the origin module object which passed by programmer
    this._rawModule = rawModule;
    var rawState = rawModule.state;
    // Store the origin module's state
    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};
var $1c2f8475454ab52e$var$prototypeAccessors$1 = {
    namespaced: {
        configurable: true
    }
};
$1c2f8475454ab52e$var$prototypeAccessors$1.namespaced.get = function() {
    return !!this._rawModule.namespaced;
};
$1c2f8475454ab52e$var$Module.prototype.addChild = function addChild(key, module) {
    this._children[key] = module;
};
$1c2f8475454ab52e$var$Module.prototype.removeChild = function removeChild(key) {
    delete this._children[key];
};
$1c2f8475454ab52e$var$Module.prototype.getChild = function getChild(key) {
    return this._children[key];
};
$1c2f8475454ab52e$var$Module.prototype.hasChild = function hasChild(key) {
    return key in this._children;
};
$1c2f8475454ab52e$var$Module.prototype.update = function update(rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;
    if (rawModule.actions) this._rawModule.actions = rawModule.actions;
    if (rawModule.mutations) this._rawModule.mutations = rawModule.mutations;
    if (rawModule.getters) this._rawModule.getters = rawModule.getters;
};
$1c2f8475454ab52e$var$Module.prototype.forEachChild = function forEachChild(fn) {
    $1c2f8475454ab52e$var$forEachValue(this._children, fn);
};
$1c2f8475454ab52e$var$Module.prototype.forEachGetter = function forEachGetter(fn) {
    if (this._rawModule.getters) $1c2f8475454ab52e$var$forEachValue(this._rawModule.getters, fn);
};
$1c2f8475454ab52e$var$Module.prototype.forEachAction = function forEachAction(fn) {
    if (this._rawModule.actions) $1c2f8475454ab52e$var$forEachValue(this._rawModule.actions, fn);
};
$1c2f8475454ab52e$var$Module.prototype.forEachMutation = function forEachMutation(fn) {
    if (this._rawModule.mutations) $1c2f8475454ab52e$var$forEachValue(this._rawModule.mutations, fn);
};
Object.defineProperties($1c2f8475454ab52e$var$Module.prototype, $1c2f8475454ab52e$var$prototypeAccessors$1);
var $1c2f8475454ab52e$var$ModuleCollection = function ModuleCollection(rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.get = function get(path) {
    return path.reduce(function(module, key) {
        return module.getChild(key);
    }, this.root);
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.getNamespace = function getNamespace(path) {
    var module = this.root;
    return path.reduce(function(namespace, key) {
        module = module.getChild(key);
        return namespace + (module.namespaced ? key + '/' : '');
    }, '');
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.update = function update$1(rawRootModule) {
    $1c2f8475454ab52e$var$update([], this.root, rawRootModule);
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
    var this$1$1 = this;
    if (runtime === void 0) runtime = true;
    $1c2f8475454ab52e$var$assertRawModule(path, rawModule);
    var newModule = new $1c2f8475454ab52e$var$Module(rawModule, runtime);
    if (path.length === 0) this.root = newModule;
    else {
        var parent = this.get(path.slice(0, -1));
        parent.addChild(path[path.length - 1], newModule);
    }
    // register nested modules
    if (rawModule.modules) $1c2f8475454ab52e$var$forEachValue(rawModule.modules, function(rawChildModule, key) {
        this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.unregister = function unregister(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);
    if (!child) {
        console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
        return;
    }
    if (!child.runtime) return;
    parent.removeChild(key);
};
$1c2f8475454ab52e$var$ModuleCollection.prototype.isRegistered = function isRegistered(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    if (parent) return parent.hasChild(key);
    return false;
};
function $1c2f8475454ab52e$var$update(path, targetModule, newModule) {
    $1c2f8475454ab52e$var$assertRawModule(path, newModule);
    // update target module
    targetModule.update(newModule);
    // update nested modules
    if (newModule.modules) for(var key in newModule.modules){
        if (!targetModule.getChild(key)) {
            console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
            return;
        }
        $1c2f8475454ab52e$var$update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
}
var $1c2f8475454ab52e$var$functionAssert = {
    assert: function(value) {
        return typeof value === 'function';
    },
    expected: 'function'
};
var $1c2f8475454ab52e$var$objectAssert = {
    assert: function(value) {
        return typeof value === 'function' || typeof value === 'object' && typeof value.handler === 'function';
    },
    expected: 'function or object with "handler" function'
};
var $1c2f8475454ab52e$var$assertTypes = {
    getters: $1c2f8475454ab52e$var$functionAssert,
    mutations: $1c2f8475454ab52e$var$functionAssert,
    actions: $1c2f8475454ab52e$var$objectAssert
};
function $1c2f8475454ab52e$var$assertRawModule(path, rawModule) {
    Object.keys($1c2f8475454ab52e$var$assertTypes).forEach(function(key) {
        if (!rawModule[key]) return;
        var assertOptions = $1c2f8475454ab52e$var$assertTypes[key];
        $1c2f8475454ab52e$var$forEachValue(rawModule[key], function(value, type) {
            $1c2f8475454ab52e$var$assert(assertOptions.assert(value), $1c2f8475454ab52e$var$makeAssertionMessage(path, key, type, value, assertOptions.expected));
        });
    });
}
function $1c2f8475454ab52e$var$makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
    if (path.length > 0) buf += " in module \"" + path.join('.') + "\"";
    buf += " is " + JSON.stringify(value) + ".";
    return buf;
}
function $1c2f8475454ab52e$export$f51a9068ac82ea43(options) {
    return new $1c2f8475454ab52e$export$390f32400eaf98c9(options);
}
var $1c2f8475454ab52e$export$390f32400eaf98c9 = function Store(options) {
    var this$1$1 = this;
    if (options === void 0) options = {};
    $1c2f8475454ab52e$var$assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    $1c2f8475454ab52e$var$assert(this instanceof Store, "store must be called with the new operator.");
    var plugins = options.plugins;
    if (plugins === void 0) plugins = [];
    var strict = options.strict;
    if (strict === void 0) strict = false;
    var devtools = options.devtools;
    // store internal state
    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new $1c2f8475454ab52e$var$ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._makeLocalGettersCache = Object.create(null);
    // EffectScope instance. when registering new getters, we wrap them inside
    // EffectScope so that getters (computed) would not be destroyed on
    // component unmount.
    this._scope = null;
    this._devtools = devtools;
    // bind commit and dispatch to self
    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    this.dispatch = function boundDispatch(type, payload) {
        return dispatch.call(store, type, payload);
    };
    this.commit = function boundCommit(type, payload, options) {
        return commit.call(store, type, payload, options);
    };
    // strict mode
    this.strict = strict;
    var state = this._modules.root.state;
    // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters
    $1c2f8475454ab52e$var$installModule(this, state, [], this._modules.root);
    // initialize the store state, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)
    $1c2f8475454ab52e$var$resetStoreState(this, state);
    // apply plugins
    plugins.forEach(function(plugin) {
        return plugin(this$1$1);
    });
};
var $1c2f8475454ab52e$var$prototypeAccessors = {
    state: {
        configurable: true
    }
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.install = function install(app, injectKey) {
    app.provide(injectKey || $1c2f8475454ab52e$export$67bdc3ac2df6c0d1, this);
    app.config.globalProperties.$store = this;
    var useDevtools = this._devtools !== undefined ? this._devtools : true;
    if (useDevtools) $1c2f8475454ab52e$var$addDevtools(app, this);
};
$1c2f8475454ab52e$var$prototypeAccessors.state.get = function() {
    return this._state.data;
};
$1c2f8475454ab52e$var$prototypeAccessors.state.set = function(v) {
    $1c2f8475454ab52e$var$assert(false, "use store.replaceState() to explicit replace store state.");
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.commit = function commit(_type, _payload, _options) {
    var this$1$1 = this;
    // check object-style commit
    var ref = $1c2f8475454ab52e$var$unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;
    var mutation = {
        type: type,
        payload: payload
    };
    var entry = this._mutations[type];
    if (!entry) {
        console.error("[vuex] unknown mutation type: " + type);
        return;
    }
    this._withCommit(function() {
        entry.forEach(function commitIterator(handler) {
            handler(payload);
        });
    });
    this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function(sub) {
        return sub(mutation, this$1$1.state);
    });
    if (options && options.silent) console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.dispatch = function dispatch(_type, _payload) {
    var this$1$1 = this;
    // check object-style dispatch
    var ref = $1c2f8475454ab52e$var$unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;
    var action = {
        type: type,
        payload: payload
    };
    var entry = this._actions[type];
    if (!entry) {
        console.error("[vuex] unknown action type: " + type);
        return;
    }
    try {
        this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
        .filter(function(sub) {
            return sub.before;
        }).forEach(function(sub) {
            return sub.before(action, this$1$1.state);
        });
    } catch (e) {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
    }
    var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
        return handler(payload);
    })) : entry[0](payload);
    return new Promise(function(resolve, reject) {
        result.then(function(res) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.after;
                }).forEach(function(sub) {
                    return sub.after(action, this$1$1.state);
                });
            } catch (e) {
                console.warn("[vuex] error in after action subscribers: ");
                console.error(e);
            }
            resolve(res);
        }, function(error) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.error;
                }).forEach(function(sub) {
                    return sub.error(action, this$1$1.state, error);
                });
            } catch (e) {
                console.warn("[vuex] error in error action subscribers: ");
                console.error(e);
            }
            reject(error);
        });
    });
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.subscribe = function subscribe(fn, options) {
    return $1c2f8475454ab52e$var$genericSubscribe(fn, this._subscribers, options);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.subscribeAction = function subscribeAction(fn, options) {
    var subs = typeof fn === 'function' ? {
        before: fn
    } : fn;
    return $1c2f8475454ab52e$var$genericSubscribe(subs, this._actionSubscribers, options);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.watch = function watch$1(getter, cb, options) {
    var this$1$1 = this;
    $1c2f8475454ab52e$var$assert(typeof getter === 'function', "store.watch only accepts a function.");
    return (0, $donES.watch)(function() {
        return getter(this$1$1.state, this$1$1.getters);
    }, cb, Object.assign({}, options));
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.replaceState = function replaceState(state) {
    var this$1$1 = this;
    this._withCommit(function() {
        this$1$1._state.data = state;
    });
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.registerModule = function registerModule(path, rawModule, options) {
    if (options === void 0) options = {};
    if (typeof path === 'string') path = [
        path
    ];
    $1c2f8475454ab52e$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    $1c2f8475454ab52e$var$assert(path.length > 0, 'cannot register the root module by using registerModule.');
    this._modules.register(path, rawModule);
    $1c2f8475454ab52e$var$installModule(this, this.state, path, this._modules.get(path), options.preserveState);
    // reset store to update getters...
    $1c2f8475454ab52e$var$resetStoreState(this, this.state);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.unregisterModule = function unregisterModule(path) {
    var this$1$1 = this;
    if (typeof path === 'string') path = [
        path
    ];
    $1c2f8475454ab52e$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    this._modules.unregister(path);
    this._withCommit(function() {
        var parentState = $1c2f8475454ab52e$var$getNestedState(this$1$1.state, path.slice(0, -1));
        delete parentState[path[path.length - 1]];
    });
    $1c2f8475454ab52e$var$resetStore(this);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.hasModule = function hasModule(path) {
    if (typeof path === 'string') path = [
        path
    ];
    $1c2f8475454ab52e$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    return this._modules.isRegistered(path);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype.hotUpdate = function hotUpdate(newOptions) {
    this._modules.update(newOptions);
    $1c2f8475454ab52e$var$resetStore(this, true);
};
$1c2f8475454ab52e$export$390f32400eaf98c9.prototype._withCommit = function _withCommit(fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
};
Object.defineProperties($1c2f8475454ab52e$export$390f32400eaf98c9.prototype, $1c2f8475454ab52e$var$prototypeAccessors);
/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */ var $1c2f8475454ab52e$export$a337c713bdba072 = $1c2f8475454ab52e$var$normalizeNamespace(function(namespace, states) {
    var res = {};
    if (!$1c2f8475454ab52e$var$isValidMap(states)) console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    $1c2f8475454ab52e$var$normalizeMap(states).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedState() {
            var state = this.$store.state;
            var getters = this.$store.getters;
            if (namespace) {
                var module = $1c2f8475454ab52e$var$getModuleByNamespace(this.$store, 'mapState', namespace);
                if (!module) return;
                state = module.context.state;
                getters = module.context.getters;
            }
            return typeof val === 'function' ? val.call(this, state, getters) : state[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $1c2f8475454ab52e$export$6763e3aa6121e797 = $1c2f8475454ab52e$var$normalizeNamespace(function(namespace, mutations) {
    var res = {};
    if (!$1c2f8475454ab52e$var$isValidMap(mutations)) console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    $1c2f8475454ab52e$var$normalizeMap(mutations).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedMutation() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // Get the commit method from store
            var commit = this.$store.commit;
            if (namespace) {
                var module = $1c2f8475454ab52e$var$getModuleByNamespace(this.$store, 'mapMutations', namespace);
                if (!module) return;
                commit = module.context.commit;
            }
            return typeof val === 'function' ? val.apply(this, [
                commit
            ].concat(args)) : commit.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */ var $1c2f8475454ab52e$export$74d9085e6d5a97cb = $1c2f8475454ab52e$var$normalizeNamespace(function(namespace, getters) {
    var res = {};
    if (!$1c2f8475454ab52e$var$isValidMap(getters)) console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    $1c2f8475454ab52e$var$normalizeMap(getters).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        // The namespace has been mutated by normalizeNamespace
        val = namespace + val;
        res[key] = function mappedGetter() {
            if (namespace && !$1c2f8475454ab52e$var$getModuleByNamespace(this.$store, 'mapGetters', namespace)) return;
            if (!(val in this.$store.getters)) {
                console.error("[vuex] unknown getter: " + val);
                return;
            }
            return this.$store.getters[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $1c2f8475454ab52e$export$1d73b9b98821f6dc = $1c2f8475454ab52e$var$normalizeNamespace(function(namespace, actions) {
    var res = {};
    if (!$1c2f8475454ab52e$var$isValidMap(actions)) console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    $1c2f8475454ab52e$var$normalizeMap(actions).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedAction() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // get dispatch function from store
            var dispatch = this.$store.dispatch;
            if (namespace) {
                var module = $1c2f8475454ab52e$var$getModuleByNamespace(this.$store, 'mapActions', namespace);
                if (!module) return;
                dispatch = module.context.dispatch;
            }
            return typeof val === 'function' ? val.apply(this, [
                dispatch
            ].concat(args)) : dispatch.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */ var $1c2f8475454ab52e$export$22ea1818d73549dc = function(namespace) {
    return {
        mapState: $1c2f8475454ab52e$export$a337c713bdba072.bind(null, namespace),
        mapGetters: $1c2f8475454ab52e$export$74d9085e6d5a97cb.bind(null, namespace),
        mapMutations: $1c2f8475454ab52e$export$6763e3aa6121e797.bind(null, namespace),
        mapActions: $1c2f8475454ab52e$export$1d73b9b98821f6dc.bind(null, namespace)
    };
};
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */ function $1c2f8475454ab52e$var$normalizeMap(map) {
    if (!$1c2f8475454ab52e$var$isValidMap(map)) return [];
    return Array.isArray(map) ? map.map(function(key) {
        return {
            key: key,
            val: key
        };
    }) : Object.keys(map).map(function(key) {
        return {
            key: key,
            val: map[key]
        };
    });
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */ function $1c2f8475454ab52e$var$isValidMap(map) {
    return Array.isArray(map) || $1c2f8475454ab52e$var$isObject(map);
}
/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */ function $1c2f8475454ab52e$var$normalizeNamespace(fn) {
    return function(namespace, map) {
        if (typeof namespace !== 'string') {
            map = namespace;
            namespace = '';
        } else if (namespace.charAt(namespace.length - 1) !== '/') namespace += '/';
        return fn(namespace, map);
    };
}
/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */ function $1c2f8475454ab52e$var$getModuleByNamespace(store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];
    if (!module) console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    return module;
}
// Credits: borrowed code from fcomb/redux-logger
function $1c2f8475454ab52e$export$fe2e61603b61130d(ref) {
    if (ref === void 0) ref = {};
    var collapsed = ref.collapsed;
    if (collapsed === void 0) collapsed = true;
    var filter = ref.filter;
    if (filter === void 0) filter = function(mutation, stateBefore, stateAfter) {
        return true;
    };
    var transformer = ref.transformer;
    if (transformer === void 0) transformer = function(state) {
        return state;
    };
    var mutationTransformer = ref.mutationTransformer;
    if (mutationTransformer === void 0) mutationTransformer = function(mut) {
        return mut;
    };
    var actionFilter = ref.actionFilter;
    if (actionFilter === void 0) actionFilter = function(action, state) {
        return true;
    };
    var actionTransformer = ref.actionTransformer;
    if (actionTransformer === void 0) actionTransformer = function(act) {
        return act;
    };
    var logMutations = ref.logMutations;
    if (logMutations === void 0) logMutations = true;
    var logActions = ref.logActions;
    if (logActions === void 0) logActions = true;
    var logger = ref.logger;
    if (logger === void 0) logger = console;
    return function(store) {
        var prevState = $1c2f8475454ab52e$var$deepCopy(store.state);
        if (typeof logger === 'undefined') return;
        if (logMutations) store.subscribe(function(mutation, state) {
            var nextState = $1c2f8475454ab52e$var$deepCopy(state);
            if (filter(mutation, prevState, nextState)) {
                var formattedTime = $1c2f8475454ab52e$var$getFormattedTime();
                var formattedMutation = mutationTransformer(mutation);
                var message = "mutation " + mutation.type + formattedTime;
                $1c2f8475454ab52e$var$startMessage(logger, message, collapsed);
                logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
                logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
                logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
                $1c2f8475454ab52e$var$endMessage(logger);
            }
            prevState = nextState;
        });
        if (logActions) store.subscribeAction(function(action, state) {
            if (actionFilter(action, state)) {
                var formattedTime = $1c2f8475454ab52e$var$getFormattedTime();
                var formattedAction = actionTransformer(action);
                var message = "action " + action.type + formattedTime;
                $1c2f8475454ab52e$var$startMessage(logger, message, collapsed);
                logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
                $1c2f8475454ab52e$var$endMessage(logger);
            }
        });
    };
}
function $1c2f8475454ab52e$var$startMessage(logger, message, collapsed) {
    var startMessage = collapsed ? logger.groupCollapsed : logger.group;
    // render
    try {
        startMessage.call(logger, message);
    } catch (e) {
        logger.log(message);
    }
}
function $1c2f8475454ab52e$var$endMessage(logger) {
    try {
        logger.groupEnd();
    } catch (e) {
        logger.log("\u2014\u2014 log end \u2014\u2014");
    }
}
function $1c2f8475454ab52e$var$getFormattedTime() {
    var time = new Date();
    return " @ " + $1c2f8475454ab52e$var$pad(time.getHours(), 2) + ":" + $1c2f8475454ab52e$var$pad(time.getMinutes(), 2) + ":" + $1c2f8475454ab52e$var$pad(time.getSeconds(), 2) + "." + $1c2f8475454ab52e$var$pad(time.getMilliseconds(), 3);
}
function $1c2f8475454ab52e$var$repeat(str, times) {
    return new Array(times + 1).join(str);
}
function $1c2f8475454ab52e$var$pad(num, maxLength) {
    return $1c2f8475454ab52e$var$repeat('0', maxLength - num.toString().length) + num;
}
var $1c2f8475454ab52e$var$index = {
    version: '4.1.0',
    Store: $1c2f8475454ab52e$export$390f32400eaf98c9,
    storeKey: $1c2f8475454ab52e$export$67bdc3ac2df6c0d1,
    createStore: $1c2f8475454ab52e$export$f51a9068ac82ea43,
    useStore: $1c2f8475454ab52e$export$6ccbb43953eebf8,
    mapState: $1c2f8475454ab52e$export$a337c713bdba072,
    mapMutations: $1c2f8475454ab52e$export$6763e3aa6121e797,
    mapGetters: $1c2f8475454ab52e$export$74d9085e6d5a97cb,
    mapActions: $1c2f8475454ab52e$export$1d73b9b98821f6dc,
    createNamespacedHelpers: $1c2f8475454ab52e$export$22ea1818d73549dc,
    createLogger: $1c2f8475454ab52e$export$fe2e61603b61130d
};
var $1c2f8475454ab52e$export$2e2bcd8739ae039 = $1c2f8475454ab52e$var$index;

});
parcelRegister("4J6PC", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", function () { return $3710a9fc0a51a377$export$63b9a9bba9f20f3e; });

var $9FfTZ = parcelRequire("9FfTZ");

var $enbax = parcelRequire("enbax");

var $6ttLr = parcelRequire("6ttLr");



function $3710a9fc0a51a377$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $9FfTZ.getTarget)();
    const hook = (0, $9FfTZ.getDevtoolsGlobalHook)();
    const enableProxy = (0, $9FfTZ.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $enbax.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $6ttLr.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("9FfTZ", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", function () { return $70944731f7c6e60f$export$5a2d366b2d9f38f6; });
$parcel$export(module.exports, "getTarget", function () { return $70944731f7c6e60f$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isProxyAvailable", function () { return $70944731f7c6e60f$export$bc32a04c49ed7464; });
function $70944731f7c6e60f$export$5a2d366b2d9f38f6() {
    return $70944731f7c6e60f$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $70944731f7c6e60f$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $70944731f7c6e60f$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("enbax", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", function () { return $a76be0932f70338f$export$b1499c3bd2a3f4df; });
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", function () { return $a76be0932f70338f$export$a0897f44accbe922; });
const $a76be0932f70338f$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $a76be0932f70338f$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("6ttLr", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", function () { return $4b6c8a0e0502f420$export$5728f3776e9b2ac1; });

var $enbax = parcelRequire("enbax");

var $jX0Bj = parcelRequire("jX0Bj");
class $4b6c8a0e0502f420$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $jX0Bj.now)();
            }
        };
        if (hook) hook.on((0, $enbax.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("jX0Bj", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $e863fe4f6823252c$export$461939dd4422153; });
let $e863fe4f6823252c$var$supported;
let $e863fe4f6823252c$var$perf;
function $e863fe4f6823252c$export$70d26280bc1ca547() {
    var _a;
    if ($e863fe4f6823252c$var$supported !== undefined) return $e863fe4f6823252c$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $e863fe4f6823252c$var$supported = true;
        $e863fe4f6823252c$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $e863fe4f6823252c$var$supported = true;
        $e863fe4f6823252c$var$perf = globalThis.perf_hooks.performance;
    } else $e863fe4f6823252c$var$supported = false;
    return $e863fe4f6823252c$var$supported;
}
function $e863fe4f6823252c$export$461939dd4422153() {
    return $e863fe4f6823252c$export$70d26280bc1ca547() ? $e863fe4f6823252c$var$perf.now() : Date.now();
}

});




parcelRegister("hEYpB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb508a46706e115$export$2e2bcd8739ae039; });
let $cdb508a46706e115$var$script;




let $cdb508a46706e115$var$initialize = ()=>{
    $cdb508a46706e115$var$script = (parcelRequire("159fF"));
    if ($cdb508a46706e115$var$script.__esModule) $cdb508a46706e115$var$script = $cdb508a46706e115$var$script.default;
    $cdb508a46706e115$var$script.render = (parcelRequire("7If98")).render;
    $cdb508a46706e115$var$script.__cssModules = {};
    (parcelRequire("5Nt1F")).default($cdb508a46706e115$var$script);
    $cdb508a46706e115$var$script.__scopeId = 'data-v-b1f821';
    $cdb508a46706e115$var$script.__file = "BaseToast.vue";
};
$cdb508a46706e115$var$initialize();
var $cdb508a46706e115$export$2e2bcd8739ae039 = $cdb508a46706e115$var$script;

});
parcelRegister("159fF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0c9d6f42dfb14d8d$export$2e2bcd8739ae039; });

var $2q1Wz = parcelRequire("2q1Wz");

var $b87k7 = parcelRequire("b87k7");

var $1XF3e = parcelRequire("1XF3e");

var $bOv93 = parcelRequire("bOv93");
var $0c9d6f42dfb14d8d$export$2e2bcd8739ae039 = {
    components: {
        CircleCheckIcon: $1XF3e.default,
        ErrorIcon: $bOv93.default
    },
    data () {
        return {
            show: false,
            timeoutId: null
        };
    },
    computed: {
        ...(0, $2q1Wz.mapGetters)([
            "toast"
        ]),
        safeMessage () {
            return (0, $b87k7.toastHtml)(this.toast.message);
        }
    },
    watch: {
        toast: {
            handler (newVal) {
                if (newVal.type) setTimeout(()=>{
                    this.showToast();
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        showToast () {
            this.show = true;
            this.timeoutId = setTimeout(()=>{
                this.show = false;
            }, this.toast.duration || 10000);
        },
        closeToast () {
            clearTimeout(this.timeoutId);
            this.show = false;
        }
    }
};

});
parcelRegister("b87k7", function(module, exports) {

$parcel$export(module.exports, "toastHtml", function () { return $81a61f61ec4a2d02$export$4e976a2198541cd6; });
// Toasts can contain server error text as well as the existing account links.
// Rebuild a small set of inert elements; never insert the supplied nodes or
// carry over attributes, styles, images, handlers, or executable URLs.
function $81a61f61ec4a2d02$export$4e976a2198541cd6(message) {
    const source = document.createElement("template");
    source.innerHTML = String(message ?? "");
    const output = document.createElement("span");
    const allowedTags = new Set([
        "A",
        "B",
        "STRONG",
        "EM",
        "I",
        "BR"
    ]);
    const append = (parent, node)=>{
        if (node.nodeType === Node.TEXT_NODE) {
            parent.appendChild(document.createTextNode(node.textContent));
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (!allowedTags.has(node.tagName)) {
            parent.appendChild(document.createTextNode(node.textContent));
            return;
        }
        const element = document.createElement(node.tagName.toLowerCase());
        if (node.tagName === "A") try {
            const href = new URL(node.getAttribute("href") || "", window.location.origin);
            // These notices only need links within the app.
            if (href.origin === window.location.origin && [
                "http:",
                "https:"
            ].includes(href.protocol)) // Keep the absolute URL: a path beginning // would otherwise become
            // a protocol-relative link to a different host when inserted again.
            element.setAttribute("href", href.href);
        } catch (_) {
        // Invalid links remain readable text.
        }
        for (const child of node.childNodes)append(element, child);
        parent.appendChild(element);
    };
    for (const node of source.content.childNodes)append(output, node);
    return output.innerHTML;
}

});

parcelRegister("1XF3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16db250e4e24dc4b$export$2e2bcd8739ae039; });
let $16db250e4e24dc4b$var$script;


let $16db250e4e24dc4b$var$initialize = ()=>{
    $16db250e4e24dc4b$var$script = {};
    $16db250e4e24dc4b$var$script.render = (parcelRequire("8tGE5")).render;
    (parcelRequire("lMimh")).default($16db250e4e24dc4b$var$script);
    $16db250e4e24dc4b$var$script.__scopeId = 'data-v-195614';
    $16db250e4e24dc4b$var$script.__file = "CircleCheckIcon.vue";
};
$16db250e4e24dc4b$var$initialize();
var $16db250e4e24dc4b$export$2e2bcd8739ae039 = $16db250e4e24dc4b$var$script;

});
parcelRegister("8tGE5", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $62c21ca92f012d29$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
const $62c21ca92f012d29$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none"
};
function $62c21ca92f012d29$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("svg", $62c21ca92f012d29$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $iZX2P.createElementVNode)("circle", {
                cx: "8.5",
                cy: "8.5",
                r: "8",
                fill: "#3E8635",
                stroke: "#3E8635"
            }, null, -1),
            (0, $iZX2P.createElementVNode)("path", {
                d: "M12 6.5L7.5 11L5 8.5",
                stroke: "white",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }, null, -1)
        ])
    ]);
}

});

parcelRegister("lMimh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdac5247d436ee04$export$2e2bcd8739ae039; });
let $fdac5247d436ee04$var$NOOP = ()=>{};
var $fdac5247d436ee04$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bOv93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $899c85f55aec7571$export$2e2bcd8739ae039; });
let $899c85f55aec7571$var$script;


let $899c85f55aec7571$var$initialize = ()=>{
    $899c85f55aec7571$var$script = {};
    $899c85f55aec7571$var$script.render = (parcelRequire("8XfJQ")).render;
    (parcelRequire("9oMVa")).default($899c85f55aec7571$var$script);
    $899c85f55aec7571$var$script.__scopeId = 'data-v-1f1b70';
    $899c85f55aec7571$var$script.__file = "ErrorIcon.vue";
};
$899c85f55aec7571$var$initialize();
var $899c85f55aec7571$export$2e2bcd8739ae039 = $899c85f55aec7571$var$script;

});
parcelRegister("8XfJQ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $68500ac21c6dab19$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
const $68500ac21c6dab19$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-exclamation-diamond-fill",
    viewBox: "0 0 16 16"
};
function $68500ac21c6dab19$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("svg", $68500ac21c6dab19$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $iZX2P.createElementVNode)("path", {
                d: "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
            }, null, -1)
        ])
    ]);
}

});

parcelRegister("9oMVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c411c4bbe5f44b$export$2e2bcd8739ae039; });
let $01c411c4bbe5f44b$var$NOOP = ()=>{};
var $01c411c4bbe5f44b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("7If98", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $59d86433f6774b91$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $6XHer = parcelRequire("6XHer");
var $aRSfV = parcelRequire("aRSfV");
const $59d86433f6774b91$var$_hoisted_1 = [
    "aria-label"
];
const $59d86433f6774b91$var$_hoisted_2 = [
    "innerHTML"
];
function $59d86433f6774b91$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CircleCheckIcon = (0, $iZX2P.resolveComponent)("CircleCheckIcon");
    const _component_ErrorIcon = (0, $iZX2P.resolveComponent)("ErrorIcon");
    const _directive_clicky = (0, $iZX2P.resolveDirective)("clicky");
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)((0, $aRSfV.Transition), {
        name: "bounce"
    }, {
        default: (0, $iZX2P.withCtx)(()=>[
                $data.show ? (0, $iZX2P.withDirectives)(((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("div", {
                    key: 0,
                    class: (0, $6XHer.normalizeClass)([
                        "toast show d-flex align-items-start gap-2",
                        `${_ctx.toast.type}`
                    ]),
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.closeToast && $options.closeToast(...args)),
                    role: "alert",
                    "aria-live": "polite",
                    "aria-label": `${_ctx.toast.type} notification: ${_ctx.toast.message}`
                }, [
                    _ctx.toast.type === 'success' ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)(_component_CircleCheckIcon, {
                        key: 0,
                        style: {
                            "width": "20px",
                            "height": "20px",
                            "flex-shrink": "0"
                        }
                    })) : ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)(_component_ErrorIcon, {
                        key: 1,
                        style: {
                            "width": "20px",
                            "height": "20px",
                            "flex-shrink": "0"
                        }
                    })),
                    (0, $iZX2P.createElementVNode)("span", {
                        innerHTML: $options.safeMessage
                    }, null, 8, $59d86433f6774b91$var$_hoisted_2)
                ], 10, $59d86433f6774b91$var$_hoisted_1)), [
                    [
                        _directive_clicky
                    ]
                ]) : (0, $iZX2P.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("5Nt1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43880b4d7dddbd7a$export$2e2bcd8739ae039; });
let $43880b4d7dddbd7a$var$NOOP = ()=>{};
var $43880b4d7dddbd7a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1nFzo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10182f5599f62e67$export$2e2bcd8739ae039; });
let $10182f5599f62e67$var$script;




let $10182f5599f62e67$var$initialize = ()=>{
    $10182f5599f62e67$var$script = (parcelRequire("bzsIn"));
    if ($10182f5599f62e67$var$script.__esModule) $10182f5599f62e67$var$script = $10182f5599f62e67$var$script.default;
    $10182f5599f62e67$var$script.render = (parcelRequire("052LD")).render;
    $10182f5599f62e67$var$script.__cssModules = {};
    (parcelRequire("1vRGr")).default($10182f5599f62e67$var$script);
    $10182f5599f62e67$var$script.__scopeId = 'data-v-7e0873';
    $10182f5599f62e67$var$script.__file = "AdminBanner.vue";
};
$10182f5599f62e67$var$initialize();
var $10182f5599f62e67$export$2e2bcd8739ae039 = $10182f5599f62e67$var$script;

});
parcelRegister("bzsIn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $86c93cb8b3252f8a$export$2e2bcd8739ae039; });

var $2q1Wz = parcelRequire("2q1Wz");

var $803xA = parcelRequire("803xA");

var $eLtO3 = parcelRequire("eLtO3");

var $cOeUb = parcelRequire("cOeUb");
var $86c93cb8b3252f8a$export$2e2bcd8739ae039 = {
    name: "AdminBanner",
    components: {
        CloseIcon: $803xA.default,
        BaseBadge: $eLtO3.default,
        BaseSelectInput: $cOeUb.default
    },
    data () {
        return {
            selectedUserId: null,
            userOptions: []
        };
    },
    computed: {
        ...(0, $2q1Wz.mapGetters)("sessions", [
            "users",
            "user",
            "trueUser",
            "isAdmin",
            "isImpersonating"
        ]),
        ...(0, $2q1Wz.mapGetters)([
            "adminBannerHidden"
        ]),
        environment () {
            return "production";
        },
        isSuperAdmin () {
            return this.trueUser && (this.trueUser.role === "super_admin" || this.trueUser.role_type === "super_admin");
        },
        defaultUserOptions () {
            const options = [
                {
                    label: this.user.email,
                    value: this.user.id
                }
            ];
            if (this.trueUser?.id !== this.user?.id) options.push({
                label: this.trueUser?.email,
                value: this.trueUser?.id
            });
            return options;
        }
    },
    methods: {
        loadUsers (query) {
            // console.log(query);
            if (query.length > 2) this.$store.dispatch("sessions/loadUsers", {
                query: query
            }).then(()=>{
                this.userOptions = this.users.map((user)=>({
                        label: user.email,
                        value: user.id
                    }));
            });
            else this.userOptions = this.defaultUserOptions;
        },
        impersonateUser () {
            this.$store.dispatch("sessions/impersonateUser", this.selectedUserId).then(()=>{
                window.location.href = "/";
            });
        },
        goToDashboard () {
            window.location.href = "/admin";
        },
        hideBanner () {
            this.$store.dispatch("setAdminBannerHidden", true);
        }
    },
    mounted () {
        this.selectedUserId = this.user?.id;
        this.userOptions = this.defaultUserOptions;
    }
};

});
parcelRegister("803xA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3111e8dc1122f8$export$2e2bcd8739ae039; });
let $5d3111e8dc1122f8$var$script;


let $5d3111e8dc1122f8$var$initialize = ()=>{
    $5d3111e8dc1122f8$var$script = {};
    $5d3111e8dc1122f8$var$script.render = (parcelRequire("bU3nq")).render;
    (parcelRequire("2DgAH")).default($5d3111e8dc1122f8$var$script);
    $5d3111e8dc1122f8$var$script.__scopeId = 'data-v-ade473';
    $5d3111e8dc1122f8$var$script.__file = "CloseIcon.vue";
};
$5d3111e8dc1122f8$var$initialize();
var $5d3111e8dc1122f8$export$2e2bcd8739ae039 = $5d3111e8dc1122f8$var$script;

});
parcelRegister("bU3nq", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8aa78b39a13cf070$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
const $8aa78b39a13cf070$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none"
};
function $8aa78b39a13cf070$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("svg", $8aa78b39a13cf070$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $iZX2P.createElementVNode)("path", {
                d: "M16.6667 8.33333L8.33333 16.6667M8.33334 8.33333L16.6667 16.6667M21.875 12.5C21.875 17.6777 17.6777 21.875 12.5 21.875C7.32233 21.875 3.125 17.6777 3.125 12.5C3.125 7.32233 7.32233 3.125 12.5 3.125C17.6777 3.125 21.875 7.32233 21.875 12.5Z",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }, null, -1)
        ])
    ]);
}

});

parcelRegister("2DgAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eac17e1b79e9ee2$export$2e2bcd8739ae039; });
let $1eac17e1b79e9ee2$var$NOOP = ()=>{};
var $1eac17e1b79e9ee2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eLtO3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abfc9367755461c8$export$2e2bcd8739ae039; });
let $abfc9367755461c8$var$script;




let $abfc9367755461c8$var$initialize = ()=>{
    $abfc9367755461c8$var$script = (parcelRequire("bVJVa"));
    if ($abfc9367755461c8$var$script.__esModule) $abfc9367755461c8$var$script = $abfc9367755461c8$var$script.default;
    $abfc9367755461c8$var$script.render = (parcelRequire("8wfj8")).render;
    $abfc9367755461c8$var$script.__cssModules = {};
    (parcelRequire("dvUeE")).default($abfc9367755461c8$var$script);
    $abfc9367755461c8$var$script.__scopeId = 'data-v-0e3313';
    $abfc9367755461c8$var$script.__file = "BaseBadge.vue";
};
$abfc9367755461c8$var$initialize();
var $abfc9367755461c8$export$2e2bcd8739ae039 = $abfc9367755461c8$var$script;

});
parcelRegister("bVJVa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8af8a38d4962371b$export$2e2bcd8739ae039; });
var $8af8a38d4962371b$export$2e2bcd8739ae039 = {
    name: "BaseBadge",
    props: {
        label: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: "var(--color-text-primary)"
        }
    }
};

});

parcelRegister("8wfj8", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $633d2fa8e6b8ad72$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $6XHer = parcelRequire("6XHer");
function $633d2fa8e6b8ad72$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("span", {
        class: "badge",
        style: (0, $6XHer.normalizeStyle)(`border: 2px solid ${$props.color}`)
    }, (0, $6XHer.toDisplayString)($props.label), 5);
}

});

parcelRegister("dvUeE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d69cac2e97bad17$export$2e2bcd8739ae039; });
let $9d69cac2e97bad17$var$NOOP = ()=>{};
var $9d69cac2e97bad17$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cOeUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9535b76e8d30c9d5$export$2e2bcd8739ae039; });
let $9535b76e8d30c9d5$var$script;




let $9535b76e8d30c9d5$var$initialize = ()=>{
    $9535b76e8d30c9d5$var$script = (parcelRequire("5KMHn"));
    if ($9535b76e8d30c9d5$var$script.__esModule) $9535b76e8d30c9d5$var$script = $9535b76e8d30c9d5$var$script.default;
    $9535b76e8d30c9d5$var$script.render = (parcelRequire("2gnby")).render;
    $9535b76e8d30c9d5$var$script.__cssModules = {};
    (parcelRequire("9R2Dl")).default($9535b76e8d30c9d5$var$script);
    $9535b76e8d30c9d5$var$script.__scopeId = 'data-v-5f1ed1';
    $9535b76e8d30c9d5$var$script.__file = "BaseSelectInput.vue";
};
$9535b76e8d30c9d5$var$initialize();
var $9535b76e8d30c9d5$export$2e2bcd8739ae039 = $9535b76e8d30c9d5$var$script;

});
parcelRegister("5KMHn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $43070623a2ad0f33$export$2e2bcd8739ae039; });

var $lxWMS = parcelRequire("lxWMS");

var $brnsE = parcelRequire("brnsE");

var $hzoNF = parcelRequire("hzoNF");
var $43070623a2ad0f33$export$2e2bcd8739ae039 = {
    name: "BaseSelectInput",
    components: {
        CaretDownIcon: $lxWMS.default
    },
    emits: [
        "update:modelValue",
        "addOption",
        "input",
        "search"
    ],
    props: {
        modelValue: {
            type: [
                Number,
                String
            ],
            default: null
        },
        placeholder: String,
        label: String,
        id: {
            type: String,
            default: ()=>{
                return "base-select-input-" + Math.random().toString(36).substring(2, 15);
            }
        },
        type: {
            type: String,
            default: "text"
        },
        required: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: "off"
        },
        options: {
            type: Array,
            default: ()=>[]
        },
        addOption: {
            type: [
                Object,
                Array
            ],
            default: null
        },
        allowCustom: {
            type: Boolean,
            default: false
        },
        searchable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            localModelValue: this.modelValue,
            dropdownInstance: null,
            isInvalid: false,
            searchQuery: "",
            debouncedSearch: null,
            highlightedIndex: -1
        };
    },
    computed: {
        selectedLabel () {
            const selected = this.options.find((option)=>option.value == this.localModelValue);
            return selected ? selected.label : this.allowCustom ? this.localModelValue : null;
        },
        normalizedAddOptions () {
            if (!this.addOption) return [];
            return Array.isArray(this.addOption) ? this.addOption : [
                this.addOption
            ];
        },
        filteredOptions () {
            if (!this.searchQuery) return this.options;
            const query = this.searchQuery.toLowerCase();
            return this.options.filter((option)=>option.label.toLowerCase().includes(query) || String(option.value ?? "").toLowerCase().includes(query));
        },
        dropdownItems () {
            const optionItems = this.filteredOptions.map((option)=>({
                    ...option,
                    type: "option"
                }));
            const query = this.searchQuery.toLowerCase();
            this.normalizedAddOptions.forEach((opt)=>{
                if (!query || opt.label.toLowerCase().includes(query)) optionItems.push({
                    ...opt,
                    type: "add"
                });
            });
            const customValue = this.searchQuery.trim();
            const exactMatch = this.options.some((option)=>option.label.toLowerCase() === customValue.toLowerCase() || String(option.value).toLowerCase() === customValue.toLowerCase());
            if (this.allowCustom && customValue && !exactMatch) optionItems.push({
                type: "custom",
                value: customValue,
                label: `Use \u{201C}${customValue}\u{201D}`
            });
            return optionItems;
        }
    },
    methods: {
        handleInvalid (event) {
            if (!this.required) return; // Only handle validation if required
            event.preventDefault();
            this.isInvalid = true;
            // Focus the dropdown button
            this.$nextTick(()=>{
                if (this.$refs.dropdownButton) this.$refs.dropdownButton.focus();
            });
        },
        selectOption (value) {
            this.localModelValue = value;
            this.isInvalid = false;
            this.searchQuery = ""; // Clear search when option is selected
            this.highlightedIndex = -1;
            this.$emit("update:modelValue", value);
            if (this.dropdownInstance) this.dropdownInstance.hide();
            this.$emit("input", value);
            this.$nextTick(()=>{
                const hiddenSelect = this.$el.querySelector(`#${this.id}-hidden`);
                if (hiddenSelect) hiddenSelect.dispatchEvent(new Event("change"));
            });
        },
        initDropdown () {
            const dropdownEl = this.$el.querySelector(".dropdown-toggle");
            if (dropdownEl) this.dropdownInstance = new (0, $brnsE.Dropdown)(dropdownEl);
        },
        emitAddOption (value) {
            this.$emit("addOption", value);
        },
        handleItemSelection (item) {
            if (item.type === "add") {
                this.highlightedIndex = -1;
                if (this.dropdownInstance) this.dropdownInstance.hide();
                this.emitAddOption(item.value);
                return;
            }
            this.selectOption(item.value);
        },
        setInitialHighlight () {
            if (!this.dropdownItems.length) {
                this.highlightedIndex = -1;
                return;
            }
            const selectedIndex = this.dropdownItems.findIndex((item)=>item.value == this.localModelValue);
            this.highlightedIndex = selectedIndex >= 0 ? selectedIndex : 0;
            this.$nextTick(()=>{
                this.scrollHighlightedIntoView();
            });
        },
        moveHighlight (step) {
            if (!this.dropdownItems.length) {
                this.highlightedIndex = -1;
                return;
            }
            if (this.highlightedIndex === -1) this.highlightedIndex = step > 0 ? 0 : this.dropdownItems.length - 1;
            else this.highlightedIndex = (this.highlightedIndex + step + this.dropdownItems.length) % this.dropdownItems.length;
            this.$nextTick(()=>{
                this.scrollHighlightedIntoView();
            });
        },
        selectHighlightedOption () {
            if (this.highlightedIndex < 0) return;
            const highlightedItem = this.dropdownItems[this.highlightedIndex];
            if (!highlightedItem) return;
            this.handleItemSelection(highlightedItem);
            this.$nextTick(()=>{
                this.focusDropdownButton();
            });
        },
        scrollHighlightedIntoView () {
            const dropdownItems = this.$el.querySelectorAll(".dropdown-item");
            const highlightedEl = dropdownItems[this.highlightedIndex];
            if (highlightedEl) highlightedEl.scrollIntoView({
                block: "nearest"
            });
        },
        focusDropdownButton () {
            if (this.$refs.dropdownButton) this.$refs.dropdownButton.focus();
        },
        isPrintableKey (event) {
            return event.key && event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;
        },
        handleTriggerKeydown (event) {
            if (!this.searchable || !this.isPrintableKey(event)) return;
            event.preventDefault();
            if (this.dropdownInstance) this.dropdownInstance.show();
            this.$nextTick(()=>{
                this.setInitialHighlight();
                if (this.$refs.searchInput) {
                    this.$refs.searchInput.focus();
                    this.searchQuery = `${this.searchQuery}${event.key}`;
                }
            });
        },
        handleDropdownOpen () {
            this.$nextTick(()=>{
                this.setInitialHighlight();
                if (this.searchable && this.$refs.searchInput) this.$refs.searchInput.focus();
            });
        }
    },
    watch: {
        modelValue (newVal) {
            this.localModelValue = newVal;
        },
        searchQuery () {
            this.setInitialHighlight();
            this.debouncedSearch();
        }
    },
    mounted () {
        this.initDropdown();
        this.debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($hzoNF)))(()=>{
            this.$emit("search", this.searchQuery);
        }, 500);
    },
    updated () {
        // Re-initialize dropdown if needed
        if (!this.dropdownInstance) this.initDropdown();
    },
    beforeUnmount () {
        // Clean up dropdown instance
        if (this.dropdownInstance) this.dropdownInstance = null;
    }
};

});
parcelRegister("lxWMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fafa47faca5a5cf5$export$2e2bcd8739ae039; });
let $fafa47faca5a5cf5$var$script;


let $fafa47faca5a5cf5$var$initialize = ()=>{
    $fafa47faca5a5cf5$var$script = {};
    $fafa47faca5a5cf5$var$script.render = (parcelRequire("a3diM")).render;
    (parcelRequire("cHPrz")).default($fafa47faca5a5cf5$var$script);
    $fafa47faca5a5cf5$var$script.__scopeId = 'data-v-a405db';
    $fafa47faca5a5cf5$var$script.__file = "CaretDownIcon.vue";
};
$fafa47faca5a5cf5$var$initialize();
var $fafa47faca5a5cf5$export$2e2bcd8739ae039 = $fafa47faca5a5cf5$var$script;

});
parcelRegister("a3diM", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $751480a7891e6575$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
const $751480a7891e6575$var$_hoisted_1 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "6",
    viewBox: "0 0 8 4",
    fill: "none"
};
function $751480a7891e6575$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("svg", $751480a7891e6575$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $iZX2P.createElementVNode)("path", {
                d: "M4 4L7.4641 0.25H0.535898L4 4Z",
                fill: "#919191"
            }, null, -1)
        ])
    ]);
}

});

parcelRegister("cHPrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $940167da7e2cf8b5$export$2e2bcd8739ae039; });
let $940167da7e2cf8b5$var$NOOP = ()=>{};
var $940167da7e2cf8b5$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("brnsE", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $85446a31c46e5d8b$export$caec2af78bcc877f; });
$parcel$export(module.exports, "Button", function () { return $85446a31c46e5d8b$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "Carousel", function () { return $85446a31c46e5d8b$export$144901db2ea8e967; });
$parcel$export(module.exports, "Collapse", function () { return $85446a31c46e5d8b$export$78768a9af065a7b; });
$parcel$export(module.exports, "Dropdown", function () { return $85446a31c46e5d8b$export$931cbfb6bfb85fc; });
$parcel$export(module.exports, "Modal", function () { return $85446a31c46e5d8b$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "Offcanvas", function () { return $85446a31c46e5d8b$export$591ca0244c9dfcd4; });
$parcel$export(module.exports, "Tooltip", function () { return $85446a31c46e5d8b$export$28c660c63b792dea; });
$parcel$export(module.exports, "Popover", function () { return $85446a31c46e5d8b$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "ScrollSpy", function () { return $85446a31c46e5d8b$export$a6472a5298a374be; });
$parcel$export(module.exports, "Tab", function () { return $85446a31c46e5d8b$export$3e41faf802a29e71; });
$parcel$export(module.exports, "Toast", function () { return $85446a31c46e5d8b$export$8d8dc7d5f743331b; });
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $e4h34 = parcelRequire("e4h34");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$elementMap = new Map();
const $85446a31c46e5d8b$var$Data = {
    set (element, key, instance) {
        if (!$85446a31c46e5d8b$var$elementMap.has(element)) $85446a31c46e5d8b$var$elementMap.set(element, new Map());
        const instanceMap = $85446a31c46e5d8b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($85446a31c46e5d8b$var$elementMap.has(element)) return $85446a31c46e5d8b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$85446a31c46e5d8b$var$elementMap.has(element)) return;
        const instanceMap = $85446a31c46e5d8b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $85446a31c46e5d8b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$MAX_UID = 1000000;
const $85446a31c46e5d8b$var$MILLISECONDS_MULTIPLIER = 1000;
const $85446a31c46e5d8b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $85446a31c46e5d8b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $85446a31c46e5d8b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $85446a31c46e5d8b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $85446a31c46e5d8b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $85446a31c46e5d8b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $85446a31c46e5d8b$var$MILLISECONDS_MULTIPLIER;
};
const $85446a31c46e5d8b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($85446a31c46e5d8b$var$TRANSITION_END));
};
const $85446a31c46e5d8b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $85446a31c46e5d8b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($85446a31c46e5d8b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($85446a31c46e5d8b$var$parseSelector(object));
    return null;
};
const $85446a31c46e5d8b$var$isVisible = (element)=>{
    if (!$85446a31c46e5d8b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $85446a31c46e5d8b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $85446a31c46e5d8b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $85446a31c46e5d8b$var$findShadowRoot(element.parentNode);
};
const $85446a31c46e5d8b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $85446a31c46e5d8b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $85446a31c46e5d8b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $85446a31c46e5d8b$var$DOMContentLoadedCallbacks = [];
const $85446a31c46e5d8b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$85446a31c46e5d8b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $85446a31c46e5d8b$var$DOMContentLoadedCallbacks)callback();
        });
        $85446a31c46e5d8b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $85446a31c46e5d8b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $85446a31c46e5d8b$var$defineJQueryPlugin = (plugin)=>{
    $85446a31c46e5d8b$var$onDOMContentLoaded(()=>{
        const $ = $85446a31c46e5d8b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $85446a31c46e5d8b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $85446a31c46e5d8b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $85446a31c46e5d8b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $85446a31c46e5d8b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($85446a31c46e5d8b$var$TRANSITION_END, handler);
        $85446a31c46e5d8b$var$execute(callback);
    };
    transitionElement.addEventListener($85446a31c46e5d8b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $85446a31c46e5d8b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $85446a31c46e5d8b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $85446a31c46e5d8b$var$stripNameRegex = /\..*/;
const $85446a31c46e5d8b$var$stripUidRegex = /::\d+$/;
const $85446a31c46e5d8b$var$eventRegistry = {}; // Events storage
let $85446a31c46e5d8b$var$uidEvent = 1;
const $85446a31c46e5d8b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $85446a31c46e5d8b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $85446a31c46e5d8b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$85446a31c46e5d8b$var$uidEvent++}` || element.uidEvent || $85446a31c46e5d8b$var$uidEvent++;
}
function $85446a31c46e5d8b$var$getElementEvents(element) {
    const uid = $85446a31c46e5d8b$var$makeEventUid(element);
    element.uidEvent = uid;
    $85446a31c46e5d8b$var$eventRegistry[uid] = $85446a31c46e5d8b$var$eventRegistry[uid] || {};
    return $85446a31c46e5d8b$var$eventRegistry[uid];
}
function $85446a31c46e5d8b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $85446a31c46e5d8b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $85446a31c46e5d8b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $85446a31c46e5d8b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $85446a31c46e5d8b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $85446a31c46e5d8b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $85446a31c46e5d8b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $85446a31c46e5d8b$var$getTypeEvent(originalTypeEvent);
    if (!$85446a31c46e5d8b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $85446a31c46e5d8b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $85446a31c46e5d8b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $85446a31c46e5d8b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $85446a31c46e5d8b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $85446a31c46e5d8b$var$makeEventUid(callable, originalTypeEvent.replace($85446a31c46e5d8b$var$namespaceRegex, ''));
    const fn = isDelegated ? $85446a31c46e5d8b$var$bootstrapDelegationHandler(element, handler, callable) : $85446a31c46e5d8b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $85446a31c46e5d8b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $85446a31c46e5d8b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $85446a31c46e5d8b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($85446a31c46e5d8b$var$stripNameRegex, '');
    return $85446a31c46e5d8b$var$customEvents[event] || event;
}
const $85446a31c46e5d8b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $85446a31c46e5d8b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $85446a31c46e5d8b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $85446a31c46e5d8b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $85446a31c46e5d8b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$85446a31c46e5d8b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($85446a31c46e5d8b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $85446a31c46e5d8b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $85446a31c46e5d8b$var$getjQuery();
        const typeEvent = $85446a31c46e5d8b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $85446a31c46e5d8b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $85446a31c46e5d8b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $85446a31c46e5d8b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $85446a31c46e5d8b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $85446a31c46e5d8b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $85446a31c46e5d8b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $85446a31c46e5d8b$var$normalizeData(element.getAttribute(`data-bs-${$85446a31c46e5d8b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $85446a31c46e5d8b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $85446a31c46e5d8b$var$isElement(element) ? $85446a31c46e5d8b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$85446a31c46e5d8b$var$isElement(element) ? $85446a31c46e5d8b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $85446a31c46e5d8b$var$isElement(value) ? 'element' : $85446a31c46e5d8b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$BaseComponent extends $85446a31c46e5d8b$var$Config {
    constructor(element, config){
        super();
        element = $85446a31c46e5d8b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $85446a31c46e5d8b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $85446a31c46e5d8b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $85446a31c46e5d8b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $85446a31c46e5d8b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $85446a31c46e5d8b$var$Data.get($85446a31c46e5d8b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $85446a31c46e5d8b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$85446a31c46e5d8b$var$parseSelector(sel)).join(',') : null;
};
const $85446a31c46e5d8b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$85446a31c46e5d8b$var$isDisabled(el) && $85446a31c46e5d8b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        if (selector) return $85446a31c46e5d8b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        return selector ? $85446a31c46e5d8b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $85446a31c46e5d8b$var$getSelector(element);
        return selector ? $85446a31c46e5d8b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $85446a31c46e5d8b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $85446a31c46e5d8b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($85446a31c46e5d8b$var$isDisabled(this)) return;
        const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$f = 'alert';
const $85446a31c46e5d8b$var$DATA_KEY$a = 'bs.alert';
const $85446a31c46e5d8b$var$EVENT_KEY$b = `.${$85446a31c46e5d8b$var$DATA_KEY$a}`;
const $85446a31c46e5d8b$var$EVENT_CLOSE = `close${$85446a31c46e5d8b$var$EVENT_KEY$b}`;
const $85446a31c46e5d8b$var$EVENT_CLOSED = `closed${$85446a31c46e5d8b$var$EVENT_KEY$b}`;
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$5 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$caec2af78bcc877f extends $85446a31c46e5d8b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$e = 'button';
const $85446a31c46e5d8b$var$DATA_KEY$9 = 'bs.button';
const $85446a31c46e5d8b$var$EVENT_KEY$a = `.${$85446a31c46e5d8b$var$DATA_KEY$9}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$6 = '.data-api';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$6 = `click${$85446a31c46e5d8b$var$EVENT_KEY$a}${$85446a31c46e5d8b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$353f5b6fc5456de1 extends $85446a31c46e5d8b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$6, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $85446a31c46e5d8b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$d = 'swipe';
const $85446a31c46e5d8b$var$EVENT_KEY$9 = '.bs.swipe';
const $85446a31c46e5d8b$var$EVENT_TOUCHSTART = `touchstart${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_TOUCHMOVE = `touchmove${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_TOUCHEND = `touchend${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_POINTERDOWN = `pointerdown${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$EVENT_POINTERUP = `pointerup${$85446a31c46e5d8b$var$EVENT_KEY$9}`;
const $85446a31c46e5d8b$var$POINTER_TYPE_TOUCH = 'touch';
const $85446a31c46e5d8b$var$POINTER_TYPE_PEN = 'pen';
const $85446a31c46e5d8b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $85446a31c46e5d8b$var$SWIPE_THRESHOLD = 40;
const $85446a31c46e5d8b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $85446a31c46e5d8b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$Swipe extends $85446a31c46e5d8b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$85446a31c46e5d8b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$c;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$c;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$d;
    }
    // Public
    dispose() {
        $85446a31c46e5d8b$var$EventHandler.off(this._element, $85446a31c46e5d8b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $85446a31c46e5d8b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $85446a31c46e5d8b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $85446a31c46e5d8b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $85446a31c46e5d8b$var$POINTER_TYPE_PEN || event.pointerType === $85446a31c46e5d8b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$c = 'carousel';
const $85446a31c46e5d8b$var$DATA_KEY$8 = 'bs.carousel';
const $85446a31c46e5d8b$var$EVENT_KEY$8 = `.${$85446a31c46e5d8b$var$DATA_KEY$8}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$5 = '.data-api';
const $85446a31c46e5d8b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $85446a31c46e5d8b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $85446a31c46e5d8b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $85446a31c46e5d8b$var$ORDER_NEXT = 'next';
const $85446a31c46e5d8b$var$ORDER_PREV = 'prev';
const $85446a31c46e5d8b$var$DIRECTION_LEFT = 'left';
const $85446a31c46e5d8b$var$DIRECTION_RIGHT = 'right';
const $85446a31c46e5d8b$var$EVENT_SLIDE = `slide${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_SLID = `slid${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN$1 = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEENTER$1 = `mouseenter${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_DRAG_START = `dragstart${$85446a31c46e5d8b$var$EVENT_KEY$8}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$3 = `load${$85446a31c46e5d8b$var$EVENT_KEY$8}${$85446a31c46e5d8b$var$DATA_API_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$5 = `click${$85446a31c46e5d8b$var$EVENT_KEY$8}${$85446a31c46e5d8b$var$DATA_API_KEY$5}`;
const $85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $85446a31c46e5d8b$var$CLASS_NAME_SLIDE = 'slide';
const $85446a31c46e5d8b$var$CLASS_NAME_END = 'carousel-item-end';
const $85446a31c46e5d8b$var$CLASS_NAME_START = 'carousel-item-start';
const $85446a31c46e5d8b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $85446a31c46e5d8b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVE = '.active';
const $85446a31c46e5d8b$var$SELECTOR_ITEM = '.carousel-item';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVE_ITEM = $85446a31c46e5d8b$var$SELECTOR_ACTIVE + $85446a31c46e5d8b$var$SELECTOR_ITEM;
const $85446a31c46e5d8b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $85446a31c46e5d8b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $85446a31c46e5d8b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $85446a31c46e5d8b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $85446a31c46e5d8b$var$KEY_TO_DIRECTION = {
    [$85446a31c46e5d8b$var$ARROW_LEFT_KEY$1]: $85446a31c46e5d8b$var$DIRECTION_RIGHT,
    [$85446a31c46e5d8b$var$ARROW_RIGHT_KEY$1]: $85446a31c46e5d8b$var$DIRECTION_LEFT
};
const $85446a31c46e5d8b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $85446a31c46e5d8b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$144901db2ea8e967 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$b;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$b;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($85446a31c46e5d8b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $85446a31c46e5d8b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($85446a31c46e5d8b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $85446a31c46e5d8b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $85446a31c46e5d8b$var$ORDER_NEXT : $85446a31c46e5d8b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $85446a31c46e5d8b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_ITEM_IMG, this._element))$85446a31c46e5d8b$var$EventHandler.on(img, $85446a31c46e5d8b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $85446a31c46e5d8b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($85446a31c46e5d8b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($85446a31c46e5d8b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $85446a31c46e5d8b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $85446a31c46e5d8b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $85446a31c46e5d8b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $85446a31c46e5d8b$var$ORDER_NEXT;
        const nextElement = element || $85446a31c46e5d8b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $85446a31c46e5d8b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($85446a31c46e5d8b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $85446a31c46e5d8b$var$CLASS_NAME_START : $85446a31c46e5d8b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $85446a31c46e5d8b$var$CLASS_NAME_NEXT : $85446a31c46e5d8b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $85446a31c46e5d8b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($85446a31c46e5d8b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($85446a31c46e5d8b$var$isRTL()) return direction === $85446a31c46e5d8b$var$DIRECTION_LEFT ? $85446a31c46e5d8b$var$ORDER_PREV : $85446a31c46e5d8b$var$ORDER_NEXT;
        return direction === $85446a31c46e5d8b$var$DIRECTION_LEFT ? $85446a31c46e5d8b$var$ORDER_NEXT : $85446a31c46e5d8b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($85446a31c46e5d8b$var$isRTL()) return order === $85446a31c46e5d8b$var$ORDER_PREV ? $85446a31c46e5d8b$var$DIRECTION_LEFT : $85446a31c46e5d8b$var$DIRECTION_RIGHT;
        return order === $85446a31c46e5d8b$var$ORDER_PREV ? $85446a31c46e5d8b$var$DIRECTION_RIGHT : $85446a31c46e5d8b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$5, $85446a31c46e5d8b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($85446a31c46e5d8b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$85446a31c46e5d8b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$b = 'collapse';
const $85446a31c46e5d8b$var$DATA_KEY$7 = 'bs.collapse';
const $85446a31c46e5d8b$var$EVENT_KEY$7 = `.${$85446a31c46e5d8b$var$DATA_KEY$7}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$4 = '.data-api';
const $85446a31c46e5d8b$var$EVENT_SHOW$6 = `show${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$6 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$6 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$6 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$7}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$4 = `click${$85446a31c46e5d8b$var$EVENT_KEY$7}${$85446a31c46e5d8b$var$DATA_API_KEY$4}`;
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $85446a31c46e5d8b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $85446a31c46e5d8b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE} .${$85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE}`;
const $85446a31c46e5d8b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $85446a31c46e5d8b$var$WIDTH = 'width';
const $85446a31c46e5d8b$var$HEIGHT = 'height';
const $85446a31c46e5d8b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $85446a31c46e5d8b$var$Default$a = {
    parent: null,
    toggle: true
};
const $85446a31c46e5d8b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$78768a9af065a7b extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $85446a31c46e5d8b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $85446a31c46e5d8b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$a;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$a;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($85446a31c46e5d8b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSE);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $85446a31c46e5d8b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_HORIZONTAL) ? $85446a31c46e5d8b$var$WIDTH : $85446a31c46e5d8b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $85446a31c46e5d8b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($85446a31c46e5d8b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$4, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.getMultipleElementsFromSelector(this))$85446a31c46e5d8b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$a = 'dropdown';
const $85446a31c46e5d8b$var$DATA_KEY$6 = 'bs.dropdown';
const $85446a31c46e5d8b$var$EVENT_KEY$6 = `.${$85446a31c46e5d8b$var$DATA_KEY$6}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$3 = '.data-api';
const $85446a31c46e5d8b$var$ESCAPE_KEY$2 = 'Escape';
const $85446a31c46e5d8b$var$TAB_KEY$1 = 'Tab';
const $85446a31c46e5d8b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $85446a31c46e5d8b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $85446a31c46e5d8b$var$EVENT_HIDE$5 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$5 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$5 = `show${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$5 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$6}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3 = `click${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_KEYUP_DATA_API = `keyup${$85446a31c46e5d8b$var$EVENT_KEY$6}${$85446a31c46e5d8b$var$DATA_API_KEY$3}`;
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$6 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPUP = 'dropup';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPEND = 'dropend';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3}.${$85446a31c46e5d8b$var$CLASS_NAME_SHOW$6}`;
const $85446a31c46e5d8b$var$SELECTOR_MENU = '.dropdown-menu';
const $85446a31c46e5d8b$var$SELECTOR_NAVBAR = '.navbar';
const $85446a31c46e5d8b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $85446a31c46e5d8b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $85446a31c46e5d8b$var$PLACEMENT_TOP = $85446a31c46e5d8b$var$isRTL() ? 'top-end' : 'top-start';
const $85446a31c46e5d8b$var$PLACEMENT_TOPEND = $85446a31c46e5d8b$var$isRTL() ? 'top-start' : 'top-end';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOM = $85446a31c46e5d8b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOMEND = $85446a31c46e5d8b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $85446a31c46e5d8b$var$PLACEMENT_RIGHT = $85446a31c46e5d8b$var$isRTL() ? 'left-start' : 'right-start';
const $85446a31c46e5d8b$var$PLACEMENT_LEFT = $85446a31c46e5d8b$var$isRTL() ? 'right-start' : 'left-start';
const $85446a31c46e5d8b$var$PLACEMENT_TOPCENTER = 'top';
const $85446a31c46e5d8b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $85446a31c46e5d8b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $85446a31c46e5d8b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$931cbfb6bfb85fc extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $85446a31c46e5d8b$var$SelectorEngine.next(this._element, $85446a31c46e5d8b$var$SELECTOR_MENU)[0] || $85446a31c46e5d8b$var$SelectorEngine.prev(this._element, $85446a31c46e5d8b$var$SELECTOR_MENU)[0] || $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$9;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$9;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($85446a31c46e5d8b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($85446a31c46e5d8b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.on(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($85446a31c46e5d8b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.off(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $85446a31c46e5d8b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$85446a31c46e5d8b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$85446a31c46e5d8b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $e4h34 === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($85446a31c46e5d8b$var$isElement(this._config.reference)) referenceElement = $85446a31c46e5d8b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $e4h34.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPEND)) return $85446a31c46e5d8b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPSTART)) return $85446a31c46e5d8b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPUP_CENTER)) return $85446a31c46e5d8b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_CENTER)) return $85446a31c46e5d8b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPUP)) return isEnd ? $85446a31c46e5d8b$var$PLACEMENT_TOPEND : $85446a31c46e5d8b$var$PLACEMENT_TOP;
        return isEnd ? $85446a31c46e5d8b$var$PLACEMENT_BOTTOMEND : $85446a31c46e5d8b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($85446a31c46e5d8b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $85446a31c46e5d8b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$85446a31c46e5d8b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$85446a31c46e5d8b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $85446a31c46e5d8b$var$getNextActiveElement(items, target, key === $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $85446a31c46e5d8b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $85446a31c46e5d8b$var$TAB_KEY$1) return;
        const openToggles = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $85446a31c46e5d8b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $85446a31c46e5d8b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $85446a31c46e5d8b$var$ARROW_UP_KEY$1,
            $85446a31c46e5d8b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3) ? this : $85446a31c46e5d8b$var$SelectorEngine.prev(this, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3)[0] || $85446a31c46e5d8b$var$SelectorEngine.next(this, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3)[0] || $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, $85446a31c46e5d8b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DATA_API, $85446a31c46e5d8b$var$SELECTOR_MENU, $85446a31c46e5d8b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3, $85446a31c46e5d8b$export$931cbfb6bfb85fc.clearMenus);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYUP_DATA_API, $85446a31c46e5d8b$export$931cbfb6bfb85fc.clearMenus);
$85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$3, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $85446a31c46e5d8b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$9 = 'backdrop';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$4 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$5 = 'show';
const $85446a31c46e5d8b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$85446a31c46e5d8b$var$NAME$9}`;
const $85446a31c46e5d8b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $85446a31c46e5d8b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$Backdrop extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$8;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$8;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $85446a31c46e5d8b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $85446a31c46e5d8b$var$reflow(element);
        element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $85446a31c46e5d8b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $85446a31c46e5d8b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $85446a31c46e5d8b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $85446a31c46e5d8b$var$EventHandler.off(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $85446a31c46e5d8b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $85446a31c46e5d8b$var$EventHandler.on(element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN, ()=>{
            $85446a31c46e5d8b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $85446a31c46e5d8b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$8 = 'focustrap';
const $85446a31c46e5d8b$var$DATA_KEY$5 = 'bs.focustrap';
const $85446a31c46e5d8b$var$EVENT_KEY$5 = `.${$85446a31c46e5d8b$var$DATA_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSIN$2 = `focusin${$85446a31c46e5d8b$var$EVENT_KEY$5}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$85446a31c46e5d8b$var$EVENT_KEY$5}`;
const $85446a31c46e5d8b$var$TAB_KEY = 'Tab';
const $85446a31c46e5d8b$var$TAB_NAV_FORWARD = 'forward';
const $85446a31c46e5d8b$var$TAB_NAV_BACKWARD = 'backward';
const $85446a31c46e5d8b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $85446a31c46e5d8b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$FocusTrap extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$7;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$7;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $85446a31c46e5d8b$var$EventHandler.off(document, $85446a31c46e5d8b$var$EVENT_KEY$5); // guard against infinite focus loop
        $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $85446a31c46e5d8b$var$EventHandler.off(document, $85446a31c46e5d8b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $85446a31c46e5d8b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $85446a31c46e5d8b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $85446a31c46e5d8b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $85446a31c46e5d8b$var$TAB_NAV_BACKWARD : $85446a31c46e5d8b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $85446a31c46e5d8b$var$PROPERTY_PADDING = 'padding-right';
const $85446a31c46e5d8b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $85446a31c46e5d8b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT, $85446a31c46e5d8b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT, $85446a31c46e5d8b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $85446a31c46e5d8b$var$PROPERTY_PADDING);
        this._resetElementAttributes($85446a31c46e5d8b$var$SELECTOR_FIXED_CONTENT, $85446a31c46e5d8b$var$PROPERTY_PADDING);
        this._resetElementAttributes($85446a31c46e5d8b$var$SELECTOR_STICKY_CONTENT, $85446a31c46e5d8b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $85446a31c46e5d8b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $85446a31c46e5d8b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $85446a31c46e5d8b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($85446a31c46e5d8b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $85446a31c46e5d8b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$7 = 'modal';
const $85446a31c46e5d8b$var$DATA_KEY$4 = 'bs.modal';
const $85446a31c46e5d8b$var$EVENT_KEY$4 = `.${$85446a31c46e5d8b$var$DATA_KEY$4}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$2 = '.data-api';
const $85446a31c46e5d8b$var$ESCAPE_KEY$1 = 'Escape';
const $85446a31c46e5d8b$var$EVENT_HIDE$4 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$4 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$4 = `show${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$4 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_RESIZE$1 = `resize${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DISMISS = `click.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$4}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$2 = `click${$85446a31c46e5d8b$var$EVENT_KEY$4}${$85446a31c46e5d8b$var$DATA_API_KEY$2}`;
const $85446a31c46e5d8b$var$CLASS_NAME_OPEN = 'modal-open';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$3 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$4 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_STATIC = 'modal-static';
const $85446a31c46e5d8b$var$OPEN_SELECTOR$1 = '.modal.show';
const $85446a31c46e5d8b$var$SELECTOR_DIALOG = '.modal-dialog';
const $85446a31c46e5d8b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $85446a31c46e5d8b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $85446a31c46e5d8b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$2b77a92f1a5ad772 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $85446a31c46e5d8b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$6;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$6;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($85446a31c46e5d8b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $85446a31c46e5d8b$var$EventHandler.off(window, $85446a31c46e5d8b$var$EVENT_KEY$4);
        $85446a31c46e5d8b$var$EventHandler.off(this._dialog, $85446a31c46e5d8b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $85446a31c46e5d8b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $85446a31c46e5d8b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $85446a31c46e5d8b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $85446a31c46e5d8b$var$EventHandler.one(this._element, $85446a31c46e5d8b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $85446a31c46e5d8b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $85446a31c46e5d8b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$2, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_HIDDEN$4, ()=>{
            if ($85446a31c46e5d8b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $85446a31c46e5d8b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $85446a31c46e5d8b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$6 = 'offcanvas';
const $85446a31c46e5d8b$var$DATA_KEY$3 = 'bs.offcanvas';
const $85446a31c46e5d8b$var$EVENT_KEY$3 = `.${$85446a31c46e5d8b$var$DATA_KEY$3}`;
const $85446a31c46e5d8b$var$DATA_API_KEY$1 = '.data-api';
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$2 = `load${$85446a31c46e5d8b$var$EVENT_KEY$3}${$85446a31c46e5d8b$var$DATA_API_KEY$1}`;
const $85446a31c46e5d8b$var$ESCAPE_KEY = 'Escape';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$3 = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $85446a31c46e5d8b$var$CLASS_NAME_HIDING = 'hiding';
const $85446a31c46e5d8b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $85446a31c46e5d8b$var$OPEN_SELECTOR = '.offcanvas.show';
const $85446a31c46e5d8b$var$EVENT_SHOW$3 = `show${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$3 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$3 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$3 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_RESIZE = `resize${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$1 = `click${$85446a31c46e5d8b$var$EVENT_KEY$3}${$85446a31c46e5d8b$var$DATA_API_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$85446a31c46e5d8b$var$EVENT_KEY$3}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $85446a31c46e5d8b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $85446a31c46e5d8b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$591ca0244c9dfcd4 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$5;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$5;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $85446a31c46e5d8b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING$1);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$3, $85446a31c46e5d8b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $85446a31c46e5d8b$var$ScrollBarHelper().reset();
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $85446a31c46e5d8b$var$Backdrop({
            className: $85446a31c46e5d8b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $85446a31c46e5d8b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $85446a31c46e5d8b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API$1, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($85446a31c46e5d8b$var$isDisabled(this)) return;
    $85446a31c46e5d8b$var$EventHandler.one(target, $85446a31c46e5d8b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($85446a31c46e5d8b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $85446a31c46e5d8b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$OPEN_SELECTOR))$85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_RESIZE, ()=>{
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $85446a31c46e5d8b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $85446a31c46e5d8b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $85446a31c46e5d8b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $85446a31c46e5d8b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $85446a31c46e5d8b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $85446a31c46e5d8b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $85446a31c46e5d8b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($85446a31c46e5d8b$var$uriAttributes.has(attributeName)) return Boolean($85446a31c46e5d8b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $85446a31c46e5d8b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$85446a31c46e5d8b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$5 = 'TemplateFactory';
const $85446a31c46e5d8b$var$Default$4 = {
    allowList: $85446a31c46e5d8b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $85446a31c46e5d8b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $85446a31c46e5d8b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$var$TemplateFactory extends $85446a31c46e5d8b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$4;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$4;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $85446a31c46e5d8b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $85446a31c46e5d8b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($85446a31c46e5d8b$var$isElement(content)) {
            this._putElementInTemplate($85446a31c46e5d8b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $85446a31c46e5d8b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $85446a31c46e5d8b$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$4 = 'tooltip';
const $85446a31c46e5d8b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$2 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_MODAL = 'modal';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$2 = 'show';
const $85446a31c46e5d8b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $85446a31c46e5d8b$var$SELECTOR_MODAL = `.${$85446a31c46e5d8b$var$CLASS_NAME_MODAL}`;
const $85446a31c46e5d8b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $85446a31c46e5d8b$var$TRIGGER_HOVER = 'hover';
const $85446a31c46e5d8b$var$TRIGGER_FOCUS = 'focus';
const $85446a31c46e5d8b$var$TRIGGER_CLICK = 'click';
const $85446a31c46e5d8b$var$TRIGGER_MANUAL = 'manual';
const $85446a31c46e5d8b$var$EVENT_HIDE$2 = 'hide';
const $85446a31c46e5d8b$var$EVENT_HIDDEN$2 = 'hidden';
const $85446a31c46e5d8b$var$EVENT_SHOW$2 = 'show';
const $85446a31c46e5d8b$var$EVENT_SHOWN$2 = 'shown';
const $85446a31c46e5d8b$var$EVENT_INSERTED = 'inserted';
const $85446a31c46e5d8b$var$EVENT_CLICK$1 = 'click';
const $85446a31c46e5d8b$var$EVENT_FOCUSIN$1 = 'focusin';
const $85446a31c46e5d8b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $85446a31c46e5d8b$var$EVENT_MOUSEENTER = 'mouseenter';
const $85446a31c46e5d8b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $85446a31c46e5d8b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $85446a31c46e5d8b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $85446a31c46e5d8b$var$isRTL() ? 'right' : 'left'
};
const $85446a31c46e5d8b$var$Default$3 = {
    allowList: $85446a31c46e5d8b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $85446a31c46e5d8b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$28c660c63b792dea extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        if (typeof $e4h34 === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$3;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$3;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $85446a31c46e5d8b$var$EventHandler.off(this._element.closest($85446a31c46e5d8b$var$SELECTOR_MODAL), $85446a31c46e5d8b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_SHOW$2));
        const shadowRoot = $85446a31c46e5d8b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.on(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        const complete = ()=>{
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$85446a31c46e5d8b$var$EventHandler.off(element, 'mouseover', $85446a31c46e5d8b$var$noop);
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_FADE$2, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $85446a31c46e5d8b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $85446a31c46e5d8b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$85446a31c46e5d8b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $85446a31c46e5d8b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $85446a31c46e5d8b$var$AttachmentMap[placement.toUpperCase()];
        return $e4h34.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $85446a31c46e5d8b$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$85446a31c46e5d8b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $85446a31c46e5d8b$var$EventHandler.on(this._element, this.constructor.eventName($85446a31c46e5d8b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$85446a31c46e5d8b$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $85446a31c46e5d8b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $85446a31c46e5d8b$var$TRIGGER_HOVER ? this.constructor.eventName($85446a31c46e5d8b$var$EVENT_MOUSEENTER) : this.constructor.eventName($85446a31c46e5d8b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $85446a31c46e5d8b$var$TRIGGER_HOVER ? this.constructor.eventName($85446a31c46e5d8b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($85446a31c46e5d8b$var$EVENT_FOCUSOUT$1);
                $85446a31c46e5d8b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $85446a31c46e5d8b$var$TRIGGER_FOCUS : $85446a31c46e5d8b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $85446a31c46e5d8b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $85446a31c46e5d8b$var$TRIGGER_FOCUS : $85446a31c46e5d8b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $85446a31c46e5d8b$var$EventHandler.on(this._element.closest($85446a31c46e5d8b$var$SELECTOR_MODAL), $85446a31c46e5d8b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $85446a31c46e5d8b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($85446a31c46e5d8b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $85446a31c46e5d8b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$3 = 'popover';
const $85446a31c46e5d8b$var$SELECTOR_TITLE = '.popover-header';
const $85446a31c46e5d8b$var$SELECTOR_CONTENT = '.popover-body';
const $85446a31c46e5d8b$var$Default$2 = {
    ...$85446a31c46e5d8b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $85446a31c46e5d8b$var$DefaultType$2 = {
    ...$85446a31c46e5d8b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$5b6b19405a83ff9d extends $85446a31c46e5d8b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$2;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$2;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$85446a31c46e5d8b$var$SELECTOR_TITLE]: this._getTitle(),
            [$85446a31c46e5d8b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$2 = 'scrollspy';
const $85446a31c46e5d8b$var$DATA_KEY$2 = 'bs.scrollspy';
const $85446a31c46e5d8b$var$EVENT_KEY$2 = `.${$85446a31c46e5d8b$var$DATA_KEY$2}`;
const $85446a31c46e5d8b$var$DATA_API_KEY = '.data-api';
const $85446a31c46e5d8b$var$EVENT_ACTIVATE = `activate${$85446a31c46e5d8b$var$EVENT_KEY$2}`;
const $85446a31c46e5d8b$var$EVENT_CLICK = `click${$85446a31c46e5d8b$var$EVENT_KEY$2}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$1 = `load${$85446a31c46e5d8b$var$EVENT_KEY$2}${$85446a31c46e5d8b$var$DATA_API_KEY}`;
const $85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $85446a31c46e5d8b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS = '[href]';
const $85446a31c46e5d8b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $85446a31c46e5d8b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $85446a31c46e5d8b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $85446a31c46e5d8b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $85446a31c46e5d8b$var$SELECTOR_LINK_ITEMS = `${$85446a31c46e5d8b$var$SELECTOR_NAV_LINKS}, ${$85446a31c46e5d8b$var$SELECTOR_NAV_ITEMS} > ${$85446a31c46e5d8b$var$SELECTOR_NAV_LINKS}, ${$85446a31c46e5d8b$var$SELECTOR_LIST_ITEMS}`;
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN = '.dropdown';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $85446a31c46e5d8b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $85446a31c46e5d8b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$a6472a5298a374be extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default$1;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType$1;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $85446a31c46e5d8b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $85446a31c46e5d8b$var$EventHandler.off(this._config.target, $85446a31c46e5d8b$var$EVENT_CLICK);
        $85446a31c46e5d8b$var$EventHandler.on(this._config.target, $85446a31c46e5d8b$var$EVENT_CLICK, $85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $85446a31c46e5d8b$var$isDisabled(anchor)) continue;
            const observableSection = $85446a31c46e5d8b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($85446a31c46e5d8b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($85446a31c46e5d8b$var$SELECTOR_DROPDOWN)).classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $85446a31c46e5d8b$var$SelectorEngine.parents(target, $85446a31c46e5d8b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $85446a31c46e5d8b$var$SelectorEngine.prev(listGroup, $85446a31c46e5d8b$var$SELECTOR_LINK_ITEMS))item.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $85446a31c46e5d8b$var$SelectorEngine.find(`${$85446a31c46e5d8b$var$SELECTOR_TARGET_LINKS}.${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_SPY))$85446a31c46e5d8b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME$1 = 'tab';
const $85446a31c46e5d8b$var$DATA_KEY$1 = 'bs.tab';
const $85446a31c46e5d8b$var$EVENT_KEY$1 = `.${$85446a31c46e5d8b$var$DATA_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_HIDE$1 = `hide${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN$1 = `hidden${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_SHOW$1 = `show${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN$1 = `shown${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API = `click${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_KEYDOWN = `keydown${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API = `load${$85446a31c46e5d8b$var$EVENT_KEY$1}`;
const $85446a31c46e5d8b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $85446a31c46e5d8b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $85446a31c46e5d8b$var$ARROW_UP_KEY = 'ArrowUp';
const $85446a31c46e5d8b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $85446a31c46e5d8b$var$HOME_KEY = 'Home';
const $85446a31c46e5d8b$var$END_KEY = 'End';
const $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE = 'active';
const $85446a31c46e5d8b$var$CLASS_NAME_FADE$1 = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW$1 = 'show';
const $85446a31c46e5d8b$var$CLASS_DROPDOWN = 'dropdown';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $85446a31c46e5d8b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $85446a31c46e5d8b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $85446a31c46e5d8b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $85446a31c46e5d8b$var$SELECTOR_INNER = `.nav-link${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$85446a31c46e5d8b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $85446a31c46e5d8b$var$SELECTOR_INNER_ELEM = `${$85446a31c46e5d8b$var$SELECTOR_INNER}, ${$85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE}`;
const $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$85446a31c46e5d8b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$3e41faf802a29e71 extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($85446a31c46e5d8b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $85446a31c46e5d8b$var$EventHandler.trigger(active, $85446a31c46e5d8b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(innerElem, $85446a31c46e5d8b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        this._activate($85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $85446a31c46e5d8b$var$EventHandler.trigger(element, $85446a31c46e5d8b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $85446a31c46e5d8b$var$EventHandler.trigger(element, $85446a31c46e5d8b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $85446a31c46e5d8b$var$ARROW_LEFT_KEY,
            $85446a31c46e5d8b$var$ARROW_RIGHT_KEY,
            $85446a31c46e5d8b$var$ARROW_UP_KEY,
            $85446a31c46e5d8b$var$ARROW_DOWN_KEY,
            $85446a31c46e5d8b$var$HOME_KEY,
            $85446a31c46e5d8b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$85446a31c46e5d8b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $85446a31c46e5d8b$var$HOME_KEY,
            $85446a31c46e5d8b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $85446a31c46e5d8b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $85446a31c46e5d8b$var$ARROW_RIGHT_KEY,
                $85446a31c46e5d8b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $85446a31c46e5d8b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $85446a31c46e5d8b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($85446a31c46e5d8b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $85446a31c46e5d8b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_TOGGLE, $85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
        toggle($85446a31c46e5d8b$var$SELECTOR_DROPDOWN_MENU, $85446a31c46e5d8b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM) ? elem : $85446a31c46e5d8b$var$SelectorEngine.findOne($85446a31c46e5d8b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($85446a31c46e5d8b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$EventHandler.on(document, $85446a31c46e5d8b$var$EVENT_CLICK_DATA_API, $85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($85446a31c46e5d8b$var$isDisabled(this)) return;
    $85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $85446a31c46e5d8b$var$EventHandler.on(window, $85446a31c46e5d8b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $85446a31c46e5d8b$var$SelectorEngine.find($85446a31c46e5d8b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$85446a31c46e5d8b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $85446a31c46e5d8b$var$NAME = 'toast';
const $85446a31c46e5d8b$var$DATA_KEY = 'bs.toast';
const $85446a31c46e5d8b$var$EVENT_KEY = `.${$85446a31c46e5d8b$var$DATA_KEY}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEOVER = `mouseover${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_MOUSEOUT = `mouseout${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSIN = `focusin${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_FOCUSOUT = `focusout${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_HIDE = `hide${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_HIDDEN = `hidden${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_SHOW = `show${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$EVENT_SHOWN = `shown${$85446a31c46e5d8b$var$EVENT_KEY}`;
const $85446a31c46e5d8b$var$CLASS_NAME_FADE = 'fade';
const $85446a31c46e5d8b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $85446a31c46e5d8b$var$CLASS_NAME_SHOW = 'show';
const $85446a31c46e5d8b$var$CLASS_NAME_SHOWING = 'showing';
const $85446a31c46e5d8b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $85446a31c46e5d8b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $85446a31c46e5d8b$export$8d8dc7d5f743331b extends $85446a31c46e5d8b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $85446a31c46e5d8b$var$Default;
    }
    static get DefaultType() {
        return $85446a31c46e5d8b$var$DefaultType;
    }
    static get NAME() {
        return $85446a31c46e5d8b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_HIDE); // @deprecated
        $85446a31c46e5d8b$var$reflow(this._element);
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOW, $85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOWING, $85446a31c46e5d8b$var$CLASS_NAME_SHOW);
            $85446a31c46e5d8b$var$EventHandler.trigger(this._element, $85446a31c46e5d8b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($85446a31c46e5d8b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($85446a31c46e5d8b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($85446a31c46e5d8b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $85446a31c46e5d8b$var$EventHandler.on(this._element, $85446a31c46e5d8b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $85446a31c46e5d8b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $85446a31c46e5d8b$var$enableDismissTrigger($85446a31c46e5d8b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $85446a31c46e5d8b$var$defineJQueryPlugin($85446a31c46e5d8b$export$8d8dc7d5f743331b);

});
parcelRegister("e4h34", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("G6QZI")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("tsn8K")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("G6QZI")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("2DJ76")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("apoHu")).createPopper; });

var $btpzK = parcelRequire("btpzK");

var $tRXom = parcelRequire("tRXom");

var $G6QZI = parcelRequire("G6QZI");
var $tsn8K = parcelRequire("tsn8K");

var $2DJ76 = parcelRequire("2DJ76");

var $apoHu = parcelRequire("apoHu");
$parcel$exportWildcard(module.exports, $btpzK);
$parcel$exportWildcard(module.exports, $tRXom);

});
parcelRegister("btpzK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $85a63deb9e4efdbe$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $85a63deb9e4efdbe$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $85a63deb9e4efdbe$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $85a63deb9e4efdbe$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $85a63deb9e4efdbe$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $85a63deb9e4efdbe$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $85a63deb9e4efdbe$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $85a63deb9e4efdbe$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $85a63deb9e4efdbe$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $85a63deb9e4efdbe$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $85a63deb9e4efdbe$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $85a63deb9e4efdbe$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $85a63deb9e4efdbe$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $85a63deb9e4efdbe$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $85a63deb9e4efdbe$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $85a63deb9e4efdbe$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $85a63deb9e4efdbe$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $85a63deb9e4efdbe$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $85a63deb9e4efdbe$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $85a63deb9e4efdbe$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $85a63deb9e4efdbe$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $85a63deb9e4efdbe$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $85a63deb9e4efdbe$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $85a63deb9e4efdbe$export$d087d3878fdf71d5; });
var $85a63deb9e4efdbe$export$1e95b668f3b82d = 'top';
var $85a63deb9e4efdbe$export$40e543e69a8b3fbb = 'bottom';
var $85a63deb9e4efdbe$export$79ffe56a765070d2 = 'right';
var $85a63deb9e4efdbe$export$eabcd2c8791e7bf4 = 'left';
var $85a63deb9e4efdbe$export$dfb5619354ba860 = 'auto';
var $85a63deb9e4efdbe$export$aec2ce47c367b8c3 = [
    $85a63deb9e4efdbe$export$1e95b668f3b82d,
    $85a63deb9e4efdbe$export$40e543e69a8b3fbb,
    $85a63deb9e4efdbe$export$79ffe56a765070d2,
    $85a63deb9e4efdbe$export$eabcd2c8791e7bf4
];
var $85a63deb9e4efdbe$export$b3571188c770cc5a = 'start';
var $85a63deb9e4efdbe$export$bd5df0f255a350f8 = 'end';
var $85a63deb9e4efdbe$export$390fd549c5303b4d = 'clippingParents';
var $85a63deb9e4efdbe$export$d7b7311ec04a3e8f = 'viewport';
var $85a63deb9e4efdbe$export$ae5ab1c730825774 = 'popper';
var $85a63deb9e4efdbe$export$ca50aac9f3ba507f = 'reference';
var $85a63deb9e4efdbe$export$368f9a87e87fa4e1 = /*#__PURE__*/ $85a63deb9e4efdbe$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $85a63deb9e4efdbe$export$b3571188c770cc5a,
        placement + "-" + $85a63deb9e4efdbe$export$bd5df0f255a350f8
    ]);
}, []);
var $85a63deb9e4efdbe$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($85a63deb9e4efdbe$export$aec2ce47c367b8c3, [
    $85a63deb9e4efdbe$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $85a63deb9e4efdbe$export$b3571188c770cc5a,
        placement + "-" + $85a63deb9e4efdbe$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $85a63deb9e4efdbe$export$421679a7c3d56e = 'beforeRead';
var $85a63deb9e4efdbe$export$aafa59e2e03f2942 = 'read';
var $85a63deb9e4efdbe$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $85a63deb9e4efdbe$export$c65e99957a05207c = 'beforeMain';
var $85a63deb9e4efdbe$export$f22da7240b7add18 = 'main';
var $85a63deb9e4efdbe$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $85a63deb9e4efdbe$export$8d4d2d70e7d46032 = 'beforeWrite';
var $85a63deb9e4efdbe$export$68d8715fc104d294 = 'write';
var $85a63deb9e4efdbe$export$70a6e5159acce2e6 = 'afterWrite';
var $85a63deb9e4efdbe$export$d087d3878fdf71d5 = [
    $85a63deb9e4efdbe$export$421679a7c3d56e,
    $85a63deb9e4efdbe$export$aafa59e2e03f2942,
    $85a63deb9e4efdbe$export$6964f6c886723980,
    $85a63deb9e4efdbe$export$c65e99957a05207c,
    $85a63deb9e4efdbe$export$f22da7240b7add18,
    $85a63deb9e4efdbe$export$bab79516f2d662fe,
    $85a63deb9e4efdbe$export$8d4d2d70e7d46032,
    $85a63deb9e4efdbe$export$68d8715fc104d294,
    $85a63deb9e4efdbe$export$70a6e5159acce2e6
];

});

parcelRegister("tRXom", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("8OgMA")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("2UESB")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("eFHzI")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("5sIsH")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("92JYe")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("kK0ry")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("7fD8B")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("l20wA")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("f6dYH")).default; });

var $8OgMA = parcelRequire("8OgMA");

var $2UESB = parcelRequire("2UESB");

var $eFHzI = parcelRequire("eFHzI");

var $5sIsH = parcelRequire("5sIsH");

var $92JYe = parcelRequire("92JYe");

var $kK0ry = parcelRequire("kK0ry");

var $7fD8B = parcelRequire("7fD8B");

var $l20wA = parcelRequire("l20wA");

var $f6dYH = parcelRequire("f6dYH");

});
parcelRegister("8OgMA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a002f13cf27b52$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");
// and applies them to the HTMLElements such as popper and arrow
function $66a002f13cf27b52$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $cDkqb.isHTMLElement)(element) || !(0, $lGz8v.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $66a002f13cf27b52$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $cDkqb.isHTMLElement)(element) || !(0, $lGz8v.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $66a002f13cf27b52$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $66a002f13cf27b52$var$applyStyles,
    effect: $66a002f13cf27b52$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("lGz8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc98c68302746ce9$export$2e2bcd8739ae039; });
function $fc98c68302746ce9$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cDkqb", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $9328f7d20c5ad8f3$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $9328f7d20c5ad8f3$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $9328f7d20c5ad8f3$export$af51f0f06c0f328a; });

var $hJIkn = parcelRequire("hJIkn");
function $9328f7d20c5ad8f3$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $hJIkn.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $9328f7d20c5ad8f3$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $hJIkn.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $9328f7d20c5ad8f3$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $hJIkn.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("hJIkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce99062bd8258a78$export$2e2bcd8739ae039; });
function $ce99062bd8258a78$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("2UESB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21f0859458a5faea$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $eh08t = parcelRequire("eh08t");

var $hqckA = parcelRequire("hqckA");

var $fUgdz = parcelRequire("fUgdz");

var $2stza = parcelRequire("2stza");

var $jDprH = parcelRequire("jDprH");

var $2N6Uq = parcelRequire("2N6Uq");

var $2JV7t = parcelRequire("2JV7t");

var $btpzK = parcelRequire("btpzK");
var $21f0859458a5faea$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2N6Uq.default)(typeof padding !== 'number' ? padding : (0, $2JV7t.default)(padding, (0, $btpzK.basePlacements)));
};
function $21f0859458a5faea$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1jvge.default)(state.placement);
    var axis = (0, $2stza.default)(basePlacement);
    var isVertical = [
        (0, $btpzK.left),
        (0, $btpzK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $21f0859458a5faea$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eh08t.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $btpzK.top) : (0, $btpzK.left);
    var maxProp = axis === 'y' ? (0, $btpzK.bottom) : (0, $btpzK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $fUgdz.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jDprH.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $21f0859458a5faea$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $hqckA.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $21f0859458a5faea$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $21f0859458a5faea$var$arrow,
    effect: $21f0859458a5faea$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("1jvge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f4fd086065911bf$export$2e2bcd8739ae039; });

function $0f4fd086065911bf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("eh08t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a642c22a9feff6be$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");
function $a642c22a9feff6be$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $hYSQh.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("hYSQh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d17294c9f412a67d$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");

var $gU5NM = parcelRequire("gU5NM");

var $hJIkn = parcelRequire("hJIkn");

var $du7FU = parcelRequire("du7FU");
function $d17294c9f412a67d$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $cDkqb.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $gU5NM.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $gU5NM.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $cDkqb.isElement)(element) ? (0, $hJIkn.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $du7FU.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gU5NM", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $c4e6606afccced1c$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $c4e6606afccced1c$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $c4e6606afccced1c$export$2077e0241d6afd3c; });
var $c4e6606afccced1c$export$8960430cfd85939f = Math.max;
var $c4e6606afccced1c$export$96ec731ed4dcb222 = Math.min;
var $c4e6606afccced1c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("du7FU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d1407c52a7c8cb0$export$2e2bcd8739ae039; });

var $1xPOh = parcelRequire("1xPOh");
function $9d1407c52a7c8cb0$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1xPOh.default)());
}

});
parcelRegister("1xPOh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12010fe8db335be8$export$2e2bcd8739ae039; });
function $12010fe8db335be8$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("hqckA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caee6e13dc008677$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");
function $caee6e13dc008677$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $cDkqb.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fUgdz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b948aa8250b50114$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");

var $lGz8v = parcelRequire("lGz8v");

var $gpf62 = parcelRequire("gpf62");

var $cDkqb = parcelRequire("cDkqb");

var $52pTN = parcelRequire("52pTN");

var $fkUg2 = parcelRequire("fkUg2");

var $1xPOh = parcelRequire("1xPOh");
function $b948aa8250b50114$var$getTrueOffsetParent(element) {
    if (!(0, $cDkqb.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gpf62.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b948aa8250b50114$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1xPOh.default)());
    var isIE = /Trident/i.test((0, $1xPOh.default)());
    if (isIE && (0, $cDkqb.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gpf62.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $fkUg2.default)(element);
    if ((0, $cDkqb.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $cDkqb.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $lGz8v.default)(currentNode)) < 0){
        var css = (0, $gpf62.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b948aa8250b50114$export$2e2bcd8739ae039(element) {
    var window = (0, $hJIkn.default)(element);
    var offsetParent = $b948aa8250b50114$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $52pTN.default)(offsetParent) && (0, $gpf62.default)(offsetParent).position === 'static')offsetParent = $b948aa8250b50114$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $lGz8v.default)(offsetParent) === 'html' || (0, $lGz8v.default)(offsetParent) === 'body' && (0, $gpf62.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $b948aa8250b50114$var$getContainingBlock(element) || window;
}

});
parcelRegister("gpf62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1ab0f752e36e07$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
function $bf1ab0f752e36e07$export$2e2bcd8739ae039(element) {
    return (0, $hJIkn.default)(element).getComputedStyle(element);
}

});

parcelRegister("52pTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab13aa4ac540f64$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");
function $3ab13aa4ac540f64$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $lGz8v.default)(element)) >= 0;
}

});

parcelRegister("fkUg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a45ce1c70eb460$export$2e2bcd8739ae039; });

var $lGz8v = parcelRequire("lGz8v");

var $bxA65 = parcelRequire("bxA65");

var $cDkqb = parcelRequire("cDkqb");
function $b2a45ce1c70eb460$export$2e2bcd8739ae039(element) {
    if ((0, $lGz8v.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $cDkqb.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $bxA65.default)(element) // fallback
    );
}

});
parcelRegister("bxA65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866ec6ec64076066$export$2e2bcd8739ae039; });

var $cDkqb = parcelRequire("cDkqb");
function $866ec6ec64076066$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $cDkqb.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("2stza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca5218822eae965$export$2e2bcd8739ae039; });
function $1ca5218822eae965$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("jDprH", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $e4b565d5ccfd9dbb$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $e4b565d5ccfd9dbb$export$86c8af6d3ef0b4a; });

var $gU5NM = parcelRequire("gU5NM");
function $e4b565d5ccfd9dbb$export$f28d906d67a997f3(min, value, max) {
    return (0, $gU5NM.max)(min, (0, $gU5NM.min)(value, max));
}
function $e4b565d5ccfd9dbb$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e4b565d5ccfd9dbb$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("2N6Uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2085845f5d837ecd$export$2e2bcd8739ae039; });

var $4tl7s = parcelRequire("4tl7s");
function $2085845f5d837ecd$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $4tl7s.default)(), paddingObject);
}

});
parcelRegister("4tl7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $341a40bb836fecd9$export$2e2bcd8739ae039; });
function $341a40bb836fecd9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("2JV7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fec177f66b842d3$export$2e2bcd8739ae039; });
function $1fec177f66b842d3$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("eFHzI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae6b221a248dd7d$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $fUgdz = parcelRequire("fUgdz");

var $hJIkn = parcelRequire("hJIkn");

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $1jvge = parcelRequire("1jvge");

var $82wN7 = parcelRequire("82wN7");

var $gU5NM = parcelRequire("gU5NM");
var $aae6b221a248dd7d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $aae6b221a248dd7d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $gU5NM.round)(x * dpr) / dpr || 0,
        y: (0, $gU5NM.round)(y * dpr) / dpr || 0
    };
}
function $aae6b221a248dd7d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $btpzK.left);
    var sideY = (0, $btpzK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $fUgdz.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $hJIkn.default)(popper)) {
            offsetParent = (0, $bxA65.default)(popper);
            if ((0, $gpf62.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $btpzK.top) || (placement === (0, $btpzK.left) || placement === (0, $btpzK.right)) && variation === (0, $btpzK.end)) {
            sideY = (0, $btpzK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $btpzK.left) || (placement === (0, $btpzK.top) || placement === (0, $btpzK.bottom)) && variation === (0, $btpzK.end)) {
            sideX = (0, $btpzK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $aae6b221a248dd7d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $aae6b221a248dd7d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $hJIkn.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $aae6b221a248dd7d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1jvge.default)(state.placement),
        variation: (0, $82wN7.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $aae6b221a248dd7d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $aae6b221a248dd7d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $aae6b221a248dd7d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $aae6b221a248dd7d$var$computeStyles,
    data: {}
};

});
parcelRegister("82wN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5da7f24416186fa1$export$2e2bcd8739ae039; });
function $5da7f24416186fa1$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("5sIsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fa20e7894537a26$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
var $3fa20e7894537a26$var$passive = {
    passive: true
};
function $3fa20e7894537a26$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $hJIkn.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3fa20e7894537a26$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3fa20e7894537a26$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3fa20e7894537a26$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3fa20e7894537a26$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3fa20e7894537a26$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3fa20e7894537a26$var$effect,
    data: {}
};

});

parcelRegister("92JYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6957f5bef1e521b8$export$2e2bcd8739ae039; });

var $93sVP = parcelRequire("93sVP");

var $1jvge = parcelRequire("1jvge");

var $9etaQ = parcelRequire("9etaQ");

var $tsn8K = parcelRequire("tsn8K");

var $gTz3Q = parcelRequire("gTz3Q");

var $btpzK = parcelRequire("btpzK");

var $82wN7 = parcelRequire("82wN7");
function $6957f5bef1e521b8$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1jvge.default)(placement) === (0, $btpzK.auto)) return [];
    var oppositePlacement = (0, $93sVP.default)(placement);
    return [
        (0, $9etaQ.default)(placement),
        oppositePlacement,
        (0, $9etaQ.default)(oppositePlacement)
    ];
}
function $6957f5bef1e521b8$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1jvge.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $93sVP.default)(preferredPlacement)
    ] : $6957f5bef1e521b8$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1jvge.default)(placement) === (0, $btpzK.auto) ? (0, $gTz3Q.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1jvge.default)(placement);
        var isStartVariation = (0, $82wN7.default)(placement) === (0, $btpzK.start);
        var isVertical = [
            (0, $btpzK.top),
            (0, $btpzK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $tsn8K.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $btpzK.right) : (0, $btpzK.left) : isStartVariation ? (0, $btpzK.bottom) : (0, $btpzK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $93sVP.default)(mainVariationSide);
        var altVariationSide = (0, $93sVP.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6957f5bef1e521b8$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6957f5bef1e521b8$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("93sVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $697ad6146bc295d1$export$2e2bcd8739ae039; });
var $697ad6146bc295d1$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $697ad6146bc295d1$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $697ad6146bc295d1$var$hash[matched];
    });
}

});

parcelRegister("9etaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b8c0d30b13c9805$export$2e2bcd8739ae039; });
var $6b8c0d30b13c9805$var$hash = {
    start: 'end',
    end: 'start'
};
function $6b8c0d30b13c9805$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $6b8c0d30b13c9805$var$hash[matched];
    });
}

});

parcelRegister("tsn8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0588b7ae84e87da8$export$2e2bcd8739ae039; });

var $jOlXH = parcelRequire("jOlXH");

var $bxA65 = parcelRequire("bxA65");

var $hYSQh = parcelRequire("hYSQh");

var $bwM7o = parcelRequire("bwM7o");

var $kMDXr = parcelRequire("kMDXr");

var $btpzK = parcelRequire("btpzK");

var $cDkqb = parcelRequire("cDkqb");

var $2N6Uq = parcelRequire("2N6Uq");

var $2JV7t = parcelRequire("2JV7t");
function $0588b7ae84e87da8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $btpzK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $btpzK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $btpzK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2N6Uq.default)(typeof padding !== 'number' ? padding : (0, $2JV7t.default)(padding, (0, $btpzK.basePlacements)));
    var altContext = elementContext === (0, $btpzK.popper) ? (0, $btpzK.reference) : (0, $btpzK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jOlXH.default)((0, $cDkqb.isElement)(element) ? element : element.contextElement || (0, $bxA65.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $hYSQh.default)(state.elements.reference);
    var popperOffsets = (0, $bwM7o.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $kMDXr.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $btpzK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $btpzK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $btpzK.right),
                (0, $btpzK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $btpzK.top),
                (0, $btpzK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jOlXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c3b903c25d9466$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $d5Zvt = parcelRequire("d5Zvt");

var $4dqBB = parcelRequire("4dqBB");

var $aaQJm = parcelRequire("aaQJm");

var $fUgdz = parcelRequire("fUgdz");

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $cDkqb = parcelRequire("cDkqb");

var $hYSQh = parcelRequire("hYSQh");

var $fkUg2 = parcelRequire("fkUg2");

var $hqckA = parcelRequire("hqckA");

var $lGz8v = parcelRequire("lGz8v");

var $kMDXr = parcelRequire("kMDXr");

var $gU5NM = parcelRequire("gU5NM");
function $e6c3b903c25d9466$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $hYSQh.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e6c3b903c25d9466$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $btpzK.viewport) ? (0, $kMDXr.default)((0, $d5Zvt.default)(element, strategy)) : (0, $cDkqb.isElement)(clippingParent) ? $e6c3b903c25d9466$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $kMDXr.default)((0, $4dqBB.default)((0, $bxA65.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e6c3b903c25d9466$var$getClippingParents(element) {
    var clippingParents = (0, $aaQJm.default)((0, $fkUg2.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gpf62.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $cDkqb.isHTMLElement)(element) ? (0, $fUgdz.default)(element) : element;
    if (!(0, $cDkqb.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $cDkqb.isElement)(clippingParent) && (0, $hqckA.default)(clippingParent, clipperElement) && (0, $lGz8v.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e6c3b903c25d9466$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $e6c3b903c25d9466$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e6c3b903c25d9466$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $gU5NM.max)(rect.top, accRect.top);
        accRect.right = (0, $gU5NM.min)(rect.right, accRect.right);
        accRect.bottom = (0, $gU5NM.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $gU5NM.max)(rect.left, accRect.left);
        return accRect;
    }, $e6c3b903c25d9466$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("d5Zvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988b73ed58caab5d$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");

var $bxA65 = parcelRequire("bxA65");

var $gjBXX = parcelRequire("gjBXX");

var $du7FU = parcelRequire("du7FU");
function $988b73ed58caab5d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $hJIkn.default)(element);
    var html = (0, $bxA65.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $du7FU.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gjBXX.default)(element),
        y: y
    };
}

});
parcelRegister("gjBXX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be0bdef070959ca4$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");

var $bxA65 = parcelRequire("bxA65");

var $2DsKR = parcelRequire("2DsKR");
function $be0bdef070959ca4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $hYSQh.default)((0, $bxA65.default)(element)).left + (0, $2DsKR.default)(element).scrollLeft;
}

});
parcelRegister("2DsKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb58767658348c0$export$2e2bcd8739ae039; });

var $hJIkn = parcelRequire("hJIkn");
function $1eb58767658348c0$export$2e2bcd8739ae039(node) {
    var win = (0, $hJIkn.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("4dqBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311d039fe68628bd$export$2e2bcd8739ae039; });

var $bxA65 = parcelRequire("bxA65");

var $gpf62 = parcelRequire("gpf62");

var $gjBXX = parcelRequire("gjBXX");

var $2DsKR = parcelRequire("2DsKR");

var $gU5NM = parcelRequire("gU5NM");
function $311d039fe68628bd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $bxA65.default)(element);
    var winScroll = (0, $2DsKR.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $gU5NM.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $gU5NM.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gjBXX.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gpf62.default)(body || html).direction === 'rtl') x += (0, $gU5NM.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("aaQJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7683bdc51586781b$export$2e2bcd8739ae039; });

var $ba8u4 = parcelRequire("ba8u4");

var $fkUg2 = parcelRequire("fkUg2");

var $hJIkn = parcelRequire("hJIkn");

var $8Sm8F = parcelRequire("8Sm8F");
function $7683bdc51586781b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ba8u4.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $hJIkn.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8Sm8F.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($7683bdc51586781b$export$2e2bcd8739ae039((0, $fkUg2.default)(target)));
}

});
parcelRegister("ba8u4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8207359ded02b362$export$2e2bcd8739ae039; });

var $fkUg2 = parcelRequire("fkUg2");

var $8Sm8F = parcelRequire("8Sm8F");

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");
function $8207359ded02b362$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $lGz8v.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $cDkqb.isHTMLElement)(node) && (0, $8Sm8F.default)(node)) return node;
    return $8207359ded02b362$export$2e2bcd8739ae039((0, $fkUg2.default)(node));
}

});
parcelRegister("8Sm8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67648a3348ea7dd4$export$2e2bcd8739ae039; });

var $gpf62 = parcelRequire("gpf62");
function $67648a3348ea7dd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gpf62.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("kMDXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f217491887b081a5$export$2e2bcd8739ae039; });
function $f217491887b081a5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("bwM7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8648022167d83b20$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $82wN7 = parcelRequire("82wN7");

var $2stza = parcelRequire("2stza");

var $btpzK = parcelRequire("btpzK");
function $8648022167d83b20$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1jvge.default)(placement) : null;
    var variation = placement ? (0, $82wN7.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $btpzK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $btpzK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $btpzK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $btpzK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2stza.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $btpzK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $btpzK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("gTz3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ccfacb1f27f0b3$export$2e2bcd8739ae039; });

var $82wN7 = parcelRequire("82wN7");

var $btpzK = parcelRequire("btpzK");

var $tsn8K = parcelRequire("tsn8K");

var $1jvge = parcelRequire("1jvge");
function $c4ccfacb1f27f0b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $btpzK.placements) : _options$allowedAutoP;
    var variation = (0, $82wN7.default)(placement);
    var placements = variation ? flipVariations ? (0, $btpzK.variationPlacements) : (0, $btpzK.variationPlacements).filter(function(placement) {
        return (0, $82wN7.default)(placement) === variation;
    }) : (0, $btpzK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $tsn8K.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1jvge.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("kK0ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f198729a69f80132$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $tsn8K = parcelRequire("tsn8K");
function $f198729a69f80132$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f198729a69f80132$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $btpzK.top),
        (0, $btpzK.right),
        (0, $btpzK.bottom),
        (0, $btpzK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f198729a69f80132$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $tsn8K.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $tsn8K.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f198729a69f80132$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f198729a69f80132$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f198729a69f80132$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f198729a69f80132$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f198729a69f80132$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $f198729a69f80132$var$hide
};

});

parcelRegister("7fD8B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54784b0cc81f9588$export$2e2bcd8739ae039; });

var $1jvge = parcelRequire("1jvge");

var $btpzK = parcelRequire("btpzK");
function $54784b0cc81f9588$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1jvge.default)(placement);
    var invertDistance = [
        (0, $btpzK.left),
        (0, $btpzK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $btpzK.left),
        (0, $btpzK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $54784b0cc81f9588$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $btpzK.placements).reduce(function(acc, placement) {
        acc[placement] = $54784b0cc81f9588$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $54784b0cc81f9588$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $54784b0cc81f9588$var$offset
};

});

parcelRegister("l20wA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4fa310b7050c0ce$export$2e2bcd8739ae039; });

var $bwM7o = parcelRequire("bwM7o");
function $f4fa310b7050c0ce$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $bwM7o.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f4fa310b7050c0ce$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f4fa310b7050c0ce$var$popperOffsets,
    data: {}
};

});

parcelRegister("f6dYH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe242486c969c43$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");

var $1jvge = parcelRequire("1jvge");

var $2stza = parcelRequire("2stza");

var $fhIRi = parcelRequire("fhIRi");

var $jDprH = parcelRequire("jDprH");

var $eh08t = parcelRequire("eh08t");

var $fUgdz = parcelRequire("fUgdz");

var $tsn8K = parcelRequire("tsn8K");

var $82wN7 = parcelRequire("82wN7");

var $4tl7s = parcelRequire("4tl7s");

var $gU5NM = parcelRequire("gU5NM");
function $afe242486c969c43$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $tsn8K.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1jvge.default)(state.placement);
    var variation = (0, $82wN7.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2stza.default)(basePlacement);
    var altAxis = (0, $fhIRi.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $btpzK.top) : (0, $btpzK.left);
        var altSide = mainAxis === 'y' ? (0, $btpzK.bottom) : (0, $btpzK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $btpzK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $btpzK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eh08t.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $4tl7s.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jDprH.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $fUgdz.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jDprH.within)(tether ? (0, $gU5NM.min)(min, tetherMin) : min, offset, tether ? (0, $gU5NM.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $btpzK.top) : (0, $btpzK.left);
        var _altSide = mainAxis === 'x' ? (0, $btpzK.bottom) : (0, $btpzK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $btpzK.top),
            (0, $btpzK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jDprH.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jDprH.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $afe242486c969c43$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $afe242486c969c43$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("fhIRi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20b3d8ab81ac378$export$2e2bcd8739ae039; });
function $b20b3d8ab81ac378$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("G6QZI", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $07e93d5ebba64980$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $07e93d5ebba64980$export$8f7491d57c8f97a9; });

var $gdOna = parcelRequire("gdOna");

var $eh08t = parcelRequire("eh08t");

var $aaQJm = parcelRequire("aaQJm");

var $fUgdz = parcelRequire("fUgdz");

var $9qBJp = parcelRequire("9qBJp");

var $bdwJx = parcelRequire("bdwJx");

var $kROea = parcelRequire("kROea");

var $tsn8K = parcelRequire("tsn8K");

var $cDkqb = parcelRequire("cDkqb");
var $07e93d5ebba64980$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $07e93d5ebba64980$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $07e93d5ebba64980$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $07e93d5ebba64980$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $07e93d5ebba64980$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $cDkqb.isElement)(reference) ? (0, $aaQJm.default)(reference) : reference.contextElement ? (0, $aaQJm.default)(reference.contextElement) : [],
                    popper: (0, $aaQJm.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9qBJp.default)((0, $kROea.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$07e93d5ebba64980$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gdOna.default)(reference, (0, $fUgdz.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $eh08t.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bdwJx.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$07e93d5ebba64980$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $07e93d5ebba64980$export$8f7491d57c8f97a9 = /*#__PURE__*/ $07e93d5ebba64980$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gdOna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcf4ef388a823bc9$export$2e2bcd8739ae039; });

var $hYSQh = parcelRequire("hYSQh");

var $e7pSV = parcelRequire("e7pSV");

var $lGz8v = parcelRequire("lGz8v");

var $cDkqb = parcelRequire("cDkqb");

var $gjBXX = parcelRequire("gjBXX");

var $bxA65 = parcelRequire("bxA65");

var $8Sm8F = parcelRequire("8Sm8F");

var $gU5NM = parcelRequire("gU5NM");
function $bcf4ef388a823bc9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $gU5NM.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $gU5NM.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcf4ef388a823bc9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $cDkqb.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $cDkqb.isHTMLElement)(offsetParent) && $bcf4ef388a823bc9$var$isElementScaled(offsetParent);
    var documentElement = (0, $bxA65.default)(offsetParent);
    var rect = (0, $hYSQh.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $lGz8v.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8Sm8F.default)(documentElement)) scroll = (0, $e7pSV.default)(offsetParent);
        if ((0, $cDkqb.isHTMLElement)(offsetParent)) {
            offsets = (0, $hYSQh.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gjBXX.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("e7pSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a475cc5521e41d7d$export$2e2bcd8739ae039; });

var $2DsKR = parcelRequire("2DsKR");

var $hJIkn = parcelRequire("hJIkn");

var $cDkqb = parcelRequire("cDkqb");

var $9xxW5 = parcelRequire("9xxW5");
function $a475cc5521e41d7d$export$2e2bcd8739ae039(node) {
    if (node === (0, $hJIkn.default)(node) || !(0, $cDkqb.isHTMLElement)(node)) return (0, $2DsKR.default)(node);
    else return (0, $9xxW5.default)(node);
}

});
parcelRegister("9xxW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f2185148431c44f$export$2e2bcd8739ae039; });
function $6f2185148431c44f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("9qBJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dd3cf6958dfec1c$export$2e2bcd8739ae039; });

var $btpzK = parcelRequire("btpzK");
function $6dd3cf6958dfec1c$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6dd3cf6958dfec1c$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6dd3cf6958dfec1c$var$order(modifiers); // order based on phase
    return (0, $btpzK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("bdwJx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82aa4cc99a13f2fb$export$2e2bcd8739ae039; });
function $82aa4cc99a13f2fb$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kROea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f30fb806ca61d5ef$export$2e2bcd8739ae039; });
function $f30fb806ca61d5ef$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("2DJ76", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $1ec237e15b54606b$export$8f7491d57c8f97a9; });

var $G6QZI = parcelRequire("G6QZI");

var $5sIsH = parcelRequire("5sIsH");

var $l20wA = parcelRequire("l20wA");

var $eFHzI = parcelRequire("eFHzI");

var $8OgMA = parcelRequire("8OgMA");

var $7fD8B = parcelRequire("7fD8B");

var $92JYe = parcelRequire("92JYe");

var $f6dYH = parcelRequire("f6dYH");

var $2UESB = parcelRequire("2UESB");

var $kK0ry = parcelRequire("kK0ry");


var $1ec237e15b54606b$export$d34966752335dd47 = [
    (0, $5sIsH.default),
    (0, $l20wA.default),
    (0, $eFHzI.default),
    (0, $8OgMA.default),
    (0, $7fD8B.default),
    (0, $92JYe.default),
    (0, $f6dYH.default),
    (0, $2UESB.default),
    (0, $kK0ry.default)
];
var $1ec237e15b54606b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $G6QZI.popperGenerator)({
    defaultModifiers: $1ec237e15b54606b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("apoHu", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $793f6628a41ce76a$export$8f7491d57c8f97a9; });

var $G6QZI = parcelRequire("G6QZI");

var $5sIsH = parcelRequire("5sIsH");

var $l20wA = parcelRequire("l20wA");

var $eFHzI = parcelRequire("eFHzI");

var $8OgMA = parcelRequire("8OgMA");
var $793f6628a41ce76a$export$d34966752335dd47 = [
    (0, $5sIsH.default),
    (0, $l20wA.default),
    (0, $eFHzI.default),
    (0, $8OgMA.default)
];
var $793f6628a41ce76a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $G6QZI.popperGenerator)({
    defaultModifiers: $793f6628a41ce76a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});



parcelRegister("hzoNF", function(module, exports) {

var $gox6m = parcelRequire("gox6m");

var $8YMgl = parcelRequire("8YMgl");

var $7cyDT = parcelRequire("7cyDT");
/** Error message constants. */ var $cca8f1522671c460$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cca8f1522671c460$var$nativeMax = Math.max, $cca8f1522671c460$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $cca8f1522671c460$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($cca8f1522671c460$var$FUNC_ERROR_TEXT);
    wait = $7cyDT(wait) || 0;
    if ($gox6m(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $cca8f1522671c460$var$nativeMax($7cyDT(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $cca8f1522671c460$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $8YMgl();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($8YMgl());
    }
    function debounced() {
        var time = $8YMgl(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $cca8f1522671c460$var$debounce;

});
parcelRegister("gox6m", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bef8908a0369e42d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $bef8908a0369e42d$var$isObject;

});

parcelRegister("8YMgl", function(module, exports) {

var $3949B = parcelRequire("3949B");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $68995d49ba57e96d$var$now = function() {
    return $3949B.Date.now();
};
module.exports = $68995d49ba57e96d$var$now;

});
parcelRegister("3949B", function(module, exports) {

var $266yZ = parcelRequire("266yZ");
/** Detect free variable `self`. */ var $24a56f37f5cae03b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $24a56f37f5cae03b$var$root = $266yZ || $24a56f37f5cae03b$var$freeSelf || Function('return this')();
module.exports = $24a56f37f5cae03b$var$root;

});
parcelRegister("266yZ", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $18713ba6185ec5ec$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $18713ba6185ec5ec$var$freeGlobal;

});



parcelRegister("7cyDT", function(module, exports) {

var $aYqqj = parcelRequire("aYqqj");

var $gox6m = parcelRequire("gox6m");

var $5VqIP = parcelRequire("5VqIP");
/** Used as references for various `Number` constants. */ var $53e486a41ea2ed14$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $53e486a41ea2ed14$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $53e486a41ea2ed14$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $53e486a41ea2ed14$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $53e486a41ea2ed14$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $53e486a41ea2ed14$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5VqIP(value)) return $53e486a41ea2ed14$var$NAN;
    if ($gox6m(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $gox6m(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $aYqqj(value);
    var isBinary = $53e486a41ea2ed14$var$reIsBinary.test(value);
    return isBinary || $53e486a41ea2ed14$var$reIsOctal.test(value) ? $53e486a41ea2ed14$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $53e486a41ea2ed14$var$reIsBadHex.test(value) ? $53e486a41ea2ed14$var$NAN : +value;
}
module.exports = $53e486a41ea2ed14$var$toNumber;

});
parcelRegister("aYqqj", function(module, exports) {

var $bTChF = parcelRequire("bTChF");
/** Used to match leading whitespace. */ var $7fd4012365a9b27d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $7fd4012365a9b27d$var$baseTrim(string) {
    return string ? string.slice(0, $bTChF(string) + 1).replace($7fd4012365a9b27d$var$reTrimStart, '') : string;
}
module.exports = $7fd4012365a9b27d$var$baseTrim;

});
parcelRegister("bTChF", function(module, exports) {
/** Used to match a single whitespace character. */ var $8a9287257612df9b$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $8a9287257612df9b$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $8a9287257612df9b$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $8a9287257612df9b$var$trimmedEndIndex;

});


parcelRegister("5VqIP", function(module, exports) {

var $EH50k = parcelRequire("EH50k");

var $2SbuO = parcelRequire("2SbuO");
/** `Object#toString` result references. */ var $4507010e41e91ec0$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4507010e41e91ec0$var$isSymbol(value) {
    return typeof value == 'symbol' || $2SbuO(value) && $EH50k(value) == $4507010e41e91ec0$var$symbolTag;
}
module.exports = $4507010e41e91ec0$var$isSymbol;

});
parcelRegister("EH50k", function(module, exports) {

var $fOnlg = parcelRequire("fOnlg");

var $b5fJ3 = parcelRequire("b5fJ3");

var $ljjWF = parcelRequire("ljjWF");
/** `Object#toString` result references. */ var $07a527468f671b35$var$nullTag = '[object Null]', $07a527468f671b35$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $07a527468f671b35$var$symToStringTag = $fOnlg ? $fOnlg.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $07a527468f671b35$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $07a527468f671b35$var$undefinedTag : $07a527468f671b35$var$nullTag;
    return $07a527468f671b35$var$symToStringTag && $07a527468f671b35$var$symToStringTag in Object(value) ? $b5fJ3(value) : $ljjWF(value);
}
module.exports = $07a527468f671b35$var$baseGetTag;

});
parcelRegister("fOnlg", function(module, exports) {

var $3949B = parcelRequire("3949B");
/** Built-in value references. */ var $b82da1bb5cad6f8a$var$Symbol = $3949B.Symbol;
module.exports = $b82da1bb5cad6f8a$var$Symbol;

});

parcelRegister("b5fJ3", function(module, exports) {

var $fOnlg = parcelRequire("fOnlg");
/** Used for built-in method references. */ var $811c5c2596fa811d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $811c5c2596fa811d$var$hasOwnProperty = $811c5c2596fa811d$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $811c5c2596fa811d$var$nativeObjectToString = $811c5c2596fa811d$var$objectProto.toString;
/** Built-in value references. */ var $811c5c2596fa811d$var$symToStringTag = $fOnlg ? $fOnlg.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $811c5c2596fa811d$var$getRawTag(value) {
    var isOwn = $811c5c2596fa811d$var$hasOwnProperty.call(value, $811c5c2596fa811d$var$symToStringTag), tag = value[$811c5c2596fa811d$var$symToStringTag];
    try {
        value[$811c5c2596fa811d$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $811c5c2596fa811d$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$811c5c2596fa811d$var$symToStringTag] = tag;
        else delete value[$811c5c2596fa811d$var$symToStringTag];
    }
    return result;
}
module.exports = $811c5c2596fa811d$var$getRawTag;

});

parcelRegister("ljjWF", function(module, exports) {
/** Used for built-in method references. */ var $f83ad80354322dae$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f83ad80354322dae$var$nativeObjectToString = $f83ad80354322dae$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f83ad80354322dae$var$objectToString(value) {
    return $f83ad80354322dae$var$nativeObjectToString.call(value);
}
module.exports = $f83ad80354322dae$var$objectToString;

});


parcelRegister("2SbuO", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $21798ac489625898$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $21798ac489625898$var$isObjectLike;

});





parcelRegister("2gnby", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $1a5f0f80da7abbc2$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $6XHer = parcelRequire("6XHer");
var $aRSfV = parcelRequire("aRSfV");
const $1a5f0f80da7abbc2$var$_hoisted_1 = [
    "for"
];
const $1a5f0f80da7abbc2$var$_hoisted_2 = {
    class: "input-container"
};
const $1a5f0f80da7abbc2$var$_hoisted_3 = {
    class: "dropdown"
};
const $1a5f0f80da7abbc2$var$_hoisted_4 = [
    "id",
    "aria-label"
];
const $1a5f0f80da7abbc2$var$_hoisted_5 = {
    class: "select-trigger-text"
};
const $1a5f0f80da7abbc2$var$_hoisted_6 = [
    "aria-labelledby"
];
const $1a5f0f80da7abbc2$var$_hoisted_7 = {
    key: 0,
    class: "search-container"
};
const $1a5f0f80da7abbc2$var$_hoisted_8 = [
    "name"
];
const $1a5f0f80da7abbc2$var$_hoisted_9 = {
    key: 1,
    class: "px-3 py-2 text-muted",
    role: "status"
};
const $1a5f0f80da7abbc2$var$_hoisted_10 = [
    "onClick"
];
const $1a5f0f80da7abbc2$var$_hoisted_11 = [
    "id",
    "name",
    "autocomplete",
    "required",
    "aria-label"
];
const $1a5f0f80da7abbc2$var$_hoisted_12 = {
    value: ""
};
const $1a5f0f80da7abbc2$var$_hoisted_13 = [
    "value"
];
const $1a5f0f80da7abbc2$var$_hoisted_14 = [
    "value"
];
const $1a5f0f80da7abbc2$var$_hoisted_15 = [
    "value"
];
const $1a5f0f80da7abbc2$var$_hoisted_16 = {
    key: 0,
    class: "invalid-feedback"
};
function $1a5f0f80da7abbc2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("div", {
        class: (0, $6XHer.normalizeClass)([
            "input-wrapper",
            {
                'is-invalid': $data.isInvalid && $props.required
            }
        ])
    }, [
        $props.label ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("label", {
            key: 0,
            for: $props.id
        }, (0, $6XHer.toDisplayString)($props.label), 9, $1a5f0f80da7abbc2$var$_hoisted_1)) : (0, $iZX2P.renderSlot)(_ctx.$slots, "label", {
            key: 1
        }),
        (0, $iZX2P.createElementVNode)("div", $1a5f0f80da7abbc2$var$_hoisted_2, [
            (0, $iZX2P.createElementVNode)("div", $1a5f0f80da7abbc2$var$_hoisted_3, [
                (0, $iZX2P.createElementVNode)("button", {
                    class: (0, $6XHer.normalizeClass)([
                        "btn dropdown-toggle",
                        {
                            'text-muted': !$options.selectedLabel,
                            'is-invalid': $data.isInvalid && $props.required
                        }
                    ]),
                    type: "button",
                    id: $props.id,
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false",
                    "aria-label": $props.label || $props.placeholder || 'Select an option',
                    ref: "dropdownButton",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.handleDropdownOpen && $options.handleDropdownOpen(...args)),
                    onKeydown: _cache[1] || (_cache[1] = (...args)=>$options.handleTriggerKeydown && $options.handleTriggerKeydown(...args))
                }, [
                    (0, $iZX2P.createElementVNode)("span", $1a5f0f80da7abbc2$var$_hoisted_5, (0, $6XHer.toDisplayString)($options.selectedLabel || $props.placeholder || "Select"), 1)
                ], 42, $1a5f0f80da7abbc2$var$_hoisted_4),
                (0, $iZX2P.createElementVNode)("ul", {
                    class: "dropdown-menu",
                    "aria-labelledby": $props.id
                }, [
                    $props.searchable ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("li", $1a5f0f80da7abbc2$var$_hoisted_7, [
                        (0, $iZX2P.withDirectives)((0, $iZX2P.createElementVNode)("input", {
                            type: "search",
                            name: `${$props.id}-option-search`,
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: false,
                            class: "search-input",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.searchQuery = $event),
                            placeholder: "Search...",
                            "aria-label": "Search options",
                            onClick: _cache[3] || (_cache[3] = (0, $aRSfV.withModifiers)(()=>{}, [
                                "stop"
                            ])),
                            onKeydown: [
                                _cache[4] || (_cache[4] = (0, $aRSfV.withKeys)((0, $aRSfV.withModifiers)(($event)=>$options.moveHighlight(1), [
                                    "prevent"
                                ]), [
                                    "down"
                                ])),
                                _cache[5] || (_cache[5] = (0, $aRSfV.withKeys)((0, $aRSfV.withModifiers)(($event)=>$options.moveHighlight(-1), [
                                    "prevent"
                                ]), [
                                    "up"
                                ])),
                                _cache[6] || (_cache[6] = (0, $aRSfV.withKeys)((0, $aRSfV.withModifiers)((...args)=>$options.selectHighlightedOption && $options.selectHighlightedOption(...args), [
                                    "prevent"
                                ]), [
                                    "enter"
                                ]))
                            ],
                            ref: "searchInput"
                        }, null, 40, $1a5f0f80da7abbc2$var$_hoisted_8), [
                            [
                                (0, $aRSfV.vModelText),
                                $data.searchQuery
                            ]
                        ])
                    ])) : (0, $iZX2P.createCommentVNode)("", true),
                    !$options.dropdownItems.length ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("li", $1a5f0f80da7abbc2$var$_hoisted_9, " No matching options ")) : (0, $iZX2P.createCommentVNode)("", true),
                    ((0, $iZX2P.openBlock)(true), (0, $iZX2P.createElementBlock)((0, $iZX2P.Fragment), null, (0, $iZX2P.renderList)($options.dropdownItems, (item, index)=>{
                        return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("li", {
                            key: `${item.type}-${item.value}`
                        }, [
                            (0, $iZX2P.createElementVNode)("a", {
                                class: (0, $6XHer.normalizeClass)([
                                    "dropdown-item",
                                    {
                                        active: item.value === $data.localModelValue,
                                        'keyboard-highlighted': index === $data.highlightedIndex
                                    }
                                ]),
                                href: "#",
                                onClick: (0, $aRSfV.withModifiers)(($event)=>$options.handleItemSelection(item), [
                                    "prevent"
                                ])
                            }, [
                                item.icon ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)((0, $iZX2P.resolveDynamicComponent)(item.icon), {
                                    key: 0,
                                    class: "dropdown-item-icon"
                                })) : (0, $iZX2P.createCommentVNode)("", true),
                                (0, $iZX2P.createTextVNode)(" " + (0, $6XHer.toDisplayString)(item.label), 1)
                            ], 10, $1a5f0f80da7abbc2$var$_hoisted_10)
                        ]);
                    }), 128))
                ], 8, $1a5f0f80da7abbc2$var$_hoisted_6)
            ]),
            (0, $iZX2P.withDirectives)((0, $iZX2P.createElementVNode)("select", {
                id: `${$props.id}-hidden`,
                name: $props.id,
                autocomplete: $props.autocomplete,
                required: $props.required,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.localModelValue = $event),
                class: "validation-select",
                "aria-label": $props.label || $props.placeholder || 'Select an option',
                onInvalid: _cache[8] || (_cache[8] = (...args)=>$options.handleInvalid && $options.handleInvalid(...args))
            }, [
                (0, $iZX2P.createElementVNode)("option", $1a5f0f80da7abbc2$var$_hoisted_12, (0, $6XHer.toDisplayString)($props.placeholder || "Select"), 1),
                ((0, $iZX2P.openBlock)(true), (0, $iZX2P.createElementBlock)((0, $iZX2P.Fragment), null, (0, $iZX2P.renderList)($props.options, (option)=>{
                    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("option", {
                        key: option.value,
                        value: option.value
                    }, (0, $6XHer.toDisplayString)(option.label), 9, $1a5f0f80da7abbc2$var$_hoisted_13);
                }), 128)),
                $props.allowCustom && $data.localModelValue && !$props.options.some((option)=>option.value == $data.localModelValue) ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("option", {
                    key: 0,
                    value: $data.localModelValue
                }, (0, $6XHer.toDisplayString)($data.localModelValue), 9, $1a5f0f80da7abbc2$var$_hoisted_14)) : (0, $iZX2P.createCommentVNode)("", true),
                $props.addOption ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("option", {
                    key: 1,
                    value: $props.addOption.value
                }, (0, $6XHer.toDisplayString)($props.addOption.label), 9, $1a5f0f80da7abbc2$var$_hoisted_15)) : (0, $iZX2P.createCommentVNode)("", true)
            ], 40, $1a5f0f80da7abbc2$var$_hoisted_11), [
                [
                    (0, $aRSfV.vModelSelect),
                    $data.localModelValue
                ]
            ]),
            $data.isInvalid && $props.required ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("div", $1a5f0f80da7abbc2$var$_hoisted_16, " Please select an option ")) : (0, $iZX2P.createCommentVNode)("", true),
            (0, $iZX2P.renderSlot)(_ctx.$slots, "append")
        ])
    ], 2);
}

});

parcelRegister("9R2Dl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72cb1b4254049b14$export$2e2bcd8739ae039; });
let $72cb1b4254049b14$var$NOOP = ()=>{};
var $72cb1b4254049b14$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("052LD", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $00f29d40ce95d958$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $6XHer = parcelRequire("6XHer");
const $00f29d40ce95d958$var$_hoisted_1 = {
    key: 0,
    id: "admin-banner",
    class: "admin-banner"
};
const $00f29d40ce95d958$var$_hoisted_2 = {
    class: "admin-banner-content"
};
const $00f29d40ce95d958$var$_hoisted_3 = {
    class: "d-flex align-items-center gap-2"
};
const $00f29d40ce95d958$var$_hoisted_4 = {
    key: 1
};
function $00f29d40ce95d958$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseBadge = (0, $iZX2P.resolveComponent)("BaseBadge");
    const _component_BaseSelectInput = (0, $iZX2P.resolveComponent)("BaseSelectInput");
    const _component_CloseIcon = (0, $iZX2P.resolveComponent)("CloseIcon");
    const _directive_clicky = (0, $iZX2P.resolveDirective)("clicky");
    return _ctx.isAdmin && !_ctx.adminBannerHidden ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("div", $00f29d40ce95d958$var$_hoisted_1, [
        (0, $iZX2P.createVNode)(_component_BaseBadge, {
            color: "var(--color-primary-dark)",
            label: $options.environment
        }, null, 8, [
            "label"
        ]),
        (0, $iZX2P.createElementVNode)("div", $00f29d40ce95d958$var$_hoisted_2, [
            (0, $iZX2P.createElementVNode)("div", $00f29d40ce95d958$var$_hoisted_3, [
                _cache[3] || (_cache[3] = (0, $iZX2P.createElementVNode)("span", {
                    class: "d-none d-lg-block"
                }, " Viewing as ", -1)),
                $options.isSuperAdmin ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)(_component_BaseSelectInput, {
                    key: 0,
                    searchable: "",
                    options: $data.userOptions,
                    modelValue: $data.selectedUserId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.selectedUserId = $event),
                    onSearch: $options.loadUsers,
                    onInput: $options.impersonateUser,
                    style: {
                        "width": "300px"
                    }
                }, null, 8, [
                    "options",
                    "modelValue",
                    "onSearch",
                    "onInput"
                ])) : ((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("span", $00f29d40ce95d958$var$_hoisted_4, (0, $6XHer.toDisplayString)(_ctx.user.email), 1))
            ]),
            (0, $iZX2P.createElementVNode)("button", {
                class: "admin-banner-button",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.goToDashboard && $options.goToDashboard(...args)),
                "aria-label": "Go to Dashboard"
            }, " Admin "),
            (0, $iZX2P.withDirectives)(((0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)("button", {
                class: "close-button",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.hideBanner && $options.hideBanner(...args)),
                "aria-label": "Close admin banner"
            }, [
                (0, $iZX2P.createVNode)(_component_CloseIcon)
            ])), [
                [
                    _directive_clicky
                ]
            ])
        ])
    ])) : (0, $iZX2P.createCommentVNode)("", true);
}

});

parcelRegister("1vRGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11a254202f3475aa$export$2e2bcd8739ae039; });
let $11a254202f3475aa$var$NOOP = ()=>{};
var $11a254202f3475aa$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5YDBd", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $45a145eb027a79ef$export$b3890eb0ae9dca99; });
parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $aRSfV = parcelRequire("aRSfV");
function $45a145eb027a79ef$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AdminBanner = (0, $iZX2P.resolveComponent)("AdminBanner");
    const _component_router_view = (0, $iZX2P.resolveComponent)("router-view");
    const _component_BaseToast = (0, $iZX2P.resolveComponent)("BaseToast");
    return (0, $iZX2P.openBlock)(), (0, $iZX2P.createElementBlock)((0, $iZX2P.Fragment), null, [
        $options.isAdmin ? ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)(_component_AdminBanner, {
            key: 0
        })) : (0, $iZX2P.createCommentVNode)("", true),
        (0, $iZX2P.createVNode)(_component_router_view, null, {
            default: (0, $iZX2P.withCtx)(({ Component: Component })=>[
                    (0, $iZX2P.createVNode)((0, $aRSfV.Transition), {
                        name: "fade",
                        mode: "out-in"
                    }, {
                        default: (0, $iZX2P.withCtx)(()=>[
                                ((0, $iZX2P.openBlock)(), (0, $iZX2P.createBlock)((0, $iZX2P.resolveDynamicComponent)(Component)))
                            ]),
                        _: 2
                    }, 1024)
                ]),
            _: 1
        }),
        (0, $iZX2P.createVNode)(_component_BaseToast)
    ], 64);
}

});

parcelRegister("hdg2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c880170d66f2d89e$export$2e2bcd8739ae039; });
let $c880170d66f2d89e$var$NOOP = ()=>{};
var $c880170d66f2d89e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("48GQ3", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", function () { return $fe1f41bb07c120fb$export$7b4942f78e7b8a49; });
$parcel$export(module.exports, "createRouter", function () { return $fe1f41bb07c120fb$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "useRouter", function () { return $fe1f41bb07c120fb$export$9a302a45f65d0572; });
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ 
var $ejIZ0 = parcelRequire("ejIZ0");
parcelRequire("bnAYy");
var $donES = parcelRequire("donES");
var $iZX2P = parcelRequire("iZX2P");
//#region src/history/html5.ts
let $fe1f41bb07c120fb$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $fe1f41bb07c120fb$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $ejIZ0.V)(pathFromHash, "");
    }
    return (0, $ejIZ0.V)(pathname, base) + search + hash;
}
function $fe1f41bb07c120fb$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $fe1f41bb07c120fb$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $ejIZ0.k).pop,
                direction: delta ? delta > 0 ? (0, $ejIZ0.O).forward : (0, $ejIZ0.O).back : (0, $ejIZ0.O).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $ejIZ0.J)({}, history$1.state, {
                scroll: (0, $ejIZ0.C)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $fe1f41bb07c120fb$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $ejIZ0.C)() : null
    };
}
function $fe1f41bb07c120fb$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $fe1f41bb07c120fb$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $fe1f41bb07c120fb$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $ejIZ0.J)({}, history$1.state, $fe1f41bb07c120fb$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $ejIZ0.J)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $ejIZ0.C)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $ejIZ0.J)({}, $fe1f41bb07c120fb$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $fe1f41bb07c120fb$export$7b4942f78e7b8a49(base) {
    base = (0, $ejIZ0.M)(base);
    const historyNavigation = $fe1f41bb07c120fb$var$useHistoryStateNavigation(base);
    const historyListeners = $fe1f41bb07c120fb$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $ejIZ0.J)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $ejIZ0.j).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $fe1f41bb07c120fb$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $ejIZ0.A),
            {}
        ]
    ];
    let position = 0;
    base = (0, $ejIZ0.M)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $ejIZ0.k).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $ejIZ0.A),
        state: {},
        base: base,
        createHref: (0, $ejIZ0.j).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $ejIZ0.A),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $ejIZ0.O).back : (0, $ejIZ0.O).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $fe1f41bb07c120fb$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $fe1f41bb07c120fb$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $fe1f41bb07c120fb$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $fe1f41bb07c120fb$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($fe1f41bb07c120fb$var$TokenizerState || {});
const $fe1f41bb07c120fb$var$ROOT_TOKEN = {
    type: $fe1f41bb07c120fb$var$TokenType.Static,
    value: ""
};
const $fe1f41bb07c120fb$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $fe1f41bb07c120fb$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $fe1f41bb07c120fb$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $fe1f41bb07c120fb$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $fe1f41bb07c120fb$var$TokenizerState.Static) segment.push({
            type: $fe1f41bb07c120fb$var$TokenType.Static,
            value: buffer
        });
        else if (state === $fe1f41bb07c120fb$var$TokenizerState.Param || state === $fe1f41bb07c120fb$var$TokenizerState.ParamRegExp || state === $fe1f41bb07c120fb$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $fe1f41bb07c120fb$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $fe1f41bb07c120fb$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $fe1f41bb07c120fb$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $fe1f41bb07c120fb$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $fe1f41bb07c120fb$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $fe1f41bb07c120fb$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $fe1f41bb07c120fb$var$TokenizerState.Param:
                if (char === "(") state = $fe1f41bb07c120fb$var$TokenizerState.ParamRegExp;
                else if ($fe1f41bb07c120fb$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $fe1f41bb07c120fb$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $fe1f41bb07c120fb$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $fe1f41bb07c120fb$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $fe1f41bb07c120fb$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $fe1f41bb07c120fb$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $fe1f41bb07c120fb$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $fe1f41bb07c120fb$var$BASE_PARAM_PATTERN = "[^/]+?";
const $fe1f41bb07c120fb$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $fe1f41bb07c120fb$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($fe1f41bb07c120fb$var$PathScore || {});
const $fe1f41bb07c120fb$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $fe1f41bb07c120fb$var$tokensToParser(segments, extraOptions) {
    const options = (0, $ejIZ0.J)({}, $fe1f41bb07c120fb$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $fe1f41bb07c120fb$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $fe1f41bb07c120fb$var$PathScore.Segment + (options.sensitive ? $fe1f41bb07c120fb$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $fe1f41bb07c120fb$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($fe1f41bb07c120fb$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $fe1f41bb07c120fb$var$PathScore.Static;
            } else if (token.type === $fe1f41bb07c120fb$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $fe1f41bb07c120fb$var$BASE_PARAM_PATTERN;
                if (re$1 !== $fe1f41bb07c120fb$var$BASE_PARAM_PATTERN) subSegmentScore += $fe1f41bb07c120fb$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $fe1f41bb07c120fb$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $fe1f41bb07c120fb$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $fe1f41bb07c120fb$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $fe1f41bb07c120fb$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $fe1f41bb07c120fb$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $fe1f41bb07c120fb$var$TokenType.Static) path += token.value;
            else if (token.type === $fe1f41bb07c120fb$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $ejIZ0.X)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $ejIZ0.X)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $fe1f41bb07c120fb$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $fe1f41bb07c120fb$var$PathScore.Static + $fe1f41bb07c120fb$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $fe1f41bb07c120fb$var$PathScore.Static + $fe1f41bb07c120fb$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $fe1f41bb07c120fb$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $fe1f41bb07c120fb$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($fe1f41bb07c120fb$var$isLastScoreNegative(aScore)) return 1;
        if ($fe1f41bb07c120fb$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $fe1f41bb07c120fb$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $fe1f41bb07c120fb$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $fe1f41bb07c120fb$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $fe1f41bb07c120fb$var$tokensToParser($fe1f41bb07c120fb$var$tokenizePath(record.path), options);
    const matcher = (0, $ejIZ0.J)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $fe1f41bb07c120fb$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $ejIZ0.Z)($fe1f41bb07c120fb$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $fe1f41bb07c120fb$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $ejIZ0.Z)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($fe1f41bb07c120fb$var$normalizeRouteRecord((0, $ejIZ0.J)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $fe1f41bb07c120fb$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$fe1f41bb07c120fb$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($fe1f41bb07c120fb$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $ejIZ0.Q);
    }
    function removeRoute(matcherRef) {
        if ((0, $ejIZ0.S)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $fe1f41bb07c120fb$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$fe1f41bb07c120fb$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $ejIZ0.y)((0, $ejIZ0._).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $ejIZ0.J)($fe1f41bb07c120fb$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $fe1f41bb07c120fb$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $ejIZ0.y)((0, $ejIZ0._).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $ejIZ0.J)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $fe1f41bb07c120fb$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $fe1f41bb07c120fb$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $fe1f41bb07c120fb$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $fe1f41bb07c120fb$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $fe1f41bb07c120fb$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $fe1f41bb07c120fb$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $fe1f41bb07c120fb$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $ejIZ0.J)(meta, record.meta), {});
}
function $fe1f41bb07c120fb$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $fe1f41bb07c120fb$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($fe1f41bb07c120fb$var$isSameParam.bind(null, key))) return (0, $ejIZ0.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($fe1f41bb07c120fb$var$isSameParam.bind(null, key))) return (0, $ejIZ0.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $fe1f41bb07c120fb$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $ejIZ0.K)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $fe1f41bb07c120fb$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $fe1f41bb07c120fb$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($fe1f41bb07c120fb$var$isSameParam.bind(null, key))) return (0, $ejIZ0.K)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $fe1f41bb07c120fb$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($fe1f41bb07c120fb$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $fe1f41bb07c120fb$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $fe1f41bb07c120fb$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($fe1f41bb07c120fb$var$isMatchable(ancestor) && $fe1f41bb07c120fb$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $fe1f41bb07c120fb$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $fe1f41bb07c120fb$export$dcf14c9974fe2767(props) {
    const router = (0, $iZX2P.inject)((0, $ejIZ0.d));
    const currentRoute = (0, $iZX2P.inject)((0, $ejIZ0.u));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $donES.computed)(()=>{
        const to = (0, $donES.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $donES.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $ejIZ0.L).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $fe1f41bb07c120fb$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $fe1f41bb07c120fb$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $ejIZ0.L).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $donES.computed)(()=>activeRecordIndex.value > -1 && $fe1f41bb07c120fb$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $donES.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $ejIZ0.I)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($fe1f41bb07c120fb$var$guardEvent(e)) {
            const p = router[(0, $donES.unref)(props.replace) ? "replace" : "push"]((0, $donES.unref)(props.to)).catch((0, $ejIZ0.Q));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $ejIZ0.$)) {
        const instance = (0, $iZX2P.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $iZX2P.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $ejIZ0.x)((0, $donES.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $donES.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $fe1f41bb07c120fb$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $fe1f41bb07c120fb$var$RouterLinkImpl = /* @__PURE__ */ (0, $iZX2P.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $fe1f41bb07c120fb$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $donES.reactive)($fe1f41bb07c120fb$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $iZX2P.inject)((0, $ejIZ0.d));
        const elClass = (0, $donES.computed)(()=>({
                [$fe1f41bb07c120fb$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$fe1f41bb07c120fb$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $fe1f41bb07c120fb$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $iZX2P.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $fe1f41bb07c120fb$export$fce709ebdac448ed = $fe1f41bb07c120fb$var$RouterLinkImpl;
function $fe1f41bb07c120fb$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $fe1f41bb07c120fb$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $ejIZ0.X)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $fe1f41bb07c120fb$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $fe1f41bb07c120fb$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $fe1f41bb07c120fb$var$RouterViewImpl = /* @__PURE__ */ (0, $iZX2P.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $iZX2P.inject)((0, $ejIZ0.f));
        const routeToDisplay = (0, $donES.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $iZX2P.inject)((0, $ejIZ0.p), 0);
        const depth = (0, $donES.computed)(()=>{
            let initialDepth = (0, $donES.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $donES.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $iZX2P.provide)((0, $ejIZ0.p), (0, $donES.computed)(()=>depth.value + 1));
        (0, $iZX2P.provide)((0, $ejIZ0.l), matchedRouteRef);
        (0, $iZX2P.provide)((0, $ejIZ0.f), routeToDisplay);
        const viewRef = (0, $donES.ref)();
        (0, $donES.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $ejIZ0.L)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $fe1f41bb07c120fb$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $iZX2P.h)(ViewComponent, (0, $ejIZ0.J)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $ejIZ0.$) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $ejIZ0.X)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $fe1f41bb07c120fb$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $fe1f41bb07c120fb$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $fe1f41bb07c120fb$export$d941f00e9b9a537 = $fe1f41bb07c120fb$var$RouterViewImpl;
function $fe1f41bb07c120fb$var$warnDeprecatedUsage() {
    const instance = (0, $iZX2P.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $ejIZ0.K)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $fe1f41bb07c120fb$export$baddd0131ee8c05b(options) {
    const matcher = $fe1f41bb07c120fb$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $ejIZ0.h);
    const stringifyQuery$1 = options.stringifyQuery || (0, $ejIZ0.g);
    const routerHistory = options.history;
    const beforeGuards = (0, $ejIZ0.c)();
    const beforeResolveGuards = (0, $ejIZ0.c)();
    const afterGuards = (0, $ejIZ0.c)();
    const currentRoute = (0, $donES.shallowRef)((0, $ejIZ0.P));
    let pendingLocation = (0, $ejIZ0.P);
    if ((0, $ejIZ0.$) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $ejIZ0.q).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $ejIZ0.q).bind(null, (0, $ejIZ0.W));
    const decodeParams = (0, $ejIZ0.q).bind(null, (0, $ejIZ0.H));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $ejIZ0.S)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $ejIZ0.J)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $ejIZ0.R)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $ejIZ0.J)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $ejIZ0.H)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $ejIZ0.J)({}, rawLocation, {
            path: (0, $ejIZ0.R)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $ejIZ0.J)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $ejIZ0.J)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $ejIZ0.B)(stringifyQuery$1, (0, $ejIZ0.J)({}, rawLocation, {
            hash: (0, $ejIZ0.U)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $ejIZ0.J)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $ejIZ0.g) ? (0, $ejIZ0.m)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $ejIZ0.R)(parseQuery$1, to, currentRoute.value.path) : (0, $ejIZ0.J)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $ejIZ0.y)((0, $ejIZ0._).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $ejIZ0.J)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $ejIZ0.J)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $ejIZ0.J)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $ejIZ0.J)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $ejIZ0.F)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $ejIZ0.y)((0, $ejIZ0._).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $ejIZ0.b)(error) ? (0, $ejIZ0.b)(error, (0, $ejIZ0._).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $ejIZ0.b)(failure$1, (0, $ejIZ0._).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $ejIZ0.J)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $ejIZ0.J)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $ejIZ0.n)(to, from);
        guards = (0, $ejIZ0.r)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $ejIZ0.i)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $ejIZ0.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $ejIZ0.r)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $ejIZ0.i)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $ejIZ0.X)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $ejIZ0.i)(beforeEnter, to, from));
                else guards.push((0, $ejIZ0.i)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $ejIZ0.r)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $ejIZ0.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $ejIZ0.b)(err, (0, $ejIZ0._).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $ejIZ0.P);
        const state = !(0, $ejIZ0.$) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $ejIZ0.J)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $ejIZ0.J)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $ejIZ0.Q));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $ejIZ0.$) (0, $ejIZ0.E)((0, $ejIZ0.T)(from.fullPath, info.delta), (0, $ejIZ0.C)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $ejIZ0.b)(error, (0, $ejIZ0._).NAVIGATION_ABORTED | (0, $ejIZ0._).NAVIGATION_CANCELLED)) return error;
                if ((0, $ejIZ0.b)(error, (0, $ejIZ0._).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $ejIZ0.J)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $ejIZ0.b)(failure, (0, $ejIZ0._).NAVIGATION_ABORTED | (0, $ejIZ0._).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $ejIZ0.k).pop) routerHistory.go(-1, false);
                    }).catch((0, $ejIZ0.Q));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $ejIZ0.b)(failure, (0, $ejIZ0._).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $ejIZ0.k).pop && (0, $ejIZ0.b)(failure, (0, $ejIZ0._).NAVIGATION_ABORTED | (0, $ejIZ0._).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $ejIZ0.Q));
        });
    }
    let readyHandlers = (0, $ejIZ0.c)();
    let errorListeners = (0, $ejIZ0.c)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $ejIZ0.P)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $ejIZ0.$) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $ejIZ0.w)((0, $ejIZ0.T)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $iZX2P.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $ejIZ0.D)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $fe1f41bb07c120fb$export$fce709ebdac448ed);
            app.component("RouterView", $fe1f41bb07c120fb$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $donES.unref)(currentRoute)
            });
            if ((0, $ejIZ0.$) && !started && currentRoute.value === (0, $ejIZ0.P)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $ejIZ0.P)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $ejIZ0.d), router);
            app.provide((0, $ejIZ0.u), (0, $donES.shallowReactive)(reactiveRoute));
            app.provide((0, $ejIZ0.f), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $ejIZ0.P);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $ejIZ0.P);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $ejIZ0.$)) (0, $ejIZ0.t)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $fe1f41bb07c120fb$export$9a302a45f65d0572() {
    return (0, $iZX2P.inject)((0, $ejIZ0.d));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $fe1f41bb07c120fb$export$3f79f0b98112cf57(_name) {
    return (0, $iZX2P.inject)((0, $ejIZ0.u));
}

});
parcelRegister("ejIZ0", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $86cc0fcd1a4ef127$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "J", function () { return $86cc0fcd1a4ef127$export$b4171a6734a65d42; });
$parcel$export(module.exports, "q", function () { return $86cc0fcd1a4ef127$export$9e5f44173e64f162; });
$parcel$export(module.exports, "X", function () { return $86cc0fcd1a4ef127$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "Q", function () { return $86cc0fcd1a4ef127$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "Z", function () { return $86cc0fcd1a4ef127$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "K", function () { return $86cc0fcd1a4ef127$export$3466f893ebf79586; });
$parcel$export(module.exports, "U", function () { return $86cc0fcd1a4ef127$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "W", function () { return $86cc0fcd1a4ef127$export$71cec2538cb2c617; });
$parcel$export(module.exports, "H", function () { return $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "R", function () { return $86cc0fcd1a4ef127$export$db202ddc8be9136; });
$parcel$export(module.exports, "B", function () { return $86cc0fcd1a4ef127$export$ef35774e6d314e91; });
$parcel$export(module.exports, "V", function () { return $86cc0fcd1a4ef127$export$e7c866399fa523f5; });
$parcel$export(module.exports, "F", function () { return $86cc0fcd1a4ef127$export$d66501df72047452; });
$parcel$export(module.exports, "L", function () { return $86cc0fcd1a4ef127$export$61196ced6d74a310; });
$parcel$export(module.exports, "I", function () { return $86cc0fcd1a4ef127$export$9bb611d729802a56; });
$parcel$export(module.exports, "P", function () { return $86cc0fcd1a4ef127$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "k", function () { return $86cc0fcd1a4ef127$export$342063e11d6c3cad; });
$parcel$export(module.exports, "O", function () { return $86cc0fcd1a4ef127$export$c4ce752e73470fba; });
$parcel$export(module.exports, "A", function () { return $86cc0fcd1a4ef127$export$ebd11618f299a286; });
$parcel$export(module.exports, "M", function () { return $86cc0fcd1a4ef127$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "j", function () { return $86cc0fcd1a4ef127$export$35e795649ee09318; });
$parcel$export(module.exports, "C", function () { return $86cc0fcd1a4ef127$export$e7094788287c5e9b; });
$parcel$export(module.exports, "D", function () { return $86cc0fcd1a4ef127$export$96f57966bedc81b4; });
$parcel$export(module.exports, "T", function () { return $86cc0fcd1a4ef127$export$971d5caa766a69d7; });
$parcel$export(module.exports, "E", function () { return $86cc0fcd1a4ef127$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "w", function () { return $86cc0fcd1a4ef127$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $86cc0fcd1a4ef127$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "S", function () { return $86cc0fcd1a4ef127$export$25ce5a424b770e84; });
$parcel$export(module.exports, "_", function () { return $86cc0fcd1a4ef127$export$71511d61b312f219; });
$parcel$export(module.exports, "y", function () { return $86cc0fcd1a4ef127$export$4a5767248b18ef41; });
$parcel$export(module.exports, "b", function () { return $86cc0fcd1a4ef127$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "h", function () { return $86cc0fcd1a4ef127$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "g", function () { return $86cc0fcd1a4ef127$export$39b482c5e57630a8; });
$parcel$export(module.exports, "m", function () { return $86cc0fcd1a4ef127$export$953cecd6e717a553; });
$parcel$export(module.exports, "l", function () { return $86cc0fcd1a4ef127$export$882b5998b3b9117c; });
$parcel$export(module.exports, "p", function () { return $86cc0fcd1a4ef127$export$ffb5f4729a158638; });
$parcel$export(module.exports, "d", function () { return $86cc0fcd1a4ef127$export$4368d992c4eafac0; });
$parcel$export(module.exports, "u", function () { return $86cc0fcd1a4ef127$export$3b14a55fb2447963; });
$parcel$export(module.exports, "f", function () { return $86cc0fcd1a4ef127$export$2d1720544b23b823; });
$parcel$export(module.exports, "c", function () { return $86cc0fcd1a4ef127$export$db3b6bfb95261072; });
$parcel$export(module.exports, "i", function () { return $86cc0fcd1a4ef127$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "r", function () { return $86cc0fcd1a4ef127$export$43caf9889c228507; });
$parcel$export(module.exports, "n", function () { return $86cc0fcd1a4ef127$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "t", function () { return $86cc0fcd1a4ef127$export$625550452a3fa3ec; });
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $donES = parcelRequire("donES");

var $4J6PC = parcelRequire("4J6PC");
//#region src/utils/env.ts
const $86cc0fcd1a4ef127$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $86cc0fcd1a4ef127$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $86cc0fcd1a4ef127$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $86cc0fcd1a4ef127$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $86cc0fcd1a4ef127$var$isRouteComponent(obj.default);
}
const $86cc0fcd1a4ef127$export$b4171a6734a65d42 = Object.assign;
function $86cc0fcd1a4ef127$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $86cc0fcd1a4ef127$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $86cc0fcd1a4ef127$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $86cc0fcd1a4ef127$export$78acf4525d8a74c4 = Array.isArray;
function $86cc0fcd1a4ef127$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $86cc0fcd1a4ef127$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $86cc0fcd1a4ef127$var$HASH_RE = /#/g;
const $86cc0fcd1a4ef127$var$AMPERSAND_RE = /&/g;
const $86cc0fcd1a4ef127$var$SLASH_RE = /\//g;
const $86cc0fcd1a4ef127$var$EQUAL_RE = /=/g;
const $86cc0fcd1a4ef127$var$IM_RE = /\?/g;
const $86cc0fcd1a4ef127$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $86cc0fcd1a4ef127$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $86cc0fcd1a4ef127$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $86cc0fcd1a4ef127$var$ENC_CARET_RE = /%5E/g;
const $86cc0fcd1a4ef127$var$ENC_BACKTICK_RE = /%60/g;
const $86cc0fcd1a4ef127$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $86cc0fcd1a4ef127$var$ENC_PIPE_RE = /%7C/g;
const $86cc0fcd1a4ef127$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $86cc0fcd1a4ef127$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $86cc0fcd1a4ef127$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($86cc0fcd1a4ef127$var$ENC_PIPE_RE, "|").replace($86cc0fcd1a4ef127$var$ENC_BRACKET_OPEN_RE, "[").replace($86cc0fcd1a4ef127$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $86cc0fcd1a4ef127$export$3a6d5c9ae78a2c08(text) {
    return $86cc0fcd1a4ef127$var$commonEncode(text).replace($86cc0fcd1a4ef127$var$ENC_CURLY_OPEN_RE, "{").replace($86cc0fcd1a4ef127$var$ENC_CURLY_CLOSE_RE, "}").replace($86cc0fcd1a4ef127$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $86cc0fcd1a4ef127$var$encodeQueryValue(text) {
    return $86cc0fcd1a4ef127$var$commonEncode(text).replace($86cc0fcd1a4ef127$var$PLUS_RE, "%2B").replace($86cc0fcd1a4ef127$var$ENC_SPACE_RE, "+").replace($86cc0fcd1a4ef127$var$HASH_RE, "%23").replace($86cc0fcd1a4ef127$var$AMPERSAND_RE, "%26").replace($86cc0fcd1a4ef127$var$ENC_BACKTICK_RE, "`").replace($86cc0fcd1a4ef127$var$ENC_CURLY_OPEN_RE, "{").replace($86cc0fcd1a4ef127$var$ENC_CURLY_CLOSE_RE, "}").replace($86cc0fcd1a4ef127$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $86cc0fcd1a4ef127$var$encodeQueryKey(text) {
    return $86cc0fcd1a4ef127$var$encodeQueryValue(text).replace($86cc0fcd1a4ef127$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $86cc0fcd1a4ef127$export$2329c99376c9d0a4(text) {
    return $86cc0fcd1a4ef127$var$commonEncode(text).replace($86cc0fcd1a4ef127$var$HASH_RE, "%23").replace($86cc0fcd1a4ef127$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $86cc0fcd1a4ef127$export$71cec2538cb2c617(text) {
    return $86cc0fcd1a4ef127$export$2329c99376c9d0a4(text).replace($86cc0fcd1a4ef127$var$SLASH_RE, "%2F");
}
function $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $86cc0fcd1a4ef127$var$TRAILING_SLASH_RE = /\/$/;
const $86cc0fcd1a4ef127$var$removeTrailingSlash = (path)=>path.replace($86cc0fcd1a4ef127$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $86cc0fcd1a4ef127$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $86cc0fcd1a4ef127$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $86cc0fcd1a4ef127$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $86cc0fcd1a4ef127$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $86cc0fcd1a4ef127$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $86cc0fcd1a4ef127$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $86cc0fcd1a4ef127$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $86cc0fcd1a4ef127$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $86cc0fcd1a4ef127$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $86cc0fcd1a4ef127$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $86cc0fcd1a4ef127$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$86cc0fcd1a4ef127$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $86cc0fcd1a4ef127$var$isSameRouteLocationParamsValue(a, b) {
    return $86cc0fcd1a4ef127$export$78acf4525d8a74c4(a) ? $86cc0fcd1a4ef127$var$isEquivalentArray(a, b) : $86cc0fcd1a4ef127$export$78acf4525d8a74c4(b) ? $86cc0fcd1a4ef127$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $86cc0fcd1a4ef127$var$isEquivalentArray(a, b) {
    return $86cc0fcd1a4ef127$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $86cc0fcd1a4ef127$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $86cc0fcd1a4ef127$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $86cc0fcd1a4ef127$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $86cc0fcd1a4ef127$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $86cc0fcd1a4ef127$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $86cc0fcd1a4ef127$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($86cc0fcd1a4ef127$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $86cc0fcd1a4ef127$var$removeTrailingSlash(base);
}
const $86cc0fcd1a4ef127$var$BEFORE_HASH_RE = /^[^#]+#/;
function $86cc0fcd1a4ef127$export$35e795649ee09318(base, location) {
    return base.replace($86cc0fcd1a4ef127$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $86cc0fcd1a4ef127$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $86cc0fcd1a4ef127$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $86cc0fcd1a4ef127$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $86cc0fcd1a4ef127$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $86cc0fcd1a4ef127$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $86cc0fcd1a4ef127$var$scrollPositions = /* @__PURE__ */ new Map();
function $86cc0fcd1a4ef127$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $86cc0fcd1a4ef127$var$scrollPositions.set(key, scrollPosition);
}
function $86cc0fcd1a4ef127$export$efccba1c4a2ef57b(key) {
    const scroll = $86cc0fcd1a4ef127$var$scrollPositions.get(key);
    $86cc0fcd1a4ef127$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $86cc0fcd1a4ef127$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $86cc0fcd1a4ef127$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $86cc0fcd1a4ef127$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $86cc0fcd1a4ef127$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $86cc0fcd1a4ef127$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $86cc0fcd1a4ef127$var$ErrorTypeMessages = {
    [$86cc0fcd1a4ef127$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$86cc0fcd1a4ef127$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $86cc0fcd1a4ef127$export$4a5767248b18ef41(type, params) {
    return $86cc0fcd1a4ef127$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$86cc0fcd1a4ef127$var$NavigationFailureSymbol]: true
    }, params);
}
function $86cc0fcd1a4ef127$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $86cc0fcd1a4ef127$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $86cc0fcd1a4ef127$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $86cc0fcd1a4ef127$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $86cc0fcd1a4ef127$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $86cc0fcd1a4ef127$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($86cc0fcd1a4ef127$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$86cc0fcd1a4ef127$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $86cc0fcd1a4ef127$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $86cc0fcd1a4ef127$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($86cc0fcd1a4ef127$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $86cc0fcd1a4ef127$var$encodeQueryValue(v)) : [
            value && $86cc0fcd1a4ef127$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $86cc0fcd1a4ef127$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $86cc0fcd1a4ef127$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $86cc0fcd1a4ef127$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $86cc0fcd1a4ef127$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $86cc0fcd1a4ef127$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $86cc0fcd1a4ef127$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $86cc0fcd1a4ef127$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $86cc0fcd1a4ef127$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $86cc0fcd1a4ef127$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $iZX2P.onUnmounted)(removeFromList);
    (0, $iZX2P.onDeactivated)(removeFromList);
    (0, $iZX2P.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $86cc0fcd1a4ef127$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $iZX2P.inject)($86cc0fcd1a4ef127$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $86cc0fcd1a4ef127$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $86cc0fcd1a4ef127$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $iZX2P.inject)($86cc0fcd1a4ef127$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $86cc0fcd1a4ef127$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $86cc0fcd1a4ef127$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($86cc0fcd1a4ef127$export$4a5767248b18ef41($86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($86cc0fcd1a4ef127$export$d141bba7fdc215a3(valid)) reject($86cc0fcd1a4ef127$export$4a5767248b18ef41($86cc0fcd1a4ef127$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $86cc0fcd1a4ef127$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $86cc0fcd1a4ef127$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $86cc0fcd1a4ef127$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($86cc0fcd1a4ef127$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($86cc0fcd1a4ef127$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $86cc0fcd1a4ef127$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $86cc0fcd1a4ef127$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $86cc0fcd1a4ef127$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $86cc0fcd1a4ef127$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $86cc0fcd1a4ef127$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$86cc0fcd1a4ef127$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$86cc0fcd1a4ef127$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $86cc0fcd1a4ef127$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $86cc0fcd1a4ef127$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$86cc0fcd1a4ef127$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $86cc0fcd1a4ef127$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $86cc0fcd1a4ef127$var$routerId = 0;
function $86cc0fcd1a4ef127$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $86cc0fcd1a4ef127$var$routerId++;
    (0, $4J6PC.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $86cc0fcd1a4ef127$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $86cc0fcd1a4ef127$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $86cc0fcd1a4ef127$var$PINK_500
                });
            }
            if ($86cc0fcd1a4ef127$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $86cc0fcd1a4ef127$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $86cc0fcd1a4ef127$var$RED_100;
                        textColor = $86cc0fcd1a4ef127$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $86cc0fcd1a4ef127$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $86cc0fcd1a4ef127$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $donES.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $86cc0fcd1a4ef127$var$formatDisplay("beforeEach"),
                from: $86cc0fcd1a4ef127$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $86cc0fcd1a4ef127$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $86cc0fcd1a4ef127$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $86cc0fcd1a4ef127$var$formatDisplay("\u274C");
            } else data.status = $86cc0fcd1a4ef127$var$formatDisplay("\u2705");
            data.from = $86cc0fcd1a4ef127$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $86cc0fcd1a4ef127$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($86cc0fcd1a4ef127$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$86cc0fcd1a4ef127$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$86cc0fcd1a4ef127$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($86cc0fcd1a4ef127$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $86cc0fcd1a4ef127$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $86cc0fcd1a4ef127$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $86cc0fcd1a4ef127$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$86cc0fcd1a4ef127$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $86cc0fcd1a4ef127$var$PINK_500 = 15485081;
const $86cc0fcd1a4ef127$var$BLUE_600 = 2450411;
const $86cc0fcd1a4ef127$var$LIME_500 = 8702998;
const $86cc0fcd1a4ef127$var$CYAN_400 = 2282478;
const $86cc0fcd1a4ef127$var$ORANGE_400 = 16486972;
const $86cc0fcd1a4ef127$var$DARK = 6710886;
const $86cc0fcd1a4ef127$var$RED_100 = 16704226;
const $86cc0fcd1a4ef127$var$RED_700 = 12131356;
function $86cc0fcd1a4ef127$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $86cc0fcd1a4ef127$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $86cc0fcd1a4ef127$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $86cc0fcd1a4ef127$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $86cc0fcd1a4ef127$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $86cc0fcd1a4ef127$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $86cc0fcd1a4ef127$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($86cc0fcd1a4ef127$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($86cc0fcd1a4ef127$var$formatRouteRecordForInspector)
    };
}
let $86cc0fcd1a4ef127$var$routeRecordId = 0;
const $86cc0fcd1a4ef127$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $86cc0fcd1a4ef127$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $86cc0fcd1a4ef127$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$86cc0fcd1a4ef127$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$86cc0fcd1a4ef127$var$markRouteRecordActive(childRoute, currentRoute));
}
function $86cc0fcd1a4ef127$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($86cc0fcd1a4ef127$var$resetMatchStateOnRouteRecord);
}
function $86cc0fcd1a4ef127$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($86cc0fcd1a4ef127$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$86cc0fcd1a4ef127$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $86cc0fcd1a4ef127$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$86cc0fcd1a4ef127$var$isRouteMatching(child, filter));
}
function $86cc0fcd1a4ef127$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}

});


parcelRegister("1MrF5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14bfbb26396b64fc$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");

var $2q1Wz = parcelRequire("2q1Wz");

var $gHDhU = parcelRequire("gHDhU");

var $d4IYa = parcelRequire("d4IYa");

var $dIkvF = parcelRequire("dIkvF");

var $LT9Rn = parcelRequire("LT9Rn");

var $1B92U = parcelRequire("1B92U");

var $dKudV = parcelRequire("dKudV");

var $amc3D = parcelRequire("amc3D");

var $8TCFf = parcelRequire("8TCFf");

var $gazI4 = parcelRequire("gazI4");

var $8ATk6 = parcelRequire("8ATk6");
var $14bfbb26396b64fc$export$2e2bcd8739ae039 = (0, $2q1Wz.createStore)({
    state: {
        toast: {
            type: null,
            message: null,
            duration: null
        },
        accountModalShow: false,
        notificationModalShow: false,
        adminBannerHidden: false,
        countries: {},
        states: {},
        institutionTypes: [],
        surveyOptions: [],
        jobTypeOptions: [],
        iceServers: [],
        cancelSurveyOptions: []
    },
    getters: {
        toast: (state)=>state.toast,
        accountModalShow: (state)=>state.accountModalShow,
        notificationModalShow: (state)=>state.notificationModalShow,
        adminBannerHidden: (state)=>state.adminBannerHidden,
        countries: (state)=>state.countries,
        states: (state)=>state.states,
        institutionTypes: (state)=>state.institutionTypes,
        surveyOptions: (state)=>state.surveyOptions,
        jobTypeOptions: (state)=>state.jobTypeOptions,
        iceServers: (state)=>state.iceServers,
        cancelSurveyOptions: (state)=>state.cancelSurveyOptions
    },
    mutations: {
        showToast (state, { type: type, message: message, duration: duration }) {
            state.toast = {
                type: type,
                message: message,
                duration: duration
            };
        },
        toggleAccountModal (state, show = true) {
            state.accountModalShow = show;
        },
        toggleNotificationModal (state, show = true) {
            state.notificationModalShow = show;
        },
        setAdminBannerHidden (state, hidden) {
            state.adminBannerHidden = hidden;
        },
        setAccountSettings (state, settings) {
            state.countries = settings.countries;
            state.states = settings.states;
            state.institutionTypes = settings.institution_types;
        },
        setStates (state, states) {
            state.states = states;
        },
        setSurveyOptions (state, surveyOptions) {
            state.surveyOptions = surveyOptions;
        },
        setJobTypeOptions (state, jobTypeOptions) {
            state.jobTypeOptions = jobTypeOptions;
        },
        setIceServers (state, iceServers) {
            state.iceServers = iceServers;
        },
        setCancelSurveyOptions (state, cancelSurveyOptions) {
            state.cancelSurveyOptions = cancelSurveyOptions;
        }
    },
    actions: {
        showToast ({ commit: commit }, { type: type, message: message, duration: duration }) {
            commit("showToast", {
                type: type,
                message: message,
                duration: duration
            });
        },
        toggleAccountModal ({ commit: commit }, show = true) {
            commit("toggleAccountModal", show);
        },
        toggleNotificationModal ({ commit: commit }, show = true) {
            commit("toggleNotificationModal", show);
        },
        setAdminBannerHidden ({ commit: commit }, hidden) {
            commit("setAdminBannerHidden", hidden);
        },
        loadAccountSettings ({ commit: commit }) {
            return (0, $lKfjl.default).get("/account_settings").then((response)=>{
                commit("setAccountSettings", response.data);
                return response;
            }).catch((error)=>error.response);
        },
        loadStates ({ commit: commit }, country) {
            return (0, $lKfjl.default).get("/load_states", {
                params: {
                    country: country
                }
            }).then((response)=>{
                commit("setStates", response.data || {});
                return response;
            }).catch((error)=>error.response);
        },
        loadSurveyOptions ({ commit: commit }) {
            return (0, $lKfjl.default).get("/survey_options").then((res)=>{
                commit("setSurveyOptions", res.data.survey_options);
                commit("setJobTypeOptions", res.data.job_type_options);
                return res;
            }).catch((e)=>e.response);
        },
        loadIceServers ({ commit: commit }) {
            return (0, $lKfjl.default).get("/ice_servers").then((res)=>{
                commit("setIceServers", res.data);
                return res;
            }).catch((e)=>e.response);
        },
        loadCancelSurveyOptions ({ commit: commit }) {
            return (0, $lKfjl.default).get("/cancel_survey_options").then((res)=>{
                commit("setCancelSurveyOptions", res.data);
                return res;
            }).catch((e)=>e.response);
        }
    },
    modules: {
        dashboard: (0, $gHDhU.default),
        sessions: (0, $d4IYa.default),
        students: (0, $dIkvF.default),
        episodes: (0, $LT9Rn.default),
        classRooms: (0, $1B92U.default),
        curriculum: (0, $dKudV.default),
        payments: (0, $amc3D.default),
        subscriptions: (0, $8TCFf.default),
        notifications: (0, $gazI4.default),
        groupAdmin: (0, $8ATk6.default)
    }
});

});
parcelRegister("lKfjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd49c55120e8a1ed$export$2e2bcd8739ae039; });
parcelRequire("8iBD7");
var $guAph = parcelRequire("guAph");
const $fd49c55120e8a1ed$var$axiosInstance = (0, $guAph.default).create({
    timeout: 15000,
    headers: {
        common: {
            "content-type": "application/json"
        }
    }
});
$fd49c55120e8a1ed$var$axiosInstance.interceptors.request.use((config)=>{
    config.headers["X-CSRF-Token"] = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    return config;
});
const $fd49c55120e8a1ed$var$refreshCsrfToken = (response)=>{
    const token = response?.headers?.["x-csrf-token"];
    if (token) document.querySelector('meta[name="csrf-token"]')?.setAttribute("content", token);
    return response;
};
$fd49c55120e8a1ed$var$axiosInstance.interceptors.response.use($fd49c55120e8a1ed$var$refreshCsrfToken, (error)=>{
    $fd49c55120e8a1ed$var$refreshCsrfToken(error.response);
    return Promise.reject(error);
});
const $fd49c55120e8a1ed$var$rootURL = `${window.location.protocol}//${window.location.host}`;
$fd49c55120e8a1ed$var$axiosInstance.defaults.baseURL = `${$fd49c55120e8a1ed$var$rootURL}/api`;
var // axios.defaults.withCredentials = true;
$fd49c55120e8a1ed$export$2e2bcd8739ae039 = $fd49c55120e8a1ed$var$axiosInstance;

});
parcelRegister("8iBD7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("guAph")).default; });

var $guAph = parcelRequire("guAph");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $60ad31acf9d8bf7b$export$1c00760e9e5a4e95, AxiosError: $60ad31acf9d8bf7b$export$c1fbed17c2f6a328, CanceledError: $60ad31acf9d8bf7b$export$1ab0c6b20d94fa14, isCancel: $60ad31acf9d8bf7b$export$3b22524397b493c6, CancelToken: $60ad31acf9d8bf7b$export$fd08e3cb425f0d61, VERSION: $60ad31acf9d8bf7b$export$a4ad2735b021c132, all: $60ad31acf9d8bf7b$export$84bf76cd7afc7469, Cancel: $60ad31acf9d8bf7b$export$848c9b7ead0df967, isAxiosError: $60ad31acf9d8bf7b$export$fbafdbe06a5b5a9a, spread: $60ad31acf9d8bf7b$export$3ae0fd4797ed47c8, toFormData: $60ad31acf9d8bf7b$export$10ae0d317ea97f8b, AxiosHeaders: $60ad31acf9d8bf7b$export$4e7d6ff0f3e6520, HttpStatusCode: $60ad31acf9d8bf7b$export$a972f69c851492b3, formToJSON: $60ad31acf9d8bf7b$export$86d7c59254d6a2c9, getAdapter: $60ad31acf9d8bf7b$export$17ddc20a97d669e2, mergeConfig: $60ad31acf9d8bf7b$export$7ec1ebcfa9d8bd6a, create: $60ad31acf9d8bf7b$export$185802fd694ee1f5 } = (0, $guAph.default);

});
parcelRegister("guAph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01bb04d86a30ac7$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $gVJYF = parcelRequire("gVJYF");

var $20Wva = parcelRequire("20Wva");

var $3crzk = parcelRequire("3crzk");

var $93RRF = parcelRequire("93RRF");

var $eK2l3 = parcelRequire("eK2l3");

var $3Q4OC = parcelRequire("3Q4OC");

var $UHUFF = parcelRequire("UHUFF");

var $6m8of = parcelRequire("6m8of");

var $4plQG = parcelRequire("4plQG");

var $8hob7 = parcelRequire("8hob7");

var $l4isF = parcelRequire("l4isF");

var $ffFI5 = parcelRequire("ffFI5");

var $dQQb2 = parcelRequire("dQQb2");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $eVzrl = parcelRequire("eVzrl");

var $5KB5o = parcelRequire("5KB5o");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c01bb04d86a30ac7$var$createInstance(defaultConfig) {
    const context = new (0, $20Wva.default)(defaultConfig);
    const instance = (0, $gVJYF.default)((0, $20Wva.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $5uQZ5.default).extend(instance, (0, $20Wva.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $5uQZ5.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c01bb04d86a30ac7$var$createInstance((0, $3crzk.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c01bb04d86a30ac7$var$axios = $c01bb04d86a30ac7$var$createInstance((0, $93RRF.default));
// Expose Axios class to allow class inheritance
$c01bb04d86a30ac7$var$axios.Axios = (0, $20Wva.default);
// Expose Cancel & CancelToken
$c01bb04d86a30ac7$var$axios.CanceledError = (0, $3Q4OC.default);
$c01bb04d86a30ac7$var$axios.CancelToken = (0, $UHUFF.default);
$c01bb04d86a30ac7$var$axios.isCancel = (0, $6m8of.default);
$c01bb04d86a30ac7$var$axios.VERSION = (0, $4plQG.VERSION);
$c01bb04d86a30ac7$var$axios.toFormData = (0, $8hob7.default);
// Expose AxiosError class
$c01bb04d86a30ac7$var$axios.AxiosError = (0, $l4isF.default);
// alias for CanceledError for backward compatibility
$c01bb04d86a30ac7$var$axios.Cancel = $c01bb04d86a30ac7$var$axios.CanceledError;
// Expose all/spread
$c01bb04d86a30ac7$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c01bb04d86a30ac7$var$axios.spread = (0, $ffFI5.default);
// Expose isAxiosError
$c01bb04d86a30ac7$var$axios.isAxiosError = (0, $dQQb2.default);
// Expose mergeConfig
$c01bb04d86a30ac7$var$axios.mergeConfig = (0, $3crzk.default);
$c01bb04d86a30ac7$var$axios.AxiosHeaders = (0, $3ZjYJ.default);
$c01bb04d86a30ac7$var$axios.formToJSON = (thing)=>(0, $eK2l3.default)((0, $5uQZ5.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$c01bb04d86a30ac7$var$axios.getAdapter = (0, $eVzrl.default).getAdapter;
$c01bb04d86a30ac7$var$axios.HttpStatusCode = (0, $5KB5o.default);
$c01bb04d86a30ac7$var$axios.default = $c01bb04d86a30ac7$var$axios;
var // this module should only have a default export
$c01bb04d86a30ac7$export$2e2bcd8739ae039 = $c01bb04d86a30ac7$var$axios;

});
parcelRegister("5uQZ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4008daabecafa6be$export$2e2bcd8739ae039; });

var $gVJYF = parcelRequire("gVJYF");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $4008daabecafa6be$var$toString } = Object.prototype;
const { getPrototypeOf: $4008daabecafa6be$var$getPrototypeOf } = Object;
const { iterator: $4008daabecafa6be$var$iterator, toStringTag: $4008daabecafa6be$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $4008daabecafa6be$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $4008daabecafa6be$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $4008daabecafa6be$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $4008daabecafa6be$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($4008daabecafa6be$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $4008daabecafa6be$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $4008daabecafa6be$var$getPrototypeOf(obj);
        if ($4008daabecafa6be$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($4008daabecafa6be$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $4008daabecafa6be$var$getSafeProp = (obj, prop)=>obj != null && $4008daabecafa6be$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $4008daabecafa6be$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $4008daabecafa6be$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $4008daabecafa6be$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $4008daabecafa6be$var$getPrototypeOf(current);
        if ($4008daabecafa6be$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($4008daabecafa6be$var$isUnsafeObjectKey(prop)) continue;
            if (!$4008daabecafa6be$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $4008daabecafa6be$var$kindOf = ((cache)=>(thing)=>{
        const str = $4008daabecafa6be$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4008daabecafa6be$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4008daabecafa6be$var$kindOf(thing) === type;
};
const $4008daabecafa6be$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4008daabecafa6be$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4008daabecafa6be$var$isUndefined = $4008daabecafa6be$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4008daabecafa6be$var$isBuffer(val) {
    return val !== null && !$4008daabecafa6be$var$isUndefined(val) && val.constructor !== null && !$4008daabecafa6be$var$isUndefined(val.constructor) && $4008daabecafa6be$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4008daabecafa6be$var$isArrayBuffer = $4008daabecafa6be$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4008daabecafa6be$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4008daabecafa6be$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4008daabecafa6be$var$isString = $4008daabecafa6be$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4008daabecafa6be$var$isFunction = $4008daabecafa6be$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4008daabecafa6be$var$isNumber = $4008daabecafa6be$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4008daabecafa6be$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4008daabecafa6be$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4008daabecafa6be$var$isPlainObject = (val)=>{
    if (!$4008daabecafa6be$var$isObject(val)) return false;
    const prototype = $4008daabecafa6be$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $4008daabecafa6be$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$4008daabecafa6be$var$hasOwnInPrototypeChain(val, $4008daabecafa6be$var$toStringTag) && !$4008daabecafa6be$var$hasOwnInPrototypeChain(val, $4008daabecafa6be$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $4008daabecafa6be$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$4008daabecafa6be$var$isObject(val) || $4008daabecafa6be$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4008daabecafa6be$var$isDate = $4008daabecafa6be$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4008daabecafa6be$var$isFile = $4008daabecafa6be$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $4008daabecafa6be$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $4008daabecafa6be$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4008daabecafa6be$var$isBlob = $4008daabecafa6be$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $4008daabecafa6be$var$isFileList = $4008daabecafa6be$var$kindOfTest('FileList');
const $4008daabecafa6be$var$isSet = $4008daabecafa6be$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4008daabecafa6be$var$isStream = (val)=>$4008daabecafa6be$var$isObject(val) && $4008daabecafa6be$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $4008daabecafa6be$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $4008daabecafa6be$var$G = $4008daabecafa6be$var$getGlobal();
const $4008daabecafa6be$var$FormDataCtor = typeof $4008daabecafa6be$var$G.FormData !== 'undefined' ? $4008daabecafa6be$var$G.FormData : undefined;
const $4008daabecafa6be$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($4008daabecafa6be$var$FormDataCtor && thing instanceof $4008daabecafa6be$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $4008daabecafa6be$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$4008daabecafa6be$var$isFunction(thing.append)) return false;
    const kind = $4008daabecafa6be$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $4008daabecafa6be$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4008daabecafa6be$var$isURLSearchParams = $4008daabecafa6be$var$kindOfTest('URLSearchParams');
const [$4008daabecafa6be$var$isReadableStream, $4008daabecafa6be$var$isRequest, $4008daabecafa6be$var$isResponse, $4008daabecafa6be$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($4008daabecafa6be$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4008daabecafa6be$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $4008daabecafa6be$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4008daabecafa6be$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($4008daabecafa6be$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $4008daabecafa6be$var$findKey(obj, key) {
    if ($4008daabecafa6be$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4008daabecafa6be$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $4008daabecafa6be$var$isContextDefined = (context)=>!$4008daabecafa6be$var$isUndefined(context) && context !== $4008daabecafa6be$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4008daabecafa6be$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $4008daabecafa6be$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $4008daabecafa6be$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $4008daabecafa6be$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($4008daabecafa6be$var$isPlainObject(existing) && $4008daabecafa6be$var$isPlainObject(val)) result[targetKey] = $4008daabecafa6be$var$merge(existing, val);
        else if ($4008daabecafa6be$var$isPlainObject(val)) result[targetKey] = $4008daabecafa6be$var$merge({}, val);
        else if ($4008daabecafa6be$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$4008daabecafa6be$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $4008daabecafa6be$var$isBuffer(source)) continue;
        $4008daabecafa6be$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $4008daabecafa6be$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($4008daabecafa6be$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4008daabecafa6be$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4008daabecafa6be$var$forEach(b, (val, key)=>{
        if (thisArg && $4008daabecafa6be$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $gVJYF.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4008daabecafa6be$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4008daabecafa6be$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4008daabecafa6be$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4008daabecafa6be$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4008daabecafa6be$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4008daabecafa6be$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4008daabecafa6be$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4008daabecafa6be$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4008daabecafa6be$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $4008daabecafa6be$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4008daabecafa6be$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$4008daabecafa6be$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4008daabecafa6be$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4008daabecafa6be$var$isHTMLForm = $4008daabecafa6be$var$kindOfTest('HTMLFormElement');
const $4008daabecafa6be$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $4008daabecafa6be$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4008daabecafa6be$var$isRegExp = $4008daabecafa6be$var$kindOfTest('RegExp');
const $4008daabecafa6be$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4008daabecafa6be$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4008daabecafa6be$var$freezeMethods = (obj)=>{
    $4008daabecafa6be$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4008daabecafa6be$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$4008daabecafa6be$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $4008daabecafa6be$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4008daabecafa6be$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4008daabecafa6be$var$noop = ()=>{};
const $4008daabecafa6be$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4008daabecafa6be$var$isSpecCompliantForm(thing) {
    return !!(thing && $4008daabecafa6be$var$isFunction(thing.append) && thing[$4008daabecafa6be$var$toStringTag] === 'FormData' && thing[$4008daabecafa6be$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $4008daabecafa6be$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($4008daabecafa6be$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($4008daabecafa6be$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($4008daabecafa6be$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$4008daabecafa6be$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $4008daabecafa6be$var$isArray(source) ? [] : {};
                    $4008daabecafa6be$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$4008daabecafa6be$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $4008daabecafa6be$var$isAsyncFn = $4008daabecafa6be$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $4008daabecafa6be$var$isThenable = (thing)=>thing && ($4008daabecafa6be$var$isObject(thing) || $4008daabecafa6be$var$isFunction(thing)) && $4008daabecafa6be$var$isFunction(thing.then) && $4008daabecafa6be$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $4008daabecafa6be$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $4008daabecafa6be$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $4008daabecafa6be$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $4008daabecafa6be$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $4008daabecafa6be$var$isFunction($4008daabecafa6be$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $4008daabecafa6be$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($4008daabecafa6be$var$_global) : $4008daabecafa6be$var$_setImmediate;
// *********************
const $4008daabecafa6be$var$isIterable = (thing)=>thing != null && $4008daabecafa6be$var$isFunction(thing[$4008daabecafa6be$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $4008daabecafa6be$var$isSafeIterable = (thing)=>thing != null && $4008daabecafa6be$var$hasOwnInPrototypeChain(thing, $4008daabecafa6be$var$iterator) && $4008daabecafa6be$var$isIterable(thing);
var $4008daabecafa6be$export$2e2bcd8739ae039 = {
    isArray: $4008daabecafa6be$var$isArray,
    isArrayBuffer: $4008daabecafa6be$var$isArrayBuffer,
    isBuffer: $4008daabecafa6be$var$isBuffer,
    isFormData: $4008daabecafa6be$var$isFormData,
    isArrayBufferView: $4008daabecafa6be$var$isArrayBufferView,
    isString: $4008daabecafa6be$var$isString,
    isNumber: $4008daabecafa6be$var$isNumber,
    isBoolean: $4008daabecafa6be$var$isBoolean,
    isObject: $4008daabecafa6be$var$isObject,
    isPlainObject: $4008daabecafa6be$var$isPlainObject,
    isEmptyObject: $4008daabecafa6be$var$isEmptyObject,
    isReadableStream: $4008daabecafa6be$var$isReadableStream,
    isRequest: $4008daabecafa6be$var$isRequest,
    isResponse: $4008daabecafa6be$var$isResponse,
    isHeaders: $4008daabecafa6be$var$isHeaders,
    isUndefined: $4008daabecafa6be$var$isUndefined,
    isDate: $4008daabecafa6be$var$isDate,
    isFile: $4008daabecafa6be$var$isFile,
    isReactNativeBlob: $4008daabecafa6be$var$isReactNativeBlob,
    isReactNative: $4008daabecafa6be$var$isReactNative,
    isBlob: $4008daabecafa6be$var$isBlob,
    isRegExp: $4008daabecafa6be$var$isRegExp,
    isFunction: $4008daabecafa6be$var$isFunction,
    isStream: $4008daabecafa6be$var$isStream,
    isURLSearchParams: $4008daabecafa6be$var$isURLSearchParams,
    isTypedArray: $4008daabecafa6be$var$isTypedArray,
    isFileList: $4008daabecafa6be$var$isFileList,
    forEach: $4008daabecafa6be$var$forEach,
    merge: $4008daabecafa6be$var$merge,
    extend: $4008daabecafa6be$var$extend,
    trim: $4008daabecafa6be$var$trim,
    stripBOM: $4008daabecafa6be$var$stripBOM,
    inherits: $4008daabecafa6be$var$inherits,
    toFlatObject: $4008daabecafa6be$var$toFlatObject,
    kindOf: $4008daabecafa6be$var$kindOf,
    kindOfTest: $4008daabecafa6be$var$kindOfTest,
    endsWith: $4008daabecafa6be$var$endsWith,
    toArray: $4008daabecafa6be$var$toArray,
    forEachEntry: $4008daabecafa6be$var$forEachEntry,
    matchAll: $4008daabecafa6be$var$matchAll,
    isHTMLForm: $4008daabecafa6be$var$isHTMLForm,
    hasOwnProperty: $4008daabecafa6be$var$hasOwnProperty,
    hasOwnProp: $4008daabecafa6be$var$hasOwnProperty,
    hasOwnInPrototypeChain: $4008daabecafa6be$var$hasOwnInPrototypeChain,
    getSafeProp: $4008daabecafa6be$var$getSafeProp,
    toSafeFlatObject: $4008daabecafa6be$var$toSafeFlatObject,
    reduceDescriptors: $4008daabecafa6be$var$reduceDescriptors,
    freezeMethods: $4008daabecafa6be$var$freezeMethods,
    toObjectSet: $4008daabecafa6be$var$toObjectSet,
    toCamelCase: $4008daabecafa6be$var$toCamelCase,
    noop: $4008daabecafa6be$var$noop,
    toFiniteNumber: $4008daabecafa6be$var$toFiniteNumber,
    findKey: $4008daabecafa6be$var$findKey,
    global: $4008daabecafa6be$var$_global,
    isContextDefined: $4008daabecafa6be$var$isContextDefined,
    isSpecCompliantForm: $4008daabecafa6be$var$isSpecCompliantForm,
    toJSONObject: $4008daabecafa6be$var$toJSONObject,
    isAsyncFn: $4008daabecafa6be$var$isAsyncFn,
    isThenable: $4008daabecafa6be$var$isThenable,
    setImmediate: $4008daabecafa6be$var$_setImmediate,
    asap: $4008daabecafa6be$var$asap,
    isIterable: $4008daabecafa6be$var$isIterable,
    isSafeIterable: $4008daabecafa6be$var$isSafeIterable
};

});
parcelRegister("gVJYF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c535a260acd784e6$export$2e2bcd8739ae039; });
'use strict';
function $c535a260acd784e6$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("20Wva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1778f61363860754$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $9Fl3u = parcelRequire("9Fl3u");

var $gsmxT = parcelRequire("gsmxT");

var $dGkmh = parcelRequire("dGkmh");

var $3crzk = parcelRequire("3crzk");

var $eSi6g = parcelRequire("eSi6g");

var $d55be = parcelRequire("d55be");

var $fFCD1 = parcelRequire("fFCD1");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $3IirL = parcelRequire("3IirL");
'use strict';
const $1778f61363860754$var$validators = (0, $fFCD1.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1778f61363860754$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $gsmxT.default)(),
            response: new (0, $gsmxT.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3crzk.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $fFCD1.default).assertOptions(transitional, {
            silentJSONParsing: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean),
            forcedJSONParsing: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean),
            clarifyTimeoutError: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean),
            legacyInterceptorReqResOrdering: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean),
            advertiseZstdAcceptEncoding: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean),
            validateStatusUndefinedResolves: $1778f61363860754$var$validators.transitional($1778f61363860754$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $5uQZ5.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $fFCD1.default).assertOptions(paramsSerializer, {
                encode: $1778f61363860754$var$validators.function,
                serialize: $1778f61363860754$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $fFCD1.default).assertOptions(config, {
            baseUrl: $1778f61363860754$var$validators.spelling('baseURL'),
            withXsrfToken: $1778f61363860754$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $5uQZ5.default).getSafeProp(config, 'method') || (0, $5uQZ5.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $5uQZ5.default).merge(headers.common, headers[config.method]);
        headers && (0, $5uQZ5.default).forEach((0, $d55be.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $3ZjYJ.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $3IirL.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dGkmh.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $5uQZ5.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $dGkmh.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $dGkmh.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3crzk.default)(this.defaults, config);
        const fullPath = (0, $eSi6g.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $9Fl3u.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $5uQZ5.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1778f61363860754$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3crzk.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $5uQZ5.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $5uQZ5.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3crzk.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1778f61363860754$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $1778f61363860754$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $1778f61363860754$export$2e2bcd8739ae039 = $1778f61363860754$var$Axios;

});
parcelRegister("9Fl3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7098468d04c75be2$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $fXHgZ = parcelRequire("fXHgZ");
'use strict';
function $7098468d04c75be2$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $7098468d04c75be2$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $5uQZ5.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $5uQZ5.default).getSafeProp(_options, 'encode') || $7098468d04c75be2$export$c564cdbbe6da493;
    const serializeFn = (0, $5uQZ5.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $5uQZ5.default).isURLSearchParams(params) ? params.toString() : new (0, $fXHgZ.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("fXHgZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9edeed83bb41c8f$export$2e2bcd8739ae039; });

var $8hob7 = parcelRequire("8hob7");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b9edeed83bb41c8f$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b9edeed83bb41c8f$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8hob7.default)(params, this, options);
}
const $b9edeed83bb41c8f$var$prototype = $b9edeed83bb41c8f$var$AxiosURLSearchParams.prototype;
$b9edeed83bb41c8f$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b9edeed83bb41c8f$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $b9edeed83bb41c8f$var$encode) : $b9edeed83bb41c8f$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $b9edeed83bb41c8f$export$2e2bcd8739ae039 = $b9edeed83bb41c8f$var$AxiosURLSearchParams;

});
parcelRegister("8hob7", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $6072aa91ad8a9365$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $6072aa91ad8a9365$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $l4isF = parcelRequire("l4isF");

var $dKIFD = parcelRequire("dKIFD");

var $dKIFD = parcelRequire("dKIFD");
'use strict';
const $6072aa91ad8a9365$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $6072aa91ad8a9365$var$isVisitable(thing) {
    return (0, $5uQZ5.default).isPlainObject(thing) || (0, $5uQZ5.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $6072aa91ad8a9365$var$removeBrackets(key) {
    return (0, $5uQZ5.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $6072aa91ad8a9365$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $6072aa91ad8a9365$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $6072aa91ad8a9365$var$isFlatArray(arr) {
    return (0, $5uQZ5.default).isArray(arr) && !arr.some($6072aa91ad8a9365$var$isVisitable);
}
const $6072aa91ad8a9365$var$predicates = (0, $5uQZ5.default).toFlatObject((0, $5uQZ5.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $6072aa91ad8a9365$var$toFormData(obj, formData, options) {
    if (!(0, $5uQZ5.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $dKIFD.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $5uQZ5.default).getSafeProp(options, name);
        return (0, $5uQZ5.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $6072aa91ad8a9365$export$659081b45d03227d);
    const useBlob = _Blob && (0, $5uQZ5.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $5uQZ5.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $5uQZ5.default).isDate(value)) return value.toISOString();
        if ((0, $5uQZ5.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $5uQZ5.default).isBlob(value)) throw new (0, $l4isF.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $5uQZ5.default).isArrayBuffer(value) || (0, $5uQZ5.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $dKIFD.default) && (0, $dKIFD.default).isBufferAvailable()) return (0, $dKIFD.default).from(value);
            throw new (0, $l4isF.default)('Blob is not supported. Use a Buffer instead.', (0, $l4isF.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $l4isF.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $l4isF.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $5uQZ5.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $5uQZ5.default).isReactNative(formData) && (0, $5uQZ5.default).isReactNativeBlob(value)) {
            formData.append($6072aa91ad8a9365$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $5uQZ5.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $5uQZ5.default).isArray(value) && $6072aa91ad8a9365$var$isFlatArray(value) || ((0, $5uQZ5.default).isFileList(value) || (0, $5uQZ5.default).endsWith(key, '[]')) && (arr = (0, $5uQZ5.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $6072aa91ad8a9365$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $5uQZ5.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $6072aa91ad8a9365$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($6072aa91ad8a9365$var$isVisitable(value)) return true;
        formData.append($6072aa91ad8a9365$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($6072aa91ad8a9365$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $6072aa91ad8a9365$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $5uQZ5.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $5uQZ5.default).forEach(value, function each(el, key) {
            const result = !((0, $5uQZ5.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $5uQZ5.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $5uQZ5.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $6072aa91ad8a9365$export$2e2bcd8739ae039 = $6072aa91ad8a9365$var$toFormData;

});
parcelRegister("l4isF", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $f5684abbe32f1b8e$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "default", function () { return $f5684abbe32f1b8e$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $3ZjYJ = parcelRequire("3ZjYJ");
'use strict';
const $f5684abbe32f1b8e$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $f5684abbe32f1b8e$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $5uQZ5.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $5uQZ5.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $f5684abbe32f1b8e$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $5uQZ5.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $3ZjYJ.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $5uQZ5.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $5uQZ5.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $5uQZ5.default).isPlainObject(source) && $f5684abbe32f1b8e$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $f5684abbe32f1b8e$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $5uQZ5.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $f5684abbe32f1b8e$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $f5684abbe32f1b8e$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $f5684abbe32f1b8e$var$stringifySafely(entry.message) : $f5684abbe32f1b8e$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $f5684abbe32f1b8e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $5uQZ5.default).isArray(error.errors) && error.errors.length) message = $f5684abbe32f1b8e$var$aggregateErrorMessage(error);
        const axiosError = new $f5684abbe32f1b8e$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $5uQZ5.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $5uQZ5.default).isArray(redactKeys) && redactKeys.length > 0 ? $f5684abbe32f1b8e$var$redactConfig(config, redactKeys) : (0, $5uQZ5.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f5684abbe32f1b8e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f5684abbe32f1b8e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f5684abbe32f1b8e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f5684abbe32f1b8e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f5684abbe32f1b8e$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$f5684abbe32f1b8e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f5684abbe32f1b8e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f5684abbe32f1b8e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f5684abbe32f1b8e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f5684abbe32f1b8e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f5684abbe32f1b8e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f5684abbe32f1b8e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f5684abbe32f1b8e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f5684abbe32f1b8e$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f5684abbe32f1b8e$export$2e2bcd8739ae039 = $f5684abbe32f1b8e$var$AxiosError;

});
parcelRegister("3ZjYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e7690ed185524f8$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $lOWUb = parcelRequire("lOWUb");

var $kNLlb = parcelRequire("kNLlb");
'use strict';
const $2e7690ed185524f8$var$$internals = Symbol('internals');
function $2e7690ed185524f8$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2e7690ed185524f8$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $5uQZ5.default).isArray(value) ? value.map($2e7690ed185524f8$var$normalizeValue) : (0, $kNLlb.sanitizeHeaderValue)(String(value));
}
function $2e7690ed185524f8$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2e7690ed185524f8$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $2e7690ed185524f8$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $2e7690ed185524f8$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $2e7690ed185524f8$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $2e7690ed185524f8$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $2e7690ed185524f8$var$trimOWS(part.slice(0, equals));
        if (!$2e7690ed185524f8$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $2e7690ed185524f8$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $2e7690ed185524f8$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $2e7690ed185524f8$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2e7690ed185524f8$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $5uQZ5.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $5uQZ5.default).isString(value)) return;
    if ((0, $5uQZ5.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $5uQZ5.default).isRegExp(filter)) return filter.test(value);
}
function $2e7690ed185524f8$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2e7690ed185524f8$var$buildAccessors(obj, header) {
    const accessorName = (0, $5uQZ5.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2e7690ed185524f8$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2e7690ed185524f8$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $5uQZ5.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2e7690ed185524f8$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $5uQZ5.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $5uQZ5.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $5uQZ5.default).isString(header) && (header = header.trim()) && !$2e7690ed185524f8$var$isValidHeaderName(header)) setHeaders((0, $lOWUb.default)(header), valueOrRewrite);
        else if ((0, $5uQZ5.default).isObject(header) && (0, $5uQZ5.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $5uQZ5.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $5uQZ5.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $5uQZ5.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2e7690ed185524f8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5uQZ5.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2e7690ed185524f8$var$parseTokens(value);
                if ((0, $5uQZ5.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $5uQZ5.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $2e7690ed185524f8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5uQZ5.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2e7690ed185524f8$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2e7690ed185524f8$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $5uQZ5.default).findKey(self, _header);
                if (key && (!matcher || $2e7690ed185524f8$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $5uQZ5.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2e7690ed185524f8$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $5uQZ5.default).forEach(this, (value, header)=>{
            const key = (0, $5uQZ5.default).findKey(headers, header);
            if (key) {
                self[key] = $2e7690ed185524f8$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2e7690ed185524f8$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2e7690ed185524f8$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $5uQZ5.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $5uQZ5.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $5uQZ5.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $2e7690ed185524f8$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2e7690ed185524f8$var$$internals] = this[$2e7690ed185524f8$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2e7690ed185524f8$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2e7690ed185524f8$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $5uQZ5.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$2e7690ed185524f8$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $5uQZ5.default).reduceDescriptors($2e7690ed185524f8$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $5uQZ5.default).freezeMethods($2e7690ed185524f8$var$AxiosHeaders);
var $2e7690ed185524f8$export$2e2bcd8739ae039 = $2e7690ed185524f8$var$AxiosHeaders;

});
parcelRegister("lOWUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe2bf5da0ea11b10$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fe2bf5da0ea11b10$var$ignoreDuplicateOf = (0, $5uQZ5.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fe2bf5da0ea11b10$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $5uQZ5.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $5uQZ5.default).hasOwnProp($fe2bf5da0ea11b10$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("kNLlb", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $f24d1b25823d91c4$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $f24d1b25823d91c4$export$c30c72bb7e677d54; });

var $5uQZ5 = parcelRequire("5uQZ5");
'use strict';
function $f24d1b25823d91c4$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f24d1b25823d91c4$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f24d1b25823d91c4$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f24d1b25823d91c4$var$sanitizeValue(value, invalidChars) {
    if ((0, $5uQZ5.default).isArray(value)) return value.map((item)=>$f24d1b25823d91c4$var$sanitizeValue(item, invalidChars));
    return $f24d1b25823d91c4$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f24d1b25823d91c4$export$9e344cffce061a22 = (value)=>$f24d1b25823d91c4$var$sanitizeValue(value, $f24d1b25823d91c4$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f24d1b25823d91c4$export$59dd66c2a12d8f62 = (value)=>$f24d1b25823d91c4$var$sanitizeValue(value, $f24d1b25823d91c4$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f24d1b25823d91c4$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $5uQZ5.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f24d1b25823d91c4$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("dKIFD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a03238dd68ec529d$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $a03238dd68ec529d$export$2e2bcd8739ae039 = null;

});




parcelRegister("gsmxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb0bff8f21c4215$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");
'use strict';
const $bfb0bff8f21c4215$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $bfb0bff8f21c4215$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $bfb0bff8f21c4215$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $bfb0bff8f21c4215$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $bfb0bff8f21c4215$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $bfb0bff8f21c4215$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$bfb0bff8f21c4215$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$bfb0bff8f21c4215$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $bfb0bff8f21c4215$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$bfb0bff8f21c4215$var$$internals];
        $bfb0bff8f21c4215$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $bfb0bff8f21c4215$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $bfb0bff8f21c4215$var$syncHandlerEntries(this, this[$bfb0bff8f21c4215$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$bfb0bff8f21c4215$var$$internals];
        $bfb0bff8f21c4215$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $5uQZ5.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $bfb0bff8f21c4215$var$syncHandlerEntries(this, internals);
                $bfb0bff8f21c4215$var$trimHandlers(this.handlers);
                internals.handlersLength = $bfb0bff8f21c4215$var$countHandlers(this.handlers);
            }
        }
    }
}
var $bfb0bff8f21c4215$export$2e2bcd8739ae039 = $bfb0bff8f21c4215$var$InterceptorManager;

});

parcelRegister("dGkmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f5efd5e3004c418$export$2e2bcd8739ae039; });

var $gRffs = parcelRequire("gRffs");

var $6m8of = parcelRequire("6m8of");

var $93RRF = parcelRequire("93RRF");

var $3Q4OC = parcelRequire("3Q4OC");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $eVzrl = parcelRequire("eVzrl");

var $5uQZ5 = parcelRequire("5uQZ5");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9f5efd5e3004c418$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $3Q4OC.default)(null, config);
}
function $9f5efd5e3004c418$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $5uQZ5.default).toSafeFlatObject(_config);
    $9f5efd5e3004c418$var$throwIfCancellationRequested(config);
    config.headers = (0, $3ZjYJ.default).from((0, $5uQZ5.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $gRffs.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $eVzrl.default).getAdapter(config.adapter || (0, $93RRF.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9f5efd5e3004c418$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $gRffs.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $3ZjYJ.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $6m8of.default)(reason)) {
            $9f5efd5e3004c418$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $gRffs.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $3ZjYJ.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("gRffs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c45d6c93225cea8e$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $93RRF = parcelRequire("93RRF");

var $3ZjYJ = parcelRequire("3ZjYJ");
'use strict';
function $c45d6c93225cea8e$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $93RRF.default);
    const context = response || config;
    const headers = (0, $3ZjYJ.default).from(context.headers);
    let data = context.data;
    (0, $5uQZ5.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("93RRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $698e2d4346db12af$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $l4isF = parcelRequire("l4isF");

var $3IirL = parcelRequire("3IirL");

var $8hob7 = parcelRequire("8hob7");

var $br6M4 = parcelRequire("br6M4");

var $4dZdN = parcelRequire("4dZdN");

var $eK2l3 = parcelRequire("eK2l3");

var $d55be = parcelRequire("d55be");
'use strict';
const $698e2d4346db12af$var$own = (obj, key)=>obj != null && (0, $5uQZ5.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $698e2d4346db12af$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $5uQZ5.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $5uQZ5.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $698e2d4346db12af$var$defaults = {
    transitional: (0, $3IirL.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $5uQZ5.default).isObject(data);
            if (isObjectPayload && (0, $5uQZ5.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $5uQZ5.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $eK2l3.default)(data)) : data;
            if ((0, $5uQZ5.default).isArrayBuffer(data) || (0, $5uQZ5.default).isBuffer(data) || (0, $5uQZ5.default).isStream(data) || (0, $5uQZ5.default).isFile(data) || (0, $5uQZ5.default).isBlob(data) || (0, $5uQZ5.default).isReadableStream(data)) return data;
            if ((0, $5uQZ5.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $5uQZ5.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $698e2d4346db12af$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $br6M4.default)(data, formSerializer).toString();
                if ((isFileList = (0, $5uQZ5.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $698e2d4346db12af$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $8hob7.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $698e2d4346db12af$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $698e2d4346db12af$var$own(this, 'transitional') || $698e2d4346db12af$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $698e2d4346db12af$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $5uQZ5.default).isResponse(data) || (0, $5uQZ5.default).isReadableStream(data)) return data;
            if (data && (0, $5uQZ5.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $698e2d4346db12af$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $l4isF.default).from(e, (0, $l4isF.default).ERR_BAD_RESPONSE, this, null, $698e2d4346db12af$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4dZdN.default).classes.FormData,
        Blob: (0, $4dZdN.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $5uQZ5.default).forEach((0, $d55be.default), (method)=>{
    $698e2d4346db12af$var$defaults.headers[method] = {};
});
var $698e2d4346db12af$export$2e2bcd8739ae039 = $698e2d4346db12af$var$defaults;

});
parcelRegister("3IirL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b43ca4b265aa549$export$2e2bcd8739ae039; });
'use strict';
var $2b43ca4b265aa549$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("br6M4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8537788d18851986$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $8hob7 = parcelRequire("8hob7");

var $4dZdN = parcelRequire("4dZdN");
'use strict';
function $8537788d18851986$export$2e2bcd8739ae039(data, options) {
    return (0, $8hob7.default)(data, new (0, $4dZdN.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $4dZdN.default).isNode && (0, $5uQZ5.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("4dZdN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3137dd9eff02306f$export$2e2bcd8739ae039; });

var $7KHIG = parcelRequire("7KHIG");

var $bGSBI = parcelRequire("bGSBI");
var $3137dd9eff02306f$export$2e2bcd8739ae039 = {
    ...$bGSBI,
    ...(0, $7KHIG.default)
};

});
parcelRegister("7KHIG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4ebe1705dcd311$export$2e2bcd8739ae039; });

var $6jCWO = parcelRequire("6jCWO");

var $SlyWc = parcelRequire("SlyWc");

var $lo5X3 = parcelRequire("lo5X3");
var $5a4ebe1705dcd311$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6jCWO.default,
        FormData: $SlyWc.default,
        Blob: $lo5X3.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("6jCWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4992ba9ecba5db38$export$2e2bcd8739ae039; });

var $fXHgZ = parcelRequire("fXHgZ");
'use strict';
var $4992ba9ecba5db38$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $fXHgZ.default);

});

parcelRegister("SlyWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a35c5205c439ecb$export$2e2bcd8739ae039; });
'use strict';
var $0a35c5205c439ecb$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("lo5X3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92074af03a95a85$export$2e2bcd8739ae039; });
'use strict';
var $f92074af03a95a85$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("bGSBI", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $882df9d231507267$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $882df9d231507267$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $882df9d231507267$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $882df9d231507267$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $882df9d231507267$export$f710a83a91838a36; });
const $882df9d231507267$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $882df9d231507267$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $882df9d231507267$export$c0bcc9250309d66 = $882df9d231507267$export$c4996c4b7b93b0bf && (!$882df9d231507267$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($882df9d231507267$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $882df9d231507267$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $882df9d231507267$export$f710a83a91838a36 = $882df9d231507267$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("eK2l3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abb72cf82d675e4d$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $l4isF = parcelRequire("l4isF");

var $8hob7 = parcelRequire("8hob7");
'use strict';
const $abb72cf82d675e4d$var$MAX_DEPTH = (0, $8hob7.DEFAULT_FORM_DATA_MAX_DEPTH);
function $abb72cf82d675e4d$var$throwIfDepthExceeded(index) {
    if (index > $abb72cf82d675e4d$var$MAX_DEPTH) throw new (0, $l4isF.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $abb72cf82d675e4d$var$MAX_DEPTH, (0, $l4isF.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $abb72cf82d675e4d$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $abb72cf82d675e4d$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $abb72cf82d675e4d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $abb72cf82d675e4d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $abb72cf82d675e4d$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $5uQZ5.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $5uQZ5.default).hasOwnProp(target, name)) target[name] = (0, $5uQZ5.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $5uQZ5.default).hasOwnProp(target, name) || !(0, $5uQZ5.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $5uQZ5.default).isArray(target[name])) target[name] = $abb72cf82d675e4d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $5uQZ5.default).isFormData(formData) && (0, $5uQZ5.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $5uQZ5.default).forEachEntry(formData, (name, value)=>{
            buildPath($abb72cf82d675e4d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $abb72cf82d675e4d$export$2e2bcd8739ae039 = $abb72cf82d675e4d$var$formDataToJSON;

});

parcelRegister("d55be", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $985fc2a91a867552$export$2e2bcd8739ae039; });
'use strict';
const $985fc2a91a867552$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $985fc2a91a867552$export$2e2bcd8739ae039 = $985fc2a91a867552$var$methodList;

});



parcelRegister("6m8of", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a0b4e448cdd4339$export$2e2bcd8739ae039; });
'use strict';
function $4a0b4e448cdd4339$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("3Q4OC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb9f6b03896b5d7$export$2e2bcd8739ae039; });

var $l4isF = parcelRequire("l4isF");
'use strict';
class $2cb9f6b03896b5d7$var$CanceledError extends (0, $l4isF.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $l4isF.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $2cb9f6b03896b5d7$export$2e2bcd8739ae039 = $2cb9f6b03896b5d7$var$CanceledError;

});

parcelRegister("eVzrl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ade1e13cb1907fe5$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $dKIFD = parcelRequire("dKIFD");

var $brRtg = parcelRequire("brRtg");

var $4PPhy = parcelRequire("4PPhy");

var $l4isF = parcelRequire("l4isF");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $ade1e13cb1907fe5$var$knownAdapters = {
    http: (0, $dKIFD.default),
    xhr: (0, $brRtg.default),
    fetch: {
        get: $4PPhy.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $5uQZ5.default).forEach($ade1e13cb1907fe5$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $ade1e13cb1907fe5$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $ade1e13cb1907fe5$var$isResolvedHandle = (adapter)=>(0, $5uQZ5.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $ade1e13cb1907fe5$var$getAdapter(adapters, config) {
    adapters = (0, $5uQZ5.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$ade1e13cb1907fe5$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $ade1e13cb1907fe5$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $l4isF.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $5uQZ5.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($ade1e13cb1907fe5$var$renderReason).join('\n') : ' ' + $ade1e13cb1907fe5$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $l4isF.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $l4isF.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $ade1e13cb1907fe5$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $ade1e13cb1907fe5$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $ade1e13cb1907fe5$var$knownAdapters
};

});
parcelRegister("brRtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $855bb18e5cd49626$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $7qJNV = parcelRequire("7qJNV");

var $3IirL = parcelRequire("3IirL");

var $l4isF = parcelRequire("l4isF");

var $3Q4OC = parcelRequire("3Q4OC");

var $j3Xgs = parcelRequire("j3Xgs");

var $7X0Aw = parcelRequire("7X0Aw");

var $4dZdN = parcelRequire("4dZdN");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $iMFkd = parcelRequire("iMFkd");

var $jmRkl = parcelRequire("jmRkl");

var $kNLlb = parcelRequire("kNLlb");
const $855bb18e5cd49626$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $855bb18e5cd49626$export$2e2bcd8739ae039 = $855bb18e5cd49626$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $jmRkl.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $3ZjYJ.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $7X0Aw.default)((0, $j3Xgs.default)(_config.url)) || (0, $7X0Aw.default)((0, $4dZdN.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $l4isF.default)('Request aborted', (0, $l4isF.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $3ZjYJ.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $7qJNV.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $l4isF.default)('Request aborted', (0, $l4isF.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $l4isF.default)(msg, (0, $l4isF.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3IirL.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $l4isF.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $l4isF.default).ETIMEDOUT : (0, $l4isF.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $5uQZ5.default).forEach((0, $kNLlb.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $5uQZ5.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $iMFkd.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $iMFkd.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $3Q4OC.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $7X0Aw.default)(_config.url);
        if (protocol && !(0, $4dZdN.default).protocols.includes(protocol)) {
            reject(new (0, $l4isF.default)('Unsupported protocol ' + protocol + ':', (0, $l4isF.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("7qJNV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568e7ddd55d6ed06$export$2e2bcd8739ae039; });

var $l4isF = parcelRequire("l4isF");
'use strict';
function $568e7ddd55d6ed06$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $l4isF.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $l4isF.default).ERR_BAD_REQUEST : (0, $l4isF.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("j3Xgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0c44cac25d15f2$export$2e2bcd8739ae039; });
'use strict';
const $de0c44cac25d15f2$var$urlParserControlCharacters = /[\t\n\r]/g;
function $de0c44cac25d15f2$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($de0c44cac25d15f2$var$urlParserControlCharacters, '');
}

});

parcelRegister("7X0Aw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9e7fd8fd8f942f$export$2e2bcd8739ae039; });
'use strict';
function $5c9e7fd8fd8f942f$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("iMFkd", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $daccc3fbacf351fb$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $daccc3fbacf351fb$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $daccc3fbacf351fb$export$5d35863c355a22a9; });

var $bLjEn = parcelRequire("bLjEn");

var $cG5fB = parcelRequire("cG5fB");

var $5uQZ5 = parcelRequire("5uQZ5");
const $daccc3fbacf351fb$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $bLjEn.default)(50, 250);
    return (0, $cG5fB.default)((e)=>{
        if (!e || !(0, $5uQZ5.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $daccc3fbacf351fb$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $daccc3fbacf351fb$export$5d35863c355a22a9 = (fn, scheduler = (0, $5uQZ5.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("bLjEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8903539cf5e89628$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $8903539cf5e89628$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $8903539cf5e89628$export$2e2bcd8739ae039 = $8903539cf5e89628$var$speedometer;

});

parcelRegister("cG5fB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ad7af5decb3c86$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $93ad7af5decb3c86$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $93ad7af5decb3c86$export$2e2bcd8739ae039 = $93ad7af5decb3c86$var$throttle;

});


parcelRegister("jmRkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e19970076dbf9c22$export$2e2bcd8739ae039; });

var $4dZdN = parcelRequire("4dZdN");

var $5uQZ5 = parcelRequire("5uQZ5");

var $l4isF = parcelRequire("l4isF");

var $fBiT7 = parcelRequire("fBiT7");

var $6jpbE = parcelRequire("6jpbE");

var $eSi6g = parcelRequire("eSi6g");

var $3crzk = parcelRequire("3crzk");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $enOa4 = parcelRequire("enOa4");

var $9Fl3u = parcelRequire("9Fl3u");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e19970076dbf9c22$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $e19970076dbf9c22$var$resolveConfig(config) {
    const newConfig = (0, $3crzk.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $5uQZ5.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $3ZjYJ.default).from(headers);
    newConfig.url = (0, $9Fl3u.default)((0, $eSi6g.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $5uQZ5.default).getSafeProp(auth, 'username') || '';
        const password = (0, $5uQZ5.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $e19970076dbf9c22$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $l4isF.default).from(e, (0, $l4isF.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $5uQZ5.default).isFormData(data)) {
        const getHeaders = (0, $5uQZ5.default).getSafeProp(data, 'getHeaders');
        if ((0, $4dZdN.default).hasStandardBrowserEnv || (0, $4dZdN.default).hasStandardBrowserWebWorkerEnv || (0, $5uQZ5.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $5uQZ5.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $enOa4.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4dZdN.default).hasStandardBrowserEnv) {
        if ((0, $5uQZ5.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $fBiT7.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $6jpbE.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $e19970076dbf9c22$export$2e2bcd8739ae039 = $e19970076dbf9c22$var$resolveConfig;

});
parcelRegister("fBiT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5b8f6800d0e9d80$export$2e2bcd8739ae039; });

var $4dZdN = parcelRequire("4dZdN");
var $b5b8f6800d0e9d80$export$2e2bcd8739ae039 = (0, $4dZdN.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $4dZdN.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $4dZdN.default).origin), (0, $4dZdN.default).navigator && /(msie|trident)/i.test((0, $4dZdN.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("6jpbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49880e0002e22c7f$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $4dZdN = parcelRequire("4dZdN");
var $49880e0002e22c7f$export$2e2bcd8739ae039 = (0, $4dZdN.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $5uQZ5.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $5uQZ5.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $5uQZ5.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $5uQZ5.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("eSi6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad44261a5356bacd$export$2e2bcd8739ae039; });

var $l4isF = parcelRequire("l4isF");

var $1m5S7 = parcelRequire("1m5S7");

var $bEMhF = parcelRequire("bEMhF");

var $j3Xgs = parcelRequire("j3Xgs");
'use strict';
const $ad44261a5356bacd$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $ad44261a5356bacd$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $l4isF.REDACTED}`;
    });
}
function $ad44261a5356bacd$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $l4isF.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $l4isF.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$ad44261a5356bacd$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $ad44261a5356bacd$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $j3Xgs.default)(url);
        if ($ad44261a5356bacd$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $l4isF.default)(`Invalid URL ${JSON.stringify($ad44261a5356bacd$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $l4isF.default).ERR_INVALID_URL, config);
    }
}
function $ad44261a5356bacd$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $ad44261a5356bacd$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $1m5S7.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $ad44261a5356bacd$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $bEMhF.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("1m5S7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fcc6693c49ee4d8$export$2e2bcd8739ae039; });
'use strict';
function $0fcc6693c49ee4d8$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("bEMhF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87c8e24e0529542f$export$2e2bcd8739ae039; });
'use strict';
function $87c8e24e0529542f$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("3crzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2547e0a789025bf6$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");

var $3ZjYJ = parcelRequire("3ZjYJ");
'use strict';
const $2547e0a789025bf6$var$headersToObject = (thing)=>thing instanceof (0, $3ZjYJ.default) ? {
        ...thing
    } : thing;
const $2547e0a789025bf6$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $2547e0a789025bf6$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $5uQZ5.default).isPlainObject(target) && (0, $5uQZ5.default).isPlainObject(source)) return (0, $5uQZ5.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $5uQZ5.default).isPlainObject(source)) return (0, $5uQZ5.default).merge({}, source);
        else if ((0, $5uQZ5.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $5uQZ5.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $5uQZ5.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $5uQZ5.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $5uQZ5.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $5uQZ5.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $5uQZ5.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $5uQZ5.default).isUndefined(transitional2)) {
            if ((0, $5uQZ5.default).isPlainObject(transitional2)) {
                if ((0, $5uQZ5.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $5uQZ5.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $5uQZ5.default).isPlainObject(transitional1) && (0, $5uQZ5.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $5uQZ5.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $5uQZ5.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($2547e0a789025bf6$var$headersToObject(a), $2547e0a789025bf6$var$headersToObject(b), prop, true)
    };
    (0, $5uQZ5.default).forEach($2547e0a789025bf6$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $5uQZ5.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $5uQZ5.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $5uQZ5.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $5uQZ5.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $5uQZ5.default).hasOwnProp(config2, 'validateStatus') && (0, $5uQZ5.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $5uQZ5.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("enOa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78a1fb52e137cda$export$2e2bcd8739ae039; });
'use strict';
const $a78a1fb52e137cda$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $a78a1fb52e137cda$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($a78a1fb52e137cda$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("4PPhy", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $3853b46bdd8237a8$export$3105c6651375d4fa; });

var $4dZdN = parcelRequire("4dZdN");

var $5uQZ5 = parcelRequire("5uQZ5");

var $l4isF = parcelRequire("l4isF");

var $kpt0x = parcelRequire("kpt0x");

var $3qWM1 = parcelRequire("3qWM1");

var $3ZjYJ = parcelRequire("3ZjYJ");

var $iMFkd = parcelRequire("iMFkd");

var $jmRkl = parcelRequire("jmRkl");

var $7qJNV = parcelRequire("7qJNV");

var $hpw4p = parcelRequire("hpw4p");

var $4plQG = parcelRequire("4plQG");

var $kNLlb = parcelRequire("kNLlb");
const $3853b46bdd8237a8$var$DEFAULT_CHUNK_SIZE = 65536;
const $3853b46bdd8237a8$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $3853b46bdd8237a8$var$isFunction } = (0, $5uQZ5.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $3853b46bdd8237a8$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $3853b46bdd8237a8$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $5uQZ5.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $3853b46bdd8237a8$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $3853b46bdd8237a8$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $3853b46bdd8237a8$var$factory = (env)=>{
    const globalObject = (0, $5uQZ5.default).global !== undefined && (0, $5uQZ5.default).global !== null ? (0, $5uQZ5.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $5uQZ5.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $3853b46bdd8237a8$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $3853b46bdd8237a8$var$isFunction(Request);
    const isResponseSupported = $3853b46bdd8237a8$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $3853b46bdd8237a8$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $3853b46bdd8237a8$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $4dZdN.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $3853b46bdd8237a8$var$test(()=>(0, $5uQZ5.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $l4isF.default)(`Response type '${type}' is not supported`, (0, $l4isF.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $5uQZ5.default).isBlob(body)) return body.size;
        if ((0, $5uQZ5.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $4dZdN.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $5uQZ5.default).isArrayBufferView(body) || (0, $5uQZ5.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $5uQZ5.default).isURLSearchParams(body)) body = body + '';
        if ((0, $5uQZ5.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $5uQZ5.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $jmRkl.default)(config);
        const hasMaxContentLength = (0, $5uQZ5.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $5uQZ5.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $5uQZ5.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $kpt0x.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $l4isF.default)('Request body larger than maxBodyLength limit', (0, $l4isF.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $5uQZ5.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $5uQZ5.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($3853b46bdd8237a8$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $4dZdN.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $3853b46bdd8237a8$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $3853b46bdd8237a8$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($3853b46bdd8237a8$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $hpw4p.default)(url);
                if (estimated > maxContentLength) throw new (0, $l4isF.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $l4isF.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $5uQZ5.default).isReadableStream(data) || (0, $5uQZ5.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $3qWM1.trackStream)(stream, $3853b46bdd8237a8$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $5uQZ5.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $iMFkd.progressEventDecorator)(requestContentLength, (0, $iMFkd.progressEventReducer)((0, $iMFkd.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $l4isF.default)('Stream request bodies are not supported by the current fetch implementation', (0, $l4isF.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $5uQZ5.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $5uQZ5.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $4plQG.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $kNLlb.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $5uQZ5.default).forEach($3853b46bdd8237a8$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $3ZjYJ.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $5uQZ5.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $l4isF.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $l4isF.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $5uQZ5.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $iMFkd.progressEventDecorator)(responseContentLength, (0, $iMFkd.progressEventReducer)((0, $iMFkd.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $l4isF.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $l4isF.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $3qWM1.trackStream)(response.body, $3853b46bdd8237a8$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $5uQZ5.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $l4isF.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $l4isF.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $7qJNV.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $3ZjYJ.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $l4isF.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $l4isF.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $l4isF.default)('Network Error', (0, $l4isF.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $l4isF.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $3853b46bdd8237a8$var$seedCache = new Map();
const $3853b46bdd8237a8$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $3853b46bdd8237a8$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $3853b46bdd8237a8$var$factory(env));
        map = target;
    }
    return target;
};
const $3853b46bdd8237a8$var$adapter = $3853b46bdd8237a8$export$3105c6651375d4fa();
var $3853b46bdd8237a8$export$2e2bcd8739ae039 = $3853b46bdd8237a8$var$adapter;

});
parcelRegister("kpt0x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbca4c77cc62295$export$2e2bcd8739ae039; });

var $3Q4OC = parcelRequire("3Q4OC");

var $l4isF = parcelRequire("l4isF");

var $5uQZ5 = parcelRequire("5uQZ5");
const $edbca4c77cc62295$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $l4isF.default) ? err : new (0, $3Q4OC.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $l4isF.default)(`timeout of ${timeout}ms exceeded`, (0, $l4isF.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $5uQZ5.default).asap(unsubscribe);
    return signal;
};
var $edbca4c77cc62295$export$2e2bcd8739ae039 = $edbca4c77cc62295$var$composeSignals;

});

parcelRegister("3qWM1", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $28016404e8dd85b0$export$b0119225647bd83; });
const $28016404e8dd85b0$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $28016404e8dd85b0$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $28016404e8dd85b0$var$readStream(iterable))yield* $28016404e8dd85b0$export$71b051935044bd5d(chunk, chunkSize);
};
const $28016404e8dd85b0$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $28016404e8dd85b0$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $28016404e8dd85b0$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("hpw4p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cacda5e827bb352d$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $cacda5e827bb352d$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $cacda5e827bb352d$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $cacda5e827bb352d$var$isHexDigit(str.charCodeAt(i + 1)) && $cacda5e827bb352d$var$isHexDigit(str.charCodeAt(i + 2));
const $cacda5e827bb352d$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $cacda5e827bb352d$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $cacda5e827bb352d$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $cacda5e827bb352d$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $cacda5e827bb352d$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $cacda5e827bb352d$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $cacda5e827bb352d$var$isPercentEncodedByte(body, i, len)) {
            code = $cacda5e827bb352d$var$hexValue(body.charCodeAt(i + 1)) * 16 + $cacda5e827bb352d$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($cacda5e827bb352d$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$cacda5e827bb352d$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $cacda5e827bb352d$var$estimateBase64BufferAllocation(body);
    return $cacda5e827bb352d$var$base64Bytes(significant);
};
const $cacda5e827bb352d$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $cacda5e827bb352d$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $cacda5e827bb352d$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $cacda5e827bb352d$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $cacda5e827bb352d$var$estimatePercentDecodedBase64Bytes);
}
function $cacda5e827bb352d$export$1f39e64b554a246f(url) {
    return $cacda5e827bb352d$var$estimateDataURLBytes(url, $cacda5e827bb352d$var$estimateBase64BufferAllocation);
}

});

parcelRegister("4plQG", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $335a71edcdc879ee$export$a4ad2735b021c132; });
const $335a71edcdc879ee$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("fFCD1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b688a6291092dd5e$export$2e2bcd8739ae039; });

var $4plQG = parcelRequire("4plQG");

var $l4isF = parcelRequire("l4isF");
'use strict';
const $b688a6291092dd5e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $b688a6291092dd5e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $b688a6291092dd5e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $b688a6291092dd5e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $4plQG.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $l4isF.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $l4isF.default).ERR_DEPRECATED);
        if (version && !$b688a6291092dd5e$var$deprecatedWarnings[opt]) {
            $b688a6291092dd5e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$b688a6291092dd5e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $b688a6291092dd5e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $l4isF.default)('options must be an object', (0, $l4isF.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $l4isF.default)('option ' + opt + ' must be ' + result, (0, $l4isF.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $l4isF.default)('Unknown option ' + opt, (0, $l4isF.default).ERR_BAD_OPTION);
    }
}
var $b688a6291092dd5e$export$2e2bcd8739ae039 = {
    assertOptions: $b688a6291092dd5e$var$assertOptions,
    validators: $b688a6291092dd5e$var$validators
};

});


parcelRegister("UHUFF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aa74b4b648a45e3$export$2e2bcd8739ae039; });

var $3Q4OC = parcelRequire("3Q4OC");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $0aa74b4b648a45e3$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $3Q4OC.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $0aa74b4b648a45e3$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $0aa74b4b648a45e3$export$2e2bcd8739ae039 = $0aa74b4b648a45e3$var$CancelToken;

});

parcelRegister("ffFI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1a89c7ef2ec0724$export$2e2bcd8739ae039; });
'use strict';
function $b1a89c7ef2ec0724$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dQQb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1589af8dbdaa4e3$export$2e2bcd8739ae039; });

var $5uQZ5 = parcelRequire("5uQZ5");
'use strict';
function $a1589af8dbdaa4e3$export$2e2bcd8739ae039(payload) {
    return (0, $5uQZ5.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("5KB5o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42fe04236dc1c8af$export$2e2bcd8739ae039; });
const $42fe04236dc1c8af$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($42fe04236dc1c8af$var$HttpStatusCode).forEach(([key, value])=>{
    if ($42fe04236dc1c8af$var$HttpStatusCode[value] === undefined) $42fe04236dc1c8af$var$HttpStatusCode[value] = key;
});
var $42fe04236dc1c8af$export$2e2bcd8739ae039 = $42fe04236dc1c8af$var$HttpStatusCode;

});




parcelRegister("gHDhU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c28f234495ebb941$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
const $c28f234495ebb941$var$buildParams = (payload)=>({
        class_room_id: payload.classRoomId,
        student_id: payload.studentId ?? null
    });
var $c28f234495ebb941$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        selCompetencies: {},
        creativeModeData: {},
        questCompletionData: {},
        assessmentAnswers: {},
        selCompetenciesLoading: false,
        creativeModeDataLoading: false,
        questCompletionDataLoading: false,
        assessmentAnswersLoading: false,
        episodeGraphData: {},
        dialogueChoicesData: []
    },
    actions: {
        async loadSelCompetencies ({ commit: commit }, { studentId: studentId = null, classRoomId: classRoomId }) {
            commit("setSelCompetenciesLoading", true);
            try {
                const response = await (0, $lKfjl.default).get("/dashboard/sel_competencies", {
                    params: $c28f234495ebb941$var$buildParams({
                        studentId: studentId,
                        classRoomId: classRoomId
                    })
                });
                commit("setSelCompetencies", response.data.sel_competencies);
            } finally{
                commit("setSelCompetenciesLoading", false);
            }
        },
        async loadCreativeModeData ({ commit: commit }, { studentId: studentId = null, classRoomId: classRoomId }) {
            commit("setCreativeModeDataLoading", true);
            try {
                const response = await (0, $lKfjl.default).get("/dashboard/creative_mode_data", {
                    params: $c28f234495ebb941$var$buildParams({
                        studentId: studentId,
                        classRoomId: classRoomId
                    })
                });
                commit("setCreativeModeData", response.data.creative_mode_data);
            } finally{
                commit("setCreativeModeDataLoading", false);
            }
        },
        async loadQuestCompletionData ({ commit: commit }, { studentId: studentId = null, classRoomId: classRoomId }) {
            commit("setQuestCompletionDataLoading", true);
            try {
                const response = await (0, $lKfjl.default).get("/dashboard/quest_completion_data", {
                    params: $c28f234495ebb941$var$buildParams({
                        studentId: studentId,
                        classRoomId: classRoomId
                    })
                });
                commit("setQuestCompletionData", response.data.quest_completion_data);
            } finally{
                commit("setQuestCompletionDataLoading", false);
            }
        },
        async loadAssessmentAnswers ({ commit: commit }, { studentId: studentId = null, classRoomId: classRoomId }) {
            commit("setAssessmentAnswersLoading", true);
            try {
                const response = await (0, $lKfjl.default).get("/dashboard/assessment_answers", {
                    params: $c28f234495ebb941$var$buildParams({
                        studentId: studentId,
                        classRoomId: classRoomId
                    })
                });
                commit("setAssessmentAnswers", response.data.assessment_answers);
            } finally{
                commit("setAssessmentAnswersLoading", false);
            }
        },
        loadDashboardSections ({ dispatch: dispatch }, { studentId: studentId = null, classRoomId: classRoomId }) {
            const payload = {
                studentId: studentId,
                classRoomId: classRoomId
            };
            dispatch("loadSelCompetencies", payload, {
                root: false
            });
            dispatch("loadCreativeModeData", payload, {
                root: false
            });
            dispatch("loadQuestCompletionData", payload, {
                root: false
            });
            dispatch("loadAssessmentAnswers", payload, {
                root: false
            });
        },
        async loadEpisodeGraphData ({ commit: commit }, { episodeNumber: episodeNumber, classRoomId: classRoomId, studentId: studentId = null }) {
            const response = await (0, $lKfjl.default).get("/dashboard/episode_graph_data", {
                params: {
                    episode_number: episodeNumber,
                    class_room_id: classRoomId,
                    student_id: studentId
                }
            });
            commit("setEpisodeGraphData", response.data.episode_graph_data);
        },
        async loadDialogueChoicesData ({ commit: commit }, { classRoomId: classRoomId, studentId: studentId = null }) {
            const response = await (0, $lKfjl.default).get("/dashboard/dialogue_choices_data", {
                params: {
                    class_room_id: classRoomId,
                    student_id: studentId
                }
            });
            commit("setDialogueChoicesData", response.data.dialogue_choices_data);
        }
    },
    mutations: {
        setSelCompetencies (state, data) {
            state.selCompetencies = data ?? {};
        },
        setCreativeModeData (state, data) {
            state.creativeModeData = data ?? {};
        },
        setQuestCompletionData (state, data) {
            state.questCompletionData = data ?? {};
        },
        setAssessmentAnswers (state, data) {
            state.assessmentAnswers = data ?? {};
        },
        setSelCompetenciesLoading (state, value) {
            state.selCompetenciesLoading = value;
        },
        setCreativeModeDataLoading (state, value) {
            state.creativeModeDataLoading = value;
        },
        setQuestCompletionDataLoading (state, value) {
            state.questCompletionDataLoading = value;
        },
        setAssessmentAnswersLoading (state, value) {
            state.assessmentAnswersLoading = value;
        },
        setEpisodeGraphData (state, data) {
            state.episodeGraphData = data;
        },
        setDialogueChoicesData (state, data) {
            state.dialogueChoicesData = data;
        }
    },
    getters: {
        dashboardData: (state)=>({
                sel_competencies: state.selCompetencies,
                creative_mode_data: state.creativeModeData,
                quest_completion_data: state.questCompletionData,
                assessment_answers: state.assessmentAnswers
            }),
        selCompetenciesLoading: (state)=>state.selCompetenciesLoading,
        creativeModeDataLoading: (state)=>state.creativeModeDataLoading,
        questCompletionDataLoading: (state)=>state.questCompletionDataLoading,
        assessmentAnswersLoading: (state)=>state.assessmentAnswersLoading,
        episodeGraphData: (state)=>state.episodeGraphData,
        dialogueChoicesData: (state)=>state.dialogueChoicesData
    }
};

});

parcelRegister("d4IYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $984e8810261c6856$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");

var $3FRe8 = parcelRequire("3FRe8");
const $984e8810261c6856$var$state = {
    authHeaders: null,
    user: {
        id: null,
        username: null,
        email: null
    },
    trueUser: {},
    users: []
};
const $984e8810261c6856$var$getters = {
    users (state) {
        return state.users;
    },
    trueUser (state) {
        return state.trueUser;
    },
    isImpersonating (state) {
        return state.trueUser?.id && state.user?.id && state.trueUser.id !== state.user.id;
    },
    isAdmin (state) {
        return state.trueUser && (state.trueUser.role === "company_admin" || state.trueUser.role === "super_admin" || state.trueUser.role_type === "company_admin" || state.trueUser.role_type === "super_admin");
    },
    isSchoolAdmin (state) {
        return state.user?.role === "school_admin";
    },
    user (state) {
        return state.user;
    },
    getAuthHeaders (state) {
        return state.authToken;
    },
    getUserEmail (state) {
        return state.user?.email;
    },
    getUserID (state) {
        return state.user?.id;
    },
    isLoggedIn (state) {
        const loggedOut = state.authHeaders == null || state.authHeaders == JSON.stringify(null);
        return !loggedOut;
    },
    userImage (state) {
        if (!state.user?.plan_preferences?.character) return (0, (/*@__PURE__*/$parcel$interopDefault($3FRe8)))["ava"];
        try {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3FRe8)))[state.user.plan_preferences.character];
        } catch (error) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3FRe8)))["ava"];
        }
    }
};
const $984e8810261c6856$var$actions = {
    updateUser ({ commit: commit }, payload) {
        return (0, $lKfjl.default).put(`/users/${$984e8810261c6856$var$state.user.id}`, payload).then((response1)=>{
            commit("setUserInfo", {
                data: {
                    ...$984e8810261c6856$var$state.user,
                    ...payload
                }
            });
            return response1;
        });
    },
    deleteAccount ({}, payload) {
        return (0, $lKfjl.default).delete(`/users/${$984e8810261c6856$var$state.user.id}`, {
            params: payload
        });
    },
    registerUser ({ commit: commit }, payload) {
        return (0, $lKfjl.default).post("/signup", {
            user: payload
        }).then((response1)=>{
            commit("setUserInfo", response1.data);
            return response1;
        }).catch((error)=>{
            return error.response;
        });
    },
    loginUser ({ commit: commit }, payload) {
        return (0, $lKfjl.default).post("/sign_in", {
            user: payload
        }).then((response1)=>{
            commit("setUserInfo", response1.data);
            return response1;
        }).catch((error)=>{
            return error.response;
        });
    },
    logoutUser ({ commit: commit }) {
        return (0, $lKfjl.default).delete("/sign_out").then(()=>{
            commit("resetUserInfo");
            return response;
        }).catch((error)=>{
            commit("resetUserInfo");
            return error.response;
        });
    },
    loginUserWithToken ({ commit: commit }) {
        return (0, $lKfjl.default).get("users/validate_token").then((response1)=>{
            commit("setUserInfo", response1.data);
            return response1;
        }).catch((error)=>{
            return error.response;
        });
    },
    resetPassword ({ commit: commit }, payload) {
        return (0, $lKfjl.default).post("/password", {
            user: payload
        }).then((response1)=>{
            return response1;
        }).catch((error)=>{
            return error.response;
        });
    },
    updatePassword ({ commit: commit }, payload) {
        return (0, $lKfjl.default).put("/password", {
            user: payload
        }).then((response1)=>{
            return response1;
        }).catch((error)=>{
            return error.response;
        });
    },
    impersonateUser ({ commit: commit }, userId) {
        return (0, $lKfjl.default).post(`/impersonate`, {
            user_id: userId
        }).then((response1)=>{
            return response1;
        });
    },
    stopImpersonatingUser ({ commit: commit }) {
        return (0, $lKfjl.default).post(`/stop_impersonating`).then((response1)=>{
            return response1;
        });
    },
    loadUsers ({ commit: commit }, { query: query }) {
        return (0, $lKfjl.default).get(`/users`, {
            params: {
                query: query
            }
        }).then((response1)=>{
            commit("setUsers", response1.data.users);
            return response1;
        });
    }
};
const $984e8810261c6856$var$mutations = {
    setUserInfo (state, data) {
        state.user = data?.data || {
            id: null,
            username: null,
            email: null,
            plan_preferences: {},
            payment_details: {}
        };
        state.trueUser = data?.true_user || data?.data || {};
    },
    resetUserInfo (state) {
        state.user = {
            id: null,
            username: null,
            email: null,
            plan_preferences: {},
            payment_details: {}
        };
        state.trueUser = {};
        state.authHeaders = null;
        localStorage.removeItem("authHeaders");
    },
    setUsers (state, users) {
        state.users = users;
    }
};
var $984e8810261c6856$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: $984e8810261c6856$var$state,
    getters: $984e8810261c6856$var$getters,
    actions: $984e8810261c6856$var$actions,
    mutations: $984e8810261c6856$var$mutations
};

});
parcelRegister("3FRe8", function(module, exports) {

var $fkcIz = parcelRequire("fkcIz");

var $6Qu1S = parcelRequire("6Qu1S");

var $8RMnn = parcelRequire("8RMnn");

var $6rZuZ = parcelRequire("6rZuZ");

var $i99mu = parcelRequire("i99mu");

var $iNPsC = parcelRequire("iNPsC");
module.exports = {
    "ava": $fkcIz,
    "lior": $6Qu1S,
    "mup": $8RMnn,
    "ramen-bot": $6rZuZ,
    "rb": $i99mu,
    "zeke": $iNPsC
};

});
parcelRegister("fkcIz", function(module, exports) {
module.exports = $parcel$resolve("kcvJj");

});

parcelRegister("6Qu1S", function(module, exports) {
module.exports = $parcel$resolve("cShTd");

});

parcelRegister("8RMnn", function(module, exports) {
module.exports = $parcel$resolve("jDrMI");

});

parcelRegister("6rZuZ", function(module, exports) {
module.exports = $parcel$resolve("cMBvi");

});

parcelRegister("i99mu", function(module, exports) {
module.exports = $parcel$resolve("8XrDJ");

});

parcelRegister("iNPsC", function(module, exports) {
module.exports = $parcel$resolve("5Nw7p");

});



parcelRegister("dIkvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fbf4b3eb2a420b9$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
var $9fbf4b3eb2a420b9$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        students: [],
        archivedStudents: [],
        student: {},
        studentActivityHistory: [],
        totalPlayTime: 0
    },
    actions: {
        async sendGameSessionCommand ({ commit: commit }, { student_id: student_id, command: command, session_token: session_token }) {
            const response = await (0, $lKfjl.default).post(`/students/${student_id}/game_session_command`, {
                command: command,
                session_token: session_token
            });
            return response.data;
        },
        async loadStudents ({ commit: commit }, { class_room_id: class_room_id, archived: archived }) {
            const response = await (0, $lKfjl.default).get("/students", {
                params: {
                    class_room_id: class_room_id,
                    archived: archived
                }
            });
            if (archived) commit("setArchivedStudents", response.data);
            else commit("setStudents", response.data);
        },
        async loadStudent ({ commit: commit }, id) {
            try {
                const response = await (0, $lKfjl.default).get(`/students/${id}`);
                commit("setStudent", response.data);
                return response;
            } catch (error) {
                return error.response;
            }
        },
        async loadStudentActivityHistory ({ commit: commit }, { id: id, start_date: start_date, end_date: end_date }) {
            const response = await (0, $lKfjl.default).get(`/students/${id}/activity_history`, {
                params: {
                    start_date: start_date,
                    end_date: end_date
                }
            });
            commit("setStudentActivityHistory", response.data.activity_history);
            commit("setTotalPlayTime", response.data.total_play_time);
        },
        async createNote ({ commit: commit, state: state }, { content: content, title: title, noteType: noteType, studentId: studentId, noteId: noteId }) {
            const response = await (0, $lKfjl.default).post(`/students/${studentId}/notes`, {
                content: content,
                title: title,
                note_type: noteType,
                note_id: noteId
            });
            commit("setStudent", {
                ...state.student,
                notes: response.data
            });
            return response.data;
        },
        async createStudents ({}, { names: names, class_room_id: class_room_id }) {
            await (0, $lKfjl.default).post(`/students`, {
                names: names,
                class_room_id: class_room_id
            });
        },
        async createStudentTransfer ({ commit: commit }, { student_id: student_id, classroom_key: classroom_key, classroom_id: classroom_id }) {
            await (0, $lKfjl.default).post(`/students/${student_id}/transfer`, {
                classroom_key: classroom_key,
                classroom_id: classroom_id
            });
        },
        async completeStudentTransfer ({ commit: commit }, { student_id: student_id, transfer_id: transfer_id, accepted: accepted }) {
            await (0, $lKfjl.default).post(`/students/${student_id}/complete_transfer`, {
                transfer_id: transfer_id,
                accepted: accepted
            });
        },
        async archiveStudent ({}, { student_id: student_id }) {
            await (0, $lKfjl.default).post(`/students/${student_id}/archive`);
        },
        async restoreStudent ({}, { student_id: student_id, classroom_id: classroom_id }) {
            await (0, $lKfjl.default).post(`/students/${student_id}/restore`, {
                classroom_id: classroom_id
            });
        },
        async deleteStudent ({}, student_id) {
            await (0, $lKfjl.default).delete(`/students/${student_id}`);
        },
        async updateStudent ({}, student) {
            await (0, $lKfjl.default).put(`/students/${student.id}`, student);
        },
        async setOnlineStatus ({ commit: commit, state: state }, { student_id: student_id, online_status: online_status }) {
            const student = state.students.find((student)=>student.id === student_id);
            const live = online_status === "online";
            student.live = live;
            if (state.student.id === student_id) state.student.live = live;
        }
    },
    mutations: {
        setStudents (state, students) {
            state.students = students;
        },
        setArchivedStudents (state, students) {
            state.archivedStudents = students;
        },
        setStudent (state, student) {
            state.student = student;
        },
        removeNote (state, { noteType: noteType, date: date, noteId: noteId }) {
            state.student.notes[noteType][date] = state.student.notes[noteType][date].filter((note)=>note.id !== noteId);
        },
        setStudentActivityHistory (state, studentActivityHistory) {
            state.studentActivityHistory = studentActivityHistory;
        },
        setTotalPlayTime (state, totalPlayTime) {
            state.totalPlayTime = totalPlayTime;
        }
    },
    getters: {
        students: (state)=>state.students,
        student: (state)=>state.student,
        studentActivityHistory: (state)=>state.studentActivityHistory,
        archivedStudents: (state)=>state.archivedStudents,
        totalPlayTime: (state)=>state.totalPlayTime
    }
};

});

parcelRegister("LT9Rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ff2d230478ceed$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
let $08ff2d230478ceed$var$episodeRequest = 0;
var $08ff2d230478ceed$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        episodes: [],
        episode: {}
    },
    actions: {
        async lockEpisode ({}, { id: id, locked: locked, class_room_id: class_room_id }) {
            await (0, $lKfjl.default).put(`/episodes/${id}/lock`, {
                locked: locked,
                class_room_id: class_room_id
            });
        },
        async loadEpisodes ({ commit: commit, state: state }) {
            const response = await (0, $lKfjl.default).get("/episodes");
            commit("setEpisodes", response.data);
        },
        async loadEpisode ({ commit: commit }, payload) {
            const { id: id, preview: preview } = typeof payload === "object" ? payload : {
                id: payload
            };
            const request = ++$08ff2d230478ceed$var$episodeRequest;
            commit("setEpisode", {});
            const response = await (0, $lKfjl.default).get(`/episodes/${id}`, {
                params: {
                    preview: preview ? "true" : undefined
                }
            });
            if (request !== $08ff2d230478ceed$var$episodeRequest) return;
            commit("setEpisode", response.data);
            return response;
        }
    },
    mutations: {
        setEpisodes (state, episodes) {
            state.episodes = episodes;
        },
        setEpisode (state, episode) {
            state.episode = episode;
        }
    },
    getters: {
        episodes: (state)=>state.episodes,
        episode: (state)=>state.episode
    }
};

});

parcelRegister("1B92U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12a0437ce456173c$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
var $12a0437ce456173c$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        classRooms: [],
        classRoom: {}
    },
    actions: {
        async loadClassRooms ({ commit: commit }) {
            const response = await (0, $lKfjl.default).get("/class_rooms");
            commit("setClassRooms", response.data);
        },
        async loadClassRoom ({ commit: commit }, id) {
            const response = await (0, $lKfjl.default).get(`/class_rooms/${id}`);
            commit("setClassRoom", response.data);
        },
        createClassRoom ({ commit: commit, state: state }, data) {
            return (0, $lKfjl.default).post("/class_rooms", data).then((response)=>{
                commit("setClassRooms", [
                    ...state.classRooms,
                    response.data
                ]);
                return response;
            }).catch((error)=>{
                return error.response;
            });
        },
        updateClassRoom ({ commit: commit, state: state }, data) {
            return (0, $lKfjl.default).put(`/class_rooms/${data.id}`, data).then((response)=>{
                commit("setClassRooms", state.classRooms.map((classRoom)=>classRoom.id === data.id ? response.data : classRoom));
                return response;
            }).catch((error)=>{
                return error.response;
            });
        },
        sendInvite ({ commit: commit, state: state }, data) {
            return (0, $lKfjl.default).post(`/class_rooms/${data.id}/invite`, data).then((response)=>{
                return response;
            });
        },
        deleteClassRoom ({ commit: commit, state: state }, id) {
            return (0, $lKfjl.default).delete(`/class_rooms/${id}`).then((response)=>{
                return response;
            });
        },
        assignEpisode ({}, { id: id, episodeId: episodeId, assigned: assigned }) {
            return (0, $lKfjl.default).post(`/class_rooms/${id}/assign_episode`, {
                episode_id: episodeId,
                assigned: assigned
            }).then((response)=>{
                return response;
            });
        },
        updateUserClassRoom ({ commit: commit, state: state }, { id: id, role: role }) {
            return (0, $lKfjl.default).put(`/user_class_rooms/${id}`, {
                user_class_room: {
                    role: role
                }
            }).then((response)=>{
                return response;
            });
        },
        removeUserClassRoom ({ commit: commit, state: state }, id) {
            return (0, $lKfjl.default).delete(`/user_class_rooms/${id}`).then((response)=>{
                return response;
            });
        },
        fetchGoogleClassrooms () {
            return (0, $lKfjl.default).get('/class_rooms/google_classrooms').then((response)=>response).catch((error)=>error.response);
        },
        async syncGoogleClassrooms (_context, selection = null) {
            const response = await (0, $lKfjl.default).post('/class_rooms/sync_google_classroom', {
                selection: selection
            });
            return response;
        },
        disconnectGoogleClassroom (_context, id) {
            return (0, $lKfjl.default).post(`/class_rooms/${id}/disconnect_google_classroom`, {
                confirm_delete_students: true
            });
        },
        async pushToGoogleClassroom (_context, { id: id, includeAnnouncement: includeAnnouncement, consentRetry: consentRetry = false }) {
            return (0, $lKfjl.default).post(`/class_rooms/${id}/push_to_classroom`, {
                include_announcement: includeAnnouncement,
                consent_retry: consentRetry
            });
        }
    },
    mutations: {
        setClassRooms (state, classRooms) {
            state.classRooms = classRooms;
        },
        setClassRoom (state, classRoom) {
            state.classRoom = classRoom;
        }
    },
    getters: {
        classRooms: (state)=>state.classRooms,
        classRoom: (state)=>state.classRoom
    }
};

});

parcelRegister("dKudV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a02703fe17318804$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
let $a02703fe17318804$var$lessonPlanRequest = 0;
let $a02703fe17318804$var$lessonRequest = 0;
var $a02703fe17318804$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        contents: [],
        categories: [],
        contentTypes: [],
        content: {},
        tags: [],
        lessonPlans: [],
        lessonPlan: {},
        lesson: {}
    },
    actions: {
        async loadAllCurriculum ({ commit: commit }) {
            const response = await (0, $lKfjl.default).get(`/lesson_plans/`);
            commit("setLessonPlans", response.data.lesson_plans);
            commit("setContentTypes", response.data.content_types);
            commit("setTags", response.data.tags);
        },
        async loadCurriculum ({ commit: commit }, id) {
            const response = await (0, $lKfjl.default).get(`/cms/${id}`);
            commit("setContent", response.data);
        },
        async fetchLessonPlan ({ commit: commit }, payload) {
            const { id: id, preview: preview, revisionId: revisionId } = typeof payload === "object" ? payload : {
                id: payload
            };
            const request = ++$a02703fe17318804$var$lessonPlanRequest;
            commit("setLessonPlan", {});
            try {
                const response = await (0, $lKfjl.default).get(`/lesson_plans/${id}`, {
                    params: {
                        preview: preview ? "true" : undefined,
                        revision_id: preview ? revisionId : undefined
                    }
                });
                if (request !== $a02703fe17318804$var$lessonPlanRequest) return;
                commit("setLessonPlan", response.data);
                return response;
            } catch (error) {
                return error.response;
            }
        },
        async fetchLesson ({ commit: commit }, payload) {
            const { id: id, preview: preview, revisionId: revisionId, lessonPlanId: lessonPlanId } = typeof payload === "object" ? payload : {
                id: payload
            };
            const request = ++$a02703fe17318804$var$lessonRequest;
            commit("setLesson", {});
            const response = await (0, $lKfjl.default).get(`/lessons/${id}`, {
                params: {
                    preview: preview ? "true" : undefined,
                    revision_id: preview ? revisionId : undefined,
                    lesson_plan_id: lessonPlanId
                }
            });
            if (request !== $a02703fe17318804$var$lessonRequest) return;
            commit("setLesson", response.data);
            return response;
        }
    },
    mutations: {
        setLessonPlans (state, data) {
            state.lessonPlans = data;
        },
        setLessonPlan (state, data) {
            state.lessonPlan = data;
        },
        setContents (state, data) {
            state.contents = data;
        },
        setContent (state, data) {
            state.content = data;
        },
        setCategories (state, data) {
            state.categories = data;
        },
        setContentTypes (state, data) {
            state.contentTypes = data;
        },
        setTags (state, data) {
            state.tags = data;
        },
        setLesson (state, data) {
            state.lesson = data;
        }
    },
    getters: {
        lessonPlans: (state)=>state.lessonPlans,
        contents: (state)=>state.contents,
        content: (state)=>state.content,
        categories: (state)=>state.categories,
        contentTypes: (state)=>state.contentTypes,
        tags: (state)=>state.tags,
        lessonPlan: (state)=>state.lessonPlan,
        lesson: (state)=>state.lesson
    }
};

});

parcelRegister("amc3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78a54fd39242fe87$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
var $78a54fd39242fe87$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        transactions: []
    },
    mutations: {
        setTransactionHistory (state, data) {
            state.transactions = data;
        }
    },
    getters: {
        transactions: (state)=>state.transactions
    },
    actions: {
        getPaymentToken () {
            return (0, $lKfjl.default).get("/payment_token").then((r)=>r).catch((e)=>e.response);
        },
        updatePaymentMethod ({}, payload) {
            return (0, $lKfjl.default).put("/user_subscriptions/update_payment_method", payload).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        },
        loadTransactions ({ commit: commit }) {
            return (0, $lKfjl.default).get("/load_transactions").then((res)=>{
                commit("setTransactionHistory", res.data);
                return res;
            }).catch((err)=>err.response);
        },
        submitPayment ({ commit: commit }, payload) {
            return (0, $lKfjl.default).post("/payments", {
                payment: {
                    ...payload
                }
            }).then((res)=>{
                // commit("setReceiptInfo", res.data);
                return res;
            }).catch((e)=>e.response);
        },
        loadDiscountCode ({}, { discountCode: discountCode, planId: planId, profileCount: profileCount }) {
            return (0, $lKfjl.default).get("/discount_code", {
                params: {
                    discount_code: discountCode,
                    plan_id: planId,
                    student_limit: profileCount
                }
            }).then((res)=>res).catch((e)=>e.response);
        }
    }
};

});

parcelRegister("8TCFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a173b82cdf9eb4$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
const $67a173b82cdf9eb4$var$getDefaultState = ()=>{
    return {
        subscriptions: [],
        userSubscription: {}
    };
};
const $67a173b82cdf9eb4$var$subscriptionsStore = {
    namespaced: true,
    state: ()=>$67a173b82cdf9eb4$var$getDefaultState(),
    mutations: {
        setSubscriptions (state, data) {
            state.subscriptions = data;
        },
        setUserSubscription (state, data) {
            state.userSubscription = data;
        }
    },
    getters: {
        subscriptions: (state)=>state.subscriptions,
        userSubscription: (state)=>state.userSubscription
    },
    actions: {
        loadSubscriptionPlans ({ commit: commit }, role) {
            return (0, $lKfjl.default).get("/subscriptions", {
                params: {
                    role: role
                }
            }).then((res)=>{
                commit("setSubscriptions", res.data);
                return res;
            });
        },
        selectPlan ({ commit: commit }, { plan: plan, student_limit: student_limit }) {
            return (0, $lKfjl.default).post("/user_subscriptions", {
                subscription_id: plan.id,
                student_limit: student_limit,
                billing_cycle: plan.billing_cycle
            }).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        },
        cancelSubscription ({}, cancelReasons) {
            return (0, $lKfjl.default).delete("/user_subscriptions", {
                params: cancelReasons
            }).then((res)=>{
                return res;
            }).catch((err)=>err.response);
        },
        updatePaymentMethod ({}, payload) {
            return (0, $lKfjl.default).put("/user_subscriptions/update_payment_method", payload).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        },
        updateSubscription ({}, payload) {
            return (0, $lKfjl.default).put("/user_subscriptions/change_subscription", payload).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        },
        calculateProration ({}, payload) {
            return (0, $lKfjl.default).post("/user_subscriptions/calculate_change", payload).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        },
        loadUserSubscription ({ commit: commit }) {
            return (0, $lKfjl.default).get("/user_subscriptions/me").then((res)=>{
                commit("setUserSubscription", res.data);
                return res;
            });
        },
        updateSubscription ({}, payload) {
            return (0, $lKfjl.default).put("/user_subscriptions/change_subscription", payload).then((res)=>{
                return res;
            }).catch((e)=>e.response);
        }
    }
};
var $67a173b82cdf9eb4$export$2e2bcd8739ae039 = $67a173b82cdf9eb4$var$subscriptionsStore;

});

parcelRegister("gazI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5947bd70bd8955$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
var $bc5947bd70bd8955$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        notifications: [],
        unreadCount: 0,
        loading: false,
        loaded: false
    },
    getters: {
        notifications: (state)=>state.notifications,
        unreadCount: (state)=>state.unreadCount,
        loading: (state)=>state.loading,
        loaded: (state)=>state.loaded
    },
    mutations: {
        setLoading (state, loading) {
            state.loading = loading;
        },
        setNotifications (state, payload) {
            state.notifications = payload.notifications || [];
            state.unreadCount = payload.unread_count || 0;
            state.loaded = true;
        }
    },
    actions: {
        async loadNotifications ({ commit: commit }) {
            commit("setLoading", true);
            try {
                const response = await (0, $lKfjl.default).get("/notifications");
                commit("setNotifications", response.data);
                return response;
            } finally{
                commit("setLoading", false);
            }
        },
        async respondToNotification ({ dispatch: dispatch }, { id: id, type: type, accepted: accepted }) {
            const endpoint = type === "co_teacher_invite" ? `/notifications/${id}/respond_to_co_teacher_invite` : `/notifications/${id}/respond_to_student_transfer`;
            const response = await (0, $lKfjl.default).post(endpoint, {
                accepted: accepted
            });
            await dispatch("loadNotifications");
            return response;
        }
    }
};

});

parcelRegister("8ATk6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641c999081fa1143$export$2e2bcd8739ae039; });

var $lKfjl = parcelRequire("lKfjl");
var $641c999081fa1143$export$2e2bcd8739ae039 = {
    namespaced: true,
    state: {
        overview: null,
        advisors: [],
        students: [],
        classrooms: [],
        sessionTrends: null,
        loadingOverview: false,
        loadingAdvisors: false,
        loadingStudents: false,
        loadingClassrooms: false,
        noGroup: false
    },
    getters: {
        overview: (state)=>state.overview,
        advisors: (state)=>state.advisors,
        students: (state)=>state.students,
        classrooms: (state)=>state.classrooms,
        sessionTrends: (state)=>state.sessionTrends,
        loadingOverview: (state)=>state.loadingOverview,
        loadingAdvisors: (state)=>state.loadingAdvisors,
        loadingStudents: (state)=>state.loadingStudents,
        loadingClassrooms: (state)=>state.loadingClassrooms,
        noGroup: (state)=>state.noGroup
    },
    mutations: {
        setNoGroup (state, value) {
            state.noGroup = value;
        },
        setSessionTrends (state, trends) {
            state.sessionTrends = trends;
        },
        setOverview (state, overview) {
            state.overview = overview;
        },
        setAdvisors (state, advisors) {
            state.advisors = advisors;
        },
        setStudents (state, students) {
            state.students = students;
        },
        setLoadingOverview (state, loading) {
            state.loadingOverview = loading;
        },
        setLoadingAdvisors (state, loading) {
            state.loadingAdvisors = loading;
        },
        setLoadingStudents (state, loading) {
            state.loadingStudents = loading;
        },
        setClassrooms (state, classrooms) {
            state.classrooms = classrooms;
        },
        setLoadingClassrooms (state, loading) {
            state.loadingClassrooms = loading;
        },
        upsertAdvisor (state, advisor) {
            const index = state.advisors.findIndex((a)=>a.id === advisor.id);
            if (index >= 0) state.advisors.splice(index, 1, advisor);
            else state.advisors.push(advisor);
        },
        upsertClassroom (state, classroom) {
            const index = state.classrooms.findIndex((c)=>c.id === classroom.id);
            if (index >= 0) state.classrooms.splice(index, 1, classroom);
            else state.classrooms.push(classroom);
        },
        upsertStudent (state, student) {
            const index = state.students.findIndex((s)=>s.id === student.id);
            if (index >= 0) state.students.splice(index, 1, student);
            else state.students.push(student);
        },
        removeAdvisor (state, id) {
            const nid = Number(id);
            state.advisors = state.advisors.filter((advisor)=>advisor.id !== nid);
        },
        removeStudent (state, id) {
            const nid = Number(id);
            state.students = state.students.filter((student)=>student.id !== nid);
        },
        removeClassroom (state, id) {
            const nid = Number(id);
            state.classrooms = state.classrooms.filter((classroom)=>classroom.id !== nid);
            state.students = state.students.filter((student)=>student.class_room_id !== nid);
        },
        setStudentsFromMove (state, students) {
            students.forEach((updated)=>{
                const index = state.students.findIndex((s)=>s.id === updated.id);
                if (index >= 0) state.students.splice(index, 1, updated);
            });
        }
    },
    actions: {
        loadOverview ({ commit: commit, dispatch: dispatch }) {
            commit("setLoadingOverview", true);
            return (0, $lKfjl.default).get("/group/overview").then((response)=>{
                commit("setNoGroup", false);
                commit("setOverview", response.data);
                return response;
            }).catch((error)=>{
                if (error.response?.status === 403) {
                    commit("setNoGroup", true);
                    return error.response;
                }
                dispatch("showToast", {
                    type: "error",
                    message: "Failed to load group overview"
                }, {
                    root: true
                });
                return error.response;
            }).finally(()=>{
                commit("setLoadingOverview", false);
            });
        },
        loadAdvisors ({ commit: commit, dispatch: dispatch }) {
            commit("setLoadingAdvisors", true);
            return (0, $lKfjl.default).get("/group/advisors").then((response)=>{
                commit("setAdvisors", response.data.advisors);
                return response;
            }).catch((error)=>{
                if (error.response?.status === 403) {
                    commit("setNoGroup", true);
                    return error.response;
                }
                dispatch("showToast", {
                    type: "error",
                    message: "Failed to load advisors"
                }, {
                    root: true
                });
                return error.response;
            }).finally(()=>{
                commit("setLoadingAdvisors", false);
            });
        },
        inviteAdvisor ({ commit: commit, dispatch: dispatch }, payload) {
            return (0, $lKfjl.default).post("/group/advisors", {
                advisor: payload
            }).then((response)=>{
                commit("upsertAdvisor", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Advisor invited successfully"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.errors?.join(", ") || error.response?.data?.error || "Failed to invite advisor";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        updateAdvisorLicenses ({ commit: commit, dispatch: dispatch }, { id: id, student_limit_override: student_limit_override }) {
            return (0, $lKfjl.default).patch(`/group/advisors/${id}`, {
                advisor: {
                    student_limit_override: student_limit_override
                }
            }).then((response)=>{
                commit("upsertAdvisor", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Licenses updated"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to update licenses";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        archiveAdvisors ({ dispatch: dispatch }, advisor_ids) {
            return (0, $lKfjl.default).post("/group/advisors/archive", {
                advisor_ids: advisor_ids
            }).catch((error)=>{
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.error || "Failed to archive advisors"
                }, {
                    root: true
                });
                return error.response;
            });
        },
        archiveAdvisor ({ commit: commit, dispatch: dispatch }, id) {
            return (0, $lKfjl.default).delete(`/group/advisors/${id}`).then((response)=>{
                commit("removeAdvisor", id);
                dispatch("showToast", {
                    type: "success",
                    message: "Advisor archived"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to archive advisor";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        updateAdvisorRoles ({ commit: commit, dispatch: dispatch }, { advisor_ids: advisor_ids, school_admin: school_admin }) {
            return (0, $lKfjl.default).patch("/group/advisors/roles", {
                advisor_ids: advisor_ids,
                school_admin: school_admin
            }).then((response)=>{
                (response.data.advisors || []).forEach((advisor)=>{
                    commit("upsertAdvisor", advisor);
                });
                dispatch("showToast", {
                    type: "success",
                    message: school_admin ? "Admin role assigned" : "Admin role removed"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to update admin roles";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        createClassroom ({ commit: commit, dispatch: dispatch }, payload) {
            return (0, $lKfjl.default).post("/group/classrooms", {
                classroom: payload
            }).then((response)=>{
                commit("upsertClassroom", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Classroom created"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to create classroom";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        updateClassroom ({ commit: commit, dispatch: dispatch }, { id: id, ...payload }) {
            return (0, $lKfjl.default).patch(`/group/classrooms/${id}`, {
                classroom: payload
            }).then((response)=>{
                commit("upsertClassroom", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Classroom updated"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to update classroom";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        fetchAdvisor ({ dispatch: dispatch }, id) {
            return (0, $lKfjl.default).get(`/group/advisors/${id}`).then((response)=>response).catch((error)=>{
                const message = error.response?.data?.error || "Failed to load advisor";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        sendAdvisorResetPassword ({ dispatch: dispatch }, id) {
            return (0, $lKfjl.default).post(`/group/advisors/${id}/send_reset_password`).then((response)=>{
                dispatch("showToast", {
                    type: "success",
                    message: "Password reset email sent"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to send password reset email";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        updateAdvisor ({ commit: commit, dispatch: dispatch }, { id: id, ...payload }) {
            return (0, $lKfjl.default).patch(`/group/advisors/${id}`, {
                advisor: payload
            }).then((response)=>{
                commit("upsertAdvisor", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Advisor updated"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.errors?.join(", ") || error.response?.data?.error || "Failed to update advisor";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        createStudents ({ commit: commit, dispatch: dispatch }, payload) {
            return (0, $lKfjl.default).post("/group/students", {
                student: payload
            }).then((response)=>{
                (response.data.students || []).forEach((student)=>{
                    commit("upsertStudent", student);
                });
                dispatch("showToast", {
                    type: "success",
                    message: "Student created"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to create student";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        fetchStudent ({ dispatch: dispatch }, id) {
            return (0, $lKfjl.default).get(`/group/students/${id}`).then((response)=>response).catch((error)=>{
                const message = error.response?.data?.error || "Failed to load student";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        archiveStudents ({ commit: commit, dispatch: dispatch }, student_ids) {
            return (0, $lKfjl.default).post("/group/students/archive", {
                student_ids: student_ids
            }).then((response)=>{
                response.data.student_ids.forEach((id)=>commit("removeStudent", id));
                const count = response.data.student_ids.length;
                dispatch("showToast", {
                    type: "success",
                    message: `${count} ${count === 1 ? "student" : "students"} archived`
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.error || "Failed to archive students"
                }, {
                    root: true
                });
                return error.response;
            });
        },
        archiveStudent ({ commit: commit, dispatch: dispatch }, id) {
            return (0, $lKfjl.default).post(`/group/students/${id}/archive`).then((response)=>{
                commit("removeStudent", id);
                dispatch("showToast", {
                    type: "success",
                    message: "Student archived"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to archive student";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        updateStudent ({ commit: commit, dispatch: dispatch }, { id: id, ...payload }) {
            return (0, $lKfjl.default).patch(`/group/students/${id}`, {
                student: payload
            }).then((response)=>{
                commit("upsertStudent", response.data);
                dispatch("showToast", {
                    type: "success",
                    message: "Student updated"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to update student";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        archiveClassroom ({ commit: commit, dispatch: dispatch }, id) {
            return (0, $lKfjl.default).delete(`/group/classrooms/${id}`).then((response)=>{
                commit("removeClassroom", id);
                dispatch("showToast", {
                    type: "success",
                    message: "Classroom archived"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to archive classroom";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        fetchClassroom ({ dispatch: dispatch }, id) {
            return (0, $lKfjl.default).get(`/group/classrooms/${id}`).then((response)=>response).catch((error)=>{
                const message = error.response?.data?.error || "Failed to load classroom";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        },
        loadStudents ({ commit: commit, dispatch: dispatch }) {
            commit("setLoadingStudents", true);
            return (0, $lKfjl.default).get("/group/students").then((response)=>{
                commit("setStudents", response.data.students);
                return response;
            }).catch((error)=>{
                if (error.response?.status === 403) {
                    commit("setNoGroup", true);
                    return error.response;
                }
                dispatch("showToast", {
                    type: "error",
                    message: "Failed to load students"
                }, {
                    root: true
                });
                return error.response;
            }).finally(()=>{
                commit("setLoadingStudents", false);
            });
        },
        loadClassrooms ({ commit: commit, dispatch: dispatch }) {
            commit("setLoadingClassrooms", true);
            return (0, $lKfjl.default).get("/group/classrooms").then((response)=>{
                commit("setClassrooms", response.data.classrooms);
                return response;
            }).catch((error)=>{
                if (error.response?.status === 403) {
                    commit("setNoGroup", true);
                    return error.response;
                }
                dispatch("showToast", {
                    type: "error",
                    message: "Failed to load classrooms"
                }, {
                    root: true
                });
                return error.response;
            }).finally(()=>{
                commit("setLoadingClassrooms", false);
            });
        },
        // The panel commits only the latest response so rapid filter changes cannot
        // replace the chart/table with results from an older request.
        loadSessionTrends (_context, params = {}) {
            return (0, $lKfjl.default).get("/group/sessions/trends", {
                params: params
            }).catch((error)=>error.response);
        },
        moveStudents ({ commit: commit, dispatch: dispatch }, { student_ids: student_ids, class_room_id: class_room_id, advisor_id: advisor_id }) {
            return (0, $lKfjl.default).post("/group/students/move", {
                student_ids: student_ids,
                class_room_id: class_room_id,
                advisor_id: advisor_id
            }).then((response)=>{
                commit("setStudentsFromMove", response.data.students);
                dispatch("showToast", {
                    type: "success",
                    message: "Students moved successfully"
                }, {
                    root: true
                });
                return response;
            }).catch((error)=>{
                const message = error.response?.data?.error || "Failed to move students";
                dispatch("showToast", {
                    type: "error",
                    message: message
                }, {
                    root: true
                });
                return error.response;
            });
        }
    }
};

});


parcelRegister("f3p95", function(module, exports) {

$parcel$export(module.exports, "returnToQuery", function () { return $af5aa43bbe4be3ba$export$ba35c408988610e4; });
$parcel$export(module.exports, "afterLoginLocation", function () { return $af5aa43bbe4be3ba$export$833e7636f62caf6a; });
// Return destinations are dashboard routes, never arbitrary URLs or server endpoints.
function $af5aa43bbe4be3ba$export$63eb036f79a91e6b(value, router) {
    if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) return null;
    // Google carries this in the cookie session; leave room for the session itself.
    if (new TextEncoder().encode(value).length > 2048) return null;
    // Reject encoded controls/backslashes as well as their literal forms. Decode only
    // for validation; retain the original query and hash for the actual navigation.
    let decoded = value;
    try {
        while(true){
            if (!decoded.startsWith("/") || decoded.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(decoded)) return null;
            const next = decoded.replace(/%([0-9a-f]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
            if (next === decoded) break;
            decoded = next;
        }
        const target = router.resolve(value);
        if ([
            "not-found",
            "account-setup"
        ].includes(target.name) || !target.matched.some((record)=>record.meta.requiresAuth)) return null;
        return target.fullPath;
    } catch  {
        return null;
    }
}
function $af5aa43bbe4be3ba$export$ba35c408988610e4(value, router) {
    const path = $af5aa43bbe4be3ba$export$63eb036f79a91e6b(value, router);
    return path ? {
        return_to: path
    } : {};
}
function $af5aa43bbe4be3ba$export$833e7636f62caf6a(value, router) {
    return $af5aa43bbe4be3ba$export$63eb036f79a91e6b(value, router) || {
        name: "dashboard"
    };
}

});

parcelRegister("477Q4", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("7DLXJ")),
    (parcelRequire("hhmXV"))($parcel$resolve("1fvDk"))
]).then(()=>parcelRequire('02WNi'));

});
parcelRegister("bO2cy", function(module, exports) {
"use strict";

var $e0b2y = parcelRequire("e0b2y");
module.exports = $e0b2y(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("e0b2y", function(module, exports) {
"use strict";
var $a319a126c9eb31bf$var$cachedBundles = {};
var $a319a126c9eb31bf$var$cachedPreloads = {};
var $a319a126c9eb31bf$var$cachedPrefetches = {};
function $a319a126c9eb31bf$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a319a126c9eb31bf$var$cachedPreloads;
        case 'prefetch':
            return $a319a126c9eb31bf$var$cachedPrefetches;
        default:
            return $a319a126c9eb31bf$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a319a126c9eb31bf$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hhmXV", function(module, exports) {
"use strict";

var $e0b2y = parcelRequire("e0b2y");
module.exports = $e0b2y(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("1qCth", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("l62qd")),
    (parcelRequire("hhmXV"))($parcel$resolve("intw5")),
    (parcelRequire("hhmXV"))($parcel$resolve("dxOnj")),
    (parcelRequire("hhmXV"))($parcel$resolve("3zPho")),
    (parcelRequire("hhmXV"))($parcel$resolve("8f0Xb"))
]).then(()=>parcelRequire('iad5Z'));

});

parcelRegister("j1GML", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("lnftg")),
    (parcelRequire("hhmXV"))($parcel$resolve("dxOnj")),
    (parcelRequire("hhmXV"))($parcel$resolve("3zPho")),
    (parcelRequire("hhmXV"))($parcel$resolve("4LDM5"))
]).then(()=>parcelRequire('ajPgB'));

});

parcelRegister("4V3RX", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("g82zY")),
    (parcelRequire("hhmXV"))($parcel$resolve("dxOnj")),
    (parcelRequire("hhmXV"))($parcel$resolve("3zPho")),
    (parcelRequire("hhmXV"))($parcel$resolve("eTVK7"))
]).then(()=>parcelRequire('497S9'));

});

parcelRegister("a9gkp", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("jv44c")),
    (parcelRequire("hhmXV"))($parcel$resolve("intw5")),
    (parcelRequire("hhmXV"))($parcel$resolve("dxOnj")),
    (parcelRequire("hhmXV"))($parcel$resolve("3zPho")),
    (parcelRequire("hhmXV"))($parcel$resolve("6HzcB"))
]).then(()=>parcelRequire('f5zGa'));

});

parcelRegister("2VPXZ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("3DX6x")),
    (parcelRequire("hhmXV"))($parcel$resolve("cuLvG"))
]).then(()=>parcelRequire('3dGGI'));

});

parcelRegister("hsp35", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("lXHaS")),
    (parcelRequire("hhmXV"))($parcel$resolve("Dk2W1"))
]).then(()=>parcelRequire('8ZjT0'));

});

parcelRegister("3lp0S", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("ezcv4")),
    (parcelRequire("hhmXV"))($parcel$resolve("dV4m1"))
]).then(()=>parcelRequire('jBeU7'));

});

parcelRegister("7XqzI", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("bt150")),
    (parcelRequire("hhmXV"))($parcel$resolve("ig0MQ"))
]).then(()=>parcelRequire('cgln8'));

});

parcelRegister("jI828", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("cB8Tc")),
    (parcelRequire("hhmXV"))($parcel$resolve("8kZ9m"))
]).then(()=>parcelRequire('hPmcN'));

});

parcelRegister("1F1LR", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("9Jfqr")),
    (parcelRequire("hhmXV"))($parcel$resolve("6H37U"))
]).then(()=>parcelRequire('8xlsh'));

});

parcelRegister("jAq8p", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("gogs1")),
    (parcelRequire("hhmXV"))($parcel$resolve("3OSER"))
]).then(()=>parcelRequire('krhEs'));

});

parcelRegister("ePN9v", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("aH4fU")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("kec2e")),
    (parcelRequire("hhmXV"))($parcel$resolve("epYis"))
]).then(()=>parcelRequire('66rbH'));

});

parcelRegister("9aMt1", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("5gbmp")),
    (parcelRequire("hhmXV"))($parcel$resolve("cQTwu")),
    (parcelRequire("bO2cy"))($parcel$resolve("h4N9U")),
    (parcelRequire("hhmXV"))($parcel$resolve("iePaV")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("77hXc")),
    (parcelRequire("hhmXV"))($parcel$resolve("idJDn"))
]).then(()=>parcelRequire('1dIEt'));

});

parcelRegister("ljNhP", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("13cZQ")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("fnjjc"))
]).then(()=>parcelRequire('7wGV0'));

});

parcelRegister("4GmtS", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("9F58g")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("aV3W7"))
]).then(()=>parcelRequire('f0TX6'));

});

parcelRegister("fMGHq", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("5eEo6")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("08NZw"))
]).then(()=>parcelRequire('16A6S'));

});

parcelRegister("aShuk", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("2PfFv")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("cHUf7"))
]).then(()=>parcelRequire('a7KbQ'));

});

parcelRegister("7uCFJ", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("fpIAy")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8jyt8"))
]).then(()=>parcelRequire('01O4i'));

});

parcelRegister("hsdLS", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("gfVUN")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("973YF"))
]).then(()=>parcelRequire('4J9gs'));

});

parcelRegister("ksQNo", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("frP0l")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("1RVLY"))
]).then(()=>parcelRequire('4ub8N'));

});

parcelRegister("edjei", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("6C6Fw")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("kec2e")),
    (parcelRequire("hhmXV"))($parcel$resolve("l9uO6"))
]).then(()=>parcelRequire('lW5qJ'));

});

parcelRegister("4GVmN", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("50Tz1")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("cslPk"))
]).then(()=>parcelRequire('vKv0e'));

});

parcelRegister("g5zll", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("hhmXV"))($parcel$resolve("1FsqH")),
    (parcelRequire("bO2cy"))($parcel$resolve("jyZFS")),
    (parcelRequire("bO2cy"))($parcel$resolve("h4N9U")),
    (parcelRequire("hhmXV"))($parcel$resolve("iePaV")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("l597n")),
    (parcelRequire("hhmXV"))($parcel$resolve("77hXc")),
    (parcelRequire("hhmXV"))($parcel$resolve("ek08q"))
]).then(()=>parcelRequire('5ZMvT'));

});

parcelRegister("bHUgq", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("gU8SW")),
    (parcelRequire("bO2cy"))($parcel$resolve("jXWTS")),
    (parcelRequire("hhmXV"))($parcel$resolve("1BbE3")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("933zF"))
]).then(()=>parcelRequire('cF1TR'));

});

parcelRegister("e1TO2", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("7ExBf")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("77hXc")),
    (parcelRequire("hhmXV"))($parcel$resolve("4rwud"))
]).then(()=>parcelRequire('f0Xd4'));

});

parcelRegister("aHop5", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("hMOiY")),
    (parcelRequire("hhmXV"))($parcel$resolve("1FsqH")),
    (parcelRequire("hhmXV"))($parcel$resolve("cQTwu")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("aTwtD"))
]).then(()=>parcelRequire('hYiuh'));

});

parcelRegister("5cHeI", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("a4Lfl")),
    (parcelRequire("hhmXV"))($parcel$resolve("1FsqH")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("7uOA6"))
]).then(()=>parcelRequire('9CSB2'));

});

parcelRegister("7yVWc", function(module, exports) {







module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("2pXv1")),
    (parcelRequire("bO2cy"))($parcel$resolve("jXWTS")),
    (parcelRequire("hhmXV"))($parcel$resolve("1BbE3")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("cAxGk")),
    (parcelRequire("hhmXV"))($parcel$resolve("77Z8e"))
]).then(()=>parcelRequire('lshsU'));

});

parcelRegister("5P1IT", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("gdOmH")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("47jHZ"))
]).then(()=>parcelRequire('8CvXp'));

});

parcelRegister("hwiZb", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("fwVdb")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("h7dLs"))
]).then(()=>parcelRequire('1YTeI'));

});

parcelRegister("efpx2", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("grxPc")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("8Xqts")),
    (parcelRequire("hhmXV"))($parcel$resolve("1D4cW"))
]).then(()=>parcelRequire('cBrsL'));

});

parcelRegister("ejJQg", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("bO2cy"))($parcel$resolve("j6qAY")),
    (parcelRequire("hhmXV"))($parcel$resolve("3JNV7")),
    (parcelRequire("hhmXV"))($parcel$resolve("gXnnp"))
]).then(()=>parcelRequire('a6ccY'));

});

parcelRegister("6p2TQ", function(module, exports) {
/*! For license information please see rollbar.umd.min.js.LICENSE.txt */ !function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function() {
        "use strict";
        var t = {
            d: function(e, r) {
                for(var n in r)t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, {
                    enumerable: !0,
                    get: r[n]
                });
            },
            o: function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            },
            r: function(t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            }
        }, e = {};
        t.d(e, {
            default: function() {
                return eo;
            }
        });
        var r = {};
        function n(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return o(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, i = function() {};
                    return {
                        s: i,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: i
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var a, s = !0, u = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return s = t.done, t;
                },
                e: function(t) {
                    u = !0, a = t;
                },
                f: function() {
                    try {
                        s || null == r.return || r.return();
                    } finally{
                        if (u) throw a;
                    }
                }
            };
        }
        function o(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function i(t) {
            return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, i(t);
        }
        function a(t, e) {
            return e === s(t);
        }
        function s(t) {
            var e = i(t);
            return "object" !== e ? e : t ? t instanceof Error ? "error" : ({}).toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
        }
        function u(t) {
            return a(t, "function");
        }
        function l(t) {
            return null != t && ("object" == i(t) || "function" == typeof t);
        }
        function c(t, e) {
            return null != t && (Object.hasOwn ? Object.hasOwn(t, e) : Object.prototype.hasOwnProperty.call(t, e));
        }
        function f(t) {
            return Number.isFinite(t);
        }
        function p(t) {
            return a(t, "error") || a(t, "exception");
        }
        function d() {
            return "********";
        }
        t.r(r), t.d(r, {
            parse: function() {
                return hn;
            }
        });
        var h = {
            debug: 0,
            info: 1,
            warning: 2,
            error: 3,
            critical: 4
        };
        function y(t) {
            var e = function(t) {
                if (!a(t, "string")) return;
                for(var e = v, r = e.parser[e.strictMode ? "strict" : "loose"].exec(t), n = {}, o = 0, i = e.key.length; o < i; ++o)n[e.key[o]] = r[o] || "";
                return n[e.q.name] = {}, n[e.key[12]].replace(e.q.parser, function(t, r, o) {
                    r && (n[e.q.name][r] = o);
                }), n;
            }(t);
            return e ? ("" === e.anchor && (e.source = e.source.replace("#", "")), t = e.source.replace("?" + e.query, "")) : "(unknown)";
        }
        var v = {
            strictMode: !1,
            key: [
                "source",
                "protocol",
                "authority",
                "userInfo",
                "user",
                "password",
                "host",
                "port",
                "relative",
                "path",
                "directory",
                "file",
                "query",
                "anchor"
            ],
            q: {
                name: "queryKey",
                parser: /(?:^|&)([^&=]*)=?([^&]*)/g
            },
            parser: {
                strict: /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose: /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
            }
        };
        function m(t, e) {
            if (!(e = e || t.protocol) && t.port && (80 === t.port ? e = "http:" : 443 === t.port && (e = "https:")), e = e || "https:", !t.hostname) return null;
            var r = e + "//" + t.hostname;
            return t.port && (r = r + ":" + t.port), t.path && (r += t.path), r;
        }
        function b(t, e) {
            var r, n;
            try {
                r = JSON.stringify(t);
            } catch (o) {
                if (e && u(e)) try {
                    r = e(t);
                } catch (t) {
                    n = t;
                }
                else n = o;
            }
            return {
                error: n,
                value: r
            };
        }
        function g(t) {
            var e, r;
            try {
                e = JSON.parse(t);
            } catch (t) {
                r = t;
            }
            return {
                error: r,
                value: e
            };
        }
        function w(t, e, r, n, o, i, a, s) {
            var u = {
                url: e || "",
                line: r,
                column: n
            };
            u.func = s.guessFunctionName(u.url, u.line), u.context = s.gatherContext(u.url, u.line);
            var l = "undefined" != typeof document && document && document.location && document.location.href, c = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
            return {
                mode: i,
                message: o ? String(o) : t || a,
                url: l,
                stack: [
                    u
                ],
                useragent: c
            };
        }
        function k(t, e) {
            return function(r, n) {
                try {
                    e(r, n);
                } catch (e) {
                    t.error(e);
                }
            };
        }
        function S(t) {
            return function t(e, r) {
                var n, o, i, u = {};
                try {
                    for(o in e)(n = e[o]) && (a(n, "object") || a(n, "array")) ? r.includes(n) ? u[o] = "Removed circular reference: " + s(n) : ((i = r.slice()).push(n), u[o] = t(n, i)) : u[o] = n;
                } catch (t) {
                    u = "Failed cloning custom data: " + t.message;
                }
                return u;
            }(t, [
                t
            ]);
        }
        function _(t, e, r, n, o) {
            for(var i, a, u, l, c, f, p = [], d = [], h = 0, y = t.length; h < y; ++h){
                var v = s(f = t[h]);
                switch(d.push(v), v){
                    case "undefined":
                        break;
                    case "string":
                        i ? p.push(f) : i = f;
                        break;
                    case "function":
                        l = k(e, f);
                        break;
                    case "date":
                        p.push(f);
                        break;
                    case "error":
                    case "domexception":
                    case "exception":
                        a ? p.push(f) : a = f;
                        break;
                    case "object":
                    case "array":
                        if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                            a ? p.push(f) : a = f;
                            break;
                        }
                        if (n && "object" === v && !c) {
                            for(var m = 0, b = n.length; m < b; ++m)if (void 0 !== f[n[m]]) {
                                c = f;
                                break;
                            }
                            if (c) break;
                        }
                        u ? p.push(f) : u = f;
                        break;
                    default:
                        if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                            a ? p.push(f) : a = f;
                            break;
                        }
                        p.push(f);
                }
            }
            u && (u = S(u)), p.length > 0 && (u || (u = S({})), u.extraArgs = S(p));
            var g, w = {
                message: i,
                err: a,
                custom: u,
                timestamp: P(),
                callback: l,
                notifier: r,
                diagnostic: {},
                uuid: (g = P(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
                    var e = (g + 16 * Math.random()) % 16 | 0;
                    return g = Math.floor(g / 16), ("x" === t ? e : 7 & e | 8).toString(16);
                }))
            };
            return w.data = w.data || {}, function(t, e) {
                e && void 0 !== e.level && (t.level = e.level, delete e.level);
                e && void 0 !== e.skipFrames && (t.skipFrames = e.skipFrames, delete e.skipFrames);
            }(w, u), n && c && (w.request = c), o && (w.lambdaContext = o), w._originalArgs = t, w.diagnostic.original_arg_types = d, w;
        }
        var O = [
            "log",
            "network",
            "dom",
            "navigation",
            "error",
            "manual"
        ], x = [
            "critical",
            "error",
            "warning",
            "info",
            "debug"
        ];
        function E(t, e) {
            var r, o = n(t);
            try {
                for(o.s(); !(r = o.n()).done;){
                    if (r.value === e) return !0;
                }
            } catch (t) {
                o.e(t);
            } finally{
                o.f();
            }
            return !1;
        }
        function j(t, e) {
            t.attributes = t.attributes || [];
            var r, o = n(e);
            try {
                for(o.s(); !(r = o.n()).done;){
                    var i = r.value;
                    void 0 !== i.value && t.attributes.push(i);
                }
            } catch (t) {
                o.e(t);
            } finally{
                o.f();
            }
        }
        function I(t, e) {
            if (t) {
                var r = e.split("."), n = t;
                try {
                    for(var o = 0, i = r.length; o < i; ++o)n = n[r[o]];
                } catch (t) {
                    n = void 0;
                }
                return n;
            }
        }
        function T(t, e, r) {
            if (t) {
                Object.setPrototypeOf(t, null);
                var n = e.split("."), o = n.length;
                if (!(o < 1)) {
                    if (1 !== o) try {
                        for(var i = t[n[0]] || {}, a = i, s = 1; s < o - 1; ++s)i[n[s]] = i[n[s]] || {}, i = i[n[s]];
                        i[n[o - 1]] = r, t[n[0]] = a;
                    } catch (t) {
                        return;
                    }
                    else t[n[0]] = r;
                }
            }
        }
        function P() {
            return Date.now ? Date.now() : Number(new Date);
        }
        function A(t, e, r, n) {
            var o = R(t, e, r);
            return o = function(t, e) {
                t.hostWhiteList && !t.hostSafeList && (t.hostSafeList = t.hostWhiteList, t.hostWhiteList = void 0, e && e.log("hostWhiteList is deprecated. Use hostSafeList."));
                t.hostBlackList && !t.hostBlockList && (t.hostBlockList = t.hostBlackList, t.hostBlackList = void 0, e && e.log("hostBlackList is deprecated. Use hostBlockList."));
                return t;
            }(o, n), !e || e.overwriteScrubFields || e.scrubFields && (o.scrubFields = (t.scrubFields || []).concat(e.scrubFields)), o;
        }
        function R() {
            function t(t) {
                if (!t || "[object Object]" !== Object.prototype.toString.call(t)) return !1;
                var e, r = c(t, "constructor"), n = t.constructor && t.constructor.prototype && c(t.constructor.prototype, "isPrototypeOf");
                if (t.constructor && !r && !n) return !1;
                for(e in t);
                return void 0 === e || c(t, e);
            }
            var e, r, n, o, i, a = Object.create(null), s = null, u = arguments.length;
            for(e = 0; e < u; e++)if (null != (s = arguments[e])) for(i in s)r = a[i], a !== (n = s[i]) && (n && t(n) ? (o = r && t(r) ? r : {}, a[i] = R(o, n)) : void 0 !== n && (a[i] = n));
            return a;
        }
        function C(t, e, r) {
            var n;
            if (null == e || !e.sessionId || !r) return !1;
            var o = null == t || null === (n = t.tracing) || void 0 === n ? void 0 : n.propagation, i = null == o ? void 0 : o.enabledHeaders;
            if (!Array.isArray(i) || !i.includes("baggage")) return !1;
            var s = null == o ? void 0 : o.enabledCorsUrls;
            return !(!Array.isArray(s) || 0 === s.length) && s.some(function(t) {
                return a(t, "string") ? r === t : !!a(t, "regexp") && t.test(r);
            });
        }
        function L(t, e) {
            var r, n, o = t[1], i = null === (r = o) || void 0 === r ? void 0 : r.headers, a = (n = t[0], "undefined" != typeof Request && n instanceof Request && t[0].headers), s = i || a;
            if (s || (o || (t[1] = o = {}), s = o.headers = {}), s instanceof Headers) for(var u = 0, c = Object.keys(e); u < c.length; u++){
                var f = c[u];
                s.append(f, e[f]);
            }
            else if (l(s)) for(var p = 0, d = Object.keys(e); p < d.length; p++){
                var h = d[p];
                s[h] = e[h];
            }
        }
        var q = function(t, e, r) {
            var n, o, i, s, u = a(t, "object"), l = a(t, "array"), f = [];
            if (r = r || {
                obj: [],
                mapped: []
            }, u) {
                if (s = r.obj.indexOf(t), u && -1 !== s) return r.mapped[s] || r.obj[s];
                r.obj.push(t), s = r.obj.length - 1;
            }
            if (u) for(n in t)c(t, n) && f.push(n);
            else if (l) for(i = 0; i < t.length; ++i)f.push(i);
            var p = u ? {} : [], d = !0;
            for(i = 0; i < f.length; ++i)o = t[n = f[i]], p[n] = e(n, o, r), d = d && p[n] === t[n];
            return u && !d && (r.mapped[s] = p), d ? t : p;
        };
        function N(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || M(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function D(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = M(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function M(t, e) {
            if (t) {
                if ("string" == typeof t) return U(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? U(t, e) : void 0;
            }
        }
        function U(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function H(t, e) {
            var r = e.split("."), n = r.length - 1;
            try {
                var o, i = D(r.entries());
                try {
                    for(i.s(); !(o = i.n()).done;){
                        var a = N(o.value, 2), s = a[0], u = a[1];
                        s < n ? t = t[u] : t[u] = d();
                    }
                } catch (t) {
                    i.e(t);
                } finally{
                    i.f();
                }
            } catch (t) {}
        }
        var F = function(t, e, r) {
            if (e = e || [], r) {
                var n, o = D(r);
                try {
                    for(o.s(); !(n = o.n()).done;)H(t, n.value);
                } catch (t) {
                    o.e(t);
                } finally{
                    o.f();
                }
            }
            var i = function(t) {
                var e, r = [], n = D(t);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var o = "^\\[?(%5[bB])?" + e.value + "\\[?(%5[bB])?\\]?(%5[dD])?$";
                        r.push(new RegExp(o, "i"));
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
                return r;
            }(e), s = function(t) {
                var e, r = [], n = D(t);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var o = "\\[?(%5[bB])?" + e.value + "\\[?(%5[bB])?\\]?(%5[dD])?";
                        r.push(new RegExp("(" + o + "=)([^&\\n]+)", "igm"));
                    }
                } catch (t) {
                    n.e(t);
                } finally{
                    n.f();
                }
                return r;
            }(e);
            function u(t, e) {
                return e + "********";
            }
            return q(t, function t(e, r, n) {
                var o = function(t, e) {
                    var r, n = D(i);
                    try {
                        for(n.s(); !(r = n.n()).done;)if (r.value.test(t)) {
                            e = d();
                            break;
                        }
                    } catch (t) {
                        n.e(t);
                    } finally{
                        n.f();
                    }
                    return e;
                }(e, r);
                return o === r ? a(r, "object") || a(r, "array") ? q(r, t, n) : function(t) {
                    if (a(t, "string")) {
                        var e, r = D(s);
                        try {
                            for(r.s(); !(e = r.n()).done;){
                                var n = e.value;
                                t = t.replace(n, u);
                            }
                        } catch (t) {
                            r.e(t);
                        } finally{
                            r.f();
                        }
                    }
                    return t;
                }(o) : o;
            });
        }, J = [
            "otelAttributes"
        ];
        function V(t) {
            return V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, V(t);
        }
        function B(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function W(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? B(Object(r), !0).forEach(function(e) {
                    $(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : B(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function $(t, e, r) {
            return (e = z(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function G(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, z(n.key), n);
            }
        }
        function z(t) {
            var e = function(t, e) {
                if ("object" != V(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != V(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == V(e) ? e : e + "";
        }
        var X = 100;
        function Z(t) {
            return [
                Math.trunc(t / 1e3),
                Math.round(t % 1e3 * 1e6)
            ];
        }
        var Q = function() {
            var t, e, r;
            return t = function t(e, r) {
                var n;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.queue = [], this.options = R(e);
                var o = this.options.maxTelemetryEvents || X;
                this.maxQueueSize = Math.max(0, Math.min(o, X)), this.tracing = r, this.telemetrySpan = null === (n = this.tracing) || void 0 === n ? void 0 : n.startSpan("rollbar-telemetry", {});
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        var e = this.options;
                        this.options = R(e, t);
                        var r = this.options.maxTelemetryEvents || X, n = Math.max(0, Math.min(r, X)), o = 0;
                        this.queue.length > n && (o = this.queue.length - n), this.maxQueueSize = n, this.queue.splice(0, o);
                    }
                },
                {
                    key: "copyEvents",
                    value: function() {
                        var t = Array.prototype.slice.call(this.queue, 0);
                        if (u(this.options.filterTelemetry)) try {
                            for(var e = t.length; e--;)this.options.filterTelemetry(t[e]) && t.splice(e, 1);
                        } catch (t) {
                            this.options.filterTelemetry = null;
                        }
                        return t = (t = t.filter(function(t) {
                            return "connectivity" !== t.type;
                        })).map(function(t) {
                            t.otelAttributes;
                            var e = function(t, e) {
                                if (null == t) return {};
                                var r, n, o = function(t, e) {
                                    if (null == t) return {};
                                    var r = {};
                                    for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
                                        if (-1 !== e.indexOf(n)) continue;
                                        r[n] = t[n];
                                    }
                                    return r;
                                }(t, e);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(t);
                                    for(n = 0; n < i.length; n++)r = i[n], -1 === e.indexOf(r) && ({}).propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
                                }
                                return o;
                            }(t, J);
                            return e;
                        }), t;
                    }
                },
                {
                    key: "exportTelemetrySpan",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        this.telemetrySpan && (this.telemetrySpan.end(t), this.telemetrySpan = this.tracing.startSpan("rollbar-telemetry", {}));
                    }
                },
                {
                    key: "capture",
                    value: function(t, e, r, n) {
                        var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null, i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, a = {
                            level: K(t, r),
                            type: t,
                            timestamp_ms: o || P(),
                            body: e,
                            source: "client"
                        };
                        n && (a.uuid = n), i && (a.otelAttributes = i);
                        try {
                            if (u(this.options.filterTelemetry) && this.options.filterTelemetry(a)) return !1;
                        } catch (t) {
                            this.options.filterTelemetry = null;
                        }
                        return this.push(a), a;
                    }
                },
                {
                    key: "captureEvent",
                    value: function(t, e, r, n) {
                        return this.capture(t, e, r, n);
                    }
                },
                {
                    key: "captureError",
                    value: function(t, e, r, n) {
                        var o, i = t.message || String(t), a = {
                            message: i
                        };
                        t.stack && (a.stack = t.stack);
                        var s = {
                            message: i,
                            level: e,
                            type: "error",
                            uuid: r
                        };
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent("rollbar-occurrence-event", s, Z(n)), this.capture("error", a, e, r, n, s);
                    }
                },
                {
                    key: "captureLog",
                    value: function(t, e, r, n) {
                        var o, i = r ? "rollbar-occurrence-event" : "rollbar-log-event", a = W({
                            message: t,
                            level: e
                        }, r ? {
                            type: "message",
                            uuid: r
                        } : {});
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent(i, a, Z(n)), this.capture("log", {
                            message: t
                        }, e, r, n, a);
                    }
                },
                {
                    key: "captureNetwork",
                    value: function(t, e, r, n) {
                        var o, i, a;
                        e = e || "xhr", t.subtype = t.subtype || e, n && (t.request = n);
                        var s = this.levelFromStatus(t.status_code), u = 1e6 * (t.end_time_ms || 0), l = {
                            type: t.subtype,
                            method: t.method,
                            url: t.url,
                            statusCode: t.status_code,
                            "request.headers": JSON.stringify(t.request_headers || {}),
                            "response.headers": JSON.stringify((null === (o = t.response) || void 0 === o ? void 0 : o.headers) || {}),
                            "response.timeUnixNano": u.toString()
                        }, c = t.request, f = null === (i = t.response) || void 0 === i ? void 0 : i.body;
                        return c && (l["request.body"] = JSON.stringify(c)), f && (l["response.body"] = JSON.stringify(f)), null === (a = this.telemetrySpan) || void 0 === a || a.addEvent("rollbar-network-event", l, Z(t.start_time_ms)), this.capture("network", t, s, r, t.start_time_ms, l);
                    }
                },
                {
                    key: "levelFromStatus",
                    value: function(t) {
                        return t >= 200 && t < 400 ? "info" : 0 === t || t >= 400 ? "error" : "info";
                    }
                },
                {
                    key: "captureDom",
                    value: function(t, e, r, n, o) {
                        var i = {
                            subtype: t,
                            element: e
                        };
                        return void 0 !== r && (i.value = r), void 0 !== n && (i.checked = n), this.capture("dom", i, "info", o);
                    }
                },
                {
                    key: "captureInput",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.value, a = t.timestamp, s = "rollbar-input-event", u = {
                            type: s,
                            subtype: r,
                            element: o,
                            value: i
                        }, l = {
                            type: r,
                            isSynthetic: n,
                            element: o,
                            value: i,
                            endTimeUnixNano: Z(a)
                        }, c = this._getRepeatedEvent(s, l);
                        return c ? this._updateRepeatedEvent(c, l, a) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(s, l, Z(a)), this.capture("dom", u, "info", null, a, l));
                    }
                },
                {
                    key: "captureClick",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.timestamp, a = "rollbar-click-event", s = {
                            type: a,
                            subtype: r,
                            element: o
                        }, u = {
                            type: r,
                            isSynthetic: n,
                            element: o,
                            endTimeUnixNano: Z(i)
                        }, l = this._getRepeatedEvent(a, u);
                        return l ? this._updateRepeatedEvent(l, u, i) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(a, u, Z(i)), this.capture("dom", s, "info", null, i, u));
                    }
                },
                {
                    key: "_getRepeatedEvent",
                    value: function(t, e) {
                        var r = this._lastEvent(this.queue);
                        if (r && r.body.type === t && r.otelAttributes.target === e.target) return r;
                    }
                },
                {
                    key: "_updateRepeatedEvent",
                    value: function(t, e, r) {
                        var n = Math.max(r - t.timestamp_ms, 1);
                        t.body.value = e.value, t.otelAttributes.value = e.value, t.otelAttributes.height = e.height, t.otelAttributes.width = e.width, t.otelAttributes.textZoomRatio = e.textZoomRatio, t.otelAttributes.endTimeUnixNano = Z(r), t.otelAttributes.durationUnixNano = Z(n), t.otelAttributes.count = (t.otelAttributes.count || 1) + 1, t.otelAttributes.rate = t.otelAttributes.count / (n / 1e3);
                    }
                },
                {
                    key: "_lastEvent",
                    value: function(t) {
                        return t.length > 0 ? t[t.length - 1] : null;
                    }
                },
                {
                    key: "captureFocus",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.timestamp, a = "rollbar-focus-event", s = {
                            type: a,
                            subtype: r,
                            element: o
                        }, u = {
                            type: r,
                            isSynthetic: n,
                            element: o
                        };
                        return null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(a, u, Z(i)), this.capture("dom", s, "info", null, i, u);
                    }
                },
                {
                    key: "captureResize",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.width, i = t.height, a = t.textZoomRatio, s = t.timestamp, u = "rollbar-resize-event", l = {
                            type: u,
                            subtype: r,
                            width: o,
                            height: i,
                            textZoomRatio: a
                        }, c = {
                            type: r,
                            isSynthetic: n,
                            width: o,
                            height: i,
                            textZoomRatio: a
                        }, f = this._getRepeatedEvent(u, c);
                        return f ? this._updateRepeatedEvent(f, c, s) : (null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(u, c, Z(s)), this.capture("dom", l, "info", null, s, c));
                    }
                },
                {
                    key: "captureDragDrop",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.element, i = t.dropEffect, a = t.effectAllowed, s = t.kinds, u = t.mediaTypes, l = t.timestamp, c = "rollbar-dragdrop-event", f = {
                            type: c,
                            subtype: r,
                            isSynthetic: n
                        }, p = {
                            type: r,
                            isSynthetic: n
                        };
                        return "dragstart" === r && (f = W(W({}, f), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a
                        }), p = W(W({}, p), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a
                        })), "drop" === r && (f = W(W({}, f), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a,
                            kinds: s,
                            mediaTypes: u
                        }), p = W(W({}, p), {}, {
                            element: o,
                            dropEffect: i,
                            effectAllowed: a,
                            kinds: s,
                            mediaTypes: u
                        })), null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(c, p, Z(l)), this.capture("dom", f, "info", null, l, p);
                    }
                },
                {
                    key: "captureNavigation",
                    value: function(t, e, r, n) {
                        var o;
                        return null === (o = this.telemetrySpan) || void 0 === o || o.addEvent("rollbar-navigation-event", {
                            "previous.url.full": t,
                            "url.full": e
                        }, Z(n)), this.capture("navigation", {
                            from: t,
                            to: e
                        }, "info", r, n);
                    }
                },
                {
                    key: "captureDomContentLoaded",
                    value: function(t) {
                        return this.capture("navigation", {
                            subtype: "DOMContentLoaded"
                        }, "info", void 0, t && t.getTime());
                    }
                },
                {
                    key: "captureLoad",
                    value: function(t) {
                        return this.capture("navigation", {
                            subtype: "load"
                        }, "info", void 0, t && t.getTime());
                    }
                },
                {
                    key: "captureConnectivityChange",
                    value: function(t) {
                        var e, r = t.type, n = t.isSynthetic, o = t.timestamp, i = "rollbar-connectivity-event", a = {
                            type: i,
                            subtype: r
                        }, s = {
                            type: r,
                            isSynthetic: n
                        };
                        return null === (e = this.telemetrySpan) || void 0 === e || e.addEvent(i, s, Z(o)), this.capture("connectivity", a, "info", null, o, s);
                    }
                },
                {
                    key: "_captureRollbarItem",
                    value: function(t) {
                        if (this.options.includeItemsInTelemetry) return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture("log", t.custom, t.level, t.uuid, t.timestamp) : void 0;
                    }
                },
                {
                    key: "push",
                    value: function(t) {
                        this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
                    }
                }
            ], e && G(t.prototype, e), r && G(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function K(t, e) {
            if (e) return e;
            return ({
                error: "error",
                manual: "info"
            })[t] || "info";
        }
        var Y = Q;
        function tt(t) {
            return tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, tt(t);
        }
        function et(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, rt(n.key), n);
            }
        }
        function rt(t) {
            var e = function(t, e) {
                if ("object" != tt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != tt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == tt(e) ? e : e + "";
        }
        var nt = function() {
            function t(e) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this._currentContext = e ? new Map(e) : new Map;
            }
            var e, r, n;
            return e = t, r = [
                {
                    key: "getValue",
                    value: function(t) {
                        return this._currentContext.get(t);
                    }
                },
                {
                    key: "setValue",
                    value: function(e, r) {
                        var n = new t(this._currentContext);
                        return n._currentContext.set(e, r), n;
                    }
                },
                {
                    key: "deleteValue",
                    value: function(e) {
                        var r = new t(self._currentContext);
                        return r._currentContext.delete(e), r;
                    }
                }
            ], et(e.prototype, r), n && et(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }(), ot = new nt;
        function it(t) {
            return it = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, it(t);
        }
        function at(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, st(n.key), n);
            }
        }
        function st(t) {
            var e = function(t, e) {
                if ("object" != it(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != it(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == it(e) ? e : e + "";
        }
        var ut = function() {
            var t, e, r;
            return t = function t() {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.currentContext = ot;
            }, e = [
                {
                    key: "active",
                    value: function() {
                        return this.currentContext;
                    }
                },
                {
                    key: "enterContext",
                    value: function(t) {
                        var e = this.currentContext;
                        return this.currentContext = t || ot, e;
                    }
                },
                {
                    key: "exitContext",
                    value: function(t) {
                        return this.currentContext = t, this.currentContext;
                    }
                },
                {
                    key: "with",
                    value: function(t, e, r) {
                        var n = this.enterContext(t);
                        try {
                            for(var o = arguments.length, i = new Array(o > 3 ? o - 3 : 0), a = 3; a < o; a++)i[a - 3] = arguments[a];
                            return e.call.apply(e, [
                                r
                            ].concat(i));
                        } finally{
                            this.exitContext(n);
                        }
                    }
                }
            ], e && at(t.prototype, e), r && at(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function lt(t) {
            return [
                Math.trunc(t / 1e3),
                Math.round(t % 1e3 * 1e6)
            ];
        }
        function ct(t, e) {
            return [
                t[0] + e[0] + Math.trunc((t[1] + e[1]) / 1e9),
                (t[1] + e[1]) % 1e9
            ];
        }
        var ft = {
            fromMillis: lt,
            toMillis: function(t) {
                return 1e3 * t[0] + Math.round(t[1] / 1e6);
            },
            toNanos: function(t) {
                return 1e9 * t[0] + t[1];
            },
            add: ct,
            now: function() {
                return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? ct(lt(performance.timeOrigin), lt(performance.now())) : lt(Date.now());
            },
            isHrTime: function(t) {
                return Array.isArray(t) && 2 === t.length && "number" == typeof t[0] && "number" == typeof t[1];
            }
        };
        function pt(t) {
            return pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, pt(t);
        }
        function dt(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || yt(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function ht(t) {
            return function(t) {
                if (Array.isArray(t)) return vt(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || yt(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function yt(t, e) {
            if (t) {
                if ("string" == typeof t) return vt(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? vt(t, e) : void 0;
            }
        }
        function vt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function mt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, bt(n.key), n);
            }
        }
        function bt(t) {
            var e = function(t, e) {
                if ("object" != pt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != pt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == pt(e) ? e : e + "";
        }
        var gt = function() {
            var t, e, r;
            return t = function t(e) {
                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.api = e, this.options = r;
            }, e = [
                {
                    key: "export",
                    value: function(t, e) {
                        wt.push.apply(wt, ht(t));
                    }
                },
                {
                    key: "toPayload",
                    value: function() {
                        var t = this, e = wt.slice();
                        if (wt.length = 0, !e || !e.length) return {
                            resourceSpans: []
                        };
                        var r, n = e[0] && e[0].resource || {}, o = new Map, i = function(t, e) {
                            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                            if (!r) {
                                if (Array.isArray(t) || (r = yt(t)) || e && t && "number" == typeof t.length) {
                                    r && (t = r);
                                    var n = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return n >= t.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: t[n++]
                                            };
                                        },
                                        e: function(t) {
                                            throw t;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, s = !1;
                            return {
                                s: function() {
                                    r = r.call(t);
                                },
                                n: function() {
                                    var t = r.next();
                                    return a = t.done, t;
                                },
                                e: function(t) {
                                    s = !0, i = t;
                                },
                                f: function() {
                                    try {
                                        a || null == r.return || r.return();
                                    } finally{
                                        if (s) throw i;
                                    }
                                }
                            };
                        }(e);
                        try {
                            for(i.s(); !(r = i.n()).done;){
                                var a = r.value, s = a.instrumentationScope ? "".concat(a.instrumentationScope.name, ":").concat(a.instrumentationScope.version) : "default:1.0.0";
                                o.has(s) || o.set(s, {
                                    scope: a.instrumentationScope || {
                                        name: "default",
                                        version: "1.0.0",
                                        attributes: []
                                    },
                                    spans: []
                                }), o.get(s).spans.push(this._transformSpan(a));
                            }
                        } catch (t) {
                            i.e(t);
                        } finally{
                            i.f();
                        }
                        return {
                            resourceSpans: [
                                {
                                    resource: this._transformResource(n),
                                    scopeSpans: Array.from(o.values()).map(function(e) {
                                        return {
                                            scope: t._transformInstrumentationScope(e.scope),
                                            spans: e.spans
                                        };
                                    })
                                }
                            ]
                        };
                    }
                },
                {
                    key: "post",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return this.api.postSpans(t, e);
                    }
                },
                {
                    key: "_transformSpan",
                    value: function(t) {
                        var e, r = this, n = function(t) {
                            return Object.entries(t || {}).map(function(t) {
                                var e = dt(t, 2), n = e[0], o = e[1];
                                return {
                                    key: n,
                                    value: r._transformAnyValue(o)
                                };
                            });
                        };
                        return {
                            traceId: t.spanContext.traceId,
                            spanId: t.spanContext.spanId,
                            parentSpanId: t.parentSpanId || "",
                            name: t.name,
                            kind: t.kind || 1,
                            startTimeUnixNano: ft.toNanos(t.startTime),
                            endTimeUnixNano: ft.toNanos(t.endTime),
                            attributes: n(t.attributes),
                            events: (e = t.events, (e || []).map(function(t) {
                                return {
                                    timeUnixNano: ft.toNanos(t.time),
                                    name: t.name,
                                    attributes: n(t.attributes)
                                };
                            }))
                        };
                    }
                },
                {
                    key: "_transformResource",
                    value: function(t) {
                        var e = this, r = t.attributes || {};
                        return {
                            attributes: Object.entries(r).map(function(t) {
                                var r = dt(t, 2), n = r[0], o = r[1];
                                return {
                                    key: n,
                                    value: e._transformAnyValue(o)
                                };
                            })
                        };
                    }
                },
                {
                    key: "_transformInstrumentationScope",
                    value: function(t) {
                        var e = this;
                        return {
                            name: t.name || "",
                            version: t.version || "",
                            attributes: (t.attributes || []).map(function(t) {
                                return {
                                    key: t.key,
                                    value: e._transformAnyValue(t.value)
                                };
                            })
                        };
                    }
                },
                {
                    key: "_transformAnyValue",
                    value: function(t) {
                        var e = this;
                        if (null == t) return {
                            stringValue: ""
                        };
                        var r = pt(t);
                        return "string" === r ? {
                            stringValue: t
                        } : "number" === r ? Number.isInteger(t) ? {
                            intValue: t.toString()
                        } : {
                            doubleValue: t
                        } : "boolean" === r ? {
                            boolValue: t
                        } : Array.isArray(t) ? {
                            arrayValue: {
                                values: t.map(function(t) {
                                    return e._transformAnyValue(t);
                                })
                            }
                        } : "object" === r ? {
                            kvlistValue: {
                                values: Object.entries(t).map(function(t) {
                                    var r = dt(t, 2), n = r[0], o = r[1];
                                    return {
                                        key: n,
                                        value: e._transformAnyValue(o)
                                    };
                                })
                            }
                        } : {
                            stringValue: String(t)
                        };
                    }
                }
            ], e && mt(t.prototype, e), r && mt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), wt = [];
        var kt = {
            gen: function() {
                var t = new Uint8Array(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 16);
                return crypto.getRandomValues(t), Array.from(t, function(t) {
                    return t.toString(16).padStart(2, "0");
                }).join("");
            }
        };
        function St(t) {
            return St = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, St(t);
        }
        function _t(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function Ot(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? _t(Object(r), !0).forEach(function(e) {
                    Et(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _t(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function xt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, jt(n.key), n);
            }
        }
        function Et(t, e, r) {
            return (e = jt(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function jt(t) {
            var e = function(t, e) {
                if ("object" != St(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != St(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == St(e) ? e : e + "";
        }
        var It = "RollbarSession", Tt = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Et(this, "_attributes", void 0), this.options = r, this.tracing = e, this.window = e.window, this.session = null, this._attributes = {};
            }, e = [
                {
                    key: "init",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return this.session || (this.getSession() || this.createSession(), this.initSessionAttributes(t)), this;
                    }
                },
                {
                    key: "getSession",
                    value: function() {
                        try {
                            var t = this.window.sessionStorage.getItem(It);
                            if (!t) return null;
                            this.session = JSON.parse(t);
                        } catch (t) {
                            return null;
                        }
                        return this;
                    }
                },
                {
                    key: "createSession",
                    value: function() {
                        return this.session = {
                            id: kt.gen(),
                            createdAt: Date.now()
                        }, this.setSession(this.session);
                    }
                },
                {
                    key: "setSession",
                    value: function(t) {
                        var e = JSON.stringify(t);
                        try {
                            this.window.sessionStorage.setItem(It, e);
                        } catch (t) {
                            return null;
                        }
                        return this;
                    }
                },
                {
                    key: "attributes",
                    get: function() {
                        return this._attributes;
                    }
                },
                {
                    key: "setAttributes",
                    value: function(t) {
                        return this._attributes = Ot(Ot({}, this._attributes), t), this;
                    }
                },
                {
                    key: "setUser",
                    value: function(t) {
                        return this.setAttributes({
                            "user.id": null == t ? void 0 : t.id,
                            "user.email": null == t ? void 0 : t.email,
                            "user.name": (null == t ? void 0 : t.name) || (null == t ? void 0 : t.username)
                        }), this;
                    }
                },
                {
                    key: "initSessionAttributes",
                    value: function(t) {
                        var e, r, n;
                        return this.setAttributes(Ot({
                            "session.id": this.session.id,
                            "browser.brands": null === (e = navigator.userAgentData) || void 0 === e ? void 0 : e.brands,
                            "browser.language": navigator.language,
                            "browser.mobile": null === (r = navigator.userAgentData) || void 0 === r ? void 0 : r.mobile,
                            "browser.platform": null === (n = navigator.userAgentData) || void 0 === n ? void 0 : n.platform,
                            "client.address": "$remote_ip",
                            "rollbar.notifier.framework": "browser-js",
                            "user_agent.original": navigator.userAgent
                        }, t)), this;
                    }
                }
            ], e && xt(t.prototype, e), r && xt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }(), Pt = function() {}, At = {
            debug: 0,
            info: 1,
            warn: 2,
            error: 3,
            disable: 4
        }, Rt = {
            error: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("error", e);
            },
            warn: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("warn", e);
            },
            info: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("info", e);
            },
            debug: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("debug", e);
            },
            log: function() {
                for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
                return Pt("info", e);
            },
            init: function(t) {
                var e = t.logLevel;
                Pt = function(t, r) {
                    At[t] < At[e] || (r.unshift("Rollbar:"), console[t].apply(console, r));
                };
            }
        }, Ct = Rt;
        function Lt(t) {
            return Lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Lt(t);
        }
        function qt(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return Nt(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Nt(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function Nt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Dt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Mt(n.key), n);
            }
        }
        function Mt(t) {
            var e = function(t, e) {
                if ("object" != Lt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Lt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Lt(e) ? e : e + "";
        }
        var Ut = function() {
            var t, e, r;
            return t = function t(e) {
                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.exporter = e, this.options = r, this.pendingSpans = new Map, this.transforms = [
                    this.userTransform.bind(this)
                ];
            }, e = [
                {
                    key: "addTransform",
                    value: function(t) {
                        this.transforms.unshift(t);
                    }
                },
                {
                    key: "userTransform",
                    value: function(t) {
                        this.options.transformSpan && this.options.transformSpan({
                            span: t
                        });
                    }
                },
                {
                    key: "applyTransforms",
                    value: function(t) {
                        var e, r = qt(this.transforms);
                        try {
                            for(r.s(); !(e = r.n()).done;){
                                var n = e.value;
                                try {
                                    n(t);
                                } catch (t) {
                                    Ct.error("Error running span transform callback", t);
                                }
                            }
                        } catch (t) {
                            r.e(t);
                        } finally{
                            r.f();
                        }
                    }
                },
                {
                    key: "onStart",
                    value: function(t, e) {
                        this.pendingSpans.set(t.span.spanContext.spanId, t);
                    }
                },
                {
                    key: "onEnd",
                    value: function(t) {
                        this.applyTransforms(t.span), this.exporter.export([
                            t.export()
                        ]), this.pendingSpans.delete(t.span.spanContext.spanId);
                    }
                }
            ], e && Dt(t.prototype, e), r && Dt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Ht(t) {
            return Ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Ht(t);
        }
        function Ft(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return Jt(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Jt(t, e) : void 0;
                }
            }(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Jt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Vt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Bt(n.key), n);
            }
        }
        function Bt(t) {
            var e = function(t, e) {
                if ("object" != Ht(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Ht(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Ht(e) ? e : e + "";
        }
        var Wt = function() {
            var t, e, r;
            return t = function t(e) {
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.usePerformance = e.usePerformance, this.initReadableSpan(e), this.spanProcessor = e.spanProcessor, this.spanProcessor.onStart(this, e.context), e.attributes && this.setAttributes(e.attributes), this;
            }, e = [
                {
                    key: "initReadableSpan",
                    value: function(t) {
                        var e;
                        this.span = {
                            name: t.name,
                            kind: t.kind,
                            spanContext: t.spanContext,
                            parentSpanId: t.parentSpanId,
                            startTime: t.startTime || ft.now(t.usePerformance),
                            endTime: [
                                0,
                                0
                            ],
                            status: {
                                code: 0,
                                message: ""
                            },
                            attributes: {
                                "session.id": null === (e = t.session) || void 0 === e ? void 0 : e.id
                            },
                            links: [],
                            events: [],
                            duration: 0,
                            ended: !1,
                            resource: t.resource,
                            instrumentationScope: t.scope,
                            droppedAttributesCount: 0,
                            droppedEventsCount: 0,
                            droppedLinksCount: 0
                        };
                    }
                },
                {
                    key: "spanContext",
                    value: function() {
                        return this.span.spanContext;
                    }
                },
                {
                    key: "spanId",
                    get: function() {
                        return this.span.spanContext.spanId;
                    }
                },
                {
                    key: "traceId",
                    get: function() {
                        return this.span.spanContext.traceId;
                    }
                },
                {
                    key: "setAttribute",
                    value: function(t, e) {
                        return null == e || this.span.ended || 0 === t.length || (this.span.attributes[t] = e), this;
                    }
                },
                {
                    key: "setAttributes",
                    value: function(t) {
                        for(var e = 0, r = Object.entries(t); e < r.length; e++){
                            var n = Ft(r[e], 2), o = n[0], i = n[1];
                            this.setAttribute(o, i);
                        }
                        return this;
                    }
                },
                {
                    key: "addEvent",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
                        return this.span.ended || this.span.events.push({
                            name: t,
                            attributes: e,
                            time: r || ft.now(),
                            droppedAttributesCount: 0
                        }), this;
                    }
                },
                {
                    key: "isRecording",
                    value: function() {
                        return !1 === this.span.ended;
                    }
                },
                {
                    key: "end",
                    value: function(t, e) {
                        t && this.setAttributes(t), this.span.endTime = e || ft.now(this.usePerformance), this.span.ended = !0, this.spanProcessor.onEnd(this);
                    }
                },
                {
                    key: "export",
                    value: function() {
                        return this.span;
                    }
                }
            ], e && Vt(t.prototype, e), r && Vt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function $t(t) {
            return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, $t(t);
        }
        function Gt(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function zt(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? Gt(Object(r), !0).forEach(function(e) {
                    Xt(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Gt(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function Xt(t, e, r) {
            return (e = Qt(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function Zt(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Qt(n.key), n);
            }
        }
        function Qt(t) {
            var e = function(t, e) {
                if ("object" != $t(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != $t(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == $t(e) ? e : e + "";
        }
        var Kt = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.spanProcessor = r, this.tracing = e;
            }, e = [
                {
                    key: "startSpan",
                    value: function(t) {
                        var e, r, n, o, i, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.tracing.contextManager.active(), u = this.tracing.getSpan(s), l = null == u ? void 0 : u.spanContext(), c = kt.gen(8), f = null;
                        l ? (o = l.traceId, f = l.traceState, i = l.spanId) : o = kt.gen(16);
                        var p = {
                            traceId: o,
                            spanId: c,
                            traceFlags: 0,
                            traceState: f
                        }, d = {
                            attributes: zt(zt({}, (null === (e = this.tracing.resource) || void 0 === e ? void 0 : e.attributes) || {}), (null === (r = a.resource) || void 0 === r ? void 0 : r.attributes) || {})
                        };
                        return new Wt({
                            resource: d,
                            scope: this.tracing.scope,
                            session: null === (n = this.tracing.session) || void 0 === n ? void 0 : n.session,
                            context: s,
                            spanContext: p,
                            name: t,
                            kind: 0,
                            parentSpanId: i,
                            spanProcessor: this.spanProcessor,
                            startTime: a.startTime,
                            usePerformance: a.usePerformance
                        });
                    }
                }
            ], e && Zt(t.prototype, e), r && Zt(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Yt(t) {
            return Yt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, Yt(t);
        }
        function te(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function ee(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? te(Object(r), !0).forEach(function(e) {
                    re(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : te(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function re(t, e, r) {
            return (e = oe(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function ne(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oe(n.key), n);
            }
        }
        function oe(t) {
            var e = function(t, e) {
                if ("object" != Yt(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != Yt(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == Yt(e) ? e : e + "";
        }
        var ie, ae = (ie = "Rollbar Context Key SPAN", Symbol.for(ie)), se = function() {
            var t, e, r;
            return t = function t(e, r, n) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.api = r, this.options = n, this.window = e, this.window.sessionStorage && (this.session = new Tt(this, n)), this.createTracer();
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        this.options = t;
                    }
                },
                {
                    key: "initSession",
                    value: function() {
                        this.session && this.session.init();
                    }
                },
                {
                    key: "sessionId",
                    get: function() {
                        return this.session ? this.session.session.id : null;
                    }
                },
                {
                    key: "resource",
                    get: function() {
                        var t, e;
                        return {
                            attributes: ee(ee({}, this.options.resource || {}), {}, {
                                "rollbar.environment": null !== (t = null === (e = this.options.payload) || void 0 === e ? void 0 : e.environment) && void 0 !== t ? t : this.options.environment
                            })
                        };
                    }
                },
                {
                    key: "scope",
                    get: function() {
                        return {
                            name: "rollbar-browser-js",
                            version: this.options.version
                        };
                    }
                },
                {
                    key: "idGen",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 16;
                        return kt.gen(t);
                    }
                },
                {
                    key: "createTracer",
                    value: function() {
                        this.contextManager = new ut, this.exporter = new gt(this.api, this.options), this.spanProcessor = new Ut(this.exporter, this.options.tracing), this.tracer = new Kt(this, this.spanProcessor);
                    }
                },
                {
                    key: "getTracer",
                    value: function() {
                        return this.tracer;
                    }
                },
                {
                    key: "addSpanTransform",
                    value: function(t) {
                        this.spanProcessor.addTransform(t);
                    }
                },
                {
                    key: "getSpan",
                    value: function() {
                        return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.contextManager.active()).getValue(ae);
                    }
                },
                {
                    key: "setSpan",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.contextManager.active(), e = arguments.length > 1 ? arguments[1] : void 0;
                        return t.setValue(ae, e);
                    }
                },
                {
                    key: "startSpan",
                    value: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.contextManager.active();
                        return this.tracer.startSpan(t, e, r);
                    }
                },
                {
                    key: "with",
                    value: function(t, e, r) {
                        for(var n, o = arguments.length, i = new Array(o > 3 ? o - 3 : 0), a = 3; a < o; a++)i[a - 3] = arguments[a];
                        return (n = this.contextManager).with.apply(n, [
                            t,
                            e,
                            r
                        ].concat(i));
                    }
                },
                {
                    key: "withSpan",
                    value: function(t, e, r, n) {
                        var o = this.startSpan(t, e);
                        return this.with(this.setSpan(this.contextManager.active(), o), r, n, o);
                    }
                }
            ], e && ne(t.prototype, e), r && ne(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function ue(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || ce(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function le(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = ce(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function ce(t, e) {
            if (t) {
                if ("string" == typeof t) return fe(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fe(t, e) : void 0;
            }
        }
        function fe(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function pe(t, e) {
            return [
                t,
                b(t, e)
            ];
        }
        function de(t, e) {
            var r = t.length;
            return r > 2 * e ? t.slice(0, e).concat(t.slice(r - e)) : t;
        }
        function he(t, e, r) {
            r = void 0 === r ? 30 : r;
            var n, o = t.data.body;
            if (o.trace_chain) {
                var i, a = le(o.trace_chain);
                try {
                    for(a.s(); !(i = a.n()).done;){
                        var s = i.value;
                        n = de(n = s.frames, r), s.frames = n;
                    }
                } catch (t) {
                    a.e(t);
                } finally{
                    a.f();
                }
            } else o.trace && (n = de(n = o.trace.frames, r), o.trace.frames = n);
            return [
                t,
                b(t, e)
            ];
        }
        function ye(t, e) {
            return e && e.length > t ? e.slice(0, t - 3).concat("...") : e;
        }
        function ve(t, e, r) {
            return e = q(e, function e(r, n, o) {
                switch(s(n)){
                    case "string":
                        return ye(t, n);
                    case "object":
                    case "array":
                        return q(n, e, o);
                    default:
                        return n;
                }
            }), [
                e,
                b(e, r)
            ];
        }
        function me(t) {
            return t.exception && (delete t.exception.description, t.exception.message = ye(255, t.exception.message)), t.frames = de(t.frames, 1), t;
        }
        function be(t, e) {
            var r = t.data.body;
            if (r.trace_chain) {
                var n, o = r.trace_chain, i = le(o.entries());
                try {
                    for(i.s(); !(n = i.n()).done;){
                        var a = ue(n.value, 2), s = a[0], u = a[1];
                        o[s] = me(u);
                    }
                } catch (t) {
                    i.e(t);
                } finally{
                    i.f();
                }
            } else r.trace && (r.trace = me(r.trace));
            return [
                t,
                b(t, e)
            ];
        }
        function ge(t, e) {
            return function(t) {
                for(var e = 0, r = t.length, n = 0; n < r; n++){
                    var o = t.charCodeAt(n);
                    o < 128 ? e += 1 : o < 2048 ? e += 2 : o < 65536 && (e += 3);
                }
                return e;
            }(t) > e;
        }
        var we = {
            truncate: function(t, e, r) {
                r = void 0 === r ? 524288 : r;
                for(var n, o, i, a = [
                    pe,
                    he,
                    ve.bind(null, 1024),
                    ve.bind(null, 512),
                    ve.bind(null, 256),
                    be
                ]; n = a.shift();)if (t = (o = n(t, e))[0], (i = o[1]).error || !ge(i.value, r)) return i;
                return i;
            },
            raw: pe,
            truncateFrames: he,
            truncateStrings: ve,
            maybeTruncateValue: ye
        };
        function ke(t) {
            if (!a(t.context, "string")) {
                var e = b(t.context);
                e.error ? t.context = "Error: could not serialize 'context'" : t.context = e.value || "", t.context.length > 255 && (t.context = t.context.substr(0, 255));
            }
            return {
                data: t
            };
        }
        function Se(t, e, r) {
            var n = e.hostname, o = e.protocol, i = e.port, a = e.path, s = e.search, u = t.timeout, l = function(t) {
                var e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = t.defaultTransport || "xhr";
                void 0 === e.fetch && (r = "xhr");
                void 0 === e.XMLHttpRequest && (r = "fetch");
                return r;
            }(t), c = t.proxy;
            if (t.endpoint) {
                var f = r.parse(t.endpoint);
                n = f.hostname, o = f.protocol, i = f.port, a = f.pathname, s = f.search;
            }
            return {
                timeout: u,
                hostname: n,
                protocol: o,
                port: i,
                path: a,
                search: s,
                proxy: c,
                transport: l
            };
        }
        function _e(t, e) {
            var r = t.protocol || "https:", n = t.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), o = t.hostname, i = t.path, a = t.timeout, s = t.transport;
            return t.search && (i += t.search), t.proxy && (i = r + "//" + o + i, o = t.proxy.host || t.proxy.hostname, n = t.proxy.port, r = t.proxy.protocol || r), {
                timeout: a,
                protocol: r,
                hostname: o,
                path: i,
                port: n,
                method: e,
                transport: s
            };
        }
        function Oe(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function xe(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? Oe(Object(r), !0).forEach(function(e) {
                    Ee(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Oe(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function Ee(t, e, r) {
            return (e = Re(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function je(t) {
            return je = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, je(t);
        }
        function Ie() {
            var t, e, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
            function i(r, n, o, i) {
                var u = n && n.prototype instanceof s ? n : s, l = Object.create(u.prototype);
                return Te(l, "_invoke", function(r, n, o) {
                    var i, s, u, l = 0, c = o || [], f = !1, p = {
                        p: 0,
                        n: 0,
                        v: t,
                        a: d,
                        f: d.bind(t, 4),
                        d: function(e, r) {
                            return i = e, s = 0, u = t, p.n = r, a;
                        }
                    };
                    function d(r, n) {
                        for(s = r, u = n, e = 0; !f && l && !o && e < c.length; e++){
                            var o, i = c[e], d = p.p, h = i[2];
                            r > 3 ? (o = h === n) && (u = i[(s = i[4]) ? 5 : (s = 3, 3)], i[4] = i[5] = t) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (s = 0, p.v = n, p.n = i[1]) : d < h && (o = r < 3 || i[0] > n || n > h) && (i[4] = r, i[5] = n, p.n = h, s = 0));
                        }
                        if (o || r > 1) return a;
                        throw f = !0, n;
                    }
                    return function(o, c, h) {
                        if (l > 1) throw TypeError("Generator is already running");
                        for(f && 1 === c && d(c, h), s = c, u = h; (e = s < 2 ? t : u) || !f;){
                            i || (s ? s < 3 ? (s > 1 && (p.n = -1), d(s, u)) : p.n = u : p.v = u);
                            try {
                                if (l = 2, i) {
                                    if (s || (o = "next"), e = i[o]) {
                                        if (!(e = e.call(i, u))) throw TypeError("iterator result is not an object");
                                        if (!e.done) return e;
                                        u = e.value, s < 2 && (s = 0);
                                    } else 1 === s && (e = i.return) && e.call(i), s < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), s = 1);
                                    i = t;
                                } else if ((e = (f = p.n < 0) ? u : r.call(n, p)) !== a) break;
                            } catch (e) {
                                i = t, s = 1, u = e;
                            } finally{
                                l = 1;
                            }
                        }
                        return {
                            value: e,
                            done: f
                        };
                    };
                }(r, o, i), !0), l;
            }
            var a = {};
            function s() {}
            function u() {}
            function l() {}
            e = Object.getPrototypeOf;
            var c = [][n] ? e(e([][n]())) : (Te(e = {}, n, function() {
                return this;
            }), e), f = l.prototype = s.prototype = Object.create(c);
            function p(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, l) : (t.__proto__ = l, Te(t, o, "GeneratorFunction")), t.prototype = Object.create(f), t;
            }
            return u.prototype = l, Te(f, "constructor", l), Te(l, "constructor", u), u.displayName = "GeneratorFunction", Te(l, o, "GeneratorFunction"), Te(f), Te(f, o, "Generator"), Te(f, n, function() {
                return this;
            }), Te(f, "toString", function() {
                return "[object Generator]";
            }), (Ie = function() {
                return {
                    w: i,
                    m: p
                };
            })();
        }
        function Te(t, e, r, n) {
            var o = Object.defineProperty;
            try {
                o({}, "", {});
            } catch (t) {
                o = 0;
            }
            Te = function(t, e, r, n) {
                function i(e, r) {
                    Te(t, e, function(t) {
                        return this._invoke(e, r, t);
                    });
                }
                e ? o ? o(t, e, {
                    value: r,
                    enumerable: !n,
                    configurable: !n,
                    writable: !n
                }) : t[e] = r : (i("next", 0), i("throw", 1), i("return", 2));
            }, Te(t, e, r, n);
        }
        function Pe(t, e, r, n, o, i, a) {
            try {
                var s = t[i](a), u = s.value;
            } catch (t) {
                return void r(t);
            }
            s.done ? e(u) : Promise.resolve(u).then(n, o);
        }
        function Ae(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Re(n.key), n);
            }
        }
        function Re(t) {
            var e = function(t, e) {
                if ("object" != je(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != je(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == je(e) ? e : e + "";
        }
        var Ce = {
            hostname: "api.rollbar.com",
            path: "/api/1/item/",
            search: null,
            version: "1",
            protocol: "https:",
            port: 443
        }, Le = {
            hostname: "api.rollbar.com",
            path: "/api/1/session/",
            search: null,
            version: "1",
            protocol: "https:",
            port: 443
        }, qe = function() {
            var t, e, r, n, o;
            return t = function t(e, r, n, o) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.options = e, this.transport = r, this.url = n, this.truncation = o, this.accessToken = e.accessToken, this.transportOptions = Ne(e, n), this.OTLPTransportOptions = De(e, n);
            }, e = [
                {
                    key: "_postPromise",
                    value: function(t) {
                        var e = this, r = t.accessToken, n = t.options, o = t.payload, i = t.headers;
                        return new Promise(function(t, a) {
                            e.transport.post({
                                accessToken: r,
                                options: n,
                                payload: o,
                                headers: i,
                                callback: function(e, r) {
                                    return e ? a(e) : t(r);
                                }
                            });
                        });
                    }
                },
                {
                    key: "postItem",
                    value: function(t, e) {
                        var r = this, n = _e(this.transportOptions, "POST"), o = ke(t);
                        setTimeout(function() {
                            r.transport.post({
                                accessToken: r.accessToken,
                                options: n,
                                payload: o,
                                callback: e
                            });
                        }, 0);
                    }
                },
                {
                    key: "postSpans",
                    value: (n = Ie().m(function t(e) {
                        var r, n, o = arguments;
                        return Ie().w(function(t) {
                            for(;;)if (0 === t.n) return r = o.length > 1 && void 0 !== o[1] ? o[1] : {}, n = _e(this.OTLPTransportOptions, "POST"), t.a(2, this._postPromise({
                                accessToken: this.accessToken,
                                options: n,
                                payload: e,
                                headers: r
                            }));
                        }, t, this);
                    }), o = function() {
                        var t = this, e = arguments;
                        return new Promise(function(r, o) {
                            var i = n.apply(t, e);
                            function a(t) {
                                Pe(i, r, o, a, s, "next", t);
                            }
                            function s(t) {
                                Pe(i, r, o, a, s, "throw", t);
                            }
                            a(void 0);
                        });
                    }, function(t) {
                        return o.apply(this, arguments);
                    })
                },
                {
                    key: "buildJsonPayload",
                    value: function(t, e) {
                        var r, n = ke(t);
                        return (r = this.truncation ? this.truncation.truncate(n) : b(n)).error ? (e && e(r.error), null) : r.value;
                    }
                },
                {
                    key: "postJsonPayload",
                    value: function(t, e) {
                        var r = _e(this.transportOptions, "POST");
                        this.transport.postJsonPayload(this.accessToken, r, t, e);
                    }
                },
                {
                    key: "configure",
                    value: function(t) {
                        var e = this.options;
                        return this.options = R(e, t), this.transportOptions = Ne(this.options, this.url), this.OTLPTransportOptions = De(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
                    }
                }
            ], e && Ae(t.prototype, e), r && Ae(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function Ne(t, e) {
            return Se(t, Ce, e);
        }
        function De(t, e) {
            var r;
            return Se(t = xe(xe({}, t), {}, {
                endpoint: null === (r = t.tracing) || void 0 === r ? void 0 : r.endpoint
            }), Le, e);
        }
        var Me = qe, Ue = "3.1.0", He = "api.rollbar.com/api/1/item/", Fe = "debug", Je = "debug", Ve = "error", Be = /(^|@)\S+:\d+/, We = /^\s*at .*(\S+:\d+|\(native\))/m, $e = /^(eval@)?(\[native code\])?$/;
        function Ge(t, e) {
            if (void 0 !== t.stacktrace || void 0 !== t["opera#sourceloc"]) return function(t, e) {
                return !t.stacktrace || t.message.includes("\n") && t.message.split("\n").length > t.stacktrace.split("\n").length ? function(t, e) {
                    for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = t.message.split("\n"), o = [], i = 2, a = n.length; i < a; i += 2){
                        var s = r.exec(n[i]);
                        s && o.push({
                            file: s[2],
                            line: +s[1],
                            raw: n[i]
                        });
                    }
                    return Xe(o, e);
                }(t) : t.stack ? function(t, e) {
                    var r = Xe(t.stack.split("\n").filter(function(t) {
                        return !!t.match(Be) && !t.match(/^Error created at/);
                    }), e);
                    return r.map(function(t) {
                        var e, r = t.split("@"), n = ze(r.pop()), o = r.shift() || "", i = o.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                        return o.match(/\(([^)]*)\)/) && (e = o.replace(/^[^(]+\(([^)]*)\)$/, "$1")), {
                            function: i,
                            args: void 0 === e || "[arguments not available]" === e ? void 0 : e.split(","),
                            file: n[0],
                            line: n[1] ? +n[1] : void 0,
                            col: n[2] ? +n[2] : void 0,
                            raw: t
                        };
                    });
                }(t, e) : function(t, e) {
                    for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = t.stacktrace.split("\n"), o = [], i = 0, a = n.length; i < a; i += 2){
                        var s = r.exec(n[i]);
                        s && o.push({
                            function: s[3] || void 0,
                            file: s[2],
                            line: s[1] ? +s[1] : void 0,
                            raw: n[i]
                        });
                    }
                    return Xe(o, e);
                }(t);
            }(t, e);
            if (t.stack && t.stack.match(We)) return function(t, e) {
                return Ze(t.stack, e);
            }(t, e);
            if (t.stack) return function(t, e) {
                return Qe(t.stack, e);
            }(t, e);
            if (null != e && e.allowEmpty) return [];
            throw new Error("Cannot parse given Error object");
        }
        function ze(t) {
            if (!t.includes(":")) return [
                t,
                void 0,
                void 0
            ];
            var e = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(t.replace(/[()]/g, ""));
            return [
                e[1],
                e[2] || void 0,
                e[3] || void 0
            ];
        }
        function Xe(t, e) {
            return e && null != e.slice ? Array.isArray(e.slice) ? t.slice(e.slice[0], e.slice[1]) : t.slice(0, e.slice) : t;
        }
        function Ze(t, e) {
            return Xe(t.split("\n").filter(function(t) {
                return !!t.match(We);
            }), e).map(function(t) {
                t.includes("(eval ") && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                var e = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), r = e.match(/ (\(.+\)$)/);
                e = r ? e.replace(r[0], "") : e;
                var n = ze(r ? r[1] : e);
                return {
                    function: r && e || void 0,
                    file: [
                        "eval",
                        "<anonymous>"
                    ].includes(n[0]) ? void 0 : n[0],
                    line: n[1] ? +n[1] : void 0,
                    col: n[2] ? +n[2] : void 0,
                    raw: t
                };
            });
        }
        function Qe(t, e) {
            return Xe(t.split("\n").filter(function(t) {
                return !t.match($e);
            }), e).map(function(t) {
                if (t.includes(" > eval") && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), t.includes("@") || t.includes(":")) {
                    var e = /(([^\n\r"\u2028\u2029]*".[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*(?:@[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*)*(?:[\n\r\u2028\u2029][^@]*)?)?[^@]*)@/, r = t.match(e), n = r && r[1] ? r[1] : void 0, o = ze(t.replace(e, ""));
                    return {
                        function: n,
                        file: o[0],
                        line: o[1] ? +o[1] : void 0,
                        col: o[2] ? +o[2] : void 0,
                        raw: t
                    };
                }
                return {
                    function: t
                };
            });
        }
        function Ke(t) {
            return t.map(function(t) {
                return {
                    functionName: t.function,
                    args: t.args,
                    fileName: t.file,
                    lineNumber: t.line,
                    columnNumber: t.col,
                    source: t.raw
                };
            });
        }
        var Ye = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
        function tr() {
            return null;
        }
        function er(t) {
            var e = {};
            return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = null, e;
        }
        function rr(t, e) {
            return {
                stack: function() {
                    var r = [];
                    e = e || 0;
                    try {
                        r = function(t, e) {
                            return Ke(Ge(t, e));
                        }(t);
                    } catch (t) {
                        r = [];
                    }
                    for(var n = [], o = e; o < r.length; o++)n.push(new er(r[o]));
                    return n;
                }(),
                message: t.message,
                name: nr(t),
                rawStack: t.stack,
                rawException: t
            };
        }
        function nr(t) {
            var e = t.name && t.name.length && t.name, r = t.constructor.name && t.constructor.name.length && t.constructor.name;
            return e && r ? "Error" === e ? r : e : e || r;
        }
        var or = {
            guessFunctionName: function() {
                return "?";
            },
            guessErrorClass: function(t) {
                if (!t || !t.match) return [
                    "Unknown error. There was no error message to display.",
                    ""
                ];
                var e = t.match(Ye), r = "(unknown)";
                return e && (r = e[e.length - 1], t = (t = t.replace((e[e.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                    r,
                    t
                ];
            },
            gatherContext: tr,
            parse: function(t, e) {
                var r = t;
                if (r.nested || r.cause) {
                    for(var n = []; r;)n.push(new rr(r, e)), r = r.nested || r.cause, e = 0;
                    return n[0].traceChain = n, n[0];
                }
                return new rr(r, e);
            },
            Stack: rr,
            Frame: er
        };
        function ir(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return ar(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ar(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function ar(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function sr(t, e) {
            var r = t.level, n = h[r] || 0, o = e.reportLevel;
            return !(n < (h[o] || 0));
        }
        function ur(t, e, r) {
            if (!t) return !r;
            var n, o, i = t.frames;
            if (!i || 0 === i.length) return !r;
            for(var s = e.length, u = i.length, l = 0; l < u; l++){
                if (!a(n = i[l].filename, "string")) return !r;
                for(var c = 0; c < s; c++)if (o = e[c], new RegExp(o).test(n)) return !0;
            }
            return !1;
        }
        function lr(t, e, r, n) {
            var o, i, a = !1;
            "blocklist" === r && (a = !0);
            try {
                if (o = a ? e.hostBlockList : e.hostSafeList, i = I(t, "body.trace_chain") || [
                    I(t, "body.trace")
                ], !o || 0 === o.length) return !a;
                if (0 === i.length || !i[0]) return !a;
                for(var s = i.length, u = 0; u < s; u++)if (ur(i[u], o, a)) return !0;
            } catch (t) {
                a ? e.hostBlockList = null : e.hostSafeList = null;
                var l = a ? "hostBlockList" : "hostSafeList";
                return n.error("Error while reading your configuration's " + l + " option. Removing custom " + l + ".", t), !a;
            }
            return !1;
        }
        function cr(t) {
            return function(e, r) {
                var n, o, i, a, s, u;
                try {
                    if (!(i = r.ignoredMessages) || 0 === i.length) return !0;
                    if (u = function(t) {
                        var e = t.body, r = [];
                        if (e.trace_chain) {
                            var n, o = ir(e.trace_chain);
                            try {
                                for(o.s(); !(n = o.n()).done;){
                                    var i = n.value;
                                    r.push(I(i, "exception.message"));
                                }
                            } catch (t) {
                                o.e(t);
                            } finally{
                                o.f();
                            }
                        }
                        e.trace && r.push(I(e, "trace.exception.message"));
                        e.message && r.push(I(e, "message.body"));
                        return r;
                    }(e), 0 === u.length) return !0;
                    for(a = i.length, n = 0; n < a; n++)for(s = new RegExp(i[n], "gi"), o = 0; o < u.length; o++)if (s.test(u[o])) return !1;
                } catch (e) {
                    r.ignoredMessages = null, t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                }
                return !0;
            };
        }
        function fr(t) {
            return fr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, fr(t);
        }
        function pr(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, dr(n.key), n);
            }
        }
        function dr(t) {
            var e = function(t, e) {
                if ("object" != fr(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != fr(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == fr(e) ? e : e + "";
        }
        var hr = function() {
            var t, e, r;
            return t = function t(e, r) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.queue = e, this.options = r, this.transforms = [], this.diagnostic = {};
            }, e = [
                {
                    key: "configure",
                    value: function(t) {
                        var e;
                        null === (e = this.queue) || void 0 === e || e.configure(t);
                        var r = this.options;
                        return this.options = R(r, t), this;
                    }
                },
                {
                    key: "addTransform",
                    value: function(t) {
                        return u(t) && this.transforms.push(t), this;
                    }
                },
                {
                    key: "log",
                    value: function(t, e) {
                        var r = this;
                        if (e = u(e) ? e : function() {}, !this.options.enabled) return e(new Error("Rollbar is not enabled"), null);
                        this.queue.addPendingItem(t);
                        var n = t.err;
                        this._applyTransforms(t, function(o, i) {
                            if (o) return r.queue.removePendingItem(t), e(o, null);
                            r.queue.addItem(i, e, n, t);
                        });
                    }
                },
                {
                    key: "_applyTransforms",
                    value: function(t, e) {
                        var r = -1, n = this.transforms.length, o = this.transforms, i = this.options, a = function(t, s) {
                            t ? e(t, null) : ++r !== n ? o[r](s, i, a) : e(null, s);
                        };
                        a(null, t);
                    }
                }
            ], e && pr(t.prototype, e), r && pr(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t;
        }();
        function yr(t) {
            return yr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, yr(t);
        }
        function vr(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, mr(n.key), n);
            }
        }
        function mr(t) {
            var e = function(t, e) {
                if ("object" != yr(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != yr(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == yr(e) ? e : e + "";
        }
        var br, gr, wr, kr = function() {
            function t(e, r, n, o, i) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.rateLimiter = e, this.api = r, this.logger = n, this.options = o, this.replay = i, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
            }
            var e, r, n;
            return e = t, r = [
                {
                    key: "configure",
                    value: function(t) {
                        var e;
                        null === (e = this.api) || void 0 === e || e.configure(t);
                        var r = this.options;
                        return this.options = R(r, t), this;
                    }
                },
                {
                    key: "addPredicate",
                    value: function(t) {
                        return u(t) && this.predicates.push(t), this;
                    }
                },
                {
                    key: "addPendingItem",
                    value: function(t) {
                        this.pendingItems.push(t);
                    }
                },
                {
                    key: "removePendingItem",
                    value: function(t) {
                        var e = this.pendingItems.indexOf(t);
                        -1 !== e && this.pendingItems.splice(e, 1);
                    }
                },
                {
                    key: "addItem",
                    value: function(t, e, r, n) {
                        var o = this;
                        e && u(e) || (e = function() {});
                        var i = t.data, a = this._applyPredicates(i);
                        if (a.stop) return this.removePendingItem(n), void e(a.err);
                        if (this._maybeLog(i, r), this.removePendingItem(n), this.options.transmit) {
                            this.replay && i.body && (t.replayId = this.replay.capture(null, i.uuid, {
                                type: "occurrence",
                                level: t.level
                            }), t.replayId && j(t.data, [
                                {
                                    key: "replay_id",
                                    value: t.replayId
                                }
                            ])), this.pendingRequests.push(i);
                            try {
                                this._makeApiRequest(i, function(r, n, a) {
                                    o._dequeuePendingRequest(i), t.replayId && o.replay.sendOrDiscardReplay(t.replayId, r, n, a), e(r, n);
                                });
                            } catch (r) {
                                var s;
                                this._dequeuePendingRequest(i), t.replayId && (null === (s = this.replay) || void 0 === s || s.discard(t.replayId)), e(r);
                            }
                        } else e(new Error("Transmit disabled"));
                    }
                },
                {
                    key: "wait",
                    value: function(t) {
                        var e = this;
                        u(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval(function() {
                            e._maybeCallWait();
                        }, 500)));
                    }
                },
                {
                    key: "_applyPredicates",
                    value: function(t) {
                        for(var e = null, r = 0, n = this.predicates.length; r < n; r++)if (!(e = this.predicates[r](t, this.options)) || void 0 !== e.err) return {
                            stop: !0,
                            err: e.err
                        };
                        return {
                            stop: !1,
                            err: null
                        };
                    }
                },
                {
                    key: "_makeApiRequest",
                    value: function(t, e) {
                        var r = this, n = this.rateLimiter.shouldSend(t);
                        n.shouldSend ? this.api.postItem(t, function(n, o, i) {
                            n ? r._maybeRetry(n, t, e) : e(n, o, i);
                        }) : n.error ? e(n.error) : this.api.postItem(n.payload, e);
                    }
                },
                {
                    key: "_maybeRetry",
                    value: function(e, r, n) {
                        var o = !1;
                        if (this.options.retryInterval) {
                            for(var i = 0, a = t.RETRIABLE_ERRORS.length; i < a; i++)if (e.code === t.RETRIABLE_ERRORS[i]) {
                                o = !0;
                                break;
                            }
                            o && f(this.options.maxRetries) && (r.retries = r.retries ? r.retries + 1 : 1, r.retries > this.options.maxRetries && (o = !1));
                        }
                        o ? this._retryApiRequest(r, n) : n(e);
                    }
                },
                {
                    key: "_retryApiRequest",
                    value: function(t, e) {
                        var r = this;
                        this.retryQueue.push({
                            item: t,
                            callback: e
                        }), this.retryHandle || (this.retryHandle = setInterval(function() {
                            for(; r.retryQueue.length;){
                                var t = r.retryQueue.shift();
                                r._makeApiRequest(t.item, t.callback);
                            }
                        }, this.options.retryInterval));
                    }
                },
                {
                    key: "_dequeuePendingRequest",
                    value: function(t) {
                        var e = this.pendingRequests.indexOf(t);
                        -1 !== e && (this.pendingRequests.splice(e, 1), this._maybeCallWait());
                    }
                },
                {
                    key: "_maybeLog",
                    value: function(t, e) {
                        if (this.logger && this.options.verbose) {
                            var r = e || I(t, "body.trace.exception.message") || I(t, "body.trace_chain.0.exception.message");
                            if (r) return void this.logger.error(r);
                            (r = I(t, "body.message.body")) && this.logger.log(r);
                        }
                    }
                },
                {
                    key: "_maybeCallWait",
                    value: function() {
                        return !(!u(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), 0));
                    }
                }
            ], r && vr(e.prototype, r), n && vr(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }();
        br = kr, wr = [
            "ECONNRESET",
            "ENOTFOUND",
            "ESOCKETTIMEDOUT",
            "ETIMEDOUT",
            "ECONNREFUSED",
            "EHOSTUNREACH",
            "EPIPE",
            "EAI_AGAIN"
        ], (gr = mr(gr = "RETRIABLE_ERRORS")) in br ? Object.defineProperty(br, gr, {
            value: wr,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : br[gr] = wr;
        var Sr = kr;
        function _r(t) {
            return _r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _r(t);
        }
        function Or(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, xr(n.key), n);
            }
        }
        function xr(t) {
            var e = function(t, e) {
                if ("object" != _r(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != _r(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == _r(e) ? e : e + "";
        }
        var Er = function() {
            function t() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), this.startTime = Date.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(e);
            }
            return function(t, e, r) {
                return e && Or(t.prototype, e), r && Or(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(t, [
                {
                    key: "configureGlobal",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = e.startTime, n = e.maxItems, o = e.itemsPerMinute;
                        void 0 !== r && (t.globalSettings.startTime = r), void 0 !== n && (t.globalSettings.maxItems = n), void 0 !== o && (t.globalSettings.itemsPerMinute = o);
                    }
                },
                {
                    key: "shouldSend",
                    value: function(e) {
                        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Date.now(), n = r - this.startTime;
                        (n < 0 || n >= 6e4) && (this.startTime = r, this.perMinCounter = 0);
                        var o = t.globalSettings.maxItems, i = t.globalSettings.itemsPerMinute;
                        if (jr(e, o, this.counter)) return Ir(this.platform, this.platformOptions, "".concat(o, " max items reached"), !1);
                        if (jr(e, i, this.perMinCounter)) return Ir(this.platform, this.platformOptions, "".concat(i, " items per minute reached"), !1);
                        this.counter += 1, this.perMinCounter += 1;
                        var a = !jr(e, o, this.counter), s = a, u = a && !jr(e, i, this.perMinCounter);
                        return Ir(this.platform, this.platformOptions, null, u, o, i, s);
                    }
                },
                {
                    key: "setPlatformOptions",
                    value: function(t, e) {
                        this.platform = t, this.platformOptions = e;
                    }
                }
            ]);
        }();
        function jr(t, e, r) {
            return !t.ignoreRateLimit && e >= 1 && r > e;
        }
        function Ir(t, e, r, n, o, i, a) {
            var s = null, u = r ? new Error(r) : null;
            return u || n || (s = function(t, e, r, n, o) {
                var i = e.environment || e.payload && e.payload.environment, a = o ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.", s = {
                    body: {
                        message: {
                            body: a,
                            extra: {
                                maxItems: r,
                                itemsPerMinute: n
                            }
                        }
                    },
                    language: "javascript",
                    environment: i,
                    notifier: {
                        version: e.notifier && e.notifier.version || e.version
                    }
                };
                "browser" === t ? (s.platform = "browser", s.framework = "browser-js", s.notifier.name = "rollbar-browser-js") : "server" === t ? (s.framework = e.framework || "node-js", s.notifier.name = e.notifier.name) : "react-native" === t && (s.framework = e.framework || "react-native", s.notifier.name = e.notifier.name);
                return s;
            }(t, e, o, i, a)), {
                error: u,
                shouldSend: n,
                payload: s
            };
        }
        !function(t, e, r) {
            (e = xr(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r;
        }(Er, "globalSettings", {
            startTime: Date.now(),
            maxItems: void 0,
            itemsPerMinute: void 0
        });
        var Tr = Er;
        function Pr(t, e, r, n, o, i, a) {
            this.options = R(t), this.logger = r, Pr.rateLimiter.configureGlobal(this.options), Pr.rateLimiter.setPlatformOptions(a, this.options), this.api = e, this.queue = new Sr(Pr.rateLimiter, e, r, this.options, i), this.tracing = o;
            var s = this.options.tracer || null;
            Rr(s) ? (this.tracer = s, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new hr(this.queue, this.options), this.telemeter = n, Ar(t), this.lastError = null, this.lastErrorHash = "none";
        }
        function Ar(t) {
            t.stackTraceLimit && (Error.stackTraceLimit = t.stackTraceLimit);
        }
        function Rr(t) {
            if (!t) return !1;
            if (!t.scope || "function" != typeof t.scope) return !1;
            var e = t.scope();
            return !(!e || !e.active || "function" != typeof e.active);
        }
        Pr.rateLimiter = new Tr({
            maxItems: 0,
            itemsPerMinute: 60
        }), Pr.prototype.global = function(t) {
            return Pr.rateLimiter.configureGlobal(t), this;
        }, Pr.prototype.configure = function(t, e) {
            var r = this.options, n = {};
            e && (n = {
                payload: e
            }), this.options = R(r, t, n);
            var o = this.options.tracer || null;
            return Rr(o) ? (this.tracer = o, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), Ar(t), this.global(this.options), Rr(t.tracer) && (this.tracer = t.tracer), this;
        }, Pr.prototype.log = function(t) {
            var e = this._defaultLogLevel();
            return this._log(e, t);
        }, Pr.prototype.debug = function(t) {
            this._log("debug", t);
        }, Pr.prototype.info = function(t) {
            this._log("info", t);
        }, Pr.prototype.warn = function(t) {
            this._log("warning", t);
        }, Pr.prototype.warning = function(t) {
            this._log("warning", t);
        }, Pr.prototype.error = function(t) {
            this._log("error", t);
        }, Pr.prototype.critical = function(t) {
            this._log("critical", t);
        }, Pr.prototype.wait = function(t) {
            this.queue.wait(t);
        }, Pr.prototype.captureEvent = function(t, e, r) {
            return this.telemeter && this.telemeter.captureEvent(t, e, r);
        }, Pr.prototype.captureDomContentLoaded = function(t) {
            return this.telemeter && this.telemeter.captureDomContentLoaded(t);
        }, Pr.prototype.captureLoad = function(t) {
            return this.telemeter && this.telemeter.captureLoad(t);
        }, Pr.prototype.buildJsonPayload = function(t) {
            return this.api.buildJsonPayload(t);
        }, Pr.prototype.sendJsonPayload = function(t) {
            this.api.postJsonPayload(t);
        }, Pr.prototype._log = function(t, e) {
            var r;
            if (e.callback && (r = e.callback, delete e.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(e)) {
                if (r) {
                    var n = new Error("ignored identical item");
                    n.item = e, r(n);
                }
            } else try {
                e.level = e.level || t, this._addItemAttributes(e), this._addTracingInfo(e);
                var o = this.telemeter;
                o && (o._captureRollbarItem(e), e.telemetryEvents = o.copyEvents() || []), this.notifier.log(e, r);
            } catch (t) {
                r && r(t), this.logger.error(t);
            }
        }, Pr.prototype._addItemAttributes = function(t) {
            var e, r, n = null === (e = this.tracing) || void 0 === e ? void 0 : e.getSpan(), o = [
                {
                    key: "session_id",
                    value: function(t) {
                        var e = t.asyncLocalStorage;
                        if (!e || "function" != typeof e.getStore) return null;
                        var r = e.getStore();
                        return (null == r ? void 0 : r.sessionId) || null;
                    }(this) || (null === (r = this.tracing) || void 0 === r ? void 0 : r.sessionId)
                },
                {
                    key: "span_id",
                    value: null == n ? void 0 : n.spanId
                },
                {
                    key: "trace_id",
                    value: null == n ? void 0 : n.traceId
                }
            ];
            t._isUncaught && o.push({
                key: "is_uncaught",
                value: "true"
            }), j(t.data, o), null == n || n.addEvent("rollbar.occurrence", [
                {
                    key: "rollbar.occurrence.uuid",
                    value: t.uuid
                }
            ]);
        }, Pr.prototype._defaultLogLevel = function() {
            return this.options.logLevel || "debug";
        }, Pr.prototype._sameAsLastError = function(t) {
            if (!t._isUncaught) return !1;
            var e = function(t) {
                var e = t.message || "", r = (t.err || {}).stack || String(t.err);
                return e + "::" + r;
            }(t);
            return this.lastErrorHash === e || (this.lastError = t.err, this.lastErrorHash = e, !1);
        }, Pr.prototype._addTracingInfo = function(t) {
            if (this.tracer) {
                var e = this.tracer.scope().active();
                if (function(t) {
                    if (!t || !t.context || "function" != typeof t.context) return !1;
                    var e = t.context();
                    if (!e || !e.toSpanId || !e.toTraceId || "function" != typeof e.toSpanId || "function" != typeof e.toTraceId) return !1;
                    return !0;
                }(e)) {
                    e.setTag("rollbar.error_uuid", t.uuid), e.setTag("rollbar.has_error", !0), e.setTag("error", !0), e.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=".concat(t.uuid)), e.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=".concat(t.uuid));
                    var r = e.context().toSpanId(), n = e.context().toTraceId();
                    t.custom ? (t.custom.opentracing_span_id = r, t.custom.opentracing_trace_id = n) : t.custom = {
                        opentracing_span_id: r,
                        opentracing_trace_id: n
                    };
                }
            }
        };
        var Cr = Pr;
        function Lr(t, e, r) {
            t._isUncaught && (t.data._isUncaught = !0), t._originalArgs && (t.data._originalArgs = t._originalArgs), r(null, t);
        }
        function qr(t, e, r) {
            var n = e.payload || {};
            n.body && delete n.body, t.data = R(t.data, n), r(null, t);
        }
        function Nr(t, e, r) {
            t.telemetryEvents && T(t, "data.body.telemetry", t.telemetryEvents), r(null, t);
        }
        function Dr(t, e, r) {
            if (t.message) {
                var n = "data.body.trace_chain.0", o = I(t, n);
                if (o || (o = I(t, n = "data.body.trace")), o) {
                    if (!o.exception || !o.exception.description) return T(t, n + ".exception.description", t.message), void r(null, t);
                    T(t, n + ".extra", R(I(t, n + ".extra") || {}, {
                        message: t.message
                    }));
                }
                r(null, t);
            } else r(null, t);
        }
        function Mr(t) {
            return function(e, r, n) {
                var o, i = R(e), s = null;
                try {
                    u(r.transform) && (s = r.transform(i.data, e));
                } catch (o) {
                    return r.transform = null, t.error("Error while calling custom transform() function. Removing custom transform().", o), void n(null, e);
                }
                l(o = s) && a(o.then, "function") ? s.then(function(t) {
                    t && (i.data = t), n(null, i);
                }, function(t) {
                    n(t, e);
                }) : n(null, i);
            };
        }
        function Ur(t, e, r) {
            if (!e.sendConfig) return r(null, t);
            var n = I(t, "data.custom") || {};
            n._rollbarConfig = e, t.data.custom = n, r(null, t);
        }
        function Hr(t, e) {
            u(t[e]) && (t[e] = t[e].toString());
        }
        function Fr(t, e, r) {
            var n = e._configuredOptions;
            Hr(n, "transform"), Hr(n, "checkIgnore"), Hr(n, "onSendCallback"), delete n.accessToken, t.data.notifier.configured_options = n, r(null, t);
        }
        function Jr(t, e, r) {
            var n = R(t.notifier.client.notifier.diagnostic, t.diagnostic);
            if (I(t, "err._isAnonymous") && (n.is_anonymous = !0), t._isUncaught && (n.is_uncaught = t._isUncaught), t.err) try {
                n.raw_error = {
                    message: t.err.message,
                    name: t.err.name,
                    constructor_name: t.err.constructor && t.err.constructor.name,
                    filename: t.err.fileName,
                    line: t.err.lineNumber,
                    column: t.err.columnNumber,
                    stack: t.err.stack
                };
            } catch (t) {
                n.raw_error = {
                    failed: String(t)
                };
            }
            t.data.notifier.diagnostic = R(t.data.notifier.diagnostic, n), r(null, t);
        }
        function Vr(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        var Br = [].concat(function(t) {
            return function(t) {
                if (Array.isArray(t)) return Vr(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return Vr(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Vr(t, e) : void 0;
                }
            }(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }([
            "pw",
            "pass",
            "passwd",
            "password",
            "secret",
            "confirm_password",
            "confirmPassword",
            "password_confirmation",
            "passwordConfirmation",
            "access_token",
            "accessToken",
            "X-Rollbar-Access-Token",
            "secret_key",
            "secretKey",
            "secretToken"
        ]), [
            "cc-number",
            "card number",
            "cardnumber",
            "cardnum",
            "ccnum",
            "ccnumber",
            "cc num",
            "creditcardnumber",
            "credit card number",
            "newcreditcardnumber",
            "new credit card",
            "creditcardno",
            "credit card no",
            "card#",
            "card #",
            "cc-csc",
            "cvc",
            "cvc2",
            "cvv2",
            "ccv2",
            "security code",
            "card verification",
            "name on credit card",
            "name on card",
            "nameoncard",
            "cardholder",
            "card holder",
            "name des karteninhabers",
            "ccname",
            "card type",
            "cardtype",
            "cc type",
            "cctype",
            "payment type",
            "expiration date",
            "expirationdate",
            "expdate",
            "cc-exp",
            "ccmonth",
            "ccyear"
        ]), Wr = {
            scrubFields: Br
        };
        function $r(t, e) {
            return !I(e, "plugins.jquery.ignoreAjaxErrors") || !I(t, "body.message.extra.isAjax");
        }
        function Gr(t, e, r) {
            if (t.err && "DOMException" === or.Stack(t.err).name) {
                var n = new Error;
                n.name = t.err.name, n.message = t.err.message, n.stack = t.err.stack, n.nested = t.err, t.err = n;
            }
            r(null, t);
        }
        function zr(t, e, r) {
            if (t.data = t.data || {}, t.err) try {
                t.stackInfo = t.err._savedStackTrace || or.parse(t.err, t.skipFrames), e.addErrorContext && function(t) {
                    var e = [], r = t.err;
                    e.push(r);
                    for(; r.nested || r.cause;)r = r.nested || r.cause, e.push(r);
                    !function(t, e) {
                        var r = t.data.custom || {}, o = !1;
                        try {
                            var i, a = n(e);
                            try {
                                for(a.s(); !(i = a.n()).done;){
                                    var s = i.value;
                                    c(s, "rollbarContext") && (r = R(r, S(s.rollbarContext)), o = !0);
                                }
                            } catch (t) {
                                a.e(t);
                            } finally{
                                a.f();
                            }
                            o && (t.data.custom = r);
                        } catch (e) {
                            t.diagnostic.error_context = "Failed: " + e.message;
                        }
                    }(t, e);
                }(t);
            } catch (e) {
                Ct.error("Error while parsing the error object.", e);
                try {
                    t.message = t.err.message || t.err.description || t.message || String(t.err);
                } catch (e) {
                    t.message = String(t.err) || String(e);
                }
                delete t.err;
            }
            r(null, t);
        }
        function Xr(t, e, r) {
            t.message || t.stackInfo || t.custom || r(new Error("No message, stack info, or custom data"), null), r(null, t);
        }
        function Zr(t, e, r) {
            var n = e.payload && e.payload.environment || e.environment;
            t.data = R(t.data, {
                environment: n,
                level: t.level,
                endpoint: e.endpoint,
                platform: "browser",
                framework: "browser-js",
                language: "javascript",
                server: {},
                uuid: t.uuid,
                notifier: {
                    name: "rollbar-browser-js",
                    version: e.version
                },
                custom: t.custom
            }), r(null, t);
        }
        function Qr(t, e, r) {
            t.stackInfo ? t.stackInfo.traceChain ? function(t, e, r) {
                for(var n = t.stackInfo.traceChain, o = [], i = n.length, a = 0; a < i; a++){
                    var s = tn(t, n[a], e);
                    o.push(s);
                }
                T(t, "data.body", {
                    trace_chain: o
                }), r(null, t);
            }(t, e, r) : function(t, e, r) {
                var n = Yr(t);
                if (n) T(t, "data.body", {
                    trace: tn(t, t.stackInfo, e)
                }), r(null, t);
                else {
                    var o = t.stackInfo, i = or.guessErrorClass(o.message), a = en(o, i[0], e), s = i[1];
                    t.message = a + ": " + s, Kr(t, e, r);
                }
            }(t, e, r) : Kr(t, e, r);
        }
        function Kr(t, e, r) {
            var n = t.message, o = t.custom;
            n || (n = "Item sent with null or missing arguments.");
            var i = {
                body: n
            };
            o && (i.extra = R(o)), T(t, "data.body", {
                message: i
            }), r(null, t);
        }
        function Yr(t) {
            var e = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || t.stackInfo).stack;
            return e && 0 === e.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (e = t._unhandledStackInfo.stack), e;
        }
        function tn(t, e, r) {
            var n = t && t.data.description, o = t && t.custom, i = Yr(t, e), a = or.guessErrorClass(e.message), s = {
                exception: {
                    class: en(e, a[0], r),
                    message: a[1]
                }
            };
            if (n && (s.exception.description = n), i) {
                var u, l, c, f, p, d, h, v;
                for(0 === i.length && (s.exception.stack = e.rawStack, s.exception.raw = String(e.rawException)), s.frames = [], h = 0; h < i.length; ++h)l = {
                    filename: (u = i[h]).url ? y(u.url) : "(unknown)",
                    lineno: u.line || null,
                    method: u.func && "?" !== u.func ? u.func : "[anonymous]",
                    colno: u.column
                }, r.sendFrameUrl && (l.url = u.url), l.method && l.method.endsWith && l.method.endsWith("_rollbar_wrapped") || (c = f = p = null, (d = u.context ? u.context.length : 0) && (v = Math.floor(d / 2), f = u.context.slice(0, v), c = u.context[v], p = u.context.slice(v)), c && (l.code = c), (f || p) && (l.context = {}, f && f.length && (l.context.pre = f), p && p.length && (l.context.post = p)), u.args && (l.args = u.args), s.frames.push(l));
                s.frames.reverse(), o && (s.extra = R(o));
            }
            return s;
        }
        function en(t, e, r) {
            return t.name ? t.name : r.guessErrorClass ? e : "(unknown)";
        }
        function rn(t) {
            return rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, rn(t);
        }
        function nn(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function on(t, e, r) {
            return (e = function(t) {
                var e = function(t, e) {
                    if ("object" != rn(t) || !t) return t;
                    var r = t[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(t, e || "default");
                        if ("object" != rn(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === e ? String : Number)(t);
                }(t, "string");
                return "symbol" == rn(e) ? e : e + "";
            }(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        var an = function(t) {
            var e, r, n = t.accessToken, o = t.url, i = t.method, a = t.payload, s = t.headers, u = t.callback, l = t.timeout;
            f(l) && (e = new AbortController, r = setTimeout(function() {
                e.abort();
            }, l)), s = function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? nn(Object(r), !0).forEach(function(e) {
                        on(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : nn(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }({
                "Content-Type": "application/json",
                "X-Rollbar-Access-Token": n,
                signal: e && e.signal
            }, s), fetch(o, {
                method: i,
                headers: s,
                body: a
            }).then(function(t) {
                r && clearTimeout(r);
                var e = t.headers, n = o.endsWith("/api/1/item/") ? {
                    "Rollbar-Replay-Enabled": e.get("Rollbar-Replay-Enabled"),
                    "Rollbar-Replay-RateLimit-Remaining": e.get("Rollbar-Replay-RateLimit-Remaining"),
                    "Rollbar-Replay-RateLimit-Reset": e.get("Rollbar-Replay-RateLimit-Reset")
                } : {}, i = t.json();
                u(null, i, n);
            }).catch(function(t) {
                Ct.error(t.message), u(t);
            });
        };
        function sn(t, e) {
            return function(t) {
                if (Array.isArray(t)) return t;
            }(t) || function(t, e) {
                var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, o, i, a, s = [], u = !0, l = !1;
                    try {
                        if (i = (r = r.call(t)).next, 0 === e) {
                            if (Object(r) !== r) return;
                            u = !1;
                        } else for(; !(u = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); u = !0);
                    } catch (t) {
                        l = !0, o = t;
                    } finally{
                        try {
                            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                        } finally{
                            if (l) throw o;
                        }
                    }
                    return s;
                }
            }(t, e) || function(t, e) {
                if (t) {
                    if ("string" == typeof t) return un(t, e);
                    var r = ({}).toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? un(t, e) : void 0;
                }
            }(t, e) || function() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function un(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function ln(t, e) {
            var r = new Error(t);
            return r.code = e || "ENOTFOUND", r;
        }
        var cn = function(t) {
            var e, r = t.accessToken, n = t.url, o = t.method, i = t.payload, s = t.headers, u = t.callback, l = t.requestFactory, c = t.timeout;
            if (!(e = l ? l() : function() {
                var t, e, r = [
                    function() {
                        return new XMLHttpRequest;
                    },
                    function() {
                        return new ActiveXObject("Msxml2.XMLHTTP");
                    },
                    function() {
                        return new ActiveXObject("Msxml3.XMLHTTP");
                    },
                    function() {
                        return new ActiveXObject("Microsoft.XMLHTTP");
                    }
                ], n = r.length;
                for(e = 0; e < n; e++)try {
                    t = r[e]();
                    break;
                } catch (t) {}
                return t;
            }())) return u(new Error("No way to send a request"));
            try {
                try {
                    var p = function() {
                        try {
                            if (p && 4 === e.readyState) {
                                p = void 0;
                                var t = g(e.responseText);
                                if (function(t) {
                                    return t && t.status && 200 === t.status;
                                }(e)) {
                                    var r = n.endsWith("/api/1/item/") ? {
                                        "Rollbar-Replay-Enabled": e.getResponseHeader("Rollbar-Replay-Enabled"),
                                        "Rollbar-Replay-RateLimit-Remaining": e.getResponseHeader("Rollbar-Replay-RateLimit-Remaining"),
                                        "Rollbar-Replay-RateLimit-Reset": e.getResponseHeader("Rollbar-Replay-RateLimit-Reset")
                                    } : {};
                                    return void u(t.error, t.value, r);
                                }
                                if (function(t) {
                                    return t && a(t.status, "number") && t.status >= 400 && t.status < 600;
                                }(e)) {
                                    if (403 === e.status) {
                                        var o = t.value && t.value.message;
                                        Ct.error(o);
                                    }
                                    u(new Error(String(e.status)));
                                } else u(ln("XHR response had no status code (likely connection failure)"));
                            }
                        } catch (t) {
                            var i;
                            i = t && t.stack ? t : new Error(t), u(i);
                        }
                    };
                    if (e.open(o, n, !0), e.setRequestHeader) {
                        e.setRequestHeader("Content-Type", "application/json"), e.setRequestHeader("X-Rollbar-Access-Token", r);
                        for(var d = 0, h = Object.entries(null != s ? s : {}); d < h.length; d++){
                            var y = sn(h[d], 2), v = y[0], m = y[1];
                            e.setRequestHeader(v, m);
                        }
                    }
                    f(c) && (e.timeout = c), e.onreadystatechange = p, e.send(i);
                } catch (t) {
                    if ("undefined" != typeof XDomainRequest) {
                        if (!window || !window.location) return u(new Error("No window available during request, unknown environment"));
                        "http:" === window.location.href.substring(0, 5) && "https" === n.substring(0, 5) && (n = "http" + n.substring(5));
                        var b = new XDomainRequest;
                        b.onprogress = function() {}, b.ontimeout = function() {
                            u(ln("Request timed out", "ETIMEDOUT"));
                        }, b.onerror = function() {
                            u(new Error("Error during request"));
                        }, b.onload = function() {
                            var t = g(b.responseText);
                            u(t.error, t.value);
                        }, b.open(o, n, !0), b.send(i);
                    } else u(new Error("Cannot find a method to transport a request"));
                }
            } catch (t) {
                u(t);
            }
        };
        function fn(t) {
            this.truncation = t;
        }
        fn.prototype.get = function(t, e, r, n, o) {
            n && u(n) || (n = function() {}), function(t, e, r) {
                (r = r || {}).access_token = t;
                var n, o = [];
                for(n in r)Object.prototype.hasOwnProperty.call(r, n) && o.push([
                    n,
                    r[n]
                ].join("="));
                var i = "?" + o.sort().join("&");
                (e = e || {}).path = e.path || "";
                var a, s = e.path.indexOf("?"), u = e.path.indexOf("#");
                -1 !== s && (-1 === u || u > s) ? (a = e.path, e.path = a.substring(0, s) + i + "&" + a.substring(s + 1)) : -1 !== u ? (a = e.path, e.path = a.substring(0, u) + i + a.substring(u)) : e.path = e.path + i;
            }(t, e, r);
            var i = m(e);
            this._makeZoneRequest({
                accessToken: t,
                url: i,
                method: "GET",
                callback: n,
                requestFactory: o,
                timeout: e.timeout,
                transport: e.transport
            });
        }, fn.prototype.post = function(t) {
            var e, r = t.accessToken, n = t.options, o = t.payload, i = t.headers, a = t.callback, s = t.requestFactory;
            if (a && u(a) || (a = function() {}), !o) return a(new Error("Cannot send empty request"));
            if ((e = this.truncation && o.body ? this.truncation.truncate(o) : b(o)).error) return a(e.error);
            var l = m(n);
            this._makeZoneRequest({
                accessToken: r,
                url: l,
                method: "POST",
                payload: e.value,
                headers: i,
                callback: a,
                requestFactory: s,
                timeout: n.timeout,
                transport: n.transport
            });
        }, fn.prototype.postJsonPayload = function(t, e, r, n, o) {
            n && u(n) || (n = function() {});
            var i = m(e);
            this._makeZoneRequest({
                accessToken: t,
                url: i,
                method: "POST",
                payload: r,
                callback: n,
                requestFactory: o,
                timeout: e.timeout,
                transport: e.transport
            });
        }, fn.prototype._makeZoneRequest = function() {
            var t = this, e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = e && e.Zone && e.Zone.root, n = Array.prototype.slice.call(arguments);
            r ? r.run(function() {
                t._makeRequest.apply(void 0, n);
            }) : this._makeRequest.apply(void 0, n);
        }, fn.prototype._makeRequest = function(t) {
            var e = t.payload, r = t.callback, n = t.transport;
            if ("undefined" != typeof RollbarProxy) return function(t, e) {
                (new RollbarProxy).sendJsonPayload(t, function(t) {}, function(t) {
                    e(new Error(t));
                });
            }(e, r);
            "fetch" === n ? an(t) : cn(t);
        };
        var pn, dn = fn;
        function hn(t) {
            var e, r, n = {
                protocol: null,
                auth: null,
                host: null,
                path: null,
                hash: null,
                href: t,
                hostname: null,
                port: null,
                pathname: null,
                search: null,
                query: null
            };
            if (-1 !== (e = t.indexOf("//")) ? (n.protocol = t.substring(0, e), r = e + 2) : r = 0, -1 !== (e = t.indexOf("@", r)) && (n.auth = t.substring(r, e), r = e + 1), -1 === (e = t.indexOf("/", r))) {
                if (-1 === (e = t.indexOf("?", r))) return -1 === (e = t.indexOf("#", r)) ? n.host = t.substring(r) : (n.host = t.substring(r, e), n.hash = t.substring(e)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
            } else n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
            if (-1 === (e = t.indexOf("#", r)) ? n.path = t.substring(r) : (n.path = t.substring(r, e), n.hash = t.substring(e)), n.path) {
                var o = n.path.split("?");
                n.pathname = o[0], n.query = o[1], n.search = n.query ? "?" + n.query : null;
            }
            return n;
        }
        function yn(t) {
            return yn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, yn(t);
        }
        function vn(t, e) {
            var r = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), r.push.apply(r, n);
            }
            return r;
        }
        function mn(t) {
            for(var e = 1; e < arguments.length; e++){
                var r = null != arguments[e] ? arguments[e] : {};
                e % 2 ? vn(Object(r), !0).forEach(function(e) {
                    gn(t, e, r[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vn(Object(r)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                });
            }
            return t;
        }
        function bn(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wn(n.key), n);
            }
        }
        function gn(t, e, r) {
            return (e = wn(e)) in t ? Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = r, t;
        }
        function wn(t) {
            var e = function(t, e) {
                if ("object" != yn(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != yn(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == yn(e) ? e : e + "";
        }
        var kn = null, Sn = function() {
            function t(e, n) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Ct.init({
                    logLevel: e.logLevel || "error"
                }), this.options = A(On, e, null, Ct), this.options._configuredOptions = e, this.components = this.components || {};
                var o = this.components.telemeter, i = this.components.instrumenter;
                this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                var a = this.components.truncation, s = this.components.tracing, l = this.components.replay, c = new dn(a), f = new Me(this.options, c, r, a);
                if (s && (this.tracing = new s(_n(), f, this.options), this.tracing.initSession()), o && (this.telemeter = new o(this.options, this.tracing)), l && "undefined" != typeof window) {
                    var p = this.options.replay;
                    this.replay = new l({
                        tracing: this.tracing,
                        telemeter: this.telemeter,
                        options: p
                    }), p.enabled && p.autoStart && this.replay.recorder.start();
                }
                this.client = n || new Cr(this.options, f, Ct, this.telemeter, this.tracing, this.replay, "browser");
                var d = _n(), h = "undefined" != typeof document && document;
                this.isChrome = d.chrome && d.chrome.runtime, this.anonymousErrorsPending = 0, function(t, e, r) {
                    t.addTransform(Gr).addTransform(zr).addTransform(Xr).addTransform(Zr).addTransform(function(t) {
                        return function(e, r, n) {
                            var o = {};
                            t && t.location && (o.url = t.location.href, o.query_string = t.location.search);
                            var i = "$remote_ip";
                            r.captureIp ? !0 !== r.captureIp && (i += "_anonymize") : i = null, i && (o.user_ip = i), Object.keys(o).length > 0 && T(e, "data.request", o), n(null, e);
                        };
                    }(r)).addTransform(function(t) {
                        return function(e, r, n) {
                            if (!t) return n(null, e);
                            var o = t.navigator || {}, i = t.screen || {};
                            T(e, "data.client", {
                                runtime_ms: e.timestamp - t._rollbarStartTime,
                                timestamp: Math.round(e.timestamp / 1e3),
                                javascript: {
                                    browser: o.userAgent,
                                    language: o.language,
                                    cookie_enabled: o.cookieEnabled,
                                    screen: {
                                        width: i.width,
                                        height: i.height
                                    }
                                }
                            }), n(null, e);
                        };
                    }(r)).addTransform(function(t) {
                        return function(e, r, n) {
                            if (!t || !t.navigator) return n(null, e);
                            for(var o, i = [], a = t.navigator.plugins || [], s = 0, u = a.length; s < u; ++s)o = a[s], i.push({
                                name: o.name,
                                description: o.description
                            });
                            T(e, "data.client.javascript.plugins", i), n(null, e);
                        };
                    }(r)).addTransform(Qr).addTransform(Dr).addTransform(Nr).addTransform(Ur).addTransform((n = e.scrub, function(t, e, r) {
                        if (n) {
                            var o = e.scrubFields || [], i = e.scrubPaths || [];
                            t.data = n(t.data, o, i);
                        }
                        r(null, t);
                    })).addTransform(qr).addTransform(Mr(Ct)).addTransform(Fr).addTransform(Jr).addTransform(Lr);
                    var n;
                }(this.client.notifier, this, d), function(t) {
                    t.addPredicate(sr).addPredicate($r).addPredicate(function(t) {
                        return function(e, r) {
                            var n = Boolean(e._isUncaught);
                            delete e._isUncaught;
                            var o = e._originalArgs;
                            delete e._originalArgs;
                            try {
                                u(r.onSendCallback) && r.onSendCallback(n, o, e);
                            } catch (e) {
                                r.onSendCallback = null, t.error("Error while calling onSendCallback, removing", e);
                            }
                            try {
                                if (u(r.checkIgnore) && r.checkIgnore(n, o, e)) return !1;
                            } catch (e) {
                                r.checkIgnore = null, t.error("Error while calling custom checkIgnore(), removing", e);
                            }
                            return !0;
                        };
                    }(Ct)).addPredicate(function(t) {
                        return function(e, r) {
                            return !lr(e, r, "blocklist", t);
                        };
                    }(Ct)).addPredicate(function(t) {
                        return function(e, r) {
                            return lr(e, r, "safelist", t);
                        };
                    }(Ct)).addPredicate(cr(Ct));
                }(this.client.queue), this.setupUnhandledCapture(), i && (this.instrumenter = new i(this.options, this.client.telemeter, this, d, h), this.instrumenter.instrument()), this.setSessionAttributesFromOptions(e), this.rollbar = this;
            }
            return function(t, e, r) {
                return e && bn(t.prototype, e), r && bn(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(t, [
                {
                    key: "global",
                    value: function(t) {
                        return this.client.global(t), this;
                    }
                },
                {
                    key: "configure",
                    value: function(t, e) {
                        var r, n, o;
                        t.logLevel && Ct.init({
                            logLevel: t.logLevel
                        }), this.setSessionAttributesFromOptions(t);
                        var i = this.options, a = {};
                        return e && (a = {
                            payload: e
                        }), this.options = A(i, t, a, Ct), this.options._configuredOptions = A(i._configuredOptions, t, a), null === (r = this.tracing) || void 0 === r || r.configure(this.options), null === (n = this.replay) || void 0 === n || n.configure(this.options.replay), this.client.configure(this.options, e), null === (o = this.instrumenter) || void 0 === o || o.configure(this.options), this.setupUnhandledCapture(), this;
                    }
                },
                {
                    key: "lastError",
                    value: function() {
                        return this.client.lastError;
                    }
                },
                {
                    key: "log",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.log(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "debug",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.debug(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "info",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.info(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "warn",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.warn(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "warning",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.warning(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "error",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.error(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "critical",
                    value: function() {
                        var t = this._createItem(arguments), e = t.uuid;
                        return this.client.critical(t), {
                            uuid: e
                        };
                    }
                },
                {
                    key: "buildJsonPayload",
                    value: function(t) {
                        return this.client.buildJsonPayload(t);
                    }
                },
                {
                    key: "sendJsonPayload",
                    value: function(t) {
                        return this.client.sendJsonPayload(t);
                    }
                },
                {
                    key: "triggerDirectReplay",
                    value: function(t) {
                        return this.triggerReplay(mn({
                            type: "direct"
                        }, t));
                    }
                },
                {
                    key: "triggerReplay",
                    value: function(t) {
                        return this.replay ? this.replay.triggerReplay(t) : null;
                    }
                },
                {
                    key: "setupUnhandledCapture",
                    value: function() {
                        var t = _n();
                        this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (!function(t, e, r) {
                            if (t) {
                                var n;
                                if ("function" == typeof e._rollbarOldOnError) n = e._rollbarOldOnError;
                                else if (t.onerror) {
                                    for(n = t.onerror; n._rollbarOldOnError;)n = n._rollbarOldOnError;
                                    e._rollbarOldOnError = n;
                                }
                                e.handleAnonymousErrors();
                                var o = function() {
                                    var r = Array.prototype.slice.call(arguments, 0);
                                    !function(t, e, r, n) {
                                        t._rollbarWrappedError && (n[4] || (n[4] = t._rollbarWrappedError), n[5] || (n[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null);
                                        var o = e.handleUncaughtException.apply(e, n);
                                        r && r.apply(t, n), "anonymous" === o && (e.anonymousErrorsPending += 1);
                                    }(t, e, n, r);
                                };
                                r && (o._rollbarOldOnError = n), t.onerror = o;
                            }
                        }(t, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(t, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (!function(t, e, r) {
                            if (t) {
                                "function" == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener("unhandledrejection", t._rollbarURH);
                                var n = function(t) {
                                    var r, n, o;
                                    try {
                                        r = t.reason;
                                    } catch (t) {
                                        r = void 0;
                                    }
                                    try {
                                        n = t.promise;
                                    } catch (t) {
                                        n = "[unhandledrejection] error getting `promise` from event";
                                    }
                                    try {
                                        o = t.detail, !r && o && (r = o.reason, n = o.promise);
                                    } catch (t) {}
                                    r || (r = "[unhandledrejection] error getting `reason` from event"), e && e.handleUnhandledRejection && e.handleUnhandledRejection(r, n);
                                };
                                n.belongsToShim = r, t._rollbarURH = n, t.addEventListener("unhandledrejection", n);
                            }
                        }(t, this), this.unhandledRejectionsInitialized = !0);
                    }
                },
                {
                    key: "handleUncaughtException",
                    value: function(t, e, r, n, o, i) {
                        if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                            if (this.options.inspectAnonymousErrors && this.isChrome && null === o && "" === e) return "anonymous";
                            var a, s = w(t, e, r, n, o, "onerror", "uncaught exception", or);
                            p(o) ? (a = this._createItem([
                                t,
                                o,
                                i
                            ]))._unhandledStackInfo = s : p(e) ? (a = this._createItem([
                                t,
                                e,
                                i
                            ]))._unhandledStackInfo = s : (a = this._createItem([
                                t,
                                i
                            ])).stackInfo = s, a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
                        }
                    }
                },
                {
                    key: "handleAnonymousErrors",
                    value: function() {
                        var t = this;
                        if (this.options.inspectAnonymousErrors && this.isChrome) try {
                            Error.prepareStackTrace = function(e, r) {
                                if (t.options.inspectAnonymousErrors && t.anonymousErrorsPending) {
                                    if (t.anonymousErrorsPending -= 1, !e) return;
                                    e._isAnonymous = !0, t.handleUncaughtException(e.message, null, null, null, e);
                                }
                                return e.stack;
                            };
                        } catch (t) {
                            this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", t);
                        }
                    }
                },
                {
                    key: "handleUnhandledRejection",
                    value: function(t, e) {
                        if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                            var r = "unhandled rejection was null or undefined!";
                            if (t) {
                                if (t.message) r = t.message;
                                else {
                                    var n = b(t);
                                    n.value && (r = n.value);
                                }
                            }
                            var o, i = t && t._rollbarContext || e && e._rollbarContext;
                            p(t) ? o = this._createItem([
                                r,
                                t,
                                i
                            ]) : (o = this._createItem([
                                r,
                                t,
                                i
                            ])).stackInfo = w(r, "", 0, 0, null, "unhandledrejection", "", or), o.level = this.options.uncaughtErrorLevel, o._isUncaught = !0, o._originalArgs = o._originalArgs || [], o._originalArgs.push(e), this.client.log(o);
                        }
                    }
                },
                {
                    key: "wrap",
                    value: function(t, e, r) {
                        try {
                            var n;
                            if (n = u(e) ? e : function() {
                                return e || {};
                            }, !u(t)) return t;
                            if (t._isWrap) return t;
                            if (!t._rollbar_wrapped) for(var o in t._rollbar_wrapped = function() {
                                r && u(r) && r.apply(this, arguments);
                                try {
                                    return t.apply(this, arguments);
                                } catch (r) {
                                    var e = r;
                                    throw e && window._rollbarWrappedError !== e && (a(e, "string") && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e), e;
                                }
                            }, t._rollbar_wrapped._isWrap = !0, t)c(t, o) && "_rollbar_wrapped" !== o && (t._rollbar_wrapped[o] = t[o]);
                            return t._rollbar_wrapped;
                        } catch (e) {
                            return t;
                        }
                    }
                },
                {
                    key: "captureEvent",
                    value: function() {
                        var t = function(t) {
                            for(var e, r, n, o, i = 0, a = t.length; i < a; ++i)switch(s(o = t[i])){
                                case "string":
                                    !e && E(O, o) ? e = o : !n && E(x, o) && (n = o);
                                    break;
                                case "object":
                                    r = o;
                            }
                            return {
                                type: e || "manual",
                                metadata: r || {},
                                level: n
                            };
                        }(arguments);
                        return this.client.captureEvent(t.type, t.metadata, t.level);
                    }
                },
                {
                    key: "setSessionUser",
                    value: function(t) {
                        var e;
                        null !== (e = this.tracing) && void 0 !== e && e.session && this.tracing.session.setUser(t);
                    }
                },
                {
                    key: "setSessionAttributes",
                    value: function(t) {
                        var e;
                        null !== (e = this.tracing) && void 0 !== e && e.session && (t = mn({}, t), this.tracing.session.setAttributes(t));
                    }
                },
                {
                    key: "setSessionAttributesFromOptions",
                    value: function(t) {
                        var e, r, n, o, i, a = t.person || (null === (e = t.payload) || void 0 === e ? void 0 : e.person);
                        a && this.setSessionUser(a);
                        var s = (null === (r = t.client) || void 0 === r || null === (r = r.javascript) || void 0 === r ? void 0 : r.code_version) || t.codeVersion || t.code_version || (null === (n = t.payload) || void 0 === n || null === (n = n.client) || void 0 === n || null === (n = n.javascript) || void 0 === n ? void 0 : n.code_version) || (null === (o = t.payload) || void 0 === o ? void 0 : o.code_version) || (null === (i = t.payload) || void 0 === i ? void 0 : i.codeVersion);
                        this.setSessionAttributes({
                            "rollbar.codeVersion": s,
                            "rollbar.notifier.name": "rollbar-browser-js",
                            "rollbar.notifier.version": t.version
                        });
                    }
                },
                {
                    key: "captureDomContentLoaded",
                    value: function(t, e) {
                        return e || (e = new Date), this.client.captureDomContentLoaded(e);
                    }
                },
                {
                    key: "captureLoad",
                    value: function(t, e) {
                        return e || (e = new Date), this.client.captureLoad(e);
                    }
                },
                {
                    key: "loadFull",
                    value: function() {
                        Ct.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
                    }
                },
                {
                    key: "_createItem",
                    value: function(t) {
                        return _(t, Ct, this);
                    }
                }
            ], [
                {
                    key: "init",
                    value: function(e, r) {
                        return kn ? kn.global(e).configure(e) : kn = new t(e, r);
                    }
                },
                {
                    key: "setComponents",
                    value: function(e) {
                        t.prototype.components = e;
                    }
                },
                {
                    key: "callInstance",
                    value: function(t, e) {
                        if (kn) return kn[t].apply(kn, e);
                        var r = "Rollbar is not initialized";
                        Ct.error(r);
                        var n = function(t) {
                            for(var e = 0, r = t.length; e < r; ++e)if (u(t[e])) return t[e];
                            return;
                        }(e);
                        n && n(new Error(r));
                    }
                }
            ]);
        }();
        function _n() {
            return "undefined" != typeof window && window || "undefined" != typeof self && self;
        }
        pn = Sn, gn(Sn, "global", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("global", e);
        }), gn(Sn, "configure", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("configure", e);
        }), gn(Sn, "lastError", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("lastError", e);
        }), gn(Sn, "log", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("log", e);
        }), gn(Sn, "debug", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("debug", e);
        }), gn(Sn, "info", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("info", e);
        }), gn(Sn, "warn", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("warn", e);
        }), gn(Sn, "warning", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("warning", e);
        }), gn(Sn, "error", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("error", e);
        }), gn(Sn, "critical", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("critical", e);
        }), gn(Sn, "buildJsonPayload", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("buildJsonPayload", e);
        }), gn(Sn, "sendJsonPayload", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("sendJsonPayload", e);
        }), gn(Sn, "wrap", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("wrap", e);
        }), gn(Sn, "captureEvent", function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            return pn.callInstance("captureEvent", e);
        });
        var On = {
            environment: "unknown",
            version: Ue,
            scrubFields: Wr.scrubFields,
            logLevel: Fe,
            reportLevel: Je,
            uncaughtErrorLevel: Ve,
            endpoint: He,
            verbose: !1,
            enabled: !0,
            transmit: !0,
            sendConfig: !1,
            includeItemsInTelemetry: !0,
            captureIp: !0,
            inspectAnonymousErrors: !0,
            ignoreDuplicateErrors: !0,
            wrapGlobalEventHandlers: !1,
            replay: {
                enabled: !1,
                autoStart: !0,
                triggerDefaults: {
                    samplingRatio: 1,
                    preDuration: 300,
                    postDuration: 5
                },
                triggers: [
                    {
                        type: "occurrence",
                        level: [
                            "error",
                            "critical"
                        ]
                    }
                ],
                debug: {
                    logErrors: !0,
                    logEmits: !1
                },
                inlineStylesheet: !0,
                inlineImages: !1,
                collectFonts: !0,
                maskInputOptions: {
                    password: !0,
                    email: !1,
                    tel: !1,
                    text: !1,
                    color: !1,
                    date: !1,
                    "datetime-local": !1,
                    month: !1,
                    number: !1,
                    range: !1,
                    search: !1,
                    time: !1,
                    url: !1,
                    week: !1
                },
                maskAllInputs: !1,
                blockClass: "rb-block",
                maskTextClass: "rb-mask",
                ignoreClass: "rb-ignore",
                slimDOMOptions: {
                    script: !0,
                    comment: !0,
                    headFavicon: !0,
                    headWhitespace: !0,
                    headMetaDescKeywords: !0,
                    headMetaSocial: !0,
                    headMetaRobots: !0,
                    headMetaHttpEquiv: !0,
                    headMetaAuthorship: !0,
                    headMetaVerification: !0
                }
            },
            tracing: {
                enabled: !1,
                endpoint: "api.rollbar.com/api/1/session/"
            }
        }, xn = Sn;
        function En(t) {
            return "string" != typeof t && (t = String(t)), t.toLowerCase();
        }
        function jn(t) {
            this.map = {}, t instanceof jn ? t.forEach(function(t, e) {
                this.append(e, t);
            }, this) : Array.isArray(t) ? t.forEach(function(t) {
                this.append(t[0], t[1]);
            }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                this.append(e, t[e]);
            }, this);
        }
        jn.prototype.append = function(t, e) {
            t = En(t), e = function(t) {
                return "string" != typeof t && (t = String(t)), t;
            }(e);
            var r = this.map[t];
            this.map[t] = r ? r + ", " + e : e;
        }, jn.prototype.get = function(t) {
            return t = En(t), this.has(t) ? this.map[t] : null;
        }, jn.prototype.has = function(t) {
            return c(this.map, En(t));
        }, jn.prototype.forEach = function(t, e) {
            for(var r in this.map)c(this.map, r) && t.call(e, this.map[r], r, this);
        }, jn.prototype.entries = function() {
            var t = [];
            return this.forEach(function(e, r) {
                t.push([
                    r,
                    e
                ]);
            }), function(t) {
                return {
                    next: function() {
                        var e = t.shift();
                        return {
                            done: void 0 === e,
                            value: e
                        };
                    }
                };
            }(t);
        };
        var In = function(t) {
            return "undefined" == typeof Headers ? new jn(t) : new Headers(t);
        };
        var Tn = function(t, e, r, n, o) {
            var i = t[e];
            t[e] = r(i), n && n[o].push([
                t,
                e,
                i
            ]);
        };
        function Pn(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return An(t, e);
                        var r = ({}).toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? An(t, e) : void 0;
                    }
                }(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function An(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        function Rn(t) {
            return function(t) {
                for(var e, r, n = [], o = 0, i = t.length - 1; i >= 0; i--){
                    if (e = Cn(t[i]), r = o + 3 * n.length + e.length, i < t.length - 1 && r >= 83) {
                        n.unshift("...");
                        break;
                    }
                    n.unshift(e), o += e.length;
                }
                return n.join(" > ");
            }(function(t) {
                for(var e, r = [], n = 0; t && n < 5 && (e = Ln(t)) && "html" !== e.tagName; n++)r.unshift(e), t = t.parentNode;
                return r;
            }(t));
        }
        function Cn(t) {
            if (!t || !t.tagName) return "";
            var e = [
                t.tagName
            ];
            t.id && e.push("#" + t.id), t.classes && e.push("." + t.classes.join("."));
            var r, n = Pn(t.attributes);
            try {
                for(n.s(); !(r = n.n()).done;){
                    var o = r.value;
                    e.push("[" + o.key + '="' + o.value + '"]');
                }
            } catch (t) {
                n.e(t);
            } finally{
                n.f();
            }
            return e.join("");
        }
        function Ln(t) {
            if (!t || !t.tagName) return null;
            var e, r = {};
            r.tagName = t.tagName.toLowerCase(), t.id && (r.id = t.id), (e = t.className) && "string" == typeof e && (r.classes = e.split(/\s+/));
            r.attributes = [];
            for(var n = 0, o = [
                "type",
                "name",
                "title",
                "alt"
            ]; n < o.length; n++){
                var i = o[n], a = t.getAttribute(i);
                a && r.attributes.push({
                    key: i,
                    value: a
                });
            }
            return r;
        }
        function qn(t) {
            return qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, qn(t);
        }
        function Nn(t) {
            return function(t) {
                if (Array.isArray(t)) return Fn(t);
            }(t) || function(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || Hn(t) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
        }
        function Dn(t, e) {
            for(var r = 0; r < e.length; r++){
                var n = e[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Mn(n.key), n);
            }
        }
        function Mn(t) {
            var e = function(t, e) {
                if ("object" != qn(t) || !t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var n = r.call(t, e || "default");
                    if ("object" != qn(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === e ? String : Number)(t);
            }(t, "string");
            return "symbol" == qn(e) ? e : e + "";
        }
        function Un(t, e) {
            var r = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!r) {
                if (Array.isArray(t) || (r = Hn(t)) || e && t && "number" == typeof t.length) {
                    r && (t = r);
                    var n = 0, o = function() {};
                    return {
                        s: o,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            };
                        },
                        e: function(t) {
                            throw t;
                        },
                        f: o
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i, a = !0, s = !1;
            return {
                s: function() {
                    r = r.call(t);
                },
                n: function() {
                    var t = r.next();
                    return a = t.done, t;
                },
                e: function(t) {
                    s = !0, i = t;
                },
                f: function() {
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (s) throw i;
                    }
                }
            };
        }
        function Hn(t, e) {
            if (t) {
                if ("string" == typeof t) return Fn(t, e);
                var r = ({}).toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Fn(t, e) : void 0;
            }
        }
        function Fn(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var r = 0, n = Array(e); r < e; r++)n[r] = t[r];
            return n;
        }
        var Jn = {
            network: !0,
            networkResponseHeaders: !1,
            networkResponseBody: !1,
            networkRequestHeaders: !1,
            networkRequestBody: !1,
            networkErrorOnHttp5xx: !1,
            networkErrorOnHttp4xx: !1,
            networkErrorOnHttp0: !1,
            log: !0,
            dom: !0,
            navigation: !0,
            connectivity: !0,
            contentSecurityPolicy: !0,
            errorOnContentSecurityPolicy: !1
        };
        function Vn(t, e) {
            for(var r; t[e].length;)(r = t[e].shift())[0][r[1]] = r[2];
        }
        function Bn(t) {
            var e, r = [], n = Un(t);
            try {
                for(n.s(); !(e = n.n()).done;){
                    var o = e.value;
                    r.push(new RegExp(o, "i"));
                }
            } catch (t) {
                n.e(t);
            } finally{
                n.f();
            }
            return function(t) {
                var e = function(t) {
                    if (!t || !t.attributes) return null;
                    var e, r = Un(t.attributes);
                    try {
                        for(r.s(); !(e = r.n()).done;){
                            var n = e.value;
                            if ("name" === n.key) return n.value;
                        }
                    } catch (t) {
                        r.e(t);
                    } finally{
                        r.f();
                    }
                    return null;
                }(t);
                if (!e) return !1;
                for(var n = 0, o = r; n < o.length; n++){
                    if (o[n].test(e)) return !0;
                }
                return !1;
            };
        }
        var Wn = function() {
            return function(t, e, r) {
                return e && Dn(t.prototype, e), r && Dn(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }(function t(e, r, n, o, i) {
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), function(t, e, r) {
                    (e = Mn(e)) in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r;
                }(this, "deinstrumentConnectivity", function() {
                    this.removeListeners("connectivity");
                }), this.options = e;
                var s = e.autoInstrument;
                !1 === e.enabled || !1 === s ? this.autoInstrument = {} : (a(s, "object") || (s = Jn), this.autoInstrument = R(Jn, s)), this.configureScrubbing(), this.telemeter = r, this.rollbar = n, this.diagnostic = n.client.notifier.diagnostic, this._window = o || {}, this._document = i || {}, this.replacements = {
                    network: [],
                    log: [],
                    navigation: [],
                    connectivity: []
                }, this.eventRemovers = {
                    dom: [],
                    connectivity: [],
                    contentsecuritypolicy: []
                }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
            }, [
                {
                    key: "configureScrubbing",
                    value: function() {
                        var t, e, r, n, o, i, a, s, u, l, c = this.options;
                        this.scrubTelemetryInputs = Boolean(null !== (t = c.scrubTelemetryInputs) && void 0 !== t ? t : null === (e = c.replay) || void 0 === e ? void 0 : e.maskAllInputs), this.telemetryScrubber = c.telemetryScrubber, this.defaultValueScrubber = Bn(c.scrubFields), this.maskInputFn = null === (r = c.replay) || void 0 === r ? void 0 : r.maskInputFn, this.maskInputOptions = (null === (n = c.replay) || void 0 === n ? void 0 : n.maskInputOptions) || {}, this.scrubClasses = [
                            null === (o = c.replay) || void 0 === o ? void 0 : o.blockClass,
                            null === (i = c.replay) || void 0 === i ? void 0 : i.ignoreClass,
                            null === (a = c.replay) || void 0 === a ? void 0 : a.maskTextClass
                        ].filter(Boolean), this.scrubSelectors = [
                            null === (s = c.replay) || void 0 === s ? void 0 : s.blockSelector,
                            null === (u = c.replay) || void 0 === u ? void 0 : u.ignoreSelector,
                            null === (l = c.replay) || void 0 === l ? void 0 : l.maskTextSelector
                        ].filter(Boolean);
                    }
                },
                {
                    key: "configure",
                    value: function(t) {
                        this.options = R(this.options, t);
                        var e = t.autoInstrument, r = R(this.autoInstrument);
                        !1 === t.enabled || !1 === e ? this.autoInstrument = {} : (a(e, "object") || (e = Jn), this.autoInstrument = R(Jn, e)), this.configureScrubbing(), this.instrument(r);
                    }
                },
                {
                    key: "instrument",
                    value: function(t) {
                        !this.autoInstrument.network || t && t.network ? !this.autoInstrument.network && t && t.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || t && t.log ? !this.autoInstrument.log && t && t.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || t && t.dom ? !this.autoInstrument.dom && t && t.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || t && t.navigation ? !this.autoInstrument.navigation && t && t.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || t && t.connectivity ? !this.autoInstrument.connectivity && t && t.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || t && t.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && t && t.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
                    }
                },
                {
                    key: "deinstrumentNetwork",
                    value: function() {
                        Vn(this.replacements, "network");
                    }
                },
                {
                    key: "instrumentNetwork",
                    value: function() {
                        var t = this;
                        function e(e, r) {
                            e in r && u(r[e]) && Tn(r, e, function(e) {
                                return t.rollbar.wrap(e);
                            });
                        }
                        if ("XMLHttpRequest" in this._window) {
                            var r = this._window.XMLHttpRequest.prototype;
                            Tn(r, "open", function(t) {
                                return function(e, r) {
                                    var n = $n(r);
                                    return (a(r, "string") || n) && (r = n ? r.toString() : r, this.__rollbar_xhr ? (this.__rollbar_xhr.method = e, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = P(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                        method: e,
                                        url: r,
                                        status_code: null,
                                        start_time_ms: P(),
                                        end_time_ms: null
                                    }), t.apply(this, arguments);
                                };
                            }, this.replacements, "network"), Tn(r, "setRequestHeader", function(e) {
                                return function(r, n) {
                                    return this.__rollbar_xhr || (this.__rollbar_xhr = {}), a(r, "string") && a(n, "string") && (t.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = n), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = n)), e.apply(this, arguments);
                                };
                            }, this.replacements, "network"), Tn(r, "send", function(r) {
                                return function(n) {
                                    var o, i, a = this, s = null === (o = t.rollbar) || void 0 === o ? void 0 : o.tracing;
                                    if (C(t.options, s, null === (i = a.__rollbar_xhr) || void 0 === i ? void 0 : i.url)) try {
                                        a.setRequestHeader("baggage", "rollbar.session.id=".concat(s.sessionId));
                                    } catch (t) {}
                                    function l() {
                                        if (a.__rollbar_xhr && (null === a.__rollbar_xhr.status_code && (a.__rollbar_xhr.status_code = 0, t.autoInstrument.networkRequestBody && (a.__rollbar_xhr.request = n), a.__rollbar_event = t.captureNetwork(a.__rollbar_xhr, "xhr", void 0)), a.readyState < 2 && (a.__rollbar_xhr.start_time_ms = P()), a.readyState > 3)) {
                                            var e = P();
                                            a.__rollbar_xhr.end_time_ms = e;
                                            var r = null;
                                            if (a.__rollbar_xhr.response_content_type = a.getResponseHeader("Content-Type"), t.autoInstrument.networkResponseHeaders) {
                                                var o = t.autoInstrument.networkResponseHeaders;
                                                r = {};
                                                try {
                                                    var i;
                                                    if (!0 === o) {
                                                        var s = a.getAllResponseHeaders();
                                                        if (s) {
                                                            var u, l, c, f = Un(s.trim().split(/[\r\n]+/));
                                                            try {
                                                                for(f.s(); !(c = f.n()).done;)i = (u = c.value.split(": ")).shift(), l = u.join(": "), r[i] = l;
                                                            } catch (t) {
                                                                f.e(t);
                                                            } finally{
                                                                f.f();
                                                            }
                                                        }
                                                    } else {
                                                        var p, d = Un(o);
                                                        try {
                                                            for(d.s(); !(p = d.n()).done;){
                                                                var h = p.value;
                                                                r[h] = a.getResponseHeader(h);
                                                            }
                                                        } catch (t) {
                                                            d.e(t);
                                                        } finally{
                                                            d.f();
                                                        }
                                                    }
                                                } catch (t) {}
                                            }
                                            var y = null;
                                            if (t.autoInstrument.networkResponseBody) try {
                                                y = a.responseText;
                                            } catch (t) {}
                                            var v = null;
                                            (y || r) && (v = {}, y && (t.isJsonContentType(a.__rollbar_xhr.response_content_type) ? v.body = t.scrubJson(y) : v.body = y), r && (v.headers = r)), v && (a.__rollbar_xhr.response = v);
                                            try {
                                                var m = a.status;
                                                m = 1223 === m ? 204 : m, a.__rollbar_xhr.status_code = m, t.addOtelNetworkResponse(a.__rollbar_event, e, m), a.__rollbar_event.level = t.telemeter.levelFromStatus(m), t.errorOnHttpStatus(a.__rollbar_xhr);
                                            } catch (t) {}
                                        }
                                    }
                                    return e("onload", a), e("onerror", a), e("onprogress", a), "onreadystatechange" in a && u(a.onreadystatechange) ? Tn(a, "onreadystatechange", function(e) {
                                        return t.rollbar.wrap(e, void 0, l);
                                    }) : a.onreadystatechange = l, a.__rollbar_xhr && t.trackHttpErrors() && (a.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                                };
                            }, this.replacements, "network");
                        }
                        "fetch" in this._window && Tn(this._window, "fetch", function(e) {
                            return function(r, n) {
                                var o, i, s = Array.prototype.slice.call(arguments), u = s[0], l = "GET", c = $n(u);
                                a(u, "string") || c ? i = c ? u.toString() : u : u && (i = u.url, u.method && (l = u.method)), s[1] && s[1].method && (l = s[1].method);
                                var f = null === (o = t.rollbar) || void 0 === o ? void 0 : o.tracing;
                                C(t.options, f, i) && L(s, {
                                    baggage: "rollbar.session.id=".concat(f.sessionId)
                                });
                                var p = {
                                    method: l,
                                    url: i,
                                    status_code: null,
                                    start_time_ms: P(),
                                    end_time_ms: null
                                };
                                if (s[1] && s[1].headers) {
                                    var d = In(s[1].headers);
                                    p.request_content_type = d.get("Content-Type"), t.autoInstrument.networkRequestHeaders && (p.request_headers = t.fetchHeaders(d, t.autoInstrument.networkRequestHeaders));
                                }
                                t.autoInstrument.networkRequestBody && (s[1] && s[1].body ? p.request = s[1].body : s[0] && !a(s[0], "string") && s[0].body && (p.request = s[0].body));
                                var h = t.captureNetwork(p, "fetch", void 0);
                                return t.trackHttpErrors() && (p.stack = (new Error).stack), e.apply(this, s).then(function(e) {
                                    var r = P();
                                    p.end_time_ms = r, p.status_code = e.status, t.addOtelNetworkResponse(h, r, e.status), p.response_content_type = e.headers.get("Content-Type");
                                    var n = null;
                                    t.autoInstrument.networkResponseHeaders && (n = t.fetchHeaders(e.headers, t.autoInstrument.networkResponseHeaders));
                                    var o = null;
                                    return t.autoInstrument.networkResponseBody && "function" == typeof e.text && (o = e.clone().text()), (n || o) && (p.response = {}, o && ("function" == typeof o.then ? o.then(function(e) {
                                        e && t.isJsonContentType(p.response_content_type) ? p.response.body = t.scrubJson(e) : p.response.body = e;
                                    }) : p.response.body = o), n && (p.response.headers = n)), t.errorOnHttpStatus(p), e;
                                });
                            };
                        }, this.replacements, "network");
                    }
                },
                {
                    key: "captureNetwork",
                    value: function(t, e, r) {
                        return t.request && this.isJsonContentType(t.request_content_type) && (t.request = this.scrubJson(t.request)), this.telemeter.captureNetwork(t, e, r);
                    }
                },
                {
                    key: "isJsonContentType",
                    value: function(t) {
                        return !!(t && a(t, "string") && t.toLowerCase().includes("json"));
                    }
                },
                {
                    key: "addOtelNetworkResponse",
                    value: function(t, e, r) {
                        t.otelAttributes && (t.otelAttributes["response.timeUnixNano"] = (1e6 * e).toString(), t.otelAttributes.statusCode = r);
                    }
                },
                {
                    key: "scrubJson",
                    value: function(t) {
                        return JSON.stringify(F(JSON.parse(t), this.options.scrubFields));
                    }
                },
                {
                    key: "fetchHeaders",
                    value: function(t, e) {
                        var r = {};
                        try {
                            if (!0 === e) {
                                if ("function" == typeof t.entries) for(var n = t.entries(), o = n.next(); !o.done;)r[o.value[0]] = o.value[1], o = n.next();
                            } else {
                                var i, a = Un(e);
                                try {
                                    for(a.s(); !(i = a.n()).done;){
                                        var s = i.value;
                                        r[s] = t.get(s);
                                    }
                                } catch (t) {
                                    a.e(t);
                                } finally{
                                    a.f();
                                }
                            }
                        } catch (t) {}
                        return r;
                    }
                },
                {
                    key: "trackHttpErrors",
                    value: function() {
                        return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
                    }
                },
                {
                    key: "errorOnHttpStatus",
                    value: function(t) {
                        var e = t.status_code;
                        if (e >= 500 && this.autoInstrument.networkErrorOnHttp5xx || e >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === e && this.autoInstrument.networkErrorOnHttp0) {
                            var r = new Error("HTTP request failed with Status " + e);
                            r.stack = t.stack, this.rollbar.error(r, {
                                skipFrames: 1
                            });
                        }
                    }
                },
                {
                    key: "deinstrumentConsole",
                    value: function() {
                        for(var t; this.replacements.log.length;)t = this.replacements.log.shift(), this._window.console[t[0]] = t[1];
                    }
                },
                {
                    key: "instrumentConsole",
                    value: function() {
                        var t;
                        if (null !== (t = this._window) && void 0 !== t && null !== (t = t.console) && void 0 !== t && t.log) {
                            var e = this, r = this._window.console;
                            try {
                                for(var n = 0, o = [
                                    "debug",
                                    "info",
                                    "warn",
                                    "error",
                                    "log"
                                ]; n < o.length; n++)i(o[n]);
                            } catch (t) {
                                this.diagnostic.instrumentConsole = {
                                    error: t.message
                                };
                            }
                        }
                        function i(t) {
                            var n = r[t], o = r, i = "warn" === t ? "warning" : t;
                            r[t] = function() {
                                var t = Array.prototype.slice.call(arguments), r = function(t) {
                                    var e, r, n, o = [];
                                    for(e = 0, r = t.length; e < r; ++e){
                                        switch(s(n = t[e])){
                                            case "object":
                                                (n = (n = b(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                                break;
                                            case "null":
                                                n = "null";
                                                break;
                                            case "undefined":
                                                n = "undefined";
                                                break;
                                            case "symbol":
                                                n = n.toString();
                                        }
                                        o.push(n);
                                    }
                                    return o.join(" ");
                                }(t);
                                e.telemeter.captureLog(r, i, null, P()), n && Function.prototype.apply.call(n, o, t);
                            }, e.replacements.log.push([
                                t,
                                n
                            ]);
                        }
                    }
                },
                {
                    key: "deinstrumentDom",
                    value: function() {
                        this.removeListeners("dom");
                    }
                },
                {
                    key: "instrumentDom",
                    value: function() {
                        var t = this;
                        this.addListener("dom", this._window, [
                            "click",
                            "dblclick",
                            "contextmenu"
                        ], function(e) {
                            return t.handleEvent("click", e);
                        }), this.addListener("dom", this._window, [
                            "dragstart",
                            "dragend",
                            "dragenter",
                            "dragleave",
                            "drop"
                        ], function(e) {
                            return t.handleEvent("dragdrop", e);
                        }), this.addListener("dom", this._window, [
                            "blur",
                            "focus"
                        ], function(e) {
                            return t.handleEvent("focus", e);
                        }), this.addListener("dom", this._window, [
                            "submit",
                            "invalid"
                        ], function(e) {
                            return t.handleEvent("form", e);
                        }), this.addListener("dom", this._window, [
                            "input",
                            "change"
                        ], function(e) {
                            return t.handleEvent("input", e);
                        }), this.addListener("dom", this._window, [
                            "resize"
                        ], function(e) {
                            return t.handleEvent("resize", e);
                        }), this.addListener("dom", this._document, [
                            "DOMContentLoaded"
                        ], function(e) {
                            return t.handleEvent("contentLoaded", e);
                        });
                    }
                },
                {
                    key: "handleEvent",
                    value: function(t, e) {
                        try {
                            return ({
                                click: this.handleClick,
                                dragdrop: this.handleDrag,
                                focus: this.handleFocus,
                                form: this.handleForm,
                                input: this.handleInput,
                                resize: this.handleResize,
                                contentLoaded: this.handleContentLoaded
                            })[t].call(this, e);
                        } catch (r) {
                            Ct.log("".concat(t, " handler error"), e, r, r.stack);
                        }
                    }
                },
                {
                    key: "handleContentLoaded",
                    value: function(t) {
                        this.rollbar.triggerReplay({
                            type: "navigation",
                            path: new URL(this._location.href).pathname
                        });
                    }
                },
                {
                    key: "handleClick",
                    value: function(t) {
                        var e, r = null === (e = t.target) || void 0 === e ? void 0 : e.tagName.toLowerCase();
                        [
                            "input",
                            "select",
                            "textarea"
                        ].includes(r) || this.telemeter.captureClick({
                            type: t.type,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleFocus",
                    value: function(t) {
                        var e, r = t.type, n = null !== (e = t.target) && void 0 !== e && e.window ? "window" : Rn(t.target);
                        this.telemeter.captureFocus({
                            type: r,
                            isSynthetic: !t.isTrusted,
                            element: n,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleForm",
                    value: function(t) {}
                },
                {
                    key: "handleResize",
                    value: function(t) {
                        var e = window.screen.width / window.innerWidth;
                        this.telemeter.captureResize({
                            type: t.type,
                            isSynthetic: !t.isTrusted,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            textZoomRatio: e,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleDrag",
                    value: function(t) {
                        var e, r, n, o, i, a, s = t.type;
                        if ("drop" === s) {
                            e = [], r = [];
                            var u, l = Un([].concat(Nn(t.dataTransfer.files), Nn(t.dataTransfer.items)));
                            try {
                                for(l.s(); !(u = l.n()).done;){
                                    var c = u.value;
                                    c.kind && c.type && (e.push(c.kind), r.push(c.type));
                                }
                            } catch (t) {
                                l.e(t);
                            } finally{
                                l.f();
                            }
                        }
                        [
                            "drop",
                            "dragstart"
                        ].includes(s) && (n = null === (i = t.dataTransfer) || void 0 === i ? void 0 : i.dropEffect, o = null === (a = t.dataTransfer) || void 0 === a ? void 0 : a.effectAllowed);
                        this.telemeter.captureDragDrop({
                            type: s,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            dropEffect: n,
                            effectAllowed: o,
                            kinds: JSON.stringify(e),
                            mediaTypes: JSON.stringify(r),
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "scrubInputValue",
                    value: function(t, e, r, n) {
                        var o = "******";
                        if ("password" === n) return o;
                        if (this.scrubTelemetryInputs) return o;
                        var i = Ln(e);
                        if (this.telemetryScrubber) {
                            if (this.telemetryScrubber(i)) return o;
                        } else if (this.defaultValueScrubber(i)) return o;
                        return function(t, e, r) {
                            try {
                                var n, o = Pn(e);
                                try {
                                    for(o.s(); !(n = o.n()).done;){
                                        var i = n.value;
                                        if ("string" == typeof i) {
                                            if (t.classList.contains(i)) return !0;
                                        } else {
                                            var a, s = Pn(t.classList);
                                            try {
                                                for(s.s(); !(a = s.n()).done;){
                                                    var u = a.value;
                                                    if (i.test(u)) return !0;
                                                }
                                            } catch (t) {
                                                s.e(t);
                                            } finally{
                                                s.f();
                                            }
                                        }
                                    }
                                } catch (t) {
                                    o.e(t);
                                } finally{
                                    o.f();
                                }
                                var l, c = Pn(r);
                                try {
                                    for(c.s(); !(l = c.n()).done;){
                                        var f = l.value;
                                        if (t.matches(f)) return !0;
                                    }
                                } catch (t) {
                                    c.e(t);
                                } finally{
                                    c.f();
                                }
                            } catch (t) {}
                            return !1;
                        }(e, this.scrubClasses, this.scrubSelectors) ? o : this.maskInputOptions[r.toLowerCase()] || this.maskInputOptions[n] ? this.maskInputFn ? this.maskInputFn(t, e) : o : t;
                    }
                },
                {
                    key: "handleInput",
                    value: function(t) {
                        var e, r, n, o, i = t.type, a = null === (e = t.target) || void 0 === e ? void 0 : e.tagName.toLowerCase(), s = null === (r = t.target) || void 0 === r ? void 0 : r.value, u = (null === (n = t.target) || void 0 === n || null === (n = n.attributes) || void 0 === n || null === (n = n.type) || void 0 === n ? void 0 : n.value) || (null === (o = t.target) || void 0 === o ? void 0 : o.type);
                        switch(void 0 !== s && (s = this.scrubInputValue(s, t.target, a, u)), i){
                            case "input":
                                if ([
                                    "radio",
                                    "checkbox"
                                ].includes(u)) return;
                                [
                                    "select",
                                    "textarea"
                                ].includes(a) && (u = a);
                                break;
                            case "change":
                                if (![
                                    "radio",
                                    "checkbox"
                                ].includes(u)) return;
                                var l;
                                if ("checkbox" === u) s = null === (l = t.target) || void 0 === l ? void 0 : l.checked;
                        }
                        this.telemeter.captureInput({
                            type: u,
                            isSynthetic: !t.isTrusted,
                            element: Rn(t.target),
                            value: s,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "deinstrumentNavigation",
                    value: function() {
                        var t = this._window.chrome;
                        !(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState && Vn(this.replacements, "navigation");
                    }
                },
                {
                    key: "instrumentNavigation",
                    value: function() {
                        var t = this._window.chrome;
                        if (!(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState) {
                            var e = this;
                            Tn(this._window, "onpopstate", function(t) {
                                return function() {
                                    var r = e._location.href;
                                    e.handleUrlChange(e._lastHref, r), t && t.apply(this, arguments);
                                };
                            }, this.replacements, "navigation"), Tn(this._window.history, "pushState", function(t) {
                                return function() {
                                    var r = arguments.length > 2 ? arguments[2] : void 0;
                                    return r && e.handleUrlChange(e._lastHref, String(r)), t.apply(this, arguments);
                                };
                            }, this.replacements, "navigation");
                        }
                    }
                },
                {
                    key: "handleUrlChange",
                    value: function(t, e) {
                        var r = hn(this._location.href), n = hn(e), o = hn(t);
                        this._lastHref = e, r.protocol === n.protocol && r.host === n.host && (e = n.path + (n.hash || "")), r.protocol === o.protocol && r.host === o.host && (t = o.path + (o.hash || "")), this.telemeter.captureNavigation(t, e, null, P()), this.rollbar.triggerReplay({
                            type: "navigation",
                            path: e
                        });
                    }
                },
                {
                    key: "instrumentConnectivity",
                    value: function() {
                        var t = this;
                        this.addListener("connectivity", this._window, [
                            "online",
                            "offline"
                        ], function(e) {
                            return t.handleConnectivity(e);
                        });
                    }
                },
                {
                    key: "handleConnectivity",
                    value: function(t) {
                        var e = t.type;
                        this.telemeter.captureConnectivityChange({
                            type: e,
                            isSynthetic: !t.isTrusted,
                            timestamp: P()
                        });
                    }
                },
                {
                    key: "handleCspEvent",
                    value: function(t) {
                        var e = "Security Policy Violation: blockedURI: " + t.blockedURI + ", violatedDirective: " + t.violatedDirective + ", effectiveDirective: " + t.effectiveDirective + ", ";
                        t.sourceFile && (e += "location: " + t.sourceFile + ", line: " + t.lineNumber + ", col: " + t.columnNumber + ", "), e += "originalPolicy: " + t.originalPolicy, this.telemeter.captureLog(e, "error", null, P()), this.handleCspError(e);
                    }
                },
                {
                    key: "handleCspError",
                    value: function(t) {
                        this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(t);
                    }
                },
                {
                    key: "deinstrumentContentSecurityPolicy",
                    value: function() {
                        this.removeListeners("contentsecuritypolicy");
                    }
                },
                {
                    key: "instrumentContentSecurityPolicy",
                    value: function() {
                        if ("addEventListener" in this._document) {
                            var t = this.handleCspEvent.bind(this);
                            this.addListener("contentsecuritypolicy", this._document, [
                                "securitypolicyviolation"
                            ], t);
                        }
                    }
                },
                {
                    key: "addListener",
                    value: function(t, e, r, n) {
                        var o = this;
                        if (e.addEventListener) {
                            var i, a = Un(r);
                            try {
                                var s = function() {
                                    var r = i.value, a = {
                                        capture: !0,
                                        passive: !0
                                    };
                                    e.addEventListener(r, n, a, !0), o.eventRemovers[t].push(function() {
                                        e.removeEventListener(r, n, a);
                                    });
                                };
                                for(a.s(); !(i = a.n()).done;)s();
                            } catch (t) {
                                a.e(t);
                            } finally{
                                a.f();
                            }
                        }
                    }
                },
                {
                    key: "removeListeners",
                    value: function(t) {
                        for(; this.eventRemovers[t].length;)this.eventRemovers[t].shift()();
                    }
                }
            ]);
        }();
        function $n(t) {
            return "undefined" != typeof URL && t instanceof URL;
        }
        var Gn = Wn;
        function zn(t, e, r) {
            if (c(e, "addEventListener")) {
                for(var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                var o = function(e, r, o) {
                    n.call(this, e, t.wrap(r), o);
                };
                o._rollbarOldAdd = n, o.belongsToShim = r, e.addEventListener = o;
                for(var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;)i = i._rollbarOldRemove;
                var a = function(t, e, r) {
                    i.call(this, t, e && e._rollbar_wrapped || e, r);
                };
                a._rollbarOldRemove = i, a.belongsToShim = r, e.removeEventListener = a;
            }
        }
        var Xn = function(t, e, r) {
            if (t) {
                var n, o, i = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                for(n = 0; n < i.length; ++n)t[o = i[n]] && t[o].prototype && zn(e, t[o].prototype, r);
            }
        };
        xn.setComponents({
            telemeter: Y,
            instrumenter: Gn,
            wrapGlobals: Xn,
            scrub: F,
            truncation: we,
            tracing: se
        });
        var Zn = xn, Qn = "undefined" != typeof window && window._rollbarConfig, Kn = Qn && Qn.globalAlias || "Rollbar", Yn = "undefined" != typeof window && window[Kn] && "function" == typeof window[Kn].shimId && void 0 !== window[Kn].shimId();
        if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !Yn && Qn) {
            var to = new Zn(Qn);
            window[Kn] = to;
        } else "undefined" != typeof window ? (window.rollbar = Zn, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = Zn, self._rollbarDidLoad = !0);
        var eo = Zn;
        return e = e.default;
    }();
});

});

parcelRegister("dYhB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2be8730df5a6746$export$2e2bcd8739ae039; });
var $a2be8730df5a6746$export$2e2bcd8739ae039 = {
    methods: {
        fomatNumber (number) {
            return Math.round(number).toLocaleString();
        },
        formatMoney (amount) {
            return parseFloat(amount).toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
            });
        },
        formatDuration (seconds) {
            if (!seconds || seconds === 0) return "00:00:00";
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor(seconds % 3600 / 60);
            const secs = Math.floor(seconds % 60);
            return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
        },
        truncateString (string, maxLength = 30) {
            return string.length > maxLength ? string.substring(0, maxLength) + "..." : string;
        }
    }
};

});

var $98d98367185989f7$exports = {};
$parcel$extendImportMap({
    "kcvJj": "profile-ava.57aa4e54.png",
    "cShTd": "profile-lior.ea7d239c.png",
    "jDrMI": "profile-mup.3c175d48.png",
    "cMBvi": "profile-ramen-bot.568c9d37.png",
    "8XrDJ": "profile-rb.d614430f.png",
    "5Nw7p": "profile-zeke.c58e2a83.png",
    "1fvDk": "Login.db4e5760.js",
    "dpWbW": "color-logo.c9212d03.png",
    "7DLXJ": "Login.3a896433.css",
    "hFZg0": "cloud-bg.84134714.png",
    "8f0Xb": "NewSubscriptionView.1110b609.js",
    "cGp5f": "braintree-logo.0c641908.png",
    "3zPho": "NewSubscriptionView.d0072abf.js",
    "dxOnj": "browser.53cc6f8e.js",
    "intw5": "NewSubscriptionView.cc5db9af.js",
    "l62qd": "NewSubscriptionView.aad7fe96.css",
    "4LDM5": "NewGuardianSubscriptionView.187a648e.js",
    "lnftg": "NewGuardianSubscriptionView.11b3032c.css",
    "eTVK7": "EditGuardianSubscriptionView.c91847aa.js",
    "g82zY": "EditGuardianSubscriptionView.60507b9d.css",
    "6HzcB": "EditSubscriptionView.04e8e213.js",
    "jv44c": "EditSubscriptionView.5872d395.css",
    "cuLvG": "PaymentConfirmation.bf68b8dc.js",
    "4ff21": "post-purchase-icon.2868e7f2.png",
    "g88NN": "mup.d4ff2501.png",
    "3DX6x": "PaymentConfirmation.f0ae8467.css",
    "Dk2W1": "SignupView.99b405ba.js",
    "lXHaS": "SignupView.b8b6f8db.css",
    "dV4m1": "ForgotPasswordView.adfb406a.js",
    "ezcv4": "ForgotPasswordView.d5baa28c.css",
    "ig0MQ": "ResetPasswordView.615ae8a4.js",
    "bt150": "ResetPasswordView.d23f0dee.css",
    "8kZ9m": "CancelPlanView.80d20650.js",
    "jIjZD": "cancel-sub.30577bd8.png",
    "kjrYX": "ava-sitting-delete-account.0b454c53.png",
    "cB8Tc": "CancelPlanView.a636ab9a.css",
    "6H37U": "DeleteAccountView.b50471a2.js",
    "lD8Ue": "ava-delete-account.b44f2d8b.png",
    "b5O83": "ship.8e8875a5.png",
    "9Jfqr": "DeleteAccountView.493f2a9f.css",
    "3OSER": "AccountSetupView.7ff58dc6.js",
    "fHUMq": "setup-complete.15733187.png",
    "gogs1": "AccountSetupView.016bcdf9.css",
    "epYis": "MainLayoutView.9ac0ff21.js",
    "kec2e": "MainLayoutView.d4c32c56.js",
    "9MncU": "logo-no-text.f70b450e.png",
    "7MtjC": "play-on-web-badge.61ab15dd.png",
    "2lq38": "google-play-badge.c42a1001.png",
    "90CHN": "apple-app-store-badge.0250a319.png",
    "8Xqts": "MainLayoutView.c2dd4ba1.js",
    "aH4fU": "MainLayoutView.e91023b1.css",
    "idJDn": "Dashboard.1d1eeac0.js",
    "l83IP": "ava-subscribed.f8aee14d.png",
    "8OgkT": "trying-new-things-ending.61f9ecb5.png",
    "77hXc": "AdminGamePlayView.46de5aef.js",
    "3JNV7": "Dashboard.df71f79e.js",
    "iePaV": "Dashboard.358c2683.js",
    "9Rr97": "blank-profile.381414e6.png",
    "h4N9U": "Dashboard.67daec10.css",
    "cQTwu": "Dashboard.2c276f4c.js",
    "5gbmp": "Dashboard.55ca6bbd.css",
    "fnjjc": "CurriculumView.dc07925e.js",
    "13cZQ": "CurriculumView.4e56cb6f.css",
    "aV3W7": "ImplementationQuizView.9d6d5687.js",
    "9F58g": "ImplementationQuizView.68e81cdf.css",
    "08NZw": "ImplementationPlanView.7b2aa0ed.js",
    "5eEo6": "ImplementationPlanView.cb39c8c3.css",
    "cHUf7": "LessonPlanView.342087b9.js",
    "2PfFv": "LessonPlanView.a4c88fca.css",
    "8jyt8": "LessonView.c8691d2c.js",
    "fpIAy": "LessonView.86b62aa0.css",
    "973YF": "ModuleLibrary.125aa7da.js",
    "gfVUN": "ModuleLibrary.d88c7e18.css",
    "1RVLY": "ModuleView.61988012.js",
    "frP0l": "ModuleView.536f6dca.css",
    "l9uO6": "NewsResources.c3e368b9.js",
    "6C6Fw": "NewsResources.300903a0.css",
    "cslPk": "HelpAndGuides.17e38ed9.js",
    "50Tz1": "HelpAndGuides.628d4663.css",
    "ek08q": "StudentView.9f595eee.js",
    "l597n": "AdminLessonPlanEditView.fcd81a85.js",
    "jyZFS": "StudentView.0930f38c.css",
    "1FsqH": "StudentView.931ca423.js",
    "933zF": "StudentActivityHistoryView.101b87f0.js",
    "1BbE3": "StudentActivityHistoryView.ac106359.js",
    "jXWTS": "StudentActivityHistoryView.62203847.css",
    "gU8SW": "StudentActivityHistoryView.8445e157.css",
    "4rwud": "StreamingView.7821f08d.js",
    "7ExBf": "StreamingView.600243c0.css",
    "aTwtD": "ClassRoomView.3964366f.js",
    "hMOiY": "ClassRoomView.b3ce5d54.css",
    "7uOA6": "StudentArchiveView.2e147792.js",
    "a4Lfl": "StudentArchiveView.e0041a00.css",
    "77Z8e": "GroupManagementView.8c25975b.js",
    "cAxGk": "AdminHomeView.1a3bc4a2.js",
    "2pXv1": "GroupManagementView.48962c25.css",
    "47jHZ": "GroupAdvisorDetailView.01af4396.js",
    "gdOmH": "GroupAdvisorDetailView.d46db662.css",
    "h7dLs": "GroupStudentDetailView.a10d15f8.js",
    "fwVdb": "GroupStudentDetailView.5a59b8f2.css",
    "1D4cW": "GroupClassroomDetailView.46f88987.js",
    "grxPc": "GroupClassroomDetailView.77d9aa7d.css",
    "gXnnp": "NotFoundView.3a4502f3.js",
    "61TeB": "ava-survey.37e565e5.png",
    "j6qAY": "NotFoundView.d80cf7e5.css"
});

parcelRequire("bnAYy");
var $aRSfV = parcelRequire("aRSfV");
var $50c58d9d3871d1d7$export$443cccf96c2700ac = /^(GTM|G)-[0-9A-Z]+$/;
function $50c58d9d3871d1d7$export$feae9699863a9c74(r) {
    if (typeof r != "string" || !$50c58d9d3871d1d7$export$443cccf96c2700ac.test(r)) {
        let t = String(r).toUpperCase().replace(/.*-|[^0-9A-Z]/g, ""), a = t.length === 0 ? "" : ` Did you mean 'GTM-${t}' or 'G-${t}'?`;
        throw new Error(`'${r}' is not a valid GTM-ID (${$50c58d9d3871d1d7$export$443cccf96c2700ac}).${a}`);
    }
}
function $50c58d9d3871d1d7$var$n(r, t = "dataLayer") {
    return r[t] || (r[t] = []), r[t];
}
function $50c58d9d3871d1d7$export$2cb99e4be0dc4646(r, t) {
    let a = document, e = a.createElement("script"), o = (g)=>{
        t.onReady?.({
            id: r,
            script: e
        }), e.removeEventListener("load", o);
    };
    e.addEventListener("load", o);
    let i = t.dataLayerName ?? "dataLayer";
    if ($50c58d9d3871d1d7$var$n(window, i).push({
        event: "gtm.js",
        "gtm.start": new Date().getTime()
    }), !r) return e;
    e.async = !t.defer, e.defer = !!(t.defer || t.compatibility), t.nonce && e.setAttribute("nonce", t.nonce), t.scriptType && (e.type = t.scriptType);
    let c = new URLSearchParams({
        id: r,
        ...t.dataLayerName ? {
            l: t.dataLayerName
        } : {},
        ...t.queryParams ?? {}
    }), d = t.source ?? "https://www.googletagmanager.com/gtm.js";
    e.src = `${d}?${c}`;
    let l = t.parentElement ?? a.body;
    if (typeof l?.appendChild != "function") throw new Error("parentElement must be a DOM element");
    return l.appendChild(e), e;
}
function $50c58d9d3871d1d7$export$54a2a28e692b911e(r = "https://www.googletagmanager.com/gtm.js") {
    return Array.from(document.getElementsByTagName("script")).some((t)=>t.src.includes(r));
}
var $50c58d9d3871d1d7$export$7c3fe145217664b7 = class {
    id;
    options;
    scriptElements = [];
    constructor(t){
        if (Array.isArray(t.id)) for (let a of t.id)typeof a == "string" ? $50c58d9d3871d1d7$export$feae9699863a9c74(a) : $50c58d9d3871d1d7$export$feae9699863a9c74(a.id);
        else $50c58d9d3871d1d7$export$feae9699863a9c74(t.id);
        this.id = t.id, this.options = {
            enabled: !0,
            debug: !1,
            loadScript: !0,
            defer: !1,
            compatibility: !1,
            dataLayerName: "dataLayer",
            ...t
        }, delete this.options.id;
    }
    isInBrowserContext = ()=>typeof window < "u";
    enabled() {
        return this.options.enabled ?? !0;
    }
    enable(t = !0, a) {
        if (this.options.enabled = t, this.isInBrowserContext() && t && !$50c58d9d3871d1d7$export$54a2a28e692b911e(a) && this.options.loadScript) {
            if (Array.isArray(this.id)) this.id.forEach((e)=>{
                let o;
                typeof e == "string" ? o = $50c58d9d3871d1d7$export$2cb99e4be0dc4646(e, {
                    ...this.options
                }) : o = $50c58d9d3871d1d7$export$2cb99e4be0dc4646(e.id, {
                    ...this.options,
                    queryParams: e.queryParams
                }), this.scriptElements.push(o);
            });
            else {
                let e = $50c58d9d3871d1d7$export$2cb99e4be0dc4646(this.id, {
                    ...this.options
                });
                this.scriptElements.push(e);
            }
        }
    }
    debugEnabled() {
        return this.options.debug ?? !1;
    }
    debug(t) {
        this.options.debug = t;
    }
    dataLayer() {
        return this.isInBrowserContext() && this.options.enabled ? $50c58d9d3871d1d7$var$n(window, this.options.dataLayerName) : !1;
    }
    trackView(t, a, e = {}) {
        let o = this.isInBrowserContext() && (this.options.enabled ?? !1);
        this.options.debug && console.log(`[GTM-Support${o ? "" : "(disabled)"}]: Dispatching TrackView`, {
            screenName: t,
            path: a
        }), o && $50c58d9d3871d1d7$var$n(window, this.options.dataLayerName).push({
            ...e,
            event: this.options.trackViewEventProperty ?? "content-view",
            "content-name": a,
            "content-view-name": t
        });
    }
    trackEvent({ event: t, category: a = null, action: e = null, label: o = null, value: i = null, noninteraction: b = !1, ...c } = {}) {
        let d = this.isInBrowserContext() && (this.options.enabled ?? !1);
        this.options.debug && console.log(`[GTM-Support${d ? "" : "(disabled)"}]: Dispatching event`, {
            event: t,
            category: a,
            action: e,
            label: o,
            value: i,
            ...c
        }), d && $50c58d9d3871d1d7$var$n(window, this.options.dataLayerName).push({
            event: t ?? "interaction",
            target: a,
            action: e,
            "target-properties": o,
            value: i,
            "interaction-type": b,
            ...c
        });
    }
    push(t) {
        let a = this.isInBrowserContext() && (this.options.enabled ?? !1);
        this.options.debug && console.log(`[GTM-Support${a ? "" : "(disabled)"}]: Dispatching event`, t), a && $50c58d9d3871d1d7$var$n(window, this.options.dataLayerName).push(t);
    }
};


parcelRequire("bnAYy");
var $iZX2P = parcelRequire("iZX2P");
var $81551a3ae87d4df4$var$i;
function $81551a3ae87d4df4$var$c(a, t = {
    id: ""
}) {
    t = {
        trackOnNextTick: !1,
        ...t
    }, $81551a3ae87d4df4$var$i = new (0, $50c58d9d3871d1d7$export$7c3fe145217664b7)(t), a.config.globalProperties.$gtm = $81551a3ae87d4df4$var$i, $81551a3ae87d4df4$var$i.isInBrowserContext() && (t.vueRouter && $81551a3ae87d4df4$var$v(a, t.vueRouter, t.ignoredViews, t.trackOnNextTick, t.vueRouterAdditionalEventData), $81551a3ae87d4df4$var$i.options.enabled && $81551a3ae87d4df4$var$i.options.loadScript && (Array.isArray(t.id) ? t.id.forEach((r)=>{
        if (typeof r == "string") (0, $50c58d9d3871d1d7$export$2cb99e4be0dc4646)(r, t);
        else {
            let n = {
                ...t
            };
            r.queryParams != null && (n.queryParams = {
                ...n.queryParams,
                ...r.queryParams
            }), (0, $50c58d9d3871d1d7$export$2cb99e4be0dc4646)(r.id, n);
        }
    }) : (0, $50c58d9d3871d1d7$export$2cb99e4be0dc4646)(t.id, t))), a.provide("gtm", t);
}
function $81551a3ae87d4df4$var$v(a, t, r = [], n, g = ()=>({})) {
    function p(e, u) {
        return e instanceof Error ? !!(e.type & u) : !1;
    }
    t.afterEach(async (e, u, l)=>{
        if (typeof e.name != "string" || Array.isArray(r) && r.includes(e.name) || typeof r == "function" && r(e, u)) return;
        let s = e.meta && typeof e.meta.gtm == "string" && e.meta.gtm ? e.meta.gtm : e.name;
        p(l, 4) ? $81551a3ae87d4df4$var$i?.debugEnabled() && console.log(`[VueGtm]: '${s}' not tracked due to navigation aborted`) : p(l, 8) && $81551a3ae87d4df4$var$i?.debugEnabled() && console.log(`[VueGtm]: '${s}' not tracked due to navigation cancelled`);
        let d = {
            ...await g(e, u),
            ...e.meta?.gtmAdditionalEventData
        }, o = t.options?.history?.base ?? "";
        o.endsWith("/") || (o += "/"), o += e.fullPath.startsWith("/") ? e.fullPath.substring(1) : e.fullPath, n ? (0, $iZX2P.nextTick)(()=>{
            $81551a3ae87d4df4$var$i?.trackView(s, o, d);
        }) : $81551a3ae87d4df4$var$i?.trackView(s, o, d);
    });
}
function $81551a3ae87d4df4$export$88a2a93534f14e73(a) {
    return {
        install: (t)=>$81551a3ae87d4df4$var$c(t, a)
    };
}
var $81551a3ae87d4df4$var$O = {
    install: $81551a3ae87d4df4$var$c
};
var $81551a3ae87d4df4$export$2e2bcd8739ae039 = $81551a3ae87d4df4$var$O;
function $81551a3ae87d4df4$export$ed68fc50c6d02484() {
    return (0, $iZX2P.getCurrentInstance)()?.appContext?.app?.config?.globalProperties?.$gtm ?? $81551a3ae87d4df4$var$i;
}


let $f034379dc5707d1c$var$script;



let $f034379dc5707d1c$var$initialize = ()=>{
    $f034379dc5707d1c$var$script = (parcelRequire("gPqVN"));
    if ($f034379dc5707d1c$var$script.__esModule) $f034379dc5707d1c$var$script = $f034379dc5707d1c$var$script.default;
    $f034379dc5707d1c$var$script.render = (parcelRequire("5YDBd")).render;
    (parcelRequire("hdg2j")).default($f034379dc5707d1c$var$script);
    $f034379dc5707d1c$var$script.__scopeId = 'data-v-9cb190';
    $f034379dc5707d1c$var$script.__file = "App.vue";
};
$f034379dc5707d1c$var$initialize();
var $f034379dc5707d1c$export$2e2bcd8739ae039 = $f034379dc5707d1c$var$script;



var $48GQ3 = parcelRequire("48GQ3");

var $1MrF5 = parcelRequire("1MrF5");
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $36f14f010576349f$export$a143d493d941bafc;
var $36f14f010576349f$export$e4cf37d7f6fb9e0a;
var $36f14f010576349f$export$f99ded8fe4b79145;
var $36f14f010576349f$export$599f31c3813fae4d;
'use strict';
var $0165b590d36de222$export$a48f0734ac7c2329;
var $0165b590d36de222$export$d622b2ad8d90c771;
var $0165b590d36de222$export$6100ba28696e12de;
'use strict';
$0165b590d36de222$export$a48f0734ac7c2329 = $0165b590d36de222$var$byteLength;
$0165b590d36de222$export$d622b2ad8d90c771 = $0165b590d36de222$var$toByteArray;
$0165b590d36de222$export$6100ba28696e12de = $0165b590d36de222$var$fromByteArray;
var $0165b590d36de222$var$lookup = [];
var $0165b590d36de222$var$revLookup = [];
var $0165b590d36de222$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0165b590d36de222$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0165b590d36de222$var$i = 0, $0165b590d36de222$var$len = $0165b590d36de222$var$code.length; $0165b590d36de222$var$i < $0165b590d36de222$var$len; ++$0165b590d36de222$var$i){
    $0165b590d36de222$var$lookup[$0165b590d36de222$var$i] = $0165b590d36de222$var$code[$0165b590d36de222$var$i];
    $0165b590d36de222$var$revLookup[$0165b590d36de222$var$code.charCodeAt($0165b590d36de222$var$i)] = $0165b590d36de222$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0165b590d36de222$var$revLookup['-'.charCodeAt(0)] = 62;
$0165b590d36de222$var$revLookup['_'.charCodeAt(0)] = 63;
function $0165b590d36de222$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0165b590d36de222$var$byteLength(b64) {
    var lens = $0165b590d36de222$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0165b590d36de222$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0165b590d36de222$var$toByteArray(b64) {
    var tmp;
    var lens = $0165b590d36de222$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0165b590d36de222$var$Arr($0165b590d36de222$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0165b590d36de222$var$revLookup[b64.charCodeAt(i)] << 18 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0165b590d36de222$var$revLookup[b64.charCodeAt(i)] << 2 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0165b590d36de222$var$revLookup[b64.charCodeAt(i)] << 10 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0165b590d36de222$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0165b590d36de222$var$tripletToBase64(num) {
    return $0165b590d36de222$var$lookup[num >> 18 & 0x3F] + $0165b590d36de222$var$lookup[num >> 12 & 0x3F] + $0165b590d36de222$var$lookup[num >> 6 & 0x3F] + $0165b590d36de222$var$lookup[num & 0x3F];
}
function $0165b590d36de222$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0165b590d36de222$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0165b590d36de222$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0165b590d36de222$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0165b590d36de222$var$lookup[tmp >> 2] + $0165b590d36de222$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0165b590d36de222$var$lookup[tmp >> 10] + $0165b590d36de222$var$lookup[tmp >> 4 & 0x3F] + $0165b590d36de222$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $597050538d95f1cd$export$aafa59e2e03f2942;
var $597050538d95f1cd$export$68d8715fc104d294;
$597050538d95f1cd$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$597050538d95f1cd$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $36f14f010576349f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$36f14f010576349f$export$a143d493d941bafc = $36f14f010576349f$var$Buffer;
$36f14f010576349f$export$e4cf37d7f6fb9e0a = $36f14f010576349f$var$SlowBuffer;
$36f14f010576349f$export$f99ded8fe4b79145 = 50;
const $36f14f010576349f$var$K_MAX_LENGTH = 0x7fffffff;
$36f14f010576349f$export$599f31c3813fae4d = $36f14f010576349f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $36f14f010576349f$var$Buffer.TYPED_ARRAY_SUPPORT = $36f14f010576349f$var$typedArraySupport();
if (!$36f14f010576349f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $36f14f010576349f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($36f14f010576349f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$36f14f010576349f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($36f14f010576349f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$36f14f010576349f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $36f14f010576349f$var$createBuffer(length) {
    if (length > $36f14f010576349f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $36f14f010576349f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $36f14f010576349f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $36f14f010576349f$var$allocUnsafe(arg);
    }
    return $36f14f010576349f$var$from(arg, encodingOrOffset, length);
}
$36f14f010576349f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $36f14f010576349f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $36f14f010576349f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $36f14f010576349f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($36f14f010576349f$var$isInstance(value, ArrayBuffer) || value && $36f14f010576349f$var$isInstance(value.buffer, ArrayBuffer)) return $36f14f010576349f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($36f14f010576349f$var$isInstance(value, SharedArrayBuffer) || value && $36f14f010576349f$var$isInstance(value.buffer, SharedArrayBuffer))) return $36f14f010576349f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $36f14f010576349f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $36f14f010576349f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $36f14f010576349f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $36f14f010576349f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $36f14f010576349f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($36f14f010576349f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($36f14f010576349f$var$Buffer, Uint8Array);
function $36f14f010576349f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $36f14f010576349f$var$alloc(size, fill, encoding) {
    $36f14f010576349f$var$assertSize(size);
    if (size <= 0) return $36f14f010576349f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $36f14f010576349f$var$createBuffer(size).fill(fill, encoding) : $36f14f010576349f$var$createBuffer(size).fill(fill);
    return $36f14f010576349f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $36f14f010576349f$var$Buffer.alloc = function(size, fill, encoding) {
    return $36f14f010576349f$var$alloc(size, fill, encoding);
};
function $36f14f010576349f$var$allocUnsafe(size) {
    $36f14f010576349f$var$assertSize(size);
    return $36f14f010576349f$var$createBuffer(size < 0 ? 0 : $36f14f010576349f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $36f14f010576349f$var$Buffer.allocUnsafe = function(size) {
    return $36f14f010576349f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $36f14f010576349f$var$Buffer.allocUnsafeSlow = function(size) {
    return $36f14f010576349f$var$allocUnsafe(size);
};
function $36f14f010576349f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$36f14f010576349f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $36f14f010576349f$var$byteLength(string, encoding) | 0;
    let buf = $36f14f010576349f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $36f14f010576349f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $36f14f010576349f$var$checked(array.length) | 0;
    const buf = $36f14f010576349f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $36f14f010576349f$var$fromArrayView(arrayView) {
    if ($36f14f010576349f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $36f14f010576349f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $36f14f010576349f$var$fromArrayLike(arrayView);
}
function $36f14f010576349f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $36f14f010576349f$var$Buffer.prototype);
    return buf;
}
function $36f14f010576349f$var$fromObject(obj) {
    if ($36f14f010576349f$var$Buffer.isBuffer(obj)) {
        const len = $36f14f010576349f$var$checked(obj.length) | 0;
        const buf = $36f14f010576349f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $36f14f010576349f$var$numberIsNaN(obj.length)) return $36f14f010576349f$var$createBuffer(0);
        return $36f14f010576349f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $36f14f010576349f$var$fromArrayLike(obj.data);
}
function $36f14f010576349f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $36f14f010576349f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $36f14f010576349f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $36f14f010576349f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $36f14f010576349f$var$Buffer.alloc(+length);
}
$36f14f010576349f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $36f14f010576349f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$36f14f010576349f$var$Buffer.compare = function compare(a, b) {
    if ($36f14f010576349f$var$isInstance(a, Uint8Array)) a = $36f14f010576349f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($36f14f010576349f$var$isInstance(b, Uint8Array)) b = $36f14f010576349f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$36f14f010576349f$var$Buffer.isBuffer(a) || !$36f14f010576349f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$36f14f010576349f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$36f14f010576349f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $36f14f010576349f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $36f14f010576349f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($36f14f010576349f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$36f14f010576349f$var$Buffer.isBuffer(buf)) buf = $36f14f010576349f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$36f14f010576349f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $36f14f010576349f$var$byteLength(string, encoding) {
    if ($36f14f010576349f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $36f14f010576349f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $36f14f010576349f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $36f14f010576349f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $36f14f010576349f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$36f14f010576349f$var$Buffer.byteLength = $36f14f010576349f$var$byteLength;
function $36f14f010576349f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $36f14f010576349f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $36f14f010576349f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $36f14f010576349f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $36f14f010576349f$var$latin1Slice(this, start, end);
        case 'base64':
            return $36f14f010576349f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $36f14f010576349f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$36f14f010576349f$var$Buffer.prototype._isBuffer = true;
function $36f14f010576349f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$36f14f010576349f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$36f14f010576349f$var$swap(this, i, i + 1);
    return this;
};
$36f14f010576349f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $36f14f010576349f$var$swap(this, i, i + 3);
        $36f14f010576349f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$36f14f010576349f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $36f14f010576349f$var$swap(this, i, i + 7);
        $36f14f010576349f$var$swap(this, i + 1, i + 6);
        $36f14f010576349f$var$swap(this, i + 2, i + 5);
        $36f14f010576349f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$36f14f010576349f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $36f14f010576349f$var$utf8Slice(this, 0, length);
    return $36f14f010576349f$var$slowToString.apply(this, arguments);
};
$36f14f010576349f$var$Buffer.prototype.toLocaleString = $36f14f010576349f$var$Buffer.prototype.toString;
$36f14f010576349f$var$Buffer.prototype.equals = function equals(b) {
    if (!$36f14f010576349f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $36f14f010576349f$var$Buffer.compare(this, b) === 0;
};
$36f14f010576349f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $36f14f010576349f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($36f14f010576349f$var$customInspectSymbol) $36f14f010576349f$var$Buffer.prototype[$36f14f010576349f$var$customInspectSymbol] = $36f14f010576349f$var$Buffer.prototype.inspect;
$36f14f010576349f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($36f14f010576349f$var$isInstance(target, Uint8Array)) target = $36f14f010576349f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$36f14f010576349f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $36f14f010576349f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($36f14f010576349f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $36f14f010576349f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($36f14f010576349f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $36f14f010576349f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $36f14f010576349f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $36f14f010576349f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$36f14f010576349f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$36f14f010576349f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $36f14f010576349f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$36f14f010576349f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $36f14f010576349f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $36f14f010576349f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($36f14f010576349f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $36f14f010576349f$var$utf8Write(buf, string, offset, length) {
    return $36f14f010576349f$var$blitBuffer($36f14f010576349f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $36f14f010576349f$var$asciiWrite(buf, string, offset, length) {
    return $36f14f010576349f$var$blitBuffer($36f14f010576349f$var$asciiToBytes(string), buf, offset, length);
}
function $36f14f010576349f$var$base64Write(buf, string, offset, length) {
    return $36f14f010576349f$var$blitBuffer($36f14f010576349f$var$base64ToBytes(string), buf, offset, length);
}
function $36f14f010576349f$var$ucs2Write(buf, string, offset, length) {
    return $36f14f010576349f$var$blitBuffer($36f14f010576349f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$36f14f010576349f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $36f14f010576349f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $36f14f010576349f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $36f14f010576349f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $36f14f010576349f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $36f14f010576349f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$36f14f010576349f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $36f14f010576349f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $0165b590d36de222$export$6100ba28696e12de(buf);
    else return $0165b590d36de222$export$6100ba28696e12de(buf.slice(start, end));
}
function $36f14f010576349f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $36f14f010576349f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $36f14f010576349f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $36f14f010576349f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $36f14f010576349f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $36f14f010576349f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $36f14f010576349f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $36f14f010576349f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $36f14f010576349f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $36f14f010576349f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $36f14f010576349f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$36f14f010576349f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $36f14f010576349f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $36f14f010576349f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$36f14f010576349f$var$Buffer.prototype.readUintLE = $36f14f010576349f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$36f14f010576349f$var$Buffer.prototype.readUintBE = $36f14f010576349f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$36f14f010576349f$var$Buffer.prototype.readUint8 = $36f14f010576349f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$36f14f010576349f$var$Buffer.prototype.readUint16LE = $36f14f010576349f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$36f14f010576349f$var$Buffer.prototype.readUint16BE = $36f14f010576349f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$36f14f010576349f$var$Buffer.prototype.readUint32LE = $36f14f010576349f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$36f14f010576349f$var$Buffer.prototype.readUint32BE = $36f14f010576349f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$36f14f010576349f$var$Buffer.prototype.readBigUInt64LE = $36f14f010576349f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $36f14f010576349f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $36f14f010576349f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$36f14f010576349f$var$Buffer.prototype.readBigUInt64BE = $36f14f010576349f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $36f14f010576349f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $36f14f010576349f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$36f14f010576349f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$36f14f010576349f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$36f14f010576349f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$36f14f010576349f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$36f14f010576349f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$36f14f010576349f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$36f14f010576349f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$36f14f010576349f$var$Buffer.prototype.readBigInt64LE = $36f14f010576349f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $36f14f010576349f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $36f14f010576349f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$36f14f010576349f$var$Buffer.prototype.readBigInt64BE = $36f14f010576349f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $36f14f010576349f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $36f14f010576349f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$36f14f010576349f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return $597050538d95f1cd$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$36f14f010576349f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 4, this.length);
    return $597050538d95f1cd$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$36f14f010576349f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 8, this.length);
    return $597050538d95f1cd$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$36f14f010576349f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkOffset(offset, 8, this.length);
    return $597050538d95f1cd$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $36f14f010576349f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$36f14f010576349f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$36f14f010576349f$var$Buffer.prototype.writeUintLE = $36f14f010576349f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $36f14f010576349f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$36f14f010576349f$var$Buffer.prototype.writeUintBE = $36f14f010576349f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $36f14f010576349f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$36f14f010576349f$var$Buffer.prototype.writeUint8 = $36f14f010576349f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$36f14f010576349f$var$Buffer.prototype.writeUint16LE = $36f14f010576349f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$36f14f010576349f$var$Buffer.prototype.writeUint16BE = $36f14f010576349f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$36f14f010576349f$var$Buffer.prototype.writeUint32LE = $36f14f010576349f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$36f14f010576349f$var$Buffer.prototype.writeUint32BE = $36f14f010576349f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $36f14f010576349f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $36f14f010576349f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $36f14f010576349f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $36f14f010576349f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$36f14f010576349f$var$Buffer.prototype.writeBigUInt64LE = $36f14f010576349f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $36f14f010576349f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$36f14f010576349f$var$Buffer.prototype.writeBigUInt64BE = $36f14f010576349f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $36f14f010576349f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$36f14f010576349f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $36f14f010576349f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$36f14f010576349f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $36f14f010576349f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$36f14f010576349f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$36f14f010576349f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$36f14f010576349f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$36f14f010576349f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$36f14f010576349f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$36f14f010576349f$var$Buffer.prototype.writeBigInt64LE = $36f14f010576349f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $36f14f010576349f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$36f14f010576349f$var$Buffer.prototype.writeBigInt64BE = $36f14f010576349f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $36f14f010576349f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $36f14f010576349f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $36f14f010576349f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $597050538d95f1cd$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$36f14f010576349f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $36f14f010576349f$var$writeFloat(this, value, offset, true, noAssert);
};
$36f14f010576349f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $36f14f010576349f$var$writeFloat(this, value, offset, false, noAssert);
};
function $36f14f010576349f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $36f14f010576349f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $597050538d95f1cd$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$36f14f010576349f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $36f14f010576349f$var$writeDouble(this, value, offset, true, noAssert);
};
$36f14f010576349f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $36f14f010576349f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$36f14f010576349f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$36f14f010576349f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$36f14f010576349f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$36f14f010576349f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $36f14f010576349f$var$Buffer.isBuffer(val) ? val : $36f14f010576349f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $36f14f010576349f$var$errors = {};
function $36f14f010576349f$var$E(sym, getMessage, Base) {
    $36f14f010576349f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$36f14f010576349f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$36f14f010576349f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$36f14f010576349f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $36f14f010576349f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $36f14f010576349f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $36f14f010576349f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $36f14f010576349f$var$checkBounds(buf, offset, byteLength) {
    $36f14f010576349f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $36f14f010576349f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $36f14f010576349f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $36f14f010576349f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $36f14f010576349f$var$checkBounds(buf, offset, byteLength);
}
function $36f14f010576349f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $36f14f010576349f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $36f14f010576349f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $36f14f010576349f$var$validateNumber(value, type);
        throw new $36f14f010576349f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $36f14f010576349f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $36f14f010576349f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $36f14f010576349f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $36f14f010576349f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($36f14f010576349f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $36f14f010576349f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $36f14f010576349f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $36f14f010576349f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $36f14f010576349f$var$base64ToBytes(str) {
    return $0165b590d36de222$export$d622b2ad8d90c771($36f14f010576349f$var$base64clean(str));
}
function $36f14f010576349f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $36f14f010576349f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $36f14f010576349f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $36f14f010576349f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $36f14f010576349f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $36f14f010576349f$var$BufferBigIntNotDefined : fn;
}
function $36f14f010576349f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $51c8f0da15dbd30c$require$Buffer = $36f14f010576349f$export$a143d493d941bafc;
var $51c8f0da15dbd30c$var$win;
if (typeof window === 'undefined') {
    var $51c8f0da15dbd30c$var$loc = {
        hostname: ''
    };
    $51c8f0da15dbd30c$var$win = {
        crypto: {
            randomUUID: function() {
                throw Error('unsupported');
            }
        },
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: $51c8f0da15dbd30c$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $51c8f0da15dbd30c$var$loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else $51c8f0da15dbd30c$var$win = window;
function $51c8f0da15dbd30c$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $51c8f0da15dbd30c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $51c8f0da15dbd30c$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $51c8f0da15dbd30c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $51c8f0da15dbd30c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $51c8f0da15dbd30c$var$_construct(Parent, args, Class) {
    if ($51c8f0da15dbd30c$var$_is_native_reflect_construct()) $51c8f0da15dbd30c$var$_construct = Reflect.construct;
    else $51c8f0da15dbd30c$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $51c8f0da15dbd30c$var$_set_prototype_of(instance, Class.prototype);
        return instance;
    };
    return $51c8f0da15dbd30c$var$_construct.apply(null, arguments);
}
function $51c8f0da15dbd30c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $51c8f0da15dbd30c$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $51c8f0da15dbd30c$var$_defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function $51c8f0da15dbd30c$var$_extends() {
    $51c8f0da15dbd30c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51c8f0da15dbd30c$var$_extends.apply(this, arguments);
}
function $51c8f0da15dbd30c$var$_get_prototype_of(o) {
    $51c8f0da15dbd30c$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51c8f0da15dbd30c$var$_get_prototype_of(o);
}
function $51c8f0da15dbd30c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $51c8f0da15dbd30c$var$_set_prototype_of(subClass, superClass);
}
function $51c8f0da15dbd30c$var$_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function $51c8f0da15dbd30c$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $51c8f0da15dbd30c$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $51c8f0da15dbd30c$var$_set_prototype_of(o, p) {
    $51c8f0da15dbd30c$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $51c8f0da15dbd30c$var$_set_prototype_of(o, p);
}
function $51c8f0da15dbd30c$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $51c8f0da15dbd30c$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $51c8f0da15dbd30c$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51c8f0da15dbd30c$var$_array_like_to_array(o, minLen);
}
function $51c8f0da15dbd30c$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $51c8f0da15dbd30c$var$_wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !$51c8f0da15dbd30c$var$_is_native_function(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $51c8f0da15dbd30c$var$_construct(Class, arguments, $51c8f0da15dbd30c$var$_get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $51c8f0da15dbd30c$var$_set_prototype_of(Wrapper, Class);
    };
    return $51c8f0da15dbd30c$var$_wrap_native_super(Class);
}
function $51c8f0da15dbd30c$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($51c8f0da15dbd30c$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $51c8f0da15dbd30c$var$_unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51c8f0da15dbd30c$var$_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $51c8f0da15dbd30c$var$_ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $51c8f0da15dbd30c$var$__defProp$1 = Object.defineProperty;
var $51c8f0da15dbd30c$var$__defNormalProp$1 = function(obj, key, value) {
    return key in obj ? $51c8f0da15dbd30c$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $51c8f0da15dbd30c$var$__publicField$1 = function(obj, key, value) {
    return $51c8f0da15dbd30c$var$__defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $51c8f0da15dbd30c$var$_a;
var $51c8f0da15dbd30c$var$__defProp$1$1 = Object.defineProperty;
var $51c8f0da15dbd30c$var$__defNormalProp$1$1 = function(obj, key, value) {
    return key in obj ? $51c8f0da15dbd30c$var$__defProp$1$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $51c8f0da15dbd30c$var$__publicField$1$1 = function(obj, key, value) {
    return $51c8f0da15dbd30c$var$__defNormalProp$1$1(obj, (typeof key === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $51c8f0da15dbd30c$var$NodeType$3 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($51c8f0da15dbd30c$var$NodeType$3 || {});
var $51c8f0da15dbd30c$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $51c8f0da15dbd30c$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $51c8f0da15dbd30c$var$untaintedBasePrototype$1 = {};
var $51c8f0da15dbd30c$var$isAngularZonePresent$1 = function() {
    return !!globalThis.Zone;
};
function $51c8f0da15dbd30c$var$getUntaintedPrototype$1(key) {
    if ($51c8f0da15dbd30c$var$untaintedBasePrototype$1[key]) return $51c8f0da15dbd30c$var$untaintedBasePrototype$1[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $51c8f0da15dbd30c$var$testableAccessors$1 ? $51c8f0da15dbd30c$var$testableAccessors$1[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $51c8f0da15dbd30c$var$testableMethods$1 ? $51c8f0da15dbd30c$var$testableMethods$1[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$51c8f0da15dbd30c$var$isAngularZonePresent$1()) {
        $51c8f0da15dbd30c$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $51c8f0da15dbd30c$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $51c8f0da15dbd30c$var$untaintedAccessorCache$1 = {};
function $51c8f0da15dbd30c$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($51c8f0da15dbd30c$var$untaintedAccessorCache$1[cacheKey]) return $51c8f0da15dbd30c$var$untaintedAccessorCache$1[cacheKey].call(instance);
    var untaintedPrototype = $51c8f0da15dbd30c$var$getUntaintedPrototype$1(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $51c8f0da15dbd30c$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $51c8f0da15dbd30c$var$untaintedMethodCache$1 = {};
function $51c8f0da15dbd30c$var$getUntaintedMethod$1(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($51c8f0da15dbd30c$var$untaintedMethodCache$1[cacheKey]) return $51c8f0da15dbd30c$var$untaintedMethodCache$1[cacheKey].bind(instance);
    var untaintedPrototype = $51c8f0da15dbd30c$var$getUntaintedPrototype$1(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $51c8f0da15dbd30c$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $51c8f0da15dbd30c$var$childNodes$1(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $51c8f0da15dbd30c$var$parentNode$1(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $51c8f0da15dbd30c$var$parentElement$1(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $51c8f0da15dbd30c$var$textContent$1(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $51c8f0da15dbd30c$var$contains$1(n2, other) {
    return $51c8f0da15dbd30c$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $51c8f0da15dbd30c$var$getRootNode$1(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $51c8f0da15dbd30c$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $51c8f0da15dbd30c$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $51c8f0da15dbd30c$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $51c8f0da15dbd30c$var$querySelector$1(n2, selectors) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $51c8f0da15dbd30c$var$querySelectorAll$1(n2, selectors) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $51c8f0da15dbd30c$var$mutationObserverCtor$1() {
    return $51c8f0da15dbd30c$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
function $51c8f0da15dbd30c$var$patch$1(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $51c8f0da15dbd30c$var$index$1 = {
    childNodes: $51c8f0da15dbd30c$var$childNodes$1,
    parentNode: $51c8f0da15dbd30c$var$parentNode$1,
    parentElement: $51c8f0da15dbd30c$var$parentElement$1,
    textContent: $51c8f0da15dbd30c$var$textContent$1,
    contains: $51c8f0da15dbd30c$var$contains$1,
    getRootNode: $51c8f0da15dbd30c$var$getRootNode$1,
    host: $51c8f0da15dbd30c$var$host$1,
    styleSheets: $51c8f0da15dbd30c$var$styleSheets$1,
    shadowRoot: $51c8f0da15dbd30c$var$shadowRoot$1,
    querySelector: $51c8f0da15dbd30c$var$querySelector$1,
    querySelectorAll: $51c8f0da15dbd30c$var$querySelectorAll$1,
    mutationObserver: $51c8f0da15dbd30c$var$mutationObserverCtor$1,
    patch: $51c8f0da15dbd30c$var$patch$1
};
function $51c8f0da15dbd30c$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $51c8f0da15dbd30c$var$isShadowRoot(n2) {
    var hostEl = // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $51c8f0da15dbd30c$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $51c8f0da15dbd30c$var$index$1.shadowRoot(hostEl) === n2);
}
function $51c8f0da15dbd30c$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $51c8f0da15dbd30c$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $51c8f0da15dbd30c$var$escapeImportStatement(rule2) {
    var cssText = rule2.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(" + JSON.stringify(rule2.href) + ")"
    ];
    if (rule2.layerName === "") statement.push("layer");
    else if (rule2.layerName) statement.push("layer(" + rule2.layerName + ")");
    if (rule2.supportsText) statement.push("supports(" + rule2.supportsText + ")");
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $51c8f0da15dbd30c$var$stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        var sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        var stringifiedRules = Array.from(rules2, function(rule2) {
            return $51c8f0da15dbd30c$var$stringifyRule(rule2, sheetHref);
        }).join("");
        return $51c8f0da15dbd30c$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $51c8f0da15dbd30c$var$stringifyRule(rule2, sheetHref) {
    if ($51c8f0da15dbd30c$var$isCSSImportRule(rule2)) {
        var importStringified;
        try {
            importStringified = $51c8f0da15dbd30c$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $51c8f0da15dbd30c$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $51c8f0da15dbd30c$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        var ruleStringified = rule2.cssText;
        if ($51c8f0da15dbd30c$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $51c8f0da15dbd30c$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $51c8f0da15dbd30c$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $51c8f0da15dbd30c$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $51c8f0da15dbd30c$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $51c8f0da15dbd30c$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
var $51c8f0da15dbd30c$var$Mirror = /*#__PURE__*/ function() {
    function Mirror() {
        $51c8f0da15dbd30c$var$__publicField$1$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $51c8f0da15dbd30c$var$__publicField$1$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    var _proto = Mirror.prototype;
    _proto.getId = function getId(n2) {
        var _a2;
        if (!n2) return -1;
        var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    };
    _proto.getNode = function getNode(id) {
        return this.idNodeMap.get(id) || null;
    };
    _proto.getIds = function getIds() {
        return Array.from(this.idNodeMap.keys());
    };
    _proto.getMeta = function getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    };
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    _proto.removeNodeFromMap = function removeNodeFromMap(n2) {
        var _this = this;
        var id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
            return _this.removeNodeFromMap(childNode);
        });
    };
    _proto.has = function has(id) {
        return this.idNodeMap.has(id);
    };
    _proto.hasNode = function hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    };
    _proto.add = function add(n2, meta) {
        var id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    };
    _proto.replace = function replace(id, n2) {
        var oldNode = this.getNode(id);
        if (oldNode) {
            var meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    };
    _proto.reset = function reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    };
    return Mirror;
}();
function $51c8f0da15dbd30c$var$createMirror$2() {
    return new $51c8f0da15dbd30c$var$Mirror();
}
function $51c8f0da15dbd30c$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    var actualType = type && $51c8f0da15dbd30c$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $51c8f0da15dbd30c$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $51c8f0da15dbd30c$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $51c8f0da15dbd30c$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x2 = 0; x2 < canvas.width; x2 += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $51c8f0da15dbd30c$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$51c8f0da15dbd30c$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $51c8f0da15dbd30c$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $51c8f0da15dbd30c$var$toLowerCase(type) : null;
}
function $51c8f0da15dbd30c$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function $51c8f0da15dbd30c$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $51c8f0da15dbd30c$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $51c8f0da15dbd30c$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $51c8f0da15dbd30c$var$URL_WWW_MATCH = /^www\..*/i;
var $51c8f0da15dbd30c$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $51c8f0da15dbd30c$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($51c8f0da15dbd30c$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($51c8f0da15dbd30c$var$URL_PROTOCOL_MATCH.test(filePath) || $51c8f0da15dbd30c$var$URL_WWW_MATCH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($51c8f0da15dbd30c$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === "/") return "url(" + maybeQuote + ($51c8f0da15dbd30c$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(parts), _step; !(_step = _iterator()).done;){
            var part = _step.value;
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join("/") + maybeQuote + ")";
    });
}
function $51c8f0da15dbd30c$var$normalizeCssString(cssText, _testNoPxNorm) {
    if (_testNoPxNorm === void 0) _testNoPxNorm = false;
    if (_testNoPxNorm) return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
    else return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function $51c8f0da15dbd30c$var$splitCssText(cssText, style, _testNoPxNorm) {
    if (_testNoPxNorm === void 0) _testNoPxNorm = false;
    var childNodes2 = Array.from(style.childNodes);
    var splits = [];
    var iterCount = 0;
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        var cssTextNorm = $51c8f0da15dbd30c$var$normalizeCssString(cssText, _testNoPxNorm);
        var normFactor = cssTextNorm.length / cssText.length;
        for(var i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            var textContentNorm = $51c8f0da15dbd30c$var$normalizeCssString(childNodes2[i2].textContent, _testNoPxNorm);
            var jLimit = 100;
            var j = 3;
            for(; j < textContentNorm.length; j++){
                if (textContentNorm[j].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
                textContentNorm.indexOf(textContentNorm.substring(0, j), 1) !== -1) continue;
                break;
            }
            for(; j < textContentNorm.length; j++){
                var startSubstring = textContentNorm.substring(0, j);
                var cssNormSplits = cssTextNorm.split(startSubstring);
                var splitNorm = -1;
                if (cssNormSplits.length === 2) splitNorm = cssNormSplits[0].length;
                else if (cssNormSplits.length > 2 && cssNormSplits[0] === "" && childNodes2[i2 - 1].textContent !== "") splitNorm = cssTextNorm.indexOf(startSubstring, 1);
                else if (cssNormSplits.length === 1) {
                    startSubstring = startSubstring.substring(0, startSubstring.length - 1);
                    cssNormSplits = cssTextNorm.split(startSubstring);
                    if (cssNormSplits.length <= 1) {
                        splits.push(cssText);
                        return splits;
                    }
                    j = jLimit + 1;
                } else if (j === textContentNorm.length - 1) splitNorm = cssTextNorm.indexOf(startSubstring);
                if (cssNormSplits.length >= 2 && j > jLimit) {
                    var prevTextContent = childNodes2[i2 - 1].textContent;
                    if (prevTextContent && typeof prevTextContent === "string") {
                        var prevMinLength = $51c8f0da15dbd30c$var$normalizeCssString(prevTextContent).length;
                        splitNorm = cssTextNorm.indexOf(startSubstring, prevMinLength);
                    }
                    if (splitNorm === -1) splitNorm = cssNormSplits[0].length;
                }
                if (splitNorm !== -1) {
                    var k = Math.floor(splitNorm / normFactor);
                    for(; k > 0 && k < cssText.length;){
                        iterCount += 1;
                        if (iterCount > 50 * childNodes2.length) {
                            splits.push(cssText);
                            return splits;
                        }
                        var normPart = $51c8f0da15dbd30c$var$normalizeCssString(cssText.substring(0, k), _testNoPxNorm);
                        if (normPart.length === splitNorm) {
                            splits.push(cssText.substring(0, k));
                            cssText = cssText.substring(k);
                            cssTextNorm = cssTextNorm.substring(splitNorm);
                            break;
                        } else if (normPart.length < splitNorm) k += Math.max(1, Math.floor((splitNorm - normPart.length) / normFactor));
                        else k -= Math.max(1, Math.floor((normPart.length - splitNorm) * normFactor));
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $51c8f0da15dbd30c$var$markCssSplits(cssText, style) {
    return $51c8f0da15dbd30c$var$splitCssText(cssText, style).join("/* rr_split */");
}
var $51c8f0da15dbd30c$var$_id = 1;
var $51c8f0da15dbd30c$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $51c8f0da15dbd30c$var$IGNORED_NODE = -2;
function $51c8f0da15dbd30c$var$genId() {
    return $51c8f0da15dbd30c$var$_id++;
}
function $51c8f0da15dbd30c$var$getValidTagName$1(element) {
    if ($51c8f0da15dbd30c$var$_instanceof(element, HTMLFormElement)) return "form";
    var processedTagName = $51c8f0da15dbd30c$var$toLowerCase(element.tagName);
    if ($51c8f0da15dbd30c$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
var $51c8f0da15dbd30c$var$canvasService;
var $51c8f0da15dbd30c$var$canvasCtx;
var $51c8f0da15dbd30c$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $51c8f0da15dbd30c$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $51c8f0da15dbd30c$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($51c8f0da15dbd30c$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($51c8f0da15dbd30c$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $51c8f0da15dbd30c$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $51c8f0da15dbd30c$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $51c8f0da15dbd30c$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $51c8f0da15dbd30c$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $51c8f0da15dbd30c$var$getHref(doc, attributeValue);
}
function $51c8f0da15dbd30c$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $51c8f0da15dbd30c$var$getHref(doc, customHref) {
    var a2 = $51c8f0da15dbd30c$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $51c8f0da15dbd30c$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $51c8f0da15dbd30c$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $51c8f0da15dbd30c$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $51c8f0da15dbd30c$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $51c8f0da15dbd30c$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $51c8f0da15dbd30c$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $51c8f0da15dbd30c$var$absolutifyURLs(value, $51c8f0da15dbd30c$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $51c8f0da15dbd30c$var$absoluteToDoc(doc, value);
    return value;
}
function $51c8f0da15dbd30c$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $51c8f0da15dbd30c$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $51c8f0da15dbd30c$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $51c8f0da15dbd30c$var$classMatchesRegex($51c8f0da15dbd30c$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(var eIndex = node2.classList.length; eIndex--;){
        var className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $51c8f0da15dbd30c$var$classMatchesRegex($51c8f0da15dbd30c$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $51c8f0da15dbd30c$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    var el;
    if ($51c8f0da15dbd30c$var$isElement(node2)) {
        el = node2;
        if (!$51c8f0da15dbd30c$var$index$1.childNodes(el).length) return false;
    } else if ($51c8f0da15dbd30c$var$index$1.parentElement(node2) === null) return false;
    else el = $51c8f0da15dbd30c$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest("." + maskTextClass)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($51c8f0da15dbd30c$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $51c8f0da15dbd30c$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $51c8f0da15dbd30c$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $51c8f0da15dbd30c$var$serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var rootId = $51c8f0da15dbd30c$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $51c8f0da15dbd30c$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $51c8f0da15dbd30c$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $51c8f0da15dbd30c$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $51c8f0da15dbd30c$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $51c8f0da15dbd30c$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $51c8f0da15dbd30c$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $51c8f0da15dbd30c$var$NodeType$3.Comment,
                textContent: $51c8f0da15dbd30c$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $51c8f0da15dbd30c$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $51c8f0da15dbd30c$var$serializeTextNode(n2, options) {
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId, cssCaptured = options.cssCaptured;
    var parent = $51c8f0da15dbd30c$var$index$1.parentNode(n2);
    var parentTagName = parent && parent.tagName;
    var textContent2 = "";
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $51c8f0da15dbd30c$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $51c8f0da15dbd30c$var$absolutifyURLs(textContent2, $51c8f0da15dbd30c$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $51c8f0da15dbd30c$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $51c8f0da15dbd30c$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $51c8f0da15dbd30c$var$serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $51c8f0da15dbd30c$var$_isBlockedElement(n2, blockClass, blockSelector);
    var tagName = $51c8f0da15dbd30c$var$getValidTagName$1(n2);
    var attributes = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (!$51c8f0da15dbd30c$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $51c8f0da15dbd30c$var$transformAttribute(doc, tagName, $51c8f0da15dbd30c$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $51c8f0da15dbd30c$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        var cssText1 = $51c8f0da15dbd30c$var$stringifyStylesheet(n2.sheet);
        if (cssText1) {
            if (n2.childNodes.length > 1) cssText1 = $51c8f0da15dbd30c$var$markCssSplits(cssText1, n2);
            attributes._cssText = cssText1;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        var value = n2.value;
        var checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $51c8f0da15dbd30c$var$maskInputValue({
            element: n2,
            type: $51c8f0da15dbd30c$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$51c8f0da15dbd30c$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$51c8f0da15dbd30c$var$canvasService) {
            $51c8f0da15dbd30c$var$canvasService = doc.createElement("canvas");
            $51c8f0da15dbd30c$var$canvasCtx = $51c8f0da15dbd30c$var$canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $51c8f0da15dbd30c$var$canvasService.width = image.naturalWidth;
                $51c8f0da15dbd30c$var$canvasService.height = image.naturalHeight;
                $51c8f0da15dbd30c$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $51c8f0da15dbd30c$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=" + imageSrc + "! Error: " + err);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: "" + width + "px",
            rr_height: "" + height + "px"
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $51c8f0da15dbd30c$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $51c8f0da15dbd30c$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $51c8f0da15dbd30c$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $51c8f0da15dbd30c$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $51c8f0da15dbd30c$var$NodeType$3.Comment) return true;
    else if (sn.type === $51c8f0da15dbd30c$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" && sn.attributes.as === "script" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $51c8f0da15dbd30c$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "application-name" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.rel) === "icon" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "robots" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "googlebot" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "author" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "generator" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "framework" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "publisher" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "progid" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "verification" || $51c8f0da15dbd30c$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $51c8f0da15dbd30c$var$serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask) {
        var checkAncestors = needsMask === void 0;
        needsMask = $51c8f0da15dbd30c$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $51c8f0da15dbd30c$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($51c8f0da15dbd30c$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $51c8f0da15dbd30c$var$IGNORED_NODE;
    else id = $51c8f0da15dbd30c$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $51c8f0da15dbd30c$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRootEl = $51c8f0da15dbd30c$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $51c8f0da15dbd30c$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Document || serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(Array.from($51c8f0da15dbd30c$var$index$1.childNodes(n2))), _step; !(_step = _iterator()).done;){
                var childN = _step.value;
                var serializedChildNode = $51c8f0da15dbd30c$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        var shadowRootEl1 = null;
        if ($51c8f0da15dbd30c$var$isElement(n2) && (shadowRootEl1 = $51c8f0da15dbd30c$var$index$1.shadowRoot(n2))) for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(Array.from($51c8f0da15dbd30c$var$index$1.childNodes(shadowRootEl1))), _step1; !(_step1 = _iterator1()).done;){
            var childN1 = _step1.value;
            var serializedChildNode1 = $51c8f0da15dbd30c$var$serializeNodeWithId(childN1, bypassOptions);
            if (serializedChildNode1) {
                $51c8f0da15dbd30c$var$isNativeShadowDom(shadowRootEl1) && (serializedChildNode1.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode1);
            }
        }
    }
    var parent = $51c8f0da15dbd30c$var$index$1.parentNode(n2);
    if (parent && $51c8f0da15dbd30c$var$isShadowRoot(parent) && $51c8f0da15dbd30c$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element && serializedNode.tagName === "iframe") $51c8f0da15dbd30c$var$onceIframeLoaded(n2, function() {
        var iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $51c8f0da15dbd30c$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $51c8f0da15dbd30c$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $51c8f0da15dbd30c$var$extractFileExtension(serializedNode.attributes.href) === "css")) $51c8f0da15dbd30c$var$onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $51c8f0da15dbd30c$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $51c8f0da15dbd30c$var$snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new $51c8f0da15dbd30c$var$Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true,
        hidden: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $51c8f0da15dbd30c$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $51c8f0da15dbd30c$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $51c8f0da15dbd30c$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($51c8f0da15dbd30c$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $51c8f0da15dbd30c$var$picocolors_browser$1 = {
    exports: {}
};
var $51c8f0da15dbd30c$var$x$1 = String;
var $51c8f0da15dbd30c$var$create$1 = function create$1() {
    return {
        isColorSupported: false,
        reset: $51c8f0da15dbd30c$var$x$1,
        bold: $51c8f0da15dbd30c$var$x$1,
        dim: $51c8f0da15dbd30c$var$x$1,
        italic: $51c8f0da15dbd30c$var$x$1,
        underline: $51c8f0da15dbd30c$var$x$1,
        inverse: $51c8f0da15dbd30c$var$x$1,
        hidden: $51c8f0da15dbd30c$var$x$1,
        strikethrough: $51c8f0da15dbd30c$var$x$1,
        black: $51c8f0da15dbd30c$var$x$1,
        red: $51c8f0da15dbd30c$var$x$1,
        green: $51c8f0da15dbd30c$var$x$1,
        yellow: $51c8f0da15dbd30c$var$x$1,
        blue: $51c8f0da15dbd30c$var$x$1,
        magenta: $51c8f0da15dbd30c$var$x$1,
        cyan: $51c8f0da15dbd30c$var$x$1,
        white: $51c8f0da15dbd30c$var$x$1,
        gray: $51c8f0da15dbd30c$var$x$1,
        bgBlack: $51c8f0da15dbd30c$var$x$1,
        bgRed: $51c8f0da15dbd30c$var$x$1,
        bgGreen: $51c8f0da15dbd30c$var$x$1,
        bgYellow: $51c8f0da15dbd30c$var$x$1,
        bgBlue: $51c8f0da15dbd30c$var$x$1,
        bgMagenta: $51c8f0da15dbd30c$var$x$1,
        bgCyan: $51c8f0da15dbd30c$var$x$1,
        bgWhite: $51c8f0da15dbd30c$var$x$1
    };
};
$51c8f0da15dbd30c$var$picocolors_browser$1.exports = $51c8f0da15dbd30c$var$create$1();
$51c8f0da15dbd30c$var$picocolors_browser$1.exports.createColors = $51c8f0da15dbd30c$var$create$1;
var $51c8f0da15dbd30c$var$picocolors_browserExports$1 = $51c8f0da15dbd30c$var$picocolors_browser$1.exports;
var $51c8f0da15dbd30c$var$__viteBrowserExternal$2 = {};
var $51c8f0da15dbd30c$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $51c8f0da15dbd30c$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
var $51c8f0da15dbd30c$var$require$$2$1 = /* @__PURE__ */ $51c8f0da15dbd30c$var$getAugmentedNamespace$1($51c8f0da15dbd30c$var$__viteBrowserExternal$1$1);
var $51c8f0da15dbd30c$var$pico$1 = $51c8f0da15dbd30c$var$picocolors_browserExports$1;
var $51c8f0da15dbd30c$var$terminalHighlight$1$1 = $51c8f0da15dbd30c$var$require$$2$1;
var $51c8f0da15dbd30c$var$CssSyntaxError$3$1 = /*#__PURE__*/ function(Error1) {
    $51c8f0da15dbd30c$var$_inherits(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    var _proto = CssSyntaxError.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $51c8f0da15dbd30c$var$pico$1.isColorSupported;
        if ($51c8f0da15dbd30c$var$terminalHighlight$1$1) {
            if (color) css = $51c8f0da15dbd30c$var$terminalHighlight$1$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico$1_createColors = $51c8f0da15dbd30c$var$pico$1.createColors(true), bold = _pico$1_createColors.bold, gray = _pico$1_createColors.gray, red = _pico$1_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError;
}($51c8f0da15dbd30c$var$_wrap_native_super(Error));
var $51c8f0da15dbd30c$var$cssSyntaxError$1 = $51c8f0da15dbd30c$var$CssSyntaxError$3$1;
$51c8f0da15dbd30c$var$CssSyntaxError$3$1.default = $51c8f0da15dbd30c$var$CssSyntaxError$3$1;
var $51c8f0da15dbd30c$var$symbols$1 = {};
$51c8f0da15dbd30c$var$symbols$1.isClean = Symbol("isClean");
$51c8f0da15dbd30c$var$symbols$1.my = Symbol("my");
var $51c8f0da15dbd30c$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $51c8f0da15dbd30c$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $51c8f0da15dbd30c$var$Stringifier$2$1 = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $51c8f0da15dbd30c$var$DEFAULT_RAW$1[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $51c8f0da15dbd30c$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $51c8f0da15dbd30c$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier;
}();
var $51c8f0da15dbd30c$var$stringifier$1 = $51c8f0da15dbd30c$var$Stringifier$2$1;
$51c8f0da15dbd30c$var$Stringifier$2$1.default = $51c8f0da15dbd30c$var$Stringifier$2$1;
var $51c8f0da15dbd30c$var$Stringifier$1$1 = $51c8f0da15dbd30c$var$stringifier$1;
function $51c8f0da15dbd30c$var$stringify$4$1(node2, builder) {
    var str = new $51c8f0da15dbd30c$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $51c8f0da15dbd30c$var$stringify_1$1 = $51c8f0da15dbd30c$var$stringify$4$1;
$51c8f0da15dbd30c$var$stringify$4$1.default = $51c8f0da15dbd30c$var$stringify$4$1;
var $51c8f0da15dbd30c$var$isClean$2$1 = $51c8f0da15dbd30c$var$symbols$1.isClean, $51c8f0da15dbd30c$var$my$2$1 = $51c8f0da15dbd30c$var$symbols$1.my;
var $51c8f0da15dbd30c$var$CssSyntaxError$2$1 = $51c8f0da15dbd30c$var$cssSyntaxError$1;
var $51c8f0da15dbd30c$var$Stringifier2$1 = $51c8f0da15dbd30c$var$stringifier$1;
var $51c8f0da15dbd30c$var$stringify$3$1 = $51c8f0da15dbd30c$var$stringify_1$1;
function $51c8f0da15dbd30c$var$cloneNode$1(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $51c8f0da15dbd30c$var$cloneNode$1(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $51c8f0da15dbd30c$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $51c8f0da15dbd30c$var$Node$4$1 = /*#__PURE__*/ function() {
    function Node2(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$51c8f0da15dbd30c$var$isClean$2$1] = false;
        this[$51c8f0da15dbd30c$var$my$2$1] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node2.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $51c8f0da15dbd30c$var$cloneNode$1(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $51c8f0da15dbd30c$var$CssSyntaxError$2$1(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$51c8f0da15dbd30c$var$isClean$2$1]) {
            this[$51c8f0da15dbd30c$var$isClean$2$1] = false;
            var next = this;
            while(next = next.parent)next[$51c8f0da15dbd30c$var$isClean$2$1] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $51c8f0da15dbd30c$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $51c8f0da15dbd30c$var$stringify$3$1;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $51c8f0da15dbd30c$var$_create_class(Node2, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node2;
}();
var $51c8f0da15dbd30c$var$node$1 = $51c8f0da15dbd30c$var$Node$4$1;
$51c8f0da15dbd30c$var$Node$4$1.default = $51c8f0da15dbd30c$var$Node$4$1;
var $51c8f0da15dbd30c$var$Node$3$1 = $51c8f0da15dbd30c$var$node$1;
var $51c8f0da15dbd30c$var$Declaration$4$1 = /*#__PURE__*/ function(Node$3$1) {
    $51c8f0da15dbd30c$var$_inherits(Declaration, Node$3$1);
    function Declaration(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $51c8f0da15dbd30c$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3$1.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $51c8f0da15dbd30c$var$_create_class(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}($51c8f0da15dbd30c$var$Node$3$1);
var $51c8f0da15dbd30c$var$declaration$1 = $51c8f0da15dbd30c$var$Declaration$4$1;
$51c8f0da15dbd30c$var$Declaration$4$1.default = $51c8f0da15dbd30c$var$Declaration$4$1;
var $51c8f0da15dbd30c$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $51c8f0da15dbd30c$var$nanoid$1$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $51c8f0da15dbd30c$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $51c8f0da15dbd30c$var$nonSecure$1 = {
    nanoid: $51c8f0da15dbd30c$var$nanoid$1$1
};
var $51c8f0da15dbd30c$var$SourceMapConsumer$2$1 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator$2$1 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapGenerator;
var $51c8f0da15dbd30c$var$existsSync$1 = $51c8f0da15dbd30c$var$require$$2$1.existsSync, $51c8f0da15dbd30c$var$readFileSync$1 = $51c8f0da15dbd30c$var$require$$2$1.readFileSync;
var $51c8f0da15dbd30c$var$dirname$1$1 = $51c8f0da15dbd30c$var$require$$2$1.dirname, $51c8f0da15dbd30c$var$join$1 = $51c8f0da15dbd30c$var$require$$2$1.join;
function $51c8f0da15dbd30c$var$fromBase64$1(str) {
    if ($51c8f0da15dbd30c$require$Buffer) return $51c8f0da15dbd30c$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $51c8f0da15dbd30c$var$PreviousMap$2$1 = /*#__PURE__*/ function() {
    function PreviousMap(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $51c8f0da15dbd30c$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $51c8f0da15dbd30c$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $51c8f0da15dbd30c$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $51c8f0da15dbd30c$var$dirname$1$1(path);
        if ($51c8f0da15dbd30c$var$existsSync$1(path)) {
            this.mapFile = path;
            return $51c8f0da15dbd30c$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($51c8f0da15dbd30c$var$_instanceof(prev, $51c8f0da15dbd30c$var$SourceMapConsumer$2$1)) return $51c8f0da15dbd30c$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if ($51c8f0da15dbd30c$var$_instanceof(prev, $51c8f0da15dbd30c$var$SourceMapGenerator$2$1)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $51c8f0da15dbd30c$var$join$1($51c8f0da15dbd30c$var$dirname$1$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap;
}();
var $51c8f0da15dbd30c$var$previousMap$1 = $51c8f0da15dbd30c$var$PreviousMap$2$1;
$51c8f0da15dbd30c$var$PreviousMap$2$1.default = $51c8f0da15dbd30c$var$PreviousMap$2$1;
var $51c8f0da15dbd30c$var$SourceMapConsumer$1$1 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator$1$1 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapGenerator;
var $51c8f0da15dbd30c$var$fileURLToPath$1 = $51c8f0da15dbd30c$var$require$$2$1.fileURLToPath, $51c8f0da15dbd30c$var$pathToFileURL$1$1 = $51c8f0da15dbd30c$var$require$$2$1.pathToFileURL;
var $51c8f0da15dbd30c$var$isAbsolute$1 = $51c8f0da15dbd30c$var$require$$2$1.isAbsolute, $51c8f0da15dbd30c$var$resolve$1$1 = $51c8f0da15dbd30c$var$require$$2$1.resolve;
var $51c8f0da15dbd30c$var$nanoid$2 = $51c8f0da15dbd30c$var$nonSecure$1.nanoid;
var $51c8f0da15dbd30c$var$terminalHighlight$2 = $51c8f0da15dbd30c$var$require$$2$1;
var $51c8f0da15dbd30c$var$CssSyntaxError$1$1 = $51c8f0da15dbd30c$var$cssSyntaxError$1;
var $51c8f0da15dbd30c$var$PreviousMap$1$1 = $51c8f0da15dbd30c$var$previousMap$1;
var $51c8f0da15dbd30c$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
var $51c8f0da15dbd30c$var$sourceMapAvailable$1$1 = Boolean($51c8f0da15dbd30c$var$SourceMapConsumer$1$1 && $51c8f0da15dbd30c$var$SourceMapGenerator$1$1);
var $51c8f0da15dbd30c$var$pathAvailable$1$1 = Boolean($51c8f0da15dbd30c$var$resolve$1$1 && $51c8f0da15dbd30c$var$isAbsolute$1);
var $51c8f0da15dbd30c$var$Input$4$1 = /*#__PURE__*/ function() {
    function Input(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$51c8f0da15dbd30c$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $51c8f0da15dbd30c$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $51c8f0da15dbd30c$var$resolve$1$1(opts.from);
        }
        if ($51c8f0da15dbd30c$var$pathAvailable$1$1 && $51c8f0da15dbd30c$var$sourceMapAvailable$1$1) {
            var map = new $51c8f0da15dbd30c$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $51c8f0da15dbd30c$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $51c8f0da15dbd30c$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $51c8f0da15dbd30c$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($51c8f0da15dbd30c$var$pathToFileURL$1$1) result2.input.url = $51c8f0da15dbd30c$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$51c8f0da15dbd30c$var$fromOffsetCache$1]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$51c8f0da15dbd30c$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$51c8f0da15dbd30c$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $51c8f0da15dbd30c$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($51c8f0da15dbd30c$var$isAbsolute$1(from.source)) fromUrl = $51c8f0da15dbd30c$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $51c8f0da15dbd30c$var$pathToFileURL$1$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($51c8f0da15dbd30c$var$fileURLToPath$1) result2.file = $51c8f0da15dbd30c$var$fileURLToPath$1(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $51c8f0da15dbd30c$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $51c8f0da15dbd30c$var$_create_class(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
var $51c8f0da15dbd30c$var$input$1 = $51c8f0da15dbd30c$var$Input$4$1;
$51c8f0da15dbd30c$var$Input$4$1.default = $51c8f0da15dbd30c$var$Input$4$1;
if ($51c8f0da15dbd30c$var$terminalHighlight$2 && $51c8f0da15dbd30c$var$terminalHighlight$2.registerInput) $51c8f0da15dbd30c$var$terminalHighlight$2.registerInput($51c8f0da15dbd30c$var$Input$4$1);
var $51c8f0da15dbd30c$var$SourceMapConsumer$3 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator$3 = $51c8f0da15dbd30c$var$require$$2$1.SourceMapGenerator;
var $51c8f0da15dbd30c$var$dirname$2 = $51c8f0da15dbd30c$var$require$$2$1.dirname, $51c8f0da15dbd30c$var$relative$1 = $51c8f0da15dbd30c$var$require$$2$1.relative, $51c8f0da15dbd30c$var$resolve$2 = $51c8f0da15dbd30c$var$require$$2$1.resolve, $51c8f0da15dbd30c$var$sep$1 = $51c8f0da15dbd30c$var$require$$2$1.sep;
var $51c8f0da15dbd30c$var$pathToFileURL$2 = $51c8f0da15dbd30c$var$require$$2$1.pathToFileURL;
var $51c8f0da15dbd30c$var$Input$3$1 = $51c8f0da15dbd30c$var$input$1;
var $51c8f0da15dbd30c$var$sourceMapAvailable$2 = Boolean($51c8f0da15dbd30c$var$SourceMapConsumer$3 && $51c8f0da15dbd30c$var$SourceMapGenerator$3);
var $51c8f0da15dbd30c$var$pathAvailable$2 = Boolean($51c8f0da15dbd30c$var$dirname$2 && $51c8f0da15dbd30c$var$resolve$2 && $51c8f0da15dbd30c$var$relative$1 && $51c8f0da15dbd30c$var$sep$1);
var $51c8f0da15dbd30c$var$MapGenerator$2$1 = /*#__PURE__*/ function() {
    function MapGenerator(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $51c8f0da15dbd30c$var$dirname$2(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $51c8f0da15dbd30c$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($51c8f0da15dbd30c$var$pathAvailable$2 && $51c8f0da15dbd30c$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $51c8f0da15dbd30c$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $51c8f0da15dbd30c$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $51c8f0da15dbd30c$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $51c8f0da15dbd30c$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $51c8f0da15dbd30c$var$dirname$2($51c8f0da15dbd30c$var$resolve$2(from, this.mapOpts.annotation));
        var path = $51c8f0da15dbd30c$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $51c8f0da15dbd30c$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($51c8f0da15dbd30c$require$Buffer) return $51c8f0da15dbd30c$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($51c8f0da15dbd30c$var$pathToFileURL$2) {
            var fileURL = $51c8f0da15dbd30c$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($51c8f0da15dbd30c$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator;
}();
var $51c8f0da15dbd30c$var$mapGenerator$1 = $51c8f0da15dbd30c$var$MapGenerator$2$1;
var $51c8f0da15dbd30c$var$Node$2$1 = $51c8f0da15dbd30c$var$node$1;
var $51c8f0da15dbd30c$var$Comment$4$1 = /*#__PURE__*/ function(Node$2$1) {
    $51c8f0da15dbd30c$var$_inherits(Comment, Node$2$1);
    function Comment(defaults) {
        var _this;
        _this = Node$2$1.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment;
}($51c8f0da15dbd30c$var$Node$2$1);
var $51c8f0da15dbd30c$var$comment$1 = $51c8f0da15dbd30c$var$Comment$4$1;
$51c8f0da15dbd30c$var$Comment$4$1.default = $51c8f0da15dbd30c$var$Comment$4$1;
var $51c8f0da15dbd30c$var$isClean$1$1 = $51c8f0da15dbd30c$var$symbols$1.isClean, $51c8f0da15dbd30c$var$my$1$1 = $51c8f0da15dbd30c$var$symbols$1.my;
var $51c8f0da15dbd30c$var$Declaration$3$1 = $51c8f0da15dbd30c$var$declaration$1;
var $51c8f0da15dbd30c$var$Comment$3$1 = $51c8f0da15dbd30c$var$comment$1;
var $51c8f0da15dbd30c$var$Node$1$1 = $51c8f0da15dbd30c$var$node$1;
var $51c8f0da15dbd30c$var$parse$4$1, $51c8f0da15dbd30c$var$Rule$4$1, $51c8f0da15dbd30c$var$AtRule$4$1, $51c8f0da15dbd30c$var$Root$6$1;
function $51c8f0da15dbd30c$var$cleanSource$1(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $51c8f0da15dbd30c$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $51c8f0da15dbd30c$var$markDirtyUp$1(node2) {
    node2[$51c8f0da15dbd30c$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $51c8f0da15dbd30c$var$markDirtyUp$1(i2);
    }
}
var $51c8f0da15dbd30c$var$Container$7$1 = /*#__PURE__*/ function(Node$1$1) {
    $51c8f0da15dbd30c$var$_inherits(Container, Node$1$1);
    function Container() {
        return Node$1$1.apply(this, arguments) || this;
    }
    var _proto = Container.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $51c8f0da15dbd30c$var$cleanSource$1($51c8f0da15dbd30c$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $51c8f0da15dbd30c$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $51c8f0da15dbd30c$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $51c8f0da15dbd30c$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $51c8f0da15dbd30c$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$51c8f0da15dbd30c$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$51c8f0da15dbd30c$var$isClean$1$1]) $51c8f0da15dbd30c$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $51c8f0da15dbd30c$var$_create_class(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}($51c8f0da15dbd30c$var$Node$1$1);
$51c8f0da15dbd30c$var$Container$7$1.registerParse = function(dependant) {
    $51c8f0da15dbd30c$var$parse$4$1 = dependant;
};
$51c8f0da15dbd30c$var$Container$7$1.registerRule = function(dependant) {
    $51c8f0da15dbd30c$var$Rule$4$1 = dependant;
};
$51c8f0da15dbd30c$var$Container$7$1.registerAtRule = function(dependant) {
    $51c8f0da15dbd30c$var$AtRule$4$1 = dependant;
};
$51c8f0da15dbd30c$var$Container$7$1.registerRoot = function(dependant) {
    $51c8f0da15dbd30c$var$Root$6$1 = dependant;
};
var $51c8f0da15dbd30c$var$container$1 = $51c8f0da15dbd30c$var$Container$7$1;
$51c8f0da15dbd30c$var$Container$7$1.default = $51c8f0da15dbd30c$var$Container$7$1;
$51c8f0da15dbd30c$var$Container$7$1.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Root$6$1.prototype);
    node2[$51c8f0da15dbd30c$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $51c8f0da15dbd30c$var$Container$7$1.rebuild(child);
    });
};
var $51c8f0da15dbd30c$var$Container$6$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$LazyResult$4$1, $51c8f0da15dbd30c$var$Processor$3$1;
var $51c8f0da15dbd30c$var$Document$3$1 = /*#__PURE__*/ function(Container$6$1) {
    $51c8f0da15dbd30c$var$_inherits(Document2, Container$6$1);
    function Document2(defaults) {
        var _this;
        _this = Container$6$1.call(this, $51c8f0da15dbd30c$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document2.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $51c8f0da15dbd30c$var$LazyResult$4$1(new $51c8f0da15dbd30c$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    };
    return Document2;
}($51c8f0da15dbd30c$var$Container$6$1);
$51c8f0da15dbd30c$var$Document$3$1.registerLazyResult = function(dependant) {
    $51c8f0da15dbd30c$var$LazyResult$4$1 = dependant;
};
$51c8f0da15dbd30c$var$Document$3$1.registerProcessor = function(dependant) {
    $51c8f0da15dbd30c$var$Processor$3$1 = dependant;
};
var $51c8f0da15dbd30c$var$document$1$1 = $51c8f0da15dbd30c$var$Document$3$1;
$51c8f0da15dbd30c$var$Document$3$1.default = $51c8f0da15dbd30c$var$Document$3$1;
var $51c8f0da15dbd30c$var$printed$1 = {};
var $51c8f0da15dbd30c$var$warnOnce$2$1 = function warnOnce(message) {
    if ($51c8f0da15dbd30c$var$printed$1[message]) return;
    $51c8f0da15dbd30c$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $51c8f0da15dbd30c$var$Warning$2$1 = /*#__PURE__*/ function() {
    function Warning(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning;
}();
var $51c8f0da15dbd30c$var$warning$1 = $51c8f0da15dbd30c$var$Warning$2$1;
$51c8f0da15dbd30c$var$Warning$2$1.default = $51c8f0da15dbd30c$var$Warning$2$1;
var $51c8f0da15dbd30c$var$Warning$1$1 = $51c8f0da15dbd30c$var$warning$1;
var $51c8f0da15dbd30c$var$Result$3$1 = /*#__PURE__*/ function() {
    function Result(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $51c8f0da15dbd30c$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $51c8f0da15dbd30c$var$_create_class(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
var $51c8f0da15dbd30c$var$result$1 = $51c8f0da15dbd30c$var$Result$3$1;
$51c8f0da15dbd30c$var$Result$3$1.default = $51c8f0da15dbd30c$var$Result$3$1;
var $51c8f0da15dbd30c$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
var $51c8f0da15dbd30c$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var $51c8f0da15dbd30c$var$BACKSLASH$1 = "\\".charCodeAt(0);
var $51c8f0da15dbd30c$var$SLASH$1 = "/".charCodeAt(0);
var $51c8f0da15dbd30c$var$NEWLINE$1 = "\n".charCodeAt(0);
var $51c8f0da15dbd30c$var$SPACE$1 = " ".charCodeAt(0);
var $51c8f0da15dbd30c$var$FEED$1 = "\f".charCodeAt(0);
var $51c8f0da15dbd30c$var$TAB$1 = "	".charCodeAt(0);
var $51c8f0da15dbd30c$var$CR$1 = "\r".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_CURLY$1 = "{".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
var $51c8f0da15dbd30c$var$SEMICOLON$1 = ";".charCodeAt(0);
var $51c8f0da15dbd30c$var$ASTERISK$1 = "*".charCodeAt(0);
var $51c8f0da15dbd30c$var$COLON$1 = ":".charCodeAt(0);
var $51c8f0da15dbd30c$var$AT$1 = "@".charCodeAt(0);
var $51c8f0da15dbd30c$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $51c8f0da15dbd30c$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $51c8f0da15dbd30c$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var $51c8f0da15dbd30c$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $51c8f0da15dbd30c$var$tokenize$1 = function tokenizer(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $51c8f0da15dbd30c$var$NEWLINE$1:
            case $51c8f0da15dbd30c$var$SPACE$1:
            case $51c8f0da15dbd30c$var$TAB$1:
            case $51c8f0da15dbd30c$var$CR$1:
            case $51c8f0da15dbd30c$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $51c8f0da15dbd30c$var$SPACE$1 || code === $51c8f0da15dbd30c$var$NEWLINE$1 || code === $51c8f0da15dbd30c$var$TAB$1 || code === $51c8f0da15dbd30c$var$CR$1 || code === $51c8f0da15dbd30c$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $51c8f0da15dbd30c$var$OPEN_SQUARE$1:
            case $51c8f0da15dbd30c$var$CLOSE_SQUARE$1:
            case $51c8f0da15dbd30c$var$OPEN_CURLY$1:
            case $51c8f0da15dbd30c$var$CLOSE_CURLY$1:
            case $51c8f0da15dbd30c$var$COLON$1:
            case $51c8f0da15dbd30c$var$SEMICOLON$1:
            case $51c8f0da15dbd30c$var$CLOSE_PARENTHESES$1:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $51c8f0da15dbd30c$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $51c8f0da15dbd30c$var$SINGLE_QUOTE$1 && n2 !== $51c8f0da15dbd30c$var$DOUBLE_QUOTE$1 && n2 !== $51c8f0da15dbd30c$var$SPACE$1 && n2 !== $51c8f0da15dbd30c$var$NEWLINE$1 && n2 !== $51c8f0da15dbd30c$var$TAB$1 && n2 !== $51c8f0da15dbd30c$var$FEED$1 && n2 !== $51c8f0da15dbd30c$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $51c8f0da15dbd30c$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $51c8f0da15dbd30c$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $51c8f0da15dbd30c$var$SINGLE_QUOTE$1:
            case $51c8f0da15dbd30c$var$DOUBLE_QUOTE$1:
                quote = code === $51c8f0da15dbd30c$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $51c8f0da15dbd30c$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $51c8f0da15dbd30c$var$AT$1:
                $51c8f0da15dbd30c$var$RE_AT_END$1.lastIndex = pos + 1;
                $51c8f0da15dbd30c$var$RE_AT_END$1.test(css);
                if ($51c8f0da15dbd30c$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $51c8f0da15dbd30c$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $51c8f0da15dbd30c$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $51c8f0da15dbd30c$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $51c8f0da15dbd30c$var$SLASH$1 && code !== $51c8f0da15dbd30c$var$SPACE$1 && code !== $51c8f0da15dbd30c$var$NEWLINE$1 && code !== $51c8f0da15dbd30c$var$TAB$1 && code !== $51c8f0da15dbd30c$var$CR$1 && code !== $51c8f0da15dbd30c$var$FEED$1) {
                    next += 1;
                    if ($51c8f0da15dbd30c$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($51c8f0da15dbd30c$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $51c8f0da15dbd30c$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $51c8f0da15dbd30c$var$SLASH$1 && css.charCodeAt(pos + 1) === $51c8f0da15dbd30c$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $51c8f0da15dbd30c$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $51c8f0da15dbd30c$var$RE_WORD_END$1.test(css);
                    if ($51c8f0da15dbd30c$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $51c8f0da15dbd30c$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $51c8f0da15dbd30c$var$Container$5$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$AtRule$3$1 = /*#__PURE__*/ function(Container$5$1) {
    $51c8f0da15dbd30c$var$_inherits(AtRule, Container$5$1);
    function AtRule(defaults) {
        var _this;
        _this = Container$5$1.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_append = Container$5$1.prototype.append).call.apply(_Container$5$1_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_prepend = Container$5$1.prototype.prepend).call.apply(_Container$5$1_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule;
}($51c8f0da15dbd30c$var$Container$5$1);
var $51c8f0da15dbd30c$var$atRule$1 = $51c8f0da15dbd30c$var$AtRule$3$1;
$51c8f0da15dbd30c$var$AtRule$3$1.default = $51c8f0da15dbd30c$var$AtRule$3$1;
$51c8f0da15dbd30c$var$Container$5$1.registerAtRule($51c8f0da15dbd30c$var$AtRule$3$1);
var $51c8f0da15dbd30c$var$Container$4$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$LazyResult$3$1, $51c8f0da15dbd30c$var$Processor$2$1;
var $51c8f0da15dbd30c$var$Root$5$1 = /*#__PURE__*/ function(Container$4$1) {
    $51c8f0da15dbd30c$var$_inherits(Root, Container$4$1);
    function Root(defaults) {
        var _this;
        _this = Container$4$1.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4$1.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4$1.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $51c8f0da15dbd30c$var$LazyResult$3$1(new $51c8f0da15dbd30c$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    };
    return Root;
}($51c8f0da15dbd30c$var$Container$4$1);
$51c8f0da15dbd30c$var$Root$5$1.registerLazyResult = function(dependant) {
    $51c8f0da15dbd30c$var$LazyResult$3$1 = dependant;
};
$51c8f0da15dbd30c$var$Root$5$1.registerProcessor = function(dependant) {
    $51c8f0da15dbd30c$var$Processor$2$1 = dependant;
};
var $51c8f0da15dbd30c$var$root$1 = $51c8f0da15dbd30c$var$Root$5$1;
$51c8f0da15dbd30c$var$Root$5$1.default = $51c8f0da15dbd30c$var$Root$5$1;
$51c8f0da15dbd30c$var$Container$4$1.registerRoot($51c8f0da15dbd30c$var$Root$5$1);
var $51c8f0da15dbd30c$var$list$2$1 = {
    comma: function comma(string) {
        return $51c8f0da15dbd30c$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $51c8f0da15dbd30c$var$list$2$1.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $51c8f0da15dbd30c$var$list_1$1 = $51c8f0da15dbd30c$var$list$2$1;
$51c8f0da15dbd30c$var$list$2$1.default = $51c8f0da15dbd30c$var$list$2$1;
var $51c8f0da15dbd30c$var$Container$3$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$list$1$1 = $51c8f0da15dbd30c$var$list_1$1;
var $51c8f0da15dbd30c$var$Rule$3$1 = /*#__PURE__*/ function(Container$3$1) {
    $51c8f0da15dbd30c$var$_inherits(Rule, Container$3$1);
    function Rule(defaults) {
        var _this;
        _this = Container$3$1.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $51c8f0da15dbd30c$var$_create_class(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $51c8f0da15dbd30c$var$list$1$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule;
}($51c8f0da15dbd30c$var$Container$3$1);
var $51c8f0da15dbd30c$var$rule$1 = $51c8f0da15dbd30c$var$Rule$3$1;
$51c8f0da15dbd30c$var$Rule$3$1.default = $51c8f0da15dbd30c$var$Rule$3$1;
$51c8f0da15dbd30c$var$Container$3$1.registerRule($51c8f0da15dbd30c$var$Rule$3$1);
var $51c8f0da15dbd30c$var$Declaration$2$1 = $51c8f0da15dbd30c$var$declaration$1;
var $51c8f0da15dbd30c$var$tokenizer2$1 = $51c8f0da15dbd30c$var$tokenize$1;
var $51c8f0da15dbd30c$var$Comment$2$1 = $51c8f0da15dbd30c$var$comment$1;
var $51c8f0da15dbd30c$var$AtRule$2$1 = $51c8f0da15dbd30c$var$atRule$1;
var $51c8f0da15dbd30c$var$Root$4$1 = $51c8f0da15dbd30c$var$root$1;
var $51c8f0da15dbd30c$var$Rule$2$1 = $51c8f0da15dbd30c$var$rule$1;
var $51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $51c8f0da15dbd30c$var$findLastWithPosition$1(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $51c8f0da15dbd30c$var$Parser$1$1 = /*#__PURE__*/ function() {
    function Parser(input2) {
        this.input = input2;
        this.root = new $51c8f0da15dbd30c$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $51c8f0da15dbd30c$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $51c8f0da15dbd30c$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $51c8f0da15dbd30c$var$tokenizer2$1(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $51c8f0da15dbd30c$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $51c8f0da15dbd30c$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $51c8f0da15dbd30c$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $51c8f0da15dbd30c$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser;
}();
var $51c8f0da15dbd30c$var$parser$1 = $51c8f0da15dbd30c$var$Parser$1$1;
var $51c8f0da15dbd30c$var$Container$2$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$Parser2$1 = $51c8f0da15dbd30c$var$parser$1;
var $51c8f0da15dbd30c$var$Input$2$1 = $51c8f0da15dbd30c$var$input$1;
function $51c8f0da15dbd30c$var$parse$3$1(css, opts) {
    var input2 = new $51c8f0da15dbd30c$var$Input$2$1(css, opts);
    var parser2 = new $51c8f0da15dbd30c$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $51c8f0da15dbd30c$var$parse_1$1 = $51c8f0da15dbd30c$var$parse$3$1;
$51c8f0da15dbd30c$var$parse$3$1.default = $51c8f0da15dbd30c$var$parse$3$1;
$51c8f0da15dbd30c$var$Container$2$1.registerParse($51c8f0da15dbd30c$var$parse$3$1);
var $51c8f0da15dbd30c$var$isClean$3 = $51c8f0da15dbd30c$var$symbols$1.isClean, $51c8f0da15dbd30c$var$my$3 = $51c8f0da15dbd30c$var$symbols$1.my;
var $51c8f0da15dbd30c$var$MapGenerator$1$1 = $51c8f0da15dbd30c$var$mapGenerator$1;
var $51c8f0da15dbd30c$var$stringify$2$1 = $51c8f0da15dbd30c$var$stringify_1$1;
var $51c8f0da15dbd30c$var$Container$1$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$Document$2$1 = $51c8f0da15dbd30c$var$document$1$1;
var $51c8f0da15dbd30c$var$warnOnce$1$1 = $51c8f0da15dbd30c$var$warnOnce$2$1;
var $51c8f0da15dbd30c$var$Result$2$1 = $51c8f0da15dbd30c$var$result$1;
var $51c8f0da15dbd30c$var$parse$2$1 = $51c8f0da15dbd30c$var$parse_1$1;
var $51c8f0da15dbd30c$var$Root$3$1 = $51c8f0da15dbd30c$var$root$1;
var $51c8f0da15dbd30c$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $51c8f0da15dbd30c$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $51c8f0da15dbd30c$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $51c8f0da15dbd30c$var$CHILDREN$1 = 0;
function $51c8f0da15dbd30c$var$isPromise$1(obj) {
    return (typeof obj === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $51c8f0da15dbd30c$var$getEvents$1(node2) {
    var key = false;
    var type = $51c8f0da15dbd30c$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $51c8f0da15dbd30c$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $51c8f0da15dbd30c$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $51c8f0da15dbd30c$var$toStack$1(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $51c8f0da15dbd30c$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $51c8f0da15dbd30c$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $51c8f0da15dbd30c$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $51c8f0da15dbd30c$var$cleanMarks$1(node2) {
    node2[$51c8f0da15dbd30c$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $51c8f0da15dbd30c$var$cleanMarks$1(i2);
    });
    return node2;
}
var $51c8f0da15dbd30c$var$postcss$2$1 = {};
var $51c8f0da15dbd30c$var$LazyResult$2$1 = /*#__PURE__*/ function() {
    function LazyResult(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $51c8f0da15dbd30c$var$cleanMarks$1(css);
        else if ($51c8f0da15dbd30c$var$_instanceof(css, LazyResult) || $51c8f0da15dbd30c$var$_instanceof(css, $51c8f0da15dbd30c$var$Result$2$1)) {
            root2 = $51c8f0da15dbd30c$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $51c8f0da15dbd30c$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$51c8f0da15dbd30c$var$my$3]) $51c8f0da15dbd30c$var$Container$1$1.rebuild(root2);
        }
        this.result = new $51c8f0da15dbd30c$var$Result$2$1(processor2, root2, opts);
        this.helpers = $51c8f0da15dbd30c$var$_extends({}, $51c8f0da15dbd30c$var$postcss$2$1, {
            postcss: $51c8f0da15dbd30c$var$postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $51c8f0da15dbd30c$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$51c8f0da15dbd30c$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$51c8f0da15dbd30c$var$NOT_VISITORS$1[event]) {
                    if ($51c8f0da15dbd30c$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $51c8f0da15dbd30c$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $51c8f0da15dbd30c$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$51c8f0da15dbd30c$var$isPromise$1(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$51c8f0da15dbd30c$var$isClean$3]) return [
                            3,
                            14
                        ];
                        root2[$51c8f0da15dbd30c$var$isClean$3] = true;
                        stack = [
                            $51c8f0da15dbd30c$var$toStack$1(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$51c8f0da15dbd30c$var$isPromise$1(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $51c8f0da15dbd30c$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $51c8f0da15dbd30c$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($51c8f0da15dbd30c$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $51c8f0da15dbd30c$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $51c8f0da15dbd30c$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($51c8f0da15dbd30c$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$51c8f0da15dbd30c$var$isClean$3]){
                root2[$51c8f0da15dbd30c$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($51c8f0da15dbd30c$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$51c8f0da15dbd30c$var$isClean$3]) {
                    child[$51c8f0da15dbd30c$var$isClean$3] = true;
                    stack.push($51c8f0da15dbd30c$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $51c8f0da15dbd30c$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$51c8f0da15dbd30c$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$51c8f0da15dbd30c$var$isClean$3] = true;
        var events = $51c8f0da15dbd30c$var$getEvents$1(node2);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $51c8f0da15dbd30c$var$CHILDREN$1) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$51c8f0da15dbd30c$var$isClean$3]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $51c8f0da15dbd30c$var$_create_class(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$51c8f0da15dbd30c$var$LazyResult$2$1.registerPostcss = function(dependant) {
    $51c8f0da15dbd30c$var$postcss$2$1 = dependant;
};
var $51c8f0da15dbd30c$var$lazyResult$1 = $51c8f0da15dbd30c$var$LazyResult$2$1;
$51c8f0da15dbd30c$var$LazyResult$2$1.default = $51c8f0da15dbd30c$var$LazyResult$2$1;
$51c8f0da15dbd30c$var$Root$3$1.registerLazyResult($51c8f0da15dbd30c$var$LazyResult$2$1);
$51c8f0da15dbd30c$var$Document$2$1.registerLazyResult($51c8f0da15dbd30c$var$LazyResult$2$1);
var $51c8f0da15dbd30c$var$MapGenerator2$1 = $51c8f0da15dbd30c$var$mapGenerator$1;
var $51c8f0da15dbd30c$var$stringify$1$1 = $51c8f0da15dbd30c$var$stringify_1$1;
var $51c8f0da15dbd30c$var$warnOnce2$1 = $51c8f0da15dbd30c$var$warnOnce$2$1;
var $51c8f0da15dbd30c$var$parse$1$1 = $51c8f0da15dbd30c$var$parse_1$1;
var $51c8f0da15dbd30c$var$Result$1$1 = $51c8f0da15dbd30c$var$result$1;
var $51c8f0da15dbd30c$var$NoWorkResult$1$1 = /*#__PURE__*/ function() {
    function NoWorkResult(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $51c8f0da15dbd30c$var$stringify$1$1;
        this.result = new $51c8f0da15dbd30c$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $51c8f0da15dbd30c$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $51c8f0da15dbd30c$var$_create_class(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $51c8f0da15dbd30c$var$parse$1$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
var $51c8f0da15dbd30c$var$noWorkResult$1 = $51c8f0da15dbd30c$var$NoWorkResult$1$1;
$51c8f0da15dbd30c$var$NoWorkResult$1$1.default = $51c8f0da15dbd30c$var$NoWorkResult$1$1;
var $51c8f0da15dbd30c$var$NoWorkResult2$1 = $51c8f0da15dbd30c$var$noWorkResult$1;
var $51c8f0da15dbd30c$var$LazyResult$1$1 = $51c8f0da15dbd30c$var$lazyResult$1;
var $51c8f0da15dbd30c$var$Document$1$1 = $51c8f0da15dbd30c$var$document$1$1;
var $51c8f0da15dbd30c$var$Root$2$1 = $51c8f0da15dbd30c$var$root$1;
var $51c8f0da15dbd30c$var$Processor$1$1 = /*#__PURE__*/ function() {
    function Processor(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $51c8f0da15dbd30c$var$NoWorkResult2$1(this, css, opts);
        else return new $51c8f0da15dbd30c$var$LazyResult$1$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor;
}();
var $51c8f0da15dbd30c$var$processor$1 = $51c8f0da15dbd30c$var$Processor$1$1;
$51c8f0da15dbd30c$var$Processor$1$1.default = $51c8f0da15dbd30c$var$Processor$1$1;
$51c8f0da15dbd30c$var$Root$2$1.registerProcessor($51c8f0da15dbd30c$var$Processor$1$1);
$51c8f0da15dbd30c$var$Document$1$1.registerProcessor($51c8f0da15dbd30c$var$Processor$1$1);
var $51c8f0da15dbd30c$var$Declaration$1$1 = $51c8f0da15dbd30c$var$declaration$1;
var $51c8f0da15dbd30c$var$PreviousMap2$1 = $51c8f0da15dbd30c$var$previousMap$1;
var $51c8f0da15dbd30c$var$Comment$1$1 = $51c8f0da15dbd30c$var$comment$1;
var $51c8f0da15dbd30c$var$AtRule$1$1 = $51c8f0da15dbd30c$var$atRule$1;
var $51c8f0da15dbd30c$var$Input$1$1 = $51c8f0da15dbd30c$var$input$1;
var $51c8f0da15dbd30c$var$Root$1$1 = $51c8f0da15dbd30c$var$root$1;
var $51c8f0da15dbd30c$var$Rule$1$1 = $51c8f0da15dbd30c$var$rule$1;
function $51c8f0da15dbd30c$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $51c8f0da15dbd30c$var$fromJSON$1$1(n2);
    });
    var ownInputs = json.inputs, defaults = $51c8f0da15dbd30c$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $51c8f0da15dbd30c$var$_extends({}, input2, {
                __proto__: $51c8f0da15dbd30c$var$Input$1$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $51c8f0da15dbd30c$var$_extends({}, inputHydrated.map, {
                __proto__: $51c8f0da15dbd30c$var$PreviousMap2$1.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $51c8f0da15dbd30c$var$fromJSON$1$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $51c8f0da15dbd30c$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $51c8f0da15dbd30c$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $51c8f0da15dbd30c$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $51c8f0da15dbd30c$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $51c8f0da15dbd30c$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $51c8f0da15dbd30c$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $51c8f0da15dbd30c$var$fromJSON_1$1 = $51c8f0da15dbd30c$var$fromJSON$1$1;
$51c8f0da15dbd30c$var$fromJSON$1$1.default = $51c8f0da15dbd30c$var$fromJSON$1$1;
var $51c8f0da15dbd30c$var$CssSyntaxError2$1 = $51c8f0da15dbd30c$var$cssSyntaxError$1;
var $51c8f0da15dbd30c$var$Declaration2$1 = $51c8f0da15dbd30c$var$declaration$1;
var $51c8f0da15dbd30c$var$LazyResult2$1 = $51c8f0da15dbd30c$var$lazyResult$1;
var $51c8f0da15dbd30c$var$Container2$1 = $51c8f0da15dbd30c$var$container$1;
var $51c8f0da15dbd30c$var$Processor2$1 = $51c8f0da15dbd30c$var$processor$1;
var $51c8f0da15dbd30c$var$stringify$5 = $51c8f0da15dbd30c$var$stringify_1$1;
var $51c8f0da15dbd30c$var$fromJSON$2 = $51c8f0da15dbd30c$var$fromJSON_1$1;
var $51c8f0da15dbd30c$var$Document22 = $51c8f0da15dbd30c$var$document$1$1;
var $51c8f0da15dbd30c$var$Warning2$1 = $51c8f0da15dbd30c$var$warning$1;
var $51c8f0da15dbd30c$var$Comment2$1 = $51c8f0da15dbd30c$var$comment$1;
var $51c8f0da15dbd30c$var$AtRule2$1 = $51c8f0da15dbd30c$var$atRule$1;
var $51c8f0da15dbd30c$var$Result2$1 = $51c8f0da15dbd30c$var$result$1;
var $51c8f0da15dbd30c$var$Input2$1 = $51c8f0da15dbd30c$var$input$1;
var $51c8f0da15dbd30c$var$parse$5 = $51c8f0da15dbd30c$var$parse_1$1;
var $51c8f0da15dbd30c$var$list$3 = $51c8f0da15dbd30c$var$list_1$1;
var $51c8f0da15dbd30c$var$Rule2$1 = $51c8f0da15dbd30c$var$rule$1;
var $51c8f0da15dbd30c$var$Root2$1 = $51c8f0da15dbd30c$var$root$1;
var $51c8f0da15dbd30c$var$Node2$1 = $51c8f0da15dbd30c$var$node$1;
function $51c8f0da15dbd30c$var$postcss$3() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $51c8f0da15dbd30c$var$Processor2$1(plugins);
}
$51c8f0da15dbd30c$var$postcss$3.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $51c8f0da15dbd30c$var$Processor2$1().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $51c8f0da15dbd30c$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$51c8f0da15dbd30c$var$postcss$3.stringify = $51c8f0da15dbd30c$var$stringify$5;
$51c8f0da15dbd30c$var$postcss$3.parse = $51c8f0da15dbd30c$var$parse$5;
$51c8f0da15dbd30c$var$postcss$3.fromJSON = $51c8f0da15dbd30c$var$fromJSON$2;
$51c8f0da15dbd30c$var$postcss$3.list = $51c8f0da15dbd30c$var$list$3;
$51c8f0da15dbd30c$var$postcss$3.comment = function(defaults) {
    return new $51c8f0da15dbd30c$var$Comment2$1(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.atRule = function(defaults) {
    return new $51c8f0da15dbd30c$var$AtRule2$1(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.decl = function(defaults) {
    return new $51c8f0da15dbd30c$var$Declaration2$1(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.rule = function(defaults) {
    return new $51c8f0da15dbd30c$var$Rule2$1(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.root = function(defaults) {
    return new $51c8f0da15dbd30c$var$Root2$1(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.document = function(defaults) {
    return new $51c8f0da15dbd30c$var$Document22(defaults);
};
$51c8f0da15dbd30c$var$postcss$3.CssSyntaxError = $51c8f0da15dbd30c$var$CssSyntaxError2$1;
$51c8f0da15dbd30c$var$postcss$3.Declaration = $51c8f0da15dbd30c$var$Declaration2$1;
$51c8f0da15dbd30c$var$postcss$3.Container = $51c8f0da15dbd30c$var$Container2$1;
$51c8f0da15dbd30c$var$postcss$3.Processor = $51c8f0da15dbd30c$var$Processor2$1;
$51c8f0da15dbd30c$var$postcss$3.Document = $51c8f0da15dbd30c$var$Document22;
$51c8f0da15dbd30c$var$postcss$3.Comment = $51c8f0da15dbd30c$var$Comment2$1;
$51c8f0da15dbd30c$var$postcss$3.Warning = $51c8f0da15dbd30c$var$Warning2$1;
$51c8f0da15dbd30c$var$postcss$3.AtRule = $51c8f0da15dbd30c$var$AtRule2$1;
$51c8f0da15dbd30c$var$postcss$3.Result = $51c8f0da15dbd30c$var$Result2$1;
$51c8f0da15dbd30c$var$postcss$3.Input = $51c8f0da15dbd30c$var$Input2$1;
$51c8f0da15dbd30c$var$postcss$3.Rule = $51c8f0da15dbd30c$var$Rule2$1;
$51c8f0da15dbd30c$var$postcss$3.Root = $51c8f0da15dbd30c$var$Root2$1;
$51c8f0da15dbd30c$var$postcss$3.Node = $51c8f0da15dbd30c$var$Node2$1;
$51c8f0da15dbd30c$var$LazyResult2$1.registerPostcss($51c8f0da15dbd30c$var$postcss$3);
var $51c8f0da15dbd30c$var$postcss_1$1 = $51c8f0da15dbd30c$var$postcss$3;
$51c8f0da15dbd30c$var$postcss$3.default = $51c8f0da15dbd30c$var$postcss$3;
var $51c8f0da15dbd30c$var$postcss$1$1 = /* @__PURE__ */ $51c8f0da15dbd30c$var$getDefaultExportFromCjs$1($51c8f0da15dbd30c$var$postcss_1$1);
$51c8f0da15dbd30c$var$postcss$1$1.stringify;
$51c8f0da15dbd30c$var$postcss$1$1.fromJSON;
$51c8f0da15dbd30c$var$postcss$1$1.plugin;
$51c8f0da15dbd30c$var$postcss$1$1.parse;
$51c8f0da15dbd30c$var$postcss$1$1.list;
$51c8f0da15dbd30c$var$postcss$1$1.document;
$51c8f0da15dbd30c$var$postcss$1$1.comment;
$51c8f0da15dbd30c$var$postcss$1$1.atRule;
$51c8f0da15dbd30c$var$postcss$1$1.rule;
$51c8f0da15dbd30c$var$postcss$1$1.decl;
$51c8f0da15dbd30c$var$postcss$1$1.root;
$51c8f0da15dbd30c$var$postcss$1$1.CssSyntaxError;
$51c8f0da15dbd30c$var$postcss$1$1.Declaration;
$51c8f0da15dbd30c$var$postcss$1$1.Container;
$51c8f0da15dbd30c$var$postcss$1$1.Processor;
$51c8f0da15dbd30c$var$postcss$1$1.Document;
$51c8f0da15dbd30c$var$postcss$1$1.Comment;
$51c8f0da15dbd30c$var$postcss$1$1.Warning;
$51c8f0da15dbd30c$var$postcss$1$1.AtRule;
$51c8f0da15dbd30c$var$postcss$1$1.Result;
$51c8f0da15dbd30c$var$postcss$1$1.Input;
$51c8f0da15dbd30c$var$postcss$1$1.Rule;
$51c8f0da15dbd30c$var$postcss$1$1.Root;
$51c8f0da15dbd30c$var$postcss$1$1.Node;
var $51c8f0da15dbd30c$var$__defProp2 = Object.defineProperty;
var $51c8f0da15dbd30c$var$__defNormalProp2 = function(obj, key, value) {
    return key in obj ? $51c8f0da15dbd30c$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $51c8f0da15dbd30c$var$__publicField2 = function(obj, key, value) {
    return $51c8f0da15dbd30c$var$__defNormalProp2(obj, (typeof key === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $51c8f0da15dbd30c$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $51c8f0da15dbd30c$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($51c8f0da15dbd30c$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $51c8f0da15dbd30c$var$picocolors_browser = {
    exports: {}
};
var $51c8f0da15dbd30c$var$x = String;
var $51c8f0da15dbd30c$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $51c8f0da15dbd30c$var$x,
        bold: $51c8f0da15dbd30c$var$x,
        dim: $51c8f0da15dbd30c$var$x,
        italic: $51c8f0da15dbd30c$var$x,
        underline: $51c8f0da15dbd30c$var$x,
        inverse: $51c8f0da15dbd30c$var$x,
        hidden: $51c8f0da15dbd30c$var$x,
        strikethrough: $51c8f0da15dbd30c$var$x,
        black: $51c8f0da15dbd30c$var$x,
        red: $51c8f0da15dbd30c$var$x,
        green: $51c8f0da15dbd30c$var$x,
        yellow: $51c8f0da15dbd30c$var$x,
        blue: $51c8f0da15dbd30c$var$x,
        magenta: $51c8f0da15dbd30c$var$x,
        cyan: $51c8f0da15dbd30c$var$x,
        white: $51c8f0da15dbd30c$var$x,
        gray: $51c8f0da15dbd30c$var$x,
        bgBlack: $51c8f0da15dbd30c$var$x,
        bgRed: $51c8f0da15dbd30c$var$x,
        bgGreen: $51c8f0da15dbd30c$var$x,
        bgYellow: $51c8f0da15dbd30c$var$x,
        bgBlue: $51c8f0da15dbd30c$var$x,
        bgMagenta: $51c8f0da15dbd30c$var$x,
        bgCyan: $51c8f0da15dbd30c$var$x,
        bgWhite: $51c8f0da15dbd30c$var$x
    };
};
$51c8f0da15dbd30c$var$picocolors_browser.exports = $51c8f0da15dbd30c$var$create();
$51c8f0da15dbd30c$var$picocolors_browser.exports.createColors = $51c8f0da15dbd30c$var$create;
var $51c8f0da15dbd30c$var$picocolors_browserExports = $51c8f0da15dbd30c$var$picocolors_browser.exports;
var $51c8f0da15dbd30c$var$__viteBrowserExternal = {};
var $51c8f0da15dbd30c$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $51c8f0da15dbd30c$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
var $51c8f0da15dbd30c$var$require$$2 = /* @__PURE__ */ $51c8f0da15dbd30c$var$getAugmentedNamespace($51c8f0da15dbd30c$var$__viteBrowserExternal$1);
var $51c8f0da15dbd30c$var$pico = $51c8f0da15dbd30c$var$picocolors_browserExports;
var $51c8f0da15dbd30c$var$terminalHighlight$1 = $51c8f0da15dbd30c$var$require$$2;
var $51c8f0da15dbd30c$var$CssSyntaxError$3 = /*#__PURE__*/ function(Error1) {
    $51c8f0da15dbd30c$var$_inherits(CssSyntaxError2, Error1);
    function CssSyntaxError2(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError2);
        return _this;
    }
    var _proto = CssSyntaxError2.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $51c8f0da15dbd30c$var$pico.isColorSupported;
        if ($51c8f0da15dbd30c$var$terminalHighlight$1) {
            if (color) css = $51c8f0da15dbd30c$var$terminalHighlight$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico_createColors = $51c8f0da15dbd30c$var$pico.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError2;
}($51c8f0da15dbd30c$var$_wrap_native_super(Error));
var $51c8f0da15dbd30c$var$cssSyntaxError = $51c8f0da15dbd30c$var$CssSyntaxError$3;
$51c8f0da15dbd30c$var$CssSyntaxError$3.default = $51c8f0da15dbd30c$var$CssSyntaxError$3;
var $51c8f0da15dbd30c$var$symbols = {};
$51c8f0da15dbd30c$var$symbols.isClean = Symbol("isClean");
$51c8f0da15dbd30c$var$symbols.my = Symbol("my");
var $51c8f0da15dbd30c$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $51c8f0da15dbd30c$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $51c8f0da15dbd30c$var$Stringifier$2 = /*#__PURE__*/ function() {
    function Stringifier2(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier2.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $51c8f0da15dbd30c$var$DEFAULT_RAW[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $51c8f0da15dbd30c$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $51c8f0da15dbd30c$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier2;
}();
var $51c8f0da15dbd30c$var$stringifier = $51c8f0da15dbd30c$var$Stringifier$2;
$51c8f0da15dbd30c$var$Stringifier$2.default = $51c8f0da15dbd30c$var$Stringifier$2;
var $51c8f0da15dbd30c$var$Stringifier$1 = $51c8f0da15dbd30c$var$stringifier;
function $51c8f0da15dbd30c$var$stringify$4(node2, builder) {
    var str = new $51c8f0da15dbd30c$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $51c8f0da15dbd30c$var$stringify_1 = $51c8f0da15dbd30c$var$stringify$4;
$51c8f0da15dbd30c$var$stringify$4.default = $51c8f0da15dbd30c$var$stringify$4;
var $51c8f0da15dbd30c$var$isClean$2 = $51c8f0da15dbd30c$var$symbols.isClean, $51c8f0da15dbd30c$var$my$2 = $51c8f0da15dbd30c$var$symbols.my;
var $51c8f0da15dbd30c$var$CssSyntaxError$2 = $51c8f0da15dbd30c$var$cssSyntaxError;
var $51c8f0da15dbd30c$var$Stringifier22 = $51c8f0da15dbd30c$var$stringifier;
var $51c8f0da15dbd30c$var$stringify$3 = $51c8f0da15dbd30c$var$stringify_1;
function $51c8f0da15dbd30c$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $51c8f0da15dbd30c$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $51c8f0da15dbd30c$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $51c8f0da15dbd30c$var$Node$4 = /*#__PURE__*/ function() {
    function Node3(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$51c8f0da15dbd30c$var$isClean$2] = false;
        this[$51c8f0da15dbd30c$var$my$2] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node3.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $51c8f0da15dbd30c$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $51c8f0da15dbd30c$var$CssSyntaxError$2(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$51c8f0da15dbd30c$var$isClean$2]) {
            this[$51c8f0da15dbd30c$var$isClean$2] = false;
            var next = this;
            while(next = next.parent)next[$51c8f0da15dbd30c$var$isClean$2] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $51c8f0da15dbd30c$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $51c8f0da15dbd30c$var$stringify$3;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $51c8f0da15dbd30c$var$_create_class(Node3, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node3;
}();
var $51c8f0da15dbd30c$var$node = $51c8f0da15dbd30c$var$Node$4;
$51c8f0da15dbd30c$var$Node$4.default = $51c8f0da15dbd30c$var$Node$4;
var $51c8f0da15dbd30c$var$Node$3 = $51c8f0da15dbd30c$var$node;
var $51c8f0da15dbd30c$var$Declaration$4 = /*#__PURE__*/ function(Node$3) {
    $51c8f0da15dbd30c$var$_inherits(Declaration2, Node$3);
    function Declaration2(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $51c8f0da15dbd30c$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $51c8f0da15dbd30c$var$_create_class(Declaration2, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration2;
}($51c8f0da15dbd30c$var$Node$3);
var $51c8f0da15dbd30c$var$declaration = $51c8f0da15dbd30c$var$Declaration$4;
$51c8f0da15dbd30c$var$Declaration$4.default = $51c8f0da15dbd30c$var$Declaration$4;
var $51c8f0da15dbd30c$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $51c8f0da15dbd30c$var$nanoid$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $51c8f0da15dbd30c$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $51c8f0da15dbd30c$var$nonSecure = {
    nanoid: $51c8f0da15dbd30c$var$nanoid$1
};
var $51c8f0da15dbd30c$var$SourceMapConsumer$2 = $51c8f0da15dbd30c$var$require$$2.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator$2 = $51c8f0da15dbd30c$var$require$$2.SourceMapGenerator;
var $51c8f0da15dbd30c$var$existsSync = $51c8f0da15dbd30c$var$require$$2.existsSync, $51c8f0da15dbd30c$var$readFileSync = $51c8f0da15dbd30c$var$require$$2.readFileSync;
var $51c8f0da15dbd30c$var$dirname$1 = $51c8f0da15dbd30c$var$require$$2.dirname, $51c8f0da15dbd30c$var$join = $51c8f0da15dbd30c$var$require$$2.join;
function $51c8f0da15dbd30c$var$fromBase64(str) {
    if ($51c8f0da15dbd30c$require$Buffer) return $51c8f0da15dbd30c$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $51c8f0da15dbd30c$var$PreviousMap$2 = /*#__PURE__*/ function() {
    function PreviousMap2(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $51c8f0da15dbd30c$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap2.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $51c8f0da15dbd30c$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $51c8f0da15dbd30c$var$fromBase64(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $51c8f0da15dbd30c$var$dirname$1(path);
        if ($51c8f0da15dbd30c$var$existsSync(path)) {
            this.mapFile = path;
            return $51c8f0da15dbd30c$var$readFileSync(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($51c8f0da15dbd30c$var$_instanceof(prev, $51c8f0da15dbd30c$var$SourceMapConsumer$2)) return $51c8f0da15dbd30c$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if ($51c8f0da15dbd30c$var$_instanceof(prev, $51c8f0da15dbd30c$var$SourceMapGenerator$2)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $51c8f0da15dbd30c$var$join($51c8f0da15dbd30c$var$dirname$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap2;
}();
var $51c8f0da15dbd30c$var$previousMap = $51c8f0da15dbd30c$var$PreviousMap$2;
$51c8f0da15dbd30c$var$PreviousMap$2.default = $51c8f0da15dbd30c$var$PreviousMap$2;
var $51c8f0da15dbd30c$var$SourceMapConsumer$1 = $51c8f0da15dbd30c$var$require$$2.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator$1 = $51c8f0da15dbd30c$var$require$$2.SourceMapGenerator;
var $51c8f0da15dbd30c$var$fileURLToPath = $51c8f0da15dbd30c$var$require$$2.fileURLToPath, $51c8f0da15dbd30c$var$pathToFileURL$1 = $51c8f0da15dbd30c$var$require$$2.pathToFileURL;
var $51c8f0da15dbd30c$var$isAbsolute = $51c8f0da15dbd30c$var$require$$2.isAbsolute, $51c8f0da15dbd30c$var$resolve$1 = $51c8f0da15dbd30c$var$require$$2.resolve;
var $51c8f0da15dbd30c$var$nanoid = $51c8f0da15dbd30c$var$nonSecure.nanoid;
var $51c8f0da15dbd30c$var$terminalHighlight = $51c8f0da15dbd30c$var$require$$2;
var $51c8f0da15dbd30c$var$CssSyntaxError$1 = $51c8f0da15dbd30c$var$cssSyntaxError;
var $51c8f0da15dbd30c$var$PreviousMap$1 = $51c8f0da15dbd30c$var$previousMap;
var $51c8f0da15dbd30c$var$fromOffsetCache = Symbol("fromOffsetCache");
var $51c8f0da15dbd30c$var$sourceMapAvailable$1 = Boolean($51c8f0da15dbd30c$var$SourceMapConsumer$1 && $51c8f0da15dbd30c$var$SourceMapGenerator$1);
var $51c8f0da15dbd30c$var$pathAvailable$1 = Boolean($51c8f0da15dbd30c$var$resolve$1 && $51c8f0da15dbd30c$var$isAbsolute);
var $51c8f0da15dbd30c$var$Input$4 = /*#__PURE__*/ function() {
    function Input2(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$51c8f0da15dbd30c$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $51c8f0da15dbd30c$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $51c8f0da15dbd30c$var$resolve$1(opts.from);
        }
        if ($51c8f0da15dbd30c$var$pathAvailable$1 && $51c8f0da15dbd30c$var$sourceMapAvailable$1) {
            var map = new $51c8f0da15dbd30c$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $51c8f0da15dbd30c$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input2.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $51c8f0da15dbd30c$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $51c8f0da15dbd30c$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($51c8f0da15dbd30c$var$pathToFileURL$1) result2.input.url = $51c8f0da15dbd30c$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$51c8f0da15dbd30c$var$fromOffsetCache]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$51c8f0da15dbd30c$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$51c8f0da15dbd30c$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $51c8f0da15dbd30c$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($51c8f0da15dbd30c$var$isAbsolute(from.source)) fromUrl = $51c8f0da15dbd30c$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $51c8f0da15dbd30c$var$pathToFileURL$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($51c8f0da15dbd30c$var$fileURLToPath) result2.file = $51c8f0da15dbd30c$var$fileURLToPath(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $51c8f0da15dbd30c$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $51c8f0da15dbd30c$var$_create_class(Input2, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input2;
}();
var $51c8f0da15dbd30c$var$input = $51c8f0da15dbd30c$var$Input$4;
$51c8f0da15dbd30c$var$Input$4.default = $51c8f0da15dbd30c$var$Input$4;
if ($51c8f0da15dbd30c$var$terminalHighlight && $51c8f0da15dbd30c$var$terminalHighlight.registerInput) $51c8f0da15dbd30c$var$terminalHighlight.registerInput($51c8f0da15dbd30c$var$Input$4);
var $51c8f0da15dbd30c$var$SourceMapConsumer = $51c8f0da15dbd30c$var$require$$2.SourceMapConsumer, $51c8f0da15dbd30c$var$SourceMapGenerator = $51c8f0da15dbd30c$var$require$$2.SourceMapGenerator;
var $51c8f0da15dbd30c$var$dirname = $51c8f0da15dbd30c$var$require$$2.dirname, $51c8f0da15dbd30c$var$relative = $51c8f0da15dbd30c$var$require$$2.relative, $51c8f0da15dbd30c$var$resolve$3 = $51c8f0da15dbd30c$var$require$$2.resolve, $51c8f0da15dbd30c$var$sep = $51c8f0da15dbd30c$var$require$$2.sep;
var $51c8f0da15dbd30c$var$pathToFileURL = $51c8f0da15dbd30c$var$require$$2.pathToFileURL;
var $51c8f0da15dbd30c$var$Input$3 = $51c8f0da15dbd30c$var$input;
var $51c8f0da15dbd30c$var$sourceMapAvailable = Boolean($51c8f0da15dbd30c$var$SourceMapConsumer && $51c8f0da15dbd30c$var$SourceMapGenerator);
var $51c8f0da15dbd30c$var$pathAvailable = Boolean($51c8f0da15dbd30c$var$dirname && $51c8f0da15dbd30c$var$resolve$3 && $51c8f0da15dbd30c$var$relative && $51c8f0da15dbd30c$var$sep);
var $51c8f0da15dbd30c$var$MapGenerator$2 = /*#__PURE__*/ function() {
    function MapGenerator2(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator2.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $51c8f0da15dbd30c$var$dirname(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $51c8f0da15dbd30c$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($51c8f0da15dbd30c$var$pathAvailable && $51c8f0da15dbd30c$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $51c8f0da15dbd30c$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $51c8f0da15dbd30c$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $51c8f0da15dbd30c$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $51c8f0da15dbd30c$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $51c8f0da15dbd30c$var$dirname($51c8f0da15dbd30c$var$resolve$3(from, this.mapOpts.annotation));
        var path = $51c8f0da15dbd30c$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $51c8f0da15dbd30c$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($51c8f0da15dbd30c$require$Buffer) return $51c8f0da15dbd30c$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($51c8f0da15dbd30c$var$pathToFileURL) {
            var fileURL = $51c8f0da15dbd30c$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($51c8f0da15dbd30c$var$sep === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator2;
}();
var $51c8f0da15dbd30c$var$mapGenerator = $51c8f0da15dbd30c$var$MapGenerator$2;
var $51c8f0da15dbd30c$var$Node$2 = $51c8f0da15dbd30c$var$node;
var $51c8f0da15dbd30c$var$Comment$4 = /*#__PURE__*/ function(Node$2) {
    $51c8f0da15dbd30c$var$_inherits(Comment2, Node$2);
    function Comment2(defaults) {
        var _this;
        _this = Node$2.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment2;
}($51c8f0da15dbd30c$var$Node$2);
var $51c8f0da15dbd30c$var$comment = $51c8f0da15dbd30c$var$Comment$4;
$51c8f0da15dbd30c$var$Comment$4.default = $51c8f0da15dbd30c$var$Comment$4;
var $51c8f0da15dbd30c$var$isClean$1 = $51c8f0da15dbd30c$var$symbols.isClean, $51c8f0da15dbd30c$var$my$1 = $51c8f0da15dbd30c$var$symbols.my;
var $51c8f0da15dbd30c$var$Declaration$3 = $51c8f0da15dbd30c$var$declaration;
var $51c8f0da15dbd30c$var$Comment$3 = $51c8f0da15dbd30c$var$comment;
var $51c8f0da15dbd30c$var$Node$1 = $51c8f0da15dbd30c$var$node;
var $51c8f0da15dbd30c$var$parse$4, $51c8f0da15dbd30c$var$Rule$4, $51c8f0da15dbd30c$var$AtRule$4, $51c8f0da15dbd30c$var$Root$6;
function $51c8f0da15dbd30c$var$cleanSource(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $51c8f0da15dbd30c$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $51c8f0da15dbd30c$var$markDirtyUp(node2) {
    node2[$51c8f0da15dbd30c$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $51c8f0da15dbd30c$var$markDirtyUp(i2);
    }
}
var $51c8f0da15dbd30c$var$Container$7 = /*#__PURE__*/ function(Node$1) {
    $51c8f0da15dbd30c$var$_inherits(Container2, Node$1);
    function Container2() {
        return Node$1.apply(this, arguments) || this;
    }
    var _proto = Container2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $51c8f0da15dbd30c$var$cleanSource($51c8f0da15dbd30c$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $51c8f0da15dbd30c$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $51c8f0da15dbd30c$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $51c8f0da15dbd30c$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $51c8f0da15dbd30c$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$51c8f0da15dbd30c$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$51c8f0da15dbd30c$var$isClean$1]) $51c8f0da15dbd30c$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($51c8f0da15dbd30c$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $51c8f0da15dbd30c$var$_create_class(Container2, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container2;
}($51c8f0da15dbd30c$var$Node$1);
$51c8f0da15dbd30c$var$Container$7.registerParse = function(dependant) {
    $51c8f0da15dbd30c$var$parse$4 = dependant;
};
$51c8f0da15dbd30c$var$Container$7.registerRule = function(dependant) {
    $51c8f0da15dbd30c$var$Rule$4 = dependant;
};
$51c8f0da15dbd30c$var$Container$7.registerAtRule = function(dependant) {
    $51c8f0da15dbd30c$var$AtRule$4 = dependant;
};
$51c8f0da15dbd30c$var$Container$7.registerRoot = function(dependant) {
    $51c8f0da15dbd30c$var$Root$6 = dependant;
};
var $51c8f0da15dbd30c$var$container = $51c8f0da15dbd30c$var$Container$7;
$51c8f0da15dbd30c$var$Container$7.default = $51c8f0da15dbd30c$var$Container$7;
$51c8f0da15dbd30c$var$Container$7.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $51c8f0da15dbd30c$var$Root$6.prototype);
    node2[$51c8f0da15dbd30c$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $51c8f0da15dbd30c$var$Container$7.rebuild(child);
    });
};
var $51c8f0da15dbd30c$var$Container$6 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$LazyResult$4, $51c8f0da15dbd30c$var$Processor$3;
var $51c8f0da15dbd30c$var$Document$3 = /*#__PURE__*/ function(Container$6) {
    $51c8f0da15dbd30c$var$_inherits(Document23, Container$6);
    function Document23(defaults) {
        var _this;
        _this = Container$6.call(this, $51c8f0da15dbd30c$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document23.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $51c8f0da15dbd30c$var$LazyResult$4(new $51c8f0da15dbd30c$var$Processor$3(), this, opts);
        return lazy.stringify();
    };
    return Document23;
}($51c8f0da15dbd30c$var$Container$6);
$51c8f0da15dbd30c$var$Document$3.registerLazyResult = function(dependant) {
    $51c8f0da15dbd30c$var$LazyResult$4 = dependant;
};
$51c8f0da15dbd30c$var$Document$3.registerProcessor = function(dependant) {
    $51c8f0da15dbd30c$var$Processor$3 = dependant;
};
var $51c8f0da15dbd30c$var$document$1$2 = $51c8f0da15dbd30c$var$Document$3;
$51c8f0da15dbd30c$var$Document$3.default = $51c8f0da15dbd30c$var$Document$3;
var $51c8f0da15dbd30c$var$printed = {};
var $51c8f0da15dbd30c$var$warnOnce$2 = function warnOnce2(message) {
    if ($51c8f0da15dbd30c$var$printed[message]) return;
    $51c8f0da15dbd30c$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $51c8f0da15dbd30c$var$Warning$2 = /*#__PURE__*/ function() {
    function Warning2(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning2.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning2;
}();
var $51c8f0da15dbd30c$var$warning = $51c8f0da15dbd30c$var$Warning$2;
$51c8f0da15dbd30c$var$Warning$2.default = $51c8f0da15dbd30c$var$Warning$2;
var $51c8f0da15dbd30c$var$Warning$1 = $51c8f0da15dbd30c$var$warning;
var $51c8f0da15dbd30c$var$Result$3 = /*#__PURE__*/ function() {
    function Result2(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result2.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $51c8f0da15dbd30c$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $51c8f0da15dbd30c$var$_create_class(Result2, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result2;
}();
var $51c8f0da15dbd30c$var$result = $51c8f0da15dbd30c$var$Result$3;
$51c8f0da15dbd30c$var$Result$3.default = $51c8f0da15dbd30c$var$Result$3;
var $51c8f0da15dbd30c$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $51c8f0da15dbd30c$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $51c8f0da15dbd30c$var$BACKSLASH = "\\".charCodeAt(0);
var $51c8f0da15dbd30c$var$SLASH = "/".charCodeAt(0);
var $51c8f0da15dbd30c$var$NEWLINE = "\n".charCodeAt(0);
var $51c8f0da15dbd30c$var$SPACE = " ".charCodeAt(0);
var $51c8f0da15dbd30c$var$FEED = "\f".charCodeAt(0);
var $51c8f0da15dbd30c$var$TAB = "	".charCodeAt(0);
var $51c8f0da15dbd30c$var$CR = "\r".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_SQUARE = "[".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $51c8f0da15dbd30c$var$OPEN_CURLY = "{".charCodeAt(0);
var $51c8f0da15dbd30c$var$CLOSE_CURLY = "}".charCodeAt(0);
var $51c8f0da15dbd30c$var$SEMICOLON = ";".charCodeAt(0);
var $51c8f0da15dbd30c$var$ASTERISK = "*".charCodeAt(0);
var $51c8f0da15dbd30c$var$COLON = ":".charCodeAt(0);
var $51c8f0da15dbd30c$var$AT = "@".charCodeAt(0);
var $51c8f0da15dbd30c$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $51c8f0da15dbd30c$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $51c8f0da15dbd30c$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $51c8f0da15dbd30c$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $51c8f0da15dbd30c$var$tokenize = function tokenizer2(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $51c8f0da15dbd30c$var$NEWLINE:
            case $51c8f0da15dbd30c$var$SPACE:
            case $51c8f0da15dbd30c$var$TAB:
            case $51c8f0da15dbd30c$var$CR:
            case $51c8f0da15dbd30c$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $51c8f0da15dbd30c$var$SPACE || code === $51c8f0da15dbd30c$var$NEWLINE || code === $51c8f0da15dbd30c$var$TAB || code === $51c8f0da15dbd30c$var$CR || code === $51c8f0da15dbd30c$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $51c8f0da15dbd30c$var$OPEN_SQUARE:
            case $51c8f0da15dbd30c$var$CLOSE_SQUARE:
            case $51c8f0da15dbd30c$var$OPEN_CURLY:
            case $51c8f0da15dbd30c$var$CLOSE_CURLY:
            case $51c8f0da15dbd30c$var$COLON:
            case $51c8f0da15dbd30c$var$SEMICOLON:
            case $51c8f0da15dbd30c$var$CLOSE_PARENTHESES:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $51c8f0da15dbd30c$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $51c8f0da15dbd30c$var$SINGLE_QUOTE && n2 !== $51c8f0da15dbd30c$var$DOUBLE_QUOTE && n2 !== $51c8f0da15dbd30c$var$SPACE && n2 !== $51c8f0da15dbd30c$var$NEWLINE && n2 !== $51c8f0da15dbd30c$var$TAB && n2 !== $51c8f0da15dbd30c$var$FEED && n2 !== $51c8f0da15dbd30c$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $51c8f0da15dbd30c$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $51c8f0da15dbd30c$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $51c8f0da15dbd30c$var$SINGLE_QUOTE:
            case $51c8f0da15dbd30c$var$DOUBLE_QUOTE:
                quote = code === $51c8f0da15dbd30c$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $51c8f0da15dbd30c$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $51c8f0da15dbd30c$var$AT:
                $51c8f0da15dbd30c$var$RE_AT_END.lastIndex = pos + 1;
                $51c8f0da15dbd30c$var$RE_AT_END.test(css);
                if ($51c8f0da15dbd30c$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $51c8f0da15dbd30c$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $51c8f0da15dbd30c$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $51c8f0da15dbd30c$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $51c8f0da15dbd30c$var$SLASH && code !== $51c8f0da15dbd30c$var$SPACE && code !== $51c8f0da15dbd30c$var$NEWLINE && code !== $51c8f0da15dbd30c$var$TAB && code !== $51c8f0da15dbd30c$var$CR && code !== $51c8f0da15dbd30c$var$FEED) {
                    next += 1;
                    if ($51c8f0da15dbd30c$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($51c8f0da15dbd30c$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $51c8f0da15dbd30c$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $51c8f0da15dbd30c$var$SLASH && css.charCodeAt(pos + 1) === $51c8f0da15dbd30c$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $51c8f0da15dbd30c$var$RE_WORD_END.lastIndex = pos + 1;
                    $51c8f0da15dbd30c$var$RE_WORD_END.test(css);
                    if ($51c8f0da15dbd30c$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $51c8f0da15dbd30c$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $51c8f0da15dbd30c$var$Container$5 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$AtRule$3 = /*#__PURE__*/ function(Container$5) {
    $51c8f0da15dbd30c$var$_inherits(AtRule2, Container$5);
    function AtRule2(defaults) {
        var _this;
        _this = Container$5.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_append = Container$5.prototype.append).call.apply(_Container$5_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_prepend = Container$5.prototype.prepend).call.apply(_Container$5_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule2;
}($51c8f0da15dbd30c$var$Container$5);
var $51c8f0da15dbd30c$var$atRule = $51c8f0da15dbd30c$var$AtRule$3;
$51c8f0da15dbd30c$var$AtRule$3.default = $51c8f0da15dbd30c$var$AtRule$3;
$51c8f0da15dbd30c$var$Container$5.registerAtRule($51c8f0da15dbd30c$var$AtRule$3);
var $51c8f0da15dbd30c$var$Container$4 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$LazyResult$3, $51c8f0da15dbd30c$var$Processor$2;
var $51c8f0da15dbd30c$var$Root$5 = /*#__PURE__*/ function(Container$4) {
    $51c8f0da15dbd30c$var$_inherits(Root2, Container$4);
    function Root2(defaults) {
        var _this;
        _this = Container$4.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root2.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $51c8f0da15dbd30c$var$LazyResult$3(new $51c8f0da15dbd30c$var$Processor$2(), this, opts);
        return lazy.stringify();
    };
    return Root2;
}($51c8f0da15dbd30c$var$Container$4);
$51c8f0da15dbd30c$var$Root$5.registerLazyResult = function(dependant) {
    $51c8f0da15dbd30c$var$LazyResult$3 = dependant;
};
$51c8f0da15dbd30c$var$Root$5.registerProcessor = function(dependant) {
    $51c8f0da15dbd30c$var$Processor$2 = dependant;
};
var $51c8f0da15dbd30c$var$root = $51c8f0da15dbd30c$var$Root$5;
$51c8f0da15dbd30c$var$Root$5.default = $51c8f0da15dbd30c$var$Root$5;
$51c8f0da15dbd30c$var$Container$4.registerRoot($51c8f0da15dbd30c$var$Root$5);
var $51c8f0da15dbd30c$var$list$2 = {
    comma: function comma(string) {
        return $51c8f0da15dbd30c$var$list$2.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $51c8f0da15dbd30c$var$list$2.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $51c8f0da15dbd30c$var$list_1 = $51c8f0da15dbd30c$var$list$2;
$51c8f0da15dbd30c$var$list$2.default = $51c8f0da15dbd30c$var$list$2;
var $51c8f0da15dbd30c$var$Container$3 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$list$1 = $51c8f0da15dbd30c$var$list_1;
var $51c8f0da15dbd30c$var$Rule$3 = /*#__PURE__*/ function(Container$3) {
    $51c8f0da15dbd30c$var$_inherits(Rule2, Container$3);
    function Rule2(defaults) {
        var _this;
        _this = Container$3.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $51c8f0da15dbd30c$var$_create_class(Rule2, [
        {
            key: "selectors",
            get: function get() {
                return $51c8f0da15dbd30c$var$list$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule2;
}($51c8f0da15dbd30c$var$Container$3);
var $51c8f0da15dbd30c$var$rule = $51c8f0da15dbd30c$var$Rule$3;
$51c8f0da15dbd30c$var$Rule$3.default = $51c8f0da15dbd30c$var$Rule$3;
$51c8f0da15dbd30c$var$Container$3.registerRule($51c8f0da15dbd30c$var$Rule$3);
var $51c8f0da15dbd30c$var$Declaration$2 = $51c8f0da15dbd30c$var$declaration;
var $51c8f0da15dbd30c$var$tokenizer22 = $51c8f0da15dbd30c$var$tokenize;
var $51c8f0da15dbd30c$var$Comment$2 = $51c8f0da15dbd30c$var$comment;
var $51c8f0da15dbd30c$var$AtRule$2 = $51c8f0da15dbd30c$var$atRule;
var $51c8f0da15dbd30c$var$Root$4 = $51c8f0da15dbd30c$var$root;
var $51c8f0da15dbd30c$var$Rule$2 = $51c8f0da15dbd30c$var$rule;
var $51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $51c8f0da15dbd30c$var$findLastWithPosition(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $51c8f0da15dbd30c$var$Parser$1 = /*#__PURE__*/ function() {
    function Parser2(input2) {
        this.input = input2;
        this.root = new $51c8f0da15dbd30c$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser2.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $51c8f0da15dbd30c$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $51c8f0da15dbd30c$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $51c8f0da15dbd30c$var$tokenizer22(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $51c8f0da15dbd30c$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $51c8f0da15dbd30c$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $51c8f0da15dbd30c$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR[prev] && !$51c8f0da15dbd30c$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $51c8f0da15dbd30c$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser2;
}();
var $51c8f0da15dbd30c$var$parser = $51c8f0da15dbd30c$var$Parser$1;
var $51c8f0da15dbd30c$var$Container$2 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$Parser22 = $51c8f0da15dbd30c$var$parser;
var $51c8f0da15dbd30c$var$Input$2 = $51c8f0da15dbd30c$var$input;
function $51c8f0da15dbd30c$var$parse$3(css, opts) {
    var input2 = new $51c8f0da15dbd30c$var$Input$2(css, opts);
    var parser2 = new $51c8f0da15dbd30c$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $51c8f0da15dbd30c$var$parse_1 = $51c8f0da15dbd30c$var$parse$3;
$51c8f0da15dbd30c$var$parse$3.default = $51c8f0da15dbd30c$var$parse$3;
$51c8f0da15dbd30c$var$Container$2.registerParse($51c8f0da15dbd30c$var$parse$3);
var $51c8f0da15dbd30c$var$isClean = $51c8f0da15dbd30c$var$symbols.isClean, $51c8f0da15dbd30c$var$my = $51c8f0da15dbd30c$var$symbols.my;
var $51c8f0da15dbd30c$var$MapGenerator$1 = $51c8f0da15dbd30c$var$mapGenerator;
var $51c8f0da15dbd30c$var$stringify$2 = $51c8f0da15dbd30c$var$stringify_1;
var $51c8f0da15dbd30c$var$Container$1 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$Document$2 = $51c8f0da15dbd30c$var$document$1$2;
var $51c8f0da15dbd30c$var$warnOnce$1 = $51c8f0da15dbd30c$var$warnOnce$2;
var $51c8f0da15dbd30c$var$Result$2 = $51c8f0da15dbd30c$var$result;
var $51c8f0da15dbd30c$var$parse$2 = $51c8f0da15dbd30c$var$parse_1;
var $51c8f0da15dbd30c$var$Root$3 = $51c8f0da15dbd30c$var$root;
var $51c8f0da15dbd30c$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $51c8f0da15dbd30c$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $51c8f0da15dbd30c$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $51c8f0da15dbd30c$var$CHILDREN = 0;
function $51c8f0da15dbd30c$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $51c8f0da15dbd30c$var$getEvents(node2) {
    var key = false;
    var type = $51c8f0da15dbd30c$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $51c8f0da15dbd30c$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $51c8f0da15dbd30c$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $51c8f0da15dbd30c$var$toStack(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $51c8f0da15dbd30c$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $51c8f0da15dbd30c$var$CHILDREN,
        "RootExit"
    ];
    else events = $51c8f0da15dbd30c$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $51c8f0da15dbd30c$var$cleanMarks(node2) {
    node2[$51c8f0da15dbd30c$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $51c8f0da15dbd30c$var$cleanMarks(i2);
    });
    return node2;
}
var $51c8f0da15dbd30c$var$postcss$2 = {};
var $51c8f0da15dbd30c$var$LazyResult$2 = /*#__PURE__*/ function() {
    function LazyResult2(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $51c8f0da15dbd30c$var$cleanMarks(css);
        else if ($51c8f0da15dbd30c$var$_instanceof(css, LazyResult2) || $51c8f0da15dbd30c$var$_instanceof(css, $51c8f0da15dbd30c$var$Result$2)) {
            root2 = $51c8f0da15dbd30c$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $51c8f0da15dbd30c$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$51c8f0da15dbd30c$var$my]) $51c8f0da15dbd30c$var$Container$1.rebuild(root2);
        }
        this.result = new $51c8f0da15dbd30c$var$Result$2(processor2, root2, opts);
        this.helpers = $51c8f0da15dbd30c$var$_extends({}, $51c8f0da15dbd30c$var$postcss$2, {
            postcss: $51c8f0da15dbd30c$var$postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $51c8f0da15dbd30c$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$51c8f0da15dbd30c$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$51c8f0da15dbd30c$var$NOT_VISITORS[event]) {
                    if ($51c8f0da15dbd30c$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $51c8f0da15dbd30c$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $51c8f0da15dbd30c$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$51c8f0da15dbd30c$var$isPromise(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$51c8f0da15dbd30c$var$isClean]) return [
                            3,
                            14
                        ];
                        root2[$51c8f0da15dbd30c$var$isClean] = true;
                        stack = [
                            $51c8f0da15dbd30c$var$toStack(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$51c8f0da15dbd30c$var$isPromise(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $51c8f0da15dbd30c$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $51c8f0da15dbd30c$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($51c8f0da15dbd30c$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $51c8f0da15dbd30c$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $51c8f0da15dbd30c$var$MapGenerator$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($51c8f0da15dbd30c$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$51c8f0da15dbd30c$var$isClean]){
                root2[$51c8f0da15dbd30c$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($51c8f0da15dbd30c$var$isPromise(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$51c8f0da15dbd30c$var$isClean]) {
                    child[$51c8f0da15dbd30c$var$isClean] = true;
                    stack.push($51c8f0da15dbd30c$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $51c8f0da15dbd30c$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$51c8f0da15dbd30c$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$51c8f0da15dbd30c$var$isClean] = true;
        var events = $51c8f0da15dbd30c$var$getEvents(node2);
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $51c8f0da15dbd30c$var$CHILDREN) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$51c8f0da15dbd30c$var$isClean]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $51c8f0da15dbd30c$var$_create_class(LazyResult2, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult2;
}();
$51c8f0da15dbd30c$var$LazyResult$2.registerPostcss = function(dependant) {
    $51c8f0da15dbd30c$var$postcss$2 = dependant;
};
var $51c8f0da15dbd30c$var$lazyResult = $51c8f0da15dbd30c$var$LazyResult$2;
$51c8f0da15dbd30c$var$LazyResult$2.default = $51c8f0da15dbd30c$var$LazyResult$2;
$51c8f0da15dbd30c$var$Root$3.registerLazyResult($51c8f0da15dbd30c$var$LazyResult$2);
$51c8f0da15dbd30c$var$Document$2.registerLazyResult($51c8f0da15dbd30c$var$LazyResult$2);
var $51c8f0da15dbd30c$var$MapGenerator22 = $51c8f0da15dbd30c$var$mapGenerator;
var $51c8f0da15dbd30c$var$stringify$1 = $51c8f0da15dbd30c$var$stringify_1;
var $51c8f0da15dbd30c$var$warnOnce22 = $51c8f0da15dbd30c$var$warnOnce$2;
var $51c8f0da15dbd30c$var$parse$1 = $51c8f0da15dbd30c$var$parse_1;
var $51c8f0da15dbd30c$var$Result$1 = $51c8f0da15dbd30c$var$result;
var $51c8f0da15dbd30c$var$NoWorkResult$1 = /*#__PURE__*/ function() {
    function NoWorkResult2(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $51c8f0da15dbd30c$var$stringify$1;
        this.result = new $51c8f0da15dbd30c$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $51c8f0da15dbd30c$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $51c8f0da15dbd30c$var$_create_class(NoWorkResult2, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $51c8f0da15dbd30c$var$parse$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult2;
}();
var $51c8f0da15dbd30c$var$noWorkResult = $51c8f0da15dbd30c$var$NoWorkResult$1;
$51c8f0da15dbd30c$var$NoWorkResult$1.default = $51c8f0da15dbd30c$var$NoWorkResult$1;
var $51c8f0da15dbd30c$var$NoWorkResult22 = $51c8f0da15dbd30c$var$noWorkResult;
var $51c8f0da15dbd30c$var$LazyResult$1 = $51c8f0da15dbd30c$var$lazyResult;
var $51c8f0da15dbd30c$var$Document$1 = $51c8f0da15dbd30c$var$document$1$2;
var $51c8f0da15dbd30c$var$Root$2 = $51c8f0da15dbd30c$var$root;
var $51c8f0da15dbd30c$var$Processor$1 = /*#__PURE__*/ function() {
    function Processor2(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor2.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $51c8f0da15dbd30c$var$NoWorkResult22(this, css, opts);
        else return new $51c8f0da15dbd30c$var$LazyResult$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor2;
}();
var $51c8f0da15dbd30c$var$processor = $51c8f0da15dbd30c$var$Processor$1;
$51c8f0da15dbd30c$var$Processor$1.default = $51c8f0da15dbd30c$var$Processor$1;
$51c8f0da15dbd30c$var$Root$2.registerProcessor($51c8f0da15dbd30c$var$Processor$1);
$51c8f0da15dbd30c$var$Document$1.registerProcessor($51c8f0da15dbd30c$var$Processor$1);
var $51c8f0da15dbd30c$var$Declaration$1 = $51c8f0da15dbd30c$var$declaration;
var $51c8f0da15dbd30c$var$PreviousMap22 = $51c8f0da15dbd30c$var$previousMap;
var $51c8f0da15dbd30c$var$Comment$1 = $51c8f0da15dbd30c$var$comment;
var $51c8f0da15dbd30c$var$AtRule$1 = $51c8f0da15dbd30c$var$atRule;
var $51c8f0da15dbd30c$var$Input$1 = $51c8f0da15dbd30c$var$input;
var $51c8f0da15dbd30c$var$Root$1 = $51c8f0da15dbd30c$var$root;
var $51c8f0da15dbd30c$var$Rule$1 = $51c8f0da15dbd30c$var$rule;
function $51c8f0da15dbd30c$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $51c8f0da15dbd30c$var$fromJSON$1(n2);
    });
    var ownInputs = json.inputs, defaults = $51c8f0da15dbd30c$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $51c8f0da15dbd30c$var$_extends({}, input2, {
                __proto__: $51c8f0da15dbd30c$var$Input$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $51c8f0da15dbd30c$var$_extends({}, inputHydrated.map, {
                __proto__: $51c8f0da15dbd30c$var$PreviousMap22.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $51c8f0da15dbd30c$var$fromJSON$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $51c8f0da15dbd30c$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $51c8f0da15dbd30c$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $51c8f0da15dbd30c$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $51c8f0da15dbd30c$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $51c8f0da15dbd30c$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $51c8f0da15dbd30c$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $51c8f0da15dbd30c$var$fromJSON_1 = $51c8f0da15dbd30c$var$fromJSON$1;
$51c8f0da15dbd30c$var$fromJSON$1.default = $51c8f0da15dbd30c$var$fromJSON$1;
var $51c8f0da15dbd30c$var$CssSyntaxError22 = $51c8f0da15dbd30c$var$cssSyntaxError;
var $51c8f0da15dbd30c$var$Declaration22 = $51c8f0da15dbd30c$var$declaration;
var $51c8f0da15dbd30c$var$LazyResult22 = $51c8f0da15dbd30c$var$lazyResult;
var $51c8f0da15dbd30c$var$Container22 = $51c8f0da15dbd30c$var$container;
var $51c8f0da15dbd30c$var$Processor22 = $51c8f0da15dbd30c$var$processor;
var $51c8f0da15dbd30c$var$stringify$6 = $51c8f0da15dbd30c$var$stringify_1;
var $51c8f0da15dbd30c$var$fromJSON = $51c8f0da15dbd30c$var$fromJSON_1;
var $51c8f0da15dbd30c$var$Document222 = $51c8f0da15dbd30c$var$document$1$2;
var $51c8f0da15dbd30c$var$Warning22 = $51c8f0da15dbd30c$var$warning;
var $51c8f0da15dbd30c$var$Comment22 = $51c8f0da15dbd30c$var$comment;
var $51c8f0da15dbd30c$var$AtRule22 = $51c8f0da15dbd30c$var$atRule;
var $51c8f0da15dbd30c$var$Result22 = $51c8f0da15dbd30c$var$result;
var $51c8f0da15dbd30c$var$Input22 = $51c8f0da15dbd30c$var$input;
var $51c8f0da15dbd30c$var$parse = $51c8f0da15dbd30c$var$parse_1;
var $51c8f0da15dbd30c$var$list = $51c8f0da15dbd30c$var$list_1;
var $51c8f0da15dbd30c$var$Rule22 = $51c8f0da15dbd30c$var$rule;
var $51c8f0da15dbd30c$var$Root22 = $51c8f0da15dbd30c$var$root;
var $51c8f0da15dbd30c$var$Node22 = $51c8f0da15dbd30c$var$node;
function $51c8f0da15dbd30c$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $51c8f0da15dbd30c$var$Processor22(plugins);
}
$51c8f0da15dbd30c$var$postcss.plugin = function plugin2(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $51c8f0da15dbd30c$var$Processor22().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $51c8f0da15dbd30c$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$51c8f0da15dbd30c$var$postcss.stringify = $51c8f0da15dbd30c$var$stringify$6;
$51c8f0da15dbd30c$var$postcss.parse = $51c8f0da15dbd30c$var$parse;
$51c8f0da15dbd30c$var$postcss.fromJSON = $51c8f0da15dbd30c$var$fromJSON;
$51c8f0da15dbd30c$var$postcss.list = $51c8f0da15dbd30c$var$list;
$51c8f0da15dbd30c$var$postcss.comment = function(defaults) {
    return new $51c8f0da15dbd30c$var$Comment22(defaults);
};
$51c8f0da15dbd30c$var$postcss.atRule = function(defaults) {
    return new $51c8f0da15dbd30c$var$AtRule22(defaults);
};
$51c8f0da15dbd30c$var$postcss.decl = function(defaults) {
    return new $51c8f0da15dbd30c$var$Declaration22(defaults);
};
$51c8f0da15dbd30c$var$postcss.rule = function(defaults) {
    return new $51c8f0da15dbd30c$var$Rule22(defaults);
};
$51c8f0da15dbd30c$var$postcss.root = function(defaults) {
    return new $51c8f0da15dbd30c$var$Root22(defaults);
};
$51c8f0da15dbd30c$var$postcss.document = function(defaults) {
    return new $51c8f0da15dbd30c$var$Document222(defaults);
};
$51c8f0da15dbd30c$var$postcss.CssSyntaxError = $51c8f0da15dbd30c$var$CssSyntaxError22;
$51c8f0da15dbd30c$var$postcss.Declaration = $51c8f0da15dbd30c$var$Declaration22;
$51c8f0da15dbd30c$var$postcss.Container = $51c8f0da15dbd30c$var$Container22;
$51c8f0da15dbd30c$var$postcss.Processor = $51c8f0da15dbd30c$var$Processor22;
$51c8f0da15dbd30c$var$postcss.Document = $51c8f0da15dbd30c$var$Document222;
$51c8f0da15dbd30c$var$postcss.Comment = $51c8f0da15dbd30c$var$Comment22;
$51c8f0da15dbd30c$var$postcss.Warning = $51c8f0da15dbd30c$var$Warning22;
$51c8f0da15dbd30c$var$postcss.AtRule = $51c8f0da15dbd30c$var$AtRule22;
$51c8f0da15dbd30c$var$postcss.Result = $51c8f0da15dbd30c$var$Result22;
$51c8f0da15dbd30c$var$postcss.Input = $51c8f0da15dbd30c$var$Input22;
$51c8f0da15dbd30c$var$postcss.Rule = $51c8f0da15dbd30c$var$Rule22;
$51c8f0da15dbd30c$var$postcss.Root = $51c8f0da15dbd30c$var$Root22;
$51c8f0da15dbd30c$var$postcss.Node = $51c8f0da15dbd30c$var$Node22;
$51c8f0da15dbd30c$var$LazyResult22.registerPostcss($51c8f0da15dbd30c$var$postcss);
var $51c8f0da15dbd30c$var$postcss_1 = $51c8f0da15dbd30c$var$postcss;
$51c8f0da15dbd30c$var$postcss.default = $51c8f0da15dbd30c$var$postcss;
var $51c8f0da15dbd30c$var$postcss$1 = /* @__PURE__ */ $51c8f0da15dbd30c$var$getDefaultExportFromCjs($51c8f0da15dbd30c$var$postcss_1);
$51c8f0da15dbd30c$var$postcss$1.stringify;
$51c8f0da15dbd30c$var$postcss$1.fromJSON;
$51c8f0da15dbd30c$var$postcss$1.plugin;
$51c8f0da15dbd30c$var$postcss$1.parse;
$51c8f0da15dbd30c$var$postcss$1.list;
$51c8f0da15dbd30c$var$postcss$1.document;
$51c8f0da15dbd30c$var$postcss$1.comment;
$51c8f0da15dbd30c$var$postcss$1.atRule;
$51c8f0da15dbd30c$var$postcss$1.rule;
$51c8f0da15dbd30c$var$postcss$1.decl;
$51c8f0da15dbd30c$var$postcss$1.root;
$51c8f0da15dbd30c$var$postcss$1.CssSyntaxError;
$51c8f0da15dbd30c$var$postcss$1.Declaration;
$51c8f0da15dbd30c$var$postcss$1.Container;
$51c8f0da15dbd30c$var$postcss$1.Processor;
$51c8f0da15dbd30c$var$postcss$1.Document;
$51c8f0da15dbd30c$var$postcss$1.Comment;
$51c8f0da15dbd30c$var$postcss$1.Warning;
$51c8f0da15dbd30c$var$postcss$1.AtRule;
$51c8f0da15dbd30c$var$postcss$1.Result;
$51c8f0da15dbd30c$var$postcss$1.Input;
$51c8f0da15dbd30c$var$postcss$1.Rule;
$51c8f0da15dbd30c$var$postcss$1.Root;
$51c8f0da15dbd30c$var$postcss$1.Node;
var $51c8f0da15dbd30c$var$BaseRRNode = /*#__PURE__*/ function() {
    function BaseRRNode() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        $51c8f0da15dbd30c$var$__publicField2(this, "parentElement", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "parentNode", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "ownerDocument");
        $51c8f0da15dbd30c$var$__publicField2(this, "firstChild", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "lastChild", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "previousSibling", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "nextSibling", null);
        $51c8f0da15dbd30c$var$__publicField2(this, "ELEMENT_NODE", 1);
        $51c8f0da15dbd30c$var$__publicField2(this, "TEXT_NODE", 3);
        $51c8f0da15dbd30c$var$__publicField2(this, "nodeType");
        $51c8f0da15dbd30c$var$__publicField2(this, "nodeName");
        $51c8f0da15dbd30c$var$__publicField2(this, "RRNodeType");
    }
    var _proto = BaseRRNode.prototype;
    _proto.contains = function contains(node2) {
        if (!$51c8f0da15dbd30c$var$_instanceof(node2, BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.appendChild = function appendChild(_newChild) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.insertBefore = function insertBefore(_newChild, _refChild) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.removeChild = function removeChild(_node) {
        throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
    };
    _proto.toString = function toString() {
        return "RRNode";
    };
    $51c8f0da15dbd30c$var$_create_class(BaseRRNode, [
        {
            key: "childNodes",
            get: function get() {
                var childNodes2 = [];
                var childIterator = this.firstChild;
                while(childIterator){
                    childNodes2.push(childIterator);
                    childIterator = childIterator.nextSibling;
                }
                return childNodes2;
            }
        }
    ]);
    return BaseRRNode;
}();
var $51c8f0da15dbd30c$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $51c8f0da15dbd30c$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $51c8f0da15dbd30c$var$untaintedBasePrototype = {};
var $51c8f0da15dbd30c$var$isAngularZonePresent = function() {
    return !!globalThis.Zone;
};
function $51c8f0da15dbd30c$var$getUntaintedPrototype(key) {
    if ($51c8f0da15dbd30c$var$untaintedBasePrototype[key]) return $51c8f0da15dbd30c$var$untaintedBasePrototype[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $51c8f0da15dbd30c$var$testableAccessors ? $51c8f0da15dbd30c$var$testableAccessors[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $51c8f0da15dbd30c$var$testableMethods ? $51c8f0da15dbd30c$var$testableMethods[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$51c8f0da15dbd30c$var$isAngularZonePresent()) {
        $51c8f0da15dbd30c$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $51c8f0da15dbd30c$var$untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $51c8f0da15dbd30c$var$untaintedAccessorCache = {};
function $51c8f0da15dbd30c$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($51c8f0da15dbd30c$var$untaintedAccessorCache[cacheKey]) return $51c8f0da15dbd30c$var$untaintedAccessorCache[cacheKey].call(instance);
    var untaintedPrototype = $51c8f0da15dbd30c$var$getUntaintedPrototype(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $51c8f0da15dbd30c$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $51c8f0da15dbd30c$var$untaintedMethodCache = {};
function $51c8f0da15dbd30c$var$getUntaintedMethod(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($51c8f0da15dbd30c$var$untaintedMethodCache[cacheKey]) return $51c8f0da15dbd30c$var$untaintedMethodCache[cacheKey].bind(instance);
    var untaintedPrototype = $51c8f0da15dbd30c$var$getUntaintedPrototype(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $51c8f0da15dbd30c$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $51c8f0da15dbd30c$var$childNodes(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $51c8f0da15dbd30c$var$parentNode(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $51c8f0da15dbd30c$var$parentElement(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $51c8f0da15dbd30c$var$textContent(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $51c8f0da15dbd30c$var$contains(n2, other) {
    return $51c8f0da15dbd30c$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $51c8f0da15dbd30c$var$getRootNode(n2) {
    return $51c8f0da15dbd30c$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $51c8f0da15dbd30c$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $51c8f0da15dbd30c$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $51c8f0da15dbd30c$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $51c8f0da15dbd30c$var$querySelector(n2, selectors) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $51c8f0da15dbd30c$var$querySelectorAll(n2, selectors) {
    return $51c8f0da15dbd30c$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $51c8f0da15dbd30c$var$mutationObserverCtor() {
    return $51c8f0da15dbd30c$var$getUntaintedPrototype("MutationObserver").constructor;
}
function $51c8f0da15dbd30c$var$patch$2(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $51c8f0da15dbd30c$var$index = {
    childNodes: $51c8f0da15dbd30c$var$childNodes,
    parentNode: $51c8f0da15dbd30c$var$parentNode,
    parentElement: $51c8f0da15dbd30c$var$parentElement,
    textContent: $51c8f0da15dbd30c$var$textContent,
    contains: $51c8f0da15dbd30c$var$contains,
    getRootNode: $51c8f0da15dbd30c$var$getRootNode,
    host: $51c8f0da15dbd30c$var$host,
    styleSheets: $51c8f0da15dbd30c$var$styleSheets,
    shadowRoot: $51c8f0da15dbd30c$var$shadowRoot,
    querySelector: $51c8f0da15dbd30c$var$querySelector,
    querySelectorAll: $51c8f0da15dbd30c$var$querySelectorAll,
    mutationObserver: $51c8f0da15dbd30c$var$mutationObserverCtor,
    patch: $51c8f0da15dbd30c$var$patch$2
};
function $51c8f0da15dbd30c$var$on(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $51c8f0da15dbd30c$var$_mirror = {
    map: {},
    getId: function getId() {
        console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $51c8f0da15dbd30c$var$_mirror = new Proxy($51c8f0da15dbd30c$var$_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error($51c8f0da15dbd30c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $51c8f0da15dbd30c$var$throttle(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $51c8f0da15dbd30c$var$hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $51c8f0da15dbd30c$var$hookSetter(target, key, original || {}, true);
    };
}
var $51c8f0da15dbd30c$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $51c8f0da15dbd30c$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $51c8f0da15dbd30c$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $51c8f0da15dbd30c$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $51c8f0da15dbd30c$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $51c8f0da15dbd30c$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $51c8f0da15dbd30c$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $51c8f0da15dbd30c$var$closestElementOfNode(node2) {
    if (!node2) return null;
    var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $51c8f0da15dbd30c$var$index.parentElement(node2);
    return el;
}
function $51c8f0da15dbd30c$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    var el = $51c8f0da15dbd30c$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($51c8f0da15dbd30c$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $51c8f0da15dbd30c$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $51c8f0da15dbd30c$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $51c8f0da15dbd30c$var$IGNORED_NODE;
}
function $51c8f0da15dbd30c$var$isAncestorRemoved(target, mirror2) {
    if ($51c8f0da15dbd30c$var$isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    var parent = $51c8f0da15dbd30c$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $51c8f0da15dbd30c$var$isAncestorRemoved(parent, mirror2);
}
function $51c8f0da15dbd30c$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $51c8f0da15dbd30c$var$polyfill$1(win) {
    if (win === void 0) win = window;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $51c8f0da15dbd30c$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $51c8f0da15dbd30c$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $51c8f0da15dbd30c$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if ($51c8f0da15dbd30c$var$_instanceof(n2, $51c8f0da15dbd30c$var$BaseRRNode) && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($51c8f0da15dbd30c$var$index.shadowRoot(n2));
}
var $51c8f0da15dbd30c$var$StyleSheetMirror = /*#__PURE__*/ function() {
    function StyleSheetMirror() {
        $51c8f0da15dbd30c$var$__publicField$1(this, "id", 1);
        $51c8f0da15dbd30c$var$__publicField$1(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    var _proto = StyleSheetMirror.prototype;
    _proto.getId = function getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    };
    _proto.has = function has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    };
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ _proto.add = function add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        var newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    };
    _proto.getStyle = function getStyle(id) {
        return this.idStyleMap.get(id) || null;
    };
    _proto.reset = function reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    };
    _proto.generateId = function generateId() {
        return this.id++;
    };
    return StyleSheetMirror;
}();
function $51c8f0da15dbd30c$var$getShadowHost(n2) {
    var _a2;
    var shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $51c8f0da15dbd30c$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $51c8f0da15dbd30c$var$index.host($51c8f0da15dbd30c$var$index.getRootNode(n2))) shadowHost = $51c8f0da15dbd30c$var$index.host($51c8f0da15dbd30c$var$index.getRootNode(n2));
    return shadowHost;
}
function $51c8f0da15dbd30c$var$getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = $51c8f0da15dbd30c$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $51c8f0da15dbd30c$var$shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = $51c8f0da15dbd30c$var$getRootShadowHost(n2);
    return $51c8f0da15dbd30c$var$index.contains(doc, shadowHost);
}
function $51c8f0da15dbd30c$var$inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return $51c8f0da15dbd30c$var$index.contains(doc, n2) || $51c8f0da15dbd30c$var$shadowHostInDom(n2);
}
var $51c8f0da15dbd30c$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($51c8f0da15dbd30c$var$EventType || {});
var $51c8f0da15dbd30c$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($51c8f0da15dbd30c$var$IncrementalSource || {});
var $51c8f0da15dbd30c$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($51c8f0da15dbd30c$var$MouseInteractions || {});
var $51c8f0da15dbd30c$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($51c8f0da15dbd30c$var$PointerTypes || {});
var $51c8f0da15dbd30c$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($51c8f0da15dbd30c$var$CanvasContext || {});
var $51c8f0da15dbd30c$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($51c8f0da15dbd30c$var$MediaInteractions || {});
var $51c8f0da15dbd30c$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($51c8f0da15dbd30c$var$NodeType || {});
function $51c8f0da15dbd30c$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $51c8f0da15dbd30c$var$DoubleLinkedList = /*#__PURE__*/ function() {
    function DoubleLinkedList() {
        $51c8f0da15dbd30c$var$__publicField$1(this, "length", 0);
        $51c8f0da15dbd30c$var$__publicField$1(this, "head", null);
        $51c8f0da15dbd30c$var$__publicField$1(this, "tail", null);
    }
    var _proto = DoubleLinkedList.prototype;
    _proto.get = function get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        var current = this.head;
        for(var index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    };
    _proto.addNode = function addNode(n2) {
        var node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $51c8f0da15dbd30c$var$isNodeInLinkedList(n2.previousSibling)) {
            var current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $51c8f0da15dbd30c$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            var current1 = n2.nextSibling.__ln.previous;
            node2.previous = current1;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current1) current1.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    };
    _proto.removeNode = function removeNode(n2) {
        var current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $51c8f0da15dbd30c$var$moveKey = function(id, parentId) {
    return id + "@" + parentId;
};
var $51c8f0da15dbd30c$var$MutationBuffer = /*#__PURE__*/ function() {
    function MutationBuffer() {
        var _this = this;
        $51c8f0da15dbd30c$var$__publicField$1(this, "frozen", false);
        $51c8f0da15dbd30c$var$__publicField$1(this, "locked", false);
        $51c8f0da15dbd30c$var$__publicField$1(this, "texts", []);
        $51c8f0da15dbd30c$var$__publicField$1(this, "attributes", []);
        $51c8f0da15dbd30c$var$__publicField$1(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "removes", []);
        $51c8f0da15dbd30c$var$__publicField$1(this, "mapRemoves", []);
        $51c8f0da15dbd30c$var$__publicField$1(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $51c8f0da15dbd30c$var$__publicField$1(this, "addedSet", /* @__PURE__ */ new Set());
        $51c8f0da15dbd30c$var$__publicField$1(this, "movedSet", /* @__PURE__ */ new Set());
        $51c8f0da15dbd30c$var$__publicField$1(this, "droppedSet", /* @__PURE__ */ new Set());
        $51c8f0da15dbd30c$var$__publicField$1(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $51c8f0da15dbd30c$var$__publicField$1(this, "mutationCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "blockClass");
        $51c8f0da15dbd30c$var$__publicField$1(this, "blockSelector");
        $51c8f0da15dbd30c$var$__publicField$1(this, "maskTextClass");
        $51c8f0da15dbd30c$var$__publicField$1(this, "maskTextSelector");
        $51c8f0da15dbd30c$var$__publicField$1(this, "inlineStylesheet");
        $51c8f0da15dbd30c$var$__publicField$1(this, "maskInputOptions");
        $51c8f0da15dbd30c$var$__publicField$1(this, "maskTextFn");
        $51c8f0da15dbd30c$var$__publicField$1(this, "maskInputFn");
        $51c8f0da15dbd30c$var$__publicField$1(this, "keepIframeSrcFn");
        $51c8f0da15dbd30c$var$__publicField$1(this, "recordCanvas");
        $51c8f0da15dbd30c$var$__publicField$1(this, "inlineImages");
        $51c8f0da15dbd30c$var$__publicField$1(this, "slimDOMOptions");
        $51c8f0da15dbd30c$var$__publicField$1(this, "dataURLOptions");
        $51c8f0da15dbd30c$var$__publicField$1(this, "doc");
        $51c8f0da15dbd30c$var$__publicField$1(this, "mirror");
        $51c8f0da15dbd30c$var$__publicField$1(this, "iframeManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "stylesheetManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "shadowDomManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "canvasManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "processedNodeManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "unattachedDoc");
        $51c8f0da15dbd30c$var$__publicField$1(this, "processMutations", function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        });
        $51c8f0da15dbd30c$var$__publicField$1(this, "emit", function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $51c8f0da15dbd30c$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $51c8f0da15dbd30c$var$IGNORED_NODE;
                while(nextId === $51c8f0da15dbd30c$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                var parent = $51c8f0da15dbd30c$var$index.parentNode(n2);
                if (!parent || !$51c8f0da15dbd30c$var$inDom(n2)) return;
                var cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    var parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && _this.addedSet.has(parent)) cssCaptured = true;
                }
                var parentId = $51c8f0da15dbd30c$var$isShadowRoot(parent) ? _this.mirror.getId($51c8f0da15dbd30c$var$getShadowHost(n2)) : _this.mirror.getId(parent);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $51c8f0da15dbd30c$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($51c8f0da15dbd30c$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($51c8f0da15dbd30c$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($51c8f0da15dbd30c$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot($51c8f0da15dbd30c$var$index.shadowRoot(n2), _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(_this.movedSet), _step; !(_step = _iterator()).done;){
                var n2 = _step.value;
                if ($51c8f0da15dbd30c$var$isParentRemoved(_this.removesSubTreeCache, n2, _this.mirror) && !_this.movedSet.has($51c8f0da15dbd30c$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(_this.addedSet), _step1; !(_step1 = _iterator1()).done;){
                var n21 = _step1.value;
                if (!$51c8f0da15dbd30c$var$isAncestorInSet(_this.droppedSet, n21) && !$51c8f0da15dbd30c$var$isParentRemoved(_this.removesSubTreeCache, n21, _this.mirror)) pushAdd(n21);
                else if ($51c8f0da15dbd30c$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                else _this.droppedSet.add(n21);
            }
            var candidate = null;
            while(addList.length){
                var node2 = null;
                if (candidate) {
                    var parentId = _this.mirror.getId($51c8f0da15dbd30c$var$index.parentNode(candidate.value));
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId($51c8f0da15dbd30c$var$index.parentNode(_node.value));
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                var parent = $51c8f0da15dbd30c$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = $51c8f0da15dbd30c$var$index.host(parent);
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n2 = text.node;
                    var parent = $51c8f0da15dbd30c$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") _this.genTextAreaValueMutation(parent);
                    return {
                        id: _this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.removesSubTreeCache = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        });
        $51c8f0da15dbd30c$var$__publicField$1(this, "genTextAreaValueMutation", function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            var value = Array.from($51c8f0da15dbd30c$var$index.childNodes(textarea), function(cn) {
                return $51c8f0da15dbd30c$var$index.textContent(cn) || "";
            }).join("");
            item.attributes.value = $51c8f0da15dbd30c$var$maskInputValue({
                element: textarea,
                maskInputOptions: _this.maskInputOptions,
                tagName: textarea.tagName,
                type: $51c8f0da15dbd30c$var$getInputType(textarea),
                value: value,
                maskInputFn: _this.maskInputFn
            });
        });
        $51c8f0da15dbd30c$var$__publicField$1(this, "processMutation", function(m) {
            if ($51c8f0da15dbd30c$var$isIgnored(m.target, _this.mirror, _this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    var value = $51c8f0da15dbd30c$var$index.textContent(m.target);
                    if (!$51c8f0da15dbd30c$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                        value: $51c8f0da15dbd30c$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $51c8f0da15dbd30c$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                        node: m.target
                    });
                    break;
                case "attributes":
                    var target = m.target;
                    var attributeName = m.attributeName;
                    var value1 = m.target.getAttribute(attributeName);
                    if (attributeName === "value") {
                        var type = $51c8f0da15dbd30c$var$getInputType(target);
                        value1 = $51c8f0da15dbd30c$var$maskInputValue({
                            element: target,
                            maskInputOptions: _this.maskInputOptions,
                            tagName: target.tagName,
                            type: type,
                            value: value1,
                            maskInputFn: _this.maskInputFn
                        });
                    }
                    if ($51c8f0da15dbd30c$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                    var item = _this.attributeMap.get(m.target);
                    if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                        if (!target.contentDocument) attributeName = "rr_src";
                        else return;
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {}
                        };
                        _this.attributes.push(item);
                        _this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                    if (!$51c8f0da15dbd30c$var$ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = $51c8f0da15dbd30c$var$transformAttribute(_this.doc, $51c8f0da15dbd30c$var$toLowerCase(target.tagName), $51c8f0da15dbd30c$var$toLowerCase(attributeName), value1);
                        if (attributeName === "style") {
                            if (!_this.unattachedDoc) try {
                                _this.unattachedDoc = document.implementation.createHTMLDocument();
                            } catch (e2) {
                                _this.unattachedDoc = _this.doc;
                            }
                            var old = _this.unattachedDoc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(Array.from(target.style)), _step; !(_step = _iterator()).done;){
                                var pname = _step.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === "") item.styleDiff[pname] = newValue;
                                    else item.styleDiff[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                } else item._unchangedStyles[pname] = [
                                    newValue,
                                    newPriority
                                ];
                            }
                            for(var _iterator1 = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(Array.from(old.style)), _step1; !(_step1 = _iterator1()).done;){
                                var pname1 = _step1.value;
                                if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                            }
                        } else if (attributeName === "open" && target.tagName === "DIALOG") {
                            if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                            else item.attributes["rr_open_mode"] = "non-modal";
                        }
                    }
                    break;
                case "childList":
                    if ($51c8f0da15dbd30c$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $51c8f0da15dbd30c$var$isShadowRoot(m.target) ? _this.mirror.getId($51c8f0da15dbd30c$var$index.host(m.target)) : _this.mirror.getId(m.target);
                        if ($51c8f0da15dbd30c$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $51c8f0da15dbd30c$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions) || !$51c8f0da15dbd30c$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $51c8f0da15dbd30c$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($51c8f0da15dbd30c$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$51c8f0da15dbd30c$var$moveKey(nodeId, parentId)]) $51c8f0da15dbd30c$var$deepDelete(_this.movedSet, n2);
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $51c8f0da15dbd30c$var$isShadowRoot(m.target) && $51c8f0da15dbd30c$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $51c8f0da15dbd30c$var$processRemoves(n2, _this.removesSubTreeCache);
                        }
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $51c8f0da15dbd30c$var$__publicField$1(this, "genAdds", function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($51c8f0da15dbd30c$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$51c8f0da15dbd30c$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$51c8f0da15dbd30c$var$isBlocked(n2, _this.blockClass, _this.blockSelector, false)) {
                $51c8f0da15dbd30c$var$index.childNodes(n2).forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($51c8f0da15dbd30c$var$hasShadowRoot(n2)) $51c8f0da15dbd30c$var$index.childNodes($51c8f0da15dbd30c$var$index.shadowRoot(n2)).forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        });
    }
    var _proto = MutationBuffer.prototype;
    _proto.init = function init(options) {
        var _this = this;
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    _proto.isFrozen = function isFrozen() {
        return this.frozen;
    };
    _proto.lock = function lock() {
        this.locked = true;
        this.canvasManager.lock();
    };
    _proto.unlock = function unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    _proto.reset = function reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $51c8f0da15dbd30c$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $51c8f0da15dbd30c$var$index.childNodes(n2).forEach(function(childN) {
        return $51c8f0da15dbd30c$var$deepDelete(addsSet, childN);
    });
}
function $51c8f0da15dbd30c$var$processRemoves(n2, cache) {
    var queue = [
        n2
    ];
    while(queue.length){
        var next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $51c8f0da15dbd30c$var$index.childNodes(next).forEach(function(n22) {
            return queue.push(n22);
        });
    }
    return;
}
function $51c8f0da15dbd30c$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $51c8f0da15dbd30c$var$_isParentRemoved(removes, n2);
}
function $51c8f0da15dbd30c$var$_isParentRemoved(removes, n2, _mirror2) {
    var node2 = $51c8f0da15dbd30c$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $51c8f0da15dbd30c$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $51c8f0da15dbd30c$var$_isAncestorInSet(set, n2);
}
function $51c8f0da15dbd30c$var$_isAncestorInSet(set, n2) {
    var parent = $51c8f0da15dbd30c$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $51c8f0da15dbd30c$var$_isAncestorInSet(set, parent);
}
var $51c8f0da15dbd30c$var$errorHandler;
function $51c8f0da15dbd30c$var$registerErrorHandler(handler) {
    $51c8f0da15dbd30c$var$errorHandler = handler;
}
function $51c8f0da15dbd30c$var$unregisterErrorHandler() {
    $51c8f0da15dbd30c$var$errorHandler = void 0;
}
var $51c8f0da15dbd30c$var$callbackWrapper = function(cb) {
    if (!$51c8f0da15dbd30c$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
        try {
            return cb.apply(void 0, [].concat(rest));
        } catch (error) {
            if ($51c8f0da15dbd30c$var$errorHandler && $51c8f0da15dbd30c$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $51c8f0da15dbd30c$var$mutationBuffers = [];
function $51c8f0da15dbd30c$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $51c8f0da15dbd30c$var$initMutationObserver(options, rootEl) {
    var mutationBuffer = new $51c8f0da15dbd30c$var$MutationBuffer();
    $51c8f0da15dbd30c$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var observer = new ($51c8f0da15dbd30c$var$mutationObserverCtor())($51c8f0da15dbd30c$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $51c8f0da15dbd30c$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $51c8f0da15dbd30c$var$throttle($51c8f0da15dbd30c$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $51c8f0da15dbd30c$var$callbackWrapper($51c8f0da15dbd30c$var$throttle($51c8f0da15dbd30c$var$callbackWrapper(function(evt) {
        var target = $51c8f0da15dbd30c$var$getEventTarget(evt);
        var _ref = $51c8f0da15dbd30c$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $51c8f0da15dbd30c$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $51c8f0da15dbd30c$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && $51c8f0da15dbd30c$var$_instanceof(evt, DragEvent) ? $51c8f0da15dbd30c$var$IncrementalSource.Drag : $51c8f0da15dbd30c$var$_instanceof(evt, MouseEvent) ? $51c8f0da15dbd30c$var$IncrementalSource.MouseMove : $51c8f0da15dbd30c$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $51c8f0da15dbd30c$var$on("mousemove", updatePosition, doc),
        $51c8f0da15dbd30c$var$on("touchmove", updatePosition, doc),
        $51c8f0da15dbd30c$var$on("drag", updatePosition, doc)
    ];
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $51c8f0da15dbd30c$var$getEventTarget(event);
            if ($51c8f0da15dbd30c$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $51c8f0da15dbd30c$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $51c8f0da15dbd30c$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $51c8f0da15dbd30c$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $51c8f0da15dbd30c$var$PointerTypes.Touch) {
                    if ($51c8f0da15dbd30c$var$MouseInteractions[eventKey] === $51c8f0da15dbd30c$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($51c8f0da15dbd30c$var$MouseInteractions[eventKey] === $51c8f0da15dbd30c$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $51c8f0da15dbd30c$var$PointerTypes.Pen;
            } else if ($51c8f0da15dbd30c$var$legacy_isTouchEvent(event)) pointerType = $51c8f0da15dbd30c$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $51c8f0da15dbd30c$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $51c8f0da15dbd30c$var$PointerTypes.Mouse) pointerType = null;
            } else if ($51c8f0da15dbd30c$var$MouseInteractions[eventKey] === $51c8f0da15dbd30c$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $51c8f0da15dbd30c$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $51c8f0da15dbd30c$var$callbackWrapper(mouseInteractionCb)($51c8f0da15dbd30c$var$_extends({
                type: $51c8f0da15dbd30c$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($51c8f0da15dbd30c$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $51c8f0da15dbd30c$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($51c8f0da15dbd30c$var$MouseInteractions[eventKey]){
            case $51c8f0da15dbd30c$var$MouseInteractions.MouseDown:
            case $51c8f0da15dbd30c$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $51c8f0da15dbd30c$var$MouseInteractions.TouchStart:
            case $51c8f0da15dbd30c$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($51c8f0da15dbd30c$var$on(eventName, handler, doc));
    });
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $51c8f0da15dbd30c$var$callbackWrapper($51c8f0da15dbd30c$var$throttle($51c8f0da15dbd30c$var$callbackWrapper(function(evt) {
        var target = $51c8f0da15dbd30c$var$getEventTarget(evt);
        if (!target || $51c8f0da15dbd30c$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $51c8f0da15dbd30c$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $51c8f0da15dbd30c$var$on("scroll", updatePosition, doc);
}
function $51c8f0da15dbd30c$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb;
    var win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $51c8f0da15dbd30c$var$callbackWrapper($51c8f0da15dbd30c$var$throttle($51c8f0da15dbd30c$var$callbackWrapper(function() {
        var height = $51c8f0da15dbd30c$var$getWindowHeight();
        var width = $51c8f0da15dbd30c$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $51c8f0da15dbd30c$var$on("resize", updateDimension, win);
}
var $51c8f0da15dbd30c$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $51c8f0da15dbd30c$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $51c8f0da15dbd30c$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $51c8f0da15dbd30c$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $51c8f0da15dbd30c$var$index.parentElement(target);
        if (!target || !tagName || $51c8f0da15dbd30c$var$INPUT_TAGS.indexOf(tagName) < 0 || $51c8f0da15dbd30c$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $51c8f0da15dbd30c$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $51c8f0da15dbd30c$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(el) {
            if (el !== target) {
                var text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $51c8f0da15dbd30c$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $51c8f0da15dbd30c$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $51c8f0da15dbd30c$var$callbackWrapper(inputCb)($51c8f0da15dbd30c$var$_extends({}, v2, {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $51c8f0da15dbd30c$var$on(eventName, $51c8f0da15dbd30c$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        var _handlers;
        (_handlers = handlers).push.apply(_handlers, [].concat(hookProperties.map(function(p) {
            return $51c8f0da15dbd30c$var$hookSetter(p[0], p[1], {
                set: function set() {
                    $51c8f0da15dbd30c$var$callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow);
        })));
    }
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$getNestedCSSRulePositions(rule2) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($51c8f0da15dbd30c$var$hasNestedCSSRule("CSSGroupingRule") && $51c8f0da15dbd30c$var$_instanceof(childRule.parentRule, CSSGroupingRule) || $51c8f0da15dbd30c$var$hasNestedCSSRule("CSSMediaRule") && $51c8f0da15dbd30c$var$_instanceof(childRule.parentRule, CSSMediaRule) || $51c8f0da15dbd30c$var$hasNestedCSSRule("CSSSupportsRule") && $51c8f0da15dbd30c$var$_instanceof(childRule.parentRule, CSSSupportsRule) || $51c8f0da15dbd30c$var$hasNestedCSSRule("CSSConditionRule") && $51c8f0da15dbd30c$var$_instanceof(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index21 = rules21.indexOf(childRule);
            pos.unshift(index21);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $51c8f0da15dbd30c$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $51c8f0da15dbd30c$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var rule2 = argumentsList[0], index2 = argumentsList[1];
            var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2) {
        if (index2 === void 0) index2 = this.cssRules.length;
        var rule2 = selector + " { " + styleBlock + " }";
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var index2 = argumentsList[0];
            var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($51c8f0da15dbd30c$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($51c8f0da15dbd30c$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($51c8f0da15dbd30c$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($51c8f0da15dbd30c$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var typeKey = param[0], type = param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var rule2 = argumentsList[0], index2 = argumentsList[1];
                var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [].concat($51c8f0da15dbd30c$var$getNestedCSSRulePositions(thisArg), [
                                index2 || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var index2 = argumentsList[0];
                var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [].concat($51c8f0da15dbd30c$var$getNestedCSSRulePositions(thisArg), [
                                index2
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var typeKey = param[0], type = param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $51c8f0da15dbd30c$var$initAdoptedStyleSheetObserver(param, host2) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a2, _b, _c;
    var hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($51c8f0da15dbd30c$var$index.host(host2));
    var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set: function set(sheets) {
            var _a3;
            var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $51c8f0da15dbd30c$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0], value = argumentsList[1], priority = argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $51c8f0da15dbd30c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $51c8f0da15dbd30c$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $51c8f0da15dbd30c$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $51c8f0da15dbd30c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $51c8f0da15dbd30c$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $51c8f0da15dbd30c$var$callbackWrapper(function(type) {
        return $51c8f0da15dbd30c$var$throttle($51c8f0da15dbd30c$var$callbackWrapper(function(event) {
            var target = $51c8f0da15dbd30c$var$getEventTarget(event);
            if (!target || $51c8f0da15dbd30c$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $51c8f0da15dbd30c$var$on("play", handler($51c8f0da15dbd30c$var$MediaInteractions.Play), doc),
        $51c8f0da15dbd30c$var$on("pause", handler($51c8f0da15dbd30c$var$MediaInteractions.Pause), doc),
        $51c8f0da15dbd30c$var$on("seeked", handler($51c8f0da15dbd30c$var$MediaInteractions.Seeked), doc),
        $51c8f0da15dbd30c$var$on("volumechange", handler($51c8f0da15dbd30c$var$MediaInteractions.VolumeChange), doc),
        $51c8f0da15dbd30c$var$on("ratechange", handler($51c8f0da15dbd30c$var$MediaInteractions.RateChange), doc)
    ];
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $51c8f0da15dbd30c$var$patch$2(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($51c8f0da15dbd30c$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $51c8f0da15dbd30c$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $51c8f0da15dbd30c$var$isBlocked(startContainer, blockClass, blockSelector, true) || $51c8f0da15dbd30c$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $51c8f0da15dbd30c$var$on("selectionchange", updateSelection);
}
function $51c8f0da15dbd30c$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $51c8f0da15dbd30c$var$patch$2(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn("Custom element callback failed for " + name);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $51c8f0da15dbd30c$var$mergeHooks(o2, hooks) {
    var mutationCb = o2.mutationCb, mousemoveCb = o2.mousemoveCb, mouseInteractionCb = o2.mouseInteractionCb, scrollCb = o2.scrollCb, viewportResizeCb = o2.viewportResizeCb, inputCb = o2.inputCb, mediaInteractionCb = o2.mediaInteractionCb, styleSheetRuleCb = o2.styleSheetRuleCb, styleDeclarationCb = o2.styleDeclarationCb, canvasMutationCb = o2.canvasMutationCb, fontCb = o2.fontCb, selectionCb = o2.selectionCb, customElementCb = o2.customElementCb;
    o2.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mutation) {
            var _hooks;
            (_hooks = hooks).mutation.apply(_hooks, [].concat(p));
        }
        mutationCb.apply(void 0, [].concat(p));
    };
    o2.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mousemove) {
            var _hooks;
            (_hooks = hooks).mousemove.apply(_hooks, [].concat(p));
        }
        mousemoveCb.apply(void 0, [].concat(p));
    };
    o2.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mouseInteraction) {
            var _hooks;
            (_hooks = hooks).mouseInteraction.apply(_hooks, [].concat(p));
        }
        mouseInteractionCb.apply(void 0, [].concat(p));
    };
    o2.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.scroll) {
            var _hooks;
            (_hooks = hooks).scroll.apply(_hooks, [].concat(p));
        }
        scrollCb.apply(void 0, [].concat(p));
    };
    o2.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.viewportResize) {
            var _hooks;
            (_hooks = hooks).viewportResize.apply(_hooks, [].concat(p));
        }
        viewportResizeCb.apply(void 0, [].concat(p));
    };
    o2.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.input) {
            var _hooks;
            (_hooks = hooks).input.apply(_hooks, [].concat(p));
        }
        inputCb.apply(void 0, [].concat(p));
    };
    o2.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mediaInteaction) {
            var _hooks;
            (_hooks = hooks).mediaInteaction.apply(_hooks, [].concat(p));
        }
        mediaInteractionCb.apply(void 0, [].concat(p));
    };
    o2.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleSheetRule) {
            var _hooks;
            (_hooks = hooks).styleSheetRule.apply(_hooks, [].concat(p));
        }
        styleSheetRuleCb.apply(void 0, [].concat(p));
    };
    o2.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleDeclaration) {
            var _hooks;
            (_hooks = hooks).styleDeclaration.apply(_hooks, [].concat(p));
        }
        styleDeclarationCb.apply(void 0, [].concat(p));
    };
    o2.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.canvasMutation) {
            var _hooks;
            (_hooks = hooks).canvasMutation.apply(_hooks, [].concat(p));
        }
        canvasMutationCb.apply(void 0, [].concat(p));
    };
    o2.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.font) {
            var _hooks;
            (_hooks = hooks).font.apply(_hooks, [].concat(p));
        }
        fontCb.apply(void 0, [].concat(p));
    };
    o2.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.selection) {
            var _hooks;
            (_hooks = hooks).selection.apply(_hooks, [].concat(p));
        }
        selectionCb.apply(void 0, [].concat(p));
    };
    o2.customElementCb = function() {
        for(var _len = arguments.length, c2 = new Array(_len), _key = 0; _key < _len; _key++)c2[_key] = arguments[_key];
        if (hooks.customElement) {
            var _hooks;
            (_hooks = hooks).customElement.apply(_hooks, [].concat(c2));
        }
        customElementCb.apply(void 0, [].concat(c2));
    };
}
function $51c8f0da15dbd30c$var$initObservers(o2, hooks) {
    if (hooks === void 0) hooks = {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    $51c8f0da15dbd30c$var$mergeHooks(o2, hooks);
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $51c8f0da15dbd30c$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $51c8f0da15dbd30c$var$initMoveObserver(o2);
    var mouseInteractionHandler = $51c8f0da15dbd30c$var$initMouseInteractionObserver(o2);
    var scrollHandler = $51c8f0da15dbd30c$var$initScrollObserver(o2);
    var viewportResizeHandler = $51c8f0da15dbd30c$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $51c8f0da15dbd30c$var$initInputObserver(o2);
    var mediaInteractionHandler = $51c8f0da15dbd30c$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $51c8f0da15dbd30c$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $51c8f0da15dbd30c$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $51c8f0da15dbd30c$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $51c8f0da15dbd30c$var$initFontObserver(o2);
    }
    var selectionObserver = $51c8f0da15dbd30c$var$initSelectionObserver(o2);
    var customElementObserver = $51c8f0da15dbd30c$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(o2.plugins), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return $51c8f0da15dbd30c$var$callbackWrapper(function() {
        $51c8f0da15dbd30c$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $51c8f0da15dbd30c$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $51c8f0da15dbd30c$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $51c8f0da15dbd30c$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    function CrossOriginIframeMirror(generateIdFn) {
        $51c8f0da15dbd30c$var$__publicField$1(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    var _proto = CrossOriginIframeMirror.prototype;
    _proto.getId = function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        var id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    };
    _proto.getIds = function getIds(iframe, remoteId) {
        var _this = this;
        var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map(function(id) {
            return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
        });
    };
    _proto.getRemoteId = function getRemoteId(iframe, id, map) {
        var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        var remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    };
    _proto.getRemoteIds = function getRemoteIds(iframe, ids) {
        var _this = this;
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map(function(id) {
            return _this.getRemoteId(iframe, id, remoteIdToIdMap);
        });
    };
    _proto.reset = function reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    };
    _proto.getIdToRemoteIdMap = function getIdToRemoteIdMap(iframe) {
        var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    };
    _proto.getRemoteIdToIdMap = function getRemoteIdToIdMap(iframe) {
        var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    };
    return CrossOriginIframeMirror;
}();
var $51c8f0da15dbd30c$var$IframeManager = /*#__PURE__*/ function() {
    function IframeManager(options) {
        $51c8f0da15dbd30c$var$__publicField$1(this, "iframes", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "crossOriginIframeMirror", new $51c8f0da15dbd30c$var$CrossOriginIframeMirror($51c8f0da15dbd30c$var$genId));
        $51c8f0da15dbd30c$var$__publicField$1(this, "crossOriginIframeStyleMirror");
        $51c8f0da15dbd30c$var$__publicField$1(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "mirror");
        $51c8f0da15dbd30c$var$__publicField$1(this, "mutationCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "wrappedEmit");
        $51c8f0da15dbd30c$var$__publicField$1(this, "loadListener");
        $51c8f0da15dbd30c$var$__publicField$1(this, "stylesheetManager");
        $51c8f0da15dbd30c$var$__publicField$1(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $51c8f0da15dbd30c$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    var _proto = IframeManager.prototype;
    _proto.addIframe = function addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    };
    _proto.addLoadListener = function addLoadListener(cb) {
        this.loadListener = cb;
    };
    _proto.attachIframe = function attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    };
    _proto.handleMessage = function handleMessage(message) {
        var crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        var iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        var iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    };
    _proto.transformCrossOriginEvent = function transformCrossOriginEvent(iframeEl, e2) {
        var _this = this;
        var _a2;
        switch(e2.type){
            case $51c8f0da15dbd30c$var$EventType.FullSnapshot:
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e2.data.node, iframeEl);
                var rootId = e2.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e2.data.node, rootId);
                return {
                    timestamp: e2.timestamp,
                    type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                    data: {
                        source: $51c8f0da15dbd30c$var$IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e2.data.node
                            }
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true
                    }
                };
            case $51c8f0da15dbd30c$var$EventType.Meta:
            case $51c8f0da15dbd30c$var$EventType.Load:
            case $51c8f0da15dbd30c$var$EventType.DomContentLoaded:
                return false;
            case $51c8f0da15dbd30c$var$EventType.Plugin:
                return e2;
            case $51c8f0da15dbd30c$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $51c8f0da15dbd30c$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            _this.replaceIdOnNode(n2.node, iframeEl);
                            var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && _this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.Drag:
                    case $51c8f0da15dbd30c$var$IncrementalSource.TouchMove:
                    case $51c8f0da15dbd30c$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach(function(p) {
                            _this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.ViewportResize:
                        return false;
                    case $51c8f0da15dbd30c$var$IncrementalSource.MediaInteraction:
                    case $51c8f0da15dbd30c$var$IncrementalSource.MouseInteraction:
                    case $51c8f0da15dbd30c$var$IncrementalSource.Scroll:
                    case $51c8f0da15dbd30c$var$IncrementalSource.CanvasMutation:
                    case $51c8f0da15dbd30c$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.StyleSheetRule:
                    case $51c8f0da15dbd30c$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.Font:
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach(function(range) {
                            _this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $51c8f0da15dbd30c$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach(function(style) {
                            _this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    };
    _proto.replace = function replace(iframeMirror, obj, iframeEl, keys) {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    };
    _proto.replaceIds = function replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    };
    _proto.replaceStyleIds = function replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    };
    _proto.replaceIdOnNode = function replaceIdOnNode(node2, iframeEl) {
        var _this = this;
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.replaceIdOnNode(child, iframeEl);
        });
    };
    _proto.patchRootIdOnNode = function patchRootIdOnNode(node2, rootId) {
        var _this = this;
        if (node2.type !== $51c8f0da15dbd30c$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.patchRootIdOnNode(child, rootId);
        });
    };
    return IframeManager;
}();
var $51c8f0da15dbd30c$var$ShadowDomManager = /*#__PURE__*/ function() {
    function ShadowDomManager(options) {
        $51c8f0da15dbd30c$var$__publicField$1(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $51c8f0da15dbd30c$var$__publicField$1(this, "mutationCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "scrollCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "bypassOptions");
        $51c8f0da15dbd30c$var$__publicField$1(this, "mirror");
        $51c8f0da15dbd30c$var$__publicField$1(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    var _proto = ShadowDomManager.prototype;
    _proto.init = function init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    };
    _proto.addShadowRoot = function addShadowRoot(shadowRoot2, doc) {
        var _this = this;
        if (!$51c8f0da15dbd30c$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        var observer = $51c8f0da15dbd30c$var$initMutationObserver($51c8f0da15dbd30c$var$_extends({}, this.bypassOptions, {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(function() {
            return observer.disconnect();
        });
        this.restoreHandlers.push($51c8f0da15dbd30c$var$initScrollObserver($51c8f0da15dbd30c$var$_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(function() {
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, _this.mirror.getId($51c8f0da15dbd30c$var$index.host(shadowRoot2)));
            _this.restoreHandlers.push($51c8f0da15dbd30c$var$initAdoptedStyleSheetObserver({
                mirror: _this.mirror,
                stylesheetManager: _this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    };
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ _proto.observeAttachShadow = function observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    };
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ _proto.patchAttachShadow = function patchAttachShadow(element, doc) {
        var manager = this;
        this.restoreHandlers.push($51c8f0da15dbd30c$var$patch$2(element.prototype, "attachShadow", function(original) {
            return function(option) {
                var sRoot = original.call(this, option);
                var shadowRootEl = $51c8f0da15dbd30c$var$index.shadowRoot(this);
                if (shadowRootEl && $51c8f0da15dbd30c$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    };
    _proto.reset = function reset() {
        this.restoreHandlers.forEach(function(handler) {
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    };
    return ShadowDomManager;
}();
var $51c8f0da15dbd30c$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $51c8f0da15dbd30c$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $51c8f0da15dbd30c$var$i$1 = 0; $51c8f0da15dbd30c$var$i$1 < $51c8f0da15dbd30c$var$chars.length; $51c8f0da15dbd30c$var$i$1++)$51c8f0da15dbd30c$var$lookup[$51c8f0da15dbd30c$var$chars.charCodeAt($51c8f0da15dbd30c$var$i$1)] = $51c8f0da15dbd30c$var$i$1;
var $51c8f0da15dbd30c$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $51c8f0da15dbd30c$var$chars[bytes[i2] >> 2];
        base64 += $51c8f0da15dbd30c$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $51c8f0da15dbd30c$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $51c8f0da15dbd30c$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $51c8f0da15dbd30c$var$canvasVarMap = /* @__PURE__ */ new Map();
function $51c8f0da15dbd30c$var$variableListFor$1(ctx, ctor) {
    var contextMap = $51c8f0da15dbd30c$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $51c8f0da15dbd30c$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $51c8f0da15dbd30c$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($51c8f0da15dbd30c$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value)) === "object")) return;
    var name = value.constructor.name;
    var list2 = $51c8f0da15dbd30c$var$variableListFor$1(ctx, name);
    var index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $51c8f0da15dbd30c$var$serializeArg(value, win, ctx) {
    if ($51c8f0da15dbd30c$var$_instanceof(value, Array)) return value.map(function(arg) {
        return $51c8f0da15dbd30c$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ($51c8f0da15dbd30c$var$_instanceof(value, Float32Array) || $51c8f0da15dbd30c$var$_instanceof(value, Float64Array) || $51c8f0da15dbd30c$var$_instanceof(value, Int32Array) || $51c8f0da15dbd30c$var$_instanceof(value, Uint32Array) || $51c8f0da15dbd30c$var$_instanceof(value, Uint8Array) || $51c8f0da15dbd30c$var$_instanceof(value, Uint16Array) || $51c8f0da15dbd30c$var$_instanceof(value, Int16Array) || $51c8f0da15dbd30c$var$_instanceof(value, Int8Array) || $51c8f0da15dbd30c$var$_instanceof(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    $51c8f0da15dbd30c$var$_instanceof(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = $51c8f0da15dbd30c$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ($51c8f0da15dbd30c$var$_instanceof(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $51c8f0da15dbd30c$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ($51c8f0da15dbd30c$var$_instanceof(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ($51c8f0da15dbd30c$var$_instanceof(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ($51c8f0da15dbd30c$var$_instanceof(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $51c8f0da15dbd30c$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($51c8f0da15dbd30c$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value)) === "object") {
        var name6 = value.constructor.name;
        var index2 = $51c8f0da15dbd30c$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index2
        };
    }
    return value;
}
var $51c8f0da15dbd30c$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $51c8f0da15dbd30c$var$serializeArg(arg, win, ctx);
    });
};
var $51c8f0da15dbd30c$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return $51c8f0da15dbd30c$var$_instanceof(value, win[name]);
    }));
};
function $51c8f0da15dbd30c$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var _loop = function() {
        var prop = _step.value;
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
            var restoreHandler = $51c8f0da15dbd30c$var$patch$2(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (!$51c8f0da15dbd30c$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                        var recordArgs = $51c8f0da15dbd30c$var$serializeArgs(args, win, _this);
                        cb(_this.canvas, {
                            type: $51c8f0da15dbd30c$var$CanvasContext["2D"],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $51c8f0da15dbd30c$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: $51c8f0da15dbd30c$var$CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(props2D), _step; !(_step = _iterator()).done;)_loop();
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $51c8f0da15dbd30c$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $51c8f0da15dbd30c$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $51c8f0da15dbd30c$var$patch$2(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (!$51c8f0da15dbd30c$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $51c8f0da15dbd30c$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && $51c8f0da15dbd30c$var$_type_of(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [].concat([
                    contextType
                ], args));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $51c8f0da15dbd30c$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    var _loop = function() {
        var prop = _step.value;
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) return "continue";
        try {
            if (typeof prototype[prop] !== "function") return "continue";
            var restoreHandler = $51c8f0da15dbd30c$var$patch$2(prototype, prop, function(original) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var result2 = original.apply(this, args);
                    $51c8f0da15dbd30c$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$51c8f0da15dbd30c$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        var recordArgs = $51c8f0da15dbd30c$var$serializeArgs(args, win, this);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $51c8f0da15dbd30c$var$hookSetter(prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(props), _step; !(_step = _iterator()).done;)_loop();
    return handlers;
}
function $51c8f0da15dbd30c$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, [].concat($51c8f0da15dbd30c$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $51c8f0da15dbd30c$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, [].concat($51c8f0da15dbd30c$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $51c8f0da15dbd30c$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $51c8f0da15dbd30c$var$encodedJs = "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";
var $51c8f0da15dbd30c$var$decodeBase64 = function(base64) {
    return Uint8Array.from(atob(base64), function(c2) {
        return c2.charCodeAt(0);
    });
};
var $51c8f0da15dbd30c$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $51c8f0da15dbd30c$var$decodeBase64($51c8f0da15dbd30c$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $51c8f0da15dbd30c$var$WorkerWrapper(options) {
    var objURL;
    try {
        objURL = $51c8f0da15dbd30c$var$blob && (window.URL || window.webkitURL).createObjectURL($51c8f0da15dbd30c$var$blob);
        if (!objURL) throw "";
        var worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", function() {
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $51c8f0da15dbd30c$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
var $51c8f0da15dbd30c$var$CanvasManager = /*#__PURE__*/ function() {
    function CanvasManager(options) {
        var _this = this;
        $51c8f0da15dbd30c$var$__publicField$1(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $51c8f0da15dbd30c$var$__publicField$1(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $51c8f0da15dbd30c$var$__publicField$1(this, "mirror");
        $51c8f0da15dbd30c$var$__publicField$1(this, "mutationCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "resetObservers");
        $51c8f0da15dbd30c$var$__publicField$1(this, "frozen", false);
        $51c8f0da15dbd30c$var$__publicField$1(this, "locked", false);
        $51c8f0da15dbd30c$var$__publicField$1(this, "processMutation", function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        });
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    var _proto = CanvasManager.prototype;
    _proto.reset = function reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
    };
    _proto.lock = function lock() {
        this.locked = true;
    };
    _proto.unlock = function unlock() {
        this.locked = false;
    };
    _proto.initCanvasFPSObserver = function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        var _this = this;
        var canvasContextReset = $51c8f0da15dbd30c$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        var snapshotInProgressMap = /* @__PURE__ */ new Map();
        var worker = new $51c8f0da15dbd30c$var$WorkerWrapper();
        worker.onmessage = function(e2) {
            var id = e2.data.id;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            var _e2_data = e2.data, base64 = _e2_data.base64, type = _e2_data.type, width = _e2_data.width, height = _e2_data.height;
            _this.mutationCb({
                id: id,
                type: $51c8f0da15dbd30c$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        var timeBetweenSnapshots = 1e3 / fps;
        var lastSnapshotTime = 0;
        var rafId;
        var getCanvas = function() {
            var matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach(function(canvas) {
                if (!$51c8f0da15dbd30c$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        var takeCanvasSnapshots = function(timestamp) {
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this1 = _this;
            getCanvas().forEach(/*#__PURE__*/ $51c8f0da15dbd30c$var$_async_to_generator(function(canvas) {
                var _a2, id, context, bitmap;
                return $51c8f0da15dbd30c$var$_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = _this1.mirror.getId(canvas);
                            if (snapshotInProgressMap.get(id)) return [
                                2
                            ];
                            if (canvas.width === 0 || canvas.height === 0) return [
                                2
                            ];
                            snapshotInProgressMap.set(id, true);
                            if ([
                                "webgl",
                                "webgl2"
                            ].includes(canvas.__context)) {
                                context = canvas.getContext(canvas.__context);
                                if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                            }
                            return [
                                4,
                                createImageBitmap(canvas)
                            ];
                        case 1:
                            bitmap = _state.sent();
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: options.dataURLOptions
                            }, [
                                bitmap
                            ]);
                            return [
                                2
                            ];
                    }
                });
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = function() {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    };
    _proto.initCanvasMutationObserver = function initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = $51c8f0da15dbd30c$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        var canvas2DReset = $51c8f0da15dbd30c$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        var canvasWebGL1and2Reset = $51c8f0da15dbd30c$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    _proto.startPendingCanvasMutationFlusher = function startPendingCanvasMutationFlusher() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.startRAFTimestamping = function startRAFTimestamping() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    _proto.flushPendingCanvasMutations = function flushPendingCanvasMutations() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(_values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.flushPendingCanvasMutationFor = function flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = $51c8f0da15dbd30c$var$_object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();
var $51c8f0da15dbd30c$var$StylesheetManager = /*#__PURE__*/ function() {
    function StylesheetManager(options) {
        $51c8f0da15dbd30c$var$__publicField$1(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $51c8f0da15dbd30c$var$__publicField$1(this, "mutationCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "adoptedStyleSheetCb");
        $51c8f0da15dbd30c$var$__publicField$1(this, "styleMirror", new $51c8f0da15dbd30c$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    var _proto = StylesheetManager.prototype;
    _proto.attachLinkElement = function attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    };
    _proto.trackLinkElement = function trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    };
    _proto.adoptStyleSheets = function adoptStyleSheets(sheets, hostId) {
        var _this, _loop = function() {
            var sheet = _step.value;
            var styleId = void 0;
            if (!_this.styleMirror.has(sheet)) {
                styleId = _this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, function(r2, index2) {
                        return {
                            rule: $51c8f0da15dbd30c$var$stringifyRule(r2, sheet.href),
                            index: index2
                        };
                    })
                });
            } else styleId = _this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        };
        if (sheets.length === 0) return;
        var adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        var styles = [];
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(sheets), _step; !(_step = _iterator()).done;)_this = this, _loop();
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    };
    _proto.reset = function reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    };
    // TODO: take snapshot on stylesheet reload by applying event listener
    _proto.trackStylesheetInLinkElement = function trackStylesheetInLinkElement(_linkEl) {};
    return StylesheetManager;
}();
var $51c8f0da15dbd30c$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    function ProcessedNodeManager() {
        $51c8f0da15dbd30c$var$__publicField$1(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $51c8f0da15dbd30c$var$__publicField$1(this, "active", false);
    }
    var _proto = ProcessedNodeManager.prototype;
    _proto.inOtherBuffer = function inOtherBuffer(node2, thisBuffer) {
        var buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some(function(buffer) {
            return buffer !== thisBuffer;
        });
    };
    _proto.add = function add(node2, buffer) {
        var _this = this;
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(function() {
                _this.nodeMap = /* @__PURE__ */ new WeakMap();
                _this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    };
    _proto.destroy = function destroy() {};
    return ProcessedNodeManager;
}();
var $51c8f0da15dbd30c$var$wrappedEmit;
var $51c8f0da15dbd30c$var$takeFullSnapshot$1;
var $51c8f0da15dbd30c$var$canvasManager;
var $51c8f0da15dbd30c$var$recording = false;
try {
    if (Array.from([
        1
    ], function(x2) {
        return x2 * 2;
    })[0] !== 2) {
        var $51c8f0da15dbd30c$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($51c8f0da15dbd30c$var$cleanFrame);
        Array.from = (($51c8f0da15dbd30c$var$_a = $51c8f0da15dbd30c$var$cleanFrame.contentWindow) == null ? void 0 : $51c8f0da15dbd30c$var$_a.Array.from) || Array.from;
        document.body.removeChild($51c8f0da15dbd30c$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $51c8f0da15dbd30c$var$mirror = $51c8f0da15dbd30c$var$createMirror$2();
function $51c8f0da15dbd30c$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler;
    $51c8f0da15dbd30c$var$registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $51c8f0da15dbd30c$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true,
        hidden: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $51c8f0da15dbd30c$var$polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
            var plugin3 = _step.value;
            if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $51c8f0da15dbd30c$var$wrappedEmit = function(r2, isCheckout) {
        var _a2;
        var e2 = r2;
        e2.timestamp = $51c8f0da15dbd30c$var$nowTimestamp();
        if (((_a2 = $51c8f0da15dbd30c$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $51c8f0da15dbd30c$var$EventType.FullSnapshot && !(e2.type === $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot && e2.data.source === $51c8f0da15dbd30c$var$IncrementalSource.Mutation)) $51c8f0da15dbd30c$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $51c8f0da15dbd30c$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $51c8f0da15dbd30c$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $51c8f0da15dbd30c$var$takeFullSnapshot$1(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
            data: $51c8f0da15dbd30c$var$_extends({
                source: $51c8f0da15dbd30c$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
            data: $51c8f0da15dbd30c$var$_extends({
                source: $51c8f0da15dbd30c$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
            data: $51c8f0da15dbd30c$var$_extends({
                source: $51c8f0da15dbd30c$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
            data: $51c8f0da15dbd30c$var$_extends({
                source: $51c8f0da15dbd30c$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $51c8f0da15dbd30c$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $51c8f0da15dbd30c$var$IframeManager({
        mirror: $51c8f0da15dbd30c$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $51c8f0da15dbd30c$var$wrappedEmit
    });
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: $51c8f0da15dbd30c$var$mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    var processedNodeManager = new $51c8f0da15dbd30c$var$ProcessedNodeManager();
    $51c8f0da15dbd30c$var$canvasManager = new $51c8f0da15dbd30c$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $51c8f0da15dbd30c$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $51c8f0da15dbd30c$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $51c8f0da15dbd30c$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $51c8f0da15dbd30c$var$mirror
    });
    $51c8f0da15dbd30c$var$takeFullSnapshot$1 = function(isCheckout) {
        if (isCheckout === void 0) isCheckout = false;
        if (!recordDOM) return;
        $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $51c8f0da15dbd30c$var$getWindowWidth(),
                height: $51c8f0da15dbd30c$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $51c8f0da15dbd30c$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node2 = $51c8f0da15dbd30c$var$snapshot(document, {
            mirror: $51c8f0da15dbd30c$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($51c8f0da15dbd30c$var$isSerializedIframe(n2, $51c8f0da15dbd30c$var$mirror)) iframeManager.addIframe(n2);
                if ($51c8f0da15dbd30c$var$isSerializedStylesheet(n2, $51c8f0da15dbd30c$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($51c8f0da15dbd30c$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($51c8f0da15dbd30c$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $51c8f0da15dbd30c$var$wrappedEmit({
            type: $51c8f0da15dbd30c$var$EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $51c8f0da15dbd30c$var$getWindowScroll(window)
            }
        }, isCheckout);
        $51c8f0da15dbd30c$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $51c8f0da15dbd30c$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a2;
            return $51c8f0da15dbd30c$var$callbackWrapper($51c8f0da15dbd30c$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $51c8f0da15dbd30c$var$wrappedEmit({
                        type: $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot,
                        data: $51c8f0da15dbd30c$var$_extends({
                            source: $51c8f0da15dbd30c$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $51c8f0da15dbd30c$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $51c8f0da15dbd30c$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) == null ? void 0 : _a2.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $51c8f0da15dbd30c$var$wrappedEmit({
                                type: $51c8f0da15dbd30c$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $51c8f0da15dbd30c$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $51c8f0da15dbd30c$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($51c8f0da15dbd30c$var$on("DOMContentLoaded", function() {
                $51c8f0da15dbd30c$var$wrappedEmit({
                    type: $51c8f0da15dbd30c$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($51c8f0da15dbd30c$var$on("load", function() {
                $51c8f0da15dbd30c$var$wrappedEmit({
                    type: $51c8f0da15dbd30c$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(handler) {
                try {
                    handler();
                } catch (error) {
                    var msg = String(error).toLowerCase();
                    if (!msg.includes("cross-origin")) console.warn(error);
                }
            });
            processedNodeManager.destroy();
            $51c8f0da15dbd30c$var$recording = false;
            $51c8f0da15dbd30c$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$51c8f0da15dbd30c$var$record.addCustomEvent = function(tag, payload) {
    if (!$51c8f0da15dbd30c$var$recording) throw new Error("please add custom event after start recording");
    $51c8f0da15dbd30c$var$wrappedEmit({
        type: $51c8f0da15dbd30c$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$51c8f0da15dbd30c$var$record.freezePage = function() {
    $51c8f0da15dbd30c$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$51c8f0da15dbd30c$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$51c8f0da15dbd30c$var$recording) throw new Error("please take full snapshot after start recording");
    $51c8f0da15dbd30c$var$takeFullSnapshot$1(isCheckout);
};
$51c8f0da15dbd30c$var$record.mirror = $51c8f0da15dbd30c$var$mirror;
var $51c8f0da15dbd30c$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($51c8f0da15dbd30c$var$n || ($51c8f0da15dbd30c$var$n = {}));
$51c8f0da15dbd30c$var$record.addCustomEvent;
$51c8f0da15dbd30c$var$record.freezePage;
$51c8f0da15dbd30c$var$record.takeFullSnapshot;
var $51c8f0da15dbd30c$var$__defProp = Object.defineProperty;
var $51c8f0da15dbd30c$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $51c8f0da15dbd30c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $51c8f0da15dbd30c$var$__publicField = function(obj, key, value) {
    return $51c8f0da15dbd30c$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $51c8f0da15dbd30c$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $51c8f0da15dbd30c$var$StackFrame = /*#__PURE__*/ function() {
    function StackFrame(obj) {
        $51c8f0da15dbd30c$var$__publicField(this, "fileName");
        $51c8f0da15dbd30c$var$__publicField(this, "functionName");
        $51c8f0da15dbd30c$var$__publicField(this, "lineNumber");
        $51c8f0da15dbd30c$var$__publicField(this, "columnNumber");
        this.fileName = obj.fileName || "";
        this.functionName = obj.functionName || "";
        this.lineNumber = obj.lineNumber;
        this.columnNumber = obj.columnNumber;
    }
    var _proto = StackFrame.prototype;
    _proto.toString = function toString() {
        var lineNumber = this.lineNumber || "";
        var columnNumber = this.columnNumber || "";
        if (this.functionName) return this.functionName + " (" + this.fileName + ":" + lineNumber + ":" + columnNumber + ")";
        return this.fileName + ":" + lineNumber + ":" + columnNumber;
    };
    return StackFrame;
}();
var $51c8f0da15dbd30c$var$FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
var $51c8f0da15dbd30c$var$CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
var $51c8f0da15dbd30c$var$SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
var $51c8f0da15dbd30c$var$ErrorStackParser = {
    /**
   * Given an Error object, extract the most information from it.
   */ parse: function parse(error) {
        if (!error) return [];
        if (// @ts-ignore
        typeof error.stacktrace !== "undefined" || // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
        else if (error.stack && error.stack.match($51c8f0da15dbd30c$var$CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
        else if (error.stack) return this.parseFFOrSafari(error);
        else {
            console.warn("[console-record-plugin]: Failed to parse error object:", error);
            return [];
        }
    },
    // Separate line and column numbers from a string of the form: (URI:Line:Column)
    extractLocation: function extractLocation(urlLike) {
        if (urlLike.indexOf(":") === -1) return [
            urlLike
        ];
        var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
        var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
        if (!parts) throw new Error("Cannot parse given url: " + urlLike);
        return [
            parts[1],
            parts[2] || void 0,
            parts[3] || void 0
        ];
    },
    parseV8OrIE: function parseV8OrIE(error) {
        var filtered = error.stack.split("\n").filter(function(line) {
            return !!line.match($51c8f0da15dbd30c$var$CHROME_IE_STACK_REGEXP);
        }, this);
        return filtered.map(function(line) {
            if (line.indexOf("(eval ") > -1) line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
            var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(");
            var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
            sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
            var tokens = sanitizedLine.split(/\s+/).slice(1);
            var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
            var functionName = tokens.join(" ") || void 0;
            var fileName = [
                "eval",
                "<anonymous>"
            ].indexOf(locationParts[0]) > -1 ? void 0 : locationParts[0];
            return new $51c8f0da15dbd30c$var$StackFrame({
                functionName: functionName,
                fileName: fileName,
                lineNumber: locationParts[1],
                columnNumber: locationParts[2]
            });
        }, this);
    },
    parseFFOrSafari: function parseFFOrSafari(error) {
        var filtered = error.stack.split("\n").filter(function(line) {
            return !line.match($51c8f0da15dbd30c$var$SAFARI_NATIVE_CODE_REGEXP);
        }, this);
        return filtered.map(function(line) {
            if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
            if (line.indexOf("@") === -1 && line.indexOf(":") === -1) return new $51c8f0da15dbd30c$var$StackFrame({
                functionName: line
            });
            else {
                var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                var matches = line.match(functionNameRegex);
                var functionName = matches && matches[1] ? matches[1] : void 0;
                var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                return new $51c8f0da15dbd30c$var$StackFrame({
                    functionName: functionName,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2]
                });
            }
        }, this);
    },
    parseOpera: function parseOpera(e) {
        if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
        else if (!e.stack) return this.parseOpera10(e);
        else return this.parseOpera11(e);
    },
    parseOpera9: function parseOpera9(e) {
        var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
        var lines = e.message.split("\n");
        var result = [];
        for(var i = 2, len = lines.length; i < len; i += 2){
            var match = lineRE.exec(lines[i]);
            if (match) result.push(new $51c8f0da15dbd30c$var$StackFrame({
                fileName: match[2],
                lineNumber: parseFloat(match[1])
            }));
        }
        return result;
    },
    parseOpera10: function parseOpera10(e) {
        var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
        var lines = e.stacktrace.split("\n");
        var result = [];
        for(var i = 0, len = lines.length; i < len; i += 2){
            var match = lineRE.exec(lines[i]);
            if (match) result.push(new $51c8f0da15dbd30c$var$StackFrame({
                functionName: match[3] || void 0,
                fileName: match[2],
                lineNumber: parseFloat(match[1])
            }));
        }
        return result;
    },
    // Opera 10.65+ Error.stack very similar to FF/Safari
    parseOpera11: function parseOpera11(error) {
        var filtered = error.stack.split("\n").filter(function(line) {
            return !!line.match($51c8f0da15dbd30c$var$FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
        }, this);
        return filtered.map(function(line) {
            var tokens = line.split("@");
            var locationParts = this.extractLocation(tokens.pop());
            var functionCall = tokens.shift() || "";
            var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
            return new $51c8f0da15dbd30c$var$StackFrame({
                functionName: functionName,
                fileName: locationParts[0],
                lineNumber: locationParts[1],
                columnNumber: locationParts[2]
            });
        }, this);
    }
};
function $51c8f0da15dbd30c$var$pathToSelector(node) {
    if (!node || !node.outerHTML) return "";
    var path = "";
    while(node.parentElement){
        var name = node.localName;
        if (!name) break;
        name = name.toLowerCase();
        var parent = node.parentElement;
        var domSiblings = [];
        if (parent.children && parent.children.length > 0) for(var i = 0; i < parent.children.length; i++){
            var sibling = parent.children[i];
            if (sibling.localName && sibling.localName.toLowerCase) {
                if (sibling.localName.toLowerCase() === name) domSiblings.push(sibling);
            }
        }
        if (domSiblings.length > 1) name += ":eq(" + domSiblings.indexOf(node) + ")";
        path = name + (path ? ">" + path : "");
        node = parent;
    }
    return path;
}
function $51c8f0da15dbd30c$var$isObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $51c8f0da15dbd30c$var$isObjTooDeep(obj, limit) {
    if (limit === 0) return true;
    var keys = Object.keys(obj);
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
        var key = _step.value;
        if ($51c8f0da15dbd30c$var$isObject(obj[key]) && $51c8f0da15dbd30c$var$isObjTooDeep(obj[key], limit - 1)) return true;
    }
    return false;
}
function $51c8f0da15dbd30c$var$stringify(obj, stringifyOptions) {
    var options = {
        numOfKeysLimit: 50,
        depthOfLimit: 4
    };
    Object.assign(options, stringifyOptions);
    var stack = [];
    var keys = [];
    return JSON.stringify(obj, function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) {
                if (stack[0] === value) value = "[Circular ~]";
                else value = "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
            }
        } else stack.push(value);
        if (value === null) return value;
        if (value === void 0) return "undefined";
        if (shouldIgnore(value)) return toString(value);
        if ((typeof value === "undefined" ? "undefined" : $51c8f0da15dbd30c$var$_type_of(value)) === "bigint") return value.toString() + "n";
        if ($51c8f0da15dbd30c$var$_instanceof(value, Event)) {
            var eventResult = {};
            for(var eventKey in value){
                var eventValue = value[eventKey];
                if (Array.isArray(eventValue)) eventResult[eventKey] = $51c8f0da15dbd30c$var$pathToSelector(eventValue.length ? eventValue[0] : null);
                else eventResult[eventKey] = eventValue;
            }
            return eventResult;
        } else if ($51c8f0da15dbd30c$var$_instanceof(value, Node)) {
            if ($51c8f0da15dbd30c$var$_instanceof(value, HTMLElement)) return value ? value.outerHTML : "";
            return value.nodeName;
        } else if ($51c8f0da15dbd30c$var$_instanceof(value, Error)) return value.stack ? value.stack + "\nEnd of stack for Error object" : value.name + ": " + value.message;
        return value;
    });
    function shouldIgnore(_obj) {
        if ($51c8f0da15dbd30c$var$isObject(_obj) && Object.keys(_obj).length > options.numOfKeysLimit) return true;
        if (typeof _obj === "function") return true;
        if ($51c8f0da15dbd30c$var$isObject(_obj) && $51c8f0da15dbd30c$var$isObjTooDeep(_obj, options.depthOfLimit)) return true;
        return false;
    }
    function toString(_obj) {
        var str = _obj.toString();
        if (options.stringLengthLimit && str.length > options.stringLengthLimit) str = "" + str.slice(0, options.stringLengthLimit) + "...";
        return str;
    }
}
var $51c8f0da15dbd30c$var$defaultLogOptions = {
    level: [
        "assert",
        "clear",
        "count",
        "countReset",
        "debug",
        "dir",
        "dirxml",
        "error",
        "group",
        "groupCollapsed",
        "groupEnd",
        "info",
        "log",
        "table",
        "time",
        "timeEnd",
        "timeLog",
        "trace",
        "warn"
    ],
    lengthThreshold: 1e3,
    logger: "console"
};
function $51c8f0da15dbd30c$var$initLogObserver(cb, win, options) {
    var logOptions = options ? Object.assign({}, $51c8f0da15dbd30c$var$defaultLogOptions, options) : $51c8f0da15dbd30c$var$defaultLogOptions;
    var loggerType = logOptions.logger;
    if (!loggerType) return function() {};
    var logger;
    if (typeof loggerType === "string") logger = win[loggerType];
    else logger = loggerType;
    var logCount = 0;
    var inStack = false;
    var cancelHandlers = [];
    if (logOptions.level.includes("error")) {
        var errorHandler = function(event) {
            var message = event.message, error = event.error;
            var trace = $51c8f0da15dbd30c$var$ErrorStackParser.parse(error).map(function(stackFrame) {
                return stackFrame.toString();
            });
            var payload = [
                $51c8f0da15dbd30c$var$stringify(message, logOptions.stringifyOptions)
            ];
            cb({
                level: "error",
                trace: trace,
                payload: payload
            });
        };
        win.addEventListener("error", errorHandler);
        cancelHandlers.push(function() {
            win.removeEventListener("error", errorHandler);
        });
        var unhandledrejectionHandler = function(event) {
            var error;
            var payload;
            if ($51c8f0da15dbd30c$var$_instanceof(event.reason, Error)) {
                error = event.reason;
                payload = [
                    $51c8f0da15dbd30c$var$stringify("Uncaught (in promise) " + error.name + ": " + error.message, logOptions.stringifyOptions)
                ];
            } else {
                error = new Error();
                payload = [
                    $51c8f0da15dbd30c$var$stringify("Uncaught (in promise)", logOptions.stringifyOptions),
                    $51c8f0da15dbd30c$var$stringify(event.reason, logOptions.stringifyOptions)
                ];
            }
            var trace = $51c8f0da15dbd30c$var$ErrorStackParser.parse(error).map(function(stackFrame) {
                return stackFrame.toString();
            });
            cb({
                level: "error",
                trace: trace,
                payload: payload
            });
        };
        win.addEventListener("unhandledrejection", unhandledrejectionHandler);
        cancelHandlers.push(function() {
            win.removeEventListener("unhandledrejection", unhandledrejectionHandler);
        });
    }
    for(var _iterator = $51c8f0da15dbd30c$var$_create_for_of_iterator_helper_loose(logOptions.level), _step; !(_step = _iterator()).done;){
        var levelType = _step.value;
        cancelHandlers.push(replace(logger, levelType));
    }
    return function() {
        cancelHandlers.forEach(function(h) {
            return h();
        });
    };
    function replace(_logger, level) {
        var _this = this;
        if (!_logger[level]) return function() {};
        return $51c8f0da15dbd30c$var$patch(_logger, level, function(original) {
            var _this1 = _this;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                original.apply(_this1, args);
                if (level === "assert" && !!args[0]) return;
                if (inStack) return;
                inStack = true;
                try {
                    var trace = $51c8f0da15dbd30c$var$ErrorStackParser.parse(new Error()).map(function(stackFrame) {
                        return stackFrame.toString();
                    }).splice(1);
                    var argsForPayload = level === "assert" ? args.slice(1) : args;
                    var payload = argsForPayload.map(function(s) {
                        return $51c8f0da15dbd30c$var$stringify(s, logOptions.stringifyOptions);
                    });
                    logCount++;
                    if (logCount < logOptions.lengthThreshold) cb({
                        level: level,
                        trace: trace,
                        payload: payload
                    });
                    else if (logCount === logOptions.lengthThreshold) cb({
                        level: "warn",
                        trace: [],
                        payload: [
                            $51c8f0da15dbd30c$var$stringify("The number of log records reached the threshold.")
                        ]
                    });
                } catch (error) {
                    original.apply(void 0, [].concat([
                        "rrweb logger error:",
                        error
                    ], args));
                } finally{
                    inStack = false;
                }
            };
        });
    }
}
var $51c8f0da15dbd30c$var$PLUGIN_NAME = "rrweb/console@1";
var $51c8f0da15dbd30c$var$getRecordConsolePlugin = function(options) {
    return {
        name: $51c8f0da15dbd30c$var$PLUGIN_NAME,
        observer: $51c8f0da15dbd30c$var$initLogObserver,
        options: options
    };
};
var $51c8f0da15dbd30c$var$setImmediate = $51c8f0da15dbd30c$var$win['setImmediate'];
var $51c8f0da15dbd30c$var$builtInProp, $51c8f0da15dbd30c$var$cycle, $51c8f0da15dbd30c$var$schedulingQueue, $51c8f0da15dbd30c$var$ToString = Object.prototype.toString, $51c8f0da15dbd30c$var$timer = typeof $51c8f0da15dbd30c$var$setImmediate !== 'undefined' ? function timer(fn) {
    return $51c8f0da15dbd30c$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    $51c8f0da15dbd30c$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $51c8f0da15dbd30c$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$51c8f0da15dbd30c$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $51c8f0da15dbd30c$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $51c8f0da15dbd30c$var$schedule(fn, self) {
    $51c8f0da15dbd30c$var$schedulingQueue.add(fn, self);
    if (!$51c8f0da15dbd30c$var$cycle) $51c8f0da15dbd30c$var$cycle = $51c8f0da15dbd30c$var$timer($51c8f0da15dbd30c$var$schedulingQueue.drain);
}
// promise duck typing
function $51c8f0da15dbd30c$var$isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function $51c8f0da15dbd30c$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$51c8f0da15dbd30c$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $51c8f0da15dbd30c$var$notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = $51c8f0da15dbd30c$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $51c8f0da15dbd30c$var$resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $51c8f0da15dbd30c$var$isThenable(msg)) $51c8f0da15dbd30c$var$schedule(function() {
            var defWrapper = new $51c8f0da15dbd30c$var$MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    $51c8f0da15dbd30c$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $51c8f0da15dbd30c$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $51c8f0da15dbd30c$var$reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) $51c8f0da15dbd30c$var$schedule($51c8f0da15dbd30c$var$notify, self);
        }
    } catch (err) {
        $51c8f0da15dbd30c$var$reject.call(new $51c8f0da15dbd30c$var$MakeDefWrapper(self), err);
    }
}
function $51c8f0da15dbd30c$var$reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) $51c8f0da15dbd30c$var$schedule($51c8f0da15dbd30c$var$notify, self);
}
function $51c8f0da15dbd30c$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $51c8f0da15dbd30c$var$MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function $51c8f0da15dbd30c$var$MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $51c8f0da15dbd30c$var$NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new $51c8f0da15dbd30c$var$MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $51c8f0da15dbd30c$var$schedule($51c8f0da15dbd30c$var$notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $51c8f0da15dbd30c$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $51c8f0da15dbd30c$var$reject.call(def, msg);
        });
    } catch (err) {
        $51c8f0da15dbd30c$var$reject.call(def, err);
    }
}
var $51c8f0da15dbd30c$var$PromisePrototype = $51c8f0da15dbd30c$var$builtInProp({}, 'constructor', $51c8f0da15dbd30c$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$51c8f0da15dbd30c$var$NpoPromise.prototype = $51c8f0da15dbd30c$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$51c8f0da15dbd30c$var$builtInProp($51c8f0da15dbd30c$var$PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
$51c8f0da15dbd30c$var$builtInProp($51c8f0da15dbd30c$var$NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
$51c8f0da15dbd30c$var$builtInProp($51c8f0da15dbd30c$var$NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
$51c8f0da15dbd30c$var$builtInProp($51c8f0da15dbd30c$var$NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($51c8f0da15dbd30c$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        $51c8f0da15dbd30c$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$51c8f0da15dbd30c$var$builtInProp($51c8f0da15dbd30c$var$NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($51c8f0da15dbd30c$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        $51c8f0da15dbd30c$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $51c8f0da15dbd30c$var$PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) $51c8f0da15dbd30c$var$PromisePolyfill = Promise;
else $51c8f0da15dbd30c$var$PromisePolyfill = $51c8f0da15dbd30c$var$NpoPromise;
var $51c8f0da15dbd30c$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.72.0'
};
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $51c8f0da15dbd30c$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $51c8f0da15dbd30c$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $51c8f0da15dbd30c$var$ArrayProto = Array.prototype, $51c8f0da15dbd30c$var$FuncProto = Function.prototype, $51c8f0da15dbd30c$var$ObjProto = Object.prototype, $51c8f0da15dbd30c$var$slice = $51c8f0da15dbd30c$var$ArrayProto.slice, $51c8f0da15dbd30c$var$toString = $51c8f0da15dbd30c$var$ObjProto.toString, $51c8f0da15dbd30c$var$hasOwnProperty = $51c8f0da15dbd30c$var$ObjProto.hasOwnProperty, $51c8f0da15dbd30c$var$windowConsole = $51c8f0da15dbd30c$var$win.console, $51c8f0da15dbd30c$var$navigator = $51c8f0da15dbd30c$var$win.navigator, $51c8f0da15dbd30c$var$document$1 = $51c8f0da15dbd30c$var$win.document, $51c8f0da15dbd30c$var$windowOpera = $51c8f0da15dbd30c$var$win.opera, $51c8f0da15dbd30c$var$screen = $51c8f0da15dbd30c$var$win.screen, $51c8f0da15dbd30c$var$userAgent = $51c8f0da15dbd30c$var$navigator.userAgent;
var $51c8f0da15dbd30c$var$nativeBind = $51c8f0da15dbd30c$var$FuncProto.bind, $51c8f0da15dbd30c$var$nativeForEach = $51c8f0da15dbd30c$var$ArrayProto.forEach, $51c8f0da15dbd30c$var$nativeIndexOf = $51c8f0da15dbd30c$var$ArrayProto.indexOf, $51c8f0da15dbd30c$var$nativeMap = $51c8f0da15dbd30c$var$ArrayProto.map, $51c8f0da15dbd30c$var$nativeIsArray = Array.isArray, $51c8f0da15dbd30c$var$breaker = {};
var $51c8f0da15dbd30c$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $51c8f0da15dbd30c$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($51c8f0da15dbd30c$var$Config.DEBUG && !$51c8f0da15dbd30c$var$_.isUndefined($51c8f0da15dbd30c$var$windowConsole) && $51c8f0da15dbd30c$var$windowConsole) try {
            $51c8f0da15dbd30c$var$windowConsole.log.apply($51c8f0da15dbd30c$var$windowConsole, arguments);
        } catch (err) {
            $51c8f0da15dbd30c$var$_.each(arguments, function(arg) {
                $51c8f0da15dbd30c$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($51c8f0da15dbd30c$var$Config.DEBUG && !$51c8f0da15dbd30c$var$_.isUndefined($51c8f0da15dbd30c$var$windowConsole) && $51c8f0da15dbd30c$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($51c8f0da15dbd30c$var$_.toArray(arguments));
            try {
                $51c8f0da15dbd30c$var$windowConsole.warn.apply($51c8f0da15dbd30c$var$windowConsole, args);
            } catch (err) {
                $51c8f0da15dbd30c$var$_.each(args, function(arg) {
                    $51c8f0da15dbd30c$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($51c8f0da15dbd30c$var$Config.DEBUG && !$51c8f0da15dbd30c$var$_.isUndefined($51c8f0da15dbd30c$var$windowConsole) && $51c8f0da15dbd30c$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($51c8f0da15dbd30c$var$_.toArray(arguments));
            try {
                $51c8f0da15dbd30c$var$windowConsole.error.apply($51c8f0da15dbd30c$var$windowConsole, args);
            } catch (err) {
                $51c8f0da15dbd30c$var$_.each(args, function(arg) {
                    $51c8f0da15dbd30c$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$51c8f0da15dbd30c$var$_.isUndefined($51c8f0da15dbd30c$var$windowConsole) && $51c8f0da15dbd30c$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($51c8f0da15dbd30c$var$_.toArray(arguments));
            try {
                $51c8f0da15dbd30c$var$windowConsole.error.apply($51c8f0da15dbd30c$var$windowConsole, args);
            } catch (err) {
                $51c8f0da15dbd30c$var$_.each(args, function(arg) {
                    $51c8f0da15dbd30c$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $51c8f0da15dbd30c$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($51c8f0da15dbd30c$var$console$1, arguments);
    };
};
var $51c8f0da15dbd30c$var$console_with_prefix = function(prefix) {
    return {
        log: $51c8f0da15dbd30c$var$log_func_with_prefix($51c8f0da15dbd30c$var$console$1.log, prefix),
        error: $51c8f0da15dbd30c$var$log_func_with_prefix($51c8f0da15dbd30c$var$console$1.error, prefix),
        critical: $51c8f0da15dbd30c$var$log_func_with_prefix($51c8f0da15dbd30c$var$console$1.critical, prefix)
    };
};
var $51c8f0da15dbd30c$var$safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            $51c8f0da15dbd30c$var$console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if ($51c8f0da15dbd30c$var$Config.DEBUG) $51c8f0da15dbd30c$var$console$1.critical(e);
        }
    };
};
var $51c8f0da15dbd30c$var$safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === 'function') proto[func] = $51c8f0da15dbd30c$var$safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
$51c8f0da15dbd30c$var$_.bind = function(func, context) {
    var args, bound;
    if ($51c8f0da15dbd30c$var$nativeBind && func.bind === $51c8f0da15dbd30c$var$nativeBind) return $51c8f0da15dbd30c$var$nativeBind.apply(func, $51c8f0da15dbd30c$var$slice.call(arguments, 1));
    if (!$51c8f0da15dbd30c$var$_.isFunction(func)) throw new TypeError();
    args = $51c8f0da15dbd30c$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($51c8f0da15dbd30c$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($51c8f0da15dbd30c$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $51c8f0da15dbd30c$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($51c8f0da15dbd30c$var$nativeForEach && obj.forEach === $51c8f0da15dbd30c$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $51c8f0da15dbd30c$var$breaker) return;
    }
    else {
        for(var key in obj)if ($51c8f0da15dbd30c$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $51c8f0da15dbd30c$var$breaker) return;
        }
    }
};
$51c8f0da15dbd30c$var$_.extend = function(obj) {
    $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$51c8f0da15dbd30c$var$_.isArray = $51c8f0da15dbd30c$var$nativeIsArray || function(obj) {
    return $51c8f0da15dbd30c$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$51c8f0da15dbd30c$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$51c8f0da15dbd30c$var$_.isArguments = function(obj) {
    return !!(obj && $51c8f0da15dbd30c$var$hasOwnProperty.call(obj, 'callee'));
};
$51c8f0da15dbd30c$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($51c8f0da15dbd30c$var$_.isArray(iterable)) return $51c8f0da15dbd30c$var$slice.call(iterable);
    if ($51c8f0da15dbd30c$var$_.isArguments(iterable)) return $51c8f0da15dbd30c$var$slice.call(iterable);
    return $51c8f0da15dbd30c$var$_.values(iterable);
};
$51c8f0da15dbd30c$var$_.map = function(arr, callback, context) {
    if ($51c8f0da15dbd30c$var$nativeMap && arr.map === $51c8f0da15dbd30c$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $51c8f0da15dbd30c$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$51c8f0da15dbd30c$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $51c8f0da15dbd30c$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$51c8f0da15dbd30c$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $51c8f0da15dbd30c$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$51c8f0da15dbd30c$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($51c8f0da15dbd30c$var$nativeIndexOf && obj.indexOf === $51c8f0da15dbd30c$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $51c8f0da15dbd30c$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $51c8f0da15dbd30c$var$breaker;
    });
    return found;
};
$51c8f0da15dbd30c$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$51c8f0da15dbd30c$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$51c8f0da15dbd30c$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$51c8f0da15dbd30c$var$_.isArray(obj);
};
$51c8f0da15dbd30c$var$_.isEmptyObject = function(obj) {
    if ($51c8f0da15dbd30c$var$_.isObject(obj)) {
        for(var key in obj){
            if ($51c8f0da15dbd30c$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$51c8f0da15dbd30c$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$51c8f0da15dbd30c$var$_.isString = function(obj) {
    return $51c8f0da15dbd30c$var$toString.call(obj) == '[object String]';
};
$51c8f0da15dbd30c$var$_.isDate = function(obj) {
    return $51c8f0da15dbd30c$var$toString.call(obj) == '[object Date]';
};
$51c8f0da15dbd30c$var$_.isNumber = function(obj) {
    return $51c8f0da15dbd30c$var$toString.call(obj) == '[object Number]';
};
$51c8f0da15dbd30c$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$51c8f0da15dbd30c$var$_.encodeDates = function(obj) {
    $51c8f0da15dbd30c$var$_.each(obj, function(v, k) {
        if ($51c8f0da15dbd30c$var$_.isDate(v)) obj[k] = $51c8f0da15dbd30c$var$_.formatDate(v);
        else if ($51c8f0da15dbd30c$var$_.isObject(v)) obj[k] = $51c8f0da15dbd30c$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$51c8f0da15dbd30c$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$51c8f0da15dbd30c$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$51c8f0da15dbd30c$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $51c8f0da15dbd30c$var$_.each(p, function(v, k) {
        if ($51c8f0da15dbd30c$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $51c8f0da15dbd30c$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($51c8f0da15dbd30c$var$_.isArray(obj)) {
        ret = [];
        $51c8f0da15dbd30c$var$_.each(obj, function(val) {
            ret.push($51c8f0da15dbd30c$var$_.truncate(val, length));
        });
    } else if ($51c8f0da15dbd30c$var$_.isObject(obj)) {
        ret = {};
        $51c8f0da15dbd30c$var$_.each(obj, function(val, key) {
            ret[key] = $51c8f0da15dbd30c$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$51c8f0da15dbd30c$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($51c8f0da15dbd30c$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($51c8f0da15dbd30c$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $51c8f0da15dbd30c$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$51c8f0da15dbd30c$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $51c8f0da15dbd30c$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$51c8f0da15dbd30c$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$51c8f0da15dbd30c$var$_.UUID = function() {
    try {
        // use native Crypto API when available
        return $51c8f0da15dbd30c$var$win['crypto']['randomUUID']();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        return $51c8f0da15dbd30c$var$_.map(uuid, function(x) {
            return x.toString(16);
        }).join('');
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $51c8f0da15dbd30c$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'amazonbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandex',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$51c8f0da15dbd30c$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $51c8f0da15dbd30c$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($51c8f0da15dbd30c$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $51c8f0da15dbd30c$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($51c8f0da15dbd30c$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $51c8f0da15dbd30c$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$51c8f0da15dbd30c$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $51c8f0da15dbd30c$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$51c8f0da15dbd30c$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $51c8f0da15dbd30c$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $51c8f0da15dbd30c$var$_.JSONDecode($51c8f0da15dbd30c$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $51c8f0da15dbd30c$var$extract_domain($51c8f0da15dbd30c$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $51c8f0da15dbd30c$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $51c8f0da15dbd30c$var$extract_domain($51c8f0da15dbd30c$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $51c8f0da15dbd30c$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $51c8f0da15dbd30c$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $51c8f0da15dbd30c$var$_testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = '__mplss_' + $51c8f0da15dbd30c$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var $51c8f0da15dbd30c$var$_localStorageSupported = null;
var $51c8f0da15dbd30c$var$localStorageSupported = function(storage, forceCheck) {
    if ($51c8f0da15dbd30c$var$_localStorageSupported !== null && !forceCheck) return $51c8f0da15dbd30c$var$_localStorageSupported;
    return $51c8f0da15dbd30c$var$_localStorageSupported = $51c8f0da15dbd30c$var$_testStorageSupported(storage || $51c8f0da15dbd30c$var$win.localStorage);
};
var $51c8f0da15dbd30c$var$_sessionStorageSupported = null;
var $51c8f0da15dbd30c$var$sessionStorageSupported = function(storage, forceCheck) {
    if ($51c8f0da15dbd30c$var$_sessionStorageSupported !== null && !forceCheck) return $51c8f0da15dbd30c$var$_sessionStorageSupported;
    return $51c8f0da15dbd30c$var$_sessionStorageSupported = $51c8f0da15dbd30c$var$_testStorageSupported(storage || $51c8f0da15dbd30c$var$win.sessionStorage);
};
function $51c8f0da15dbd30c$var$_storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        $51c8f0da15dbd30c$var$console$1.error(name + ' error: ' + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) $51c8f0da15dbd30c$var$console$1.error(name + ' unsupported');
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return $51c8f0da15dbd30c$var$_.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
$51c8f0da15dbd30c$var$_.localStorage = $51c8f0da15dbd30c$var$_storageWrapper($51c8f0da15dbd30c$var$win.localStorage, 'localStorage', $51c8f0da15dbd30c$var$localStorageSupported);
$51c8f0da15dbd30c$var$_.sessionStorage = $51c8f0da15dbd30c$var$_storageWrapper($51c8f0da15dbd30c$var$win.sessionStorage, 'sessionStorage', $51c8f0da15dbd30c$var$sessionStorageSupported);
$51c8f0da15dbd30c$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $51c8f0da15dbd30c$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent($51c8f0da15dbd30c$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($51c8f0da15dbd30c$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $51c8f0da15dbd30c$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$51c8f0da15dbd30c$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$51c8f0da15dbd30c$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $51c8f0da15dbd30c$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $51c8f0da15dbd30c$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $51c8f0da15dbd30c$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($51c8f0da15dbd30c$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($51c8f0da15dbd30c$var$_.isElement(query)) return [
            query
        ];
        else if ($51c8f0da15dbd30c$var$_.isObject(query) && !$51c8f0da15dbd30c$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $51c8f0da15dbd30c$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $51c8f0da15dbd30c$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$51c8f0da15dbd30c$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $51c8f0da15dbd30c$var$_.getQueryParam($51c8f0da15dbd30c$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$CLICK_IDS, function(idkey) {
            id = $51c8f0da15dbd30c$var$_.getQueryParam($51c8f0da15dbd30c$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$_.info.campaignParams(), $51c8f0da15dbd30c$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $51c8f0da15dbd30c$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $51c8f0da15dbd30c$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $51c8f0da15dbd30c$var$_.includes(user_agent, ' OPR/')) {
            if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'IEMobile') || $51c8f0da15dbd30c$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Edge') || $51c8f0da15dbd30c$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Whale/')) // https://user-agents.net/browsers/whale-browser
        return 'Whale Browser';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'UCWEB') || $51c8f0da15dbd30c$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($51c8f0da15dbd30c$var$_.includes(vendor, 'Apple')) {
            if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'MSIE') || $51c8f0da15dbd30c$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($51c8f0da15dbd30c$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $51c8f0da15dbd30c$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/,
            'Whale Browser': /Whale\/(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $51c8f0da15dbd30c$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return $51c8f0da15dbd30c$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return $51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$_.strip_empty_properties({
            '$os': $51c8f0da15dbd30c$var$_.info.os(),
            '$browser': $51c8f0da15dbd30c$var$_.info.browser($51c8f0da15dbd30c$var$userAgent, $51c8f0da15dbd30c$var$navigator.vendor, $51c8f0da15dbd30c$var$windowOpera),
            '$referrer': $51c8f0da15dbd30c$var$document$1.referrer,
            '$referring_domain': $51c8f0da15dbd30c$var$_.info.referringDomain($51c8f0da15dbd30c$var$document$1.referrer),
            '$device': $51c8f0da15dbd30c$var$_.info.device($51c8f0da15dbd30c$var$userAgent)
        }), {
            '$current_url': $51c8f0da15dbd30c$var$_.info.currentUrl(),
            '$browser_version': $51c8f0da15dbd30c$var$_.info.browserVersion($51c8f0da15dbd30c$var$userAgent, $51c8f0da15dbd30c$var$navigator.vendor, $51c8f0da15dbd30c$var$windowOpera),
            '$screen_height': $51c8f0da15dbd30c$var$screen.height,
            '$screen_width': $51c8f0da15dbd30c$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $51c8f0da15dbd30c$var$Config.LIB_VERSION,
            '$insert_id': $51c8f0da15dbd30c$var$cheap_guid(),
            'time': $51c8f0da15dbd30c$var$_.timestamp() / 1000 // epoch time in seconds
        }, $51c8f0da15dbd30c$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$_.strip_empty_properties({
            '$os': $51c8f0da15dbd30c$var$_.info.os(),
            '$browser': $51c8f0da15dbd30c$var$_.info.browser($51c8f0da15dbd30c$var$userAgent, $51c8f0da15dbd30c$var$navigator.vendor, $51c8f0da15dbd30c$var$windowOpera)
        }), {
            '$browser_version': $51c8f0da15dbd30c$var$_.info.browserVersion($51c8f0da15dbd30c$var$userAgent, $51c8f0da15dbd30c$var$navigator.vendor, $51c8f0da15dbd30c$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $51c8f0da15dbd30c$var$_.strip_empty_properties({
            'current_page_title': $51c8f0da15dbd30c$var$document$1.title,
            'current_domain': $51c8f0da15dbd30c$var$win.location.hostname,
            'current_url_path': $51c8f0da15dbd30c$var$win.location.pathname,
            'current_url_protocol': $51c8f0da15dbd30c$var$win.location.protocol,
            'current_url_search': $51c8f0da15dbd30c$var$win.location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var $51c8f0da15dbd30c$var$batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new $51c8f0da15dbd30c$var$PromisePolyfill(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var $51c8f0da15dbd30c$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
/**
 * Generates a W3C traceparent header for easy interop with distributed tracing systems i.e Open Telemetry
 * https://www.w3.org/TR/trace-context/#traceparent-header
*/ var $51c8f0da15dbd30c$var$generateTraceparent = function() {
    var traceID = $51c8f0da15dbd30c$var$_.UUID().replace(/-/g, '');
    var parentID = $51c8f0da15dbd30c$var$_.UUID().replace(/-/g, '').substring(0, 16);
    // Sampled trace
    var traceFlags = '01';
    return '00-' + traceID + '-' + parentID + '-' + traceFlags;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $51c8f0da15dbd30c$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $51c8f0da15dbd30c$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $51c8f0da15dbd30c$var$extract_domain = function(hostname) {
    var domain_regex = $51c8f0da15dbd30c$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $51c8f0da15dbd30c$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $51c8f0da15dbd30c$var$isOnline = function() {
    var onLine = $51c8f0da15dbd30c$var$win.navigator['onLine'];
    return $51c8f0da15dbd30c$var$_.isUndefined(onLine) || onLine;
};
var $51c8f0da15dbd30c$var$NOOP_FUNC = function() {};
var $51c8f0da15dbd30c$var$JSONStringify = null, $51c8f0da15dbd30c$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $51c8f0da15dbd30c$var$JSONStringify = JSON.stringify;
    $51c8f0da15dbd30c$var$JSONParse = JSON.parse;
}
$51c8f0da15dbd30c$var$JSONStringify = $51c8f0da15dbd30c$var$JSONStringify || $51c8f0da15dbd30c$var$_.JSONEncode;
$51c8f0da15dbd30c$var$JSONParse = $51c8f0da15dbd30c$var$JSONParse || $51c8f0da15dbd30c$var$_.JSONDecode;
/**
 * Determines if CompressionStream API should be used.
 * Returns false for Safari 16.4 and 16.5 which have breaking CompressionStream bugs.
 * https://bugs.webkit.org/show_bug.cgi?id=254021
 * fixed in 16.6 https://developer.apple.com/documentation/safari-release-notes/safari-16_6-release-notes
 */ var $51c8f0da15dbd30c$var$canUseCompressionStream = function(userAgent, vendor, opera) {
    if (!$51c8f0da15dbd30c$var$win.CompressionStream) return false;
    var browser = $51c8f0da15dbd30c$var$_.info.browser(userAgent, vendor, opera);
    var version = $51c8f0da15dbd30c$var$_.info.browserVersion(userAgent, vendor, opera);
    if (browser === 'Safari' || browser === 'Mobile Safari') {
        if (version >= 16.4 && version < 16.6) return false;
    }
    return true;
};
// UNMINIFIED EXPORTS (for closure compiler)
$51c8f0da15dbd30c$var$_['info'] = $51c8f0da15dbd30c$var$_.info;
$51c8f0da15dbd30c$var$_['info']['browser'] = $51c8f0da15dbd30c$var$_.info.browser;
$51c8f0da15dbd30c$var$_['info']['browserVersion'] = $51c8f0da15dbd30c$var$_.info.browserVersion;
$51c8f0da15dbd30c$var$_['info']['device'] = $51c8f0da15dbd30c$var$_.info.device;
$51c8f0da15dbd30c$var$_['info']['properties'] = $51c8f0da15dbd30c$var$_.info.properties;
$51c8f0da15dbd30c$var$_['isBlockedUA'] = $51c8f0da15dbd30c$var$_.isBlockedUA;
$51c8f0da15dbd30c$var$_['isEmptyObject'] = $51c8f0da15dbd30c$var$_.isEmptyObject;
$51c8f0da15dbd30c$var$_['isObject'] = $51c8f0da15dbd30c$var$_.isObject;
$51c8f0da15dbd30c$var$_['JSONDecode'] = $51c8f0da15dbd30c$var$_.JSONDecode;
$51c8f0da15dbd30c$var$_['JSONEncode'] = $51c8f0da15dbd30c$var$_.JSONEncode;
$51c8f0da15dbd30c$var$_['toArray'] = $51c8f0da15dbd30c$var$_.toArray;
$51c8f0da15dbd30c$var$_['NPO'] = $51c8f0da15dbd30c$var$NpoPromise;
var $51c8f0da15dbd30c$var$MIXPANEL_DB_NAME = 'mixpanelBrowserDb';
var $51c8f0da15dbd30c$var$RECORDING_EVENTS_STORE_NAME = 'mixpanelRecordingEvents';
var $51c8f0da15dbd30c$var$RECORDING_REGISTRY_STORE_NAME = 'mixpanelRecordingRegistry';
// note: increment the version number when adding new object stores
var $51c8f0da15dbd30c$var$DB_VERSION = 1;
var $51c8f0da15dbd30c$var$OBJECT_STORES = [
    $51c8f0da15dbd30c$var$RECORDING_EVENTS_STORE_NAME,
    $51c8f0da15dbd30c$var$RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $51c8f0da15dbd30c$var$IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype._openDb = function() {
    return new $51c8f0da15dbd30c$var$PromisePolyfill(function(resolve, reject) {
        var openRequest = $51c8f0da15dbd30c$var$win.indexedDB.open($51c8f0da15dbd30c$var$MIXPANEL_DB_NAME, $51c8f0da15dbd30c$var$DB_VERSION);
        openRequest['onerror'] = function() {
            reject(openRequest.error);
        };
        openRequest['onsuccess'] = function() {
            resolve(openRequest.result);
        };
        openRequest['onupgradeneeded'] = function(ev) {
            var db = ev.target.result;
            $51c8f0da15dbd30c$var$OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.init = function() {
    if (!$51c8f0da15dbd30c$var$win.indexedDB) return $51c8f0da15dbd30c$var$PromisePolyfill.reject('indexedDB is not supported in this browser');
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof $51c8f0da15dbd30c$var$win['IDBDatabase']) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
        else return $51c8f0da15dbd30c$var$PromisePolyfill.reject(dbOrError);
    });
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.isInitialized = function() {
    return !!this.dbPromise;
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ $51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new $51c8f0da15dbd30c$var$PromisePolyfill(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err['name'] === 'InvalidStateError') {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return $51c8f0da15dbd30c$var$PromisePolyfill.reject(err);
    }).bind(this));
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.put(value, key);
    });
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.delete(key);
    });
};
$51c8f0da15dbd30c$var$IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $51c8f0da15dbd30c$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $51c8f0da15dbd30c$var$optIn(token, options) {
    $51c8f0da15dbd30c$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $51c8f0da15dbd30c$var$optOut(token, options) {
    $51c8f0da15dbd30c$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $51c8f0da15dbd30c$var$hasOptedIn(token, options) {
    return $51c8f0da15dbd30c$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $51c8f0da15dbd30c$var$hasOptedOut(token, options) {
    if ($51c8f0da15dbd30c$var$_hasDoNotTrackFlagOn(options)) {
        $51c8f0da15dbd30c$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $51c8f0da15dbd30c$var$_getStorageValue(token, options) === '0';
    if (optedOut) $51c8f0da15dbd30c$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(method) {
    return $51c8f0da15dbd30c$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(method) {
    return $51c8f0da15dbd30c$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(method) {
    return $51c8f0da15dbd30c$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $51c8f0da15dbd30c$var$clearOptInOut(token, options) {
    options = options || {};
    $51c8f0da15dbd30c$var$_getStorage(options).remove($51c8f0da15dbd30c$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $51c8f0da15dbd30c$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $51c8f0da15dbd30c$var$_.localStorage : $51c8f0da15dbd30c$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $51c8f0da15dbd30c$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $51c8f0da15dbd30c$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $51c8f0da15dbd30c$var$_getStorageValue(token, options) {
    return $51c8f0da15dbd30c$var$_getStorage(options).get($51c8f0da15dbd30c$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $51c8f0da15dbd30c$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $51c8f0da15dbd30c$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $51c8f0da15dbd30c$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($51c8f0da15dbd30c$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $51c8f0da15dbd30c$var$_optInOut(optValue, token, options) {
    if (!$51c8f0da15dbd30c$var$_.isString(token) || !token.length) {
        $51c8f0da15dbd30c$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $51c8f0da15dbd30c$var$_getStorage(options).set($51c8f0da15dbd30c$var$_getStorageKey(token, options), optValue ? 1 : 0, $51c8f0da15dbd30c$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $51c8f0da15dbd30c$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $51c8f0da15dbd30c$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $51c8f0da15dbd30c$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $51c8f0da15dbd30c$var$logger$6 = $51c8f0da15dbd30c$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $51c8f0da15dbd30c$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || $51c8f0da15dbd30c$var$win.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $51c8f0da15dbd30c$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$51c8f0da15dbd30c$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise1 = this.promiseImpl;
    return new Promise1($51c8f0da15dbd30c$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $51c8f0da15dbd30c$var$logger$6.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$51c8f0da15dbd30c$var$localStorageSupported(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, '1');
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($51c8f0da15dbd30c$var$localStorageSupported(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $51c8f0da15dbd30c$var$LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || $51c8f0da15dbd30c$var$win.localStorage;
};
$51c8f0da15dbd30c$var$LocalStorageWrapper.prototype.init = function() {
    return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
};
$51c8f0da15dbd30c$var$LocalStorageWrapper.prototype.isInitialized = function() {
    return true;
};
$51c8f0da15dbd30c$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $51c8f0da15dbd30c$var$PromisePolyfill($51c8f0da15dbd30c$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, $51c8f0da15dbd30c$var$JSONStringify(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$51c8f0da15dbd30c$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $51c8f0da15dbd30c$var$PromisePolyfill($51c8f0da15dbd30c$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = $51c8f0da15dbd30c$var$JSONParse(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$51c8f0da15dbd30c$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $51c8f0da15dbd30c$var$PromisePolyfill($51c8f0da15dbd30c$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $51c8f0da15dbd30c$var$logger$5 = $51c8f0da15dbd30c$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $51c8f0da15dbd30c$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $51c8f0da15dbd30c$var$LocalStorageWrapper();
        this.lock = new $51c8f0da15dbd30c$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || $51c8f0da15dbd30c$var$win.localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || $51c8f0da15dbd30c$var$_.bind($51c8f0da15dbd30c$var$logger$5.error, $51c8f0da15dbd30c$var$logger$5);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = $51c8f0da15dbd30c$var$batchedThrottle($51c8f0da15dbd30c$var$_.bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = $51c8f0da15dbd30c$var$_.bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
$51c8f0da15dbd30c$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized || !this.usePersistence) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($51c8f0da15dbd30c$var$_.bind(function() {
        this.initialized = true;
    }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        'id': $51c8f0da15dbd30c$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
$51c8f0da15dbd30c$var$RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = $51c8f0da15dbd30c$var$_.bind(function() {
        return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then($51c8f0da15dbd30c$var$_.bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
            this.reportError('Error enqueueing items', err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $51c8f0da15dbd30c$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $51c8f0da15dbd30c$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $51c8f0da15dbd30c$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $51c8f0da15dbd30c$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $51c8f0da15dbd30c$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $51c8f0da15dbd30c$var$_.bind(function() {
            return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storedQueue) {
                storedQueue = $51c8f0da15dbd30c$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($51c8f0da15dbd30c$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!$51c8f0da15dbd30c$var$localStorageSupported(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($51c8f0da15dbd30c$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $51c8f0da15dbd30c$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $51c8f0da15dbd30c$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $51c8f0da15dbd30c$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($51c8f0da15dbd30c$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storedQueue) {
            storedQueue = $51c8f0da15dbd30c$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($51c8f0da15dbd30c$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            if (!$51c8f0da15dbd30c$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $51c8f0da15dbd30c$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($51c8f0da15dbd30c$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $51c8f0da15dbd30c$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $51c8f0da15dbd30c$var$logger$4 = $51c8f0da15dbd30c$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $51c8f0da15dbd30c$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $51c8f0da15dbd30c$var$RequestQueue(storageKey, {
        errorReporter: $51c8f0da15dbd30c$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($51c8f0da15dbd30c$var$_.bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $51c8f0da15dbd30c$var$PromisePolyfill($51c8f0da15dbd30c$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $51c8f0da15dbd30c$var$logger$4.log('Flush: Request already in progress');
        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($51c8f0da15dbd30c$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $51c8f0da15dbd30c$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $51c8f0da15dbd30c$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $51c8f0da15dbd30c$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $51c8f0da15dbd30c$var$_.bind(function() {
            return this.queue.removeItemsByID($51c8f0da15dbd30c$var$_.map(batch, function(item) {
                return item['id'];
            })).then($51c8f0da15dbd30c$var$_.bind(function(succeeded) {
                // client-side dedupe
                $51c8f0da15dbd30c$var$_.each(batch, $51c8f0da15dbd30c$var$_.bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $51c8f0da15dbd30c$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($51c8f0da15dbd30c$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ($51c8f0da15dbd30c$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$51c8f0da15dbd30c$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($51c8f0da15dbd30c$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
                } else if ($51c8f0da15dbd30c$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $51c8f0da15dbd30c$var$logger$4.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $51c8f0da15dbd30c$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $51c8f0da15dbd30c$var$logger$4.error.apply($51c8f0da15dbd30c$var$logger$4.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $51c8f0da15dbd30c$var$logger$4.error(err);
    }
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var $51c8f0da15dbd30c$var$isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording['maxExpires'] || now > serializedRecording['idleExpires'];
};
var $51c8f0da15dbd30c$var$RECORD_ENQUEUE_THROTTLE_MS = 250;
var $51c8f0da15dbd30c$var$logger$3 = $51c8f0da15dbd30c$var$console_with_prefix('recorder');
var $51c8f0da15dbd30c$var$CompressionStream = $51c8f0da15dbd30c$var$win['CompressionStream'];
var $51c8f0da15dbd30c$var$RECORDER_BATCHER_LIB_CONFIG = {
    'batch_size': 1000,
    'batch_flush_interval_ms': 10000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true
};
var $51c8f0da15dbd30c$var$ACTIVE_SOURCES = new Set([
    $51c8f0da15dbd30c$var$IncrementalSource.MouseMove,
    $51c8f0da15dbd30c$var$IncrementalSource.MouseInteraction,
    $51c8f0da15dbd30c$var$IncrementalSource.Scroll,
    $51c8f0da15dbd30c$var$IncrementalSource.ViewportResize,
    $51c8f0da15dbd30c$var$IncrementalSource.Input,
    $51c8f0da15dbd30c$var$IncrementalSource.TouchMove,
    $51c8f0da15dbd30c$var$IncrementalSource.MediaInteraction,
    $51c8f0da15dbd30c$var$IncrementalSource.Drag,
    $51c8f0da15dbd30c$var$IncrementalSource.Selection
]);
function $51c8f0da15dbd30c$var$isUserEvent(ev) {
    return ev.type === $51c8f0da15dbd30c$var$EventType.IncrementalSnapshot && $51c8f0da15dbd30c$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * @typedef {Object} SerializedRecording
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} lastEventTimestamp
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayId
 * @property {string} tabId
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} SessionRecordingOptions
 * @property {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @property {String} [options.replayId] - unique uuid for a single replay
 * @property {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @property {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @property {Function} [options.rrwebRecord] - rrweb's `record` function
 * @property {Function} [options.onBatchSent] - callback when a batch of events is sent to the server
 * @property {Storage} [options.sharedLockStorage] - optional storage for shared lock, used for test dependency injection
 * optional properties for deserialization:
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} lastEventTimestamp - the unix timestamp of the last recorded event from rrweb
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} UserIdInfo
 * @property {string} distinct_id
 * @property {string} user_id
 * @property {string} device_id
 */ /**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {SessionRecordingOptions} options
 */ var $51c8f0da15dbd30c$var$SessionRecording = function(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout || $51c8f0da15dbd30c$var$NOOP_FUNC;
    this._onMaxLengthReached = options.onMaxLengthReached || $51c8f0da15dbd30c$var$NOOP_FUNC;
    this._onBatchSent = options.onBatchSent || $51c8f0da15dbd30c$var$NOOP_FUNC;
    this._rrwebRecord = options.rrwebRecord || null;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.replayId = options.replayId;
    this.batchStartUrl = options.batchStartUrl || null;
    this.replayStartUrl = options.replayStartUrl || null;
    this.idleExpires = options.idleExpires || null;
    this.maxExpires = options.maxExpires || null;
    this.replayStartTime = options.replayStartTime || null;
    this.lastEventTimestamp = options.lastEventTimestamp || null;
    this.seqNo = options.seqNo || 0;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $51c8f0da15dbd30c$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // disable persistence if localStorage is not supported
    // request-queue will automatically disable persistence if indexedDB fails to initialize
    var usePersistence = $51c8f0da15dbd30c$var$localStorageSupported(options.sharedLockStorage, true) && !this.getConfig('disable_persistence');
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    this.batcherKey = '__mprec_' + this.getConfig('name') + '_' + this.getConfig('token') + '_' + this.replayId;
    this.queueStorage = new $51c8f0da15dbd30c$var$IDBStorageWrapper($51c8f0da15dbd30c$var$RECORDING_EVENTS_STORE_NAME);
    this.batcher = new $51c8f0da15dbd30c$var$RequestBatcher(this.batcherKey, {
        errorReporter: this.reportError.bind(this),
        flushOnlyOnInterval: true,
        libConfig: $51c8f0da15dbd30c$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: this.flushEventsWithOptOut.bind(this),
        queueStorage: this.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: usePersistence,
        stopAllBatchingFunc: this.stopRecording.bind(this),
        // increased throttle and shared lock timeout because recording events are very high frequency.
        // this will minimize the amount of lock contention between enqueued events.
        // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
        enqueueThrottleMs: $51c8f0da15dbd30c$var$RECORD_ENQUEUE_THROTTLE_MS,
        sharedLockTimeoutMS: 10000
    });
};
/**
 * @returns {UserIdInfo}
 */ $51c8f0da15dbd30c$var$SessionRecording.prototype.getUserIdInfo = function() {
    if (this.finalFlushUserIdInfo) return this.finalFlushUserIdInfo;
    var userIdInfo = {
        'distinct_id': String(this._mixpanel.get_distinct_id())
    };
    // send ID management props if they exist
    var deviceId = this._mixpanel.get_property('$device_id');
    if (deviceId) userIdInfo['$device_id'] = deviceId;
    var userId = this._mixpanel.get_property('$user_id');
    if (userId) userIdInfo['$user_id'] = userId;
    return userIdInfo;
};
$51c8f0da15dbd30c$var$SessionRecording.prototype.unloadPersistedData = function() {
    this.batcher.stop();
    return this.queueStorage.init().catch((function() {
        this.reportError('Error initializing IndexedDB storage for unloading persisted data.');
    }).bind(this)).then((function() {
        // if the recording is too short, just delete any stored events without flushing
        if (this.getDurationMs() < this._getRecordMinMs()) return this.queueStorage.removeItem(this.batcherKey);
        return this.batcher.flush().then((function() {
            return this.queueStorage.removeItem(this.batcherKey);
        }).bind(this));
    }).bind(this));
};
$51c8f0da15dbd30c$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$51c8f0da15dbd30c$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$51c8f0da15dbd30c$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._rrwebRecord === null) {
        this.reportError('rrweb record function not provided. ');
        return;
    }
    if (this._stopRecording !== null) {
        $51c8f0da15dbd30c$var$logger$3.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.getConfig('record_max_ms');
    if (this.recordMaxMs > $51c8f0da15dbd30c$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $51c8f0da15dbd30c$var$MAX_RECORDING_MS;
        $51c8f0da15dbd30c$var$logger$3.critical('record_max_ms cannot be greater than ' + $51c8f0da15dbd30c$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.maxExpires) this.maxExpires = new Date().getTime() + this.recordMaxMs;
    this.recordMinMs = this._getRecordMinMs();
    if (!this.replayStartTime) {
        this.replayStartTime = new Date().getTime();
        this.batchStartUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
        this.replayStartUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
    }
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = (function() {
        clearTimeout(this.idleTimeoutId);
        var idleTimeoutMs = this.getConfig('record_idle_timeout_ms');
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, idleTimeoutMs);
        this.idleExpires = new Date().getTime() + idleTimeoutMs;
    }).bind(this);
    resetIdleTimeout();
    var blockSelector = this.getConfig('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    try {
        this._stopRecording = this._rrwebRecord({
            'emit': (function(ev) {
                if (this.idleExpires && this.idleExpires < ev.timestamp) {
                    this._onIdleTimeout();
                    return;
                }
                if ($51c8f0da15dbd30c$var$isUserEvent(ev)) {
                    if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                    this.batcher.start();
                    resetIdleTimeout();
                }
                // promise only used to await during tests
                this.__enqueuePromise = this.batcher.enqueue(ev);
                // Capture the timestamp of the last event for duration calculation.
                if (this.lastEventTimestamp === null || ev.timestamp > this.lastEventTimestamp) this.lastEventTimestamp = ev.timestamp;
            }).bind(this),
            'blockClass': this.getConfig('record_block_class'),
            'blockSelector': blockSelector,
            'collectFonts': this.getConfig('record_collect_fonts'),
            'dataURLOptions': {
                'type': 'image/webp',
                'quality': 0.6
            },
            'maskAllInputs': true,
            'maskTextClass': this.getConfig('record_mask_text_class'),
            'maskTextSelector': this.getConfig('record_mask_text_selector'),
            'recordCanvas': this.getConfig('record_canvas'),
            'sampling': {
                'canvas': 15
            },
            'plugins': this.getConfig('record_console') ? [
                $51c8f0da15dbd30c$var$getRecordConsolePlugin({
                    stringifyOptions: {
                        stringLengthLimit: 1000,
                        numOfKeysLimit: 50,
                        depthOfLimit: 2
                    }
                })
            ] : []
        });
    } catch (err) {
        this.reportError('Unexpected error when starting rrweb recording.', err);
    }
    if (typeof this._stopRecording !== 'function') {
        this.reportError('rrweb failed to start, skipping this recording.');
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    var maxTimeoutMs = this.maxExpires - new Date().getTime();
    this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), maxTimeoutMs);
};
$51c8f0da15dbd30c$var$SessionRecording.prototype.stopRecording = function(skipFlush) {
    // store the user ID info in case this is getting called in mixpanel.reset()
    this.finalFlushUserIdInfo = this.getUserIdInfo();
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError('Error with rrweb stopRecording', err);
        }
        this._stopRecording = null;
    }
    var flushPromise;
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    flushPromise = this.batcher.clear();
    else if (!skipFlush) // flush any remaining events from running batcher
    flushPromise = this.batcher.flush();
    this.batcher.stop();
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
    return flushPromise;
};
$51c8f0da15dbd30c$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $51c8f0da15dbd30c$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    var onOptOut = (function(code) {
        // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
        if (code === 0) {
            this.stopRecording();
            cb({
                error: 'Tracking has been opted out, stopping recording.'
            });
        }
    }).bind(this);
    this._flushEvents(data, options, cb, onOptOut);
};
/**
 * @returns {SerializedRecording}
 */ $51c8f0da15dbd30c$var$SessionRecording.prototype.serialize = function() {
    // don't break if mixpanel instance was destroyed at some point
    var tabId;
    try {
        tabId = this._mixpanel.get_tab_id();
    } catch (e) {
        this.reportError('Error getting tab ID for serialization ', e);
        tabId = null;
    }
    return {
        'replayId': this.replayId,
        'seqNo': this.seqNo,
        'replayStartTime': this.replayStartTime,
        'batchStartUrl': this.batchStartUrl,
        'replayStartUrl': this.replayStartUrl,
        'lastEventTimestamp': this.lastEventTimestamp,
        'idleExpires': this.idleExpires,
        'maxExpires': this.maxExpires,
        'tabId': tabId
    };
};
/**
 * @static
 * @param {SerializedRecording} serializedRecording
 * @param {SessionRecordingOptions} options
 * @returns {SessionRecording}
 */ $51c8f0da15dbd30c$var$SessionRecording.deserialize = function(serializedRecording, options) {
    var recording = new $51c8f0da15dbd30c$var$SessionRecording($51c8f0da15dbd30c$var$_.extend({}, options, {
        replayId: serializedRecording['replayId'],
        batchStartUrl: serializedRecording['batchStartUrl'],
        replayStartUrl: serializedRecording['replayStartUrl'],
        idleExpires: serializedRecording['idleExpires'],
        maxExpires: serializedRecording['maxExpires'],
        replayStartTime: serializedRecording['replayStartTime'],
        lastEventTimestamp: serializedRecording['lastEventTimestamp'],
        seqNo: serializedRecording['seqNo'],
        sharedLockStorage: options.sharedLockStorage
    }));
    return recording;
};
$51c8f0da15dbd30c$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = (function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
        }
        this._onBatchSent();
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }).bind(this);
    var apiHost = this._mixpanel.get_api_host && this._mixpanel.get_api_host('record') || this.getConfig('api_host');
    $51c8f0da15dbd30c$var$win['fetch'](apiHost + '/' + this.getConfig('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$51c8f0da15dbd30c$var$SessionRecording.prototype._flushEvents = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = Infinity;
        var batchEndTime = -Infinity;
        var hasFullSnapshot = false;
        for(var i = 0; i < numEvents; i++){
            batchStartTime = Math.min(batchStartTime, data[i].timestamp);
            batchEndTime = Math.max(batchEndTime, data[i].timestamp);
            if (data[i].type === $51c8f0da15dbd30c$var$EventType.FullSnapshot) hasFullSnapshot = true;
        }
        if (this.seqNo === 0) {
            if (!hasFullSnapshot) {
                callback({
                    error: 'First batch does not contain a full snapshot. Aborting recording.'
                });
                this.stopRecording(true);
                return;
            }
            this.replayStartTime = batchStartTime;
        } else if (!this.replayStartTime) {
            this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = batchEndTime - this.replayStartTime;
        var reqParams = {
            '$current_url': this.batchStartUrl,
            '$lib_version': $51c8f0da15dbd30c$var$Config.LIB_VERSION,
            'batch_start_time': batchStartTime / 1000,
            'mp_lib': 'web',
            'replay_id': replayId,
            'replay_length_ms': replayLengthMs,
            'replay_start_time': this.replayStartTime / 1000,
            'replay_start_url': this.replayStartUrl,
            'seq': this.seqNo
        };
        var eventsJson = JSON.stringify(data);
        Object.assign(reqParams, this.getUserIdInfo());
        if ($51c8f0da15dbd30c$var$canUseCompressionStream($51c8f0da15dbd30c$var$userAgent, $51c8f0da15dbd30c$var$navigator.vendor, $51c8f0da15dbd30c$var$windowOpera)) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $51c8f0da15dbd30c$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then((function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }).bind(this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$51c8f0da15dbd30c$var$SessionRecording.prototype.reportError = function(msg, err) {
    $51c8f0da15dbd30c$var$logger$3.error.apply($51c8f0da15dbd30c$var$logger$3.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig('error_reporter')(msg, err);
    } catch (err) {
        $51c8f0da15dbd30c$var$logger$3.error(err);
    }
};
/**
 * Calculates the duration of the recording in milliseconds, based on the start time and time of last recorded event.
 * @returns {number} The duration of the recording in milliseconds. Returns 0 if recording hasn't started.
 */ $51c8f0da15dbd30c$var$SessionRecording.prototype.getDurationMs = function() {
    if (this.replayStartTime === null) return 0;
    // If the recording has no events, assume it is in progress and use the current time as the end time.
    if (this.lastEventTimestamp === null) return new Date().getTime() - this.replayStartTime;
    return this.lastEventTimestamp - this.replayStartTime;
};
/**
 * Lazily loads the minimum recording length config in milliseconds, respecting the maximum limit.
 * @returns {number} The minimum recording length in milliseconds.
 */ $51c8f0da15dbd30c$var$SessionRecording.prototype._getRecordMinMs = function() {
    var configValue = this.getConfig('record_min_ms');
    if (configValue > $51c8f0da15dbd30c$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        $51c8f0da15dbd30c$var$logger$3.critical('record_min_ms cannot be greater than ' + $51c8f0da15dbd30c$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
        return $51c8f0da15dbd30c$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
    }
    return configValue;
};
/**
 * Module for handling the storage and retrieval of recording metadata as well as any active recordings.
 * Makes sure that only one tab can be recording at a time.
 */ var $51c8f0da15dbd30c$var$RecordingRegistry = function(options) {
    /** @type {IDBStorageWrapper} */ this.idb = new $51c8f0da15dbd30c$var$IDBStorageWrapper($51c8f0da15dbd30c$var$RECORDING_REGISTRY_STORE_NAME);
    this.errorReporter = options.errorReporter;
    this.mixpanelInstance = options.mixpanelInstance;
    this.sharedLockStorage = options.sharedLockStorage;
};
$51c8f0da15dbd30c$var$RecordingRegistry.prototype.isPersistenceEnabled = function() {
    return !this.mixpanelInstance.get_config('disable_persistence');
};
$51c8f0da15dbd30c$var$RecordingRegistry.prototype.handleError = function(err) {
    this.errorReporter('IndexedDB error: ', err);
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 */ $51c8f0da15dbd30c$var$RecordingRegistry.prototype.setActiveRecording = function(serializedRecording) {
    if (!this.isPersistenceEnabled()) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
    var tabId = serializedRecording['tabId'];
    if (!tabId) {
        console.warn('No tab ID is set, cannot persist recording metadata.');
        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
    }
    return this.idb.init().then((function() {
        return this.idb.setItem(tabId, serializedRecording);
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * @returns {Promise<import('./session-recording').SerializedRecording>}
 */ $51c8f0da15dbd30c$var$RecordingRegistry.prototype.getActiveRecording = function() {
    if (!this.isPersistenceEnabled()) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(null);
    return this.idb.init().then((function() {
        return this.idb.getItem(this.mixpanelInstance.get_tab_id());
    }).bind(this)).then((function(serializedRecording) {
        return $51c8f0da15dbd30c$var$isRecordingExpired(serializedRecording) ? null : serializedRecording;
    }).bind(this)).catch(this.handleError.bind(this));
};
$51c8f0da15dbd30c$var$RecordingRegistry.prototype.clearActiveRecording = function() {
    if (this.isPersistenceEnabled()) // mark recording as expired instead of deleting it in case the page unloads mid-flush and doesn't make it to ingestion.
    // this will ensure the next pageload will flush the remaining events, but not try to continue the recording.
    return this.markActiveRecordingExpired();
    else return this.deleteActiveRecording();
};
$51c8f0da15dbd30c$var$RecordingRegistry.prototype.markActiveRecordingExpired = function() {
    return this.getActiveRecording().then((function(serializedRecording) {
        if (serializedRecording) {
            serializedRecording['maxExpires'] = 0;
            return this.setActiveRecording(serializedRecording);
        }
    }).bind(this)).catch(this.handleError.bind(this));
};
$51c8f0da15dbd30c$var$RecordingRegistry.prototype.deleteActiveRecording = function() {
    // avoid initializing IDB if this registry instance hasn't already written a recording
    if (this.idb.isInitialized()) return this.idb.removeItem(this.mixpanelInstance.get_tab_id()).catch(this.handleError.bind(this));
    else return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
};
/**
 * Flush any inactive recordings from the registry to minimize data loss.
 * The main idea here is that we can flush remaining rrweb events on the next page load if a tab is closed mid-batch.
 */ $51c8f0da15dbd30c$var$RecordingRegistry.prototype.flushInactiveRecordings = function() {
    if (!this.isPersistenceEnabled()) return $51c8f0da15dbd30c$var$PromisePolyfill.resolve([]);
    return this.idb.init().then((function() {
        return this.idb.getAll();
    }).bind(this)).then((function(serializedRecordings) {
        // clean up any expired recordings from the registry, non-expired ones may be active in other tabs
        var unloadPromises = serializedRecordings.filter(function(serializedRecording) {
            return $51c8f0da15dbd30c$var$isRecordingExpired(serializedRecording);
        }).map((function(serializedRecording) {
            var sessionRecording = $51c8f0da15dbd30c$var$SessionRecording.deserialize(serializedRecording, {
                mixpanelInstance: this.mixpanelInstance,
                sharedLockStorage: this.sharedLockStorage
            });
            return sessionRecording.unloadPersistedData().then((function() {
                // expired recording was successfully flushed, we can clean it up from the registry
                return this.idb.removeItem(serializedRecording['tabId']);
            }).bind(this)).catch(this.handleError.bind(this));
        }).bind(this));
        return $51c8f0da15dbd30c$var$PromisePolyfill.all(unloadPromises);
    }).bind(this)).catch(this.handleError.bind(this));
};
var $51c8f0da15dbd30c$var$logger$2 = $51c8f0da15dbd30c$var$console_with_prefix('recorder');
/**
 * Recorder API: bundles rrweb and and exposes methods to start and stop recordings.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
*/ var $51c8f0da15dbd30c$var$MixpanelRecorder = function(mixpanelInstance, rrwebRecord, sharedLockStorage) {
    this.mixpanelInstance = mixpanelInstance;
    this.rrwebRecord = rrwebRecord || $51c8f0da15dbd30c$var$record;
    this.sharedLockStorage = sharedLockStorage;
    /**
     * @member {import('./registry').RecordingRegistry}
     */ this.recordingRegistry = new $51c8f0da15dbd30c$var$RecordingRegistry({
        mixpanelInstance: this.mixpanelInstance,
        errorReporter: $51c8f0da15dbd30c$var$logger$2.error,
        sharedLockStorage: sharedLockStorage
    });
    this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings();
    this.activeRecording = null;
    this.stopRecordingInProgress = false;
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.startRecording = function(options) {
    options = options || {};
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $51c8f0da15dbd30c$var$logger$2.log('Recording already in progress, skipping startRecording.');
        return;
    }
    var onIdleTimeout = (function() {
        $51c8f0da15dbd30c$var$logger$2.log('Idle timeout reached, restarting recording.');
        this.resetRecording();
    }).bind(this);
    var onMaxLengthReached = (function() {
        $51c8f0da15dbd30c$var$logger$2.log('Max recording length reached, stopping recording.');
        this.resetRecording();
    }).bind(this);
    var onBatchSent = (function() {
        this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
        this['__flushPromise'] = this.activeRecording.batcher._flushPromise;
    }).bind(this);
    /**
     * @type {import('./session-recording').SessionRecordingOptions}
     */ var sessionRecordingOptions = {
        mixpanelInstance: this.mixpanelInstance,
        onBatchSent: onBatchSent,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $51c8f0da15dbd30c$var$_.UUID(),
        rrwebRecord: this.rrwebRecord,
        sharedLockStorage: this.sharedLockStorage
    };
    if (options.activeSerializedRecording) this.activeRecording = $51c8f0da15dbd30c$var$SessionRecording.deserialize(options.activeSerializedRecording, sessionRecordingOptions);
    else this.activeRecording = new $51c8f0da15dbd30c$var$SessionRecording(sessionRecordingOptions);
    this.activeRecording.startRecording(options.shouldStopBatcher);
    return this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.stopRecording = function() {
    // Prevents activeSerializedRecording from being reused when stopping the recording.
    this.stopRecordingInProgress = true;
    return this._stopCurrentRecording(false, true).then((function() {
        return this.recordingRegistry.clearActiveRecording();
    }).bind(this)).then((function() {
        this.stopRecordingInProgress = false;
    }).bind(this));
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.pauseRecording = function() {
    return this._stopCurrentRecording(false);
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype._stopCurrentRecording = function(skipFlush, disableActiveRecording) {
    if (this.activeRecording) {
        var stopRecordingPromise = this.activeRecording.stopRecording(skipFlush);
        if (disableActiveRecording) this.activeRecording = null;
        return stopRecordingPromise;
    }
    return $51c8f0da15dbd30c$var$PromisePolyfill.resolve();
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.resumeRecording = function(startNewIfInactive) {
    if (this.activeRecording && this.activeRecording.isRrwebStopped()) {
        this.activeRecording.startRecording(false);
        return $51c8f0da15dbd30c$var$PromisePolyfill.resolve(null);
    }
    return this.recordingRegistry.getActiveRecording().then((function(activeSerializedRecording) {
        if (activeSerializedRecording && !this.stopRecordingInProgress) return this.startRecording({
            activeSerializedRecording: activeSerializedRecording
        });
        else if (startNewIfInactive) return this.startRecording({
            shouldStopBatcher: false
        });
        else {
            $51c8f0da15dbd30c$var$logger$2.log('No resumable recording found.');
            return null;
        }
    }).bind(this));
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording({
        shouldStopBatcher: true
    });
};
$51c8f0da15dbd30c$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($51c8f0da15dbd30c$var$MixpanelRecorder.prototype, 'replayId', {
    get: function() {
        return this.getActiveReplayId();
    }
});
$51c8f0da15dbd30c$var$win['__mp_recorder'] = $51c8f0da15dbd30c$var$MixpanelRecorder;
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var $51c8f0da15dbd30c$var$EV_CHANGE = 'change';
var $51c8f0da15dbd30c$var$EV_CLICK = 'click';
var $51c8f0da15dbd30c$var$EV_HASHCHANGE = 'hashchange';
var $51c8f0da15dbd30c$var$EV_INPUT = 'input';
var $51c8f0da15dbd30c$var$EV_LOAD = 'load';
var $51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE = 'mp_locationchange';
var $51c8f0da15dbd30c$var$EV_POPSTATE = 'popstate';
// TODO scrollend isn't available in Safari: document or polyfill?
var $51c8f0da15dbd30c$var$EV_SCROLLEND = 'scrollend';
var $51c8f0da15dbd30c$var$EV_SCROLL = 'scroll';
var $51c8f0da15dbd30c$var$EV_SELECT = 'select';
var $51c8f0da15dbd30c$var$EV_SUBMIT = 'submit';
var $51c8f0da15dbd30c$var$EV_TOGGLE = 'toggle';
var $51c8f0da15dbd30c$var$EV_VISIBILITYCHANGE = 'visibilitychange';
var $51c8f0da15dbd30c$var$CLICK_EVENT_PROPS = [
    'clientX',
    'clientY',
    'offsetX',
    'offsetY',
    'pageX',
    'pageY',
    'screenX',
    'screenY',
    'x',
    'y'
];
var $51c8f0da15dbd30c$var$OPT_IN_CLASSES = [
    'mp-include'
];
var $51c8f0da15dbd30c$var$OPT_OUT_CLASSES = [
    'mp-no-track'
];
var $51c8f0da15dbd30c$var$SENSITIVE_DATA_CLASSES = $51c8f0da15dbd30c$var$OPT_OUT_CLASSES.concat([
    'mp-sensitive'
]);
var $51c8f0da15dbd30c$var$TRACKED_ATTRS = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'href',
    'name',
    'role',
    'title',
    'type'
];
var $51c8f0da15dbd30c$var$INTERACTIVE_ARIA_ROLES = {
    'button': true,
    'checkbox': true,
    'combobox': true,
    'grid': true,
    'link': true,
    'listbox': true,
    'menu': true,
    'menubar': true,
    'menuitem': true,
    'menuitemcheckbox': true,
    'menuitemradio': true,
    'navigation': true,
    'option': true,
    'radio': true,
    'radiogroup': true,
    'searchbox': true,
    'slider': true,
    'spinbutton': true,
    'switch': true,
    'tab': true,
    'tablist': true,
    'textbox': true,
    'tree': true,
    'treegrid': true,
    'treeitem': true
};
var $51c8f0da15dbd30c$var$ALWAYS_NON_INTERACTIVE_TAGS = {
    // Document metadata
    'base': true,
    'head': true,
    'html': true,
    'link': true,
    'meta': true,
    'script': true,
    'style': true,
    'title': true,
    // Text formatting
    'br': true,
    'hr': true,
    'wbr': true,
    // Other
    'noscript': true,
    'picture': true,
    'source': true,
    'template': true,
    'track': true
};
// Common container tags that need additional checks
var $51c8f0da15dbd30c$var$TEXT_CONTAINER_TAGS = {
    'article': true,
    'div': true,
    'h1': true,
    'h2': true,
    'h3': true,
    'h4': true,
    'h5': true,
    'h6': true,
    'p': true,
    'section': true,
    'span': true
};
var $51c8f0da15dbd30c$var$EVENT_HANDLER_ATTRIBUTES = [
    'onclick',
    'onmousedown',
    'onmouseup',
    'onpointerdown',
    'onpointerup',
    'ontouchend',
    'ontouchstart'
];
var $51c8f0da15dbd30c$var$MAX_DEPTH = 5;
var $51c8f0da15dbd30c$var$logger$1 = $51c8f0da15dbd30c$var$console_with_prefix('autocapture');
function $51c8f0da15dbd30c$var$getClasses(el) {
    var classes = {};
    var classList = $51c8f0da15dbd30c$var$getClassName(el).split(' ');
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $51c8f0da15dbd30c$var$getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        case 'object':
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            return '';
    }
}
function $51c8f0da15dbd30c$var$getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !$51c8f0da15dbd30c$var$isElementNode(el));
        return el;
    }
}
function $51c8f0da15dbd30c$var$getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        '$classes': $51c8f0da15dbd30c$var$getClassName(el).split(' '),
        '$tag_name': el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props['$id'] = elId;
    if ($51c8f0da15dbd30c$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if ($51c8f0da15dbd30c$var$shouldTrackValue(attrVal)) props['$attr-' + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = $51c8f0da15dbd30c$var$getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props['$nth_child'] = nthChild;
    props['$nth_of_type'] = nthOfType;
    return props;
}
function $51c8f0da15dbd30c$var$getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    $51c8f0da15dbd30c$var$_.each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === 'undefined' ? ev.srcElement : ev.target;
    if ($51c8f0da15dbd30c$var$isTextNode(target)) target = target.parentNode;
    if ($51c8f0da15dbd30c$var$shouldTrackDomEvent(target, ev) && $51c8f0da15dbd30c$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !$51c8f0da15dbd30c$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !$51c8f0da15dbd30c$var$isTag(curEl, 'body')){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        $51c8f0da15dbd30c$var$_.each(targetElementList, function(el) {
            var shouldTrackDetails = $51c8f0da15dbd30c$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet['href'] && el.tagName.toLowerCase() === 'a') {
                href = el.getAttribute('href');
                href = shouldTrackDetails && $51c8f0da15dbd30c$var$shouldTrackValue(href) && href;
            }
            if ($51c8f0da15dbd30c$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push($51c8f0da15dbd30c$var$getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = $51c8f0da15dbd30c$var$document$1['documentElement'];
            props = {
                '$event_type': ev.type,
                '$host': $51c8f0da15dbd30c$var$win.location.host,
                '$pathname': $51c8f0da15dbd30c$var$win.location.pathname,
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$viewportHeight': Math.max(docElement['clientHeight'], $51c8f0da15dbd30c$var$win['innerHeight'] || 0),
                '$viewportWidth': Math.max(docElement['clientWidth'], $51c8f0da15dbd30c$var$win['innerWidth'] || 0),
                '$pageHeight': $51c8f0da15dbd30c$var$document$1['body']['offsetHeight'] || 0,
                '$pageWidth': $51c8f0da15dbd30c$var$document$1['body']['offsetWidth'] || 0
            };
            $51c8f0da15dbd30c$var$_.each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if ($51c8f0da15dbd30c$var$shouldTrackValue(attrVal)) props['$el_attr__' + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = $51c8f0da15dbd30c$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (ev.type === $51c8f0da15dbd30c$var$EV_CLICK) {
                $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props['$' + prop] = ev[prop];
                });
                if (capturedForHeatMap) props['$captured_for_heatmap'] = true;
                target = $51c8f0da15dbd30c$var$guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = $51c8f0da15dbd30c$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!$51c8f0da15dbd30c$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) || $51c8f0da15dbd30c$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = $51c8f0da15dbd30c$var$getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props['$target'] = targetProps;
                // pull up more props onto main event props
                props['$el_classes'] = targetProps['$classes'];
                $51c8f0da15dbd30c$var$_.extend(props, $51c8f0da15dbd30c$var$_.strip_empty_properties({
                    '$el_id': targetProps['$id'],
                    '$el_tag_name': targetProps['$tag_name']
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function $51c8f0da15dbd30c$var$getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = '';
    if ($51c8f0da15dbd30c$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) $51c8f0da15dbd30c$var$_.each(el.childNodes, function(child) {
        if ($51c8f0da15dbd30c$var$isTextNode(child) && child.textContent) elText += $51c8f0da15dbd30c$var$_.trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($51c8f0da15dbd30c$var$shouldTrackValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return $51c8f0da15dbd30c$var$_.trim(elText);
}
function $51c8f0da15dbd30c$var$guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev['composedPath']();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if ($51c8f0da15dbd30c$var$isTag(node, 'a') || $51c8f0da15dbd30c$var$isTag(node, 'button') || $51c8f0da15dbd30c$var$isTag(node, 'input') || $51c8f0da15dbd30c$var$isTag(node, 'select') || node.getAttribute && node.getAttribute('role') === 'button') {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function $51c8f0da15dbd30c$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while checking element in allowElementCallback', err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    return false;
}
function $51c8f0da15dbd30c$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while checking element in blockElementCallback', err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = $51c8f0da15dbd30c$var$getClasses(el);
    for(i = 0; i < $51c8f0da15dbd30c$var$OPT_OUT_CLASSES.length; i++){
        if (classes[$51c8f0da15dbd30c$var$OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function $51c8f0da15dbd30c$var$isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $51c8f0da15dbd30c$var$isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function $51c8f0da15dbd30c$var$isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function $51c8f0da15dbd30c$var$minDOMApisSupported() {
    try {
        var testEl = $51c8f0da15dbd30c$var$document$1.createElement('div');
        return !!testEl['matches'];
    } catch (err) {
        return false;
    }
}
function $51c8f0da15dbd30c$var$weakSetSupported() {
    return typeof WeakSet !== 'undefined';
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function $51c8f0da15dbd30c$var$shouldTrackDomEvent(el, ev) {
    if (!el || $51c8f0da15dbd30c$var$isTag(el, 'html') || !$51c8f0da15dbd30c$var$isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'form':
            return ev.type === $51c8f0da15dbd30c$var$EV_SUBMIT;
        case 'input':
            if ([
                'button',
                'submit'
            ].indexOf(el.getAttribute('type')) === -1) return ev.type === $51c8f0da15dbd30c$var$EV_CHANGE;
            else return ev.type === $51c8f0da15dbd30c$var$EV_CLICK;
        case 'select':
        case 'textarea':
            return ev.type === $51c8f0da15dbd30c$var$EV_CHANGE;
        default:
            return ev.type === $51c8f0da15dbd30c$var$EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function $51c8f0da15dbd30c$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!$51c8f0da15dbd30c$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !$51c8f0da15dbd30c$var$isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = $51c8f0da15dbd30c$var$getClasses(curEl);
        for(i = 0; i < $51c8f0da15dbd30c$var$SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[$51c8f0da15dbd30c$var$SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = $51c8f0da15dbd30c$var$getClasses(el);
    for(i = 0; i < $51c8f0da15dbd30c$var$OPT_IN_CLASSES.length; i++){
        if (elClasses[$51c8f0da15dbd30c$var$OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if ($51c8f0da15dbd30c$var$isTag(el, 'input') || $51c8f0da15dbd30c$var$isTag(el, 'select') || $51c8f0da15dbd30c$var$isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return false;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function $51c8f0da15dbd30c$var$shouldTrackValue(value) {
    if (value === null || $51c8f0da15dbd30c$var$_.isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = $51c8f0da15dbd30c$var$_.trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
/**
 * Creates a cross-browser compatible scroll end function with appropriate event listener.
 * For browsers that support scrollend, returns the original function with scrollend event.
 * For browsers without scrollend support, returns a debounced function that triggers
 * 100ms after the last scroll event to simulate scrollend behavior.
 * @param {Function} originalFunction - The function to call when scrolling ends
 * @returns {Object} Object containing listener function and eventType string
 * @returns {Function} returns.listener - The wrapped function to use as event listener
 * @returns {string} returns.eventType - The event type to listen for ('scrollend' or 'scroll')
 */ function $51c8f0da15dbd30c$var$getPolyfillScrollEndFunction(originalFunction) {
    var supportsScrollEnd = 'onscrollend' in $51c8f0da15dbd30c$var$win;
    var polyfillFunction = $51c8f0da15dbd30c$var$safewrap(originalFunction);
    var polyfillEvent = $51c8f0da15dbd30c$var$EV_SCROLLEND;
    if (!supportsScrollEnd) {
        // Polyfill for browsers without scrollend support: wait 100ms after the last scroll event
        // https://developer.chrome.com/blog/scrollend-a-new-javascript-event
        var scrollTimer = null;
        var scrollDelayMs = 100;
        polyfillFunction = $51c8f0da15dbd30c$var$safewrap(function() {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(originalFunction, scrollDelayMs);
        });
        polyfillEvent = $51c8f0da15dbd30c$var$EV_SCROLL;
    }
    return {
        listener: polyfillFunction,
        eventType: polyfillEvent
    };
}
function $51c8f0da15dbd30c$var$hasInlineEventHandlers(element) {
    for(var i = 0; i < $51c8f0da15dbd30c$var$EVENT_HANDLER_ATTRIBUTES.length; i++){
        if (element.hasAttribute($51c8f0da15dbd30c$var$EVENT_HANDLER_ATTRIBUTES[i])) return true;
    }
    return false;
}
function $51c8f0da15dbd30c$var$hasInteractiveAriaRole(element) {
    var role = element.getAttribute('role');
    if (!role) return false;
    // Handle invalid markup where multiple roles might be specified
    // Only the first token is recognized per ARIA spec
    var primaryRole = role.trim().split(/\s+/)[0].toLowerCase();
    return $51c8f0da15dbd30c$var$INTERACTIVE_ARIA_ROLES[primaryRole];
}
function $51c8f0da15dbd30c$var$hasAnyInteractivityIndicators(element) {
    var tagName = element.tagName.toLowerCase();
    // Check for interactive HTML elements
    if (tagName === 'button' || tagName === 'input' || tagName === 'select' || tagName === 'textarea' || tagName === 'details' || tagName === 'dialog') return true;
    if (element.isContentEditable) return true;
    if (element.onclick || element.onmousedown || element.onmouseup || element.ontouchstart || element.ontouchend) return true;
    if ($51c8f0da15dbd30c$var$hasInlineEventHandlers(element)) return true;
    if ($51c8f0da15dbd30c$var$hasInteractiveAriaRole(element)) return true;
    if (tagName === 'a' && element.hasAttribute('href')) return true;
    if (element.hasAttribute('tabindex')) return true;
    return false;
}
function $51c8f0da15dbd30c$var$isDefinitelyNonInteractive(element) {
    if (!element || !element.tagName) return true;
    var tagName = element.tagName.toLowerCase();
    // These tags are definitely non-interactive
    if ($51c8f0da15dbd30c$var$ALWAYS_NON_INTERACTIVE_TAGS[tagName]) return true;
    // For all other elements, we can only be certain they're non-interactive if they lack ALL indicators of interactivity
    // Check for any signs of interactivity
    if ($51c8f0da15dbd30c$var$hasAnyInteractivityIndicators(element)) return false;
    // Check parent chain for interactive context
    var parent = element.parentElement;
    var depth = 0;
    while(parent && depth < $51c8f0da15dbd30c$var$MAX_DEPTH){
        if ($51c8f0da15dbd30c$var$hasAnyInteractivityIndicators(parent)) return false; // Element is inside an interactive parent
        if (parent.getRootNode && parent.getRootNode() !== $51c8f0da15dbd30c$var$document$1) {
            var root = parent.getRootNode();
            if (root.host && $51c8f0da15dbd30c$var$hasAnyInteractivityIndicators(root.host)) return false; // Inside an interactive shadow host
        }
        parent = parent.parentElement;
        depth++;
    }
    // Pure text containers without any interactive context
    if ($51c8f0da15dbd30c$var$TEXT_CONTAINER_TAGS[tagName]) // These are non-interactive ONLY if they have no interactive indicators (already checked as part of hasAnyInteractivityIndicators)
    return true;
    // Default: we can't be certain it's non-interactive
    return false;
}
/**
 * Get the composed path of a click event for elements embedded in shadow DOM.
 * @param {Event} event - event to get the composed path from
 * @returns {Array} the composed path of the click event
*/ function $51c8f0da15dbd30c$var$getClickEventComposedPath(event) {
    if ('composedPath' in event) return event['composedPath']();
    return [];
}
/**
 * Get the element from a click event, accounting for elements embedded in shadow DOM.
 * @param {Event} event - event to get the target from
 * @returns {Element | null} the element that was the target of the click event
 */ function $51c8f0da15dbd30c$var$getClickEventTargetElement(event) {
    var path = $51c8f0da15dbd30c$var$getClickEventComposedPath(event);
    if (path && path.length > 0) return path[0];
    return event['target'] || event['srcElement'];
}
/** @const */ var $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_THRESHOLD_PX = 30;
/** @const */ var $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_TIMEOUT_MS = 1000;
/** @const */ var $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_CLICK_COUNT = 4;
/** @const */ var $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_INTERACTIVE_ELEMENTS_ONLY = false;
function $51c8f0da15dbd30c$var$RageClickTracker() {
    this.clicks = [];
}
/**
 * Determines if a click event is part of a rage click sequence.
 * @param {Event} event - the original click event.
 * @param {import('../index.d.ts').RageClickConfig} options - configuration options for rage click detection.
 * @returns {boolean} - true if the click is considered a rage click, false otherwise.
 */ $51c8f0da15dbd30c$var$RageClickTracker.prototype.isRageClick = function(event, options) {
    options = options || {};
    var thresholdPx = options['threshold_px'] || $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_THRESHOLD_PX;
    var timeoutMs = options['timeout_ms'] || $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_TIMEOUT_MS;
    var clickCount = options['click_count'] || $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_CLICK_COUNT;
    var interactiveElementsOnly = options['interactive_elements_only'] || $51c8f0da15dbd30c$var$DEFAULT_RAGE_CLICK_INTERACTIVE_ELEMENTS_ONLY;
    if (interactiveElementsOnly) {
        var target = $51c8f0da15dbd30c$var$getClickEventTargetElement(event);
        if (!target || $51c8f0da15dbd30c$var$isDefinitelyNonInteractive(target)) return false;
    }
    var timestamp = Date.now();
    var x = event['pageX'], y = event['pageY'];
    var lastClick = this.clicks[this.clicks.length - 1];
    if (lastClick && timestamp - lastClick.timestamp < timeoutMs && Math.sqrt(Math.pow(x - lastClick.x, 2) + Math.pow(y - lastClick.y, 2)) < thresholdPx) {
        this.clicks.push({
            x: x,
            y: y,
            timestamp: timestamp
        });
        if (this.clicks.length >= clickCount) {
            this.clicks = [];
            return true;
        }
    } else this.clicks = [
        {
            x: x,
            y: y,
            timestamp: timestamp
        }
    ];
    return false;
};
function $51c8f0da15dbd30c$var$ShadowDOMObserver(changeCallback, observerConfig) {
    this.changeCallback = changeCallback || function() {};
    this.observerConfig = observerConfig;
    this.observedShadowRoots = null;
    this.shadowObservers = [];
}
$51c8f0da15dbd30c$var$ShadowDOMObserver.prototype.getEventTarget = function(event) {
    if (!this.observedShadowRoots) return;
    return $51c8f0da15dbd30c$var$getClickEventTargetElement(event);
};
$51c8f0da15dbd30c$var$ShadowDOMObserver.prototype.observeFromEvent = function(event) {
    if (!this.observedShadowRoots) return;
    var path = $51c8f0da15dbd30c$var$getClickEventComposedPath(event);
    // Check each element in path for shadow roots
    for(var i = 0; i < path.length; i++){
        var element = path[i];
        if (element && element.shadowRoot) this.observeShadowRoot(element.shadowRoot);
    }
};
$51c8f0da15dbd30c$var$ShadowDOMObserver.prototype.observeShadowRoot = function(shadowRoot) {
    if (!this.observedShadowRoots || this.observedShadowRoots.has(shadowRoot)) return;
    var self = this;
    try {
        this.observedShadowRoots.add(shadowRoot);
        var observer = new window.MutationObserver(function() {
            self.changeCallback();
        });
        observer.observe(shadowRoot, this.observerConfig);
        this.shadowObservers.push(observer);
    } catch (e) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while observing shadow root', e);
    }
};
$51c8f0da15dbd30c$var$ShadowDOMObserver.prototype.start = function() {
    if (this.observedShadowRoots) return;
    if (!$51c8f0da15dbd30c$var$weakSetSupported()) {
        $51c8f0da15dbd30c$var$logger$1.critical('Shadow DOM observation unavailable: WeakSet not supported');
        return;
    }
    this.observedShadowRoots = new WeakSet();
};
$51c8f0da15dbd30c$var$ShadowDOMObserver.prototype.stop = function() {
    if (!this.observedShadowRoots) return;
    for(var i = 0; i < this.shadowObservers.length; i++)try {
        this.shadowObservers[i].disconnect();
    } catch (e) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while disconnecting shadow DOM observer', e);
    }
    this.shadowObservers = [];
    this.observedShadowRoots = null;
};
/** @const */ var $51c8f0da15dbd30c$var$DEFAULT_DEAD_CLICK_TIMEOUT_MS = 500;
/** @const */ var $51c8f0da15dbd30c$var$INTERACTION_EVENTS = [
    $51c8f0da15dbd30c$var$EV_CHANGE,
    $51c8f0da15dbd30c$var$EV_INPUT,
    $51c8f0da15dbd30c$var$EV_SUBMIT,
    $51c8f0da15dbd30c$var$EV_SELECT,
    $51c8f0da15dbd30c$var$EV_TOGGLE
];
/** @const */ var $51c8f0da15dbd30c$var$LAYOUT_EVENTS = [
    $51c8f0da15dbd30c$var$EV_SCROLLEND
];
/** @const */ var $51c8f0da15dbd30c$var$NAVIGATION_EVENTS = [
    $51c8f0da15dbd30c$var$EV_HASHCHANGE
];
/** @const */ var $51c8f0da15dbd30c$var$MUTATION_OBSERVER_CONFIG = {
    characterData: true,
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
        'style',
        'class',
        'hidden',
        'checked',
        'selected',
        'value',
        'display',
        'visibility'
    ]
};
function $51c8f0da15dbd30c$var$DeadClickTracker(onDeadClickCallback) {
    this.eventListeners = [];
    this.mutationObserver = null;
    this.shadowDOMObserver = null;
    this.isTracking = false;
    this.lastChangeEventTimestamp = 0;
    this.pendingClicks = [];
    this.onDeadClickCallback = onDeadClickCallback;
    this.processingActive = false;
    this.processingTimeout = null;
}
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.addClick = function(event) {
    var element = this.shadowDOMObserver && this.shadowDOMObserver.getEventTarget(event);
    if (!element) element = event['target'] || event['srcElement'];
    if (!element || $51c8f0da15dbd30c$var$isDefinitelyNonInteractive(element)) return false;
    if (this.shadowDOMObserver) this.shadowDOMObserver.observeFromEvent(event);
    this.pendingClicks.push({
        element: element,
        event: event,
        timestamp: Date.now()
    });
    return true;
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.trackClick = function(event, config) {
    if (!this.isTracking) return false;
    var added = this.addClick(event);
    if (added) this.triggerProcessing(config);
    return added;
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.getDeadClicks = function(config) {
    if (this.pendingClicks.length === 0) return [];
    var timeoutMs = config['timeout_ms'];
    var now = Date.now();
    var clicksToEvaluate = this.pendingClicks.slice(); // Copy array
    this.pendingClicks = []; // Clear original
    var deadClicks = [];
    for(var i = 0; i < clicksToEvaluate.length; i++){
        var click = clicksToEvaluate[i];
        if (now - click.timestamp >= timeoutMs) // Click has exceeded timeout, check if it's dead by looking for changes after this specific click
        {
            if (!this.hasChangesAfter(click.timestamp)) deadClicks.push(click);
        } else // Still pending - add back
        this.pendingClicks.push(click);
    }
    return deadClicks;
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.hasChangesAfter = function(timestamp) {
    // 100ms tolerance for race condition between when we record the click and the change event
    return this.lastChangeEventTimestamp >= timestamp - 100;
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.recordChangeEvent = function() {
    this.lastChangeEventTimestamp = Date.now();
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.triggerProcessing = function(config) {
    // Prevent multiple concurrent processing chains
    if (this.processingActive) return;
    this.processingActive = true;
    this.processRecursively(config);
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.processRecursively = function(config) {
    if (!this.isTracking || !this.onDeadClickCallback) {
        this.processingActive = false;
        return;
    }
    var timeoutMs = config['timeout_ms'];
    var self = this;
    this.processingTimeout = setTimeout(function() {
        if (!self.processingActive) return;
        var deadClicks = self.getDeadClicks(config);
        for(var i = 0; i < deadClicks.length; i++)self.onDeadClickCallback(deadClicks[i].event);
        if (self.pendingClicks.length > 0) self.processRecursively(config);
        else self.processingActive = false;
    }, timeoutMs);
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.startTracking = function() {
    if (this.isTracking) return;
    this.isTracking = true;
    var self = this;
    $51c8f0da15dbd30c$var$INTERACTION_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        document.addEventListener(event, handler, {
            capture: true,
            passive: true
        });
        self.eventListeners.push({
            target: document,
            event: event,
            handler: handler,
            options: {
                capture: true,
                passive: true
            }
        });
    });
    $51c8f0da15dbd30c$var$NAVIGATION_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        window.addEventListener(event, handler);
        self.eventListeners.push({
            target: window,
            event: event,
            handler: handler
        });
    });
    $51c8f0da15dbd30c$var$LAYOUT_EVENTS.forEach(function(event) {
        var handler = function() {
            self.recordChangeEvent();
        };
        window.addEventListener(event, handler, {
            passive: true
        });
        self.eventListeners.push({
            target: window,
            event: event,
            handler: handler,
            options: {
                passive: true
            }
        });
    });
    var selectionHandler = function() {
        self.recordChangeEvent();
    };
    document.addEventListener('selectionchange', selectionHandler);
    self.eventListeners.push({
        target: document,
        event: 'selectionchange',
        handler: selectionHandler
    });
    // Set up MutationObserver
    if (window.MutationObserver) try {
        this.mutationObserver = new window.MutationObserver(function() {
            self.recordChangeEvent();
        });
        this.mutationObserver.observe(document.body || document.documentElement, $51c8f0da15dbd30c$var$MUTATION_OBSERVER_CONFIG);
    } catch (e) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while setting up mutation observer', e);
    }
    // Set up Shadow DOM observer
    if (window.customElements) try {
        this.shadowDOMObserver = new $51c8f0da15dbd30c$var$ShadowDOMObserver(function() {
            self.recordChangeEvent();
        }, $51c8f0da15dbd30c$var$MUTATION_OBSERVER_CONFIG);
        this.shadowDOMObserver.start();
    } catch (e) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while setting up shadow DOM observer', e);
        this.shadowDOMObserver = null;
    }
};
$51c8f0da15dbd30c$var$DeadClickTracker.prototype.stopTracking = function() {
    if (!this.isTracking) return;
    this.isTracking = false;
    this.pendingClicks = [];
    this.lastChangeEventTimestamp = 0;
    this.processingActive = false;
    if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
        this.processingTimeout = null;
    }
    // Remove all event listeners
    for(var i = 0; i < this.eventListeners.length; i++){
        var listener = this.eventListeners[i];
        try {
            listener.target.removeEventListener(listener.event, listener.handler, listener.options);
        } catch (e) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while removing event listener', e);
        }
    }
    this.eventListeners = [];
    if (this.mutationObserver) {
        try {
            this.mutationObserver.disconnect();
        } catch (e) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while disconnecting mutation observer', e);
        }
        this.mutationObserver = null;
    }
    if (this.shadowDOMObserver) {
        try {
            this.shadowDOMObserver.stop();
        } catch (e) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while stopping shadow DOM observer', e);
        }
        this.shadowDOMObserver = null;
    }
};
var $51c8f0da15dbd30c$var$AUTOCAPTURE_CONFIG_KEY = 'autocapture';
var $51c8f0da15dbd30c$var$LEGACY_PAGEVIEW_CONFIG_KEY = 'track_pageview';
var $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_FULL_URL = 'full-url';
var $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = 'url-with-path-and-query-string';
var $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_URL_WITH_PATH = 'url-with-path';
var $51c8f0da15dbd30c$var$CONFIG_ALLOW_ELEMENT_CALLBACK = 'allow_element_callback';
var $51c8f0da15dbd30c$var$CONFIG_ALLOW_SELECTORS = 'allow_selectors';
var $51c8f0da15dbd30c$var$CONFIG_ALLOW_URL_REGEXES = 'allow_url_regexes';
var $51c8f0da15dbd30c$var$CONFIG_BLOCK_ATTRS = 'block_attrs';
var $51c8f0da15dbd30c$var$CONFIG_BLOCK_ELEMENT_CALLBACK = 'block_element_callback';
var $51c8f0da15dbd30c$var$CONFIG_BLOCK_SELECTORS = 'block_selectors';
var $51c8f0da15dbd30c$var$CONFIG_BLOCK_URL_REGEXES = 'block_url_regexes';
var $51c8f0da15dbd30c$var$CONFIG_CAPTURE_EXTRA_ATTRS = 'capture_extra_attrs';
var $51c8f0da15dbd30c$var$CONFIG_CAPTURE_TEXT_CONTENT = 'capture_text_content';
var $51c8f0da15dbd30c$var$CONFIG_SCROLL_CAPTURE_ALL = 'scroll_capture_all';
var $51c8f0da15dbd30c$var$CONFIG_SCROLL_CHECKPOINTS = 'scroll_depth_percent_checkpoints';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_CLICK = 'click';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_DEAD_CLICK = 'dead_click';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_INPUT = 'input';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_PAGEVIEW = 'pageview';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_RAGE_CLICK = 'rage_click';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_SCROLL = 'scroll';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_PAGE_LEAVE = 'page_leave';
var $51c8f0da15dbd30c$var$CONFIG_TRACK_SUBMIT = 'submit';
var $51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1 = {};
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_ALLOW_SELECTORS] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_ALLOW_URL_REGEXES] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_BLOCK_ATTRS] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_BLOCK_SELECTORS] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_BLOCK_URL_REGEXES] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_CAPTURE_EXTRA_ATTRS] = [];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_CAPTURE_TEXT_CONTENT] = false;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_SCROLL_CAPTURE_ALL] = false;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_CLICK] = true;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_DEAD_CLICK] = true;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_INPUT] = true;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_PAGEVIEW] = $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_FULL_URL;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_RAGE_CLICK] = true;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_SCROLL] = true;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_PAGE_LEAVE] = false;
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1[$51c8f0da15dbd30c$var$CONFIG_TRACK_SUBMIT] = true;
var $51c8f0da15dbd30c$var$DEFAULT_PROPS = {
    '$mp_autocapture': true
};
var $51c8f0da15dbd30c$var$MP_EV_CLICK = '$mp_click';
var $51c8f0da15dbd30c$var$MP_EV_DEAD_CLICK = '$mp_dead_click';
var $51c8f0da15dbd30c$var$MP_EV_INPUT = '$mp_input_change';
var $51c8f0da15dbd30c$var$MP_EV_RAGE_CLICK = '$mp_rage_click';
var $51c8f0da15dbd30c$var$MP_EV_SCROLL = '$mp_scroll';
var $51c8f0da15dbd30c$var$MP_EV_SUBMIT = '$mp_submit';
var $51c8f0da15dbd30c$var$MP_EV_PAGE_LEAVE = '$mp_page_leave';
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var $51c8f0da15dbd30c$var$Autocapture = function(mp) {
    this.mp = mp;
    this.maxScrollViewDepth = 0;
    this.hasTrackedScrollSession = false;
    this.previousScrollHeight = 0;
};
$51c8f0da15dbd30c$var$Autocapture.prototype.init = function() {
    if (!$51c8f0da15dbd30c$var$minDOMApisSupported()) {
        $51c8f0da15dbd30c$var$logger$1.critical('Autocapture unavailable: missing required DOM APIs');
        return;
    }
    this.initPageListeners();
    this.initPageviewTracking();
    this.initClickTracking();
    this.initDeadClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
    this.initRageClickTracking();
    this.initPageLeaveTracking();
};
$51c8f0da15dbd30c$var$Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config($51c8f0da15dbd30c$var$AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ($51c8f0da15dbd30c$var$_.isObject(autocaptureConfig)) return $51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return $51c8f0da15dbd30c$var$CONFIG_DEFAULTS$1;
};
$51c8f0da15dbd30c$var$Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$51c8f0da15dbd30c$var$Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
    var allowUrlRegexes = this.getConfig($51c8f0da15dbd30c$var$CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                $51c8f0da15dbd30c$var$logger$1.critical('Error while checking block URL regex: ' + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig($51c8f0da15dbd30c$var$CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        $51c8f0da15dbd30c$var$logger$1.critical('Error while checking block URL regex: ' + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
$51c8f0da15dbd30c$var$Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config($51c8f0da15dbd30c$var$AUTOCAPTURE_CONFIG_KEY)) return this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config($51c8f0da15dbd30c$var$LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
$51c8f0da15dbd30c$var$Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var isCapturedForHeatMap = this.mp.is_recording_heatmap_data() && (mpEventName === $51c8f0da15dbd30c$var$MP_EV_CLICK && !this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_CLICK) || mpEventName === $51c8f0da15dbd30c$var$MP_EV_RAGE_CLICK && !this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_RAGE_CLICK) || mpEventName === $51c8f0da15dbd30c$var$MP_EV_DEAD_CLICK && !this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_DEAD_CLICK));
    var props = $51c8f0da15dbd30c$var$getPropsForDOMEvent(ev, {
        allowElementCallback: this.getConfig($51c8f0da15dbd30c$var$CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig($51c8f0da15dbd30c$var$CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig($51c8f0da15dbd30c$var$CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig($51c8f0da15dbd30c$var$CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig($51c8f0da15dbd30c$var$CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig($51c8f0da15dbd30c$var$CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig($51c8f0da15dbd30c$var$CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: isCapturedForHeatMap
    });
    if (props) {
        $51c8f0da15dbd30c$var$_.extend(props, $51c8f0da15dbd30c$var$DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initPageListeners = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_POPSTATE, this.listenerPopstate);
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_HASHCHANGE, this.listenerHashchange);
    if (!this.pageviewTrackingConfig() && !this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.get_config('record_heatmap_data')) // These are all the configs that use these listeners
    return;
    this.listenerPopstate = function() {
        $51c8f0da15dbd30c$var$win.dispatchEvent(new Event($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE));
    };
    this.listenerHashchange = function() {
        $51c8f0da15dbd30c$var$win.dispatchEvent(new Event($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE));
    };
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_POPSTATE, this.listenerPopstate);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_HASHCHANGE, this.listenerHashchange);
    var nativePushState = $51c8f0da15dbd30c$var$win.history.pushState;
    if (typeof nativePushState === 'function') $51c8f0da15dbd30c$var$win.history.pushState = function(state, unused, url) {
        nativePushState.call($51c8f0da15dbd30c$var$win.history, state, unused, url);
        $51c8f0da15dbd30c$var$win.dispatchEvent(new Event($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE));
    };
    var nativeReplaceState = $51c8f0da15dbd30c$var$win.history.replaceState;
    if (typeof nativeReplaceState === 'function') $51c8f0da15dbd30c$var$win.history.replaceState = function(state, unused, url) {
        nativeReplaceState.call($51c8f0da15dbd30c$var$win.history, state, unused, url);
        $51c8f0da15dbd30c$var$win.dispatchEvent(new Event($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE));
    };
};
$51c8f0da15dbd30c$var$Autocapture.prototype._getClickTrackingConfig = function(configKey) {
    var config = this.getConfig(configKey);
    if (!config) return null; // click tracking disabled
    if (config === true) return {}; // use defaults
    if (typeof config === 'object') return config; // use custom configuration
    return {}; // fallback to defaults for any other truthy value
};
$51c8f0da15dbd30c$var$Autocapture.prototype._trackPageLeave = function(ev, currentUrl, currentScrollHeight) {
    if (this.hasTrackedScrollSession) // User has navigated away already ending their impression.
    return;
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.is_recording_heatmap_data()) return;
    this.hasTrackedScrollSession = true;
    var viewportHeight = Math.max($51c8f0da15dbd30c$var$document$1.documentElement.clientHeight, $51c8f0da15dbd30c$var$win.innerHeight || 0);
    var scrollPercentage = Math.round(Math.max(this.maxScrollViewDepth - viewportHeight, 0) / (currentScrollHeight - viewportHeight) * 100);
    var foldLinePercentage = Math.round(viewportHeight / currentScrollHeight * 100);
    if (currentScrollHeight <= viewportHeight) {
        // If the content fits within the viewport, consider it fully scrolled
        scrollPercentage = 100;
        foldLinePercentage = 100;
    }
    var props = $51c8f0da15dbd30c$var$_.extend({
        '$max_scroll_view_depth': this.maxScrollViewDepth,
        '$max_scroll_percentage': scrollPercentage,
        '$fold_line_percentage': foldLinePercentage,
        '$scroll_height': currentScrollHeight,
        '$event_type': ev.type,
        '$current_url': currentUrl || $51c8f0da15dbd30c$var$_.info.currentUrl(),
        '$viewportHeight': viewportHeight,
        '$viewportWidth': Math.max($51c8f0da15dbd30c$var$document$1.documentElement.clientWidth, $51c8f0da15dbd30c$var$win.innerWidth || 0),
        '$captured_for_heatmap': this.mp.is_recording_heatmap_data()
    }, $51c8f0da15dbd30c$var$DEFAULT_PROPS);
    // Send with beacon transport to ensure event is sent before unload
    this.mp.track($51c8f0da15dbd30c$var$MP_EV_PAGE_LEAVE, props, {
        transport: 'sendBeacon'
    });
};
$51c8f0da15dbd30c$var$Autocapture.prototype._initScrollDepthTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_SCROLL, this.listenerScrollDepth);
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_SCROLLEND, this.listenerScrollDepth);
    if (!this.mp.get_config('record_heatmap_data')) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing scroll depth tracking');
    this.maxScrollViewDepth = Math.max($51c8f0da15dbd30c$var$document$1.documentElement.clientHeight, $51c8f0da15dbd30c$var$win.innerHeight || 0);
    var updateScrollDepth = (function() {
        if (this.currentUrlBlocked()) return;
        var scrollViewHeight = Math.max($51c8f0da15dbd30c$var$document$1.documentElement.clientHeight, $51c8f0da15dbd30c$var$win.innerHeight || 0) + $51c8f0da15dbd30c$var$win.scrollY;
        if (scrollViewHeight > this.maxScrollViewDepth) this.maxScrollViewDepth = scrollViewHeight;
        this.previousScrollHeight = $51c8f0da15dbd30c$var$document$1.body.scrollHeight;
    }).bind(this);
    var scrollEndPolyfill = $51c8f0da15dbd30c$var$getPolyfillScrollEndFunction(updateScrollDepth);
    this.listenerScrollDepth = scrollEndPolyfill.listener;
    $51c8f0da15dbd30c$var$win.addEventListener(scrollEndPolyfill.eventType, this.listenerScrollDepth);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initClickTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerClick);
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_CLICK) && !this.mp.get_config('record_heatmap_data')) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing click tracking');
    this.listenerClick = (function(ev) {
        if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, $51c8f0da15dbd30c$var$MP_EV_CLICK);
    }).bind(this);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerClick);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initDeadClickTracking = function() {
    var deadClickConfig = this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_DEAD_CLICK);
    if (!deadClickConfig && !this.mp.get_config('record_heatmap_data')) {
        this.stopDeadClickTracking();
        return;
    }
    $51c8f0da15dbd30c$var$logger$1.log('Initializing dead click tracking');
    if (!this._deadClickTracker) {
        this._deadClickTracker = new $51c8f0da15dbd30c$var$DeadClickTracker((function(deadClickEvent) {
            this.trackDomEvent(deadClickEvent, $51c8f0da15dbd30c$var$MP_EV_DEAD_CLICK);
        }).bind(this));
        this._deadClickTracker.startTracking();
    }
    if (!this.listenerDeadClick) {
        this.listenerDeadClick = (function(ev) {
            var currentDeadClickConfig = this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_DEAD_CLICK);
            if (!currentDeadClickConfig && !this.mp.is_recording_heatmap_data()) return;
            if (this.currentUrlBlocked()) return;
            // Normalize config to ensure timeout_ms is always set
            var normalizedConfig = currentDeadClickConfig || {};
            if (!normalizedConfig['timeout_ms']) normalizedConfig['timeout_ms'] = $51c8f0da15dbd30c$var$DEFAULT_DEAD_CLICK_TIMEOUT_MS;
            this._deadClickTracker.trackClick(ev, normalizedConfig);
        }).bind(this);
        $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerDeadClick);
    }
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initInputTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_CHANGE, this.listenerChange);
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_INPUT)) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing input tracking');
    this.listenerChange = (function(ev) {
        if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, $51c8f0da15dbd30c$var$MP_EV_INPUT);
    }).bind(this);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_CHANGE, this.listenerChange);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initPageviewTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing pageview tracking');
    var previousTrackedUrl = '';
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview($51c8f0da15dbd30c$var$DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
    this.listenerLocationchange = $51c8f0da15dbd30c$var$safewrap((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split('#')[0].split('?')[0] !== previousTrackedUrl.split('#')[0].split('?')[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split('#')[0] !== previousTrackedUrl.split('#')[0];
        else if (trackPageviewOption === $51c8f0da15dbd30c$var$PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview($51c8f0da15dbd30c$var$DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                $51c8f0da15dbd30c$var$logger$1.log('Path change: re-initializing scroll depth checkpoints');
            }
        }
    }).bind(this));
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initRageClickTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerRageClick);
    var rageClickConfig = this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_RAGE_CLICK);
    if (!rageClickConfig && !this.mp.get_config('record_heatmap_data')) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing rage click tracking');
    if (!this._rageClickTracker) this._rageClickTracker = new $51c8f0da15dbd30c$var$RageClickTracker();
    this.listenerRageClick = (function(ev) {
        var currentRageClickConfig = this._getClickTrackingConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_RAGE_CLICK);
        if (!currentRageClickConfig && !this.mp.is_recording_heatmap_data()) return;
        if (this.currentUrlBlocked()) return;
        if (this._rageClickTracker.isRageClick(ev, currentRageClickConfig)) this.trackDomEvent(ev, $51c8f0da15dbd30c$var$MP_EV_RAGE_CLICK);
    }).bind(this);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerRageClick);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initScrollTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_SCROLLEND, this.listenerScroll);
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_SCROLL, this.listenerScroll);
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_SCROLL)) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing scroll tracking');
    this.lastScrollCheckpoint = 0;
    var scrollTrackFunction = (function() {
        if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig($51c8f0da15dbd30c$var$CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig($51c8f0da15dbd30c$var$CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = $51c8f0da15dbd30c$var$win.scrollY;
        var props = $51c8f0da15dbd30c$var$_.extend({
            '$scroll_top': scrollTop
        }, $51c8f0da15dbd30c$var$DEFAULT_PROPS);
        try {
            var scrollHeight = $51c8f0da15dbd30c$var$document$1.body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - $51c8f0da15dbd30c$var$win.innerHeight) * 100);
            props['$scroll_height'] = scrollHeight;
            props['$scroll_percentage'] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props['$scroll_checkpoint'] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            $51c8f0da15dbd30c$var$logger$1.critical('Error while calculating scroll percentage', err);
        }
        if (shouldTrack) this.mp.track($51c8f0da15dbd30c$var$MP_EV_SCROLL, props);
    }).bind(this);
    var scrollEndPolyfill = $51c8f0da15dbd30c$var$getPolyfillScrollEndFunction(scrollTrackFunction);
    this.listenerScroll = scrollEndPolyfill.listener;
    $51c8f0da15dbd30c$var$win.addEventListener(scrollEndPolyfill.eventType, this.listenerScroll);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initSubmitTracking = function() {
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_SUBMIT, this.listenerSubmit);
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_SUBMIT)) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing submit tracking');
    this.listenerSubmit = (function(ev) {
        if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, $51c8f0da15dbd30c$var$MP_EV_SUBMIT);
    }).bind(this);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_SUBMIT, this.listenerSubmit);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.initPageLeaveTracking = function() {
    // Capture page_leave both when the user navigates away from the page (visibilitychange) as well
    // as when they navigate to a different page within the SPA (popstate/pushstate/hashchange).
    $51c8f0da15dbd30c$var$document$1.removeEventListener($51c8f0da15dbd30c$var$EV_VISIBILITYCHANGE, this.listenerPageLeaveVisibilitychange);
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE, this.listenerPageLeaveLocationchange);
    $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_LOAD, this.listenerPageLoad);
    if (!this.getConfig($51c8f0da15dbd30c$var$CONFIG_TRACK_PAGE_LEAVE) && !this.mp.get_config('record_heatmap_data')) return;
    $51c8f0da15dbd30c$var$logger$1.log('Initializing page visibility tracking.');
    this._initScrollDepthTracking();
    var previousTrackedUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
    // Initialize previousScrollHeight on `load` which handles async loading
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
    this.listenerPageLoad = (function() {
        this.previousScrollHeight = $51c8f0da15dbd30c$var$document$1.body.scrollHeight;
    }).bind(this);
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_LOAD, this.listenerPageLoad);
    // Track page navigation events similar to how initPageviewTracking does it
    this.listenerPageLeaveLocationchange = $51c8f0da15dbd30c$var$safewrap((function(ev) {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $51c8f0da15dbd30c$var$_.info.currentUrl();
        // Track all URL changes including query string or fragment changes as separate scroll sessions
        var shouldTrack = currentUrl !== previousTrackedUrl;
        if (shouldTrack) {
            this._trackPageLeave(ev, previousTrackedUrl, this.previousScrollHeight);
            previousTrackedUrl = currentUrl;
            // Fragment navigation should call scroll(end) and trigger listener, don't add window.scrollY here.
            this.maxScrollViewDepth = Math.max($51c8f0da15dbd30c$var$document$1.documentElement.clientHeight, $51c8f0da15dbd30c$var$win.innerHeight || 0);
            this.previousScrollHeight = $51c8f0da15dbd30c$var$document$1.body.scrollHeight;
            this.hasTrackedScrollSession = false;
        }
    }).bind(this));
    $51c8f0da15dbd30c$var$win.addEventListener($51c8f0da15dbd30c$var$EV_MP_LOCATION_CHANGE, this.listenerPageLeaveLocationchange);
    this.listenerPageLeaveVisibilitychange = (function(ev) {
        if ($51c8f0da15dbd30c$var$document$1.hidden) this._trackPageLeave(ev, previousTrackedUrl, this.previousScrollHeight);
    }).bind(this);
    $51c8f0da15dbd30c$var$document$1.addEventListener($51c8f0da15dbd30c$var$EV_VISIBILITYCHANGE, this.listenerPageLeaveVisibilitychange);
};
$51c8f0da15dbd30c$var$Autocapture.prototype.stopDeadClickTracking = function() {
    if (this.listenerDeadClick) {
        $51c8f0da15dbd30c$var$win.removeEventListener($51c8f0da15dbd30c$var$EV_CLICK, this.listenerDeadClick);
        this.listenerDeadClick = null;
    }
    if (this._deadClickTracker) {
        this._deadClickTracker.stopTracking();
        this._deadClickTracker = null;
    }
};
// TODO integrate error_reporter from mixpanel instance
$51c8f0da15dbd30c$var$safewrapClass($51c8f0da15dbd30c$var$Autocapture);
var $51c8f0da15dbd30c$var$logger = $51c8f0da15dbd30c$var$console_with_prefix('flags');
var $51c8f0da15dbd30c$var$FLAGS_CONFIG_KEY = 'flags';
var $51c8f0da15dbd30c$var$CONFIG_CONTEXT = 'context';
var $51c8f0da15dbd30c$var$CONFIG_DEFAULTS = {};
$51c8f0da15dbd30c$var$CONFIG_DEFAULTS[$51c8f0da15dbd30c$var$CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var $51c8f0da15dbd30c$var$FeatureFlagManager = function(initOptions) {
    this.fetch = $51c8f0da15dbd30c$var$win['fetch'];
    this.getFullApiRoute = initOptions.getFullApiRoute;
    this.getMpConfig = initOptions.getConfigFunc;
    this.setMpConfig = initOptions.setConfigFunc;
    this.getMpProperty = initOptions.getPropertyFunc;
    this.track = initOptions.trackingFunc;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.init = function() {
    if (!this.minApisSupported()) {
        $51c8f0da15dbd30c$var$logger.critical('Feature Flags unavailable: missing minimum required APIs');
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig($51c8f0da15dbd30c$var$FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ($51c8f0da15dbd30c$var$_.isObject(ffConfig)) return $51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return $51c8f0da15dbd30c$var$CONFIG_DEFAULTS;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.isSystemEnabled = function() {
    return !!this.getMpConfig($51c8f0da15dbd30c$var$FLAGS_CONFIG_KEY);
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.updateContext = function(newContext, options) {
    if (!this.isSystemEnabled()) {
        $51c8f0da15dbd30c$var$logger.critical('Feature Flags not enabled, cannot update context');
        return Promise.resolve();
    }
    var ffConfig = this.getMpConfig($51c8f0da15dbd30c$var$FLAGS_CONFIG_KEY);
    if (!$51c8f0da15dbd30c$var$_.isObject(ffConfig)) ffConfig = {};
    var oldContext = options && options['replace'] ? {} : this.getConfig($51c8f0da15dbd30c$var$CONFIG_CONTEXT);
    ffConfig[$51c8f0da15dbd30c$var$CONFIG_CONTEXT] = $51c8f0da15dbd30c$var$_.extend({}, oldContext, newContext);
    this.setMpConfig($51c8f0da15dbd30c$var$FLAGS_CONFIG_KEY, ffConfig);
    return this.fetchFlags();
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.areFlagsReady = function() {
    if (!this.isSystemEnabled()) $51c8f0da15dbd30c$var$logger.error('Feature Flags not enabled');
    return !!this.flags;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isSystemEnabled()) return Promise.resolve();
    var distinctId = this.getMpProperty('distinct_id');
    var deviceId = this.getMpProperty('$device_id');
    var traceparent = $51c8f0da15dbd30c$var$generateTraceparent();
    $51c8f0da15dbd30c$var$logger.log('Fetching flags for distinct ID: ' + distinctId);
    var context = $51c8f0da15dbd30c$var$_.extend({
        'distinct_id': distinctId,
        'device_id': deviceId
    }, this.getConfig($51c8f0da15dbd30c$var$CONFIG_CONTEXT));
    var searchParams = new URLSearchParams();
    searchParams.set('context', JSON.stringify(context));
    searchParams.set('token', this.getMpConfig('token'));
    searchParams.set('mp_lib', 'web');
    searchParams.set('$lib_version', $51c8f0da15dbd30c$var$Config.LIB_VERSION);
    var url = this.getFullApiRoute() + '?' + searchParams.toString();
    this._fetchInProgressStartTime = Date.now();
    this.fetchPromise = this.fetch.call($51c8f0da15dbd30c$var$win, url, {
        'method': 'GET',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getMpConfig('token') + ':'),
            'traceparent': traceparent
        }
    }).then((function(response) {
        this.markFetchComplete();
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody['flags'];
            if (!responseFlags) throw new Error('No flags in API response');
            var flags = new Map();
            $51c8f0da15dbd30c$var$_.each(responseFlags, function(data, key) {
                flags.set(key, {
                    'key': data['variant_key'],
                    'value': data['variant_value'],
                    'experiment_id': data['experiment_id'],
                    'is_experiment_active': data['is_experiment_active'],
                    'is_qa_tester': data['is_qa_tester']
                });
            });
            this.flags = flags;
            this._traceparent = traceparent;
        }).bind(this)).catch((function(error) {
            this.markFetchComplete();
            $51c8f0da15dbd30c$var$logger.error(error);
        }).bind(this));
    }).bind(this)).catch((function(error) {
        this.markFetchComplete();
        $51c8f0da15dbd30c$var$logger.error(error);
    }).bind(this));
    return this.fetchPromise;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.markFetchComplete = function() {
    if (!this._fetchInProgressStartTime) {
        $51c8f0da15dbd30c$var$logger.error('Fetch in progress started time not set, cannot mark fetch complete');
        return;
    }
    this._fetchStartTime = this._fetchInProgressStartTime;
    this._fetchCompleteTime = Date.now();
    this._fetchLatency = this._fetchCompleteTime - this._fetchStartTime;
    this._fetchInProgressStartTime = null;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariant = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        $51c8f0da15dbd30c$var$logger.critical('Feature Flags not initialized');
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getVariantSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        $51c8f0da15dbd30c$var$logger.error(error);
        return fallback;
    });
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantSync = function(featureName, fallback) {
    if (!this.areFlagsReady()) {
        $51c8f0da15dbd30c$var$logger.log('Flags not loaded yet');
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        $51c8f0da15dbd30c$var$logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantValue = function(featureName, fallbackValue) {
    return this.getVariant(featureName, {
        'value': fallbackValue
    }).then(function(feature) {
        return feature['value'];
    }).catch(function(error) {
        $51c8f0da15dbd30c$var$logger.error(error);
        return fallbackValue;
    });
};
// TODO remove deprecated method
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    $51c8f0da15dbd30c$var$logger.critical('mixpanel.flags.get_feature_data() is deprecated and will be removed in a future release. Use mixpanel.flags.get_variant_value() instead.');
    return this.getVariantValue(featureName, fallbackValue);
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantValueSync = function(featureName, fallbackValue) {
    return this.getVariantSync(featureName, {
        'value': fallbackValue
    })['value'];
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.isEnabled = function(featureName, fallbackValue) {
    return this.getVariantValue(featureName).then((function() {
        return this.isEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        $51c8f0da15dbd30c$var$logger.error(error);
        return fallbackValue;
    });
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.isEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getVariantValueSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        $51c8f0da15dbd30c$var$logger.error('Feature flag "' + featureName + '" value: ' + val + ' is not a boolean; returning fallback value: ' + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    var trackingProperties = {
        'Experiment name': featureName,
        'Variant name': feature['key'],
        '$experiment_type': 'feature_flag',
        'Variant fetch start time': new Date(this._fetchStartTime).toISOString(),
        'Variant fetch complete time': new Date(this._fetchCompleteTime).toISOString(),
        'Variant fetch latency (ms)': this._fetchLatency,
        'Variant fetch traceparent': this._traceparent
    };
    if (feature['experiment_id'] !== 'undefined') trackingProperties['$experiment_id'] = feature['experiment_id'];
    if (feature['is_experiment_active'] !== 'undefined') trackingProperties['$is_experiment_active'] = feature['is_experiment_active'];
    if (feature['is_qa_tester'] !== 'undefined') trackingProperties['$is_qa_tester'] = feature['is_qa_tester'];
    this.track('$experiment_started', trackingProperties);
};
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype.minApisSupported = function() {
    return !!this.fetch && typeof Promise !== 'undefined' && typeof Map !== 'undefined' && typeof Set !== 'undefined';
};
$51c8f0da15dbd30c$var$safewrapClass($51c8f0da15dbd30c$var$FeatureFlagManager);
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['are_flags_ready'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.areFlagsReady;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['get_variant'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariant;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['get_variant_sync'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantSync;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['get_variant_value'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantValue;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['get_variant_value_sync'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getVariantValueSync;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['is_enabled'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.isEnabled;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['is_enabled_sync'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.isEnabledSync;
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['update_context'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.updateContext;
// Deprecated method
$51c8f0da15dbd30c$var$FeatureFlagManager.prototype['get_feature_data'] = $51c8f0da15dbd30c$var$FeatureFlagManager.prototype.getFeatureData;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $51c8f0da15dbd30c$var$DomTracker = function() {};
// interface
$51c8f0da15dbd30c$var$DomTracker.prototype.create_properties = function() {};
$51c8f0da15dbd30c$var$DomTracker.prototype.event_handler = function() {};
$51c8f0da15dbd30c$var$DomTracker.prototype.after_track_handler = function() {};
$51c8f0da15dbd30c$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $51c8f0da15dbd30c$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $51c8f0da15dbd30c$var$_.dom_query(query);
    if (elements.length === 0) {
        $51c8f0da15dbd30c$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $51c8f0da15dbd30c$var$_.each(elements, function(element) {
        $51c8f0da15dbd30c$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $51c8f0da15dbd30c$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$51c8f0da15dbd30c$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $51c8f0da15dbd30c$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $51c8f0da15dbd30c$var$LinkTracker = function() {
    this.override_event = 'click';
};
$51c8f0da15dbd30c$var$_.inherit($51c8f0da15dbd30c$var$LinkTracker, $51c8f0da15dbd30c$var$DomTracker);
$51c8f0da15dbd30c$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $51c8f0da15dbd30c$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$51c8f0da15dbd30c$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$51c8f0da15dbd30c$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $51c8f0da15dbd30c$var$FormTracker = function() {
    this.override_event = 'submit';
};
$51c8f0da15dbd30c$var$_.inherit($51c8f0da15dbd30c$var$FormTracker, $51c8f0da15dbd30c$var$DomTracker);
$51c8f0da15dbd30c$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$51c8f0da15dbd30c$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $51c8f0da15dbd30c$var$SET_ACTION = '$set';
/** @const */ var $51c8f0da15dbd30c$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $51c8f0da15dbd30c$var$UNSET_ACTION = '$unset';
/** @const */ var $51c8f0da15dbd30c$var$ADD_ACTION = '$add';
/** @const */ var $51c8f0da15dbd30c$var$APPEND_ACTION = '$append';
/** @const */ var $51c8f0da15dbd30c$var$UNION_ACTION = '$union';
/** @const */ var $51c8f0da15dbd30c$var$REMOVE_ACTION = '$remove';
/** @const */ var $51c8f0da15dbd30c$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $51c8f0da15dbd30c$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($51c8f0da15dbd30c$var$_.isObject(prop)) $51c8f0da15dbd30c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$51c8f0da15dbd30c$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$51c8f0da15dbd30c$var$_.isArray(prop)) prop = [
            prop
        ];
        $51c8f0da15dbd30c$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$51c8f0da15dbd30c$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($51c8f0da15dbd30c$var$_.isObject(prop)) $51c8f0da15dbd30c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$51c8f0da15dbd30c$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($51c8f0da15dbd30c$var$_.isObject(list_name)) $51c8f0da15dbd30c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $51c8f0da15dbd30c$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $51c8f0da15dbd30c$var$_.isArray(values) ? values : [
            values
        ];
        data[$51c8f0da15dbd30c$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($51c8f0da15dbd30c$var$_.isObject(list_name)) $51c8f0da15dbd30c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$51c8f0da15dbd30c$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($51c8f0da15dbd30c$var$_.isObject(list_name)) $51c8f0da15dbd30c$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$51c8f0da15dbd30c$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$51c8f0da15dbd30c$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $51c8f0da15dbd30c$var$MixpanelGroup = function() {};
$51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$MixpanelGroup.prototype, $51c8f0da15dbd30c$var$apiActions);
$51c8f0da15dbd30c$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype.set = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($51c8f0da15dbd30c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype.set_once = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($51c8f0da15dbd30c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype.unset = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype.union = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($51c8f0da15dbd30c$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype['delete'] = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $51c8f0da15dbd30c$var$MixpanelGroup.prototype.remove = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$51c8f0da15dbd30c$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $51c8f0da15dbd30c$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host('groups') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$51c8f0da15dbd30c$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$51c8f0da15dbd30c$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$51c8f0da15dbd30c$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['remove'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.remove;
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['set'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.set;
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['set_once'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.set_once;
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['union'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.union;
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['unset'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.unset;
$51c8f0da15dbd30c$var$MixpanelGroup.prototype['toString'] = $51c8f0da15dbd30c$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $51c8f0da15dbd30c$var$MixpanelPeople = function() {};
$51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$MixpanelPeople.prototype, $51c8f0da15dbd30c$var$apiActions);
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.set = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($51c8f0da15dbd30c$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$51c8f0da15dbd30c$var$SET_ACTION] = $51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$_.info.people_properties(), data[$51c8f0da15dbd30c$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.set_once = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($51c8f0da15dbd30c$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.unset = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.increment = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($51c8f0da15dbd30c$var$_.isObject(prop)) {
        $51c8f0da15dbd30c$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $51c8f0da15dbd30c$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($51c8f0da15dbd30c$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$51c8f0da15dbd30c$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.append = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($51c8f0da15dbd30c$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.remove = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($51c8f0da15dbd30c$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.union = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($51c8f0da15dbd30c$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.track_charge = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelPeople(function() {
    $51c8f0da15dbd30c$var$console$1.error('mixpanel.people.track_charge() is deprecated and no longer has any effect.');
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $51c8f0da15dbd30c$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $51c8f0da15dbd30c$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $51c8f0da15dbd30c$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$51c8f0da15dbd30c$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $51c8f0da15dbd30c$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host('people') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($51c8f0da15dbd30c$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$SET_ACTION, data);
    else if ($51c8f0da15dbd30c$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$SET_ONCE_ACTION, data);
    else if ($51c8f0da15dbd30c$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, data);
    else if ($51c8f0da15dbd30c$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$ADD_ACTION, data);
    else if ($51c8f0da15dbd30c$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$APPEND_ACTION, data);
    else if ($51c8f0da15dbd30c$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$REMOVE_ACTION, data);
    else if ($51c8f0da15dbd30c$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$UNION_ACTION, data);
    else $51c8f0da15dbd30c$var$console$1.error('Invalid call to _enqueue():', data);
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $51c8f0da15dbd30c$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$51c8f0da15dbd30c$var$_.isUndefined(queued_data) && $51c8f0da15dbd30c$var$_.isObject(queued_data) && !$51c8f0da15dbd30c$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$51c8f0da15dbd30c$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($51c8f0da15dbd30c$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($51c8f0da15dbd30c$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($51c8f0da15dbd30c$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $51c8f0da15dbd30c$var$_.keys(queue);
    });
    this._flush_one_queue($51c8f0da15dbd30c$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($51c8f0da15dbd30c$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($51c8f0da15dbd30c$var$APPEND_ACTION);
    if (!$51c8f0da15dbd30c$var$_.isUndefined($append_queue) && $51c8f0da15dbd30c$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$APPEND_ACTION, $append_item);
            if (!$51c8f0da15dbd30c$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($51c8f0da15dbd30c$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$51c8f0da15dbd30c$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($51c8f0da15dbd30c$var$REMOVE_ACTION);
    if (!$51c8f0da15dbd30c$var$_.isUndefined($remove_queue) && $51c8f0da15dbd30c$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($51c8f0da15dbd30c$var$REMOVE_ACTION, $remove_item);
            if (!$51c8f0da15dbd30c$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($51c8f0da15dbd30c$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$51c8f0da15dbd30c$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$51c8f0da15dbd30c$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['set'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.set;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['set_once'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.set_once;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['unset'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.unset;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['increment'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.increment;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['append'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.append;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['remove'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.remove;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['union'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.union;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['track_charge'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.track_charge;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['clear_charges'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.clear_charges;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['delete_user'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.delete_user;
$51c8f0da15dbd30c$var$MixpanelPeople.prototype['toString'] = $51c8f0da15dbd30c$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $51c8f0da15dbd30c$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $51c8f0da15dbd30c$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $51c8f0da15dbd30c$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $51c8f0da15dbd30c$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $51c8f0da15dbd30c$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $51c8f0da15dbd30c$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $51c8f0da15dbd30c$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $51c8f0da15dbd30c$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $51c8f0da15dbd30c$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $51c8f0da15dbd30c$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $51c8f0da15dbd30c$var$RESERVED_PROPERTIES = [
    $51c8f0da15dbd30c$var$SET_QUEUE_KEY,
    $51c8f0da15dbd30c$var$SET_ONCE_QUEUE_KEY,
    $51c8f0da15dbd30c$var$UNSET_QUEUE_KEY,
    $51c8f0da15dbd30c$var$ADD_QUEUE_KEY,
    $51c8f0da15dbd30c$var$APPEND_QUEUE_KEY,
    $51c8f0da15dbd30c$var$REMOVE_QUEUE_KEY,
    $51c8f0da15dbd30c$var$UNION_QUEUE_KEY,
    $51c8f0da15dbd30c$var$PEOPLE_DISTINCT_ID_KEY,
    $51c8f0da15dbd30c$var$ALIAS_ID_KEY,
    $51c8f0da15dbd30c$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $51c8f0da15dbd30c$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $51c8f0da15dbd30c$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $51c8f0da15dbd30c$var$_.localStorage.is_supported()) this.storage = $51c8f0da15dbd30c$var$_.localStorage;
    else this.storage = $51c8f0da15dbd30c$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $51c8f0da15dbd30c$var$_.each(this['props'], function(v, k) {
        if (!$51c8f0da15dbd30c$var$_.include($51c8f0da15dbd30c$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $51c8f0da15dbd30c$var$_.extend({}, entry);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $51c8f0da15dbd30c$var$_.localStorage) {
        old_cookie = $51c8f0da15dbd30c$var$_.cookie.parse(this.name);
        $51c8f0da15dbd30c$var$_.cookie.remove(this.name);
        $51c8f0da15dbd30c$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $51c8f0da15dbd30c$var$_.cookie) {
        old_localstorage = $51c8f0da15dbd30c$var$_.localStorage.parse(this.name);
        $51c8f0da15dbd30c$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $51c8f0da15dbd30c$var$JSONStringify(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($51c8f0da15dbd30c$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $51c8f0da15dbd30c$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($51c8f0da15dbd30c$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $51c8f0da15dbd30c$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($51c8f0da15dbd30c$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $51c8f0da15dbd30c$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $51c8f0da15dbd30c$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($51c8f0da15dbd30c$var$SET_ACTION), set_once_q = this._get_or_create_queue($51c8f0da15dbd30c$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($51c8f0da15dbd30c$var$UNSET_ACTION), add_q = this._get_or_create_queue($51c8f0da15dbd30c$var$ADD_ACTION), union_q = this._get_or_create_queue($51c8f0da15dbd30c$var$UNION_ACTION), remove_q = this._get_or_create_queue($51c8f0da15dbd30c$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($51c8f0da15dbd30c$var$APPEND_ACTION, []);
    if (q_key === $51c8f0da15dbd30c$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $51c8f0da15dbd30c$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($51c8f0da15dbd30c$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, q_data);
    } else if (q_key === $51c8f0da15dbd30c$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $51c8f0da15dbd30c$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, q_data);
    } else if (q_key === $51c8f0da15dbd30c$var$UNSET_QUEUE_KEY) $51c8f0da15dbd30c$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $51c8f0da15dbd30c$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $51c8f0da15dbd30c$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $51c8f0da15dbd30c$var$ADD_QUEUE_KEY) {
        $51c8f0da15dbd30c$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, q_data);
    } else if (q_key === $51c8f0da15dbd30c$var$UNION_QUEUE_KEY) {
        $51c8f0da15dbd30c$var$_.each(q_data, function(v, k) {
            if ($51c8f0da15dbd30c$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                $51c8f0da15dbd30c$var$_.each(v, function(item) {
                    if (!$51c8f0da15dbd30c$var$_.include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, q_data);
    } else if (q_key === $51c8f0da15dbd30c$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($51c8f0da15dbd30c$var$APPEND_ACTION, q_data);
    } else if (q_key === $51c8f0da15dbd30c$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($51c8f0da15dbd30c$var$UNSET_ACTION, q_data);
    }
    $51c8f0da15dbd30c$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $51c8f0da15dbd30c$var$console$1.log(data);
    this.save();
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$51c8f0da15dbd30c$var$_.isUndefined(q)) $51c8f0da15dbd30c$var$_.each(data, function(v, k) {
        if (queue === $51c8f0da15dbd30c$var$APPEND_ACTION || queue === $51c8f0da15dbd30c$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $51c8f0da15dbd30c$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $51c8f0da15dbd30c$var$SET_ACTION) return $51c8f0da15dbd30c$var$SET_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$SET_ONCE_ACTION) return $51c8f0da15dbd30c$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$UNSET_ACTION) return $51c8f0da15dbd30c$var$UNSET_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$ADD_ACTION) return $51c8f0da15dbd30c$var$ADD_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$APPEND_ACTION) return $51c8f0da15dbd30c$var$APPEND_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$REMOVE_ACTION) return $51c8f0da15dbd30c$var$REMOVE_QUEUE_KEY;
    else if (queue === $51c8f0da15dbd30c$var$UNION_ACTION) return $51c8f0da15dbd30c$var$UNION_QUEUE_KEY;
    else $51c8f0da15dbd30c$var$console$1.error('Invalid queue:', queue);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $51c8f0da15dbd30c$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($51c8f0da15dbd30c$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$51c8f0da15dbd30c$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($51c8f0da15dbd30c$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$51c8f0da15dbd30c$var$_.isUndefined(timestamp)) {
        delete this['props'][$51c8f0da15dbd30c$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $51c8f0da15dbd30c$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $51c8f0da15dbd30c$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $51c8f0da15dbd30c$var$mixpanel_master; // main mixpanel instance / object
var $51c8f0da15dbd30c$var$INIT_MODULE = 0;
var $51c8f0da15dbd30c$var$INIT_SNIPPET = 1;
var $51c8f0da15dbd30c$var$IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $51c8f0da15dbd30c$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $51c8f0da15dbd30c$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $51c8f0da15dbd30c$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $51c8f0da15dbd30c$var$USE_XHR = $51c8f0da15dbd30c$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $51c8f0da15dbd30c$var$ENQUEUE_REQUESTS = !$51c8f0da15dbd30c$var$USE_XHR && $51c8f0da15dbd30c$var$userAgent.indexOf('MSIE') === -1 && $51c8f0da15dbd30c$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $51c8f0da15dbd30c$var$sendBeacon = null;
if ($51c8f0da15dbd30c$var$navigator['sendBeacon']) $51c8f0da15dbd30c$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $51c8f0da15dbd30c$var$navigator['sendBeacon'].apply($51c8f0da15dbd30c$var$navigator, arguments);
};
var $51c8f0da15dbd30c$var$DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/',
    'flags': 'flags/'
};
/*
 * Module-level globals
 */ var $51c8f0da15dbd30c$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_hosts': {},
    'api_routes': $51c8f0da15dbd30c$var$DEFAULT_API_ROUTES,
    'api_extra_query_params': {},
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $51c8f0da15dbd30c$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'autocapture': false,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $51c8f0da15dbd30c$var$NOOP_FUNC,
    'flags': false,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $51c8f0da15dbd30c$var$NOOP_FUNC,
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video, audio',
    'record_canvas': false,
    'record_collect_fonts': false,
    'record_console': true,
    'record_heatmap_data': false,
    'record_idle_timeout_ms': 1800000,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': $51c8f0da15dbd30c$var$MAX_RECORDING_MS,
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $51c8f0da15dbd30c$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $51c8f0da15dbd30c$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $51c8f0da15dbd30c$var$create_mplib = function(token, config, name) {
    var instance, target = name === $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME ? $51c8f0da15dbd30c$var$mixpanel_master : $51c8f0da15dbd30c$var$mixpanel_master[name];
    if (target && $51c8f0da15dbd30c$var$init_type === $51c8f0da15dbd30c$var$INIT_MODULE) instance = target;
    else {
        if (target && !$51c8f0da15dbd30c$var$_.isArray(target)) {
            $51c8f0da15dbd30c$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $51c8f0da15dbd30c$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $51c8f0da15dbd30c$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $51c8f0da15dbd30c$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $51c8f0da15dbd30c$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $51c8f0da15dbd30c$var$Config.DEBUG = $51c8f0da15dbd30c$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$51c8f0da15dbd30c$var$_.isUndefined(target) && $51c8f0da15dbd30c$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($51c8f0da15dbd30c$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $51c8f0da15dbd30c$var$create_mplib(token, config, name);
    $51c8f0da15dbd30c$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$51c8f0da15dbd30c$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $51c8f0da15dbd30c$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $51c8f0da15dbd30c$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME ? name : $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $51c8f0da15dbd30c$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$51c8f0da15dbd30c$var$_.localStorage.is_supported(true) || !$51c8f0da15dbd30c$var$USE_XHR) {
            this._batch_requests = false;
            $51c8f0da15dbd30c$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $51c8f0da15dbd30c$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $51c8f0da15dbd30c$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $51c8f0da15dbd30c$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($51c8f0da15dbd30c$var$sendBeacon && $51c8f0da15dbd30c$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $51c8f0da15dbd30c$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $51c8f0da15dbd30c$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $51c8f0da15dbd30c$var$win.addEventListener('visibilitychange', function() {
                    if ($51c8f0da15dbd30c$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $51c8f0da15dbd30c$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $51c8f0da15dbd30c$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $51c8f0da15dbd30c$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.flags = new $51c8f0da15dbd30c$var$FeatureFlagManager({
        getFullApiRoute: $51c8f0da15dbd30c$var$_.bind(function() {
            return this.get_api_host('flags') + '/' + this.get_config('api_routes')['flags'];
        }, this),
        getConfigFunc: $51c8f0da15dbd30c$var$_.bind(this.get_config, this),
        setConfigFunc: $51c8f0da15dbd30c$var$_.bind(this.set_config, this),
        getPropertyFunc: $51c8f0da15dbd30c$var$_.bind(this.get_property, this),
        trackingFunc: $51c8f0da15dbd30c$var$_.bind(this.track, this)
    });
    this.flags.init();
    this['flags'] = this.flags;
    this.autocapture = new $51c8f0da15dbd30c$var$Autocapture(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype._init_tab_id = function() {
    if (this.get_config('disable_persistence')) $51c8f0da15dbd30c$var$console$1.log('Tab ID initialization skipped due to disable_persistence config');
    else if ($51c8f0da15dbd30c$var$_.sessionStorage.is_supported()) try {
        var key_suffix = this.get_config('name') + '_' + this.get_config('token');
        var tab_id_key = 'mp_tab_id_' + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = 'mp_gen_new_tab_id_' + key_suffix;
        if ($51c8f0da15dbd30c$var$_.sessionStorage.get(should_generate_new_tab_id_key) || !$51c8f0da15dbd30c$var$_.sessionStorage.get(tab_id_key)) $51c8f0da15dbd30c$var$_.sessionStorage.set(tab_id_key, '$tab-' + $51c8f0da15dbd30c$var$_.UUID());
        $51c8f0da15dbd30c$var$_.sessionStorage.set(should_generate_new_tab_id_key, '1');
        this.tab_id = $51c8f0da15dbd30c$var$_.sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        $51c8f0da15dbd30c$var$win.addEventListener('beforeunload', function() {
            $51c8f0da15dbd30c$var$_.sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error('Error initializing tab id', err);
    }
    else this.report_error('Session storage is not supported, cannot keep track of unique tab ID.');
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._should_load_recorder = function() {
    if (this.get_config('disable_persistence')) {
        $51c8f0da15dbd30c$var$console$1.log('Load recorder check skipped due to disable_persistence config');
        return Promise.resolve(false);
    }
    var recording_registry_idb = new $51c8f0da15dbd30c$var$IDBStorageWrapper($51c8f0da15dbd30c$var$RECORDING_REGISTRY_STORE_NAME);
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ($51c8f0da15dbd30c$var$isRecordingExpired(recordings[i]) || recordings[i]['tabId'] === tab_id) return true;
        }
        return false;
    }).catch($51c8f0da15dbd30c$var$_.bind(function(err) {
        this.report_error('Error checking recording registry', err);
    }, this));
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._check_and_start_session_recording = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(force_start) {
    if (!$51c8f0da15dbd30c$var$win['MutationObserver']) {
        $51c8f0da15dbd30c$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var loadRecorder = $51c8f0da15dbd30c$var$_.bind(function(startNewIfInactive) {
        var handleLoadedRecorder = $51c8f0da15dbd30c$var$_.bind(function() {
            this._recorder = this._recorder || new $51c8f0da15dbd30c$var$win['__mp_recorder'](this);
            this._recorder['resumeRecording'](startNewIfInactive);
        }, this);
        if ($51c8f0da15dbd30c$var$_.isUndefined($51c8f0da15dbd30c$var$win['__mp_recorder'])) $51c8f0da15dbd30c$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent');
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
$51c8f0da15dbd30c$var$MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) return this._recorder['stopRecording']();
    return Promise.resolve();
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) return this._recorder['pauseRecording']();
    return Promise.resolve();
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) return this._recorder['resumeRecording']();
    return Promise.resolve();
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config('record_heatmap_data');
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $51c8f0da15dbd30c$var$_.HTTPBuildQuery({
            'replay_id': replay_id,
            'distinct_id': this.get_distinct_id(),
            'token': this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
$51c8f0da15dbd30c$var$MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
$51c8f0da15dbd30c$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $51c8f0da15dbd30c$var$_.info.campaignParams(null);
        $51c8f0da15dbd30c$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$51c8f0da15dbd30c$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($51c8f0da15dbd30c$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($51c8f0da15dbd30c$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($51c8f0da15dbd30c$var$document$1.referrer);
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._dom_loaded = function() {
    $51c8f0da15dbd30c$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $51c8f0da15dbd30c$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$51c8f0da15dbd30c$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($51c8f0da15dbd30c$var$_.isUndefined(callback)) return null;
    if ($51c8f0da15dbd30c$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($51c8f0da15dbd30c$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($51c8f0da15dbd30c$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $51c8f0da15dbd30c$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$51c8f0da15dbd30c$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $51c8f0da15dbd30c$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$51c8f0da15dbd30c$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    $51c8f0da15dbd30c$var$_.extend(data, this.get_config('api_extra_query_params'));
    url += '?' + $51c8f0da15dbd30c$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $51c8f0da15dbd30c$var$document$1.createElement('img');
        img.src = url;
        $51c8f0da15dbd30c$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $51c8f0da15dbd30c$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($51c8f0da15dbd30c$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $51c8f0da15dbd30c$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $51c8f0da15dbd30c$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $51c8f0da15dbd30c$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $51c8f0da15dbd30c$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $51c8f0da15dbd30c$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($51c8f0da15dbd30c$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($51c8f0da15dbd30c$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($51c8f0da15dbd30c$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $51c8f0da15dbd30c$var$_.each(calls, function(item) {
            if ($51c8f0da15dbd30c$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $51c8f0da15dbd30c$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$51c8f0da15dbd30c$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            api_name: 'track',
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            api_name: 'engage',
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            api_name: 'groups',
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $51c8f0da15dbd30c$var$_.bind(function(attrs) {
            return new $51c8f0da15dbd30c$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $51c8f0da15dbd30c$var$_.bind(function(data, options, cb) {
                    var api_routes = this.get_config('api_routes');
                    this._send_request(this.get_api_host(attrs.api_name) + '/' + api_routes[attrs.api_name], this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $51c8f0da15dbd30c$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $51c8f0da15dbd30c$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $51c8f0da15dbd30c$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $51c8f0da15dbd30c$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $51c8f0da15dbd30c$var$JSONStringify(data);
    if (this.get_config('api_payload_format') === $51c8f0da15dbd30c$var$PAYLOAD_TYPE_BASE64) encoded_data = $51c8f0da15dbd30c$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$51c8f0da15dbd30c$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $51c8f0da15dbd30c$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $51c8f0da15dbd30c$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $51c8f0da15dbd30c$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $51c8f0da15dbd30c$var$console$1.log('MIXPANEL REQUEST:');
            $51c8f0da15dbd30c$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.track = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $51c8f0da15dbd30c$var$NOOP_FUNC;
    if ($51c8f0da15dbd30c$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $51c8f0da15dbd30c$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$51c8f0da15dbd30c$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $51c8f0da15dbd30c$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$_.info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($51c8f0da15dbd30c$var$_.isArray(property_blacklist)) $51c8f0da15dbd30c$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_api_host('events') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.set_group = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$51c8f0da15dbd30c$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.add_group = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.remove_group = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_with_groups = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $51c8f0da15dbd30c$var$_.extend({}, properties || {});
    $51c8f0da15dbd30c$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$51c8f0da15dbd30c$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $51c8f0da15dbd30c$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_pageview = $51c8f0da15dbd30c$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $51c8f0da15dbd30c$var$_.extend($51c8f0da15dbd30c$var$_.info.mpPageViewProperties(), $51c8f0da15dbd30c$var$_.info.campaignParams(), $51c8f0da15dbd30c$var$_.info.clickParams());
    var event_properties = $51c8f0da15dbd30c$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $51c8f0da15dbd30c$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $51c8f0da15dbd30c$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($51c8f0da15dbd30c$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $51c8f0da15dbd30c$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $51c8f0da15dbd30c$var$options_for_register = function(days_or_options) {
    var options;
    if ($51c8f0da15dbd30c$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$51c8f0da15dbd30c$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $51c8f0da15dbd30c$var$_.extend({}, $51c8f0da15dbd30c$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $51c8f0da15dbd30c$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $51c8f0da15dbd30c$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $51c8f0da15dbd30c$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $51c8f0da15dbd30c$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $51c8f0da15dbd30c$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($51c8f0da15dbd30c$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($51c8f0da15dbd30c$var$ALIAS_ID_KEY)) {
        this.unregister($51c8f0da15dbd30c$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.reset = function() {
    this.stop_session_recording();
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $51c8f0da15dbd30c$var$_.UUID();
    this.register_once({
        'distinct_id': $51c8f0da15dbd30c$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this._check_and_start_session_recording();
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($51c8f0da15dbd30c$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($51c8f0da15dbd30c$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($51c8f0da15dbd30c$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.set_config = function(config) {
    if ($51c8f0da15dbd30c$var$_.isObject(config)) {
        $51c8f0da15dbd30c$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $51c8f0da15dbd30c$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $51c8f0da15dbd30c$var$Config.DEBUG = $51c8f0da15dbd30c$var$Config.DEBUG || this.get_config('debug');
        if (('autocapture' in config || 'record_heatmap_data' in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $51c8f0da15dbd30c$var$IDENTITY_FUNC).apply(this, $51c8f0da15dbd30c$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
/**
 * Get the API host for a specific endpoint type, falling back to the default api_host if not specified
 *
 * @param {String} endpoint_type The type of endpoint (e.g., "events", "people", "groups")
 * @returns {String} The API host to use for this endpoint
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_api_host = function(endpoint_type) {
    return this.get_config('api_hosts')[endpoint_type] || this.get_config('api_host');
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME) name = $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $51c8f0da15dbd30c$var$_.isBlockedUA($51c8f0da15dbd30c$var$userAgent) || this._flags.disable_all_events || $51c8f0da15dbd30c$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$51c8f0da15dbd30c$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $51c8f0da15dbd30c$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $51c8f0da15dbd30c$var$_.cookie.get('mp_optout'))) {
        $51c8f0da15dbd30c$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$51c8f0da15dbd30c$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $51c8f0da15dbd30c$var$_.extend({
        'track': $51c8f0da15dbd30c$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$51c8f0da15dbd30c$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $51c8f0da15dbd30c$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($51c8f0da15dbd30c$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $51c8f0da15dbd30c$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($51c8f0da15dbd30c$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($51c8f0da15dbd30c$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($51c8f0da15dbd30c$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $51c8f0da15dbd30c$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $51c8f0da15dbd30c$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($51c8f0da15dbd30c$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$51c8f0da15dbd30c$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $51c8f0da15dbd30c$var$console$1.error.apply($51c8f0da15dbd30c$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $51c8f0da15dbd30c$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$51c8f0da15dbd30c$var$MixpanelLib.prototype['init'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.init;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['reset'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.reset;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['disable'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.disable;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['time_event'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.time_event;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['track'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.track;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['track_links'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_links;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['track_forms'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_forms;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['track_pageview'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_pageview;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['register'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.register;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['register_once'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.register_once;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['unregister'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.unregister;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['identify'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.identify;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['alias'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.alias;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['name_tag'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.name_tag;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['set_config'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.set_config;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_config'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_config;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_api_host'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_api_host;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_property'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_property;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_distinct_id'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_distinct_id;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['toString'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.toString;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['opt_out_tracking'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.opt_out_tracking;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['opt_in_tracking'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.opt_in_tracking;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['has_opted_out_tracking'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.has_opted_out_tracking;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['has_opted_in_tracking'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.has_opted_in_tracking;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_group'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_group;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['set_group'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.set_group;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['add_group'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.add_group;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['remove_group'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.remove_group;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['track_with_groups'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.track_with_groups;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['start_batch_senders'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.start_batch_senders;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['stop_batch_senders'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.stop_batch_senders;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['start_session_recording'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.start_session_recording;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['stop_session_recording'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.stop_session_recording;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['pause_session_recording'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.pause_session_recording;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['resume_session_recording'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.resume_session_recording;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_session_recording_properties'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_session_recording_properties;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_session_replay_url'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_session_replay_url;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['get_tab_id'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.get_tab_id;
$51c8f0da15dbd30c$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $51c8f0da15dbd30c$var$DEFAULT_API_ROUTES;
// Exports intended only for testing
$51c8f0da15dbd30c$var$MixpanelLib.prototype['__get_recorder'] = $51c8f0da15dbd30c$var$MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype['properties'] = $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.properties;
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype['update_search_keyword'] = $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.update_search_keyword;
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype['update_referrer_info'] = $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.update_referrer_info;
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.get_cross_subdomain;
$51c8f0da15dbd30c$var$MixpanelPersistence.prototype['clear'] = $51c8f0da15dbd30c$var$MixpanelPersistence.prototype.clear;
var $51c8f0da15dbd30c$var$instances = {};
var $51c8f0da15dbd30c$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$instances, function(instance, name) {
        if (name !== $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME) $51c8f0da15dbd30c$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $51c8f0da15dbd30c$var$mixpanel_master['_'] = $51c8f0da15dbd30c$var$_;
};
var $51c8f0da15dbd30c$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $51c8f0da15dbd30c$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$51c8f0da15dbd30c$var$mixpanel_master[name]) {
                $51c8f0da15dbd30c$var$mixpanel_master[name] = $51c8f0da15dbd30c$var$instances[name] = $51c8f0da15dbd30c$var$create_mplib(token, config, name);
                $51c8f0da15dbd30c$var$mixpanel_master[name]._loaded();
            }
            return $51c8f0da15dbd30c$var$mixpanel_master[name];
        } else {
            var instance = $51c8f0da15dbd30c$var$mixpanel_master;
            if ($51c8f0da15dbd30c$var$instances[$51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $51c8f0da15dbd30c$var$instances[$51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $51c8f0da15dbd30c$var$create_mplib(token, config, $51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $51c8f0da15dbd30c$var$instances[$51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $51c8f0da15dbd30c$var$mixpanel_master = instance;
            if ($51c8f0da15dbd30c$var$init_type === $51c8f0da15dbd30c$var$INIT_SNIPPET) $51c8f0da15dbd30c$var$win[$51c8f0da15dbd30c$var$PRIMARY_INSTANCE_NAME] = $51c8f0da15dbd30c$var$mixpanel_master;
            $51c8f0da15dbd30c$var$extend_mp();
        }
    };
};
var $51c8f0da15dbd30c$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $51c8f0da15dbd30c$var$DOM_LOADED = true;
        $51c8f0da15dbd30c$var$ENQUEUE_REQUESTS = false;
        $51c8f0da15dbd30c$var$_.each($51c8f0da15dbd30c$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $51c8f0da15dbd30c$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($51c8f0da15dbd30c$var$document$1.addEventListener) {
        if ($51c8f0da15dbd30c$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $51c8f0da15dbd30c$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($51c8f0da15dbd30c$var$document$1.attachEvent) {
        // IE
        $51c8f0da15dbd30c$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $51c8f0da15dbd30c$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($51c8f0da15dbd30c$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $51c8f0da15dbd30c$var$_.register_event($51c8f0da15dbd30c$var$win, 'load', dom_loaded_handler, true);
};
function $51c8f0da15dbd30c$var$init_as_module(bundle_loader) {
    $51c8f0da15dbd30c$var$load_extra_bundle = bundle_loader;
    $51c8f0da15dbd30c$var$init_type = $51c8f0da15dbd30c$var$INIT_MODULE;
    $51c8f0da15dbd30c$var$mixpanel_master = new $51c8f0da15dbd30c$var$MixpanelLib();
    $51c8f0da15dbd30c$var$override_mp_init_func();
    $51c8f0da15dbd30c$var$mixpanel_master['init']();
    $51c8f0da15dbd30c$var$add_dom_loaded_handler();
    return $51c8f0da15dbd30c$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
// For builds that have everything in one bundle, no extra work.
function $51c8f0da15dbd30c$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $51c8f0da15dbd30c$export$2e2bcd8739ae039 = $51c8f0da15dbd30c$var$init_as_module($51c8f0da15dbd30c$var$loadNoop);


(0, $51c8f0da15dbd30c$export$2e2bcd8739ae039).init("TEST_TOKEN");
var $704d5a656f6aa279$export$2e2bcd8739ae039 = (0, $51c8f0da15dbd30c$export$2e2bcd8739ae039);



var $f3p95 = parcelRequire("f3p95");
const $291fd5f69b1bd399$var$routeToSubscription = (to, next)=>{
    const user = (0, $1MrF5.default).getters["sessions/user"];
    let routeName = null;
    switch(to.name){
        case "new-subscription":
            if (user.subscription_purchase_role === "guardian") routeName = "new-guardian-subscription";
            break;
        case "new-guardian-subscription":
            if (user.subscription_purchase_role !== "guardian") routeName = "new-subscription";
            break;
        case "edit-subscription":
            if (!user.active_subscriber) routeName = "new-subscription";
            else if (user.subscription_purchase_role === "guardian") routeName = "edit-guardian-subscription";
            break;
        case "edit-guardian-subscription":
            if (!user.active_subscriber) routeName = "new-guardian-subscription";
            else if (user.subscription_purchase_role !== "guardian") routeName = "edit-subscription";
            break;
    }
    if (routeName) next({
        name: routeName,
        query: to.query,
        hash: to.hash
    });
    else next();
};

































const $291fd5f69b1bd399$var$router = (0, $48GQ3.createRouter)({
    history: (0, $48GQ3.createWebHistory)("/"),
    routes: [
        {
            path: "/login",
            name: "login",
            component: ()=>(parcelRequire("477Q4")),
            beforeEnter: (to, from, next)=>{
                (0, $1MrF5.default).dispatch("sessions/loginUserWithToken").then((response)=>{
                    if (response?.status < 300) next((0, $f3p95.afterLoginLocation)(to.query.return_to, $291fd5f69b1bd399$var$router));
                    else next();
                });
            }
        },
        {
            path: "/subscriptions/new",
            name: "new-subscription",
            component: ()=>(parcelRequire("1qCth")),
            meta: {
                requiresAuth: true
            },
            beforeEnter: (to, from, next)=>{
                $291fd5f69b1bd399$var$routeToSubscription(to, next);
            }
        },
        {
            path: "/subscriptions/guardian/new",
            name: "new-guardian-subscription",
            component: ()=>(parcelRequire("j1GML")),
            meta: {
                requiresAuth: true
            },
            beforeEnter: (to, from, next)=>{
                $291fd5f69b1bd399$var$routeToSubscription(to, next);
            }
        },
        {
            path: "/subscriptions/guardian/edit",
            name: "edit-guardian-subscription",
            component: ()=>(parcelRequire("4V3RX")),
            meta: {
                requiresAuth: true
            },
            beforeEnter: (to, from, next)=>{
                $291fd5f69b1bd399$var$routeToSubscription(to, next);
            }
        },
        {
            path: "/subscriptions/edit",
            name: "edit-subscription",
            component: ()=>(parcelRequire("a9gkp")),
            meta: {
                requiresAuth: true
            },
            beforeEnter: (to, from, next)=>{
                $291fd5f69b1bd399$var$routeToSubscription(to, next);
            }
        },
        {
            path: "/payment-confirmation/:transactionId",
            name: "payment-confirmation",
            props: true,
            component: ()=>(parcelRequire("2VPXZ")),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/signup",
            name: "signup",
            component: ()=>(parcelRequire("hsp35"))
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: ()=>(parcelRequire("3lp0S"))
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: ()=>(parcelRequire("7XqzI"))
        },
        {
            path: "/cancel-plan",
            name: "cancel-plan",
            component: ()=>(parcelRequire("jI828")),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/delete-account",
            name: "delete-account",
            component: ()=>(parcelRequire("1F1LR")),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/account-setup",
            name: "account-setup",
            component: ()=>(parcelRequire("jAq8p")),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/",
            name: "Home",
            component: ()=>(parcelRequire("ePN9v")),
            children: [
                {
                    path: "",
                    name: "dashboard",
                    component: ()=>(parcelRequire("9aMt1")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "curriculum",
                    name: "curriculum",
                    component: ()=>(parcelRequire("ljNhP")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "implementation-quiz",
                    name: "implementation-quiz",
                    component: ()=>(parcelRequire("4GmtS")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "lesson-plan",
                    name: "implementation-plan",
                    component: ()=>(parcelRequire("fMGHq")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "lesson-plan/:id",
                    name: "lesson-plan",
                    component: ()=>(parcelRequire("aShuk")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "lesson-plan/:lessonPlanId/lessons/:id",
                    name: "lesson",
                    component: ()=>(parcelRequire("7uCFJ")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "modules",
                    name: "module-library",
                    component: ()=>(parcelRequire("hsdLS")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "modules/:id",
                    name: "module",
                    component: ()=>(parcelRequire("ksQNo")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "news-resources",
                    name: "news-resources",
                    component: ()=>(parcelRequire("edjei")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "help-and-guides",
                    name: "help-and-guides",
                    component: ()=>(parcelRequire("4GVmN")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "students/:id",
                    name: "student",
                    component: ()=>(parcelRequire("g5zll")),
                    meta: {
                        requiresAuth: true
                    },
                    beforeEnter: (to, from, next)=>{
                        (0, $1MrF5.default).dispatch("students/loadStudent", to.params.id).then((response)=>{
                            if (response.status < 300) next();
                            else {
                                (0, $1MrF5.default).dispatch("showToast", {
                                    type: "error",
                                    message: "Student not found"
                                });
                                next({
                                    name: "dashboard"
                                });
                            }
                        });
                    }
                },
                {
                    path: "students/:id/activity-history",
                    name: "student-activity-history",
                    component: ()=>(parcelRequire("bHUgq")),
                    meta: {
                        requiresAuth: true
                    },
                    beforeEnter: (to, from, next)=>{
                        if (!to.params.id || to.params.id === "undefined") {
                            next({
                                name: "dashboard"
                            });
                            return;
                        }
                        next();
                    }
                },
                {
                    path: "students/:id/streaming",
                    name: "streaming",
                    component: ()=>(parcelRequire("e1TO2")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "classroom/:id",
                    name: "classroom",
                    component: ()=>(parcelRequire("aHop5")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "archive/:classId",
                    name: "archive",
                    component: ()=>(parcelRequire("5cHeI")),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "group-dashboard",
                    name: "group-dashboard",
                    component: ()=>(parcelRequire("7yVWc")),
                    meta: {
                        requiresAuth: true,
                        requiresSchoolAdmin: true
                    }
                },
                {
                    path: "group-dashboard/analytics",
                    redirect: {
                        name: "group-dashboard",
                        query: {
                            tab: "sessions"
                        }
                    }
                },
                {
                    path: "group-dashboard/advisors/:id",
                    name: "group-advisor",
                    component: ()=>(parcelRequire("5P1IT")),
                    meta: {
                        requiresAuth: true,
                        requiresSchoolAdmin: true
                    }
                },
                {
                    path: "group-dashboard/students/:id",
                    name: "group-student",
                    component: ()=>(parcelRequire("hwiZb")),
                    meta: {
                        requiresAuth: true,
                        requiresSchoolAdmin: true
                    }
                },
                {
                    path: "group-dashboard/classrooms/:id",
                    name: "group-classroom",
                    component: ()=>(parcelRequire("efpx2")),
                    meta: {
                        requiresAuth: true,
                        requiresSchoolAdmin: true
                    }
                },
                {
                    path: ":pathMatch(.*)*",
                    name: "not-found",
                    component: ()=>(parcelRequire("ejJQg")),
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        }
    ]
});
$291fd5f69b1bd399$var$router.beforeEach((to, from, next)=>{
    if (to.query.google_error === 'email_mismatch') {
        (0, $1MrF5.default).dispatch('showToast', {
            type: 'error',
            message: "Could not connect Google account \u2014 please make sure your account emails match.",
            duration: 8000
        });
        const query = {
            ...to.query
        };
        delete query.google_error;
        return next({
            ...to,
            query: query,
            replace: true
        });
    }
    if (to.matched.some((record)=>record.meta.requiresAuth)) (0, $1MrF5.default).dispatch("sessions/loginUserWithToken").then((response)=>{
        if (response && response.status < 300) {
            const user = (0, $1MrF5.default).getters["sessions/user"];
            (0, $704d5a656f6aa279$export$2e2bcd8739ae039).identify(user.id);
            // if user is not signed up, redirect to account-setup
            if (!user.signed_up && to.name !== "account-setup") next({
                name: "account-setup",
                query: (0, $f3p95.returnToQuery)(to.fullPath, $291fd5f69b1bd399$var$router)
            });
            else if (user.signed_up && to.name === "account-setup") next((0, $f3p95.afterLoginLocation)(to.query.return_to, $291fd5f69b1bd399$var$router));
            else if (to.matched.some((record)=>record.meta.requiresSchoolAdmin)) {
                if ((0, $1MrF5.default).getters["sessions/isSchoolAdmin"]) next();
                else next({
                    name: "dashboard"
                });
            } else next();
        } else {
            const destination = to.name === "account-setup" ? to.query.return_to : to.fullPath;
            next({
                name: "login",
                query: (0, $f3p95.returnToQuery)(destination, $291fd5f69b1bd399$var$router)
            });
        }
    });
    else next();
});
var $291fd5f69b1bd399$export$2e2bcd8739ae039 = $291fd5f69b1bd399$var$router;



var $1MrF5 = parcelRequire("1MrF5");

var $6p2TQ = parcelRequire("6p2TQ");

// app/javascript/directives/clicky.js
var $fdee91e3307c30e7$export$2e2bcd8739ae039 = {
    beforeMount (el) {
        el.style.transition = "transform 0.1s ease";
        el.style.cursor = "pointer";
        el.addEventListener("mousedown", ()=>{
            el.style.transform = "scale(0.98)";
        });
        el.addEventListener("mouseup", ()=>{
            el.style.transform = "scale(1)";
        });
        el.addEventListener("mouseleave", ()=>{
            el.style.transform = "scale(1)";
        });
    }
};



var $dYhB1 = parcelRequire("dYhB1");

const $4089d07565044323$var$rollbar = new (0, (/*@__PURE__*/$parcel$interopDefault($6p2TQ)))({
    accessToken: "b36555f2d6184d98bb26ebda893764f2",
    captureUncaught: false,
    captureUnhandledRejections: false,
    payload: {
        environment: "production"
    }
});
document.addEventListener("DOMContentLoaded", ()=>{
    const app = (0, $aRSfV.createApp)((0, $f034379dc5707d1c$export$2e2bcd8739ae039));
    app.config.errorHandler = (err, vm, info)=>{
        $4089d07565044323$var$rollbar.error(err);
        throw err;
    };
    app.config.warnHandler = (msg, vm, trace)=>{};
    app.config.globalProperties.$rollbar = $4089d07565044323$var$rollbar;
    app.config.globalProperties.$mixpanel = (0, $704d5a656f6aa279$export$2e2bcd8739ae039);
    app.config.productionTip = false;
    app.directive("clicky", (0, $fdee91e3307c30e7$export$2e2bcd8739ae039)).use((0, $1MrF5.default)).use((0, $291fd5f69b1bd399$export$2e2bcd8739ae039)).mixin((0, $dYhB1.default));
    try {
        app.use((0, $81551a3ae87d4df4$export$88a2a93534f14e73)({
            id: "GTM-KKX4T2J",
            // Production must follow GTM's Live container. Local preview settings
            // are also passed into Docker builds and can pin it to an old version.
            queryParams: {},
            defer: true,
            compatibility: true,
            nonce: Math.random().toString(36).slice(2),
            enabled: true,
            debug: false,
            loadScript: true,
            vueRouter: (0, $291fd5f69b1bd399$export$2e2bcd8739ae039),
            vueRouterAdditionalEventData: ()=>{
                try {
                    const accountStatus = (0, $1MrF5.default).getters["sessions/user"]?.account_status_name || "New User";
                    return {
                        accountStatus: accountStatus
                    };
                } catch (error) {
                    console.error("Error getting account status:", error);
                    return {
                        accountStatus: "New User"
                    };
                }
            },
            ignoredViews: [
                ""
            ],
            trackOnNextTick: false
        }));
    } catch (error) {
        console.error("Error initializing GTM:", error);
    }
    app.mount("#app");
});



})();
//# sourceMappingURL=dashboard.js.map
